import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateActivity: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any; }
  EntitiesIdsSelected: { input: any; output: any; }
  IsoDate: { input: any; output: any; }
  IsoDateTime: { input: any; output: any; }
  RawJson: { input: any; output: any; }
  /** Represents an uploaded file. */
  Upload: { input: any; output: any; }
};

export type AccessCard = {
  __typename?: 'AccessCard';
  accessToken?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type AccessReportPayload = {
  __typename?: 'AccessReportPayload';
  averageTimeByAccess?: Maybe<Scalars['Decimal']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  numberOfAccesses?: Maybe<Scalars['Int']['output']>;
  platformTime?: Maybe<Scalars['Decimal']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  readingTime?: Maybe<Scalars['Decimal']['output']>;
  studentName?: Maybe<Scalars['String']['output']>;
  teacherName?: Maybe<Scalars['String']['output']>;
};

export type ActionField = {
  __typename?: 'ActionField';
  fieldPractices?: Maybe<Array<Maybe<FieldPractice>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActionResult = {
  __typename?: 'ActionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActionStatus = {
  __typename?: 'ActionStatus';
  info?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivateLayersUserPayload = {
  __typename?: 'ActivateLayersUserPayload';
  degree: Scalars['String']['output'];
  entityId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export type ActivitiesReport = {
  __typename?: 'ActivitiesReport';
  currentEntity?: Maybe<GeneralVisionCurrentEntity>;
  data?: Maybe<Array<Maybe<ActivitiesReportActivityData>>>;
  summaryData?: Maybe<ActivitiesReportSummaryData>;
};

export type ActivitiesReportActivityData = {
  __typename?: 'ActivitiesReportActivityData';
  averageCorrectAnswersByUser: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
  usersAnswered: Scalars['Int']['output'];
};

export type ActivitiesReportSummaryData = {
  __typename?: 'ActivitiesReportSummaryData';
  averageCorrectAnswersByUser: Scalars['Float']['output'];
  totalAnswers: Scalars['Int']['output'];
  totalCorrectAnswers: Scalars['Int']['output'];
};

export type ActivitiesUserReport = {
  __typename?: 'ActivitiesUserReport';
  data?: Maybe<Array<Maybe<ActivitiesUserReportActivityData>>>;
  summaryData?: Maybe<ActivitiesUserReportSummaryData>;
};

export type ActivitiesUserReportActivityData = {
  __typename?: 'ActivitiesUserReportActivityData';
  correctAnswers: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  percentageCorrectAnswer: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalAnswers: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type ActivitiesUserReportSummaryData = {
  __typename?: 'ActivitiesUserReportSummaryData';
  averageCorrectAnswerByActivity: Scalars['Float']['output'];
  totalActivities: Scalars['Int']['output'];
  totalAnswers: Scalars['Int']['output'];
  totalCorrectAnswers: Scalars['Int']['output'];
  totalCorrectAnswersPercentage: Scalars['Float']['output'];
};

export type Activity = {
  __typename?: 'Activity';
  approvedForPublic: Scalars['Boolean']['output'];
  articles?: Maybe<Array<Maybe<Article>>>;
  authorInfo?: Maybe<ActivityAuthorInfo>;
  bookCount?: Maybe<Scalars['Int']['output']>;
  books?: Maybe<Array<Maybe<Book>>>;
  degreeRange?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  didacticSequenceId?: Maybe<Scalars['Int']['output']>;
  difficultyLevel?: Maybe<ActivityDifficultyLevel>;
  estimatedCompletionTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  examQuestions?: Maybe<Array<Maybe<ExamQuestion>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isBncc?: Maybe<Scalars['Boolean']['output']>;
  isReady?: Maybe<Scalars['Boolean']['output']>;
  moduleId?: Maybe<Scalars['Int']['output']>;
  publicDataActivity?: Maybe<PublicDataActivity>;
  submittedToPublic: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Info on the author of the activity. */
export type ActivityAuthorInfo = {
  __typename?: 'ActivityAuthorInfo';
  facebookPhoto?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  school?: Maybe<Scalars['String']['output']>;
};

export enum ActivityDegree {
  Degree_1 = 'DEGREE_1',
  Degree_2 = 'DEGREE_2',
  Degree_3 = 'DEGREE_3',
  Degree_4 = 'DEGREE_4',
  Degree_5 = 'DEGREE_5',
  Degree_6 = 'DEGREE_6',
  Degree_7 = 'DEGREE_7',
  Degree_8 = 'DEGREE_8',
  Degree_9 = 'DEGREE_9',
  DegreeEi = 'DEGREE_EI',
  DegreeM = 'DEGREE_M'
}

export enum ActivityDetailStatus {
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type ActivityDetailStudentData = {
  __typename?: 'ActivityDetailStudentData';
  answeredQuestions: Scalars['Int']['output'];
  answersIsCorrect?: Maybe<Array<Maybe<Scalars['Boolean']['output']>>>;
  appliedActivityId?: Maybe<Scalars['Int']['output']>;
  correctAnswers: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  readerId: Scalars['Int']['output'];
  status: ActivityDetailStatus;
  totalAnswers: Scalars['Int']['output'];
};

export type ActivityDetails = {
  __typename?: 'ActivityDetails';
  answers?: Maybe<Array<Maybe<ActivityDetailsAnswer>>>;
  appliedActivityId?: Maybe<Scalars['Int']['output']>;
  conclusionPercentage: Scalars['Float']['output'];
  finalGrade?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  readerId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type ActivityDetailsAnswer = {
  __typename?: 'ActivityDetailsAnswer';
  bnccTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  examQuestionId: Scalars['Int']['output'];
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  type: ExamQuestionType;
};

export enum ActivityDifficultyLevel {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE'
}

export type ActivityExamQuestion = {
  __typename?: 'ActivityExamQuestion';
  activityId: Scalars['Int']['output'];
  examQuestionId: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityForReader = {
  __typename?: 'ActivityForReader';
  appliedActivityAnswerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrectionAutomatic?: Maybe<Scalars['Boolean']['output']>;
  questions?: Maybe<Array<Maybe<QuestionForReader>>>;
  status?: Maybe<ActivityStatus>;
  title?: Maybe<Scalars['String']['output']>;
  totalCoins?: Maybe<Scalars['Int']['output']>;
};

export type ActivityReportActivityVisualization = {
  __typename?: 'ActivityReportActivityVisualization';
  activityId?: Maybe<Scalars['Int']['output']>;
  activityName?: Maybe<Scalars['String']['output']>;
  conclusionPercentage?: Maybe<Scalars['Float']['output']>;
  recommendedDegree?: Maybe<Scalars['String']['output']>;
  subjectsName?: Maybe<Scalars['String']['output']>;
};

export type ActivityReportReaderVisualization = {
  __typename?: 'ActivityReportReaderVisualization';
  activityId: Scalars['Int']['output'];
  activityName: Scalars['String']['output'];
  conclusionPercentage: Scalars['Float']['output'];
  grade?: Maybe<Scalars['String']['output']>;
  recommendedDegree?: Maybe<Scalars['String']['output']>;
};

export type ActivityReportSubjectVisualization = {
  __typename?: 'ActivityReportSubjectVisualization';
  conclusionPercentage?: Maybe<Scalars['Float']['output']>;
  finishedActivitiesCount?: Maybe<Scalars['Int']['output']>;
  inProgressActivitiesCount?: Maybe<Scalars['Int']['output']>;
  notStartedActivitiesCount?: Maybe<Scalars['Int']['output']>;
  subjectId?: Maybe<Scalars['Int']['output']>;
  subjectName?: Maybe<Scalars['String']['output']>;
  totalActivitiesCount?: Maybe<Scalars['Int']['output']>;
};

export enum ActivityStatus {
  /** Atividade corrigida */
  Corrected = 'CORRECTED',
  /** Atividade em andamento */
  Doing = 'DOING',
  /** Atividade concluída */
  Done = 'DONE',
  /** Atividade atrasada */
  Late = 'LATE',
  /** Atividade nova */
  New = 'NEW'
}

export type AddActivitiesToArticle = {
  __typename?: 'AddActivitiesToArticle';
  activity?: Maybe<Activity>;
  activityOrder?: Maybe<Scalars['Int']['output']>;
  article?: Maybe<Article>;
};

export type AddActivitiesToArticlePayload = {
  activityId?: InputMaybe<Scalars['Int']['input']>;
  activityOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type AddArticleToActivityPayload = {
  __typename?: 'AddArticleToActivityPayload';
  activity?: Maybe<Activity>;
  article?: Maybe<Article>;
};

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type AdminSearchAtualidadesActivitiesPayload = {
  __typename?: 'AdminSearchAtualidadesActivitiesPayload';
  activities?: Maybe<Array<Maybe<Activity>>>;
  totalEntries?: Maybe<Scalars['Int']['output']>;
};

export type AncestryDetail = {
  __typename?: 'AncestryDetail';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Answer = {
  __typename?: 'Answer';
  aiComment?: Maybe<Scalars['String']['output']>;
  aiGrade?: Maybe<Scalars['String']['output']>;
  answerChoiceId?: Maybe<Scalars['Int']['output']>;
  answerDiscursive?: Maybe<Scalars['String']['output']>;
  answerMatchingPairs?: Maybe<Array<Maybe<AnswerMatchingPairForReader>>>;
  correctAnswerId?: Maybe<Scalars['Int']['output']>;
  examQuestionId?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  teacherComments?: Maybe<Scalars['String']['output']>;
};

export type AnswerForReader = {
  __typename?: 'AnswerForReader';
  answerChoiceId?: Maybe<Scalars['Int']['output']>;
  answerDiscursive?: Maybe<Scalars['String']['output']>;
  answerMatchingPairs?: Maybe<Array<Maybe<AnswerMatchingPairForReader>>>;
  correctAnswerId?: Maybe<Scalars['Int']['output']>;
  examQuestionId?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  isPartiallyCorrect?: Maybe<Scalars['Boolean']['output']>;
  teacherComments?: Maybe<Scalars['String']['output']>;
};

export type AnswerMatchingPairForReader = {
  __typename?: 'AnswerMatchingPairForReader';
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  leftId?: Maybe<Scalars['String']['output']>;
  rightId?: Maybe<Scalars['String']['output']>;
};

export type AnswerMatchingPairInput = {
  appliedActivityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  matchingPairs: Array<InputMaybe<MatchingPairInput>>;
};

export type AnswerMatchingPairPayload = {
  __typename?: 'AnswerMatchingPairPayload';
  completed: Scalars['Boolean']['output'];
  match: Scalars['Boolean']['output'];
};

export type AnswerMatchingPairV2Result = {
  __typename?: 'AnswerMatchingPairV2Result';
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect: Scalars['Boolean']['output'];
  leftId: Scalars['String']['output'];
  rightId: Scalars['String']['output'];
};

export type AnswerMatchingPairsV2Payload = {
  __typename?: 'AnswerMatchingPairsV2Payload';
  matchingPairs: Array<Maybe<AnswerMatchingPairV2Result>>;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  android?: Maybe<AppVersionInfo>;
  /** @deprecated Will no longer be supported */
  androidMinVersion?: Maybe<Scalars['Int']['output']>;
  ios?: Maybe<AppVersionInfo>;
  /** @deprecated Will no longer be supported */
  iosMinVersion?: Maybe<Scalars['Int']['output']>;
};

export type AppVersionInfo = {
  __typename?: 'AppVersionInfo';
  forceUpgrade?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents the activity applied to an entity or individual reader. */
export type AppliedActivity = {
  __typename?: 'AppliedActivity';
  activity?: Maybe<Activity>;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  appliedActivityAnswers?: Maybe<Array<Maybe<AppliedActivityAnswer>>>;
  autoCorrectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateActivity']['output']>;
  endDate?: Maybe<Scalars['DateActivity']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateActivity']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AppliedActivityAnswer = {
  __typename?: 'AppliedActivityAnswer';
  answers?: Maybe<Array<Maybe<Answer>>>;
  customEndDate?: Maybe<Scalars['DateTime']['output']>;
  customStartDate?: Maybe<Scalars['DateTime']['output']>;
  finalComment?: Maybe<Scalars['String']['output']>;
  finalGrade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum AppliedActivityAnswerStatus {
  Cancelled = 'CANCELLED',
  Corrected = 'CORRECTED',
  Doing = 'DOING',
  Done = 'DONE',
  Pending = 'PENDING'
}

/**
 * The activity applied by a teacher, with aggregate information
 * on its current applications.
 */
export type AppliedActivityByTeacher = {
  __typename?: 'AppliedActivityByTeacher';
  applicationsDoing?: Maybe<Scalars['String']['output']>;
  applicationsDone?: Maybe<Scalars['String']['output']>;
  applicationsGraded?: Maybe<Scalars['String']['output']>;
  approvedForPublic?: Maybe<Scalars['Boolean']['output']>;
  articles?: Maybe<Array<Maybe<Article>>>;
  books?: Maybe<Array<Maybe<Book>>>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AppliedActivityDetails = {
  __typename?: 'AppliedActivityDetails';
  appliedActivityAnswerId?: Maybe<Scalars['Int']['output']>;
  appliedActivityId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  finalGrade?: Maybe<Scalars['String']['output']>;
  parentEntityName?: Maybe<Scalars['String']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  readerName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AppliedActivityDetailsOutput = {
  __typename?: 'AppliedActivityDetailsOutput';
  activityCreatedAt?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['Int']['output']>;
  activityTitle?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Scalars['RawJson']['output']>;
  others?: Maybe<Array<Maybe<AppliedActivityDetails>>>;
};

export type ApplyActivitiesToEntitiesTeachersPayload = {
  __typename?: 'ApplyActivitiesToEntitiesTeachersPayload';
  status?: Maybe<Scalars['String']['output']>;
};

export type ApplyAssignmentActivityInput = {
  id: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplyAssignmentInput = {
  activities: Array<InputMaybe<ApplyAssignmentActivityInput>>;
  autoCorrectionWithAi?: InputMaybe<Scalars['Boolean']['input']>;
  dueDate?: InputMaybe<Scalars['IsoDateTime']['input']>;
  entityId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  flowType: AssignmentFlowType;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  readerId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate?: InputMaybe<Scalars['IsoDateTime']['input']>;
  taskLocation: AssignmentTaskLocation;
};

export type ApplyAssignmentPayload = {
  __typename?: 'ApplyAssignmentPayload';
  assignmentId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Article = {
  __typename?: 'Article';
  activities?: Maybe<Array<Maybe<Activity>>>;
  author?: Maybe<Scalars['String']['output']>;
  categories: Array<Maybe<Category>>;
  consumptionStatus?: Maybe<ContentConsumptionStatus>;
  coverSubtitle?: Maybe<Scalars['String']['output']>;
  coverTitle?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  htmlRaw?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageAuthor?: Maybe<Scalars['String']['output']>;
  isHighlighted?: Maybe<Scalars['Boolean']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  recommendedContentShelves?: Maybe<Array<Maybe<ContentShelf>>>;
  schoolSegment?: Maybe<SchoolSegment>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ArticleShelf = {
  __typename?: 'ArticleShelf';
  articles?: Maybe<Array<Maybe<Article>>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


export type ArticleShelfArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ArvoreSharedReadingInput = {
  bookSlug?: InputMaybe<Scalars['String']['input']>;
  entities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  participants?: InputMaybe<Array<InputMaybe<ParticipantInput>>>;
  readers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ArvoreSharedReadingPayload = {
  __typename?: 'ArvoreSharedReadingPayload';
  sharedReadingId?: Maybe<Scalars['Int']['output']>;
};

export type AssignOnboardingLikedBooksToReaderInput = {
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type AssignedQuestionsCountByKindInput = {
  __typename?: 'AssignedQuestionsCountByKindInput';
  count: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
};

export enum AssignmentFlowType {
  Free = 'FREE',
  Sequential = 'SEQUENTIAL'
}

export enum AssignmentTaskLocation {
  Classroom = 'CLASSROOM',
  Home = 'HOME'
}

export type AudioBook = {
  __typename?: 'AudioBook';
  active?: Maybe<Scalars['Boolean']['output']>;
  artwork?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  hasListened?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  listenedTimestamp?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** This enum represents the errors by type in the reading fluency assessment (Azure service). */
export enum AzureReadingFluencyErrorType {
  Insertion = 'INSERTION',
  Mispronunciation = 'MISPRONUNCIATION',
  MissingBreak = 'MISSING_BREAK',
  Monotone = 'MONOTONE',
  Omission = 'OMISSION',
  UnexpectedBreak = 'UNEXPECTED_BREAK'
}

export type Banner = {
  __typename?: 'Banner';
  imageUrl?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BaseText = {
  __typename?: 'BaseText';
  id?: Maybe<Scalars['Int']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
};

export type BasicReader = {
  __typename?: 'BasicReader';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BasicUser = {
  __typename?: 'BasicUser';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BenchmarkItem = {
  __typename?: 'BenchmarkItem';
  book?: Maybe<Book>;
  filePath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  partnerLevelingId?: Maybe<Scalars['Int']['output']>;
  wordCount?: Maybe<Scalars['Int']['output']>;
};

export type BnccAbility = {
  __typename?: 'BnccAbility';
  code?: Maybe<Scalars['String']['output']>;
  degreeRange?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  practiceObject?: Maybe<PracticeObject>;
  practiceObjectId?: Maybe<Scalars['String']['output']>;
};

export type BnccAbilityExamQuestion = {
  __typename?: 'BnccAbilityExamQuestion';
  bnccAbility?: Maybe<BnccAbility>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type BnccAbilityRankingEntry = {
  __typename?: 'BnccAbilityRankingEntry';
  ability: Scalars['String']['output'];
  abilityDescription: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type BnccDegree = {
  __typename?: 'BnccDegree';
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BnccTag = {
  __typename?: 'BnccTag';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Book = {
  __typename?: 'Book';
  activities?: Maybe<Array<Maybe<Activity>>>;
  audioBooks?: Maybe<Array<Maybe<AudioBook>>>;
  author?: Maybe<Scalars['String']['output']>;
  authors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bookCategory?: Maybe<Array<Maybe<BookCategory>>>;
  bookCharacteristic?: Maybe<Array<Maybe<BookCharacteristic>>>;
  bookDegree?: Maybe<Array<Maybe<BookDegree>>>;
  bookPolemicTheme?: Maybe<Array<Maybe<BookPolemicTheme>>>;
  bookTag?: Maybe<Array<Maybe<BookTag>>>;
  bookThema?: Maybe<Array<Maybe<BookThema>>>;
  bookTheme?: Maybe<Array<Maybe<BookTheme>>>;
  censured?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customCategories?: Maybe<Array<Maybe<CustomCategory>>>;
  degree?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  edition?: Maybe<Scalars['String']['output']>;
  englishLevels?: Maybe<Array<Maybe<EnglishLevel>>>;
  freemium?: Maybe<Scalars['Boolean']['output']>;
  hasAudioBook?: Maybe<Scalars['Boolean']['output']>;
  hasEbook?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrlIntermediaria?: Maybe<Scalars['String']['output']>;
  imageUrlThumb?: Maybe<Scalars['String']['output']>;
  imageUrlThumbLow?: Maybe<Scalars['String']['output']>;
  imprint?: Maybe<Scalars['String']['output']>;
  isReadingTrail?: Maybe<Scalars['Boolean']['output']>;
  isbn?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastInteraction?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  leiturometroCollectionLevel?: Maybe<Scalars['Int']['output']>;
  lexileLevel?: Maybe<Scalars['Int']['output']>;
  manualInfoChecked?: Maybe<Scalars['Boolean']['output']>;
  maxUses?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pendingActivities?: Maybe<Array<Maybe<Activity>>>;
  premium?: Maybe<Scalars['Boolean']['output']>;
  premiumBook?: Maybe<Scalars['Boolean']['output']>;
  premiumLock?: Maybe<Scalars['Boolean']['output']>;
  publicationYear?: Maybe<Scalars['Int']['output']>;
  publisher?: Maybe<Publisher>;
  publisherName?: Maybe<Scalars['String']['output']>;
  qualeActivities?: Maybe<Array<Maybe<Activity>>>;
  readAloudEnabled?: Maybe<Scalars['Boolean']['output']>;
  readingLevel?: Maybe<Scalars['Int']['output']>;
  recommendedContentShelves?: Maybe<Array<Maybe<ContentShelf>>>;
  relatedContents?: Maybe<Array<Maybe<RelatedContent>>>;
  rights?: Maybe<Scalars['String']['output']>;
  sentirActivities?: Maybe<Array<Maybe<Activity>>>;
  series?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  themaCategories?: Maybe<Array<Maybe<Thema>>>;
  themaSubcategories?: Maybe<Array<Maybe<Thema>>>;
  v2ready?: Maybe<Scalars['Boolean']['output']>;
  writtenType?: Maybe<Scalars['String']['output']>;
};

export type BookAsNode = Node & {
  __typename?: 'BookAsNode';
  activities?: Maybe<Array<Maybe<Activity>>>;
  audioBooks?: Maybe<Array<Maybe<AudioBook>>>;
  author?: Maybe<Scalars['String']['output']>;
  authors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bookCategory?: Maybe<Array<Maybe<BookCategory>>>;
  bookCharacteristic?: Maybe<Array<Maybe<BookCharacteristic>>>;
  bookDegree?: Maybe<Array<Maybe<BookDegree>>>;
  bookPolemicTheme?: Maybe<Array<Maybe<BookPolemicTheme>>>;
  bookTag?: Maybe<Array<Maybe<BookTag>>>;
  bookThema?: Maybe<Array<Maybe<BookThema>>>;
  bookTheme?: Maybe<Array<Maybe<BookTheme>>>;
  censured?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  edition?: Maybe<Scalars['String']['output']>;
  englishLevels?: Maybe<Array<Maybe<EnglishLevel>>>;
  favoritesVisibility: Scalars['Boolean']['output'];
  freemium?: Maybe<Scalars['Boolean']['output']>;
  hasAudioBook?: Maybe<Scalars['Boolean']['output']>;
  hasEbook?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  imageUrlIntermediaria?: Maybe<Scalars['String']['output']>;
  imageUrlThumb?: Maybe<Scalars['String']['output']>;
  imageUrlThumbLow?: Maybe<Scalars['String']['output']>;
  imprint?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastInteraction?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  leiturometroCollectionLevel?: Maybe<Scalars['Int']['output']>;
  lexileLevel?: Maybe<Scalars['Int']['output']>;
  manualInfoChecked?: Maybe<Scalars['Boolean']['output']>;
  maxUses?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  pendingActivities?: Maybe<Array<Maybe<Activity>>>;
  premium?: Maybe<Scalars['Boolean']['output']>;
  premiumBook?: Maybe<Scalars['Boolean']['output']>;
  premiumLock?: Maybe<Scalars['Boolean']['output']>;
  publicationYear?: Maybe<Scalars['Int']['output']>;
  publisher?: Maybe<Publisher>;
  publisherName?: Maybe<Scalars['String']['output']>;
  qualeActivities?: Maybe<Array<Maybe<Activity>>>;
  readingLevel?: Maybe<Scalars['Int']['output']>;
  relatedContents?: Maybe<Array<Maybe<RelatedContent>>>;
  rights?: Maybe<Scalars['String']['output']>;
  sentirActivities?: Maybe<Array<Maybe<Activity>>>;
  series?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  themaCategories?: Maybe<Array<Maybe<Thema>>>;
  themaSubcategories?: Maybe<Array<Maybe<Thema>>>;
  v2ready?: Maybe<Scalars['Boolean']['output']>;
  writtenType?: Maybe<Scalars['String']['output']>;
};

export type BookAsNodeConnection = {
  __typename?: 'BookAsNodeConnection';
  edges?: Maybe<Array<Maybe<BookAsNodeEdge>>>;
  pageInfo: PageInfo;
};

export type BookAsNodeEdge = {
  __typename?: 'BookAsNodeEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<BookAsNode>;
};

export type BookCategory = {
  __typename?: 'BookCategory';
  category?: Maybe<Category>;
};

export type BookCharacteristic = {
  __typename?: 'BookCharacteristic';
  characteristic?: Maybe<Characteristic>;
};

export type BookCollection = {
  __typename?: 'BookCollection';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BookDegree = {
  __typename?: 'BookDegree';
  degree?: Maybe<Scalars['String']['output']>;
};

export type BookDetailReport = {
  __typename?: 'BookDetailReport';
  data?: Maybe<Array<Maybe<BookDetailReportStudentData>>>;
};

export type BookDetailReportStudentData = {
  __typename?: 'BookDetailReportStudentData';
  effectiveReadingPercentage: Scalars['Float']['output'];
  effectiveReadingTime: Scalars['Int']['output'];
  hasAudioRecording: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lastReadDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  readingTime: Scalars['Int']['output'];
};

export type BookPolemicTheme = {
  __typename?: 'BookPolemicTheme';
  polemicTheme?: Maybe<PolemicTheme>;
};

export type BookRemovalDate = {
  __typename?: 'BookRemovalDate';
  deactivationDate?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type BookSection = {
  __typename?: 'BookSection';
  books?: Maybe<Array<Maybe<Book>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BookShelf = {
  __typename?: 'BookShelf';
  acervoType?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  bgColor?: Maybe<Scalars['String']['output']>;
  bookShelfItems?: Maybe<Array<Maybe<BookShelfItem>>>;
  bookShelfItemsCount?: Maybe<Scalars['Int']['output']>;
  books?: Maybe<Array<Maybe<Book>>>;
  contentFilter?: Maybe<Scalars['String']['output']>;
  degreeRange?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  isHighlight?: Maybe<Scalars['Boolean']['output']>;
  isShuffle?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderPriority?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


export type BookShelfBookShelfItemsArgs = {
  degree?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type BookShelfItem = {
  __typename?: 'BookShelfItem';
  book?: Maybe<Book>;
  bookShelfId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mascot?: Maybe<Scalars['String']['output']>;
};

export type BookSnippetSelected = {
  __typename?: 'BookSnippetSelected';
  book?: Maybe<Book>;
  rawText?: Maybe<Scalars['String']['output']>;
  textInHtml?: Maybe<Scalars['String']['output']>;
  wordCount?: Maybe<Scalars['Int']['output']>;
};

export type BookTag = {
  __typename?: 'BookTag';
  tag?: Maybe<Tag>;
};

export type BookThema = {
  __typename?: 'BookThema';
  thema?: Maybe<Thema>;
};

export type BookTheme = {
  __typename?: 'BookTheme';
  theme?: Maybe<Theme>;
};

export type BooksReport = {
  __typename?: 'BooksReport';
  currentEntity?: Maybe<GeneralVisionCurrentEntity>;
  data?: Maybe<Array<Maybe<BooksReportBookData>>>;
  summaryData?: Maybe<BooksReportSummaryData>;
};

export type BooksReportBookData = {
  __typename?: 'BooksReportBookData';
  author?: Maybe<Scalars['String']['output']>;
  averageReadingTimeByUser: Scalars['Int']['output'];
  coverUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalEffectiveReadingTime: Scalars['Int']['output'];
  totalUsersRead: Scalars['Int']['output'];
};

export type BooksReportSummaryData = {
  __typename?: 'BooksReportSummaryData';
  averageReadingTimeByUser: Scalars['Int']['output'];
  totalArticlesRead: Scalars['Int']['output'];
  totalBooksRead: Scalars['Int']['output'];
  totalEffectiveReadingTime: Scalars['Int']['output'];
};

export type BooksUserReport = {
  __typename?: 'BooksUserReport';
  data?: Maybe<Array<Maybe<BooksUserReportBookData>>>;
  summaryData?: Maybe<BooksUserReportSummaryData>;
};

export type BooksUserReportBookData = {
  __typename?: 'BooksUserReportBookData';
  author?: Maybe<Scalars['String']['output']>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  effectiveReadingPercentage: Scalars['Float']['output'];
  hasAudioRecording: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isDefaultReading: Scalars['Boolean']['output'];
  isSharedReading: Scalars['Boolean']['output'];
  lastReadingDate?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalEffectiveReadingTime: Scalars['Int']['output'];
  totalReadingTime: Scalars['Int']['output'];
};

export type BooksUserReportSummaryData = {
  __typename?: 'BooksUserReportSummaryData';
  averageReadingByDay: Scalars['Int']['output'];
  totalArticlesRead: Scalars['Int']['output'];
  totalBooksRead: Scalars['Int']['output'];
  totalEffectiveReadingTime: Scalars['Int']['output'];
};

export type BoostForestInput = {
  coins?: InputMaybe<Scalars['Int']['input']>;
  drops?: InputMaybe<Scalars['Int']['input']>;
};

export type BootstrapActivityForReaderPayload = {
  __typename?: 'BootstrapActivityForReaderPayload';
  appliedActivityId?: Maybe<Scalars['Int']['output']>;
};

export enum BootstrapActivityForReaderTypes {
  Activity = 'ACTIVITY',
  AppliedActivity = 'APPLIED_ACTIVITY'
}

export type BuySeedInput = {
  itemId: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

export type BuySeedPayload = {
  __typename?: 'BuySeedPayload';
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type BuySpecialItemInput = {
  itemId: Scalars['Int']['input'];
  treeId?: InputMaybe<Scalars['Int']['input']>;
};

export type BuySpecialItemPayload = {
  __typename?: 'BuySpecialItemPayload';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelLastReadingFluencyAssessmentInput = {
  userId: Scalars['Int']['input'];
};

export type Card = {
  __typename?: 'Card';
  accessToken?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  iconIdentifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Challenge = {
  __typename?: 'Challenge';
  description?: Maybe<Scalars['String']['output']>;
  finalDate?: Maybe<Scalars['DateTime']['output']>;
  initialDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  progressBar?: Maybe<Scalars['Float']['output']>;
  requirement?: Maybe<Array<Maybe<ChallengeRequirement>>>;
};

export type ChallengeRequirement = {
  __typename?: 'ChallengeRequirement';
  order?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  reward?: Maybe<ChallengeReward>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ChallengeReward = {
  __typename?: 'ChallengeReward';
  canClaim?: Maybe<Scalars['Boolean']['output']>;
  claimed?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ChangeBooksSlugsInput = {
  newSlug?: InputMaybe<Scalars['String']['input']>;
  oldSlug?: InputMaybe<Scalars['String']['input']>;
};

export type Characteristic = {
  __typename?: 'Characteristic';
  name?: Maybe<Scalars['String']['output']>;
};

export type ChoiceForReader = {
  __typename?: 'ChoiceForReader';
  choiceImageUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ClaimRewardPayload = {
  __typename?: 'ClaimRewardPayload';
  claimed?: Maybe<Scalars['Boolean']['output']>;
};

export type Class = {
  __typename?: 'Class';
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type ClassLastJournalEntriesPayload = {
  __typename?: 'ClassLastJournalEntriesPayload';
  reader?: Maybe<SentirReader>;
};

export type ClassReadingFluencyAssessment = {
  __typename?: 'ClassReadingFluencyAssessment';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ClientContractPayload = {
  __typename?: 'ClientContractPayload';
  contractModules?: Maybe<Array<Maybe<ContractModule>>>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ClientListing = {
  __typename?: 'ClientListing';
  deactivated?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ClientListingFilters = {
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CnpjPayingExtraInformation = {
  __typename?: 'CnpjPayingExtraInformation';
  activeUsers?: Maybe<Scalars['Int']['output']>;
  chargedUsers?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type CnpjPayingModuleInfoPayload = {
  __typename?: 'CnpjPayingModuleInfoPayload';
  bookCollection?: Maybe<Scalars['String']['output']>;
  freeUsers?: Maybe<Scalars['Int']['output']>;
  minUsers?: Maybe<Scalars['Int']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
};

export enum CodeType {
  /** Cadastro Trial 30 Dias */
  Monthly = 'MONTHLY',
  /** Cadastro Trial */
  Trial = 'TRIAL',
  /** Cadastro Voucher */
  Voucher = 'VOUCHER'
}

export type Collection = {
  __typename?: 'Collection';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ConfirmTeacherEmailPayload = {
  __typename?: 'ConfirmTeacherEmailPayload';
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
};

export type ConsumeContentInput = {
  consumptionType: ContentConsumptionType;
  contentIdentifier: Scalars['String']['input'];
  contentType: ContentType;
};

export type ConsumeContentOutput = {
  __typename?: 'ConsumeContentOutput';
  rewards?: Maybe<Array<Maybe<Reward>>>;
};

export type ConsumedContent = {
  __typename?: 'ConsumedContent';
  content?: Maybe<Content>;
  events?: Maybe<Array<Maybe<ConsumedContentEvent>>>;
  firstConsumedAt?: Maybe<Scalars['IsoDateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ContentConsumptionStatus>;
  user?: Maybe<User>;
};

export type ConsumedContentContentReport = {
  __typename?: 'ConsumedContentContentReport';
  content?: Maybe<Content>;
  fullyConsumedCount?: Maybe<Scalars['Int']['output']>;
  openedCount?: Maybe<Scalars['Int']['output']>;
};

export type ConsumedContentEvent = {
  __typename?: 'ConsumedContentEvent';
  consumptionTime?: Maybe<Scalars['IsoDateTime']['output']>;
  consumptionType?: Maybe<ContentConsumptionType>;
};

export type ConsumedContentsByEntityAndContentInput = {
  contentIdentifier: Scalars['String']['input'];
  contentType: ContentType;
  entityId: Scalars['Int']['input'];
};

export type Content = {
  __typename?: 'Content';
  contentDetails?: Maybe<ContentDetails>;
  identifier?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ContentCategoryShelf = {
  __typename?: 'ContentCategoryShelf';
  contents: Array<Maybe<Content>>;
  iconIdentifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum ContentConsumptionStatus {
  FullyConsumed = 'FULLY_CONSUMED',
  NotConsumed = 'NOT_CONSUMED',
  Opened = 'OPENED'
}

export enum ContentConsumptionType {
  FullyConsumed = 'FULLY_CONSUMED',
  Opened = 'OPENED'
}

export type ContentDetails = Article | Book;

export type ContentEntry = {
  __typename?: 'ContentEntry';
  author: Scalars['String']['output'];
  contentId: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  thumbUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ContentIndication = {
  __typename?: 'ContentIndication';
  content?: Maybe<Content>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  indicatedAt?: Maybe<Scalars['Date']['output']>;
  sourceUser?: Maybe<IndicationSourceUser>;
  target?: Maybe<IndicationTarget>;
};

export type ContentIndicationTarget = {
  targetId: Scalars['Int']['input'];
  targetType: ContentIndicationTargetType;
};

export enum ContentIndicationTargetType {
  Entity = 'ENTITY',
  User = 'USER'
}

/** A content reading record represents an audio recording made by a user for a specific content. */
export type ContentReadingRecord = {
  __typename?: 'ContentReadingRecord';
  audioS3Key: Scalars['String']['output'];
  audioUrl?: Maybe<Scalars['String']['output']>;
  contentIdentifier: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  evaluationResponse?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

/** A shelf that may contains both books and articles */
export type ContentShelf = {
  __typename?: 'ContentShelf';
  contentShelf: Array<Maybe<Book>>;
  identifier: ContentShelfIdentifier;
  shelfItems: Array<Maybe<ContentShelfItem>>;
  title: Scalars['String']['output'];
};

export enum ContentShelfIdentifier {
  SameAuthor = 'SAME_AUTHOR',
  SameSeries = 'SAME_SERIES',
  YouMayLike = 'YOU_MAY_LIKE'
}

/** An item that can be a book or an article */
export type ContentShelfItem = Article | Book;

export enum ContentType {
  Article = 'ARTICLE',
  Book = 'BOOK'
}

export type ContractFeaturePayload = {
  __typename?: 'ContractFeaturePayload';
  contractId?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<Maybe<Feature>>>;
};

export type ContractListing = {
  __typename?: 'ContractListing';
  active?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['Int']['output']>;
  contractModules?: Maybe<Array<Maybe<ContractModule>>>;
  contractType?: Maybe<Scalars['String']['output']>;
};

export type ContractModule = {
  __typename?: 'ContractModule';
  bookCollections?: Maybe<Array<Maybe<BookCollection>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  contractId?: Maybe<Scalars['Int']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  extraInformation?: Maybe<ContractModuleExtraInformationPayload>;
  id?: Maybe<Scalars['Int']['output']>;
  info?: Maybe<ContractModuleInfo>;
  module?: Maybe<Module>;
};

export type ContractModuleExtraInformationPayload = CnpjPayingExtraInformation | FamilyPayingExtraInformation | FpBookfairExtraInformation | ProjectExtraInformation | PublicExtraInformation | TrialExtraInformation;

export type ContractModuleInfo = CnpjPayingModuleInfoPayload | FamilyPayingModuleInfoPayload | FpBookfairModuleInfoPayload | ProjectModuleInfoPayload | PublicModuleInfoPayload | TrialModuleInfoPayload;

export type ContractPayload = {
  __typename?: 'ContractPayload';
  active?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<Address>;
  clientId?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['Int']['output']>;
  contractModules?: Maybe<Array<Maybe<ContractModule>>>;
  contractType?: Maybe<Scalars['String']['output']>;
  disableContractAfterExpiration?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  entityOptions?: Maybe<EntityOption>;
  expirationWarningDays?: Maybe<Scalars['Int']['output']>;
  features?: Maybe<Array<Maybe<Feature>>>;
  financeContactEmail?: Maybe<Scalars['String']['output']>;
  financeContactName?: Maybe<Scalars['String']['output']>;
  financeContactPhone?: Maybe<Scalars['String']['output']>;
  firstChargeDate?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  municipalRegistration?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  paymentInfo?: Maybe<Scalars['String']['output']>;
  signatureDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  stateRegistration?: Maybe<Scalars['String']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
};

export enum ContractType {
  /** CNPJ pagante */
  CnpjPaying = 'CNPJ_PAYING',
  /** Família pagante */
  FamilyPaying = 'FAMILY_PAYING',
  /** Bookfair */
  FpBookfair = 'FP_BOOKFAIR',
  /** Concurso */
  Project = 'PROJECT',
  /** Público */
  Public = 'PUBLIC',
  /** Trial */
  Trial = 'TRIAL'
}

export type CreateActivityInput = {
  activityQuestions?: InputMaybe<Array<InputMaybe<CreateExamQuestionInput>>>;
  module: ModuleType;
  relatedArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  relatedBooks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitPublicApproval?: InputMaybe<Scalars['Boolean']['input']>;
  suggestedDegrees: Array<InputMaybe<ActivityDegree>>;
  title: Scalars['String']['input'];
};

export type CreateArticleInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  coverSubtitle: Scalars['String']['input'];
  coverTitle: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  htmlContent: Scalars['String']['input'];
  htmlRaw?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageAuthor?: InputMaybe<Scalars['String']['input']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  schoolSegment: SchoolSegmentValue;
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateBatchEntitiesPayload = {
  __typename?: 'CreateBatchEntitiesPayload';
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateContentIndicationInput = {
  contentIdentifier: Scalars['String']['input'];
  contentType: ContentType;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  targets: Array<InputMaybe<ContentIndicationTarget>>;
};

export type CreateEmotionJournalEntryInput = {
  blockNote?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  primaryEmotion: JournalPrimaryEmotion;
  secondaryEmotions?: InputMaybe<Array<InputMaybe<JournalSecondaryEmotion>>>;
};

export type CreateExamQuestionChoiceInput = {
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExamQuestionInput = {
  questionChoices?: InputMaybe<Array<InputMaybe<CreateExamQuestionChoiceInput>>>;
  questionType: ExamQuestionType;
  statement: Scalars['String']['input'];
};

export type CreateOrUpdateClientInput = {
  acervoType?: InputMaybe<Scalars['String']['input']>;
  blockAccessTokens?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  internalContacts?: InputMaybe<InternalContactsInput>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  loginType?: InputMaybe<LoginTypeInput>;
  maxSimultaneousUsers?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payingClient?: InputMaybe<Scalars['Boolean']['input']>;
  responsibleEmail?: InputMaybe<Scalars['String']['input']>;
  responsibleName?: InputMaybe<Scalars['String']['input']>;
  schoolStructure?: InputMaybe<SchoolStructureOptions>;
  segment?: InputMaybe<SegmentOptions>;
  whoPays?: InputMaybe<WhoPaysOptions>;
};

export type CreateOrUpdateClientPayload = {
  __typename?: 'CreateOrUpdateClientPayload';
  id?: Maybe<Scalars['Int']['output']>;
};

export type CreateOrUpdateContractInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['Int']['input'];
  cnpj?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  municipalRegistration?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateRegistration?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type: ContractType;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateModuleAndObservationInput = {
  contractId: Scalars['Int']['input'];
  contractModules?: InputMaybe<Array<InputMaybe<CreateOrUpdateModuleInput>>>;
  observation?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateModuleInput = {
  acervos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bookCollectionsIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  collectionsIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  info?: InputMaybe<InfoModuleInput>;
  name: ModuleType;
};

export type CreateOrUpdateReadingGoalsInput = {
  entityIds: Array<Scalars['Int']['input']>;
  goal: Scalars['Int']['input'];
};

export type CreateOrUpdateReadingGoalsPayload = {
  __typename?: 'CreateOrUpdateReadingGoalsPayload';
  readingGoals?: Maybe<Array<Maybe<ReadingGoal>>>;
};

export type CreatePaymentTransactionInput = {
  amount: Scalars['Decimal']['input'];
  provider: PaymentProvider;
  userId: Scalars['Int']['input'];
};

export enum CsatContext {
  /** Gaming */
  Gaming = 'GAMING'
}

export type CsatJustifyPayload = {
  __typename?: 'CsatJustifyPayload';
  context?: Maybe<CsatContext>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type CsatScorePayload = {
  __typename?: 'CsatScorePayload';
  context?: Maybe<CsatContext>;
  score?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type CustomCategory = {
  __typename?: 'CustomCategory';
  endDate?: Maybe<Scalars['String']['output']>;
  iconPath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  staticIconPath?: Maybe<Scalars['String']['output']>;
};

export type DeactivateClientPayload = {
  __typename?: 'DeactivateClientPayload';
  id?: Maybe<Scalars['Int']['output']>;
};

export type DeactivateClientsPayload = {
  __typename?: 'DeactivateClientsPayload';
  deactivated?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DeactivateReadingGoalInput = {
  entityId: Scalars['Int']['input'];
};

export type DeactivateReadingGoalPayload = {
  __typename?: 'DeactivateReadingGoalPayload';
  readingGoals: Array<ReadingGoal>;
};

export enum Degree {
  Degree_1 = 'DEGREE_1',
  Degree_2 = 'DEGREE_2',
  Degree_3 = 'DEGREE_3',
  Degree_4 = 'DEGREE_4',
  Degree_5 = 'DEGREE_5',
  Degree_6 = 'DEGREE_6',
  Degree_7 = 'DEGREE_7',
  Degree_8 = 'DEGREE_8',
  Degree_9 = 'DEGREE_9',
  DegreeE = 'DEGREE_E',
  DegreeEi = 'DEGREE_EI',
  DegreeEm = 'DEGREE_EM',
  DegreeF = 'DEGREE_F',
  DegreeG = 'DEGREE_G',
  DegreeM = 'DEGREE_M',
  DegreeS = 'DEGREE_S'
}

export type DeleteOnboardingThemeFromReaderResponse = {
  __typename?: 'DeleteOnboardingThemeFromReaderResponse';
  errors?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeprecatedRole = {
  __typename?: 'DeprecatedRole';
  title?: Maybe<Scalars['String']['output']>;
};

export type DetailedActivitiesActivity = {
  __typename?: 'DetailedActivitiesActivity';
  difficultyLevel?: Maybe<ActivityDifficultyLevel>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DetailedActivitiesReportItem = {
  __typename?: 'DetailedActivitiesReportItem';
  activity?: Maybe<DetailedActivitiesActivity>;
  appliedAt?: Maybe<Scalars['IsoDate']['output']>;
  appliedBy?: Maybe<DetailedActivitiesUserOrEntity>;
  /** The list of users/entities that the activity was applied to OR the top-most entity in the ancestry */
  appliedTo?: Maybe<Array<Maybe<DetailedActivitiesUserOrEntity>>>;
  finalizedActivitiesPercentage?: Maybe<Scalars['Decimal']['output']>;
};

export type DetailedActivitiesUserOrEntity = {
  __typename?: 'DetailedActivitiesUserOrEntity';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum DeviceType {
  /** Android */
  Android = 'ANDROID',
  /** Browser */
  Browser = 'BROWSER',
  /** iOS */
  Ios = 'IOS'
}

export type DidacticSequence = {
  __typename?: 'DidacticSequence';
  activity?: Maybe<Activity>;
  arvoreId?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  bnccAbilities?: Maybe<Array<Maybe<BnccAbility>>>;
  bnccDegrees?: Maybe<Array<Maybe<BnccDegree>>>;
  books?: Maybe<Array<Maybe<Book>>>;
  contents?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isReady?: Maybe<Scalars['Boolean']['output']>;
  lessons?: Maybe<Array<Maybe<Lesson>>>;
  purposes?: Maybe<Scalars['String']['output']>;
  specificSkills?: Maybe<Array<Maybe<SpecificSkill>>>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<BnccTag>>>;
  textualGenres?: Maybe<Array<Maybe<TextualGenre>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DidacticSequenceSearchResult = {
  __typename?: 'DidacticSequenceSearchResult';
  abilities?: Maybe<Array<Maybe<BnccAbility>>>;
  actionFields?: Maybe<Array<Maybe<ActionField>>>;
  books?: Maybe<Array<Maybe<Book>>>;
  contents?: Maybe<Scalars['String']['output']>;
  degrees?: Maybe<Array<Maybe<BnccDegree>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isReady?: Maybe<Scalars['Boolean']['output']>;
  lessons?: Maybe<Array<Maybe<Lesson>>>;
  purposes?: Maybe<Scalars['String']['output']>;
  specificSkills?: Maybe<Array<Maybe<SpecificSkill>>>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<BnccTag>>>;
  textualGenres?: Maybe<Array<Maybe<TextualGenre>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DidacticSequenceSearchResults = {
  __typename?: 'DidacticSequenceSearchResults';
  didacticSequences?: Maybe<Array<Maybe<DidacticSequenceSearchResult>>>;
  searchFilters?: Maybe<Scalars['RawJson']['output']>;
};

export type DifficultyLevelEntry = {
  __typename?: 'DifficultyLevelEntry';
  count: Scalars['Int']['output'];
  difficultyLevel: Scalars['String']['output'];
};

export type Discipline = {
  __typename?: 'Discipline';
  title?: Maybe<Scalars['String']['output']>;
};

export type EditActivityInput = {
  activityId: Scalars['Int']['input'];
  activityQuestions?: InputMaybe<Array<InputMaybe<EditExamQuestionInput>>>;
  module: ModuleType;
  relatedArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  relatedBooks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitPublicApproval: Scalars['Boolean']['input'];
  suggestedDegrees?: InputMaybe<Array<InputMaybe<ActivityDegree>>>;
  title: Scalars['String']['input'];
};

export type EditAppliedActivityInput = {
  endDate?: InputMaybe<Scalars['DateActivity']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  readerId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateActivity']['input']>;
};

export type EditExamQuestionChoiceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type EditExamQuestionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  questionChoices?: InputMaybe<Array<InputMaybe<EditExamQuestionChoiceInput>>>;
  questionType?: InputMaybe<ExamQuestionType>;
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type EditExamQuestionPayload = {
  choices: Array<InputMaybe<ExamQuestionChoiceInput>>;
  id: Scalars['Int']['input'];
  referencePage?: InputMaybe<Scalars['String']['input']>;
};

export type EmbeddedInBookActivity = {
  __typename?: 'EmbeddedInBookActivity';
  hasActivitiesToShow?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Array<Maybe<EmbeddedInBookActivityQuestion>>>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EmbeddedInBookActivityQuestion = {
  __typename?: 'EmbeddedInBookActivityQuestion';
  answer?: Maybe<Answer>;
  choices?: Maybe<Array<Maybe<EmbeddedInBookActivityQuestionChoices>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  matchingPairs?: Maybe<Array<Maybe<ExamQuestionMatchingPairs>>>;
  pageReference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EmbeddedInBookActivityQuestionChoices = {
  __typename?: 'EmbeddedInBookActivityQuestionChoices';
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EmotionJournalEntry = {
  __typename?: 'EmotionJournalEntry';
  blockNote?: Maybe<Scalars['Boolean']['output']>;
  emotionColor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insertedAt?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  primaryEmotion?: Maybe<Scalars['String']['output']>;
  secondaryEmotions?: Maybe<Array<Maybe<SecondaryEmotion>>>;
};

export type EnglishLevel = {
  __typename?: 'EnglishLevel';
  levels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<EnglishLevelType>;
};

export enum EnglishLevelType {
  /** Level type CEFR */
  Cefr = 'CEFR',
  /** Level type Fountas and Pinnell */
  FountasAndPinnell = 'FOUNTAS_AND_PINNELL'
}

export type EnglishTrailDetails = {
  __typename?: 'EnglishTrailDetails';
  endDate?: Maybe<Scalars['String']['output']>;
  remainingDays?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type Entity = {
  __typename?: 'Entity';
  ancestry?: Maybe<Scalars['String']['output']>;
  ancestryDetails?: Maybe<Array<AncestryDetail>>;
  children?: Maybe<Array<Maybe<EntityChildrenPayload>>>;
  childrenCount?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contractInfo?: Maybe<EntityContractInfo>;
  currentSimultaneousUsers?: Maybe<Scalars['Int']['output']>;
  customCategories?: Maybe<Array<Maybe<CustomCategory>>>;
  /** @deprecated This field is deprecated. Use `access_days_left` instead. */
  daysLeft?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  indicationsWithInfo?: Maybe<Array<Maybe<IndicationWithInfo>>>;
  inep?: Maybe<Scalars['String']['output']>;
  lastReadingFluencyResult?: Maybe<ReadingFluencyClassResult>;
  /** @deprecated This field is deprecated. */
  maxOfflineBooks?: Maybe<Scalars['Int']['output']>;
  maxSimultaneousUsers?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextReaderSpotAvailable?: Maybe<Scalars['String']['output']>;
  paymentInfo?: Maybe<Scalars['RawJson']['output']>;
  paymentPrice?: Maybe<Scalars['Decimal']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  rankingEntity?: Maybe<Array<Maybe<RankingReader>>>;
  rankingRoot?: Maybe<Array<Maybe<RankingReader>>>;
  rankingRootWithTier?: Maybe<Scalars['RawJson']['output']>;
  rankingSchool?: Maybe<Array<Maybe<RankingReader>>>;
  /** @deprecated Use readersPerPage instead. */
  readers?: Maybe<Array<Maybe<Reader>>>;
  readersAsRoot?: Maybe<Array<Maybe<Reader>>>;
  /** Gets readers with reading fluency results, ordered by name, correct words per minute, or assessment date. Valid orderBy values: 'name', 'correct_words_per_minute', 'assessment_date'. Valid orderDirection values: 'asc', 'desc' */
  readersByReadingFluency?: Maybe<Array<Maybe<EntityReaderPayload>>>;
  /** Gets a list of readers from that entity, with teachers included. perPage limit is 20. */
  readersPerPage?: Maybe<Array<Maybe<EntityReaderPayload>>>;
  readingFluencyResultsForCurrentYear?: Maybe<Array<Maybe<ReadingFluencyClassResultForCurrentYear>>>;
  requirePayment?: Maybe<Scalars['Boolean']['output']>;
  responsibleUser?: Maybe<User>;
  /** @deprecated Use acervos instead to retrieve a list of acervos the user has access. */
  rootAcervo?: Maybe<Scalars['String']['output']>;
  rootId?: Maybe<Scalars['Int']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  temporarilyBooks?: Maybe<Scalars['RawJson']['output']>;
  topCategoryByEntityDegree?: Maybe<Array<Maybe<Category>>>;
  type?: Maybe<Scalars['String']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};


export type EntityChildrenArgs = {
  input?: InputMaybe<GetEntityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityChildrenCountArgs = {
  input?: InputMaybe<GetEntityInput>;
};


export type EntityReadersByReadingFluencyArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityReadersPerPageArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityChildrenPayload = {
  __typename?: 'EntityChildrenPayload';
  ancestry?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<EntityChildrenPayload>>>;
  childrenCount?: Maybe<Scalars['Int']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};


export type EntityChildrenPayloadChildrenArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityChildrenPayloadChildrenCountArgs = {
  input?: InputMaybe<GetEntityInput>;
};

export type EntityContentConsumptionSummary = {
  __typename?: 'EntityContentConsumptionSummary';
  fullyConsumedContentCount?: Maybe<Scalars['Int']['output']>;
  openedContentCount?: Maybe<Scalars['Int']['output']>;
};

/** Current contract info for an entity. */
export type EntityContractInfo = {
  __typename?: 'EntityContractInfo';
  contractModules?: Maybe<Array<Maybe<EntityContractModule>>>;
  features?: Maybe<Array<Maybe<Scalars['RawJson']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  usesContractModule?: Maybe<Scalars['Boolean']['output']>;
};

/** Contract module for an entity. */
export type EntityContractModule = {
  __typename?: 'EntityContractModule';
  bookCollection?: Maybe<Scalars['String']['output']>;
  moduleIconUri?: Maybe<Scalars['String']['output']>;
  moduleName?: Maybe<Scalars['String']['output']>;
};

export type EntityOption = {
  __typename?: 'EntityOption';
  ancestry?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtrees?: Maybe<Scalars['RawJson']['output']>;
};

export type EntityParamsInput = {
  degree?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentEntityId?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityPublicInfoPayload = {
  __typename?: 'EntityPublicInfoPayload';
  degree?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  rootName?: Maybe<Scalars['String']['output']>;
};

export type EntityReaderPayload = {
  __typename?: 'EntityReaderPayload';
  accessExpireDate?: Maybe<Scalars['String']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastPresenceEvent?: Maybe<LastPresenceEvent>;
  lastRunningRecordsResult?: Maybe<LastRunningRecordsResultPayload>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  readingFluencyResult?: Maybe<ReadingFluencyResult>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teacherPermissions?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type EntitySelectedItem = {
  __typename?: 'EntitySelectedItem';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EntitySummary = {
  __typename?: 'EntitySummary';
  ancestry?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExamQuestion = {
  __typename?: 'ExamQuestion';
  baseText?: Maybe<BaseText>;
  bnccAbilities?: Maybe<Array<Maybe<BnccAbility>>>;
  bnccAbility?: Maybe<BnccAbilityExamQuestion>;
  bnccAbilityExamQuestion?: Maybe<BnccAbilityExamQuestion>;
  books?: Maybe<Array<Maybe<Book>>>;
  commentedAnswer?: Maybe<Scalars['String']['output']>;
  examQuestionChoices?: Maybe<Array<Maybe<ExamQuestionChoice>>>;
  examQuestionMatchingPairs?: Maybe<Array<Maybe<ExamQuestionMatchingPairs>>>;
  expectedAnswer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  pageReference?: Maybe<Scalars['String']['output']>;
  relatedBnccs?: Maybe<Array<Maybe<BnccAbility>>>;
  statement?: Maybe<Scalars['String']['output']>;
  tempImage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExamQuestionType>;
};

export type ExamQuestionChoice = {
  __typename?: 'ExamQuestionChoice';
  examQuestionId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
  tempImage?: Maybe<Scalars['String']['output']>;
};

export type ExamQuestionChoiceInput = {
  examQuestionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type ExamQuestionMatchingPairs = {
  __typename?: 'ExamQuestionMatchingPairs';
  id?: Maybe<Scalars['String']['output']>;
  leftId?: Maybe<Scalars['String']['output']>;
  leftStatement?: Maybe<Scalars['String']['output']>;
  rightId?: Maybe<Scalars['String']['output']>;
  rightStatement?: Maybe<Scalars['String']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
};

export enum ExamQuestionType {
  /** Questão discursiva */
  Discursive = 'DISCURSIVE',
  /** Questão de conexão */
  MatchingPair = 'MATCHING_PAIR',
  /** Questão objetiva */
  Objective = 'OBJECTIVE',
  /** Questão observação */
  Observation = 'OBSERVATION'
}

export type FamilyPayingExtraInformation = {
  __typename?: 'FamilyPayingExtraInformation';
  activeUsers?: Maybe<Scalars['Int']['output']>;
  paidUsers?: Maybe<Scalars['Int']['output']>;
};

export type FamilyPayingModuleInfoPayload = {
  __typename?: 'FamilyPayingModuleInfoPayload';
  bookCollection?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountExpirationDate?: Maybe<Scalars['String']['output']>;
  minUsers?: Maybe<Scalars['Int']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
};

export type Feature = {
  __typename?: 'Feature';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureToggles = {
  __typename?: 'FeatureToggles';
  activitiesV3?: Maybe<Scalars['Boolean']['output']>;
  adminPanelV2Rollout?: Maybe<Scalars['Boolean']['output']>;
  appAtualidades?: Maybe<Scalars['Boolean']['output']>;
  appEnableAdminPanel?: Maybe<Scalars['Boolean']['output']>;
  askTheBook?: Maybe<Scalars['Boolean']['output']>;
  autoCorrectionWithAi?: Maybe<Scalars['Boolean']['output']>;
  bookReadingRecord?: Maybe<Scalars['Boolean']['output']>;
  comprehensionQuestions?: Maybe<Scalars['Boolean']['output']>;
  doActivityV2?: Maybe<Scalars['Boolean']['output']>;
  elevenLabsReadAloud?: Maybe<Scalars['Boolean']['output']>;
  enableModuleLer?: Maybe<Scalars['Boolean']['output']>;
  enableReadingFluencyReapplication?: Maybe<Scalars['Boolean']['output']>;
  entityUsersOnlineStatus?: Maybe<Scalars['Boolean']['output']>;
  fluencyEmptyState?: Maybe<Scalars['Boolean']['output']>;
  hiddenLeagueName?: Maybe<Scalars['Boolean']['output']>;
  hideNews?: Maybe<Scalars['Boolean']['output']>;
  intermediaryPageRecommendations?: Maybe<Scalars['Boolean']['output']>;
  jsChallenge?: Maybe<Scalars['Boolean']['output']>;
  labAiOptimizedSearch?: Maybe<Scalars['Boolean']['output']>;
  layoutThema?: Maybe<Scalars['Boolean']['output']>;
  maple?: Maybe<Scalars['Boolean']['output']>;
  markAsReadModal?: Maybe<Scalars['Boolean']['output']>;
  mobiarvorev3?: Maybe<Scalars['Boolean']['output']>;
  newContentIndicationInfrastructure?: Maybe<Scalars['Boolean']['output']>;
  newPermissionsManagement?: Maybe<Scalars['Boolean']['output']>;
  newReadingAssessmentV2?: Maybe<Scalars['Boolean']['output']>;
  newReadingFluency?: Maybe<Scalars['Boolean']['output']>;
  notificationPreferencesApp?: Maybe<Scalars['Boolean']['output']>;
  onboardingAlunoV3?: Maybe<Scalars['Boolean']['output']>;
  onboardingTeacher?: Maybe<Scalars['Boolean']['output']>;
  ottoAiEnabled?: Maybe<Scalars['Boolean']['output']>;
  pagarmeV5Enabled?: Maybe<Scalars['Boolean']['output']>;
  paranaNotice?: Maybe<Scalars['Boolean']['output']>;
  readAloudV2Leveling?: Maybe<Scalars['Boolean']['output']>;
  readingFluency6thGradeLeveling?: Maybe<Scalars['Boolean']['output']>;
  readingFluencySimplifiedResults?: Maybe<Scalars['Boolean']['output']>;
  readingReportV2?: Maybe<Scalars['Boolean']['output']>;
  readingRewards?: Maybe<Scalars['Boolean']['output']>;
  readingRewardsPoints?: Maybe<Scalars['Boolean']['output']>;
  registerAudioBooksV2Enabled?: Maybe<Scalars['Boolean']['output']>;
  reportReadingGoalsEnabled?: Maybe<Scalars['Boolean']['output']>;
  reportsV2?: Maybe<Scalars['Boolean']['output']>;
  rewind?: Maybe<Scalars['Boolean']['output']>;
  runningRecords?: Maybe<Scalars['Boolean']['output']>;
  sentirEmotionJournal?: Maybe<Scalars['Boolean']['output']>;
  sentirEmotionJournalNotes?: Maybe<Scalars['Boolean']['output']>;
  sentirEmotionJournalSecondaryEmotions?: Maybe<Scalars['Boolean']['output']>;
  sharedReadingEnabled?: Maybe<Scalars['Boolean']['output']>;
  showPressreaderIconOnHeader?: Maybe<Scalars['Boolean']['output']>;
  storyTree?: Maybe<Scalars['Boolean']['output']>;
  summaryReportV2?: Maybe<Scalars['Boolean']['output']>;
  suspiciousActivityUsersSeduc?: Maybe<Scalars['Boolean']['output']>;
  usageTime?: Maybe<Scalars['Boolean']['output']>;
  useImportationAiBased?: Maybe<Scalars['Boolean']['output']>;
  useNewImportationProcess?: Maybe<Scalars['Boolean']['output']>;
};

export enum FeatureType {
  /** banca */
  Banca = 'BANCA',
  /** liga */
  Liga = 'LIGA'
}

export type FieldPractice = {
  __typename?: 'FieldPractice';
  actionField?: Maybe<ActionField>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  practiceObjects?: Maybe<PracticeObject>;
};

export type Forest = {
  __typename?: 'Forest';
  coins?: Maybe<Scalars['Decimal']['output']>;
  friendTreeListings?: Maybe<Array<Maybe<TreeListing>>>;
  friends?: Maybe<Array<Maybe<Friend>>>;
  friendsForAdmin?: Maybe<Array<Maybe<FriendForAdmin>>>;
  id?: Maybe<Scalars['Int']['output']>;
  seeds?: Maybe<Array<Maybe<Seed>>>;
  specialItems?: Maybe<Array<Maybe<SpecialItem>>>;
  treeListings?: Maybe<Array<Maybe<TreeListing>>>;
  trees?: Maybe<Array<Maybe<Tree>>>;
  waterDropDetails?: Maybe<WaterDropDetails>;
};


export type ForestFriendTreeListingsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  friendReaderId: Scalars['Int']['input'];
};


export type ForestFriendsArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type ForestFriendsForAdminArgs = {
  count: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type ForestTreeListingsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type ForestTreesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type FpBookfairExtraInformation = {
  __typename?: 'FpBookfairExtraInformation';
  activeUsers?: Maybe<Scalars['Int']['output']>;
  paidUsers?: Maybe<Scalars['Int']['output']>;
};

export type FpBookfairModuleInfoPayload = {
  __typename?: 'FpBookfairModuleInfoPayload';
  bookCollection?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountExpirationDate?: Maybe<Scalars['String']['output']>;
  minUsers?: Maybe<Scalars['Int']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
};

export type Friend = {
  __typename?: 'Friend';
  name?: Maybe<Scalars['String']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
};

export type FriendForAdmin = {
  __typename?: 'FriendForAdmin';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Game = {
  __typename?: 'Game';
  coins?: Maybe<Scalars['Decimal']['output']>;
  waterDrops?: Maybe<Scalars['Decimal']['output']>;
};

export type GameReward = {
  __typename?: 'GameReward';
  coins?: Maybe<Scalars['Int']['output']>;
  waterDrops?: Maybe<Scalars['Int']['output']>;
};

export type GeneralSkill = {
  __typename?: 'GeneralSkill';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type GeneralSummaryManagementIndicators = {
  __typename?: 'GeneralSummaryManagementIndicators';
  classesCount: Scalars['Int']['output'];
  networksCount: Scalars['Int']['output'];
  schoolsCount: Scalars['Int']['output'];
  studentsCount: Scalars['Int']['output'];
  trademarksCount: Scalars['Int']['output'];
};

export type GeneralSummaryPerformanceIndicators = {
  __typename?: 'GeneralSummaryPerformanceIndicators';
  assignedActivitiesCount: Scalars['Int']['output'];
  bestBnccAbilitiesByObjectiveQuestions?: Maybe<Array<Maybe<BnccAbilityRankingEntry>>>;
  completedActivitiesCountToDate: Scalars['Int']['output'];
  completedActivitiesTrendForCurrentWeek: Scalars['Int']['output'];
  indicationsCountToDate: Scalars['Int']['output'];
  indicationsTrendForCurrentWeek: Scalars['Int']['output'];
  mostIndicatedContents?: Maybe<Array<Maybe<ContentEntry>>>;
  mostReadContents?: Maybe<Array<Maybe<ContentEntry>>>;
  pendingReviewActivitiesCount: Scalars['Int']['output'];
  readingsCountByFormat?: Maybe<Array<Maybe<ReadingCountByFormatEntry>>>;
  readingsCountToDate: Scalars['Int']['output'];
  readingsTrendForCurrentWeek: Scalars['Int']['output'];
  reviewedActivitiesCount: Scalars['Int']['output'];
  startedActivitiesCount: Scalars['Int']['output'];
  worstBnccAbilitiesByObjectiveQuestions?: Maybe<Array<Maybe<BnccAbilityRankingEntry>>>;
};

export type GeneralSummaryReport = {
  __typename?: 'GeneralSummaryReport';
  managementIndicators?: Maybe<GeneralSummaryManagementIndicators>;
  performanceIndicators?: Maybe<GeneralSummaryPerformanceIndicators>;
  usageTimeIndicators?: Maybe<UsageTimeIndicators>;
};

export type GeneralVisionClassReport = {
  __typename?: 'GeneralVisionClassReport';
  currentEntity?: Maybe<GeneralVisionCurrentEntity>;
  data?: Maybe<Array<Maybe<GeneralVisionStudentData>>>;
  summaryData?: Maybe<GeneralVisionClassSummaryData>;
};

export type GeneralVisionClassSummaryData = {
  __typename?: 'GeneralVisionClassSummaryData';
  activeUsers: Scalars['Int']['output'];
  activeUsersPercentage: Scalars['Float']['output'];
  averageCorrectAnswersByUser: Scalars['Float']['output'];
  averageReadingTimeByUser: Scalars['Int']['output'];
  totalArticlesRead: Scalars['Int']['output'];
  totalBooksRead: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type GeneralVisionCurrentEntity = {
  __typename?: 'GeneralVisionCurrentEntity';
  entityId?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
};

export type GeneralVisionEntityData = {
  __typename?: 'GeneralVisionEntityData';
  activeUsers: Scalars['Int']['output'];
  activeUsersPercentage: Scalars['Float']['output'];
  averageCorrectAnswersByUser: Scalars['Float']['output'];
  averageReadingTime: Scalars['Int']['output'];
  correctAnswers: Scalars['Int']['output'];
  correctAnswersPercentage: Scalars['Float']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  totalAnswers: Scalars['Int']['output'];
  totalArticlesRead: Scalars['Int']['output'];
  totalBooksRead: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type GeneralVisionReport = {
  __typename?: 'GeneralVisionReport';
  currentEntity?: Maybe<GeneralVisionCurrentEntity>;
  data?: Maybe<Array<Maybe<GeneralVisionEntityData>>>;
  summaryData?: Maybe<GeneralVisionSummaryData>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GeneralVisionStudentData = {
  __typename?: 'GeneralVisionStudentData';
  articlesRead: Scalars['Int']['output'];
  averageCorrectAnswersByActivity: Scalars['Float']['output'];
  booksRead: Scalars['Int']['output'];
  correctAnswersPercentage: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  lastAccessDate?: Maybe<Scalars['String']['output']>;
  readingTime: Scalars['Int']['output'];
  studentName: Scalars['String']['output'];
};

export type GeneralVisionSummaryData = {
  __typename?: 'GeneralVisionSummaryData';
  activeUsers: Scalars['Int']['output'];
  activeUsersPercentage: Scalars['Float']['output'];
  averageCorrectAnswersByUser: Scalars['Float']['output'];
  averageReadingTimeByUser: Scalars['Int']['output'];
  totalArticlesRead: Scalars['Int']['output'];
  totalBooksRead: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type GeneralVisionUserBookData = {
  __typename?: 'GeneralVisionUserBookData';
  author?: Maybe<Scalars['String']['output']>;
  correctAnswers: Scalars['Int']['output'];
  correctAnswersPercentage: Scalars['Float']['output'];
  coverUrl?: Maybe<Scalars['String']['output']>;
  effectiveReadingPercentage: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  isDefaultReading: Scalars['Boolean']['output'];
  isSharedReading: Scalars['Boolean']['output'];
  readingTime: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  totalAnswers: Scalars['Int']['output'];
};

export type GeneralVisionUserReport = {
  __typename?: 'GeneralVisionUserReport';
  data?: Maybe<Array<Maybe<GeneralVisionUserBookData>>>;
  summaryData?: Maybe<GeneralVisionUserSummaryData>;
};

export type GeneralVisionUserSummaryData = {
  __typename?: 'GeneralVisionUserSummaryData';
  averageCorrectAnswersByActivity: Scalars['Float']['output'];
  correctAnswersPercentage: Scalars['Float']['output'];
  readingTime: Scalars['Int']['output'];
  totalBooksRead: Scalars['Int']['output'];
};

export type GetBookSnippetsByDegreePayload = {
  __typename?: 'GetBookSnippetsByDegreePayload';
  book?: Maybe<Book>;
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rawText?: Maybe<Scalars['String']['output']>;
  textInHtml?: Maybe<Scalars['String']['output']>;
  wordCount?: Maybe<Scalars['Int']['output']>;
};

export type GetClientPayload = {
  __typename?: 'GetClientPayload';
  accessCode?: Maybe<Scalars['String']['output']>;
  blockAccessTokens?: Maybe<Scalars['Boolean']['output']>;
  clientContracts?: Maybe<Array<Maybe<ClientContractPayload>>>;
  contractModules?: Maybe<Array<Maybe<ContractModule>>>;
  deactivated?: Maybe<Scalars['Boolean']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  internalContacts?: Maybe<Scalars['RawJson']['output']>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  loginType?: Maybe<Scalars['RawJson']['output']>;
  maxSimultaneousUsers?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payingClient?: Maybe<Scalars['Boolean']['output']>;
  responsibleEmail?: Maybe<Scalars['String']['output']>;
  responsibleName?: Maybe<Scalars['String']['output']>;
  schoolStructure?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  usesContractModuleSystem?: Maybe<Scalars['Boolean']['output']>;
  whoPays?: Maybe<Scalars['String']['output']>;
};

export type GetEntityInput = {
  degreesList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetMotrixAssessmentsInput = {
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetReaderPayload = {
  __typename?: 'GetReaderPayload';
  accessExpireDate?: Maybe<Scalars['String']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
  teacherPermissions?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type HierarchyTypeResult = {
  __typename?: 'HierarchyTypeResult';
  hierarchyType?: Maybe<Scalars['String']['output']>;
};

export type IdentifyMotrixUserPayload = {
  __typename?: 'IdentifyMotrixUserPayload';
  partnerData?: Maybe<Scalars['RawJson']['output']>;
  partnerExternalId?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ImportUserFromGoogleClassPayload = {
  __typename?: 'ImportUserFromGoogleClassPayload';
  comboId: Scalars['Int']['output'];
};

export type ImportUserFromGoogleClassRoomInput = {
  courses: Array<InputMaybe<ImportUserFromGoogleClassroomCourses>>;
  email: Scalars['String']['input'];
  isTeacher: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ImportUserFromGoogleClassroomCourses = {
  courseName?: InputMaybe<Scalars['String']['input']>;
  schoolReferenceExternalId?: InputMaybe<Scalars['String']['input']>;
};

export type Importation = {
  __typename?: 'Importation';
  clientId: Scalars['Int']['output'];
  clientName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  processType: ImportationProcessType;
  progress?: Maybe<Scalars['Int']['output']>;
  readerType: ImportationReaderType;
  status: ImportationStatus;
  userName: Scalars['String']['output'];
};

export type ImportationLine = {
  __typename?: 'ImportationLine';
  id: Scalars['Int']['output'];
  info?: Maybe<Scalars['RawJson']['output']>;
  status: ImportationLineStatus;
};

export type ImportationLinePayload = {
  __typename?: 'ImportationLinePayload';
  importationLine?: Maybe<ImportationLine>;
  updateStatus: UpdateLineStatus;
};

export enum ImportationLineStatus {
  Done = 'DONE',
  Error = 'ERROR',
  Reviewed = 'REVIEWED',
  Waiting = 'WAITING'
}

export enum ImportationProcessType {
  Add = 'ADD',
  Migrate = 'MIGRATE',
  Register = 'REGISTER',
  Regroup = 'REGROUP'
}

export enum ImportationReaderType {
  Admin = 'ADMIN',
  Reader = 'READER'
}

export enum ImportationStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Error = 'ERROR',
  New = 'NEW',
  Parsed = 'PARSED',
  Parsing = 'PARSING',
  Processing = 'PROCESSING',
  ValidatingWithAi = 'VALIDATING_WITH_AI'
}

export type IndependentActivity = {
  __typename?: 'IndependentActivity';
  appliedActivityId?: Maybe<Scalars['Int']['output']>;
  articles?: Maybe<Array<Maybe<Article>>>;
  books?: Maybe<Array<Maybe<Book>>>;
  entity?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  moduleId?: Maybe<Scalars['Int']['output']>;
  reader?: Maybe<Scalars['String']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  startedDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IndicationSourceUser = {
  __typename?: 'IndicationSourceUser';
  id?: Maybe<Scalars['Int']['output']>;
  isFamily?: Maybe<Scalars['Boolean']['output']>;
  isTeacher?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IndicationTarget = {
  __typename?: 'IndicationTarget';
  id?: Maybe<Scalars['Int']['output']>;
  targetDetails?: Maybe<IndicationTargetDetailsPayload>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IndicationTargetDetailsPayload = Entity | Reader;

export type IndicationWithInfo = {
  __typename?: 'IndicationWithInfo';
  book?: Maybe<Book>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deadlineDate?: Maybe<Scalars['String']['output']>;
  teacherName?: Maybe<Scalars['String']['output']>;
};

export type IndicationsCountEntry = {
  __typename?: 'IndicationsCountEntry';
  indicationsCount: Scalars['Int']['output'];
  referenceMonth: Scalars['Int']['output'];
};

export type InfoModuleInput = {
  bookCollection?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountExpirationDate?: InputMaybe<Scalars['String']['input']>;
  freeUsers?: InputMaybe<Scalars['Int']['input']>;
  maxReaders?: InputMaybe<Scalars['Int']['input']>;
  maxTeachers?: InputMaybe<Scalars['Int']['input']>;
  maxUsers?: InputMaybe<Scalars['Int']['input']>;
  minUsers?: InputMaybe<Scalars['Int']['input']>;
  numberOfReaders?: InputMaybe<Scalars['Int']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type InternalContactsInput = {
  customerSuccess?: InputMaybe<Scalars['String']['input']>;
  pedagogic?: InputMaybe<Scalars['String']['input']>;
  preSales?: InputMaybe<Scalars['String']['input']>;
  sales?: InputMaybe<Scalars['String']['input']>;
};

export enum JobArea {
  ExpressionsAndBody = 'EXPRESSIONS_AND_BODY',
  ForeignLanguage = 'FOREIGN_LANGUAGE',
  HumanSciences = 'HUMAN_SCIENCES',
  LanguagesAndCommunication = 'LANGUAGES_AND_COMMUNICATION',
  MathematicsAndTechnologies = 'MATHEMATICS_AND_TECHNOLOGIES',
  NaturalSciences = 'NATURAL_SCIENCES',
  PersonalDevelopment = 'PERSONAL_DEVELOPMENT',
  TechnologyAndInnovation = 'TECHNOLOGY_AND_INNOVATION'
}

export enum JobPosition {
  Administrative = 'ADMINISTRATIVE',
  AssistantOrIntern = 'ASSISTANT_OR_INTERN',
  Coordinator = 'COORDINATOR',
  EducationalTechnology = 'EDUCATIONAL_TECHNOLOGY',
  Financial = 'FINANCIAL',
  It = 'IT',
  Librarian = 'LIBRARIAN',
  PedagogicalAdvisor = 'PEDAGOGICAL_ADVISOR',
  Principal = 'PRINCIPAL',
  Psychologist = 'PSYCHOLOGIST',
  SchoolSupport = 'SCHOOL_SUPPORT',
  Teacher = 'TEACHER'
}

export type JoinGamePayload = {
  __typename?: 'JoinGamePayload';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type JournalEntriesByMonthPayload = {
  __typename?: 'JournalEntriesByMonthPayload';
  date?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<Maybe<EmotionJournalEntry>>>;
};

export enum JournalPrimaryEmotion {
  Happy = 'HAPPY',
  LittleHappy = 'LITTLE_HAPPY',
  LittleSad = 'LITTLE_SAD',
  Neutral = 'NEUTRAL',
  Sad = 'SAD',
  VeryHappy = 'VERY_HAPPY',
  VerySad = 'VERY_SAD'
}

export enum JournalSecondaryEmotion {
  Anger = 'ANGER',
  Animation = 'ANIMATION',
  Anxiety = 'ANXIETY',
  Calm = 'CALM',
  Cheerful = 'CHEERFUL',
  Confidence = 'CONFIDENCE',
  Confusion = 'CONFUSION',
  Courage = 'COURAGE',
  Disappointment = 'DISAPPOINTMENT',
  Discouragement = 'DISCOURAGEMENT',
  Distraction = 'DISTRACTION',
  Envy = 'ENVY',
  Fatigue = 'FATIGUE',
  Fear = 'FEAR',
  Frustration = 'FRUSTRATION',
  Fun = 'FUN',
  Gratitude = 'GRATITUDE',
  Guilt = 'GUILT',
  Happiness = 'HAPPINESS',
  Hope = 'HOPE',
  Indifference = 'INDIFFERENCE',
  Joy = 'JOY',
  Loneliness = 'LONELINESS',
  Passion = 'PASSION',
  Peace = 'PEACE',
  Pride = 'PRIDE',
  Relief = 'RELIEF',
  Satisfaction = 'SATISFACTION',
  Shame = 'SHAME',
  Stress = 'STRESS',
  Surprise = 'SURPRISE',
  Worry = 'WORRY'
}

export type KnowledgeArea = {
  __typename?: 'KnowledgeArea';
  actionFields?: Maybe<Array<Maybe<ActionField>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  specificSkills?: Maybe<Array<Maybe<SpecificSkill>>>;
};

export type LastPresenceEvent = {
  __typename?: 'LastPresenceEvent';
  createdAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LastRunningRecordsResultPayload = {
  __typename?: 'LastRunningRecordsResultPayload';
  currentLeveling?: Maybe<Scalars['String']['output']>;
  lastAssessmentDate?: Maybe<Scalars['String']['output']>;
};

export type LayersPaymentEntityInfo = {
  __typename?: 'LayersPaymentEntityInfo';
  arvoreEntityId?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
};

export type Lesson = {
  __typename?: 'Lesson';
  id?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ListArticlesInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  publisher?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ListArticlesOutput = {
  __typename?: 'ListArticlesOutput';
  articles?: Maybe<Array<Maybe<Article>>>;
  totalEntries?: Maybe<Scalars['Int']['output']>;
};

export enum ListBooksByCsvQueryType {
  Id = 'ID',
  Slug = 'SLUG'
}

export type ListIndependentActivitiesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ListIndependentActivitiesPayload = {
  __typename?: 'ListIndependentActivitiesPayload';
  activities?: Maybe<Array<Maybe<IndependentActivity>>>;
  totalEntries?: Maybe<Scalars['Int']['output']>;
};

export type ListRunningRecordsBenchmarksInput = {
  partnerLevelingId: Scalars['Int']['input'];
};

export type ListUserPartnerReportsInput = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type LoginTypeInput = {
  reader?: InputMaybe<ProfileLoginTypeInput>;
  teacher?: InputMaybe<ProfileLoginTypeInput>;
};

export enum LoginTypeOption {
  /** email */
  Email = 'EMAIL',
  /** identificador */
  Identifier = 'IDENTIFIER',
  /** prefixo */
  Prefix = 'PREFIX',
  /** sufixo */
  Sufix = 'SUFIX',
  /** access token */
  Token = 'TOKEN'
}

export enum LoginTypePrefixOrSufix {
  /** Prefixo */
  Prefix = 'PREFIX',
  /** Sufixo */
  Sufix = 'SUFIX'
}

/** A search result */
export type MainScreenSuggestion = Banner | BookSection;

export type MarkBookAsHiddenPayload = {
  __typename?: 'MarkBookAsHiddenPayload';
  status?: Maybe<Scalars['String']['output']>;
};

export type MarkBookAsReadPayload = {
  __typename?: 'MarkBookAsReadPayload';
  status?: Maybe<Scalars['String']['output']>;
};

export type MarkBookAsReadingPayload = {
  __typename?: 'MarkBookAsReadingPayload';
  status?: Maybe<Scalars['String']['output']>;
};

export type MarkBookAsUnreadPayload = {
  __typename?: 'MarkBookAsUnreadPayload';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkBookAsVisiblePayload = {
  __typename?: 'MarkBookAsVisiblePayload';
  removed?: Maybe<Scalars['Boolean']['output']>;
};

export type MatchingPairForReader = {
  __typename?: 'MatchingPairForReader';
  id?: Maybe<Scalars['Int']['output']>;
  leftId?: Maybe<Scalars['String']['output']>;
  leftStatement?: Maybe<Scalars['String']['output']>;
  rightId?: Maybe<Scalars['String']['output']>;
  rightStatement?: Maybe<Scalars['String']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
};

export type MatchingPairInput = {
  leftId: Scalars['String']['input'];
  rightId: Scalars['String']['input'];
};

export type MatchingPairV2Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  leftId: Scalars['String']['input'];
  rightId: Scalars['String']['input'];
};

export type Module = {
  __typename?: 'Module';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ModuleType {
  /** Atualidades */
  Atualidades = 'ATUALIDADES',
  /** Criar */
  Criar = 'CRIAR',
  /** Inglês */
  English = 'ENGLISH',
  /** Ler */
  Ler = 'LER',
  /** Livros */
  Livros = 'LIVROS',
  /** Socioemocional */
  Sentir = 'SENTIR'
}

export type MonthlyCompletedActivitiesCountEntry = {
  __typename?: 'MonthlyCompletedActivitiesCountEntry';
  completedActivitiesCount: Scalars['Int']['output'];
  referenceMonth: Scalars['Int']['output'];
};

export type MonthlyReadingsCountEntry = {
  __typename?: 'MonthlyReadingsCountEntry';
  readingsCount: Scalars['Int']['output'];
  referenceMonth: Scalars['Int']['output'];
};

export type MostAssignedBnccCompetenciesInput = {
  __typename?: 'MostAssignedBnccCompetenciesInput';
  competency: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type MotrixAssessmentBooksSuggestedInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type MotrixAssessmentPayload = {
  __typename?: 'MotrixAssessmentPayload';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MotrixRecordingPayload = {
  __typename?: 'MotrixRecordingPayload';
  audioDatetime?: Maybe<Scalars['String']['output']>;
  imageCategory?: Maybe<Scalars['String']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  /**
   * Current recording step of reader. Currently, the reader needs record 3 audios.
   * Useful to sync the frontend assessment routes.
   */
  indexOnSession?: Maybe<Scalars['Int']['output']>;
  recordingId?: Maybe<Scalars['String']['output']>;
  recordingStatus?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export type NewsstandArticles = {
  __typename?: 'NewsstandArticles';
  cid?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

/** Notification preferences response. */
export type NotificationPreferencesPayload = {
  __typename?: 'NotificationPreferencesPayload';
  weeklyReadingReport?: Maybe<Scalars['Boolean']['output']>;
};

export enum NotificationType {
  WeeklyReadingReport = 'WEEKLY_READING_REPORT'
}

export type NpsScore = {
  __typename?: 'NpsScore';
  createdAt?: Maybe<Scalars['DateActivity']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type OnboardingReaderProfileLikedBooks = {
  __typename?: 'OnboardingReaderProfileLikedBooks';
  liked?: Maybe<Scalars['Boolean']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type OnboardingReaderProfileLikedBooksCreationResponse = {
  __typename?: 'OnboardingReaderProfileLikedBooksCreationResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  likedBooks?: Maybe<Array<Maybe<OnboardingReaderProfileLikedBooks>>>;
};

export type OnboardingReaderProfileThemesInput = {
  priority: Scalars['Int']['input'];
  themeId: Scalars['Int']['input'];
};

export type OnboardingTheme = {
  __typename?: 'OnboardingTheme';
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParanaActivity = {
  __typename?: 'ParanaActivity';
  books: Array<ParanaActivityBook>;
  difficultyLevel?: Maybe<ActivityDifficultyLevel>;
  estimatedCompletionTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  recommendedDegrees: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  textualGenres: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ParanaActivityBook = {
  __typename?: 'ParanaActivityBook';
  imageUrlThumb: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ParanaSearchAggregation = {
  __typename?: 'ParanaSearchAggregation';
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<SearchAggregation>>>;
};

export type ParticipantInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerLeveling = {
  __typename?: 'PartnerLeveling';
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
};

export type PartnerLevelingDetailsInput = {
  degree?: InputMaybe<Degree>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};

export type PasswordResetUserPayload = {
  __typename?: 'PasswordResetUserPayload';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum PaymentProvider {
  /** Payment free provided by Árvore */
  ArvoreFree = 'ARVORE_FREE',
  /** Pagarme payment provider */
  Pagarme = 'PAGARME'
}

export enum PaymentStatus {
  CanRenew = 'CAN_RENEW',
  NotPaid = 'NOT_PAID',
  NotRequired = 'NOT_REQUIRED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Renewed = 'RENEWED'
}

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['IsoDate']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  productIdentifier: Scalars['String']['output'];
  provider: PaymentProvider;
};

export type Pillar = {
  __typename?: 'Pillar';
  iconUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Plan = {
  __typename?: 'Plan';
  favorite?: Maybe<Scalars['Boolean']['output']>;
  iconUri?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productSum?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  type?: Maybe<PlanType>;
};

export enum PlanType {
  /** aquisicao */
  FamilyPayingUpsell = 'FAMILY_PAYING_UPSELL'
}

export type PolemicTheme = {
  __typename?: 'PolemicTheme';
  name?: Maybe<Scalars['String']['output']>;
};

export type PracticeObject = {
  __typename?: 'PracticeObject';
  bnccAbilities?: Maybe<BnccAbility>;
  fieldPractice?: Maybe<FieldPractice>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
};

export type ProfileLoginTypeInput = {
  prefix?: InputMaybe<Scalars['String']['input']>;
  sufix?: InputMaybe<Scalars['String']['input']>;
  type: LoginTypeOption;
};

export enum ProfileType {
  Entities = 'ENTITIES',
  Reader = 'READER',
  Teacher = 'TEACHER'
}

export type ProgressBnccAbilityEntry = {
  __typename?: 'ProgressBnccAbilityEntry';
  ability: Scalars['String']['output'];
  abilityDescription: Scalars['String']['output'];
  totalCorrectObjectiveQuestionsCount: Scalars['Int']['output'];
  totalObjectiveQuestionsCount: Scalars['Int']['output'];
};

export type ProjectExtraInformation = {
  __typename?: 'ProjectExtraInformation';
  maxReaders?: Maybe<Scalars['Int']['output']>;
  maxTeachers?: Maybe<Scalars['Int']['output']>;
};

export type ProjectModuleInfoPayload = {
  __typename?: 'ProjectModuleInfoPayload';
  bookCollection?: Maybe<Scalars['String']['output']>;
  maxReaders?: Maybe<Scalars['Int']['output']>;
  maxTeachers?: Maybe<Scalars['Int']['output']>;
};

export enum Provider {
  /** Google */
  Google = 'GOOGLE',
  /** Microsoft */
  Microsoft = 'MICROSOFT'
}

export type PublicDataActivity = {
  __typename?: 'PublicDataActivity';
  curationStatus?: Maybe<Scalars['String']['output']>;
  degreeRange?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  generalSkills?: Maybe<Array<Maybe<GeneralSkill>>>;
  id?: Maybe<Scalars['Int']['output']>;
  objective?: Maybe<Scalars['String']['output']>;
  publicActivity?: Maybe<Activity>;
  publicActivityId?: Maybe<Scalars['Int']['output']>;
  school?: Maybe<Scalars['String']['output']>;
  sourceActivity?: Maybe<Activity>;
  sourceActivityId?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  textualGenres?: Maybe<Array<Maybe<TextualGenre>>>;
};

export type PublicExtraInformation = {
  __typename?: 'PublicExtraInformation';
  activeUsers?: Maybe<Scalars['Int']['output']>;
  numberOfReaders?: Maybe<Scalars['Int']['output']>;
};

export type PublicFeatureToggles = {
  __typename?: 'PublicFeatureToggles';
  comboRedirects?: Maybe<Scalars['Boolean']['output']>;
};

export type PublicModuleInfoPayload = {
  __typename?: 'PublicModuleInfoPayload';
  bookCollection?: Maybe<Scalars['String']['output']>;
  numberOfReaders?: Maybe<Scalars['Int']['output']>;
};

export type Publisher = {
  __typename?: 'Publisher';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type QualifyJobDescriptionResponse = {
  __typename?: 'QualifyJobDescriptionResponse';
  id: Scalars['ID']['output'];
  jobAreas: Array<Maybe<JobArea>>;
  jobPositions: Array<Maybe<JobPosition>>;
};

export type QuestionForReader = {
  __typename?: 'QuestionForReader';
  answer?: Maybe<AnswerForReader>;
  choices?: Maybe<Array<Maybe<ChoiceForReader>>>;
  coins?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  isPartiallyCorrect?: Maybe<Scalars['Boolean']['output']>;
  matchingPairs?: Maybe<Array<Maybe<MatchingPairForReader>>>;
  status?: Maybe<QuestionStatus>;
  title?: Maybe<Scalars['String']['output']>;
  titleImageUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionType>;
};

export enum QuestionStatus {
  /** Questão respondida corretamente */
  Correct = 'CORRECT',
  /** Questão respondida incorretamente */
  Incorrect = 'INCORRECT',
  /** Questão respondida incorretamente com possibilidade de retentativa */
  IncorrectWithRetry = 'INCORRECT_WITH_RETRY',
  /** Questão a ser corrigida manualmente */
  ManualCorrection = 'MANUAL_CORRECTION',
  /** Questão não respondida */
  NotAnswered = 'NOT_ANSWERED',
  /** Questão acertada parcialmente */
  Partial = 'PARTIAL'
}

export enum QuestionType {
  /** Questão discursiva */
  Discursive = 'DISCURSIVE',
  /** Questão de conexão */
  MatchingPairs = 'MATCHING_PAIRS',
  /** Questão objetiva */
  Objective = 'OBJECTIVE'
}

export type Ranking = {
  __typename?: 'Ranking';
  percentage?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  rankingUsers?: Maybe<Array<Maybe<RankingReader>>>;
  tier?: Maybe<Scalars['String']['output']>;
};

export type RankingLine = {
  __typename?: 'RankingLine';
  name?: Maybe<Scalars['ID']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  school?: Maybe<Scalars['Int']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  timeSpent?: Maybe<Scalars['Int']['output']>;
};

export type RankingReader = {
  __typename?: 'RankingReader';
  entityId?: Maybe<Scalars['Int']['output']>;
  facebookUid?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  rankPosition?: Maybe<Scalars['Int']['output']>;
  rootName?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  totalTimeSpent?: Maybe<Scalars['Decimal']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type RankingReaderHistory = {
  __typename?: 'RankingReaderHistory';
  month?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  rankPosition?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Reader = {
  __typename?: 'Reader';
  accessDaysLeft?: Maybe<Scalars['Int']['output']>;
  acervos: Array<Maybe<Scalars['String']['output']>>;
  articleShelves?: Maybe<Array<Maybe<ArticleShelf>>>;
  bookSuggestions?: Maybe<Array<Maybe<Book>>>;
  canAccessOnboarding?: Maybe<Scalars['Boolean']['output']>;
  collection?: Maybe<BookShelf>;
  collections?: Maybe<Array<Maybe<BookShelf>>>;
  contentFilters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated This field is deprecated. */
  currentProject?: Maybe<Scalars['RawJson']['output']>;
  entity?: Maybe<Entity>;
  entityId?: Maybe<Scalars['Int']['output']>;
  existsAtLeastOnePlantedTree?: Maybe<Scalars['Boolean']['output']>;
  favoriteBooks?: Maybe<Array<Maybe<Book>>>;
  forest?: Maybe<Forest>;
  game?: Maybe<Game>;
  getCurrentPoints?: Maybe<Scalars['Int']['output']>;
  getViewedBookPosition?: Maybe<Scalars['RawJson']['output']>;
  highlightsv2?: Maybe<Array<Maybe<BookShelf>>>;
  id?: Maybe<Scalars['ID']['output']>;
  indicationsForMe?: Maybe<Array<Maybe<IndicationWithInfo>>>;
  isFavoriteBook?: Maybe<Scalars['Boolean']['output']>;
  leveledCollection?: Maybe<BookShelf>;
  leveledCollections?: Maybe<Array<Maybe<BookShelf>>>;
  listAppliedActivities?: Maybe<Scalars['RawJson']['output']>;
  listEnglishLevels?: Maybe<Array<Maybe<EnglishLevel>>>;
  listReadersSameDegree?: Maybe<Scalars['RawJson']['output']>;
  magazinesShelf?: Maybe<Array<Maybe<NewsstandArticles>>>;
  /** @deprecated Use mainScreenSuggestionV3 instead. */
  mainScreenSuggestions?: Maybe<Array<Maybe<MainScreenSuggestion>>>;
  /** Returns a list of bookshelves for a reader. */
  mainScreenSuggestionsv3?: Maybe<Array<Maybe<BookShelf>>>;
  motrixAssessmentAvailable?: Maybe<Scalars['Boolean']['output']>;
  motrixAssessmentBooksSuggested?: Maybe<Array<Maybe<Book>>>;
  newspaperShelf?: Maybe<Array<Maybe<NewsstandArticles>>>;
  overallRanking?: Maybe<Ranking>;
  overallRankingHistory?: Maybe<Array<Maybe<RankingReaderHistory>>>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  permissions?: Maybe<Scalars['String']['output']>;
  ranking?: Maybe<Array<Maybe<RankingLine>>>;
  readingFluencyAssessmentAvailable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Calculate the game rewards earned since a specific period
   * ## Parameters
   * - params:
   *   * `:viewed_book_id`: integer
   *   * `:reading_session_start_at`: integer
   */
  readingGameRewardsSince?: Maybe<GameReward>;
  readingGoalStatus?: Maybe<ReadingGoalStatus>;
  relayPaginatedFavorites?: Maybe<BookAsNodeConnection>;
  /**
   * List viewed books
   * ## Parameters
   * - params: Map containing filter fields, these fields can be:
   *   * `:content_filter`: string
   *     ** Used to only list book views from english books, accepted values: ['english'];
   *   * `last`: integer
   *     ** list the n more recents viewed books
   */
  relayPaginatedViewedBooks?: Maybe<ViewedBookAsNodeConnection>;
  root?: Maybe<Entity>;
  rootAndEntityPermissions?: Maybe<Scalars['String']['output']>;
  rootId?: Maybe<Scalars['Int']['output']>;
  runningRecordsAssessmentBooksSuggested?: Maybe<Array<Maybe<Book>>>;
  sharedReadings?: Maybe<Array<Maybe<SharedReading>>>;
  /** Returns a boolean deciding if the reader can score a CSAT value for the context. */
  showCsatForm?: Maybe<Scalars['Boolean']['output']>;
  surveys?: Maybe<Scalars['RawJson']['output']>;
  /** Returns reader test periods. */
  testPeriods?: Maybe<Array<Maybe<TestPeriod>>>;
  themas?: Maybe<Array<Maybe<Thema>>>;
  topGeneralSharedReadingsWeekly?: Maybe<Array<Maybe<SharedReading>>>;
  user?: Maybe<User>;
  viewedBooks?: Maybe<Array<Maybe<ViewedBook>>>;
};


export type ReaderCollectionArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ReaderCollectionsArgs = {
  contentFilter?: InputMaybe<Scalars['String']['input']>;
};


export type ReaderGetViewedBookPositionArgs = {
  slug: Scalars['String']['input'];
};


export type ReaderHighlightsv2Args = {
  contentFilter?: InputMaybe<Scalars['String']['input']>;
};


export type ReaderIsFavoriteBookArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type ReaderLeveledCollectionArgs = {
  id: Scalars['Int']['input'];
};


export type ReaderListReadersSameDegreeArgs = {
  term: Scalars['String']['input'];
};


export type ReaderMainScreenSuggestionsv3Args = {
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type ReaderMotrixAssessmentBooksSuggestedArgs = {
  input?: InputMaybe<MotrixAssessmentBooksSuggestedInput>;
};


export type ReaderOverallRankingArgs = {
  neighbors?: InputMaybe<Scalars['Int']['input']>;
};


export type ReaderReadingGameRewardsSinceArgs = {
  readingSessionStartAt: Scalars['IsoDateTime']['input'];
  viewedBookId: Scalars['Int']['input'];
};


export type ReaderRelayPaginatedFavoritesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ReaderRelayPaginatedViewedBooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isReading?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ReaderRunningRecordsAssessmentBooksSuggestedArgs = {
  input?: InputMaybe<RunningRecordsAssessmentBooksSuggestedInput>;
};


export type ReaderSharedReadingsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sharedByMeOnly: Scalars['Boolean']['input'];
};


export type ReaderShowCsatFormArgs = {
  context: CsatContext;
};


export type ReaderViewedBooksArgs = {
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  isReading?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ReaderActivityStatus = {
  __typename?: 'ReaderActivityStatus';
  activityDetails?: Maybe<Array<ActivityDetails>>;
  bnccTags?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
};

export type ReaderPerformanceIndicators = {
  __typename?: 'ReaderPerformanceIndicators';
  completedActivitiesCountByDifficulty?: Maybe<Array<Maybe<DifficultyLevelEntry>>>;
  completedActivitiesCountToDate: Scalars['Int']['output'];
  hitRateInPercentageObjectiveQuestions: Scalars['Decimal']['output'];
  hitsPerQuestionToDate: Scalars['String']['output'];
  mostReadContents?: Maybe<Array<Maybe<ContentEntry>>>;
  objectiveQuestionsAverageScore: Scalars['Decimal']['output'];
  progressBnccAbilities?: Maybe<Array<Maybe<ProgressBnccAbilityEntry>>>;
  startedActivitiesCountToDate: Scalars['Int']['output'];
};

export type ReaderProfileOnboardingThemeCreationResponse = {
  __typename?: 'ReaderProfileOnboardingThemeCreationResponse';
  entities?: Maybe<Array<Maybe<ReaderProfileOnboardingThemes>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ReaderProfileOnboardingThemes = {
  __typename?: 'ReaderProfileOnboardingThemes';
  name?: Maybe<Scalars['String']['output']>;
  onboardingReaderProfileThemeId?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type ReaderSummaryReport = {
  __typename?: 'ReaderSummaryReport';
  performanceIndicators?: Maybe<ReaderPerformanceIndicators>;
  usageTimeIndicators?: Maybe<UsageTimeIndicators>;
  yearlyIndicators?: Maybe<ReaderYearlyIndicators>;
};

export type ReaderYearlyIndicators = {
  __typename?: 'ReaderYearlyIndicators';
  monthlyCompletedActivitiesCount?: Maybe<Array<Maybe<MonthlyCompletedActivitiesCountEntry>>>;
  monthlyReadingsCount?: Maybe<Array<Maybe<MonthlyReadingsCountEntry>>>;
};

export type ReadersAccessInfo = Card | ReadersAccessInfoPayload;

export type ReadersAccessInfoPayload = {
  __typename?: 'ReadersAccessInfoPayload';
  accessCode?: Maybe<Scalars['String']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  readerName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReadersInfoSourceType {
  /** Carteirinha */
  Card = 'CARD',
  /** Csv */
  Csv = 'CSV'
}

export type ReadingCountByFormatEntry = {
  __typename?: 'ReadingCountByFormatEntry';
  format: Scalars['String']['output'];
  readingsCount: Scalars['Int']['output'];
};

export type ReadingFluencyAssessmentInfo = {
  __typename?: 'ReadingFluencyAssessmentInfo';
  appliedBy?: Maybe<Scalars['String']['output']>;
  bookSnippetName?: Maybe<Scalars['String']['output']>;
  bookSnippetThumb?: Maybe<Scalars['String']['output']>;
  canRescheduleSubmission?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ReadingFluencyClassLevelingResult = {
  __typename?: 'ReadingFluencyClassLevelingResult';
  count?: Maybe<Scalars['Int']['output']>;
  leveling?: Maybe<ReadingFluencyLeveling>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
};

export type ReadingFluencyClassResult = {
  __typename?: 'ReadingFluencyClassResult';
  assessmentInfo?: Maybe<ReadingFluencyAssessmentInfo>;
  levelingResults?: Maybe<Array<Maybe<ReadingFluencyClassLevelingResult>>>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
};

export type ReadingFluencyClassResultForCurrentYear = {
  __typename?: 'ReadingFluencyClassResultForCurrentYear';
  assessmentInfo?: Maybe<ReadingFluencyAssessmentInfo>;
  levelingResults?: Maybe<Array<Maybe<ReadingFluencyClassLevelingResult>>>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  userResults?: Maybe<Array<Maybe<ReadingFluencyUserResult>>>;
};

/**
 * This object represents the errors by type in the reading fluency assessment.
 * Example:
 *   {
 *     "type": "mispronunciation",
 *     "quantity": 2
 *   }
 */
export type ReadingFluencyErrorDetail = {
  __typename?: 'ReadingFluencyErrorDetail';
  quantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<AzureReadingFluencyErrorType>;
};

/** This enum represents the reading fluency levelings in the reading fluency assessment. */
export enum ReadingFluencyLeveling {
  AdequateReader = 'ADEQUATE_READER',
  AdvancedReader = 'ADVANCED_READER',
  ApprenticeReader = 'APPRENTICE_READER',
  BasicReader = 'BASIC_READER',
  BeginnerReader = 'BEGINNER_READER',
  BelowBasicReader = 'BELOW_BASIC_READER',
  ExperiencedReader = 'EXPERIENCED_READER',
  FluentReader = 'FLUENT_READER',
  IntermediateReader = 'INTERMEDIATE_READER',
  Year_6BeginnerReader_1 = 'YEAR_6_BEGINNER_READER_1',
  Year_6BeginnerReader_2 = 'YEAR_6_BEGINNER_READER_2'
}

export type ReadingFluencyResult = {
  __typename?: 'ReadingFluencyResult';
  assessmentDate?: Maybe<Scalars['DateTime']['output']>;
  assessmentStatus?: Maybe<Scalars['String']['output']>;
  comprehensionLevel?: Maybe<Scalars['Int']['output']>;
  correctWordsPerMinute?: Maybe<Scalars['Decimal']['output']>;
  leveling?: Maybe<ReadingFluencyLeveling>;
};

export type ReadingFluencyUserResult = {
  __typename?: 'ReadingFluencyUserResult';
  assessmentDate?: Maybe<Scalars['DateTime']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  comprehensionLevel?: Maybe<Scalars['Int']['output']>;
  correctWordsPerMinute?: Maybe<Scalars['Decimal']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  readingFluencyResult?: Maybe<ReadingFluencyLeveling>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ReadingGoal = {
  __typename?: 'ReadingGoal';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['Int']['output'];
  goal: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ReadingGoalStatus = {
  __typename?: 'ReadingGoalStatus';
  goal: Scalars['Int']['output'];
  readingTime: Scalars['Int']['output'];
};

export enum ReadingGoalsReportOrder {
  ByName = 'BY_NAME',
  ByReadingTime = 'BY_READING_TIME'
}

export type ReadingGoalsReportPayload = {
  __typename?: 'ReadingGoalsReportPayload';
  readingGoal: ReadingGoal;
  totalCount: Scalars['Int']['output'];
  users: Array<UserReadingTime>;
};

export type ReadingReportAggregatePayload = {
  __typename?: 'ReadingReportAggregatePayload';
  totalCorrectQuestions?: Maybe<Scalars['Int']['output']>;
  totalReadingTime?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  totalValidReadingTime?: Maybe<Scalars['Int']['output']>;
};

export type ReadingReportByReaderIdItem = {
  __typename?: 'ReadingReportByReaderIdItem';
  finalGrade?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timeSpent?: Maybe<Scalars['Int']['output']>;
  validTimeSpent?: Maybe<Scalars['Int']['output']>;
};

export type ReadingReportByReaderIdResponse = {
  __typename?: 'ReadingReportByReaderIdResponse';
  readingData?: Maybe<Array<Maybe<ReadingReportByReaderIdItem>>>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ReadingReportPayload = {
  __typename?: 'ReadingReportPayload';
  finalGrade?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  timeSpent?: Maybe<Scalars['Int']['output']>;
  validTimeSpent?: Maybe<Scalars['Int']['output']>;
};

export type ReadingReportWithAggregatePayload = {
  __typename?: 'ReadingReportWithAggregatePayload';
  aggregate?: Maybe<ReadingReportAggregatePayload>;
  users?: Maybe<Array<Maybe<ReadingReportPayload>>>;
};

export type Referral = {
  __typename?: 'Referral';
  contact?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  referralType?: Maybe<ReferralType>;
  role?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export enum ReferralType {
  EnglishAsLanguage = 'ENGLISH_AS_LANGUAGE',
  ReferAFriend = 'REFER_A_FRIEND',
  SelfReferral = 'SELF_REFERRAL'
}

export type RelatedContent = {
  __typename?: 'RelatedContent';
  source: RelatedContentSource;
  url: Scalars['String']['output'];
};

export enum RelatedContentSource {
  Youtube = 'YOUTUBE'
}

export type RemoveArticleFromActivityPayload = {
  __typename?: 'RemoveArticleFromActivityPayload';
  activity?: Maybe<Activity>;
  article?: Maybe<Article>;
};

export type RemoveContractModuleFromEntityInput = {
  contractModuleId: Scalars['Int']['input'];
  entityAndSubtree: Scalars['Boolean']['input'];
  entityId: Scalars['Int']['input'];
};

export type RescheduleReadingFluencyAssessmentInput = {
  assessmentId: Scalars['Int']['input'];
  newEndDate: Scalars['Date']['input'];
};

export type ResendEmailConfirmationPayload = {
  __typename?: 'ResendEmailConfirmationPayload';
  secondEmail?: Maybe<Scalars['String']['output']>;
};

export type ReviewedActivitiesCountEntry = {
  __typename?: 'ReviewedActivitiesCountEntry';
  referenceMonth: Scalars['Int']['output'];
  reviewedActivitiesCount: Scalars['Int']['output'];
};

export type Reward = {
  __typename?: 'Reward';
  amount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<RewardType>;
};

export enum RewardType {
  Coins = 'COINS'
}

export enum Role {
  Admin = 'ADMIN',
  Advanced = 'ADVANCED',
  Basic = 'BASIC',
  SuperAdmin = 'SUPER_ADMIN'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  activateAutomaticGrading?: Maybe<AppliedActivityAnswer>;
  activateBookshelf?: Maybe<BookShelf>;
  activateFeatureToEntity?: Maybe<Entity>;
  activateLayersUser?: Maybe<ActivateLayersUserPayload>;
  activateOrDeactivateContract?: Maybe<ContractPayload>;
  addAbilityToExamQuestion?: Maybe<Activity>;
  /** Associates one article to many activities */
  addActivitiesToArticle?: Maybe<Array<Maybe<AddActivitiesToArticle>>>;
  /**
   * Associates the article to the activity
   * @deprecated Use AddActivitiesToArticle instead
   */
  addArticleToActivity?: Maybe<AddArticleToActivityPayload>;
  addBnccTag?: Maybe<DidacticSequence>;
  addBookToActivity?: Maybe<Activity>;
  addBookToAtualidadesActivity?: Maybe<Activity>;
  addBookToBlackList?: Maybe<Book>;
  addBookToExamQuestion?: Maybe<Activity>;
  addBooksToBookShelf?: Maybe<Array<Maybe<BookShelfItem>>>;
  addBooksToCollection?: Maybe<Scalars['Int']['output']>;
  addChoiceToActivityExamQuestion?: Maybe<Activity>;
  addChoiceToExamQuestion?: Maybe<ExamQuestionChoice>;
  addDidacticSequenceAbility?: Maybe<DidacticSequence>;
  addDidacticSequenceBook?: Maybe<DidacticSequence>;
  addDidacticSequenceLesson?: Maybe<DidacticSequence>;
  addDidacticSequenceSpecificSkill?: Maybe<DidacticSequence>;
  addDidacticSequenceTextualGenre?: Maybe<DidacticSequence>;
  addDidaticSequenceDegree?: Maybe<DidacticSequence>;
  addMascotToBookShelfItem?: Maybe<BookShelfItem>;
  addTag?: Maybe<Activity>;
  addTeacherEntityToUser?: Maybe<Scalars['Int']['output']>;
  addTextualGenre?: Maybe<Activity>;
  addToFavorites?: Maybe<ActionResult>;
  /** Allows any admin from Time Árvore to soft delete an activity. */
  adminDeleteActivity?: Maybe<Activity>;
  adminUpdateUserData?: Maybe<User>;
  answerMatchingPair?: Maybe<AnswerMatchingPairPayload>;
  answerMatchingPairsV2?: Maybe<AnswerMatchingPairsV2Payload>;
  applyActivitiesToEntitiesTeachers?: Maybe<ApplyActivitiesToEntitiesTeachersPayload>;
  /**
   * Applies an activity to an entity.
   * `start_date` and `end_date` must be in the format `DD/MM/YYYY`.
   */
  applyActivityToEntity?: Maybe<AppliedActivity>;
  /**
   * Applies an activity to a reader.
   * `start_date` and `end_date` must be in the format `DD/MM/YYYY`.
   */
  applyActivityToReader?: Maybe<AppliedActivity>;
  /** Applies an assignment with multiple activities to entities/readers. */
  applyAssignment?: Maybe<ApplyAssignmentPayload>;
  /** Applies an independent activity (through an existent activity) to a reader. */
  applyIndependentActivityToReader?: Maybe<AppliedActivity>;
  approveActivityForPublic?: Maybe<Activity>;
  arvoreSharedReading?: Maybe<ArvoreSharedReadingPayload>;
  assignOnboardingLikedBooksToReader?: Maybe<OnboardingReaderProfileLikedBooksCreationResponse>;
  authenticateWithProvider?: Maybe<Scalars['String']['output']>;
  boostForest?: Maybe<Forest>;
  bootstrapActivityForReader?: Maybe<BootstrapActivityForReaderPayload>;
  buySeed?: Maybe<BuySeedPayload>;
  buySpecialItem?: Maybe<BuySpecialItemPayload>;
  /** Cancels an import. */
  cancelImportation?: Maybe<Importation>;
  cancelLastReadingFluencyAssessmentResult?: Maybe<Scalars['String']['output']>;
  changeAdminPermissions?: Maybe<ActionResult>;
  changeBooksSlugs?: Maybe<Array<Maybe<Book>>>;
  changeEntity?: Maybe<Scalars['RawJson']['output']>;
  changeOrderFromBookShelf?: Maybe<Array<Maybe<BookShelf>>>;
  changeOrderFromBookShelfItem?: Maybe<Array<Maybe<BookShelfItem>>>;
  changePassword?: Maybe<User>;
  changePasswordFirstLogin?: Maybe<User>;
  changeRole?: Maybe<User>;
  changeTeacherEntity?: Maybe<Teacher>;
  chooseTeacherClass?: Maybe<Scalars['String']['output']>;
  claimReward?: Maybe<ClaimRewardPayload>;
  confirmTeacherEmail?: Maybe<ConfirmTeacherEmailPayload>;
  consumeContent?: Maybe<ConsumeContentOutput>;
  /** @deprecated Use createActivityV2 instead */
  createActivity?: Maybe<Activity>;
  /** Creates an activity using only one request */
  createActivityV2?: Maybe<Activity>;
  createAppliedActivityAnswer?: Maybe<AppliedActivityAnswer>;
  createArticle?: Maybe<Article>;
  createAtivity?: Maybe<Activity>;
  /** @deprecated Use createActivityV2 instead */
  createAtualidadesActivity?: Maybe<Activity>;
  createBaseText?: Maybe<BaseText>;
  createBatchEntities?: Maybe<Array<Maybe<CreateBatchEntitiesPayload>>>;
  createBookShelf?: Maybe<BookShelf>;
  createContentIndications?: Maybe<Array<Maybe<ContentIndication>>>;
  createCoordinatorClasses?: Maybe<Teacher>;
  createDidacticSequence?: Maybe<DidacticSequence>;
  createEmotionJournalEntry?: Maybe<EmotionJournalEntry>;
  createEnglishAsLanguageReferral?: Maybe<Referral>;
  createEntity?: Maybe<Entity>;
  createExamQuestion?: Maybe<ExamQuestion>;
  createNewMotrixRecording?: Maybe<MotrixRecordingPayload>;
  createOnboardingReaderThemes?: Maybe<ReaderProfileOnboardingThemeCreationResponse>;
  createOrUpdateClient?: Maybe<CreateOrUpdateClientPayload>;
  createOrUpdateContract?: Maybe<ContractPayload>;
  createOrUpdateModuleAndObservation?: Maybe<ContractPayload>;
  createOrUpdateReadingGoals?: Maybe<CreateOrUpdateReadingGoalsPayload>;
  createPaymentTransaction?: Maybe<PaymentTransaction>;
  createPublicDataActivity?: Maybe<Activity>;
  createReader?: Maybe<User>;
  createReferralToAFriend?: Maybe<Referral>;
  createSampleEntities?: Maybe<Array<Maybe<Entity>>>;
  createSelfReferral?: Maybe<Referral>;
  /** @deprecated Use createActivityV2 instead */
  createSentirActivity?: Maybe<Activity>;
  createSharedReading?: Maybe<SharedReading>;
  createTeacher?: Maybe<User>;
  createTeacherSubject?: Maybe<Teacher>;
  curationAddBookToActivity?: Maybe<Activity>;
  curationAddChoiceToExamQuestion?: Maybe<ExamQuestionChoice>;
  curationAddGeneralSkillToPublicData?: Maybe<Activity>;
  curationAddTagToPublicData?: Maybe<Activity>;
  curationAddTextualGenreToPublicData?: Maybe<Activity>;
  curationApprove?: Maybe<PublicDataActivity>;
  curationChangeActivityTitle?: Maybe<Activity>;
  curationChangeChoiceStatement?: Maybe<Activity>;
  curationChangeExamQuestionStatement?: Maybe<Activity>;
  curationChangePublicDataDegreeRange?: Maybe<Activity>;
  curationChangePublicDataEmail?: Maybe<Activity>;
  curationChangePublicDataObjective?: Maybe<Activity>;
  curationChangePublicDataSchool?: Maybe<Activity>;
  curationCreateExamQuestion?: Maybe<ExamQuestion>;
  curationDeleteExamQuestion?: Maybe<Activity>;
  curationPublish?: Maybe<PublicDataActivity>;
  curationRefuse?: Maybe<PublicDataActivity>;
  curationRemoveBookFromActivity?: Maybe<Activity>;
  curationRemoveChoiceFromExamQuestion?: Maybe<Activity>;
  curationRemoveGeneralSkillFromPublicData?: Maybe<Activity>;
  curationRemoveTagFromPublicData?: Maybe<Activity>;
  curationRemoveTextualGenreFromPublicData?: Maybe<Activity>;
  curationSetExamQuestionOrder?: Maybe<Array<Maybe<ActivityExamQuestion>>>;
  curationSetIsCorrectChoice?: Maybe<Activity>;
  curationUnpublish?: Maybe<PublicDataActivity>;
  deactivateBookshelf?: Maybe<BookShelf>;
  deactivateClient?: Maybe<DeactivateClientPayload>;
  deactivateClients?: Maybe<Array<Maybe<DeactivateClientsPayload>>>;
  deactivateEntities?: Maybe<Scalars['RawJson']['output']>;
  deactivateReadingGoal?: Maybe<DeactivateReadingGoalPayload>;
  deactivateUser?: Maybe<Scalars['RawJson']['output']>;
  deleteActivity?: Maybe<Activity>;
  deleteAppliedActivity?: Maybe<AppliedActivity>;
  /**
   * Removes the tag completely and all its associations.
   * This action affects other didactic sequences that already
   * have associations with this tag.
   */
  deleteBnccTag?: Maybe<BnccTag>;
  deleteDidacticSequence?: Maybe<DidacticSequence>;
  deleteEntity?: Maybe<Scalars['RawJson']['output']>;
  deleteExamQuestion?: Maybe<Activity>;
  deleteSampleEntity?: Maybe<Entity>;
  deleteTutorial?: Maybe<Tutorial>;
  desativateFeatureFromEntity?: Maybe<Entity>;
  /** Delete a article */
  disableArticle?: Maybe<Article>;
  /** Disables the assessment record with the given id. */
  disableAssessment?: Maybe<Scalars['String']['output']>;
  duplicateActivity?: Maybe<Activity>;
  duplicateBookshelf?: Maybe<BookShelf>;
  /** Edits an activity using only one request */
  editActivity?: Maybe<Activity>;
  editAppliedActivity?: Maybe<AppliedActivity>;
  editDidacticSequenceLesson?: Maybe<Lesson>;
  editEntity?: Maybe<Scalars['RawJson']['output']>;
  editExamQuestions?: Maybe<Array<Maybe<ExamQuestionChoice>>>;
  editManyUsers?: Maybe<Array<Maybe<UserChange>>>;
  editUser?: Maybe<User>;
  favoriteDidacticSequence?: Maybe<ActionStatus>;
  fullPasswordReset?: Maybe<Scalars['String']['output']>;
  getUser?: Maybe<UserLoginInfo>;
  /** Identify/create a user on Motrix side. */
  identifyMotrixUser?: Maybe<IdentifyMotrixUserPayload>;
  importUserFromGoogleClassRoom?: Maybe<ImportUserFromGoogleClassPayload>;
  joinGame?: Maybe<JoinGamePayload>;
  /** Allows the user to update the reason for a CSAT score. */
  justifyCsat?: Maybe<CsatJustifyPayload>;
  likeOrDislikeSharedReading?: Maybe<Scalars['RawJson']['output']>;
  listBooksByCsv?: Maybe<Array<Maybe<Book>>>;
  listClientsByCsv?: Maybe<Array<Maybe<ClientListing>>>;
  login?: Maybe<Session>;
  loginDirectFacebook?: Maybe<SessionWithFacebook>;
  loginUserForPayment?: Maybe<Session>;
  loginWithFacebook?: Maybe<SessionWithFacebook>;
  loginWithToken?: Maybe<Session>;
  markBookAsHidden?: Maybe<MarkBookAsHiddenPayload>;
  markBookAsRead?: Maybe<MarkBookAsReadPayload>;
  markBookAsReading?: Maybe<MarkBookAsReadingPayload>;
  markBookAsUnread?: Maybe<MarkBookAsUnreadPayload>;
  markBookAsVisible?: Maybe<MarkBookAsVisiblePayload>;
  moveReader?: Maybe<Scalars['RawJson']['output']>;
  moveReaders?: Maybe<Scalars['RawJson']['output']>;
  moveUserToRoot?: Maybe<BasicUser>;
  passwordReset?: Maybe<Scalars['String']['output']>;
  /** Process an import asynchronously. */
  processImportation?: Maybe<Importation>;
  processImportationSuggestion?: Maybe<ImportationLinePayload>;
  processOnixFile?: Maybe<Scalars['RawJson']['output']>;
  publishArticle?: Maybe<Article>;
  publishDidacticSequence?: Maybe<DidacticSequence>;
  qualifyJobDescription?: Maybe<QualifyJobDescriptionResponse>;
  qualifyUserJobDescription?: Maybe<QualifyJobDescriptionResponse>;
  rateAppStore?: Maybe<StoreRating>;
  removeAbilityFromExamQuestion?: Maybe<Activity>;
  /** Removes the association between the article and activity */
  removeArticleFromActivity?: Maybe<RemoveArticleFromActivityPayload>;
  removeBaseText?: Maybe<BaseText>;
  /** Removes association between tag and didactic sequence */
  removeBnccTag?: Maybe<DidacticSequence>;
  removeBookFromActivity?: Maybe<Activity>;
  removeBookFromAtualidadesActivity?: Maybe<Activity>;
  removeBookFromBlackList?: Maybe<Book>;
  removeBookFromBookShelf?: Maybe<BookShelfItem>;
  removeBookFromExamQuestion?: Maybe<Activity>;
  removeBookShelf?: Maybe<BookShelf>;
  removeChoiceFromExamQuestion?: Maybe<Activity>;
  removeContentIndication?: Maybe<ContentIndication>;
  removeContractModuleFromEntity?: Maybe<Scalars['RawJson']['output']>;
  removeDidacticSequenceAbility?: Maybe<DidacticSequence>;
  removeDidacticSequenceBook?: Maybe<DidacticSequence>;
  removeDidacticSequenceLesson?: Maybe<DidacticSequence>;
  removeDidacticSequenceSpecificSkill?: Maybe<DidacticSequence>;
  removeDidacticSequenceTextualGenre?: Maybe<DidacticSequence>;
  removeDidaticSequenceDegree?: Maybe<DidacticSequence>;
  removeExamQuestion?: Maybe<Activity>;
  removeExamQuestionChoice?: Maybe<Activity>;
  removeFromFavorites?: Maybe<ActionResult>;
  removeMascotFromBookShelfItem?: Maybe<BookShelfItem>;
  removeOnboardingThemesFromReader?: Maybe<DeleteOnboardingThemeFromReaderResponse>;
  removeTag?: Maybe<Activity>;
  removeTeacherClass?: Maybe<Scalars['String']['output']>;
  removeTeacherClasses?: Maybe<Teacher>;
  removeTeacherSubject?: Maybe<Teacher>;
  removeTextualGenre?: Maybe<Activity>;
  requestPasswordReset?: Maybe<Scalars['String']['output']>;
  requestVoucher?: Maybe<Scalars['String']['output']>;
  requirePayment?: Maybe<Scalars['String']['output']>;
  rescheduleSubmissionDateForReadingFluencyAssessment?: Maybe<Scalars['String']['output']>;
  resendEmailConfirmation?: Maybe<ResendEmailConfirmationPayload>;
  resetPassword?: Maybe<Scalars['RawJson']['output']>;
  /** Allows the user to score the CSAT value. */
  scoreCsat?: Maybe<CsatScorePayload>;
  scoreNps?: Maybe<NpsScore>;
  seekAndDestroyEmptyClasses?: Maybe<SeekAndDestroyEmptyClassesPayload>;
  selfRegister?: Maybe<SelfRegisterPayload>;
  sendActivityForCorrection?: Maybe<AppliedActivityAnswer>;
  sendApplicationToReader?: Maybe<AppliedActivityAnswer>;
  sendFeatureFeedback?: Maybe<Scalars['String']['output']>;
  /**
   * Sends the result of Running Records assessment. It receives:
   *  - New level id,
   *  - Reader's user Id
   */
  sendRunningRecordsResult?: Maybe<Scalars['String']['output']>;
  setActivityDegreeRange?: Maybe<Activity>;
  setActivityDescription?: Maybe<Activity>;
  setActivityTitle?: Maybe<Activity>;
  setActivityToReady?: Maybe<Activity>;
  setAppliedActivityAnswerStatusCancelled?: Maybe<Array<Maybe<AppliedActivityAnswer>>>;
  setBaseTextStatement?: Maybe<Activity>;
  setChoiceIdAnswer?: Maybe<Answer>;
  setChoiceStatement?: Maybe<Activity>;
  setCommentedAnswer?: Maybe<Activity>;
  setContractDatesAndWarning?: Maybe<ContractPayload>;
  setContractMarket?: Maybe<ContractPayload>;
  setContractModuleToEntity?: Maybe<Scalars['RawJson']['output']>;
  setDidacticSequenceArvoreId?: Maybe<DidacticSequence>;
  setDidacticSequenceAuthor?: Maybe<DidacticSequence>;
  setDidacticSequenceContent?: Maybe<DidacticSequence>;
  setDidacticSequenceEvaluation?: Maybe<DidacticSequence>;
  setDidacticSequencePurposes?: Maybe<DidacticSequence>;
  setDidacticSequenceSummary?: Maybe<DidacticSequence>;
  setDidacticSequenceTitle?: Maybe<DidacticSequence>;
  setDiscursiveAnswer?: Maybe<AnswerForReader>;
  setExamQuestionCommentedAnswer?: Maybe<Activity>;
  setExamQuestionOrder?: Maybe<Array<Maybe<ActivityExamQuestion>>>;
  setExamQuestionStatement?: Maybe<Activity>;
  setExamQuestionToBaseText?: Maybe<Activity>;
  setFinalCommentAppliedActivityAnswer?: Maybe<AppliedActivityAnswer>;
  setFinalGradeAppliedActivityAnswer?: Maybe<AppliedActivityAnswer>;
  setFinanceContact?: Maybe<ContractPayload>;
  setGradeAnswer?: Maybe<AppliedActivityAnswer>;
  setIsCorrect?: Maybe<Activity>;
  setIsCorrectChoice?: Maybe<Activity>;
  setIsShuffleToBookshelf?: Maybe<BookShelf>;
  setLastDayAccessToReader?: Maybe<Reader>;
  setPublicActivityDegreeRange?: Maybe<Activity>;
  setPublicActivityEmail?: Maybe<Activity>;
  setPublicActivityObjective?: Maybe<Activity>;
  setPublicActivitySchool?: Maybe<Activity>;
  setTeacherCommentsAnswer?: Maybe<AppliedActivityAnswer>;
  setTeacherPhoneNumber?: Maybe<User>;
  /** @deprecated This field was deprecated. */
  setTeacherRole?: Maybe<Teacher>;
  setTeacherSecondEmail?: Maybe<User>;
  setTrialFirstAccessData?: Maybe<Reader>;
  skipTeacherUpdate?: Maybe<TeacherUpdateStatus>;
  /**
   * It start a new motrix assessment passing:
   *   - Assessment Name
   *   - Dates (start date and end date)
   *   - List of entities ids for the relationship between the assessment created
   */
  startMotrixAssessment?: Maybe<MotrixAssessmentPayload>;
  /**
   * It starts a reading fluency assessment for a given user and returns a success
   * or error message.
   */
  startReadingFluencyAssessment?: Maybe<Scalars['String']['output']>;
  submitActivityToPublicApproval?: Maybe<Activity>;
  toggleClient?: Maybe<DeactivateClientPayload>;
  toggleFeatures?: Maybe<ContractFeaturePayload>;
  /** Given a notification type, it toggles the notification status. */
  toggleNotificationStatus?: Maybe<ToggleNotificationStatusPayload>;
  unassignOnboardingLikedBooks?: Maybe<UnassignOnboardingLikedBooksResponse>;
  unfavoriteDidacticSequence?: Maybe<ActionStatus>;
  unpublishArticle?: Maybe<Article>;
  unpublishDidacticSequence?: Maybe<DidacticSequence>;
  updateAdminPanelV2OnboardingTutorialState?: Maybe<Tutorial>;
  updateArticle?: Maybe<Article>;
  updateBookShelf?: Maybe<BookShelf>;
  /** Updates the evaluation response for a content recording. */
  updateContentRecordingEvaluation?: Maybe<ContentReadingRecord>;
  updateGamificationOnboardingTutorialState?: Maybe<Tutorial>;
  updateImportationLine?: Maybe<ImportationLinePayload>;
  updateOnboardingV2TutorialState?: Maybe<Tutorial>;
  updateTeacherInfo?: Maybe<User>;
  /** Updates the teacher preference passing a list with entities ids selected. */
  updateTeacherRunningRecordsPreference?: Maybe<TeacherPreferencePayload>;
  /** Uploads a content recording for the authenticated user. */
  uploadContentRecording?: Maybe<Scalars['String']['output']>;
  uploadMotrixAudio?: Maybe<Scalars['String']['output']>;
  uploadReadingFluencyAudio?: Maybe<Scalars['String']['output']>;
  validatePasswordReset?: Maybe<PasswordResetUserPayload>;
};


export type RootMutationTypeActivateAutomaticGradingArgs = {
  appliedActivityAnswerId: Scalars['Int']['input'];
};


export type RootMutationTypeActivateBookshelfArgs = {
  bookShelfId: Scalars['Int']['input'];
};


export type RootMutationTypeActivateFeatureToEntityArgs = {
  entityId: Scalars['Int']['input'];
  feature: FeatureType;
  profile: ProfileType;
};


export type RootMutationTypeActivateLayersUserArgs = {
  degree: Scalars['String']['input'];
  entityId: Scalars['Int']['input'];
  externalTransactionId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type RootMutationTypeActivateOrDeactivateContractArgs = {
  active: Scalars['Boolean']['input'];
  contractId: Scalars['Int']['input'];
};


export type RootMutationTypeAddAbilityToExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  bnccAbilityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeAddActivitiesToArticleArgs = {
  activityList?: InputMaybe<Array<InputMaybe<AddActivitiesToArticlePayload>>>;
  articleId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeAddArticleToActivityArgs = {
  activityId?: InputMaybe<Scalars['Int']['input']>;
  articleId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeAddBnccTagArgs = {
  bnccTag: Scalars['String']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeAddBookToActivityArgs = {
  activityId: Scalars['Int']['input'];
  embeddedInBook?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};


export type RootMutationTypeAddBookToAtualidadesActivityArgs = {
  activityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeAddBookToBlackListArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeAddBookToExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeAddBooksToBookShelfArgs = {
  bookShelfId: Scalars['Int']['input'];
  mascot?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootMutationTypeAddBooksToCollectionArgs = {
  bookIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  collectionId: Scalars['Int']['input'];
};


export type RootMutationTypeAddChoiceToActivityExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  statement: Scalars['String']['input'];
};


export type RootMutationTypeAddChoiceToExamQuestionArgs = {
  examQuestionId: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
  statement: Scalars['String']['input'];
};


export type RootMutationTypeAddDidacticSequenceAbilityArgs = {
  code: Scalars['String']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeAddDidacticSequenceBookArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeAddDidacticSequenceLessonArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypeAddDidacticSequenceSpecificSkillArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  specificSkillId: Scalars['Int']['input'];
};


export type RootMutationTypeAddDidacticSequenceTextualGenreArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  textualGenre: Scalars['String']['input'];
};


export type RootMutationTypeAddDidaticSequenceDegreeArgs = {
  degree: Scalars['String']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeAddMascotToBookShelfItemArgs = {
  bookShelfItemId: Scalars['Int']['input'];
  mascot: Scalars['String']['input'];
};


export type RootMutationTypeAddTagArgs = {
  activityId: Scalars['Int']['input'];
  tag: Scalars['String']['input'];
};


export type RootMutationTypeAddTeacherEntityToUserArgs = {
  entityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId: Scalars['Int']['input'];
};


export type RootMutationTypeAddTextualGenreArgs = {
  activityId: Scalars['Int']['input'];
  textualGenre: Scalars['String']['input'];
};


export type RootMutationTypeAddToFavoritesArgs = {
  slug: Scalars['String']['input'];
};


export type RootMutationTypeAdminDeleteActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeAdminUpdateUserDataArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  secondEmail?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeAnswerMatchingPairArgs = {
  input: AnswerMatchingPairInput;
};


export type RootMutationTypeAnswerMatchingPairsV2Args = {
  appliedActivityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  isCorrectionAutomatic: Scalars['Boolean']['input'];
  matchingPairs: Array<InputMaybe<MatchingPairV2Input>>;
};


export type RootMutationTypeApplyActivitiesToEntitiesTeachersArgs = {
  activities: Array<InputMaybe<Scalars['Int']['input']>>;
  entities: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootMutationTypeApplyActivityToEntityArgs = {
  activityId: Scalars['Int']['input'];
  autoCorrectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateActivity']['input']>;
  entityId: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateActivity']['input']>;
};


export type RootMutationTypeApplyActivityToReaderArgs = {
  activityId: Scalars['Int']['input'];
  autoCorrectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateActivity']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  readerId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateActivity']['input']>;
};


export type RootMutationTypeApplyAssignmentArgs = {
  input: ApplyAssignmentInput;
};


export type RootMutationTypeApplyIndependentActivityToReaderArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeApproveActivityForPublicArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeArvoreSharedReadingArgs = {
  input: ArvoreSharedReadingInput;
};


export type RootMutationTypeAssignOnboardingLikedBooksToReaderArgs = {
  likedBooks?: InputMaybe<Array<InputMaybe<AssignOnboardingLikedBooksToReaderInput>>>;
};


export type RootMutationTypeAuthenticateWithProviderArgs = {
  deviceId: Scalars['String']['input'];
  deviceType: DeviceType;
  provider: Provider;
  token: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeBoostForestArgs = {
  input: BoostForestInput;
};


export type RootMutationTypeBootstrapActivityForReaderArgs = {
  id: Scalars['Int']['input'];
  type: BootstrapActivityForReaderTypes;
};


export type RootMutationTypeBuySeedArgs = {
  input?: InputMaybe<BuySeedInput>;
};


export type RootMutationTypeBuySpecialItemArgs = {
  input?: InputMaybe<BuySpecialItemInput>;
};


export type RootMutationTypeCancelImportationArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeCancelLastReadingFluencyAssessmentResultArgs = {
  input: CancelLastReadingFluencyAssessmentInput;
};


export type RootMutationTypeChangeAdminPermissionsArgs = {
  canCreateAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateReader?: InputMaybe<Scalars['Boolean']['input']>;
  canDeleteAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  canDeleteReader?: InputMaybe<Scalars['Boolean']['input']>;
  teacherId: Scalars['Int']['input'];
};


export type RootMutationTypeChangeBooksSlugsArgs = {
  input?: InputMaybe<Array<InputMaybe<ChangeBooksSlugsInput>>>;
};


export type RootMutationTypeChangeEntityArgs = {
  entityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeChangeOrderFromBookShelfArgs = {
  order?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootMutationTypeChangeOrderFromBookShelfItemArgs = {
  order?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootMutationTypeChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type RootMutationTypeChangePasswordFirstLoginArgs = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeChangeRoleArgs = {
  roleName: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type RootMutationTypeChangeTeacherEntityArgs = {
  entityId: Scalars['Int']['input'];
};


export type RootMutationTypeChooseTeacherClassArgs = {
  classId: Scalars['Int']['input'];
};


export type RootMutationTypeClaimRewardArgs = {
  challengeId: Scalars['Int']['input'];
  requirementId: Scalars['Int']['input'];
};


export type RootMutationTypeConfirmTeacherEmailArgs = {
  code: Scalars['String']['input'];
};


export type RootMutationTypeConsumeContentArgs = {
  input: ConsumeContentInput;
};


export type RootMutationTypeCreateActivityArgs = {
  title: Scalars['String']['input'];
};


export type RootMutationTypeCreateActivityV2Args = {
  input: CreateActivityInput;
};


export type RootMutationTypeCreateAppliedActivityAnswerArgs = {
  appliedActivityId: Scalars['Int']['input'];
};


export type RootMutationTypeCreateArticleArgs = {
  input: CreateArticleInput;
};


export type RootMutationTypeCreateAtivityArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeCreateAtualidadesActivityArgs = {
  title: Scalars['String']['input'];
};


export type RootMutationTypeCreateBaseTextArgs = {
  examQuestionIds: Array<InputMaybe<Scalars['Int']['input']>>;
  statement: Scalars['String']['input'];
};


export type RootMutationTypeCreateBatchEntitiesArgs = {
  entityParams?: InputMaybe<Array<InputMaybe<EntityParamsInput>>>;
};


export type RootMutationTypeCreateBookShelfArgs = {
  acervoType: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bgColor?: InputMaybe<Scalars['String']['input']>;
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  degreeRange: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isHighlight: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type RootMutationTypeCreateContentIndicationsArgs = {
  input: CreateContentIndicationInput;
};


export type RootMutationTypeCreateCoordinatorClassesArgs = {
  degrees?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootMutationTypeCreateDidacticSequenceArgs = {
  arvoreId?: InputMaybe<Scalars['String']['input']>;
  author: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeCreateEmotionJournalEntryArgs = {
  input: CreateEmotionJournalEntryInput;
};


export type RootMutationTypeCreateEnglishAsLanguageReferralArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeCreateEntityArgs = {
  degree: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentEntityId: Scalars['Int']['input'];
};


export type RootMutationTypeCreateExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionType: ExamQuestionType;
  pageReference?: InputMaybe<Scalars['String']['input']>;
  relatedBnccs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootMutationTypeCreateNewMotrixRecordingArgs = {
  partnerExternalId: Scalars['String']['input'];
};


export type RootMutationTypeCreateOnboardingReaderThemesArgs = {
  onboardingReaderProfileThemes?: InputMaybe<Array<OnboardingReaderProfileThemesInput>>;
};


export type RootMutationTypeCreateOrUpdateClientArgs = {
  input: CreateOrUpdateClientInput;
};


export type RootMutationTypeCreateOrUpdateContractArgs = {
  input: CreateOrUpdateContractInput;
};


export type RootMutationTypeCreateOrUpdateModuleAndObservationArgs = {
  input: CreateOrUpdateModuleAndObservationInput;
};


export type RootMutationTypeCreateOrUpdateReadingGoalsArgs = {
  input: CreateOrUpdateReadingGoalsInput;
};


export type RootMutationTypeCreatePaymentTransactionArgs = {
  input: CreatePaymentTransactionInput;
};


export type RootMutationTypeCreatePublicDataActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeCreateReaderArgs = {
  bornDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type RootMutationTypeCreateReferralToAFriendArgs = {
  contact: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  schoolName: Scalars['String']['input'];
};


export type RootMutationTypeCreateSampleEntitiesArgs = {
  entityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootMutationTypeCreateSelfReferralArgs = {
  role: Scalars['String']['input'];
};


export type RootMutationTypeCreateSentirActivityArgs = {
  title: Scalars['String']['input'];
};


export type RootMutationTypeCreateSharedReadingArgs = {
  slug: Scalars['String']['input'];
};


export type RootMutationTypeCreateTeacherArgs = {
  bornDate?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  entityId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateTeacherSubjectArgs = {
  subjects?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RootMutationTypeCurationAddBookToActivityArgs = {
  activityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeCurationAddChoiceToExamQuestionArgs = {
  examQuestionId: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
  statement: Scalars['String']['input'];
};


export type RootMutationTypeCurationAddGeneralSkillToPublicDataArgs = {
  activityId: Scalars['Int']['input'];
  generalSkillId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationAddTagToPublicDataArgs = {
  activityId: Scalars['Int']['input'];
  tag: Scalars['String']['input'];
};


export type RootMutationTypeCurationAddTextualGenreToPublicDataArgs = {
  activityId: Scalars['Int']['input'];
  textualGenre: Scalars['String']['input'];
};


export type RootMutationTypeCurationApproveArgs = {
  publicDataActivityId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationChangeActivityTitleArgs = {
  activityId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeCurationChangeChoiceStatementArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  statement: Scalars['String']['input'];
};


export type RootMutationTypeCurationChangeExamQuestionStatementArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  statement: Scalars['String']['input'];
};


export type RootMutationTypeCurationChangePublicDataDegreeRangeArgs = {
  activityId: Scalars['Int']['input'];
  degreeRange: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootMutationTypeCurationChangePublicDataEmailArgs = {
  activityId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
};


export type RootMutationTypeCurationChangePublicDataObjectiveArgs = {
  activityId: Scalars['Int']['input'];
  objective: Scalars['String']['input'];
};


export type RootMutationTypeCurationChangePublicDataSchoolArgs = {
  activityId: Scalars['Int']['input'];
  school: Scalars['String']['input'];
};


export type RootMutationTypeCurationCreateExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionType: ExamQuestionType;
};


export type RootMutationTypeCurationDeleteExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationPublishArgs = {
  publicDataActivityId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationRefuseArgs = {
  publicDataActivityId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationRemoveBookFromActivityArgs = {
  activityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeCurationRemoveChoiceFromExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationRemoveGeneralSkillFromPublicDataArgs = {
  activityId: Scalars['Int']['input'];
  generalSkillId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationRemoveTagFromPublicDataArgs = {
  activityId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationRemoveTextualGenreFromPublicDataArgs = {
  activityId: Scalars['Int']['input'];
  textualGenreId: Scalars['Int']['input'];
};


export type RootMutationTypeCurationSetExamQuestionOrderArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootMutationTypeCurationSetIsCorrectChoiceArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
};


export type RootMutationTypeCurationUnpublishArgs = {
  publicDataActivityId: Scalars['Int']['input'];
};


export type RootMutationTypeDeactivateBookshelfArgs = {
  bookShelfId: Scalars['Int']['input'];
};


export type RootMutationTypeDeactivateClientArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootMutationTypeDeactivateClientsArgs = {
  clientIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootMutationTypeDeactivateEntitiesArgs = {
  entityIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootMutationTypeDeactivateReadingGoalArgs = {
  input: DeactivateReadingGoalInput;
};


export type RootMutationTypeDeactivateUserArgs = {
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteAppliedActivityArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteBnccTagArgs = {
  name: Scalars['String']['input'];
};


export type RootMutationTypeDeleteDidacticSequenceArgs = {
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteEntityArgs = {
  entityId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeDeleteSampleEntityArgs = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeDeleteTutorialArgs = {
  tutorialId: Scalars['Int']['input'];
};


export type RootMutationTypeDesativateFeatureFromEntityArgs = {
  entityId: Scalars['Int']['input'];
  feature: FeatureType;
  profile: ProfileType;
};


export type RootMutationTypeDisableArticleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeDisableAssessmentArgs = {
  assessmentId: Scalars['Int']['input'];
};


export type RootMutationTypeDuplicateActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeDuplicateBookshelfArgs = {
  bookShelfId: Scalars['Int']['input'];
  degreeRange: Scalars['String']['input'];
};


export type RootMutationTypeEditActivityArgs = {
  input: EditActivityInput;
};


export type RootMutationTypeEditAppliedActivityArgs = {
  input: EditAppliedActivityInput;
};


export type RootMutationTypeEditDidacticSequenceLessonArgs = {
  lessonId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};


export type RootMutationTypeEditEntityArgs = {
  degree?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeEditExamQuestionsArgs = {
  params?: InputMaybe<Array<InputMaybe<EditExamQuestionPayload>>>;
};


export type RootMutationTypeEditManyUsersArgs = {
  file: Scalars['Upload']['input'];
  queryType: Scalars['String']['input'];
};


export type RootMutationTypeEditUserArgs = {
  bornDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeFavoriteDidacticSequenceArgs = {
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeFullPasswordResetArgs = {
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeGetUserArgs = {
  login: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeIdentifyMotrixUserArgs = {
  degree: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
};


export type RootMutationTypeImportUserFromGoogleClassRoomArgs = {
  input: ImportUserFromGoogleClassRoomInput;
};


export type RootMutationTypeJustifyCsatArgs = {
  context: CsatContext;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeLikeOrDislikeSharedReadingArgs = {
  slug: Scalars['String']['input'];
};


export type RootMutationTypeListBooksByCsvArgs = {
  file: Scalars['Upload']['input'];
  queryType: ListBooksByCsvQueryType;
};


export type RootMutationTypeListClientsByCsvArgs = {
  file: Scalars['Upload']['input'];
};


export type RootMutationTypeLoginArgs = {
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeLoginDirectFacebookArgs = {
  oauthToken: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type RootMutationTypeLoginUserForPaymentArgs = {
  rootId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type RootMutationTypeLoginWithFacebookArgs = {
  login?: InputMaybe<Scalars['String']['input']>;
  oauthToken: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};


export type RootMutationTypeLoginWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type RootMutationTypeMarkBookAsHiddenArgs = {
  bookSlug: Scalars['String']['input'];
};


export type RootMutationTypeMarkBookAsReadArgs = {
  bookSlug: Scalars['String']['input'];
};


export type RootMutationTypeMarkBookAsReadingArgs = {
  bookSlug: Scalars['String']['input'];
};


export type RootMutationTypeMarkBookAsUnreadArgs = {
  bookSlug: Scalars['String']['input'];
};


export type RootMutationTypeMarkBookAsVisibleArgs = {
  bookSlug: Scalars['String']['input'];
};


export type RootMutationTypeMoveReaderArgs = {
  entityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeMoveReadersArgs = {
  entityId: Scalars['Int']['input'];
  readerIds: Array<Scalars['Int']['input']>;
};


export type RootMutationTypeMoveUserToRootArgs = {
  accessToken: Scalars['String']['input'];
};


export type RootMutationTypePasswordResetArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type RootMutationTypeProcessImportationArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeProcessImportationSuggestionArgs = {
  lineId: Scalars['Int']['input'];
  suggestionContent: SuggestionContentInput;
};


export type RootMutationTypeProcessOnixFileArgs = {
  isbn: Scalars['String']['input'];
};


export type RootMutationTypePublishArticleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypePublishDidacticSequenceArgs = {
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeQualifyJobDescriptionArgs = {
  jobAreas?: InputMaybe<Array<InputMaybe<JobArea>>>;
  jobPositions?: InputMaybe<Array<JobPosition>>;
};


export type RootMutationTypeQualifyUserJobDescriptionArgs = {
  jobPositions: Array<InputMaybe<JobPosition>>;
  targetUserId: Scalars['Int']['input'];
};


export type RootMutationTypeRateAppStoreArgs = {
  rating: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveAbilityFromExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  bnccAbilityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveArticleFromActivityArgs = {
  activityId?: InputMaybe<Scalars['Int']['input']>;
  articleId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeRemoveBaseTextArgs = {
  baseTextId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveBnccTagArgs = {
  bnccTagId: Scalars['Int']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveBookFromActivityArgs = {
  activityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeRemoveBookFromAtualidadesActivityArgs = {
  activityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeRemoveBookFromBlackListArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeRemoveBookFromBookShelfArgs = {
  bookShelfId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeRemoveBookFromExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeRemoveBookShelfArgs = {
  bookShelfId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveChoiceFromExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveContentIndicationArgs = {
  contentIndicationId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveContractModuleFromEntityArgs = {
  input: RemoveContractModuleFromEntityInput;
};


export type RootMutationTypeRemoveDidacticSequenceAbilityArgs = {
  code: Scalars['String']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveDidacticSequenceBookArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeRemoveDidacticSequenceLessonArgs = {
  lessonId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveDidacticSequenceSpecificSkillArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  specificSkillId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveDidacticSequenceTextualGenreArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  textualGenreId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveDidaticSequenceDegreeArgs = {
  bnccDegreeId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveExamQuestionArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveExamQuestionChoiceArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveFromFavoritesArgs = {
  slug: Scalars['String']['input'];
};


export type RootMutationTypeRemoveMascotFromBookShelfItemArgs = {
  bookShelfItemId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveTagArgs = {
  activityId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveTeacherClassArgs = {
  classId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveTeacherClassesArgs = {
  teacherClassIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type RootMutationTypeRemoveTeacherSubjectArgs = {
  teacherSubjectId: Scalars['Int']['input'];
};


export type RootMutationTypeRemoveTextualGenreArgs = {
  activityId: Scalars['Int']['input'];
  textualGenreId: Scalars['Int']['input'];
};


export type RootMutationTypeRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeRequestVoucherArgs = {
  codeType?: InputMaybe<Scalars['String']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type RootMutationTypeRequirePaymentArgs = {
  entityId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type RootMutationTypeRescheduleSubmissionDateForReadingFluencyAssessmentArgs = {
  input: RescheduleReadingFluencyAssessmentInput;
};


export type RootMutationTypeResendEmailConfirmationArgs = {
  secondEmail: Scalars['String']['input'];
};


export type RootMutationTypeResetPasswordArgs = {
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeScoreCsatArgs = {
  context: CsatContext;
  score: Scalars['Int']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeScoreNpsArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
  source: Scalars['String']['input'];
};


export type RootMutationTypeSeekAndDestroyEmptyClassesArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootMutationTypeSelfRegisterArgs = {
  captcha?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  codeType: CodeType;
  degree?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referrerId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeSendActivityForCorrectionArgs = {
  appliedActivityAnswerId: Scalars['Int']['input'];
  readerId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeSendApplicationToReaderArgs = {
  appliedActivityAnswerId: Scalars['Int']['input'];
};


export type RootMutationTypeSendFeatureFeedbackArgs = {
  feedback: Scalars['String']['input'];
};


export type RootMutationTypeSendRunningRecordsResultArgs = {
  input: SendRunningRecordsResultInput;
};


export type RootMutationTypeSetActivityDegreeRangeArgs = {
  activityId: Scalars['Int']['input'];
  degreeRange?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootMutationTypeSetActivityDescriptionArgs = {
  activityId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
};


export type RootMutationTypeSetActivityTitleArgs = {
  activityId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeSetActivityToReadyArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeSetAppliedActivityAnswerStatusCancelledArgs = {
  appliedActivityId: Scalars['Int']['input'];
  entityId?: InputMaybe<Scalars['Int']['input']>;
  readerId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeSetBaseTextStatementArgs = {
  activityId: Scalars['Int']['input'];
  baseTextId: Scalars['Int']['input'];
  statement: Scalars['String']['input'];
};


export type RootMutationTypeSetChoiceIdAnswerArgs = {
  appliedActivityAnswerId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  isCorrectionAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeSetChoiceStatementArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  statement: Scalars['String']['input'];
};


export type RootMutationTypeSetCommentedAnswerArgs = {
  activityId: Scalars['Int']['input'];
  commentedAnswer: Scalars['String']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeSetContractDatesAndWarningArgs = {
  input: SetContractDatesAndWarningInput;
};


export type RootMutationTypeSetContractMarketArgs = {
  contractId: Scalars['Int']['input'];
  market: Scalars['String']['input'];
};


export type RootMutationTypeSetContractModuleToEntityArgs = {
  input: SetContractModuleToEntityInput;
};


export type RootMutationTypeSetDidacticSequenceArvoreIdArgs = {
  arvoreId: Scalars['String']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeSetDidacticSequenceAuthorArgs = {
  author: Scalars['String']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeSetDidacticSequenceContentArgs = {
  content: Scalars['String']['input'];
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeSetDidacticSequenceEvaluationArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  evaluation: Scalars['String']['input'];
};


export type RootMutationTypeSetDidacticSequencePurposesArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  purposes: Scalars['String']['input'];
};


export type RootMutationTypeSetDidacticSequenceSummaryArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  summary: Scalars['String']['input'];
};


export type RootMutationTypeSetDidacticSequenceTitleArgs = {
  didacticSequenceId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeSetDiscursiveAnswerArgs = {
  appliedActivityAnswerId: Scalars['Int']['input'];
  discursiveAnswer: Scalars['String']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeSetExamQuestionCommentedAnswerArgs = {
  activityId: Scalars['Int']['input'];
  commentedAnswer: Scalars['String']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeSetExamQuestionOrderArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type RootMutationTypeSetExamQuestionStatementArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  expectedAnswer?: InputMaybe<Scalars['String']['input']>;
  statement: Scalars['String']['input'];
};


export type RootMutationTypeSetExamQuestionToBaseTextArgs = {
  activityId: Scalars['Int']['input'];
  baseTextId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
};


export type RootMutationTypeSetFinalCommentAppliedActivityAnswerArgs = {
  appliedActivityAnswerId: Scalars['Int']['input'];
  finalComment: Scalars['String']['input'];
};


export type RootMutationTypeSetFinalGradeAppliedActivityAnswerArgs = {
  appliedActivityAnswerId?: InputMaybe<Scalars['Int']['input']>;
  appliedActivityId: Scalars['Int']['input'];
  finalGrade: Scalars['String']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeSetFinanceContactArgs = {
  input: SetFinanceContactInput;
};


export type RootMutationTypeSetGradeAnswerArgs = {
  answerId: Scalars['Int']['input'];
  grade: Scalars['String']['input'];
};


export type RootMutationTypeSetIsCorrectArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
};


export type RootMutationTypeSetIsCorrectChoiceArgs = {
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
};


export type RootMutationTypeSetIsShuffleToBookshelfArgs = {
  bookShelfId: Scalars['Int']['input'];
  isShuffle: Scalars['Boolean']['input'];
};


export type RootMutationTypeSetLastDayAccessToReaderArgs = {
  days: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeSetPublicActivityDegreeRangeArgs = {
  activityId: Scalars['Int']['input'];
  degreeRange: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootMutationTypeSetPublicActivityEmailArgs = {
  activityId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
};


export type RootMutationTypeSetPublicActivityObjectiveArgs = {
  activityId: Scalars['Int']['input'];
  objective: Scalars['String']['input'];
};


export type RootMutationTypeSetPublicActivitySchoolArgs = {
  activityId: Scalars['Int']['input'];
  school: Scalars['String']['input'];
};


export type RootMutationTypeSetTeacherCommentsAnswerArgs = {
  answerId?: InputMaybe<Scalars['Int']['input']>;
  appliedActivityId: Scalars['Int']['input'];
  comments: Scalars['String']['input'];
  examQuestionId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootMutationTypeSetTeacherPhoneNumberArgs = {
  phone: Scalars['String']['input'];
};


export type RootMutationTypeSetTeacherRoleArgs = {
  role: Scalars['String']['input'];
};


export type RootMutationTypeSetTeacherSecondEmailArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeSetTrialFirstAccessDataArgs = {
  entityCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type RootMutationTypeStartMotrixAssessmentArgs = {
  input: StartMotrixAssessmentInput;
};


export type RootMutationTypeStartReadingFluencyAssessmentArgs = {
  input: StartReadingFluencyAssessmentInput;
};


export type RootMutationTypeSubmitActivityToPublicApprovalArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootMutationTypeToggleClientArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootMutationTypeToggleFeaturesArgs = {
  contractId: Scalars['Int']['input'];
  features: Array<InputMaybe<ToggleFeatureInput>>;
};


export type RootMutationTypeToggleNotificationStatusArgs = {
  input: ToggleNotificationStatusInput;
};


export type RootMutationTypeUnfavoriteDidacticSequenceArgs = {
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeUnpublishArticleArgs = {
  id: Scalars['Int']['input'];
};


export type RootMutationTypeUnpublishDidacticSequenceArgs = {
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootMutationTypeUpdateAdminPanelV2OnboardingTutorialStateArgs = {
  action: TutorialActions;
};


export type RootMutationTypeUpdateArticleArgs = {
  input: UpdateArticleInput;
};


export type RootMutationTypeUpdateBookShelfArgs = {
  acervoType: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bgColor?: InputMaybe<Scalars['String']['input']>;
  bookShelfId: Scalars['Int']['input'];
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  degreeRange: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isHighlight: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type RootMutationTypeUpdateContentRecordingEvaluationArgs = {
  input: UpdateContentRecordingEvaluationInput;
};


export type RootMutationTypeUpdateGamificationOnboardingTutorialStateArgs = {
  action: TutorialActions;
};


export type RootMutationTypeUpdateImportationLineArgs = {
  input: UpdateImportationLineInput;
  lineId: Scalars['Int']['input'];
};


export type RootMutationTypeUpdateOnboardingV2TutorialStateArgs = {
  action: TutorialActions;
};


export type RootMutationTypeUpdateTeacherInfoArgs = {
  disciplines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearsResponsibleFor?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootMutationTypeUpdateTeacherRunningRecordsPreferenceArgs = {
  input: UpdateTeacherRunningRecordsPreferenceInput;
};


export type RootMutationTypeUploadContentRecordingArgs = {
  input: UploadContentRecordingInput;
};


export type RootMutationTypeUploadMotrixAudioArgs = {
  input?: InputMaybe<UploadMotrixAudioInput>;
};


export type RootMutationTypeUploadReadingFluencyAudioArgs = {
  input: UploadReadingFluencyAudioInput;
};


export type RootMutationTypeValidatePasswordResetArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RootPublicInfoPayload = {
  __typename?: 'RootPublicInfoPayload';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  acquisitionPlans?: Maybe<Array<Maybe<Plan>>>;
  activitiesReport?: Maybe<ActivitiesReport>;
  activitiesUserReport?: Maybe<ActivitiesUserReport>;
  activityDetailReport?: Maybe<Array<Maybe<ActivityDetailStudentData>>>;
  activityDetailsByLineage?: Maybe<Array<Maybe<ActivityDetails>>>;
  activityReportActivityVisualization?: Maybe<Array<Maybe<ActivityReportActivityVisualization>>>;
  activityReportReaderVisualization?: Maybe<Array<Maybe<ActivityReportReaderVisualization>>>;
  activityReportSubjectVisualization?: Maybe<Array<Maybe<ActivityReportSubjectVisualization>>>;
  adminListBookActivities?: Maybe<EmbeddedInBookActivity>;
  adminSearchAtualidadesActivities?: Maybe<AdminSearchAtualidadesActivitiesPayload>;
  appMinVersions?: Maybe<AppVersion>;
  articleDetails?: Maybe<Article>;
  articleSchoolSegments?: Maybe<Array<Maybe<SchoolSegment>>>;
  avgHoursForBook?: Maybe<Scalars['RawJson']['output']>;
  avgHoursForImprint?: Maybe<Scalars['RawJson']['output']>;
  avgHoursForPublisherIds?: Maybe<Scalars['RawJson']['output']>;
  bookDetailReport?: Maybe<BookDetailReport>;
  bookDetails?: Maybe<Book>;
  bookReadsCountForImprint?: Maybe<Scalars['Int']['output']>;
  bookReadsCountForPublisherIds?: Maybe<Scalars['Int']['output']>;
  bookRemovalDates?: Maybe<Array<Maybe<BookRemovalDate>>>;
  booksReport?: Maybe<BooksReport>;
  booksUserReport?: Maybe<BooksUserReport>;
  /** Cancels an import. */
  cancelImportation?: Maybe<Importation>;
  checkHealth?: Maybe<Scalars['RawJson']['output']>;
  classLastJournalEntries?: Maybe<Array<Maybe<ClassLastJournalEntriesPayload>>>;
  consumedContentsByEntityAndContentReport?: Maybe<Array<Maybe<ConsumedContent>>>;
  consumedContentsByUserReport?: Maybe<Array<Maybe<ConsumedContent>>>;
  consumedContentsContentReport?: Maybe<Array<Maybe<ConsumedContentContentReport>>>;
  contentCategories: Array<Maybe<Category>>;
  contentCategoryShelves: Array<Maybe<ContentCategoryShelf>>;
  detailedActivitiesReport?: Maybe<Array<Maybe<DetailedActivitiesReportItem>>>;
  emotionJournalEntriesByMonth?: Maybe<Array<Maybe<JournalEntriesByMonthPayload>>>;
  entityPublicInfo?: Maybe<EntityPublicInfoPayload>;
  fetchActivityForReader?: Maybe<ActivityForReader>;
  fetchBooksByCollectionAndBookCollection?: Maybe<Array<Maybe<Book>>>;
  fetchUsersWithRoles?: Maybe<UsersWithRolesResponse>;
  findReaders?: Maybe<Array<Maybe<BasicReader>>>;
  generalSummaryReport?: Maybe<GeneralSummaryReport>;
  generalVision?: Maybe<GeneralVisionReport>;
  generalVisionClassReport?: Maybe<GeneralVisionClassReport>;
  generalVisionUserReport?: Maybe<GeneralVisionUserReport>;
  getAccessReport?: Maybe<Array<Maybe<AccessReportPayload>>>;
  getAcervoTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getActiveChallenge?: Maybe<Challenge>;
  getActivity?: Maybe<Activity>;
  getAllDegreesFromTeacherEntity?: Maybe<Scalars['RawJson']['output']>;
  getAssessmentHistory?: Maybe<Array<Maybe<UserReadingFluencyAssessmentHistoryItem>>>;
  getBnccAbility?: Maybe<BnccAbility>;
  getBookById?: Maybe<Scalars['RawJson']['output']>;
  getBookBySlug?: Maybe<Scalars['RawJson']['output']>;
  getBookSnippetSelected?: Maybe<BookSnippetSelected>;
  getBookSnippetsByDegree?: Maybe<Array<Maybe<GetBookSnippetsByDegreePayload>>>;
  getCards?: Maybe<Array<Maybe<AccessCard>>>;
  getClassesAvailableToReadingFluencyAssessment?: Maybe<Array<Maybe<ClassReadingFluencyAssessment>>>;
  /** Get the classes with or without reading fluency assessment. */
  getClassesWithReadingFluencyAssessment?: Maybe<Array<Maybe<ClassReadingFluencyAssessment>>>;
  getClient?: Maybe<GetClientPayload>;
  getClientListing?: Maybe<Array<Maybe<ClientListing>>>;
  getCompleteAssessmentHistory?: Maybe<Array<Maybe<UserReadingFluencyCompleteAssessmentHistoryItem>>>;
  getContract?: Maybe<ContractPayload>;
  getContractListing?: Maybe<Array<Maybe<ContractListing>>>;
  getDidacticSequence?: Maybe<DidacticSequence>;
  getEntitiesByAncestry?: Maybe<Array<Maybe<EntitySummary>>>;
  getEntity?: Maybe<Entity>;
  /** Returns an importation. */
  getImportation?: Maybe<Importation>;
  getIndexByAlias?: Maybe<Scalars['RawJson']['output']>;
  getKnowledgeAreaByAbility?: Maybe<KnowledgeArea>;
  getMappingByIndex?: Maybe<Scalars['RawJson']['output']>;
  /**
   * Returns the motrix assessments list. The list can be filtered by:
   *  - disableStatus
   */
  getMotrixAssessments?: Maybe<Array<Maybe<MotrixAssessmentPayload>>>;
  getPublicActivity?: Maybe<Activity>;
  getReader?: Maybe<GetReaderPayload>;
  getReaderActivityStatusByEntity?: Maybe<Array<ReaderActivityStatus>>;
  getRecommendedBookShelf?: Maybe<Array<Maybe<Book>>>;
  /** Generate a presigned URL for a recording */
  getRecordingUrl?: Maybe<Scalars['String']['output']>;
  getSubtreeFromEntityListing?: Maybe<Array<Maybe<SubtreeFromEntityListingPayload>>>;
  getTeacherClasses?: Maybe<Array<Maybe<Entity>>>;
  /** Returns a list with entities selected by Teacher to apply the RR assessment. */
  getTeacherEntitiesSelected?: Maybe<Array<Maybe<EntitySelectedItem>>>;
  getUser?: Maybe<User>;
  getUserByVoucherRedeemed?: Maybe<User>;
  /** Get content recordings for a specific user and content */
  getUserContentRecordings?: Maybe<Array<Maybe<ContentReadingRecord>>>;
  getUserReadingFluencyResult?: Maybe<UserReadingFluencyResultDetail>;
  getUserTeacherEntities?: Maybe<Array<Maybe<TeacherEntity>>>;
  getUsersListing?: Maybe<Array<Maybe<UserSummary>>>;
  /** Returns a list of changes that will be performed for an import. */
  importReview?: Maybe<Scalars['RawJson']['output']>;
  /** Returns a list of importations. */
  importationListing?: Maybe<Array<Maybe<Importation>>>;
  /** Returns the progress of an import. */
  importationProgress?: Maybe<Scalars['Int']['output']>;
  labBooksDetails?: Maybe<Array<Maybe<Book>>>;
  layersPaymentEntityInfo?: Maybe<LayersPaymentEntityInfo>;
  listAbilitiesFromDidacticSequence?: Maybe<Array<Maybe<BnccAbility>>>;
  listActionFields?: Maybe<Array<Maybe<ActionField>>>;
  listActivityQuestions?: Maybe<AppliedActivity>;
  listActivityQuestionsV2?: Maybe<AppliedActivity>;
  listAllBooksIncludingCensured?: Maybe<Array<Maybe<Book>>>;
  listAppliedActivitiesForEntity?: Maybe<Array<Maybe<AppliedActivity>>>;
  listAppliedActivitiesForReader?: Maybe<Scalars['RawJson']['output']>;
  listAppliedActivityCorrectionForReader?: Maybe<AppliedActivityAnswer>;
  listArticleActivities?: Maybe<Array<Maybe<Activity>>>;
  listArticles?: Maybe<ListArticlesOutput>;
  /** Returns the running records benchmark books filtered by partner leveling_id */
  listBenchmarks?: Maybe<Array<Maybe<BenchmarkItem>>>;
  /** List all abilities. */
  listBnccAbilities?: Maybe<Array<Maybe<BnccAbility>>>;
  /** List only abilities already associated to some didactic sequence. */
  listBnccAbilitiesForFilter?: Maybe<Array<Maybe<BnccAbility>>>;
  listBnccTags?: Maybe<Array<Maybe<BnccTag>>>;
  listBookCollections?: Maybe<Array<Maybe<BookCollection>>>;
  listCollections?: Maybe<Array<Maybe<Collection>>>;
  /**
   * List didactic sequences.
   *
   * When `favorite` is `true`, it will filter only favorited sequences for
   * the current user. Otherwise, it does not filter for favorites.
   *
   * When `is_ready` is `true`, it will filter only published didactic sequences;
   * when `false`, only unpublished ones. Otherwise, includes all sequences.
   */
  listDidacticSequences?: Maybe<Array<Maybe<DidacticSequence>>>;
  listEmbeddedInBookActivity?: Maybe<EmbeddedInBookActivity>;
  listExamQuestions?: Maybe<Array<Maybe<ExamQuestion>>>;
  listExistingBookshelf?: Maybe<Array<Maybe<BookShelf>>>;
  listGeneralSkills?: Maybe<Array<Maybe<GeneralSkill>>>;
  listIndependentActivities?: Maybe<ListIndependentActivitiesPayload>;
  listKnowledgeAreas?: Maybe<Array<Maybe<KnowledgeArea>>>;
  /** Returns all Running Records levelings from partner_levelings table */
  listLevelings?: Maybe<Array<Maybe<PartnerLeveling>>>;
  listMascots?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listOnboardingThemes?: Maybe<Array<Maybe<OnboardingTheme>>>;
  listSampleEntities?: Maybe<Array<Maybe<Entity>>>;
  listSpecificSkills?: Maybe<Array<Maybe<SpecificSkill>>>;
  listTextualGenres?: Maybe<Array<Maybe<TextualGenre>>>;
  listUsersByFullAncestry?: Maybe<Array<Maybe<UsersFullAncestry>>>;
  maximumHierarchyType?: Maybe<HierarchyTypeResult>;
  me?: Maybe<User>;
  minVersionDynamic?: Maybe<Scalars['Int']['output']>;
  minVersionFixed?: Maybe<Scalars['Int']['output']>;
  mostReadContentByType?: Maybe<Array<Maybe<ConsumedContentContentReport>>>;
  newsstandQuale?: Maybe<SearchResult>;
  node?: Maybe<Node>;
  notificationsPreferences?: Maybe<NotificationPreferencesPayload>;
  /**
   * Returns the partner leveling details passing the following filters:
   * - name
   * - partnerId
   * - degree
   */
  partnerLevelingDetails?: Maybe<PartnerLeveling>;
  /** Process an import asynchronously. */
  processImportation?: Maybe<Importation>;
  processImportationSuggestion?: Maybe<ImportationLinePayload>;
  publicFeatureToggles?: Maybe<PublicFeatureToggles>;
  rangeCountByDegreeForBook?: Maybe<Scalars['RawJson']['output']>;
  rangeCountForBook?: Maybe<Scalars['RawJson']['output']>;
  readBooksByDegreeForImprint?: Maybe<Scalars['RawJson']['output']>;
  readBooksByDegreeForPublisherIds?: Maybe<Scalars['Int']['output']>;
  readerSummaryReport?: Maybe<ReaderSummaryReport>;
  readersAccessInfo?: Maybe<Array<Maybe<ReadersAccessInfo>>>;
  readingGoals?: Maybe<Array<ReadingGoal>>;
  readingGoalsReport?: Maybe<ReadingGoalsReportPayload>;
  readingReport?: Maybe<ReadingReportWithAggregatePayload>;
  readingReportByReaderId?: Maybe<ReadingReportByReaderIdResponse>;
  recommendedBooks?: Maybe<Array<Maybe<Book>>>;
  rentBooksByDegreeForImprint?: Maybe<Scalars['RawJson']['output']>;
  rentBooksByDegreeForPublisherIds?: Maybe<Scalars['Int']['output']>;
  renunciationByAllRentsForPublisherIds?: Maybe<Scalars['RawJson']['output']>;
  rootPublicInfo?: Maybe<RootPublicInfoPayload>;
  schoolsByRoot?: Maybe<Array<Maybe<SchoolSummary>>>;
  searchActivity?: Maybe<Scalars['RawJson']['output']>;
  searchAllAvailableBooks?: Maybe<Array<Maybe<Book>>>;
  searchAllBooks?: Maybe<Array<Maybe<Book>>>;
  searchArticles?: Maybe<Array<Maybe<SearchArticlesPayload>>>;
  searchBnccAbility?: Maybe<Array<Maybe<BnccAbility>>>;
  searchBnccTags?: Maybe<Array<Maybe<BnccTag>>>;
  searchBook?: Maybe<Array<Maybe<Book>>>;
  searchBookV3?: Maybe<SearchResult>;
  searchCategoryV2?: Maybe<SearchResult>;
  searchDidacticSequence?: Maybe<DidacticSequenceSearchResults>;
  searchIndependentActivities?: Maybe<SearchIndependentActivitiesPayload>;
  searchLoginType?: Maybe<SearchLoginTypePayload>;
  searchParanaActivities?: Maybe<SearchParanaActivitiesResult>;
  searchTextualGenre?: Maybe<Array<Maybe<TextualGenre>>>;
  searchUsersInternal?: Maybe<Scalars['RawJson']['output']>;
  sentirHomeContents?: Maybe<SentirHomeContentsOutput>;
  showBookShelf?: Maybe<BookShelf>;
  studentDetailedActivitiesReport?: Maybe<Array<Maybe<StudentDetailedActivitiesReportItem>>>;
  summarizedActivitiesReport?: Maybe<Array<Maybe<SummarizedActivitiesReport>>>;
  teacherSummaryReport?: Maybe<TeacherSummaryReport>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  updateImportationLine?: Maybe<ImportationLinePayload>;
  userPublicInfo?: Maybe<Array<Maybe<UserPublicInfoPayload>>>;
  voucherRedeemed?: Maybe<Scalars['Boolean']['output']>;
};


export type RootQueryTypeActivitiesReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeActivitiesUserReportArgs = {
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
  userId: Scalars['Int']['input'];
};


export type RootQueryTypeActivityDetailReportArgs = {
  activityId: Scalars['Int']['input'];
  classId: Scalars['Int']['input'];
};


export type RootQueryTypeActivityDetailsByLineageArgs = {
  activityId: Scalars['Int']['input'];
  classId: Scalars['Int']['input'];
};


export type RootQueryTypeActivityReportActivityVisualizationArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeActivityReportReaderVisualizationArgs = {
  endDate: Scalars['IsoDate']['input'];
  readerId: Scalars['Int']['input'];
  startDate: Scalars['IsoDate']['input'];
};


export type RootQueryTypeActivityReportSubjectVisualizationArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAdminListBookActivitiesArgs = {
  bookSlug: Scalars['String']['input'];
};


export type RootQueryTypeAdminSearchAtualidadesActivitiesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeArticleDetailsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAvgHoursForBookArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeAvgHoursForImprintArgs = {
  imprint: Scalars['String']['input'];
};


export type RootQueryTypeAvgHoursForPublisherIdsArgs = {
  publisherIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootQueryTypeBookDetailReportArgs = {
  bookId: Scalars['Int']['input'];
  classId: Scalars['Int']['input'];
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
};


export type RootQueryTypeBookDetailsArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeBookReadsCountForImprintArgs = {
  imprint: Scalars['String']['input'];
};


export type RootQueryTypeBookReadsCountForPublisherIdsArgs = {
  publisherIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootQueryTypeBookRemovalDatesArgs = {
  slugs: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootQueryTypeBooksReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeBooksUserReportArgs = {
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
  userId: Scalars['Int']['input'];
};


export type RootQueryTypeCancelImportationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeClassLastJournalEntriesArgs = {
  classId: Scalars['Int']['input'];
};


export type RootQueryTypeConsumedContentsByEntityAndContentReportArgs = {
  input: ConsumedContentsByEntityAndContentInput;
};


export type RootQueryTypeConsumedContentsByUserReportArgs = {
  readerId: Scalars['Int']['input'];
};


export type RootQueryTypeConsumedContentsContentReportArgs = {
  contentType: ContentType;
  entityId: Scalars['Int']['input'];
};


export type RootQueryTypeContentCategoriesArgs = {
  type: ContentType;
};


export type RootQueryTypeContentCategoryShelvesArgs = {
  type: ContentType;
};


export type RootQueryTypeDetailedActivitiesReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  teacherUserId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeEmotionJournalEntriesByMonthArgs = {
  month: Scalars['Int']['input'];
  readerId?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type RootQueryTypeEntityPublicInfoArgs = {
  code: Scalars['String']['input'];
};


export type RootQueryTypeFetchActivityForReaderArgs = {
  appliedActivityId: Scalars['Int']['input'];
};


export type RootQueryTypeFetchBooksByCollectionAndBookCollectionArgs = {
  bookCollectionId?: InputMaybe<Scalars['Int']['input']>;
  collectionId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeFetchUsersWithRolesArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  role?: InputMaybe<Role>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeFindReadersArgs = {
  entityId: Scalars['Int']['input'];
  term: Scalars['String']['input'];
};


export type RootQueryTypeGeneralSummaryReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGeneralVisionArgs = {
  endDate: Scalars['IsoDate']['input'];
  networkId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGeneralVisionClassReportArgs = {
  classId: Scalars['Int']['input'];
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
};


export type RootQueryTypeGeneralVisionUserReportArgs = {
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
  userId: Scalars['Int']['input'];
};


export type RootQueryTypeGetAccessReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<UserProfileType>;
};


export type RootQueryTypeGetActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootQueryTypeGetAssessmentHistoryArgs = {
  userId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type RootQueryTypeGetBnccAbilityArgs = {
  code: Scalars['String']['input'];
};


export type RootQueryTypeGetBookByIdArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeGetBookBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeGetBookSnippetsByDegreeArgs = {
  degree: Scalars['String']['input'];
};


export type RootQueryTypeGetCardsArgs = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetClientArgs = {
  clientId: Scalars['Int']['input'];
};


export type RootQueryTypeGetClientListingArgs = {
  filters?: InputMaybe<ClientListingFilters>;
};


export type RootQueryTypeGetCompleteAssessmentHistoryArgs = {
  userId: Scalars['Int']['input'];
};


export type RootQueryTypeGetContractArgs = {
  contractId: Scalars['Int']['input'];
};


export type RootQueryTypeGetContractListingArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetDidacticSequenceArgs = {
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootQueryTypeGetEntitiesByAncestryArgs = {
  rootId?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetEntityArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeGetImportationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetIndexByAliasArgs = {
  alias: Scalars['String']['input'];
};


export type RootQueryTypeGetKnowledgeAreaByAbilityArgs = {
  abilityId: Scalars['Int']['input'];
};


export type RootQueryTypeGetMappingByIndexArgs = {
  index: Scalars['String']['input'];
};


export type RootQueryTypeGetMotrixAssessmentsArgs = {
  input?: InputMaybe<GetMotrixAssessmentsInput>;
};


export type RootQueryTypeGetPublicActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootQueryTypeGetReaderArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeGetReaderActivityStatusByEntityArgs = {
  appliedActivityId: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
};


export type RootQueryTypeGetRecordingUrlArgs = {
  recordingId: Scalars['Int']['input'];
};


export type RootQueryTypeGetSubtreeFromEntityListingArgs = {
  entityId: Scalars['Int']['input'];
};


export type RootQueryTypeGetTeacherClassesArgs = {
  degree?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeGetUserArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeGetUserByVoucherRedeemedArgs = {
  captcha?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type RootQueryTypeGetUserContentRecordingsArgs = {
  contentIdentifier: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type RootQueryTypeGetUserReadingFluencyResultArgs = {
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type RootQueryTypeGetUserTeacherEntitiesArgs = {
  userId: Scalars['Int']['input'];
};


export type RootQueryTypeGetUsersListingArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeImportReviewArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeImportationListingArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeImportationProgressArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeLabBooksDetailsArgs = {
  slugs: Array<InputMaybe<Scalars['String']['input']>>;
};


export type RootQueryTypeLayersPaymentEntityInfoArgs = {
  externalTransactionId: Scalars['String']['input'];
};


export type RootQueryTypeListAbilitiesFromDidacticSequenceArgs = {
  didacticSequenceId: Scalars['Int']['input'];
};


export type RootQueryTypeListActivityQuestionsArgs = {
  appliedActivityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootQueryTypeListActivityQuestionsV2Args = {
  appliedActivityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootQueryTypeListAllBooksIncludingCensuredArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type RootQueryTypeListAppliedActivitiesForEntityArgs = {
  entityId: Scalars['Int']['input'];
};


export type RootQueryTypeListAppliedActivitiesForReaderArgs = {
  readerId: Scalars['Int']['input'];
};


export type RootQueryTypeListAppliedActivityCorrectionForReaderArgs = {
  appliedActivityAnswerId: Scalars['Int']['input'];
};


export type RootQueryTypeListArticleActivitiesArgs = {
  articleId: Scalars['Int']['input'];
};


export type RootQueryTypeListArticlesArgs = {
  input?: InputMaybe<ListArticlesInput>;
};


export type RootQueryTypeListBenchmarksArgs = {
  input?: InputMaybe<ListRunningRecordsBenchmarksInput>;
};


export type RootQueryTypeListDidacticSequencesArgs = {
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  isReady?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeListEmbeddedInBookActivityArgs = {
  bookSlug: Scalars['String']['input'];
  readerId: Scalars['Int']['input'];
};


export type RootQueryTypeListExamQuestionsArgs = {
  activityId: Scalars['Int']['input'];
};


export type RootQueryTypeListExistingBookshelfArgs = {
  acervoType?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  degreeRange?: InputMaybe<Scalars['String']['input']>;
  isHighlight: Scalars['Boolean']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeListIndependentActivitiesArgs = {
  input?: InputMaybe<ListIndependentActivitiesInput>;
};


export type RootQueryTypeListSpecificSkillsArgs = {
  knowledgeAreaId: Scalars['Int']['input'];
};


export type RootQueryTypeListUsersByFullAncestryArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  userProfile?: InputMaybe<UserProfileType>;
};


export type RootQueryTypeMaximumHierarchyTypeArgs = {
  rootId: Scalars['Int']['input'];
};


export type RootQueryTypeMostReadContentByTypeArgs = {
  contentType: ContentType;
};


export type RootQueryTypeNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePartnerLevelingDetailsArgs = {
  input?: InputMaybe<PartnerLevelingDetailsInput>;
};


export type RootQueryTypeProcessImportationArgs = {
  id: Scalars['Int']['input'];
};


export type RootQueryTypeProcessImportationSuggestionArgs = {
  lineId: Scalars['Int']['input'];
  suggestionContent: SuggestionContentInput;
};


export type RootQueryTypeRangeCountByDegreeForBookArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeRangeCountForBookArgs = {
  slug: Scalars['String']['input'];
};


export type RootQueryTypeReadBooksByDegreeForImprintArgs = {
  imprint: Scalars['String']['input'];
};


export type RootQueryTypeReadBooksByDegreeForPublisherIdsArgs = {
  publisherIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootQueryTypeReaderSummaryReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeReadersAccessInfoArgs = {
  entityId: Scalars['Int']['input'];
  profileType: ProfileType;
  source: ReadersInfoSourceType;
};


export type RootQueryTypeReadingGoalsArgs = {
  entityIds: Array<Scalars['Int']['input']>;
};


export type RootQueryTypeReadingGoalsReportArgs = {
  entityId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadingGoalsReportOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type RootQueryTypeReadingReportArgs = {
  classId: Scalars['Int']['input'];
  endDate: Scalars['IsoDate']['input'];
  networkId: Scalars['Int']['input'];
  schoolId: Scalars['Int']['input'];
  startDate: Scalars['IsoDate']['input'];
  trademarkId: Scalars['Int']['input'];
};


export type RootQueryTypeReadingReportByReaderIdArgs = {
  endDate: Scalars['IsoDate']['input'];
  readerId: Scalars['Int']['input'];
  startDate: Scalars['IsoDate']['input'];
};


export type RootQueryTypeRentBooksByDegreeForImprintArgs = {
  imprint: Scalars['String']['input'];
};


export type RootQueryTypeRentBooksByDegreeForPublisherIdsArgs = {
  publisherIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootQueryTypeRenunciationByAllRentsForPublisherIdsArgs = {
  publisherIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RootQueryTypeRootPublicInfoArgs = {
  code: Scalars['String']['input'];
};


export type RootQueryTypeSchoolsByRootArgs = {
  rootId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


export type RootQueryTypeSearchActivityArgs = {
  opts?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSearchAllAvailableBooksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSearchAllBooksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSearchArticlesArgs = {
  input?: InputMaybe<SearchArticlesInput>;
};


export type RootQueryTypeSearchBnccAbilityArgs = {
  term: Scalars['String']['input'];
};


export type RootQueryTypeSearchBnccTagsArgs = {
  term: Scalars['String']['input'];
};


export type RootQueryTypeSearchBookArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSearchBookV3Args = {
  opts?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeSearchCategoryV2Args = {
  opts?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSearchDidacticSequenceArgs = {
  opts?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSearchIndependentActivitiesArgs = {
  input?: InputMaybe<SearchIndependentActivitiesInput>;
};


export type RootQueryTypeSearchLoginTypeArgs = {
  prefixOrSufix: LoginTypePrefixOrSufix;
  profileType: ProfileType;
  term: Scalars['String']['input'];
};


export type RootQueryTypeSearchParanaActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchFilters?: InputMaybe<SearchParanaActivitiesFiltersInput>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSearchTextualGenreArgs = {
  term: Scalars['String']['input'];
};


export type RootQueryTypeSearchUsersInternalArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
};


export type RootQueryTypeSentirHomeContentsArgs = {
  degree?: InputMaybe<Scalars['String']['input']>;
  pillar: Scalars['String']['input'];
};


export type RootQueryTypeShowBookShelfArgs = {
  bookShelfId: Scalars['Int']['input'];
};


export type RootQueryTypeStudentDetailedActivitiesReportArgs = {
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
  studentUserId: Scalars['Int']['input'];
};


export type RootQueryTypeSummarizedActivitiesReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeTeacherSummaryReportArgs = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  teacherId: Scalars['Int']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeUpdateImportationLineArgs = {
  input: UpdateImportationLineInput;
  lineId: Scalars['Int']['input'];
};


export type RootQueryTypeUserPublicInfoArgs = {
  input: UserPublicInfoInput;
};


export type RootQueryTypeVoucherRedeemedArgs = {
  code: Scalars['String']['input'];
};

export type RunningRecordsAssessmentBooksSuggestedInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolSegment = {
  __typename?: 'SchoolSegment';
  abbreviation: Scalars['String']['output'];
  label: Scalars['String']['output'];
  recommendedDegrees?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value: SchoolSegmentValue;
};

export enum SchoolSegmentValue {
  Ef1 = 'EF1',
  Ef2 = 'EF2',
  Ei = 'EI',
  Em = 'EM',
  G = 'G'
}

export enum SchoolStructureOptions {
  /** Rede > Unidade > Turma */
  NetworkSchoolClass = 'NETWORK_SCHOOL_CLASS',
  /** Unidade > Turma */
  SchoolClass = 'SCHOOL_CLASS',
  /** Rede > Unidade > Turma */
  TrademarkNetworkSchoolClass = 'TRADEMARK_NETWORK_SCHOOL_CLASS'
}

export type SchoolSummary = {
  __typename?: 'SchoolSummary';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SearchAggregation = {
  __typename?: 'SearchAggregation';
  count?: Maybe<Scalars['Int']['output']>;
  parameterValue?: Maybe<Scalars['String']['output']>;
};

export type SearchArticlesInput = {
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type SearchArticlesPayload = {
  __typename?: 'SearchArticlesPayload';
  author?: Maybe<Scalars['String']['output']>;
  degree?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  recommendedDegrees?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  schoolSegment?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SearchIndependentActivitiesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type SearchIndependentActivitiesPayload = {
  __typename?: 'SearchIndependentActivitiesPayload';
  independentActivities?: Maybe<Array<Maybe<IndependentActivity>>>;
  totalEntries?: Maybe<Scalars['Int']['output']>;
};


export type SearchIndependentActivitiesPayloadTotalEntriesArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type SearchLoginTypePayload = {
  __typename?: 'SearchLoginTypePayload';
  id?: Maybe<Scalars['Int']['output']>;
};

export type SearchParanaActivitiesFiltersInput = {
  difficultyLevel?: InputMaybe<ActivityDifficultyLevel>;
  estimatedCompletionTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  recommendedDegrees?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchParanaActivitiesResult = {
  __typename?: 'SearchParanaActivitiesResult';
  activities: Array<ParanaActivity>;
  aggregations?: Maybe<Array<Maybe<ParanaSearchAggregation>>>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  books?: Maybe<Array<Maybe<Book>>>;
  searchFilters?: Maybe<Scalars['RawJson']['output']>;
};

export type SecondaryEmotion = {
  __typename?: 'SecondaryEmotion';
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type SecondaryEmotions = {
  __typename?: 'SecondaryEmotions';
  happy?: Maybe<Array<Maybe<SecondaryEmotion>>>;
  neutral?: Maybe<Array<Maybe<SecondaryEmotion>>>;
  sad?: Maybe<Array<Maybe<SecondaryEmotion>>>;
};

export type Seed = {
  __typename?: 'Seed';
  description?: Maybe<Scalars['String']['output']>;
  growthTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  lockedText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  scientificName?: Maybe<Scalars['String']['output']>;
  species?: Maybe<Scalars['String']['output']>;
};

export type SeekAndDestroyEmptyClassesPayload = {
  __typename?: 'SeekAndDestroyEmptyClassesPayload';
  deletedClasses?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export enum SegmentOptions {
  /** Corporativo */
  Corporate = 'CORPORATE',
  /** Interno */
  Internal = 'INTERNAL',
  /** Biblioteca */
  Library = 'LIBRARY',
  /** Outro */
  Others = 'OTHERS',
  /** Privado */
  Private = 'PRIVATE',
  /** Teste de Produto */
  ProductTest = 'PRODUCT_TEST',
  /** Público token */
  Public = 'PUBLIC'
}

export type SelfRegisterPayload = {
  __typename?: 'SelfRegisterPayload';
  accessToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referrerId?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type SendRunningRecordsResultInput = {
  newLevelingId: Scalars['Int']['input'];
  readerUserId: Scalars['Int']['input'];
};

export type SentirBookShelf = {
  __typename?: 'SentirBookShelf';
  active?: Maybe<Scalars['Boolean']['output']>;
  bookShelfItems?: Maybe<Array<Maybe<BookShelfItem>>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type SentirBookShelfBookShelfItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SentirHomeContentsOutput = {
  __typename?: 'SentirHomeContentsOutput';
  bookShelves?: Maybe<Array<Maybe<SentirBookShelf>>>;
  courseBooks?: Maybe<Array<Maybe<Book>>>;
  degreeColor?: Maybe<Scalars['String']['output']>;
  pillars?: Maybe<Array<Maybe<Pillar>>>;
  secondaryEmotions?: Maybe<SecondaryEmotions>;
  subpages?: Maybe<Array<Maybe<SentirSubpage>>>;
};

export type SentirReader = {
  __typename?: 'SentirReader';
  id?: Maybe<Scalars['Int']['output']>;
  lastEntries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  showAlert?: Maybe<Scalars['Boolean']['output']>;
};

export enum SentirSubpage {
  EmotionsJournal = 'EMOTIONS_JOURNAL'
}

export type Session = {
  __typename?: 'Session';
  token?: Maybe<Scalars['String']['output']>;
};

export type SessionWithFacebook = {
  __typename?: 'SessionWithFacebook';
  token?: Maybe<Scalars['String']['output']>;
};

export type SetContractDatesAndWarningInput = {
  contractId: Scalars['Int']['input'];
  disableContractAfterExpiration: Scalars['Boolean']['input'];
  endDate: Scalars['String']['input'];
  expirationWarningDays?: InputMaybe<Scalars['Int']['input']>;
  firstChargeDate?: InputMaybe<Scalars['String']['input']>;
  signatureDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type SetContractModuleToEntityInput = {
  contractModuleId: Scalars['Int']['input'];
  entityAndSubtree: Scalars['Boolean']['input'];
  entityId: Scalars['Int']['input'];
};

export type SetFinanceContactInput = {
  contractId: Scalars['Int']['input'];
  financeContactEmail?: InputMaybe<Scalars['String']['input']>;
  financeContactName?: InputMaybe<Scalars['String']['input']>;
  financeContactPhone?: InputMaybe<Scalars['String']['input']>;
};

export type SharedReading = {
  __typename?: 'SharedReading';
  book?: Maybe<Book>;
  lastUserShare?: Maybe<Scalars['String']['output']>;
  likedByMe?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  sharedByMe?: Maybe<Scalars['Boolean']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SnippetBook = {
  __typename?: 'SnippetBook';
  name?: Maybe<Scalars['String']['output']>;
};

export type SpecialItem = {
  __typename?: 'SpecialItem';
  action?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SpecificSkill = {
  __typename?: 'SpecificSkill';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  knowledgeAreaId?: Maybe<Scalars['Int']['output']>;
};

export type StartMotrixAssessmentInput = {
  endDate: Scalars['DateTime']['input'];
  entitiesIds: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type StartReadingFluencyAssessmentInput = {
  endDate: Scalars['DateTime']['input'];
  entitiesIds: Array<InputMaybe<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  /**
   * The ID refers to the test book snippet selected by the teacher while
   * creating an reading fluency assessment.
   */
  snippetId: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type StoreRating = {
  __typename?: 'StoreRating';
  createdAt?: Maybe<Scalars['DateActivity']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

export type StudentDetailedActivitiesReportItem = {
  __typename?: 'StudentDetailedActivitiesReportItem';
  activity?: Maybe<DetailedActivitiesActivity>;
  appliedActivityId?: Maybe<Scalars['Int']['output']>;
  appliedAt?: Maybe<Scalars['IsoDate']['output']>;
  appliedBy?: Maybe<DetailedActivitiesUserOrEntity>;
  finalGrade?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AppliedActivityAnswerStatus>;
};

export type SubtreeFromEntityListingPayload = {
  __typename?: 'SubtreeFromEntityListingPayload';
  accessCode?: Maybe<Scalars['String']['output']>;
  child?: Maybe<Scalars['Boolean']['output']>;
  contractModules?: Maybe<Array<Maybe<ContractModule>>>;
  degree?: Maybe<Scalars['String']['output']>;
  entityAncestry?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
};

export type SuggestionContentInput = {
  /** Field without the suffix `_suggestion`. */
  originalKey: Scalars['String']['input'];
  /** Field with the suffix `_suggestion`. */
  suggestionKey: Scalars['String']['input'];
  /**
   * Value of the suggestion answer, it can be the suggestion value
   * or the original value.
   */
  value: Scalars['String']['input'];
};

export type SummarizedActivitiesReport = {
  __typename?: 'SummarizedActivitiesReport';
  finalizedActivitiesPercentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfAnsweredActivities?: Maybe<Scalars['Int']['output']>;
  numberOfAppliedActivities?: Maybe<Scalars['Int']['output']>;
  numberOfCorrectedActivities?: Maybe<Scalars['Int']['output']>;
  numberOfInProgressActivities?: Maybe<Scalars['Int']['output']>;
  numberOfNotStartedActivities?: Maybe<Scalars['Int']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Teacher = {
  __typename?: 'Teacher';
  activitiesReport?: Maybe<Scalars['RawJson']['output']>;
  activityDetailReport?: Maybe<Scalars['RawJson']['output']>;
  availableBooks?: Maybe<Array<Maybe<Book>>>;
  blockedBooks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bookReadDetailsReport?: Maybe<Scalars['RawJson']['output']>;
  booksReadReport?: Maybe<Scalars['RawJson']['output']>;
  classes?: Maybe<Array<Maybe<Class>>>;
  countReaders?: Maybe<Scalars['RawJson']['output']>;
  curationGetActivity?: Maybe<Activity>;
  curationListApproved?: Maybe<Array<Maybe<PublicDataActivity>>>;
  curationListPending?: Maybe<Array<Maybe<PublicDataActivity>>>;
  curationListRefused?: Maybe<Array<Maybe<PublicDataActivity>>>;
  disciplines?: Maybe<Array<Maybe<Discipline>>>;
  /** @deprecated This feature is deprecated. */
  englishTrial?: Maybe<EnglishTrailDetails>;
  entitiesReport?: Maybe<Scalars['RawJson']['output']>;
  entitiesSubtree?: Maybe<Scalars['RawJson']['output']>;
  entitiesSubtreeFlat?: Maybe<Scalars['RawJson']['output']>;
  entityContentConsumptionSummary?: Maybe<EntityContentConsumptionSummary>;
  getCardForReader?: Maybe<Card>;
  getCardsForEntity?: Maybe<Array<Maybe<Card>>>;
  getCardsForRoot?: Maybe<Array<Maybe<Card>>>;
  getReaderAnswers?: Maybe<Array<Maybe<AppliedActivityAnswer>>>;
  getReadersFromEntity?: Maybe<Scalars['RawJson']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  indicatedBooks?: Maybe<Scalars['RawJson']['output']>;
  indicationsReport?: Maybe<Scalars['RawJson']['output']>;
  isFamilyPaying?: Maybe<Scalars['Boolean']['output']>;
  listApplicationsForActivity?: Maybe<Array<Maybe<AppliedActivity>>>;
  listAppliedActivityDetails?: Maybe<AppliedActivityDetailsOutput>;
  listExamQuestions?: Maybe<Array<Maybe<ExamQuestion>>>;
  listMyActivities?: Maybe<Array<Maybe<Activity>>>;
  listMyAppliedActivities?: Maybe<Array<Maybe<AppliedActivityByTeacher>>>;
  mostReaders?: Maybe<Scalars['RawJson']['output']>;
  mostReadersByEntity?: Maybe<Scalars['RawJson']['output']>;
  openedBooks?: Maybe<Scalars['RawJson']['output']>;
  paymentsReport?: Maybe<Scalars['RawJson']['output']>;
  permissions?: Maybe<Scalars['String']['output']>;
  preferredBooks?: Maybe<Scalars['RawJson']['output']>;
  readBooks?: Maybe<Scalars['RawJson']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field was deprecated. */
  roles?: Maybe<Array<Maybe<DeprecatedRole>>>;
  root?: Maybe<Entity>;
  rootSubtree?: Maybe<Scalars['RawJson']['output']>;
  searchAvailableReadersToIndicate?: Maybe<Scalars['RawJson']['output']>;
  searchReaders?: Maybe<Scalars['RawJson']['output']>;
  /** @deprecated Esse campo foi descontinuado. */
  showFlag?: Maybe<Scalars['Boolean']['output']>;
  subjects?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subtreeActivation?: Maybe<Scalars['RawJson']['output']>;
  surveysOfMySchool?: Maybe<Scalars['RawJson']['output']>;
  /** This query is temporary until the classes query can be used */
  teacherClasses?: Maybe<Array<Maybe<Entity>>>;
  teacherEntities?: Maybe<Scalars['RawJson']['output']>;
  teacherIndications?: Maybe<Scalars['RawJson']['output']>;
  totalTimeSpent?: Maybe<Scalars['RawJson']['output']>;
  updateStatus?: Maybe<TeacherUpdateStatus>;
  usersReport?: Maybe<Scalars['RawJson']['output']>;
  viewedBooksByReader?: Maybe<Scalars['RawJson']['output']>;
  yearsResponsibleFor?: Maybe<Scalars['String']['output']>;
};


export type TeacherActivitiesReportArgs = {
  entityId: Scalars['Int']['input'];
};


export type TeacherActivityDetailReportArgs = {
  activityId: Scalars['Int']['input'];
  entityIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type TeacherAvailableBooksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  readerId?: InputMaybe<Scalars['Int']['input']>;
};


export type TeacherBookReadDetailsReportArgs = {
  entityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
};


export type TeacherBooksReadReportArgs = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};


export type TeacherCurationGetActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type TeacherEntitiesReportArgs = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};


export type TeacherGetCardForReaderArgs = {
  readerId: Scalars['Int']['input'];
};


export type TeacherGetCardsForEntityArgs = {
  entityId: Scalars['Int']['input'];
};


export type TeacherGetCardsForRootArgs = {
  rootId: Scalars['Int']['input'];
};


export type TeacherGetReaderAnswersArgs = {
  appliedActivityId: Scalars['Int']['input'];
};


export type TeacherGetReadersFromEntityArgs = {
  entityId: Scalars['Int']['input'];
};


export type TeacherIndicationsReportArgs = {
  entityId: Scalars['Int']['input'];
};


export type TeacherListApplicationsForActivityArgs = {
  activityId: Scalars['Int']['input'];
};


export type TeacherListAppliedActivityDetailsArgs = {
  activityId: Scalars['Int']['input'];
};


export type TeacherListExamQuestionsArgs = {
  activityId: Scalars['Int']['input'];
};


export type TeacherPaymentsReportArgs = {
  entityId: Scalars['Int']['input'];
};


export type TeacherSearchAvailableReadersToIndicateArgs = {
  term: Scalars['String']['input'];
};


export type TeacherSearchReadersArgs = {
  searchTerm: Scalars['String']['input'];
};


export type TeacherTeacherClassesArgs = {
  degree: Scalars['String']['input'];
};


export type TeacherUsersReportArgs = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
};


export type TeacherViewedBooksByReaderArgs = {
  readerId: Scalars['Int']['input'];
};

export type TeacherEntity = {
  __typename?: 'TeacherEntity';
  entity?: Maybe<EntitySummary>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type TeacherPreferencePayload = {
  __typename?: 'TeacherPreferencePayload';
  entitiesIdsSelected?: Maybe<Scalars['EntitiesIdsSelected']['output']>;
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type TeacherSummaryPerformanceIndicators = {
  __typename?: 'TeacherSummaryPerformanceIndicators';
  assignedActivitiesCount: Scalars['Int']['output'];
  assignedActivitiesCountByDifficulty?: Maybe<Array<Maybe<DifficultyLevelEntry>>>;
  assignedQuestionsCountByKind?: Maybe<Array<Maybe<AssignedQuestionsCountByKindInput>>>;
  mostAssignedBnccCompetencies?: Maybe<Array<Maybe<MostAssignedBnccCompetenciesInput>>>;
  pendingReviewActivitiesCount: Scalars['Int']['output'];
  reviewedActivitiesCount: Scalars['Int']['output'];
  startedActivitiesCount: Scalars['Int']['output'];
};

export type TeacherSummaryReport = {
  __typename?: 'TeacherSummaryReport';
  performanceIndicators?: Maybe<TeacherSummaryPerformanceIndicators>;
  usageTimeIndicators?: Maybe<UsageTimeIndicators>;
  yearlyIndicators?: Maybe<TeacherSummaryYearlyIndicators>;
};

export type TeacherSummaryYearlyIndicators = {
  __typename?: 'TeacherSummaryYearlyIndicators';
  monthlyIndicationsCount?: Maybe<Array<Maybe<IndicationsCountEntry>>>;
  monthlyReviewedActivitiesCount?: Maybe<Array<Maybe<ReviewedActivitiesCountEntry>>>;
};

export type TeacherUpdateStatus = {
  __typename?: 'TeacherUpdateStatus';
  emailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  skips?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Boolean']['output']>;
};

export type TestPeriod = {
  __typename?: 'TestPeriod';
  createdAt?: Maybe<Scalars['String']['output']>;
  durationInDays?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  readerId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<TestPeriodType>;
};

export enum TestPeriodType {
  /** Teste de Familia Pagante */
  FpTest = 'FP_TEST'
}

export type TextualGenre = {
  __typename?: 'TextualGenre';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Thema = {
  __typename?: 'Thema';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uiName?: Maybe<Scalars['String']['output']>;
};

export type Theme = {
  __typename?: 'Theme';
  name?: Maybe<Scalars['String']['output']>;
};

export type ToggleFeatureInput = {
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ToggleNotificationStatusInput = {
  notificationType: NotificationType;
};

/** Toggle notification status response. */
export type ToggleNotificationStatusPayload = {
  __typename?: 'ToggleNotificationStatusPayload';
  weeklyReadingReport?: Maybe<Scalars['Boolean']['output']>;
};

export type Tree = {
  __typename?: 'Tree';
  agePercentage?: Maybe<Scalars['Int']['output']>;
  ageStatusText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  growthTime?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  scientificName?: Maybe<Scalars['String']['output']>;
  specialItemUsed?: Maybe<Scalars['Boolean']['output']>;
  species?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['Int']['output']>;
};

export type TreeListing = {
  __typename?: 'TreeListing';
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type TrialExtraInformation = {
  __typename?: 'TrialExtraInformation';
  maxReaders?: Maybe<Scalars['Int']['output']>;
  maxTeachers?: Maybe<Scalars['Int']['output']>;
};

export type TrialModuleInfoPayload = {
  __typename?: 'TrialModuleInfoPayload';
  bookCollection?: Maybe<Scalars['String']['output']>;
  maxReaders?: Maybe<Scalars['Int']['output']>;
  maxTeachers?: Maybe<Scalars['Int']['output']>;
};

export type Tutorial = {
  __typename?: 'Tutorial';
  id?: Maybe<Scalars['Int']['output']>;
  interactions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum TutorialActions {
  Complete = 'COMPLETE',
  Consume = 'CONSUME',
  Dismiss = 'DISMISS'
}

export type UnassignOnboardingLikedBooksResponse = {
  __typename?: 'UnassignOnboardingLikedBooksResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type UpdateArticleInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  coverSubtitle?: InputMaybe<Scalars['String']['input']>;
  coverTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  htmlRaw?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  imageAuthor?: InputMaybe<Scalars['String']['input']>;
  isHighlighted?: InputMaybe<Scalars['Boolean']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  schoolSegment?: InputMaybe<SchoolSegmentValue>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a content recording evaluation. */
export type UpdateContentRecordingEvaluationInput = {
  /** The evaluation response (needs_support, developing, excellent) */
  evaluationResponse: Scalars['String']['input'];
  /** The ID of the recording to update */
  recordingId: Scalars['Int']['input'];
};

export type UpdateImportationLineInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  class?: InputMaybe<Scalars['String']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  educationSegment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  inep?: InputMaybe<Scalars['String']['input']>;
  knowledgeArea?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  studentRegistry?: InputMaybe<Scalars['String']['input']>;
  targetEntityId?: InputMaybe<Scalars['Int']['input']>;
  targetRootId?: InputMaybe<Scalars['Int']['input']>;
  trademark?: InputMaybe<Scalars['String']['input']>;
  whatsappNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum UpdateLineStatus {
  Success = 'SUCCESS',
  UpdatedWithErrors = 'UPDATED_WITH_ERRORS'
}

export type UpdateTeacherRunningRecordsPreferenceInput = {
  entitiesIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

/** Input for uploading a content recording. */
export type UploadContentRecordingInput = {
  /** The identifier (slug for books, ID for others) of the content being recorded */
  contentIdentifier: Scalars['String']['input'];
  /** The type of content (e.g., 'book') */
  contentType: Scalars['String']['input'];
  /** The audio file to upload */
  file: Scalars['Upload']['input'];
};

export type UploadMotrixAudioInput = {
  audio: Scalars['Upload']['input'];
  recordingId: Scalars['String']['input'];
  timestamp: Scalars['String']['input'];
};

export type UploadReadingFluencyAudioInput = {
  file: Scalars['Upload']['input'];
  userId: Scalars['Int']['input'];
};

export type UsageTimeIndicators = {
  __typename?: 'UsageTimeIndicators';
  learningTimeInMinutes?: Maybe<Scalars['Int']['output']>;
  platformUsageTimeInMinutes?: Maybe<Scalars['Int']['output']>;
};

export type User = {
  __typename?: 'User';
  accessToken?: Maybe<Scalars['String']['output']>;
  adminPanelV2OnboardingTutorial?: Maybe<Tutorial>;
  apiToken?: Maybe<Scalars['String']['output']>;
  changedPassword?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookPhoto?: Maybe<Scalars['String']['output']>;
  featureToggles?: Maybe<FeatureToggles>;
  filledOnboardingJobInfo?: Maybe<Scalars['Boolean']['output']>;
  firstAccess?: Maybe<Scalars['Boolean']['output']>;
  gamificationOnboardingTutorial?: Maybe<Tutorial>;
  hasPendingPaymentTransactions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  indicationsMadeByMe?: Maybe<Array<Maybe<ContentIndication>>>;
  indicationsToMe?: Maybe<Array<Maybe<ContentIndication>>>;
  intercom?: Maybe<Scalars['String']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  jobAreas?: Maybe<Array<Maybe<JobArea>>>;
  jobPositions?: Maybe<Array<Maybe<JobPosition>>>;
  /**
   * Returns all user partner reports.
   * It can be used with filters (user_id and partner_id).
   * Reports can be used to store all partner information related with user.
   *
   * Take a look at UserPartnerReport Ecto schema to get more details.
   */
  listUserPartnerReports?: Maybe<Array<Maybe<UserPartnerReport>>>;
  mainBooks?: Maybe<Array<Maybe<BookSection>>>;
  name?: Maybe<Scalars['String']['output']>;
  /** Returns the last NPS score given by the user. */
  npsScore?: Maybe<NpsScore>;
  onboardingV2Tutorial?: Maybe<Tutorial>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated There is no other product than arvore. This field will be removed in the future */
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reader?: Maybe<Reader>;
  requiresPayment?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  secondEmail?: Maybe<Scalars['String']['output']>;
  /** Returns the server's current date and time in ISO8601 format. */
  serverDateTime?: Maybe<Scalars['String']['output']>;
  /** Returns the last rating the user gave to the app. */
  storeRating?: Maybe<StoreRating>;
  suggestedCategories?: Maybe<Array<Maybe<Category>>>;
  suspicionScore?: Maybe<Scalars['Int']['output']>;
  teacher?: Maybe<Teacher>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UserListUserPartnerReportsArgs = {
  input?: InputMaybe<ListUserPartnerReportsInput>;
};

export type UserChange = {
  __typename?: 'UserChange';
  accessToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserLoginInfo = {
  __typename?: 'UserLoginInfo';
  info?: Maybe<Scalars['String']['output']>;
  responseType?: Maybe<Scalars['String']['output']>;
};

export type UserPartnerReport = {
  __typename?: 'UserPartnerReport';
  id: Scalars['Int']['output'];
  partnerData?: Maybe<Scalars['RawJson']['output']>;
  partnerExternalId?: Maybe<Scalars['String']['output']>;
  partnerId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export enum UserProfileType {
  Student = 'STUDENT',
  Teacher = 'TEACHER'
}

export type UserPublicInfoInput = {
  name: Scalars['String']['input'];
  rootId: Scalars['Int']['input'];
};

export type UserPublicInfoPayload = {
  __typename?: 'UserPublicInfoPayload';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
};

export type UserReadingFluencyAssessmentHistoryItem = {
  __typename?: 'UserReadingFluencyAssessmentHistoryItem';
  assessmentDate?: Maybe<Scalars['DateTime']['output']>;
  assessmentName?: Maybe<Scalars['String']['output']>;
  correctWordsPerMinute?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  leveling?: Maybe<ReadingFluencyLeveling>;
};

export type UserReadingFluencyCompleteAssessmentHistoryItem = {
  __typename?: 'UserReadingFluencyCompleteAssessmentHistoryItem';
  assessmentName?: Maybe<Scalars['String']['output']>;
  bookSnippetDegree?: Maybe<Scalars['String']['output']>;
  correctWordsPerMinute?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  leveling?: Maybe<ReadingFluencyLeveling>;
  resultDate?: Maybe<Scalars['DateTime']['output']>;
  studentDegree?: Maybe<Scalars['String']['output']>;
};

export type UserReadingFluencyResultDetail = {
  __typename?: 'UserReadingFluencyResultDetail';
  assessmentDate?: Maybe<Scalars['DateTime']['output']>;
  assessmentEndDate?: Maybe<Scalars['DateTime']['output']>;
  assessmentName?: Maybe<Scalars['String']['output']>;
  assessmentReapplicationLimitReached?: Maybe<Scalars['Boolean']['output']>;
  assessmentStatus?: Maybe<Scalars['String']['output']>;
  audioDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  correctWordsPerMinute?: Maybe<Scalars['Decimal']['output']>;
  errorsByType?: Maybe<Array<Maybe<ReadingFluencyErrorDetail>>>;
  leveling?: Maybe<ReadingFluencyLeveling>;
  snippetBook?: Maybe<SnippetBook>;
  studentDegree?: Maybe<Scalars['String']['output']>;
  successRate?: Maybe<Scalars['Decimal']['output']>;
  /** The text read by the user (reader) with errors and correct words in HTML format. */
  textReadInHtml?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type UserReadingTime = {
  __typename?: 'UserReadingTime';
  name: Scalars['String']['output'];
  readingTime: Scalars['Int']['output'];
};

export type UserSummary = {
  __typename?: 'UserSummary';
  email?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<EntitySummary>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  root?: Maybe<EntitySummary>;
};

export type UserWithRoles = {
  __typename?: 'UserWithRoles';
  id: Scalars['Int']['output'];
  jobPositions: Array<Maybe<JobPosition>>;
  name: Scalars['String']['output'];
  roles: Array<Maybe<Role>>;
  teacherId?: Maybe<Scalars['Int']['output']>;
};

export type UsersFullAncestry = {
  __typename?: 'UsersFullAncestry';
  className: Scalars['String']['output'];
  profile: Scalars['String']['output'];
  readerId: Scalars['Int']['output'];
  schoolName: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type UsersWithRolesResponse = {
  __typename?: 'UsersWithRolesResponse';
  totalCount: Scalars['Int']['output'];
  users: Array<Maybe<UserWithRoles>>;
};

export type ViewedBook = {
  __typename?: 'ViewedBook';
  audioBookProgress?: Maybe<Scalars['Decimal']['output']>;
  book?: Maybe<Book>;
  effectiveReadingPercentage?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefaultReading?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  isSharedReading?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
};

export type ViewedBookAsNode = Node & {
  __typename?: 'ViewedBookAsNode';
  audioBookProgress?: Maybe<Scalars['Decimal']['output']>;
  book?: Maybe<Book>;
  effectiveReadingPercentage?: Maybe<Scalars['Float']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  isDefaultReading?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  isSharedReading?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Decimal']['output']>;
};

export type ViewedBookAsNodeConnection = {
  __typename?: 'ViewedBookAsNodeConnection';
  edges?: Maybe<Array<Maybe<ViewedBookAsNodeEdge>>>;
  pageInfo: PageInfo;
};

export type ViewedBookAsNodeEdge = {
  __typename?: 'ViewedBookAsNodeEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ViewedBookAsNode>;
};

export type WaterDropDetails = {
  __typename?: 'WaterDropDetails';
  currentDrops?: Maybe<Scalars['Decimal']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dropsPerLevel?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  maxDrops?: Maybe<Scalars['Int']['output']>;
  minimumLevel?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  raining?: Maybe<Scalars['Boolean']['output']>;
  statusText?: Maybe<Scalars['String']['output']>;
};

export enum WhoPaysOptions {
  /** Turma */
  Class = 'CLASS',
  /** Rede */
  Network = 'NETWORK',
  /** Unidade */
  School = 'SCHOOL',
  /** Marca */
  Trademark = 'TRADEMARK'
}

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'RootMutationType', requestPasswordReset?: string | null };

export type ValidatePasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ValidatePasswordResetMutation = { __typename?: 'RootMutationType', validatePasswordReset?: { __typename?: 'PasswordResetUserPayload', id?: number | null, name?: string | null, email?: string | null } | null };

export type PasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type PasswordResetMutation = { __typename?: 'RootMutationType', passwordReset?: string | null };

export type FinalGradeAppliedActivityAnswerMutationVariables = Exact<{
  finalGrade: Scalars['String']['input'];
  appliedActivityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
}>;


export type FinalGradeAppliedActivityAnswerMutation = { __typename?: 'RootMutationType', setFinalGradeAppliedActivityAnswer?: { __typename?: 'AppliedActivityAnswer', id?: number | null } | null };

export type SendApplicationToReaderMutationVariables = Exact<{
  appliedActivityAnswerId: Scalars['Int']['input'];
}>;


export type SendApplicationToReaderMutation = { __typename?: 'RootMutationType', sendApplicationToReader?: { __typename?: 'AppliedActivityAnswer', id?: number | null } | null };

export type SetDiscursiveAnswerMutationVariables = Exact<{
  appliedActivityAnswerId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  discursiveAnswer: Scalars['String']['input'];
}>;


export type SetDiscursiveAnswerMutation = { __typename?: 'RootMutationType', setDiscursiveAnswer?: { __typename?: 'AnswerForReader', id?: number | null, answerDiscursive?: string | null, examQuestionId?: number | null, teacherComments?: string | null, grade?: string | null, isCorrect?: boolean | null, correctAnswerId?: number | null } | null };

export type SendActivityForCorrectionMutationVariables = Exact<{
  appliedActivityAnswerId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
}>;


export type SendActivityForCorrectionMutation = { __typename?: 'RootMutationType', sendActivityForCorrection?: { __typename?: 'AppliedActivityAnswer', id?: number | null } | null };

export type BootstrapActivityForReaderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  type: BootstrapActivityForReaderTypes;
}>;


export type BootstrapActivityForReaderMutation = { __typename?: 'RootMutationType', bootstrapActivityForReader?: { __typename?: 'BootstrapActivityForReaderPayload', appliedActivityId?: number | null } | null };

export type SetChoiceIdAnswerMutationVariables = Exact<{
  appliedActivityAnswerId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  isCorrectionAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetChoiceIdAnswerMutation = { __typename?: 'RootMutationType', setChoiceIdAnswer?: { __typename?: 'Answer', id?: number | null, answerChoiceId?: number | null, examQuestionId?: number | null, isCorrect?: boolean | null, correctAnswerId?: number | null } | null };

export type CreateAppliedActivityAnswerMutationVariables = Exact<{
  appliedActivityId: Scalars['Int']['input'];
}>;


export type CreateAppliedActivityAnswerMutation = { __typename?: 'RootMutationType', createAppliedActivityAnswer?: { __typename?: 'AppliedActivityAnswer', id?: number | null } | null };

export type AnswerMatchingPairsV2MutationVariables = Exact<{
  appliedActivityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  matchingPairs: Array<InputMaybe<MatchingPairV2Input>> | InputMaybe<MatchingPairV2Input>;
  isCorrectionAutomatic: Scalars['Boolean']['input'];
}>;


export type AnswerMatchingPairsV2Mutation = { __typename?: 'RootMutationType', answerMatchingPairsV2?: { __typename?: 'AnswerMatchingPairsV2Payload', matchingPairs: Array<{ __typename?: 'AnswerMatchingPairV2Result', id?: number | null, leftId: string, rightId: string, isCorrect: boolean } | null> } | null };

export type Teste2QueryVariables = Exact<{ [key: string]: never; }>;


export type Teste2Query = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null } | null };

export type Teste3QueryVariables = Exact<{ [key: string]: never; }>;


export type Teste3Query = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null } | null };

export type CreateArticleMutationVariables = Exact<{
  input: CreateArticleInput;
}>;


export type CreateArticleMutation = { __typename?: 'RootMutationType', createArticle?: { __typename?: 'Article', id: number, title?: string | null, subtitle?: string | null, imageAuthor?: string | null, htmlContent?: string | null, degree?: string | null, coverTitle?: string | null, coverSubtitle?: string | null, author?: string | null, schoolSegment?: { __typename?: 'SchoolSegment', value: SchoolSegmentValue, label: string, abbreviation: string, recommendedDegrees?: Array<string | null> | null } | null } | null };

export type UpdateArticleMutationVariables = Exact<{
  input: UpdateArticleInput;
}>;


export type UpdateArticleMutation = { __typename?: 'RootMutationType', updateArticle?: { __typename?: 'Article', id: number, title?: string | null, subtitle?: string | null, imageAuthor?: string | null, htmlContent?: string | null, degree?: string | null, coverTitle?: string | null, coverSubtitle?: string | null, author?: string | null, schoolSegment?: { __typename?: 'SchoolSegment', value: SchoolSegmentValue, label: string, abbreviation: string, recommendedDegrees?: Array<string | null> | null } | null } | null };

export type QualifyUserJobDescriptionMutationVariables = Exact<{
  targetUserId: Scalars['Int']['input'];
  jobPositions: Array<InputMaybe<JobPosition>> | InputMaybe<JobPosition>;
}>;


export type QualifyUserJobDescriptionMutation = { __typename?: 'RootMutationType', qualifyUserJobDescription?: { __typename?: 'QualifyJobDescriptionResponse', id: string, jobPositions: Array<JobPosition | null> } | null };

export type UpdateUserRoleMutationVariables = Exact<{
  roleName: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
}>;


export type UpdateUserRoleMutation = { __typename?: 'RootMutationType', changeRole?: { __typename?: 'User', id?: string | null, roles?: Array<string | null> | null } | null };

export type EditManyUsersMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  queryType: Scalars['String']['input'];
}>;


export type EditManyUsersMutation = { __typename?: 'RootMutationType', editManyUsers?: Array<{ __typename?: 'UserChange', name?: string | null, email?: string | null, accessToken?: string | null } | null> | null };

export type ListBooksByCsvMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  queryType: ListBooksByCsvQueryType;
}>;


export type ListBooksByCsvMutation = { __typename?: 'RootMutationType', listBooksByCsv?: Array<{ __typename?: 'Book', id?: number | null, name?: string | null, author?: string | null, imageUrlThumb?: string | null } | null> | null };

export type AddBooksToCollectionMutationVariables = Exact<{
  collectionId: Scalars['Int']['input'];
  bookIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AddBooksToCollectionMutation = { __typename?: 'RootMutationType', addBooksToCollection?: number | null };

export type EditExamQuestionMutationVariables = Exact<{
  params?: InputMaybe<Array<InputMaybe<EditExamQuestionPayload>> | InputMaybe<EditExamQuestionPayload>>;
}>;


export type EditExamQuestionMutation = { __typename?: 'RootMutationType', editExamQuestions?: Array<{ __typename?: 'ExamQuestionChoice', examQuestionId?: number | null, id?: number | null, isCorrect?: boolean | null, statement?: string | null } | null> | null };

export type ProcessOnixFileMutationVariables = Exact<{
  isbn: Scalars['String']['input'];
}>;


export type ProcessOnixFileMutation = { __typename?: 'RootMutationType', processOnixFile?: any | null };

export type ListClientsByCsvMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ListClientsByCsvMutation = { __typename?: 'RootMutationType', listClientsByCsv?: Array<{ __typename?: 'ClientListing', id?: number | null, name?: string | null } | null> | null };

export type DeactivateClientsMutationVariables = Exact<{
  clientIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type DeactivateClientsMutation = { __typename?: 'RootMutationType', deactivateClients?: Array<{ __typename?: 'DeactivateClientsPayload', id?: number | null, deactivated?: boolean | null, errorMessage?: string | null } | null> | null };

export type CancelApplicationMutationVariables = Exact<{
  appliedActivityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
}>;


export type CancelApplicationMutation = { __typename?: 'RootMutationType', setAppliedActivityAnswerStatusCancelled?: Array<{ __typename?: 'AppliedActivityAnswer', id?: number | null } | null> | null };

export type ApplyAssignmentMutationVariables = Exact<{
  input: ApplyAssignmentInput;
}>;


export type ApplyAssignmentMutation = { __typename?: 'RootMutationType', applyAssignment?: { __typename?: 'ApplyAssignmentPayload', assignmentId?: number | null, status?: string | null } | null };

export type BoostForestMutationVariables = Exact<{
  coins: Scalars['Int']['input'];
  drops: Scalars['Int']['input'];
}>;


export type BoostForestMutation = { __typename?: 'RootMutationType', boostForest?: { __typename?: 'Forest', coins?: any | null, waterDropDetails?: { __typename?: 'WaterDropDetails', currentDrops?: any | null } | null } | null };

export type UpdateContentRecordingEvaluationMutationVariables = Exact<{
  input: UpdateContentRecordingEvaluationInput;
}>;


export type UpdateContentRecordingEvaluationMutation = { __typename?: 'RootMutationType', updateContentRecordingEvaluation?: { __typename?: 'ContentReadingRecord', id: number, userId: number, contentIdentifier: string, contentType: string, audioS3Key: string, evaluationResponse?: string | null, createdAt: string, updatedAt: string, audioUrl?: string | null } | null };

export type CreatePaymentTransactionMutationVariables = Exact<{
  input: CreatePaymentTransactionInput;
}>;


export type CreatePaymentTransactionMutation = { __typename?: 'RootMutationType', createPaymentTransaction?: { __typename?: 'PaymentTransaction', id: string, paymentUrl?: string | null } | null };

export type ActivateLayersUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
  degree: Scalars['String']['input'];
  externalTransactionId: Scalars['String']['input'];
}>;


export type ActivateLayersUserMutation = { __typename?: 'RootMutationType', activateLayersUser?: { __typename?: 'ActivateLayersUserPayload', userId: number, entityId: number, degree: string } | null };

export type JoinGameMutationVariables = Exact<{ [key: string]: never; }>;


export type JoinGameMutation = { __typename?: 'RootMutationType', joinGame?: { __typename?: 'JoinGamePayload', status?: boolean | null } | null };

export type AuthenticateWithProviderMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  deviceType: DeviceType;
  provider: Provider;
  token: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthenticateWithProviderMutation = { __typename?: 'RootMutationType', authenticateWithProvider?: string | null };

export type MoveUserToRootMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type MoveUserToRootMutation = { __typename?: 'RootMutationType', moveUserToRoot?: { __typename?: 'BasicUser', id?: number | null, name?: string | null } | null };

export type CreateActivityMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateActivityMutation = { __typename?: 'RootMutationType', createActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null, moduleId?: number | null } | null };

export type CreateAtualidadesActivityMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateAtualidadesActivityMutation = { __typename?: 'RootMutationType', createAtualidadesActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null, moduleId?: number | null } | null };

export type AddBookToAtualidadesActivityMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
}>;


export type AddBookToAtualidadesActivityMutation = { __typename?: 'RootMutationType', addBookToAtualidadesActivity?: { __typename?: 'Activity', id?: number | null, moduleId?: number | null, books?: Array<{ __typename?: 'Book', name?: string | null } | null> | null } | null };

export type RemoveBookFromAtualidadesActivityMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
}>;


export type RemoveBookFromAtualidadesActivityMutation = { __typename?: 'RootMutationType', removeBookFromAtualidadesActivity?: { __typename?: 'Activity', id?: number | null, moduleId?: number | null, books?: Array<{ __typename?: 'Book', name?: string | null } | null> | null } | null };

export type ApplyIndependentActivityToReaderMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type ApplyIndependentActivityToReaderMutation = { __typename?: 'RootMutationType', applyIndependentActivityToReader?: { __typename?: 'AppliedActivity', id?: number | null, activity?: { __typename?: 'Activity', moduleId?: number | null } | null } | null };

export type AddArticleToActivityMutationVariables = Exact<{
  articleId: Scalars['Int']['input'];
  activityId: Scalars['Int']['input'];
}>;


export type AddArticleToActivityMutation = { __typename?: 'RootMutationType', addArticleToActivity?: { __typename?: 'AddArticleToActivityPayload', article?: { __typename?: 'Article', title?: string | null } | null, activity?: { __typename?: 'Activity', title?: string | null } | null } | null };

export type SetActivityDegreeRangeMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
  degreeRange?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SetActivityDegreeRangeMutation = { __typename?: 'RootMutationType', setActivityDegreeRange?: { __typename?: 'Activity', id?: number | null } | null };

export type CreateExamQuestionMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
  examQuestionType: ExamQuestionType;
  pageReference?: InputMaybe<Scalars['String']['input']>;
  relatedBnccs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type CreateExamQuestionMutation = { __typename?: 'RootMutationType', createExamQuestion?: { __typename?: 'ExamQuestion', id?: number | null } | null };

export type SetExamQuestionStatementMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  statement: Scalars['String']['input'];
  expectedAnswer?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetExamQuestionStatementMutation = { __typename?: 'RootMutationType', setExamQuestionStatement?: { __typename?: 'Activity', id?: number | null } | null };

export type AddChoiceToExamQuestionMutationVariables = Exact<{
  examQuestionId: Scalars['Int']['input'];
  isCorrect: Scalars['Boolean']['input'];
  statement: Scalars['String']['input'];
}>;


export type AddChoiceToExamQuestionMutation = { __typename?: 'RootMutationType', addChoiceToExamQuestion?: { __typename?: 'ExamQuestionChoice', id?: number | null } | null };

export type SetChoiceStatementMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
  examQuestionChoiceId: Scalars['Int']['input'];
  statement: Scalars['String']['input'];
}>;


export type SetChoiceStatementMutation = { __typename?: 'RootMutationType', setChoiceStatement?: { __typename?: 'Activity', id?: number | null } | null };

export type CreateSentirActivityMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateSentirActivityMutation = { __typename?: 'RootMutationType', createSentirActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null, moduleId?: number | null } | null };

export type IdentifyMotrixUserMutationVariables = Exact<{
  degree: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type IdentifyMotrixUserMutation = { __typename?: 'RootMutationType', identifyMotrixUser?: { __typename?: 'IdentifyMotrixUserPayload', partnerData?: any | null, partnerExternalId?: string | null, partnerId?: number | null, userId?: number | null } | null };

export type CreateNewMotrixRecordingMutationVariables = Exact<{
  partnerExternalId: Scalars['String']['input'];
}>;


export type CreateNewMotrixRecordingMutation = { __typename?: 'RootMutationType', createNewMotrixRecording?: { __typename?: 'MotrixRecordingPayload', recordingId?: string | null, imageCategory?: string | null, imagePath?: string | null, sessionId?: string | null } | null };

export type CreateOnboardingReaderThemesMutationVariables = Exact<{
  onboardingReaderProfileThemes?: InputMaybe<Array<OnboardingReaderProfileThemesInput> | OnboardingReaderProfileThemesInput>;
}>;


export type CreateOnboardingReaderThemesMutation = { __typename?: 'RootMutationType', createOnboardingReaderThemes?: { __typename?: 'ReaderProfileOnboardingThemeCreationResponse', entities?: Array<{ __typename?: 'ReaderProfileOnboardingThemes', onboardingReaderProfileThemeId?: number | null } | null> | null } | null };

export type UpdateOnboardingV2TutorialStateMutationVariables = Exact<{
  action: TutorialActions;
}>;


export type UpdateOnboardingV2TutorialStateMutation = { __typename?: 'RootMutationType', updateOnboardingV2TutorialState?: { __typename?: 'Tutorial', id?: number | null, userId?: number | null, interactions?: number | null, name?: string | null, state?: string | null } | null };

export type UpdateGamificationOnboardingTutorialStateMutationVariables = Exact<{
  action: TutorialActions;
}>;


export type UpdateGamificationOnboardingTutorialStateMutation = { __typename?: 'RootMutationType', updateGamificationOnboardingTutorialState?: { __typename?: 'Tutorial', id?: number | null, userId?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null } | null };

export type UpdateAdminPanelV2OnboardingTutorialStateMutationVariables = Exact<{
  action: TutorialActions;
}>;


export type UpdateAdminPanelV2OnboardingTutorialStateMutation = { __typename?: 'RootMutationType', updateAdminPanelV2OnboardingTutorialState?: { __typename?: 'Tutorial', id?: number | null, userId?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null } | null };

export type AssignOnboardingLikedBooksToReaderMutationVariables = Exact<{
  likedBooks?: InputMaybe<Array<AssignOnboardingLikedBooksToReaderInput> | AssignOnboardingLikedBooksToReaderInput>;
}>;


export type AssignOnboardingLikedBooksToReaderMutation = { __typename?: 'RootMutationType', assignOnboardingLikedBooksToReader?: { __typename?: 'OnboardingReaderProfileLikedBooksCreationResponse', likedBooks?: Array<{ __typename?: 'OnboardingReaderProfileLikedBooks', slug?: string | null, liked?: boolean | null } | null> | null } | null };

export type RemoveOnboardingThemesFromReaderMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveOnboardingThemesFromReaderMutation = { __typename?: 'RootMutationType', removeOnboardingThemesFromReader?: { __typename?: 'DeleteOnboardingThemeFromReaderResponse', message?: string | null, errors?: Array<number | null> | null } | null };

export type UnassignOnboardingLikedBooksMutationVariables = Exact<{ [key: string]: never; }>;


export type UnassignOnboardingLikedBooksMutation = { __typename?: 'RootMutationType', unassignOnboardingLikedBooks?: { __typename?: 'UnassignOnboardingLikedBooksResponse', message?: string | null } | null };

export type CreateEmotionJournalEntryMutationVariables = Exact<{
  primaryEmotion: JournalPrimaryEmotion;
  note?: InputMaybe<Scalars['String']['input']>;
  blockNote?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryEmotions?: InputMaybe<Array<InputMaybe<JournalSecondaryEmotion>> | InputMaybe<JournalSecondaryEmotion>>;
}>;


export type CreateEmotionJournalEntryMutation = { __typename?: 'RootMutationType', createEmotionJournalEntry?: { __typename?: 'EmotionJournalEntry', id?: number | null, primaryEmotion?: string | null, note?: string | null, blockNote?: boolean | null, insertedAt?: string | null, secondaryEmotions?: Array<{ __typename?: 'SecondaryEmotion', slug?: string | null } | null> | null } | null };

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  notificationType: NotificationType;
}>;


export type UpdateNotificationPreferencesMutation = { __typename?: 'RootMutationType', toggleNotificationStatus?: { __typename?: 'ToggleNotificationStatusPayload', weeklyReadingReport?: boolean | null } | null };

export type AdminDeleteActivityMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type AdminDeleteActivityMutation = { __typename?: 'RootMutationType', adminDeleteActivity?: { __typename?: 'Activity', id?: number | null } | null };

export type CreateActivityV2MutationVariables = Exact<{
  activityQuestions?: InputMaybe<Array<InputMaybe<CreateExamQuestionInput>> | InputMaybe<CreateExamQuestionInput>>;
  module: ModuleType;
  relatedArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  relatedBooks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  submitPublicApproval: Scalars['Boolean']['input'];
  suggestedDegrees: Array<InputMaybe<ActivityDegree>> | InputMaybe<ActivityDegree>;
  title: Scalars['String']['input'];
}>;


export type CreateActivityV2Mutation = { __typename?: 'RootMutationType', createActivityV2?: { __typename?: 'Activity', id?: number | null, title?: string | null, moduleId?: number | null, articles?: Array<{ __typename?: 'Article', id: number } | null> | null, books?: Array<{ __typename?: 'Book', name?: string | null, degree?: string | null } | null> | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id?: number | null, statement?: string | null, type?: ExamQuestionType | null, examQuestionChoices?: Array<{ __typename?: 'ExamQuestionChoice', statement?: string | null, isCorrect?: boolean | null } | null> | null } | null> | null } | null };

export type EditActivityMutationVariables = Exact<{
  activityId: Scalars['Int']['input'];
  activityQuestions?: InputMaybe<Array<InputMaybe<EditExamQuestionInput>> | InputMaybe<EditExamQuestionInput>>;
  module: ModuleType;
  relatedArticles?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  relatedBooks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  submitPublicApproval: Scalars['Boolean']['input'];
  suggestedDegrees?: InputMaybe<Array<InputMaybe<ActivityDegree>> | InputMaybe<ActivityDegree>>;
  title: Scalars['String']['input'];
}>;


export type EditActivityMutation = { __typename?: 'RootMutationType', editActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null, moduleId?: number | null, articles?: Array<{ __typename?: 'Article', id: number } | null> | null, books?: Array<{ __typename?: 'Book', name?: string | null, degree?: string | null, slug?: string | null } | null> | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id?: number | null, statement?: string | null, type?: ExamQuestionType | null, examQuestionChoices?: Array<{ __typename?: 'ExamQuestionChoice', statement?: string | null, isCorrect?: boolean | null } | null> | null } | null> | null } | null };

export type CreateContentIndicationsMutationVariables = Exact<{
  input: CreateContentIndicationInput;
}>;


export type CreateContentIndicationsMutation = { __typename?: 'RootMutationType', createContentIndications?: Array<{ __typename?: 'ContentIndication', dueDate?: any | null, indicatedAt?: any | null, sourceUser?: { __typename?: 'IndicationSourceUser', id?: number | null, name?: string | null, isTeacher?: boolean | null } | null, target?: { __typename?: 'IndicationTarget', id?: number | null, type?: string | null } | null, content?: { __typename?: 'Content', identifier?: string | null, type?: string | null } | null } | null> | null };

export type RemoveContentIndicationMutationVariables = Exact<{
  indicationId: Scalars['Int']['input'];
}>;


export type RemoveContentIndicationMutation = { __typename?: 'RootMutationType', removeContentIndication?: { __typename?: 'ContentIndication', id?: number | null } | null };

export type ConsumeContentMutationVariables = Exact<{
  input: ConsumeContentInput;
}>;


export type ConsumeContentMutation = { __typename?: 'RootMutationType', consumeContent?: { __typename?: 'ConsumeContentOutput', rewards?: Array<{ __typename?: 'Reward', type?: RewardType | null, amount?: number | null } | null> | null } | null };

export type SendFeatureFeedbackMutationVariables = Exact<{
  feedback: Scalars['String']['input'];
}>;


export type SendFeatureFeedbackMutation = { __typename?: 'RootMutationType', sendFeatureFeedback?: string | null };

export type CreateOrUpdateReadingGoalsMutationVariables = Exact<{
  goal: Scalars['Int']['input'];
  entityIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreateOrUpdateReadingGoalsMutation = { __typename?: 'RootMutationType', createOrUpdateReadingGoals?: { __typename?: 'CreateOrUpdateReadingGoalsPayload', readingGoals?: Array<{ __typename?: 'ReadingGoal', goal: number, startDate: any, entityId: number } | null> | null } | null };

export type DeactivateReadingGoalMutationVariables = Exact<{
  entityId: Scalars['Int']['input'];
}>;


export type DeactivateReadingGoalMutation = { __typename?: 'RootMutationType', deactivateReadingGoal?: { __typename?: 'DeactivateReadingGoalPayload', readingGoals: Array<{ __typename?: 'ReadingGoal', goal: number, startDate: any, endDate?: any | null, entityId: number }> } | null };

export type GetReadingGoalsByEntitiesQueryVariables = Exact<{
  entityIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetReadingGoalsByEntitiesQuery = { __typename?: 'RootQueryType', readingGoals?: Array<{ __typename?: 'ReadingGoal', goal: number, startDate: any, entityId: number }> | null };

export type GetReadingGoalReportQueryVariables = Exact<{
  entityId: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  referenceDate: Scalars['DateTime']['input'];
}>;


export type GetReadingGoalReportQuery = { __typename?: 'RootQueryType', readingGoalsReport?: { __typename?: 'ReadingGoalsReportPayload', totalCount: number, readingGoal: { __typename?: 'ReadingGoal', goal: number, startDate: any }, users: Array<{ __typename?: 'UserReadingTime', name: string, readingTime: number }> } | null };

export type UploadReadingFluencyAudioMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  userId: Scalars['Int']['input'];
}>;


export type UploadReadingFluencyAudioMutation = { __typename?: 'RootMutationType', uploadReadingFluencyAudio?: string | null };

export type RescheduleSubmissionDateForReadingFluencyAssessmentMutationVariables = Exact<{
  assessmentId: Scalars['Int']['input'];
  newEndDate: Scalars['Date']['input'];
}>;


export type RescheduleSubmissionDateForReadingFluencyAssessmentMutation = { __typename?: 'RootMutationType', rescheduleSubmissionDateForReadingFluencyAssessment?: string | null };

export type ChooseTeacherClassMutationVariables = Exact<{
  classId: Scalars['Int']['input'];
}>;


export type ChooseTeacherClassMutation = { __typename?: 'RootMutationType', chooseTeacherClass?: string | null };

export type RemoveTeacherClassMutationVariables = Exact<{
  classId: Scalars['Int']['input'];
}>;


export type RemoveTeacherClassMutation = { __typename?: 'RootMutationType', removeTeacherClass?: string | null };

export type AddToBlockedBooksMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddToBlockedBooksMutation = { __typename?: 'RootMutationType', addToBlockedBooks?: { __typename?: 'Book', slug?: string | null } | null };

export type RemoveFromBlockedBooksMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveFromBlockedBooksMutation = { __typename?: 'RootMutationType', removeFromBlockedBooks?: { __typename?: 'Book', slug?: string | null } | null };

export type ChangeTeacherEntityMutationVariables = Exact<{
  entityId: Scalars['Int']['input'];
}>;


export type ChangeTeacherEntityMutation = { __typename?: 'RootMutationType', changeTeacherEntity?: { __typename?: 'Teacher', id?: number | null } | null };

export type QualifyJobDescriptionMutationVariables = Exact<{
  jobPositions?: InputMaybe<Array<JobPosition> | JobPosition>;
  jobAreas?: InputMaybe<Array<JobArea> | JobArea>;
}>;


export type QualifyJobDescriptionMutation = { __typename?: 'RootMutationType', qualifyJobDescription?: { __typename?: 'QualifyJobDescriptionResponse', id: string, jobPositions: Array<JobPosition | null>, jobAreas: Array<JobArea | null> } | null };

export type AddTeacherEntityToUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  entityIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type AddTeacherEntityToUserMutation = { __typename?: 'RootMutationType', addTeacherEntityToUser?: number | null };

export type SearchParanaPublicActivitiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchFilters?: InputMaybe<SearchParanaActivitiesFiltersInput>;
  searchTerm: Scalars['String']['input'];
}>;


export type SearchParanaPublicActivitiesQuery = { __typename?: 'RootQueryType', searchParanaActivities?: { __typename?: 'SearchParanaActivitiesResult', activities: Array<{ __typename?: 'ParanaActivity', difficultyLevel?: ActivityDifficultyLevel | null, estimatedCompletionTimeInSeconds?: number | null, id: number, recommendedDegrees: Array<string>, tags: Array<string>, textualGenres: Array<string>, title: string, books: Array<{ __typename?: 'ParanaActivityBook', imageUrlThumb: string, name: string }> }>, aggregations?: Array<{ __typename?: 'ParanaSearchAggregation', name?: string | null, values?: Array<{ __typename?: 'SearchAggregation', count?: number | null, parameterValue?: string | null } | null> | null } | null> | null } | null };

export type ListActivityQuestionsV2QueryVariables = Exact<{
  appliedActivityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
}>;


export type ListActivityQuestionsV2Query = { __typename?: 'RootQueryType', listActivityQuestionsV2?: { __typename?: 'AppliedActivity', id?: number | null, readerId?: number | null, message?: string | null, appliedActivityAnswers?: Array<{ __typename?: 'AppliedActivityAnswer', status?: string | null, id?: number | null, finalGrade?: string | null, answers?: Array<{ __typename?: 'Answer', answerChoiceId?: number | null, answerDiscursive?: string | null, examQuestionId?: number | null, grade?: string | null, id?: number | null, teacherComments?: string | null, aiGrade?: string | null, aiComment?: string | null, answerMatchingPairs?: Array<{ __typename?: 'AnswerMatchingPairForReader', id?: number | null, leftId?: string | null, rightId?: string | null, isCorrect?: boolean | null } | null> | null } | null> | null } | null> | null, activity?: { __typename?: 'Activity', id?: number | null, moduleId?: number | null, title?: string | null, books?: Array<{ __typename?: 'Book', imageUrlThumb?: string | null, slug?: string | null, author?: string | null, name?: string | null } | null> | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', statement?: string | null, type?: ExamQuestionType | null, id?: number | null, commentedAnswer?: string | null, expectedAnswer?: string | null, examQuestionMatchingPairs?: Array<{ __typename?: 'ExamQuestionMatchingPairs', id?: string | null, leftId?: string | null, leftStatement?: string | null, rightId?: string | null, rightStatement?: string | null } | null> | null, examQuestionChoices?: Array<{ __typename?: 'ExamQuestionChoice', id?: number | null, statement?: string | null, isCorrect?: boolean | null } | null> | null } | null> | null } | null } | null };

export type ListBnccAbilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBnccAbilitiesQuery = { __typename?: 'RootQueryType', listBnccAbilities?: Array<{ __typename?: 'BnccAbility', code?: string | null, degreeRange?: string | null, description?: string | null, id?: number | null } | null> | null };

export type SummarizedActivitiesReportQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
}>;


export type SummarizedActivitiesReportQuery = { __typename?: 'RootQueryType', summarizedActivitiesReport?: Array<{ __typename?: 'SummarizedActivitiesReport', finalizedActivitiesPercentage?: number | null, id?: number | null, name?: string | null, numberOfAnsweredActivities?: number | null, numberOfAppliedActivities?: number | null, numberOfCorrectedActivities?: number | null, numberOfInProgressActivities?: number | null, numberOfNotStartedActivities?: number | null } | null> | null };

export type DetailedActivitiesReportQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  teacherUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DetailedActivitiesReportQuery = { __typename?: 'RootQueryType', detailedActivitiesReport?: Array<{ __typename?: 'DetailedActivitiesReportItem', appliedAt?: any | null, finalizedActivitiesPercentage?: any | null, activity?: { __typename?: 'DetailedActivitiesActivity', difficultyLevel?: ActivityDifficultyLevel | null, id?: number | null, title?: string | null } | null, appliedBy?: { __typename?: 'DetailedActivitiesUserOrEntity', id?: number | null, name?: string | null } | null, appliedTo?: Array<{ __typename?: 'DetailedActivitiesUserOrEntity', id?: number | null, name?: string | null } | null> | null } | null> | null };

export type StudentDetailedActivitiesReportQueryVariables = Exact<{
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
  studentUserId: Scalars['Int']['input'];
}>;


export type StudentDetailedActivitiesReportQuery = { __typename?: 'RootQueryType', studentDetailedActivitiesReport?: Array<{ __typename?: 'StudentDetailedActivitiesReportItem', appliedActivityId?: number | null, appliedAt?: any | null, finalGrade?: string | null, status?: AppliedActivityAnswerStatus | null, activity?: { __typename?: 'DetailedActivitiesActivity', difficultyLevel?: ActivityDifficultyLevel | null, id?: number | null, title?: string | null } | null, appliedBy?: { __typename?: 'DetailedActivitiesUserOrEntity', id?: number | null, name?: string | null } | null } | null> | null };

export type ActivityDetailsByLineageQueryVariables = Exact<{
  classId: Scalars['Int']['input'];
  activityId: Scalars['Int']['input'];
}>;


export type ActivityDetailsByLineageQuery = { __typename?: 'RootQueryType', activityDetailsByLineage?: Array<{ __typename?: 'ActivityDetails', finalGrade?: string | null, grade?: string | null, readerId: number, status?: string | null, userName: string, appliedActivityId?: number | null, conclusionPercentage: number, answers?: Array<{ __typename?: 'ActivityDetailsAnswer', examQuestionId: number, isCorrect?: boolean | null, type: ExamQuestionType, bnccTags?: Array<string | null> | null } | null> | null } | null> | null };

export type ActivityReportActivityVisualizationQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActivityReportActivityVisualizationQuery = { __typename?: 'RootQueryType', activityReportActivityVisualization?: Array<{ __typename?: 'ActivityReportActivityVisualization', activityId?: number | null, activityName?: string | null, recommendedDegree?: string | null, subjectsName?: string | null, conclusionPercentage?: number | null } | null> | null };

export type ActivityReportSubjectVisualizationQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActivityReportSubjectVisualizationQuery = { __typename?: 'RootQueryType', activityReportSubjectVisualization?: Array<{ __typename?: 'ActivityReportSubjectVisualization', subjectId?: number | null, subjectName?: string | null, totalActivitiesCount?: number | null, notStartedActivitiesCount?: number | null, inProgressActivitiesCount?: number | null, finishedActivitiesCount?: number | null, conclusionPercentage?: number | null } | null> | null };

export type ActivityReportReaderVisualizationQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  readerId: Scalars['Int']['input'];
}>;


export type ActivityReportReaderVisualizationQuery = { __typename?: 'RootQueryType', activityReportReaderVisualization?: Array<{ __typename?: 'ActivityReportReaderVisualization', activityId: number, activityName: string, recommendedDegree?: string | null, grade?: string | null, conclusionPercentage: number } | null> | null };

export type FetchActivityForReaderQueryVariables = Exact<{
  appliedActivityId: Scalars['Int']['input'];
}>;


export type FetchActivityForReaderQuery = { __typename?: 'RootQueryType', fetchActivityForReader?: { __typename?: 'ActivityForReader', id?: number | null, title?: string | null, status?: ActivityStatus | null, isCorrectionAutomatic?: boolean | null, totalCoins?: number | null, appliedActivityAnswerId?: number | null, questions?: Array<{ __typename?: 'QuestionForReader', id?: number | null, coins?: number | null, title?: string | null, isCorrect?: boolean | null, isPartiallyCorrect?: boolean | null, titleImageUrl?: string | null, status?: QuestionStatus | null, type?: QuestionType | null, matchingPairs?: Array<{ __typename?: 'MatchingPairForReader', id?: number | null, leftId?: string | null, leftStatement?: string | null, rightId?: string | null, rightStatement?: string | null } | null> | null, answer?: { __typename?: 'AnswerForReader', id?: number | null, answerDiscursive?: string | null, answerChoiceId?: number | null, examQuestionId?: number | null, teacherComments?: string | null, grade?: string | null, isCorrect?: boolean | null, correctAnswerId?: number | null, isPartiallyCorrect?: boolean | null, answerMatchingPairs?: Array<{ __typename?: 'AnswerMatchingPairForReader', id?: number | null, leftId?: string | null, rightId?: string | null, isCorrect?: boolean | null } | null> | null } | null, choices?: Array<{ __typename?: 'ChoiceForReader', id?: number | null, title?: string | null, choiceImageUrl?: string | null, isCorrect?: boolean | null } | null> | null } | null> | null } | null };

export type ActivityDetailReportQueryVariables = Exact<{
  entityIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  activityId: Scalars['Int']['input'];
}>;


export type ActivityDetailReportQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, serverDateTime?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, activityDetailReport?: any | null } | null } | null, getActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null } | null };

export type AdminSearchAtualidadesActivitiesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchTerm: Scalars['String']['input'];
}>;


export type AdminSearchAtualidadesActivitiesQuery = { __typename?: 'RootQueryType', adminSearchAtualidadesActivities?: { __typename?: 'AdminSearchAtualidadesActivitiesPayload', totalEntries?: number | null, activities?: Array<{ __typename?: 'Activity', degreeRange?: string | null, id?: number | null, moduleId?: number | null, title?: string | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', type?: ExamQuestionType | null } | null> | null, articles?: Array<{ __typename?: 'Article', id: number, image?: string | null, title?: string | null } | null> | null } | null> | null } | null };

export type SelectEntityQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectEntityQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, permissions?: string | null, teacherEntities?: any | null, showFlag?: boolean | null } | null } | null };

export type ListAppliedActivityDetailsQueryVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type ListAppliedActivityDetailsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, listAppliedActivityDetails?: { __typename?: 'AppliedActivityDetailsOutput', activityTitle?: string | null, entities?: any | null, others?: Array<{ __typename?: 'AppliedActivityDetails', status?: string | null } | null> | null } | null } | null } | null };

export type Teste1QueryVariables = Exact<{ [key: string]: never; }>;


export type Teste1Query = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null } | null };

export type ReaderYearlyIndicatorsQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReaderYearlyIndicatorsQuery = { __typename?: 'RootQueryType', readerSummaryReport?: { __typename?: 'ReaderSummaryReport', yearlyIndicators?: { __typename?: 'ReaderYearlyIndicators', monthlyCompletedActivitiesCount?: Array<{ __typename?: 'MonthlyCompletedActivitiesCountEntry', completedActivitiesCount: number, referenceMonth: number } | null> | null, monthlyReadingsCount?: Array<{ __typename?: 'MonthlyReadingsCountEntry', readingsCount: number, referenceMonth: number } | null> | null } | null } | null };

export type TeacherYearlyIndicatorsQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  teacherId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeacherYearlyIndicatorsQuery = { __typename?: 'RootQueryType', teacherSummaryReport?: { __typename?: 'TeacherSummaryReport', yearlyIndicators?: { __typename?: 'TeacherSummaryYearlyIndicators', monthlyReviewedActivitiesCount?: Array<{ __typename?: 'ReviewedActivitiesCountEntry', referenceMonth: number, reviewedActivitiesCount: number } | null> | null, monthlyIndicationsCount?: Array<{ __typename?: 'IndicationsCountEntry', indicationsCount: number, referenceMonth: number } | null> | null } | null } | null };

export type ReaderProgressBnccAbilitiesQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReaderProgressBnccAbilitiesQuery = { __typename?: 'RootQueryType', readerSummaryReport?: { __typename?: 'ReaderSummaryReport', performanceIndicators?: { __typename?: 'ReaderPerformanceIndicators', progressBnccAbilities?: Array<{ __typename?: 'ProgressBnccAbilityEntry', ability: string, abilityDescription: string, totalCorrectObjectiveQuestionsCount: number, totalObjectiveQuestionsCount: number } | null> | null } | null } | null };

export type ReaderMostReadContentsQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReaderMostReadContentsQuery = { __typename?: 'RootQueryType', readerSummaryReport?: { __typename?: 'ReaderSummaryReport', performanceIndicators?: { __typename?: 'ReaderPerformanceIndicators', mostReadContents?: Array<{ __typename?: 'ContentEntry', author: string, contentId: number, contentType: string, thumbUrl: string, title: string } | null> | null } | null } | null };

export type ActivitiesReaderQueryQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActivitiesReaderQueryQuery = { __typename?: 'RootQueryType', readerSummaryReport?: { __typename?: 'ReaderSummaryReport', performanceIndicators?: { __typename?: 'ReaderPerformanceIndicators', completedActivitiesCountToDate: number, startedActivitiesCountToDate: number, hitsPerQuestionToDate: string } | null } | null };

export type ActivitiesTeacherQueryQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  teacherId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActivitiesTeacherQueryQuery = { __typename?: 'RootQueryType', teacherSummaryReport?: { __typename?: 'TeacherSummaryReport', performanceIndicators?: { __typename?: 'TeacherSummaryPerformanceIndicators', assignedActivitiesCount: number, startedActivitiesCount: number, pendingReviewActivitiesCount: number, reviewedActivitiesCount: number, assignedActivitiesCountByDifficulty?: Array<{ __typename?: 'DifficultyLevelEntry', count: number, difficultyLevel: string } | null> | null, mostAssignedBnccCompetencies?: Array<{ __typename?: 'MostAssignedBnccCompetenciesInput', competency: string, count: number } | null> | null, assignedQuestionsCountByKind?: Array<{ __typename?: 'AssignedQuestionsCountByKindInput', count: number, kind: string } | null> | null } | null } | null };

export type ReaderAccessCountQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  readerId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReaderAccessCountQuery = { __typename?: 'RootQueryType', readerSummaryReport?: { __typename?: 'ReaderSummaryReport', usageTimeIndicators?: { __typename?: 'UsageTimeIndicators', learningTimeInMinutes?: number | null } | null } | null };

export type TeacherAccessCountQueryVariables = Exact<{
  classId?: InputMaybe<Scalars['Int']['input']>;
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  teacherId: Scalars['Int']['input'];
  referenceDate: Scalars['IsoDate']['input'];
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeacherAccessCountQuery = { __typename?: 'RootQueryType', teacherSummaryReport?: { __typename?: 'TeacherSummaryReport', usageTimeIndicators?: { __typename?: 'UsageTimeIndicators', platformUsageTimeInMinutes?: number | null } | null } | null };

export type ListCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCollectionsQuery = { __typename?: 'RootQueryType', listCollections?: Array<{ __typename?: 'Collection', id?: number | null, name?: string | null } | null> | null };

export type FetchBooksByCollectionAndBookCollectionQueryVariables = Exact<{
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  bookCollectionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchBooksByCollectionAndBookCollectionQuery = { __typename?: 'RootQueryType', fetchBooksByCollectionAndBookCollection?: Array<{ __typename?: 'Book', id?: number | null, name?: string | null, author?: string | null, slug?: string | null, publicationYear?: number | null, isbn?: string | null, publisher?: { __typename?: 'Publisher', name?: string | null } | null } | null> | null };

export type AdminListBookActivitiesQueryVariables = Exact<{
  bookSlug: Scalars['String']['input'];
}>;


export type AdminListBookActivitiesQuery = { __typename?: 'RootQueryType', adminListBookActivities?: { __typename: 'EmbeddedInBookActivity', hasActivitiesToShow?: boolean | null, id?: number | null, title?: string | null, status?: string | null, questions?: Array<{ __typename: 'EmbeddedInBookActivityQuestion', id?: number | null, type?: string | null, title?: string | null, isCorrect?: boolean | null, pageReference?: string | null, matchingPairs?: Array<{ __typename: 'ExamQuestionMatchingPairs', id?: string | null, statement?: string | null, leftId?: string | null, leftStatement?: string | null, rightId?: string | null, rightStatement?: string | null } | null> | null, answer?: { __typename: 'Answer', id?: number | null, answerDiscursive?: string | null, answerChoiceId?: number | null, examQuestionId?: number | null, teacherComments?: string | null, grade?: string | null, isCorrect?: boolean | null, correctAnswerId?: number | null } | null, choices?: Array<{ __typename: 'EmbeddedInBookActivityQuestionChoices', id?: number | null, title?: string | null, isCorrect?: boolean | null } | null> | null } | null> | null } | null };

export type GetAccessReportQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['IsoDate']['input'];
  startDate: Scalars['IsoDate']['input'];
  userProfile?: InputMaybe<UserProfileType>;
}>;


export type GetAccessReportQuery = { __typename?: 'RootQueryType', getAccessReport?: Array<{ __typename?: 'AccessReportPayload', numberOfAccesses?: number | null, studentName?: string | null, readerId?: number | null, entityId?: number | null, entityName?: string | null, readingTime?: any | null, platformTime?: any | null, averageTimeByAccess?: any | null, teacherName?: string | null } | null> | null };

export type GetReaderActivityStatusByEntityQueryVariables = Exact<{
  appliedActivityId: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
}>;


export type GetReaderActivityStatusByEntityQuery = { __typename?: 'RootQueryType', getReaderActivityStatusByEntity?: Array<{ __typename?: 'ReaderActivityStatus', bnccTags?: Array<Array<string | null> | null> | null, activityDetails?: Array<{ __typename?: 'ActivityDetails', userName: string, readerId: number, status?: string | null, finalGrade?: string | null, answers?: Array<{ __typename?: 'ActivityDetailsAnswer', examQuestionId: number, type: ExamQuestionType, isCorrect?: boolean | null } | null> | null }> | null }> | null };

export type GetUsageTimeIndicatorsQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type GetUsageTimeIndicatorsQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', usageTimeIndicators?: { __typename?: 'UsageTimeIndicators', learningTimeInMinutes?: number | null } | null } | null };

export type GetManagementIndicatorsQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type GetManagementIndicatorsQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', managementIndicators?: { __typename?: 'GeneralSummaryManagementIndicators', classesCount: number, networksCount: number, schoolsCount: number, studentsCount: number, trademarksCount: number } | null } | null };

export type ListUsersByFullAncestryQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
  userProfile?: InputMaybe<UserProfileType>;
}>;


export type ListUsersByFullAncestryQuery = { __typename?: 'RootQueryType', listUsersByFullAncestry?: Array<{ __typename?: 'UsersFullAncestry', className: string, profile: string, readerId: number, schoolName: string, userId: number, userName: string } | null> | null };

export type MostReadContentsAdminAdminSummaryQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type MostReadContentsAdminAdminSummaryQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', performanceIndicators?: { __typename?: 'GeneralSummaryPerformanceIndicators', mostReadContents?: Array<{ __typename?: 'ContentEntry', author: string, contentId: number, contentType: string, thumbUrl: string, title: string } | null> | null, readingsCountByFormat?: Array<{ __typename?: 'ReadingCountByFormatEntry', format: string, readingsCount: number } | null> | null } | null } | null };

export type RecommendationsAdminSummaryQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type RecommendationsAdminSummaryQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', performanceIndicators?: { __typename?: 'GeneralSummaryPerformanceIndicators', mostIndicatedContents?: Array<{ __typename?: 'ContentEntry', author: string, contentId: number, contentType: string, thumbUrl: string, title: string } | null> | null } | null } | null };

export type ActivitiesAdminSummaryQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type ActivitiesAdminSummaryQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', performanceIndicators?: { __typename?: 'GeneralSummaryPerformanceIndicators', reviewedActivitiesCount: number, startedActivitiesCount: number, pendingReviewActivitiesCount: number, assignedActivitiesCount: number, bestBnccAbilitiesByObjectiveQuestions?: Array<{ __typename?: 'BnccAbilityRankingEntry', ability: string, abilityDescription: string, count: number } | null> | null, worstBnccAbilitiesByObjectiveQuestions?: Array<{ __typename?: 'BnccAbilityRankingEntry', ability: string, abilityDescription: string, count: number } | null> | null } | null } | null };

export type PerformanceSummaryActivitiesQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type PerformanceSummaryActivitiesQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', performanceIndicators?: { __typename?: 'GeneralSummaryPerformanceIndicators', completedActivitiesCountToDate: number, completedActivitiesTrendForCurrentWeek: number } | null } | null };

export type PerformanceSummaryReadingsQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type PerformanceSummaryReadingsQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', performanceIndicators?: { __typename?: 'GeneralSummaryPerformanceIndicators', readingsCountToDate: number, readingsTrendForCurrentWeek: number } | null } | null };

export type PerformanceSummaryIndicationsQueryVariables = Exact<{
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
  referenceDate: Scalars['IsoDate']['input'];
}>;


export type PerformanceSummaryIndicationsQuery = { __typename?: 'RootQueryType', generalSummaryReport?: { __typename?: 'GeneralSummaryReport', performanceIndicators?: { __typename?: 'GeneralSummaryPerformanceIndicators', indicationsCountToDate: number, indicationsTrendForCurrentWeek: number } | null } | null };

export type UsersWithRolesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
}>;


export type UsersWithRolesQuery = { __typename?: 'RootQueryType', fetchUsersWithRoles?: { __typename?: 'UsersWithRolesResponse', totalCount: number, users: Array<{ __typename?: 'UserWithRoles', id: number, name: string, jobPositions: Array<JobPosition | null>, roles: Array<Role | null>, teacherId?: number | null } | null> } | null };

export type ReadingReportQueryVariables = Exact<{
  schoolId: Scalars['Int']['input'];
  classId: Scalars['Int']['input'];
  trademarkId: Scalars['Int']['input'];
  networkId: Scalars['Int']['input'];
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
}>;


export type ReadingReportQuery = { __typename?: 'RootQueryType', readingReport?: { __typename?: 'ReadingReportWithAggregatePayload', users?: Array<{ __typename?: 'ReadingReportPayload', name?: string | null, timeSpent?: number | null, validTimeSpent?: number | null, finalGrade?: string | null, readerId?: number | null } | null> | null, aggregate?: { __typename?: 'ReadingReportAggregatePayload', totalReadingTime?: number | null, totalValidReadingTime?: number | null, totalCorrectQuestions?: number | null, totalUsers?: number | null } | null } | null };

export type ReadingReportByReaderIdQueryVariables = Exact<{
  readerId: Scalars['Int']['input'];
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
}>;


export type ReadingReportByReaderIdQuery = { __typename?: 'RootQueryType', readingReportByReaderId?: { __typename?: 'ReadingReportByReaderIdResponse', userName?: string | null, readingData?: Array<{ __typename?: 'ReadingReportByReaderIdItem', name?: string | null, thumbnailUrl?: string | null, slug?: string | null, timeSpent?: number | null, validTimeSpent?: number | null, finalGrade?: string | null } | null> | null } | null };

export type GeneralVisionReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GeneralVisionReportQuery = { __typename?: 'RootQueryType', generalVision?: { __typename?: 'GeneralVisionReport', totalCount?: number | null, currentEntity?: { __typename?: 'GeneralVisionCurrentEntity', entityId?: number | null, entityName?: string | null } | null, summaryData?: { __typename?: 'GeneralVisionSummaryData', activeUsers: number, totalUsers: number, activeUsersPercentage: number, averageReadingTimeByUser: number, averageCorrectAnswersByUser: number, totalBooksRead: number, totalArticlesRead: number } | null, data?: Array<{ __typename?: 'GeneralVisionEntityData', id: number, entityName: string, activeUsersPercentage: number, totalUsers: number, activeUsers: number, averageReadingTime: number, correctAnswersPercentage: number, totalAnswers: number, correctAnswers: number, averageCorrectAnswersByUser: number, totalBooksRead: number, totalArticlesRead: number } | null> | null } | null };

export type GeneralVisionClassReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  classId: Scalars['Int']['input'];
}>;


export type GeneralVisionClassReportQuery = { __typename?: 'RootQueryType', generalVisionClassReport?: { __typename?: 'GeneralVisionClassReport', currentEntity?: { __typename?: 'GeneralVisionCurrentEntity', entityId?: number | null, entityName?: string | null } | null, summaryData?: { __typename?: 'GeneralVisionClassSummaryData', activeUsers: number, totalUsers: number, activeUsersPercentage: number, averageReadingTimeByUser: number, averageCorrectAnswersByUser: number, totalBooksRead: number, totalArticlesRead: number } | null, data?: Array<{ __typename?: 'GeneralVisionStudentData', id: number, studentName: string, lastAccessDate?: string | null, readingTime: number, correctAnswersPercentage: number, averageCorrectAnswersByActivity: number, booksRead: number, articlesRead: number } | null> | null } | null };

export type GeneralVisionUserReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  userId: Scalars['Int']['input'];
}>;


export type GeneralVisionUserReportQuery = { __typename?: 'RootQueryType', generalVisionUserReport?: { __typename?: 'GeneralVisionUserReport', summaryData?: { __typename?: 'GeneralVisionUserSummaryData', readingTime: number, correctAnswersPercentage: number, averageCorrectAnswersByActivity: number, totalBooksRead: number } | null, data?: Array<{ __typename?: 'GeneralVisionUserBookData', id: number, title: string, author?: string | null, readingTime: number, correctAnswersPercentage: number, correctAnswers: number, totalAnswers: number, coverUrl?: string | null, effectiveReadingPercentage: number, isSharedReading: boolean, isDefaultReading: boolean } | null> | null } | null };

export type BooksReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BooksReportQuery = { __typename?: 'RootQueryType', booksReport?: { __typename?: 'BooksReport', currentEntity?: { __typename?: 'GeneralVisionCurrentEntity', entityId?: number | null, entityName?: string | null } | null, summaryData?: { __typename?: 'BooksReportSummaryData', totalBooksRead: number, totalArticlesRead: number, totalEffectiveReadingTime: number, averageReadingTimeByUser: number } | null, data?: Array<{ __typename?: 'BooksReportBookData', id: number, title: string, author?: string | null, totalUsersRead: number, totalEffectiveReadingTime: number, averageReadingTimeByUser: number, coverUrl?: string | null, slug?: string | null } | null> | null } | null };

export type BooksUserReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  userId: Scalars['Int']['input'];
}>;


export type BooksUserReportQuery = { __typename?: 'RootQueryType', booksUserReport?: { __typename?: 'BooksUserReport', summaryData?: { __typename?: 'BooksUserReportSummaryData', totalBooksRead: number, totalArticlesRead: number, averageReadingByDay: number, totalEffectiveReadingTime: number } | null, data?: Array<{ __typename?: 'BooksUserReportBookData', id: number, title: string, author?: string | null, slug?: string | null, coverUrl?: string | null, lastReadingDate?: string | null, totalReadingTime: number, totalEffectiveReadingTime: number, effectiveReadingPercentage: number, hasAudioRecording: boolean, isSharedReading: boolean, isDefaultReading: boolean } | null> | null } | null };

export type BookDetailReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  classId: Scalars['Int']['input'];
  bookId: Scalars['Int']['input'];
}>;


export type BookDetailReportQuery = { __typename?: 'RootQueryType', bookDetailReport?: { __typename?: 'BookDetailReport', data?: Array<{ __typename?: 'BookDetailReportStudentData', id: number, name: string, lastReadDate?: string | null, readingTime: number, effectiveReadingTime: number, effectiveReadingPercentage: number, hasAudioRecording: boolean } | null> | null } | null };

export type ActivitiesReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  holdingId?: InputMaybe<Scalars['Int']['input']>;
  trademarkId?: InputMaybe<Scalars['Int']['input']>;
  networkId?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['Int']['input']>;
  classId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ActivitiesReportQuery = { __typename?: 'RootQueryType', activitiesReport?: { __typename?: 'ActivitiesReport', currentEntity?: { __typename?: 'GeneralVisionCurrentEntity', entityId?: number | null, entityName?: string | null } | null, summaryData?: { __typename?: 'ActivitiesReportSummaryData', totalCorrectAnswers: number, totalAnswers: number, averageCorrectAnswersByUser: number } | null, data?: Array<{ __typename?: 'ActivitiesReportActivityData', id: number, title: string, totalQuestions: number, usersAnswered: number, averageCorrectAnswersByUser: number } | null> | null } | null };

export type ActivitiesUserReportQueryVariables = Exact<{
  startDate: Scalars['IsoDate']['input'];
  endDate: Scalars['IsoDate']['input'];
  userId: Scalars['Int']['input'];
}>;


export type ActivitiesUserReportQuery = { __typename?: 'RootQueryType', activitiesUserReport?: { __typename?: 'ActivitiesUserReport', summaryData?: { __typename?: 'ActivitiesUserReportSummaryData', totalActivities: number, totalCorrectAnswersPercentage: number, totalAnswers: number, totalCorrectAnswers: number, averageCorrectAnswerByActivity: number } | null, data?: Array<{ __typename?: 'ActivitiesUserReportActivityData', id: number, title: string, totalQuestions: number, status: string, percentageCorrectAnswer: number, correctAnswers: number, totalAnswers: number } | null> | null } | null };

export type ActivityDetailReportV2QueryVariables = Exact<{
  classId: Scalars['Int']['input'];
  activityId: Scalars['Int']['input'];
}>;


export type ActivityDetailReportV2Query = { __typename?: 'RootQueryType', activityDetailReport?: Array<{ __typename?: 'ActivityDetailStudentData', id: number, name: string, status: ActivityDetailStatus, correctAnswers: number, totalAnswers: number, answeredQuestions: number, answersIsCorrect?: Array<boolean | null> | null, readerId: number, appliedActivityId?: number | null } | null> | null };

export type GetUserContentRecordingsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  contentIdentifier: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type GetUserContentRecordingsQuery = { __typename?: 'RootQueryType', getUserContentRecordings?: Array<{ __typename?: 'ContentReadingRecord', id: number, userId: number, contentIdentifier: string, contentType: string, audioS3Key: string, evaluationResponse?: string | null, createdAt: string, updatedAt: string, audioUrl?: string | null } | null> | null };

export type GetRecordingUrlQueryVariables = Exact<{
  recordingId: Scalars['Int']['input'];
}>;


export type GetRecordingUrlQuery = { __typename?: 'RootQueryType', getRecordingUrl?: string | null };

export type GetEntityQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEntityQuery = { __typename?: 'RootQueryType', getEntity?: { __typename?: 'Entity', id?: number | null, childrenCount?: number | null, name?: string | null, ancestry?: string | null, type?: string | null, userCount?: number | null, ancestryDetails?: Array<{ __typename?: 'AncestryDetail', id: number, name: string }> | null, children?: Array<{ __typename?: 'EntityChildrenPayload', childrenCount?: number | null, id?: number | null, name?: string | null, ancestry?: string | null, userCount?: number | null, degree?: string | null } | null> | null } | null };

export type GetEntityReadersPaginatedQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEntityReadersPaginatedQuery = { __typename?: 'RootQueryType', getEntity?: { __typename?: 'Entity', id?: number | null, readersPerPage?: Array<{ __typename?: 'EntityReaderPayload', accessExpireDate?: string | null, accessToken?: string | null, email?: string | null, id?: number | null, name?: string | null, permissions?: string | null, teacherId?: number | null, teacherPermissions?: string | null, userId?: number | null } | null> | null } | null };

export type GetEntityBasicInfoQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetEntityBasicInfoQuery = { __typename?: 'RootQueryType', getEntity?: { __typename?: 'Entity', id?: number | null, name?: string | null, ancestry?: string | null, type?: string | null, ancestryDetails?: Array<{ __typename?: 'AncestryDetail', id: number, name: string }> | null } | null };

export type GetReadersLastPresenceEventQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReadersLastPresenceEventQuery = { __typename?: 'RootQueryType', getEntity?: { __typename?: 'Entity', id?: number | null, readersPerPage?: Array<{ __typename?: 'EntityReaderPayload', id?: number | null, name?: string | null, lastPresenceEvent?: { __typename?: 'LastPresenceEvent', createdAt?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetEntityReadersWithLastRunningRecordsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEntityReadersWithLastRunningRecordsQuery = { __typename?: 'RootQueryType', getEntity?: { __typename?: 'Entity', id?: number | null, userCount?: number | null, readersPerPage?: Array<{ __typename?: 'EntityReaderPayload', id?: number | null, name?: string | null, userId?: number | null, lastRunningRecordsResult?: { __typename?: 'LastRunningRecordsResultPayload', lastAssessmentDate?: string | null, currentLeveling?: string | null } | null } | null> | null } | null };

export type GetEntityChildrenWithBasicInfoPaginatedQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetEntityChildrenWithBasicInfoPaginatedQuery = { __typename?: 'RootQueryType', getEntity?: { __typename?: 'Entity', id?: number | null, degree?: string | null, children?: Array<{ __typename?: 'EntityChildrenPayload', id?: number | null, name?: string | null, degree?: string | null, type?: string | null } | null> | null } | null };

export type GetEntitiesByAncestryQueryVariables = Exact<{
  rootId: Scalars['String']['input'];
}>;


export type GetEntitiesByAncestryQuery = { __typename?: 'RootQueryType', getEntitiesByAncestry?: Array<{ __typename?: 'EntitySummary', id?: string | null, name?: string | null, ancestry?: string | null } | null> | null };

export type GetBookSnippetSelectedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookSnippetSelectedQuery = { __typename?: 'RootQueryType', getBookSnippetSelected?: { __typename?: 'BookSnippetSelected', textInHtml?: string | null, rawText?: string | null, wordCount?: number | null, book?: { __typename?: 'Book', name?: string | null, author?: string | null } | null } | null };

export type ReadingFluencyAssessmentAvailableQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadingFluencyAssessmentAvailableQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, readingFluencyAssessmentAvailable?: boolean | null } | null } | null };

export type GetClassesWithReadingFluencyAssessmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClassesWithReadingFluencyAssessmentQuery = { __typename?: 'RootQueryType', getClassesWithReadingFluencyAssessment?: Array<{ __typename?: 'ClassReadingFluencyAssessment', id?: number | null, name?: string | null } | null> | null };

export type GetClassesAvailableToReadingFluencyAssessmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClassesAvailableToReadingFluencyAssessmentQuery = { __typename?: 'RootQueryType', getClassesAvailableToReadingFluencyAssessment?: Array<{ __typename?: 'ClassReadingFluencyAssessment', id?: number | null, name?: string | null } | null> | null };

export type GetBookSnippetsByDegreeQueryVariables = Exact<{
  degree: Scalars['String']['input'];
}>;


export type GetBookSnippetsByDegreeQuery = { __typename?: 'RootQueryType', getBookSnippetsByDegree?: Array<{ __typename?: 'GetBookSnippetsByDegreePayload', id?: number | null, rawText?: string | null, textInHtml?: string | null, wordCount?: number | null, degree?: string | null, book?: { __typename?: 'Book', name?: string | null, description?: string | null, slug?: string | null, author?: string | null, imageUrlThumb?: string | null } | null } | null> | null };

export type StartReadingFluencyAssessmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  start_date: Scalars['DateTime']['input'];
  end_date: Scalars['DateTime']['input'];
  entities_ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  snippet_id: Scalars['Int']['input'];
}>;


export type StartReadingFluencyAssessmentMutation = { __typename?: 'RootMutationType', startReadingFluencyAssessment?: string | null };

export type ReadingFluencyResultQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadingFluencyResultQuery = { __typename?: 'RootQueryType', getEntity?: { __typename?: 'Entity', id?: number | null, userCount?: number | null, readingFluencyResultsForCurrentYear?: Array<{ __typename?: 'ReadingFluencyClassResultForCurrentYear', totalUsers?: number | null, assessmentInfo?: { __typename?: 'ReadingFluencyAssessmentInfo', id?: string | null, appliedBy?: string | null, name?: string | null, startDate?: any | null, endDate?: any | null, bookSnippetName?: string | null, bookSnippetThumb?: string | null } | null, levelingResults?: Array<{ __typename?: 'ReadingFluencyClassLevelingResult', count?: number | null, percentage?: any | null, leveling?: ReadingFluencyLeveling | null } | null> | null, userResults?: Array<{ __typename?: 'ReadingFluencyUserResult', userId?: number | null, name?: string | null, degree?: string | null, readingFluencyResult?: ReadingFluencyLeveling | null, correctWordsPerMinute?: any | null, assessmentDate?: any | null, canceledAt?: any | null, comprehensionLevel?: number | null } | null> | null } | null> | null, lastReadingFluencyResult?: { __typename?: 'ReadingFluencyClassResult', totalUsers?: number | null, levelingResults?: Array<{ __typename?: 'ReadingFluencyClassLevelingResult', count?: number | null, percentage?: any | null, leveling?: ReadingFluencyLeveling | null } | null> | null, assessmentInfo?: { __typename?: 'ReadingFluencyAssessmentInfo', appliedBy?: string | null, id?: string | null, name?: string | null, startDate?: any | null, endDate?: any | null, bookSnippetName?: string | null, bookSnippetThumb?: string | null } | null } | null, readersByReadingFluency?: Array<{ __typename?: 'EntityReaderPayload', name?: string | null, userId?: number | null, degree?: string | null, readingFluencyResult?: { __typename?: 'ReadingFluencyResult', correctWordsPerMinute?: any | null, assessmentDate?: any | null, leveling?: ReadingFluencyLeveling | null, assessmentStatus?: string | null, comprehensionLevel?: number | null } | null } | null> | null } | null };

export type GetUserReadingFluencyResultQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUserReadingFluencyResultQuery = { __typename?: 'RootQueryType', getUserReadingFluencyResult?: { __typename?: 'UserReadingFluencyResultDetail', correctWordsPerMinute?: any | null, leveling?: ReadingFluencyLeveling | null, assessmentDate?: any | null, successRate?: any | null, assessmentEndDate?: any | null, assessmentReapplicationLimitReached?: boolean | null, userName?: string | null, assessmentName?: string | null, studentDegree?: string | null, audioUrl?: string | null, audioDurationInSeconds?: number | null, textReadInHtml?: string | null, errorsByType?: Array<{ __typename?: 'ReadingFluencyErrorDetail', quantity?: number | null, type?: AzureReadingFluencyErrorType | null } | null> | null, snippetBook?: { __typename?: 'SnippetBook', name?: string | null } | null } | null, me?: { __typename?: 'User', id?: string | null, serverDateTime?: string | null } | null };

export type GetAssessmentHistoryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}>;


export type GetAssessmentHistoryQuery = { __typename?: 'RootQueryType', getAssessmentHistory?: Array<{ __typename?: 'UserReadingFluencyAssessmentHistoryItem', id?: number | null, assessmentName?: string | null, assessmentDate?: any | null, leveling?: ReadingFluencyLeveling | null, correctWordsPerMinute?: any | null } | null> | null };

export type CancelLastReadingFluencyAssessmentResultMutationVariables = Exact<{
  input: CancelLastReadingFluencyAssessmentInput;
}>;


export type CancelLastReadingFluencyAssessmentResultMutation = { __typename?: 'RootMutationType', cancelLastReadingFluencyAssessmentResult?: string | null };

export type GetWaterDropDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWaterDropDetailsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, coins?: any | null, waterDropDetails?: { __typename?: 'WaterDropDetails', currentDrops?: any | null, dropsPerLevel?: number | null, maxDrops?: number | null, minimumLevel?: number | null, image?: string | null, percentage?: number | null, statusText?: string | null, description?: string | null } | null } | null } | null } | null };

export type HasForestQueryVariables = Exact<{ [key: string]: never; }>;


export type HasForestQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, treeListings?: Array<{ __typename?: 'TreeListing', id?: number | null } | null> | null } | null } | null } | null };

export type LeagueReportQueryVariables = Exact<{ [key: string]: never; }>;


export type LeagueReportQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, root?: { __typename?: 'Entity', id?: number | null, rankingRootWithTier?: any | null } | null } | null } | null };

export type LeagueBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type LeagueBoardsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, getCurrentPoints?: number | null, overallRanking?: { __typename?: 'Ranking', points?: number | null, tier?: string | null, percentage?: number | null, rankingUsers?: Array<{ __typename?: 'RankingReader', entityId?: number | null, profileId?: number | null, rankPosition?: number | null, rootName?: string | null, totalTimeSpent?: any | null, points?: number | null, userName?: string | null } | null> | null } | null, overallRankingHistory?: Array<{ __typename?: 'RankingReaderHistory', points?: number | null, month?: number | null, rankPosition?: number | null, tier?: string | null, status?: string | null } | null> | null, entity?: { __typename?: 'Entity', id?: number | null, degree?: string | null, ancestry?: string | null, rankingEntity?: Array<{ __typename?: 'RankingReader', profileId?: number | null, rankPosition?: number | null, rootName?: string | null, tier?: string | null, totalTimeSpent?: any | null, points?: number | null, userName?: string | null } | null> | null, rankingSchool?: Array<{ __typename?: 'RankingReader', profileId?: number | null, rankPosition?: number | null, rootName?: string | null, tier?: string | null, totalTimeSpent?: any | null, points?: number | null, userName?: string | null } | null> | null, rankingRoot?: Array<{ __typename?: 'RankingReader', profileId?: number | null, rankPosition?: number | null, rootName?: string | null, tier?: string | null, totalTimeSpent?: any | null, points?: number | null, userName?: string | null } | null> | null } | null } | null } | null };

export type LeaguePointsQueryVariables = Exact<{ [key: string]: never; }>;


export type LeaguePointsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, getCurrentPoints?: number | null, overallRanking?: { __typename?: 'Ranking', points?: number | null, tier?: string | null, percentage?: number | null } | null } | null } | null };

export type ListLevelingsBooksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListLevelingsBooksQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, motrixAssessmentBooksSuggested?: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, language?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null> | null } | null } | null };

export type MotrixAssessmentBooksSuggestedQueryVariables = Exact<{ [key: string]: never; }>;


export type MotrixAssessmentBooksSuggestedQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, motrixAssessmentAvailable?: boolean | null } | null } | null };

export type BookNavigationFieldsFragment = { __typename?: 'Book', name?: string | null, author?: string | null, freemium?: boolean | null, slug?: string | null, language?: string | null, layout?: string | null, v2ready?: boolean | null, degree?: string | null, manualInfoChecked?: boolean | null, description?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premium?: boolean | null, premiumLock?: boolean | null, rights?: string | null, hasAudioBook?: boolean | null };

export type GetTeacherInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeacherInfoQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, secondEmail?: string | null, phone?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, yearsResponsibleFor?: string | null, disciplines?: Array<{ __typename?: 'Discipline', title?: string | null } | null> | null, roles?: Array<{ __typename?: 'DeprecatedRole', title?: string | null } | null> | null } | null } | null };

export type FavoriteBooksQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteBooksQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, favoriteBooks?: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, freemium?: boolean | null, slug?: string | null, language?: string | null, layout?: string | null, v2ready?: boolean | null, degree?: string | null, manualInfoChecked?: boolean | null, description?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premium?: boolean | null, premiumLock?: boolean | null, rights?: string | null, hasAudioBook?: boolean | null } | null> | null } | null } | null };

export type OldListReadersSameDegreeQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type OldListReadersSameDegreeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, listReadersSameDegree?: any | null } | null } | null };

export type EntitiesSubtreeFlatQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type EntitiesSubtreeFlatQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, entitiesSubtreeFlat?: any | null } | null } | null };

export type OldSearchAvailableReadersToIndicateQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type OldSearchAvailableReadersToIndicateQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, searchAvailableReadersToIndicate?: any | null } | null } | null };

export type BookBasicInfoQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BookBasicInfoQuery = { __typename?: 'RootQueryType', bookDetails?: { __typename?: 'Book', name?: string | null, author?: string | null, freemium?: boolean | null, slug?: string | null, language?: string | null, layout?: string | null, v2ready?: boolean | null, degree?: string | null, manualInfoChecked?: boolean | null, description?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premium?: boolean | null, premiumLock?: boolean | null, rights?: string | null, hasAudioBook?: boolean | null } | null };

export type CollectionQueryVariables = Exact<{
  collectionId: Scalars['Int']['input'];
}>;


export type CollectionQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, collection?: { __typename?: 'BookShelf', id?: number | null, name?: string | null, image?: string | null, bgColor?: string | null, description?: string | null, books?: Array<{ __typename?: 'Book', author?: string | null, degree?: string | null, description?: string | null, edition?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, name?: string | null, readingLevel?: number | null, series?: string | null, slug?: string | null, subtitle?: string | null, hasAudioBook?: boolean | null } | null> | null } | null } | null } | null };

export type SearchAllAvailableBooksQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchAllAvailableBooksQuery = { __typename?: 'RootQueryType', searchAllAvailableBooks?: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, freemium?: boolean | null, slug?: string | null, language?: string | null, layout?: string | null, v2ready?: boolean | null, degree?: string | null, manualInfoChecked?: boolean | null, description?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premium?: boolean | null, premiumLock?: boolean | null, rights?: string | null, hasAudioBook?: boolean | null } | null> | null };

export type OldSearchBookForAutoCompleteQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type OldSearchBookForAutoCompleteQuery = { __typename?: 'RootQueryType', searchBook?: Array<{ __typename?: 'Book', name?: string | null, slug?: string | null } | null> | null };

export type OldSearchBookForAutoCompleteActivityQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type OldSearchBookForAutoCompleteActivityQuery = { __typename?: 'RootQueryType', searchBook?: Array<{ __typename?: 'Book', name?: string | null, slug?: string | null } | null> | null };

export type ListMascotsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMascotsQuery = { __typename?: 'RootQueryType', listMascots?: Array<string | null> | null };

export type SearchBnccAbilityForAutoCompleteQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type SearchBnccAbilityForAutoCompleteQuery = { __typename?: 'RootQueryType', searchBnccAbility?: Array<{ __typename?: 'BnccAbility', code?: string | null, description?: string | null } | null> | null };

export type SearchBnccTagsForAutoCompleteQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type SearchBnccTagsForAutoCompleteQuery = { __typename?: 'RootQueryType', searchBnccTags?: Array<{ __typename?: 'BnccTag', name?: string | null } | null> | null };

export type SearchTextualGenresForAutoCompleteQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type SearchTextualGenresForAutoCompleteQuery = { __typename?: 'RootQueryType', searchTextualGenre?: Array<{ __typename?: 'TextualGenre', name?: string | null } | null> | null };

export type BooksInCategoryWithFiltersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  opts?: InputMaybe<Scalars['String']['input']>;
}>;


export type BooksInCategoryWithFiltersQuery = { __typename?: 'RootQueryType', searchCategoryV2?: { __typename?: 'SearchResult', searchFilters?: any | null, books?: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, freemium?: boolean | null, slug?: string | null, language?: string | null, layout?: string | null, v2ready?: boolean | null, degree?: string | null, manualInfoChecked?: boolean | null, description?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premium?: boolean | null, premiumLock?: boolean | null, rights?: string | null, hasAudioBook?: boolean | null } | null> | null } | null };

export type AdminHomeInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminHomeInfosQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, firstAccess?: boolean | null, teacher?: { __typename?: 'Teacher', id?: number | null, countReaders?: any | null, totalTimeSpent?: any | null, indicatedBooks?: any | null, preferredBooks?: any | null, mostReaders?: any | null, mostReadersByEntity?: any | null, entityContentConsumptionSummary?: { __typename?: 'EntityContentConsumptionSummary', openedContentCount?: number | null, fullyConsumedContentCount?: number | null } | null, root?: { __typename?: 'Entity', id?: number | null, segment?: string | null } | null } | null } | null };

export type PreferredBooksQueryVariables = Exact<{ [key: string]: never; }>;


export type PreferredBooksQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, preferredBooks?: any | null } | null } | null };

export type GetInitialDataForSharedBooksPageQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetInitialDataForSharedBooksPageQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, topGeneralSharedReadingsWeekly?: Array<{ __typename?: 'SharedReading', likedByMe?: number | null, likes?: number | null, lastUserShare?: string | null, sharedByMe?: boolean | null, book?: { __typename?: 'Book', name?: string | null, imageUrlThumb?: string | null, slug?: string | null, hasAudioBook?: boolean | null } | null } | null> | null, sharedReadingsBySchool?: Array<{ __typename?: 'SharedReading', likedByMe?: number | null, likes?: number | null, lastUserShare?: string | null, shares?: number | null, sharedByMe?: boolean | null, book?: { __typename?: 'Book', name?: string | null, imageUrlThumb?: string | null, slug?: string | null, hasAudioBook?: boolean | null } | null } | null> | null } | null } | null };

export type GetMoreSharedBooksQueryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sharedByMeOnly: Scalars['Boolean']['input'];
}>;


export type GetMoreSharedBooksQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, sharedReadings?: Array<{ __typename?: 'SharedReading', likedByMe?: number | null, likes?: number | null, lastUserShare?: string | null, shares?: number | null, sharedByMe?: boolean | null, book?: { __typename?: 'Book', name?: string | null, imageUrlThumb?: string | null, slug?: string | null, hasAudioBook?: boolean | null } | null } | null> | null } | null } | null };

export type AllUserActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserActivitiesQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, serverDateTime?: string | null, reader?: { __typename?: 'Reader', id?: string | null, listAppliedActivities?: any | null } | null } | null };

export type OldAllUserActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type OldAllUserActivitiesQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, surveys?: any | null } | null } | null };

export type SurveysOfMySchoolQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SurveysOfMySchoolQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, surveysOfMySchool?: any | null } | null } | null };

export type AllBookshelvesQueryVariables = Exact<{
  isHighlight: Scalars['Boolean']['input'];
  acervoType?: InputMaybe<Scalars['String']['input']>;
  degreeRange?: InputMaybe<Scalars['String']['input']>;
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllBookshelvesQuery = { __typename?: 'RootQueryType', listExistingBookshelf?: Array<{ __typename?: 'BookShelf', name?: string | null, active?: boolean | null, degreeRange?: string | null, id?: number | null, isHighlight?: boolean | null, type?: string | null, image?: string | null, bgColor?: string | null, description?: string | null, bookShelfItemsCount?: number | null, bookShelfItems?: Array<{ __typename?: 'BookShelfItem', bookShelfId?: number | null, id?: number | null, mascot?: string | null, book?: { __typename?: 'Book', slug?: string | null, name?: string | null, imageUrlThumb?: string | null, author?: string | null, hasAudioBook?: boolean | null, degree?: string | null } | null } | null> | null } | null> | null };

export type ShowBookShelfOldQueryVariables = Exact<{
  bookShelfId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ShowBookShelfOldQuery = { __typename?: 'RootQueryType', showBookShelf?: { __typename?: 'BookShelf', name?: string | null, subtitle?: string | null, degreeRange?: string | null, contentFilter?: string | null, isHighlight?: boolean | null, acervoType?: string | null, id?: number | null, type?: string | null, description?: string | null, image?: string | null, bgColor?: string | null, bookShelfItemsCount?: number | null, bookShelfItems?: Array<{ __typename?: 'BookShelfItem', bookShelfId?: number | null, id?: number | null, mascot?: string | null, book?: { __typename?: 'Book', slug?: string | null, name?: string | null, imageUrlThumb?: string | null, author?: string | null, hasAudioBook?: boolean | null, degree?: string | null, premiumLock?: boolean | null } | null } | null> | null } | null };

export type GetAcervoTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAcervoTypesQueryQuery = { __typename?: 'RootQueryType', getAcervoTypes?: Array<string | null> | null };

export type ListDidacticSequencesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDidacticSequencesQueryQuery = { __typename?: 'RootQueryType', listDidacticSequences?: Array<{ __typename?: 'DidacticSequence', id?: number | null, title?: string | null, isReady?: boolean | null, arvoreId?: string | null } | null> | null };

export type ListSpecificSkillsQueryVariables = Exact<{
  knowledgeAreaId: Scalars['Int']['input'];
}>;


export type ListSpecificSkillsQuery = { __typename?: 'RootQueryType', listSpecificSkills?: Array<{ __typename?: 'SpecificSkill', description?: string | null, id?: number | null } | null> | null };

export type ListGeneralSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGeneralSkillsQuery = { __typename?: 'RootQueryType', listGeneralSkills?: Array<{ __typename?: 'GeneralSkill', id?: number | null, description?: string | null } | null> | null };

export type GetDidacticSequenceQueryVariables = Exact<{
  didacticSequenceId: Scalars['Int']['input'];
}>;


export type GetDidacticSequenceQuery = { __typename?: 'RootQueryType', getDidacticSequence?: { __typename?: 'DidacticSequence', isFavorite?: boolean | null, arvoreId?: string | null, author?: string | null, contents?: string | null, evaluation?: string | null, id?: number | null, isReady?: boolean | null, purposes?: string | null, summary?: string | null, title?: string | null, tags?: Array<{ __typename?: 'BnccTag', id?: number | null, name?: string | null } | null> | null, activity?: { __typename?: 'Activity', id?: number | null, description?: string | null, didacticSequenceId?: number | null, isBncc?: boolean | null, title?: string | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id?: number | null, commentedAnswer?: string | null, statement?: string | null, type?: ExamQuestionType | null, baseText?: { __typename?: 'BaseText', id?: number | null, statement?: string | null } | null, bnccAbility?: { __typename?: 'BnccAbilityExamQuestion', bnccAbility?: { __typename?: 'BnccAbility', id?: number | null, code?: string | null, description?: string | null } | null } | null, books?: Array<{ __typename?: 'Book', name?: string | null, slug?: string | null, imageUrlThumb?: string | null, author?: string | null } | null> | null, examQuestionChoices?: Array<{ __typename?: 'ExamQuestionChoice', examQuestionId?: number | null, id?: number | null, isCorrect?: boolean | null, statement?: string | null, tempImage?: string | null } | null> | null } | null> | null } | null, bnccAbilities?: Array<{ __typename?: 'BnccAbility', id?: number | null, code?: string | null, degreeRange?: string | null, description?: string | null, practiceObjectId?: string | null, practiceObject?: { __typename?: 'PracticeObject', name?: string | null, fieldPractice?: { __typename?: 'FieldPractice', name?: string | null } | null } | null } | null> | null, bnccDegrees?: Array<{ __typename?: 'BnccDegree', degree?: string | null, id?: string | null } | null> | null, books?: Array<{ __typename?: 'Book', name?: string | null, slug?: string | null, author?: string | null, imageUrlThumb?: string | null } | null> | null, lessons?: Array<{ __typename?: 'Lesson', text?: string | null, id?: number | null } | null> | null, specificSkills?: Array<{ __typename?: 'SpecificSkill', description?: string | null, id?: number | null, knowledgeAreaId?: number | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', name?: string | null, id?: number | null } | null> | null } | null };

export type SearchDidacticSequenceQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  opts?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchDidacticSequenceQuery = { __typename?: 'RootQueryType', searchDidacticSequence?: { __typename?: 'DidacticSequenceSearchResults', searchFilters?: any | null, didacticSequences?: Array<{ __typename?: 'DidacticSequenceSearchResult', title?: string | null, id?: number | null, actionFields?: Array<{ __typename?: 'ActionField', id?: number | null, name?: string | null } | null> | null, lessons?: Array<{ __typename?: 'Lesson', text?: string | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', name?: string | null } | null> | null, degrees?: Array<{ __typename?: 'BnccDegree', degree?: string | null } | null> | null } | null> | null } | null };

export type ListDidacticSequencesQueryVariables = Exact<{
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  isReady?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListDidacticSequencesQuery = { __typename?: 'RootQueryType', listDidacticSequences?: Array<{ __typename?: 'DidacticSequence', title?: string | null, id?: number | null, bnccAbilities?: Array<{ __typename?: 'BnccAbility', code?: string | null, practiceObject?: { __typename?: 'PracticeObject', id?: number | null, name?: string | null, fieldPractice?: { __typename?: 'FieldPractice', id?: number | null, name?: string | null, actionField?: { __typename?: 'ActionField', id?: number | null, name?: string | null } | null } | null } | null } | null> | null, lessons?: Array<{ __typename?: 'Lesson', text?: string | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', name?: string | null } | null> | null, bnccDegrees?: Array<{ __typename?: 'BnccDegree', degree?: string | null } | null> | null } | null> | null };

export type ListBnccAbilitiesForFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBnccAbilitiesForFilterQuery = { __typename?: 'RootQueryType', listBnccAbilitiesForFilter?: Array<{ __typename?: 'BnccAbility', id?: number | null, code?: string | null, description?: string | null } | null> | null };

export type OldGetActivityQueryVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type OldGetActivityQuery = { __typename?: 'RootQueryType', getActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null, moduleId?: number | null, description?: string | null, submittedToPublic: boolean, isReady?: boolean | null, degreeRange?: string | null, authorInfo?: { __typename?: 'ActivityAuthorInfo', facebookPhoto?: string | null, name?: string | null, school?: string | null } | null, books?: Array<{ __typename?: 'Book', slug?: string | null, author?: string | null, name?: string | null, imageUrlThumb?: string | null, publisher?: { __typename?: 'Publisher', id?: number | null, name?: string | null } | null } | null> | null, articles?: Array<{ __typename?: 'Article', id: number, image?: string | null, title?: string | null, author?: string | null, degree?: string | null, publishDate?: string | null, subtitle?: string | null } | null> | null, publicDataActivity?: { __typename?: 'PublicDataActivity', degreeRange?: string | null, email?: string | null, id?: number | null, objective?: string | null, publicActivityId?: number | null, school?: string | null, sourceActivityId?: number | null, generalSkills?: Array<{ __typename?: 'GeneralSkill', id?: number | null, description?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', name?: string | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', id?: number | null, name?: string | null } | null> | null } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', statement?: string | null, type?: ExamQuestionType | null, id?: number | null, tempImage?: string | null, examQuestionMatchingPairs?: Array<{ __typename?: 'ExamQuestionMatchingPairs', id?: string | null, leftId?: string | null, leftStatement?: string | null, rightId?: string | null, rightStatement?: string | null } | null> | null, examQuestionChoices?: Array<{ __typename?: 'ExamQuestionChoice', id?: number | null, statement?: string | null, isCorrect?: boolean | null, tempImage?: string | null } | null> | null } | null> | null } | null };

export type GetPublicActivityQueryVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type GetPublicActivityQuery = { __typename?: 'RootQueryType', getPublicActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null, description?: string | null, submittedToPublic: boolean, isReady?: boolean | null, difficultyLevel?: ActivityDifficultyLevel | null, estimatedCompletionTimeInSeconds?: number | null, authorInfo?: { __typename?: 'ActivityAuthorInfo', facebookPhoto?: string | null, name?: string | null, school?: string | null } | null, books?: Array<{ __typename?: 'Book', slug?: string | null, author?: string | null, name?: string | null, imageUrlThumb?: string | null } | null> | null, publicDataActivity?: { __typename?: 'PublicDataActivity', degreeRange?: string | null, email?: string | null, id?: number | null, objective?: string | null, publicActivityId?: number | null, school?: string | null, sourceActivityId?: number | null, generalSkills?: Array<{ __typename?: 'GeneralSkill', id?: number | null, description?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', name?: string | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', id?: number | null, name?: string | null } | null> | null } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', statement?: string | null, type?: ExamQuestionType | null, id?: number | null, examQuestionChoices?: Array<{ __typename?: 'ExamQuestionChoice', id?: number | null, statement?: string | null, isCorrect?: boolean | null, tempImage?: string | null } | null> | null, bnccAbilities?: Array<{ __typename?: 'BnccAbility', id?: number | null, code?: string | null, description?: string | null, practiceObject?: { __typename?: 'PracticeObject', id?: number | null, name?: string | null, fieldPractice?: { __typename?: 'FieldPractice', id?: number | null, name?: string | null, actionField?: { __typename?: 'ActionField', id?: number | null, name?: string | null } | null } | null } | null } | null> | null } | null> | null } | null };

export type CurationGetActivityQueryVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type CurationGetActivityQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, curationGetActivity?: { __typename?: 'Activity', id?: number | null, title?: string | null, description?: string | null, submittedToPublic: boolean, isReady?: boolean | null, authorInfo?: { __typename?: 'ActivityAuthorInfo', facebookPhoto?: string | null, name?: string | null, school?: string | null } | null, books?: Array<{ __typename?: 'Book', slug?: string | null, author?: string | null, name?: string | null, imageUrlThumb?: string | null, publisher?: { __typename?: 'Publisher', id?: number | null, name?: string | null } | null } | null> | null, publicDataActivity?: { __typename?: 'PublicDataActivity', degreeRange?: string | null, email?: string | null, id?: number | null, objective?: string | null, publicActivityId?: number | null, school?: string | null, sourceActivityId?: number | null, generalSkills?: Array<{ __typename?: 'GeneralSkill', id?: number | null, description?: string | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', id?: number | null, name?: string | null } | null> | null } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', statement?: string | null, type?: ExamQuestionType | null, id?: number | null, examQuestionChoices?: Array<{ __typename?: 'ExamQuestionChoice', id?: number | null, statement?: string | null, isCorrect?: boolean | null, tempImage?: string | null } | null> | null } | null> | null } | null } | null } | null };

export type ListMyActivitiesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMyActivitiesQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, listMyActivities?: Array<{ __typename?: 'Activity', id?: number | null, title?: string | null, books?: Array<{ __typename?: 'Book', slug?: string | null, author?: string | null, name?: string | null, imageUrlThumb?: string | null, publisher?: { __typename?: 'Publisher', id?: number | null, name?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type ListApplicationsForActivityQueryQueryVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type ListApplicationsForActivityQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, listApplicationsForActivity?: Array<{ __typename?: 'AppliedActivity', startDate?: any | null, endDate?: any | null, readerId?: number | null, entityId?: number | null, id?: number | null, createdAt?: any | null, title?: string | null } | null> | null } | null } | null };

export type SearchReadersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type SearchReadersQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, searchReaders?: any | null } | null } | null };

export type CategoriesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesPageQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, entity?: { __typename?: 'Entity', id?: number | null, customCategories?: Array<{ __typename?: 'CustomCategory', name?: string | null, iconPath?: string | null } | null> | null } | null } | null } | null };

export type GetTemporarilyBooksQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemporarilyBooksQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, entity?: { __typename?: 'Entity', id?: number | null, temporarilyBooks?: any | null } | null } | null } | null };

export type GetNpsScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNpsScoreQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, npsScore?: { __typename?: 'NpsScore', score?: number | null, source?: string | null, createdAt?: any | null } | null } | null };

export type TrialFirstAccessQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TrialFirstAccessQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null } | null } | null };

export type DataHomeForestOldQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DataHomeForestOldQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, coins?: any | null, treeListings?: Array<{ __typename?: 'TreeListing', id?: number | null, image?: string | null } | null> | null } | null } | null } | null };

export type GetDataMainForestScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDataMainForestScreenQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, coins?: any | null, trees?: Array<{ __typename?: 'Tree', id?: number | null, specialItemUsed?: boolean | null, stage?: number | null, agePercentage?: number | null, description?: string | null, growthTime?: number | null, image?: string | null, name?: string | null, position?: number | null, scientificName?: string | null, species?: string | null, ageStatusText?: string | null } | null> | null, seeds?: Array<{ __typename?: 'Seed', id?: number | null, image?: string | null, name?: string | null, description?: string | null, locked?: boolean | null, lockedText?: string | null, scientificName?: string | null, species?: string | null, growthTime?: string | null, price?: number | null } | null> | null, specialItems?: Array<{ __typename?: 'SpecialItem', id?: number | null, name?: string | null, description?: string | null, price?: number | null, action?: string | null, image?: string | null, type?: string | null } | null> | null, waterDropDetails?: { __typename?: 'WaterDropDetails', raining?: boolean | null } | null } | null } | null } | null };

export type FriendTreeListingsQueryVariables = Exact<{
  friendReaderId: Scalars['Int']['input'];
}>;


export type FriendTreeListingsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, friendTreeListings?: Array<{ __typename?: 'TreeListing', id?: number | null, image?: string | null, position?: number | null } | null> | null } | null } | null } | null };

export type FriendsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  count: Scalars['Int']['input'];
}>;


export type FriendsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, friends?: Array<{ __typename?: 'Friend', name?: string | null, readerId?: number | null } | null> | null } | null } | null } | null };

export type FriendsForAdminQueryVariables = Exact<{
  entityId: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  count: Scalars['Int']['input'];
}>;


export type FriendsForAdminQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, friendsForAdmin?: Array<{ __typename?: 'FriendForAdmin', id?: number | null, name?: string | null, type?: string | null } | null> | null } | null } | null } | null };

export type GetMyForestAndSeedsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyForestAndSeedsDataQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, coins?: any | null, trees?: Array<{ __typename?: 'Tree', id?: number | null, specialItemUsed?: boolean | null, stage?: number | null, agePercentage?: number | null, description?: string | null, growthTime?: number | null, image?: string | null, name?: string | null, position?: number | null, scientificName?: string | null, species?: string | null, ageStatusText?: string | null } | null> | null, seeds?: Array<{ __typename?: 'Seed', id?: number | null, image?: string | null, name?: string | null, description?: string | null, locked?: boolean | null, lockedText?: string | null, scientificName?: string | null, species?: string | null, growthTime?: string | null, price?: number | null } | null> | null } | null } | null } | null };

export type GetStoreDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStoreDataQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, coins?: any | null, seeds?: Array<{ __typename?: 'Seed', id?: number | null, image?: string | null, name?: string | null, description?: string | null, locked?: boolean | null, lockedText?: string | null, scientificName?: string | null, species?: string | null, growthTime?: string | null, price?: number | null } | null> | null, waterDropDetails?: { __typename?: 'WaterDropDetails', raining?: boolean | null } | null } | null } | null } | null };

export type GetClientListingQueryVariables = Exact<{
  filters?: InputMaybe<ClientListingFilters>;
}>;


export type GetClientListingQuery = { __typename?: 'RootQueryType', getClientListing?: Array<{ __typename?: 'ClientListing', id?: number | null, name?: string | null, deactivated?: boolean | null } | null> | null };

export type SearchLoginTypeQueryVariables = Exact<{
  prefixOrSufix: LoginTypePrefixOrSufix;
  profileType: ProfileType;
  term: Scalars['String']['input'];
}>;


export type SearchLoginTypeQuery = { __typename?: 'RootQueryType', searchLoginType?: { __typename?: 'SearchLoginTypePayload', id?: number | null } | null };

export type GetClientQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
}>;


export type GetClientQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null } | null, getClient?: { __typename?: 'GetClientPayload', id?: number | null, name?: string | null, accessCode?: string | null, isTrial?: boolean | null, whoPays?: string | null, loginType?: any | null, payingClient?: boolean | null, responsibleName?: string | null, responsibleEmail?: string | null, schoolStructure?: string | null, segment?: string | null, internalContacts?: any | null, usesContractModuleSystem?: boolean | null, entityType?: string | null, blockAccessTokens?: boolean | null, deactivated?: boolean | null, maxSimultaneousUsers?: number | null, clientContracts?: Array<{ __typename?: 'ClientContractPayload', id?: number | null, type?: string | null, contractModules?: Array<{ __typename?: 'ContractModule', id?: number | null, contractId?: number | null, info?: { __typename?: 'CnpjPayingModuleInfoPayload', minUsers?: number | null, freeUsers?: number | null, pricePerUnit?: number | null, bookCollection?: string | null } | { __typename?: 'FamilyPayingModuleInfoPayload', minUsers?: number | null, pricePerUnit?: number | null, discount?: number | null, discountExpirationDate?: string | null, bookCollection?: string | null } | { __typename?: 'FpBookfairModuleInfoPayload' } | { __typename?: 'ProjectModuleInfoPayload', maxTeachers?: number | null, maxReaders?: number | null, bookCollection?: string | null } | { __typename?: 'PublicModuleInfoPayload', numberOfReaders?: number | null, bookCollection?: string | null } | { __typename?: 'TrialModuleInfoPayload', maxTeachers?: number | null, maxReaders?: number | null, bookCollection?: string | null } | null, module?: { __typename?: 'Module', name?: string | null } | null } | null> | null } | null> | null, contractModules?: Array<{ __typename?: 'ContractModule', id?: number | null, contractId?: number | null, module?: { __typename?: 'Module', name?: string | null } | null } | null> | null } | null, getContractListing?: Array<{ __typename?: 'ContractListing', active?: boolean | null, clientId?: number | null, clientName?: string | null, contractType?: string | null, contractId?: number | null, contractModules?: Array<{ __typename?: 'ContractModule', id?: number | null, contractId?: number | null, module?: { __typename?: 'Module', name?: string | null } | null } | null> | null } | null> | null, getSubtreeFromEntityListing?: Array<{ __typename?: 'SubtreeFromEntityListingPayload', child?: boolean | null, parentId?: number | null, parentName?: string | null, accessCode?: string | null, degree?: string | null, entityId?: number | null, entityName?: string | null, entityAncestry?: string | null, entityType?: string | null, contractModules?: Array<{ __typename?: 'ContractModule', id?: number | null, contractId?: number | null, module?: { __typename?: 'Module', name?: string | null } | null } | null> | null } | null> | null };

export type GetContractListingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractListingQueryQuery = { __typename?: 'RootQueryType', getContractListing?: Array<{ __typename?: 'ContractListing', active?: boolean | null, clientId?: number | null, clientName?: string | null, contractType?: string | null, contractId?: number | null, contractModules?: Array<{ __typename?: 'ContractModule', id?: number | null, contractId?: number | null, module?: { __typename?: 'Module', name?: string | null } | null } | null> | null } | null> | null };

export type GetSubtreeFromEntityListingQueryQueryVariables = Exact<{
  entityId: Scalars['Int']['input'];
}>;


export type GetSubtreeFromEntityListingQueryQuery = { __typename?: 'RootQueryType', getSubtreeFromEntityListing?: Array<{ __typename?: 'SubtreeFromEntityListingPayload', degree?: string | null, child?: boolean | null, parentId?: number | null, parentName?: string | null, entityId?: number | null, entityName?: string | null, entityAncestry?: string | null, entityType?: string | null, contractModules?: Array<{ __typename?: 'ContractModule', contractId?: number | null, module?: { __typename?: 'Module', id?: number | null, name?: string | null } | null } | null> | null } | null> | null };

export type GetReadersAccessInfoQueryQueryVariables = Exact<{
  entityId: Scalars['Int']['input'];
  source: ReadersInfoSourceType;
  profileType: ProfileType;
}>;


export type GetReadersAccessInfoQueryQuery = { __typename?: 'RootQueryType', readersAccessInfo?: Array<{ __typename?: 'Card', id?: number | null, name?: string | null, entityName?: string | null, accessToken?: string | null } | { __typename?: 'ReadersAccessInfoPayload', entityName?: string | null, accessCode?: string | null, readerName?: string | null, accessToken?: string | null, url?: string | null } | null> | null };

export type GetContractDataQueryQueryVariables = Exact<{
  contractId: Scalars['Int']['input'];
}>;


export type GetContractDataQueryQuery = { __typename?: 'RootQueryType', getAcervoTypes?: Array<string | null> | null, listCollections?: Array<{ __typename?: 'Collection', id?: number | null, name?: string | null } | null> | null, listBookCollections?: Array<{ __typename?: 'BookCollection', id?: number | null, name?: string | null } | null> | null, getContract?: { __typename?: 'ContractPayload', active?: boolean | null, cnpj?: string | null, clientId?: number | null, clientName?: string | null, companyName?: string | null, contractId?: number | null, contractType?: string | null, disableContractAfterExpiration?: boolean | null, endDate?: string | null, entityName?: string | null, expirationWarningDays?: number | null, financeContactEmail?: string | null, financeContactName?: string | null, financeContactPhone?: string | null, observation?: string | null, paymentInfo?: string | null, signatureDate?: string | null, startDate?: string | null, stateRegistration?: string | null, municipalRegistration?: string | null, market?: string | null, tradingName?: string | null, firstChargeDate?: string | null, contractModules?: Array<{ __typename?: 'ContractModule', collections?: Array<{ __typename?: 'Collection', id?: number | null, name?: string | null } | null> | null, bookCollections?: Array<{ __typename?: 'BookCollection', id?: number | null, name?: string | null } | null> | null, extraInformation?: { __typename?: 'CnpjPayingExtraInformation', activeUsers?: number | null, chargedUsers?: number | null, totalAmount?: number | null } | { __typename?: 'FamilyPayingExtraInformation', activeUsers?: number | null, paidUsers?: number | null } | { __typename?: 'FpBookfairExtraInformation' } | { __typename?: 'ProjectExtraInformation', maxReaders?: number | null, maxTeachers?: number | null } | { __typename?: 'PublicExtraInformation', activeUsers?: number | null, numberOfReaders?: number | null } | { __typename?: 'TrialExtraInformation', maxReaders?: number | null, maxTeachers?: number | null } | null, info?: { __typename?: 'CnpjPayingModuleInfoPayload', minUsers?: number | null, freeUsers?: number | null, pricePerUnit?: number | null, bookCollection?: string | null } | { __typename?: 'FamilyPayingModuleInfoPayload', minUsers?: number | null, pricePerUnit?: number | null, discount?: number | null, discountExpirationDate?: string | null, bookCollection?: string | null } | { __typename?: 'FpBookfairModuleInfoPayload' } | { __typename?: 'ProjectModuleInfoPayload', maxTeachers?: number | null, maxReaders?: number | null, bookCollection?: string | null } | { __typename?: 'PublicModuleInfoPayload', numberOfReaders?: number | null, bookCollection?: string | null } | { __typename?: 'TrialModuleInfoPayload', maxTeachers?: number | null, maxReaders?: number | null, bookCollection?: string | null } | null, module?: { __typename?: 'Module', name?: string | null } | null } | null> | null, billingAddress?: { __typename?: 'Address', address?: string | null, city?: string | null, complement?: string | null, country?: string | null, neighborhood?: string | null, number?: string | null, state?: string | null, zipcode?: string | null } | null } | null };

export type GetImportationListingQueryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  clientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetImportationListingQueryQuery = { __typename?: 'RootQueryType', importationListing?: Array<{ __typename?: 'Importation', clientName: string, id: number, processType: ImportationProcessType, progress?: number | null, status: ImportationStatus, userName: string } | null> | null };

export type ImportationReviewQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ImportationReviewQuery = { __typename?: 'RootQueryType', importReview?: any | null };

export type ImportationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ImportationQuery = { __typename?: 'RootQueryType', getImportation?: { __typename?: 'Importation', id: number, clientName: string, clientId: number, userName: string, status: ImportationStatus } | null };

export type EntityPublicInfoQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type EntityPublicInfoQuery = { __typename?: 'RootQueryType', entityPublicInfo?: { __typename?: 'EntityPublicInfoPayload', rootName?: string | null, degree?: string | null } | null };

export type GetBooksDeactivationDatesQueryVariables = Exact<{
  slugs: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GetBooksDeactivationDatesQuery = { __typename?: 'RootQueryType', bookRemovalDates?: Array<{ __typename?: 'BookRemovalDate', slug?: string | null, deactivationDate?: string | null } | null> | null };

export type GetRootPublicInfoQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetRootPublicInfoQuery = { __typename?: 'RootQueryType', rootPublicInfo?: { __typename?: 'RootPublicInfoPayload', id?: number | null, name?: string | null } | null };

export type LayersPaymentEntityInfoQueryVariables = Exact<{
  externalTransactionId: Scalars['String']['input'];
}>;


export type LayersPaymentEntityInfoQuery = { __typename?: 'RootQueryType', layersPaymentEntityInfo?: { __typename?: 'LayersPaymentEntityInfo', arvoreEntityId?: number | null, entityName?: string | null } | null };

export type GetUserPublicInfoQueryVariables = Exact<{
  input: UserPublicInfoInput;
}>;


export type GetUserPublicInfoQuery = { __typename?: 'RootQueryType', userPublicInfo?: Array<{ __typename?: 'UserPublicInfoPayload', id?: number | null, name?: string | null, paid?: boolean | null } | null> | null };

export type GetMaximumHierarchyTypeQueryVariables = Exact<{
  rootId: Scalars['Int']['input'];
}>;


export type GetMaximumHierarchyTypeQuery = { __typename?: 'RootQueryType', maximumHierarchyType?: { __typename?: 'HierarchyTypeResult', hierarchyType?: string | null } | null };

export type GetSchoolsByRootQueryVariables = Exact<{
  rootId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
}>;


export type GetSchoolsByRootQuery = { __typename?: 'RootQueryType', schoolsByRoot?: Array<{ __typename?: 'SchoolSummary', id: number, name: string } | null> | null };

export type FindReadersQueryVariables = Exact<{
  entityId: Scalars['Int']['input'];
  term: Scalars['String']['input'];
}>;


export type FindReadersQuery = { __typename?: 'RootQueryType', findReaders?: Array<{ __typename?: 'BasicReader', id: number, name: string } | null> | null };

export type AcquisitionPlansOldQueryVariables = Exact<{ [key: string]: never; }>;


export type AcquisitionPlansOldQuery = { __typename?: 'RootQueryType', acquisitionPlans?: Array<{ __typename?: 'Plan', iconUri?: string | null, id?: number | null, name?: string | null, price?: string | null, productSum?: string | null, type?: PlanType | null, products?: Array<{ __typename?: 'Product', id?: number | null, name?: string | null, price?: string | null } | null> | null } | null> | null };

export type GetForestDropsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetForestDropsDataQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, waterDropDetails?: { __typename?: 'WaterDropDetails', currentDrops?: any | null, dropsPerLevel?: number | null, maxDrops?: number | null, minimumLevel?: number | null, raining?: boolean | null } | null } | null } | null } | null };

export type GetUsersListingQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersListingQuery = { __typename?: 'RootQueryType', totalUsers?: number | null, getUsersListing?: Array<{ __typename?: 'UserSummary', id?: string | null, name?: string | null, email?: string | null, entity?: { __typename?: 'EntitySummary', id?: string | null, name?: string | null } | null, root?: { __typename?: 'EntitySummary', id?: string | null, name?: string | null } | null } | null> | null };

export type GetPublicFeatureTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicFeatureTogglesQuery = { __typename?: 'RootQueryType', publicFeatureToggles?: { __typename?: 'PublicFeatureToggles', comboRedirects?: boolean | null } | null };

export type GetReaderQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetReaderQuery = { __typename?: 'RootQueryType', getReader?: { __typename?: 'GetReaderPayload', id?: number | null, userId?: number | null, name?: string | null, email?: string | null, accessToken?: string | null, permissions?: string | null, accessExpireDate?: string | null, teacherId?: number | null, teacherPermissions?: string | null } | null };

export type IsFavoriteBookQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type IsFavoriteBookQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, isFavoriteBook?: boolean | null } | null } | null };

export type ListOnboardingThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOnboardingThemesQuery = { __typename?: 'RootQueryType', listOnboardingThemes?: Array<{ __typename?: 'OnboardingTheme', id?: number | null, name?: string | null, iconName?: string | null } | null> | null };

export type CollectionsQueryVariables = Exact<{
  contentFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollectionsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, collections?: Array<{ __typename?: 'BookShelf', id?: number | null, name?: string | null, image?: string | null } | null> | null } | null } | null };

export type HighlightsBooksQueryVariables = Exact<{
  contentFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type HighlightsBooksQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, highlightsv2?: Array<{ __typename?: 'BookShelf', id?: number | null, isHighlight?: boolean | null, name?: string | null, bookShelfItems?: Array<{ __typename?: 'BookShelfItem', mascot?: string | null, book?: { __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, language?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null } | null> | null } | null> | null } | null } | null };

export type RelayPaginatedFavoritesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  hasStoryTree?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RelayPaginatedFavoritesQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, relayPaginatedFavorites?: { __typename?: 'BookAsNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'BookAsNodeEdge', cursor?: string | null, node?: { __typename?: 'BookAsNode', id: string, name?: string | null, hasEbook?: boolean | null, hasAudioBook?: boolean | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premiumLock?: boolean | null, lexileLevel?: number | null, language?: string | null, favoritesVisibility: boolean, publisher?: { __typename?: 'Publisher', id?: number | null } | null, activities?: Array<{ __typename?: 'Activity', moduleId?: number | null } | null> | null, qualeActivities?: Array<{ __typename?: 'Activity', moduleId?: number | null } | null> | null, sentirActivities?: Array<{ __typename?: 'Activity', moduleId?: number | null } | null> | null } | null } | null> | null } | null } | null } | null };

export type RelayPaginatedViewedBooksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentFilter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isReading?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  hasStoryTree?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RelayPaginatedViewedBooksQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, relayPaginatedViewedBooks?: { __typename?: 'ViewedBookAsNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'ViewedBookAsNodeEdge', cursor?: string | null, node?: { __typename?: 'ViewedBookAsNode', id: string, book?: { __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null, hasEbook?: boolean | null, language?: string | null, lexileLevel?: number | null } | null } | null } | null> | null } | null } | null } | null };

export type BookLastInteractionQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BookLastInteractionQuery = { __typename?: 'RootQueryType', bookDetails?: { __typename?: 'Book', slug?: string | null, lastInteraction?: string | null } | null };

export type MainScreenSuggestionsv3QueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  contentFilter: Scalars['String']['input'];
  degree?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MainScreenSuggestionsv3Query = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, mainScreenSuggestionsv3?: Array<{ __typename?: 'BookShelf', id?: number | null, name?: string | null, subtitle?: string | null, isHighlight?: boolean | null, bookShelfItems?: Array<{ __typename?: 'BookShelfItem', id?: number | null, book?: { __typename?: 'Book', name?: string | null, author?: string | null, language?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null } | null> | null } | null> | null } | null } | null };

export type GetReaderEnglishLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReaderEnglishLevelsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', listEnglishLevels?: Array<{ __typename?: 'EnglishLevel', type?: EnglishLevelType | null, levels?: Array<string | null> | null } | null> | null } | null } | null };

export type BookQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BookQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, isFavoriteBook?: boolean | null, viewedBookPosition?: any | null } | null } | null, bookDetails?: { __typename?: 'Book', id?: number | null, authors?: Array<string | null> | null, downloadUrl?: string | null, language?: string | null, imprint?: string | null, readingLevel?: number | null, series?: string | null, subtitle?: string | null, edition?: string | null, publicationYear?: number | null, note?: string | null, hasEbook?: boolean | null, disabled?: boolean | null, name?: string | null, author?: string | null, freemium?: boolean | null, slug?: string | null, layout?: string | null, v2ready?: boolean | null, degree?: string | null, manualInfoChecked?: boolean | null, description?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premium?: boolean | null, premiumLock?: boolean | null, rights?: string | null, hasAudioBook?: boolean | null, relatedContents?: Array<{ __typename?: 'RelatedContent', source: RelatedContentSource, url: string } | null> | null, bookCharacteristic?: Array<{ __typename?: 'BookCharacteristic', characteristic?: { __typename?: 'Characteristic', name?: string | null } | null } | null> | null, bookTheme?: Array<{ __typename?: 'BookTheme', theme?: { __typename?: 'Theme', name?: string | null } | null } | null> | null, bookThema?: Array<{ __typename?: 'BookThema', thema?: { __typename?: 'Thema', id?: number | null, name?: string | null, code?: string | null, uiName?: string | null } | null } | null> | null, bookCategory?: Array<{ __typename?: 'BookCategory', category?: { __typename?: 'Category', name: string } | null } | null> | null, customCategories?: Array<{ __typename?: 'CustomCategory', name?: string | null } | null> | null, bookDegree?: Array<{ __typename?: 'BookDegree', degree?: string | null } | null> | null, publisher?: { __typename?: 'Publisher', id?: number | null, name?: string | null } | null, activities?: Array<{ __typename?: 'Activity', id?: number | null, title?: string | null, bookCount?: number | null, isBncc?: boolean | null, estimatedCompletionTimeInSeconds?: number | null, authorInfo?: { __typename?: 'ActivityAuthorInfo', name?: string | null, school?: string | null } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id?: number | null, type?: ExamQuestionType | null, bnccAbilityExamQuestion?: { __typename?: 'BnccAbilityExamQuestion', id?: number | null, bnccAbility?: { __typename?: 'BnccAbility', id?: number | null, code?: string | null } | null } | null } | null> | null, publicDataActivity?: { __typename?: 'PublicDataActivity', id?: number | null, objective?: string | null, degreeRange?: string | null, tags?: Array<{ __typename?: 'Tag', name?: string | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', name?: string | null } | null> | null, generalSkills?: Array<{ __typename?: 'GeneralSkill', description?: string | null } | null> | null } | null, books?: Array<{ __typename?: 'Book', author?: string | null, name?: string | null, imageUrlThumb?: string | null } | null> | null } | null> | null, pendingActivities?: Array<{ __typename?: 'Activity', id?: number | null, title?: string | null, bookCount?: number | null, isBncc?: boolean | null, estimatedCompletionTimeInSeconds?: number | null, authorInfo?: { __typename?: 'ActivityAuthorInfo', name?: string | null, school?: string | null } | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id?: number | null, type?: ExamQuestionType | null, bnccAbilityExamQuestion?: { __typename?: 'BnccAbilityExamQuestion', id?: number | null, bnccAbility?: { __typename?: 'BnccAbility', id?: number | null, code?: string | null } | null } | null } | null> | null, publicDataActivity?: { __typename?: 'PublicDataActivity', id?: number | null, objective?: string | null, degreeRange?: string | null, tags?: Array<{ __typename?: 'Tag', name?: string | null } | null> | null, textualGenres?: Array<{ __typename?: 'TextualGenre', name?: string | null } | null> | null, generalSkills?: Array<{ __typename?: 'GeneralSkill', description?: string | null } | null> | null } | null, books?: Array<{ __typename?: 'Book', author?: string | null, name?: string | null, imageUrlThumb?: string | null } | null> | null } | null> | null, qualeActivities?: Array<{ __typename?: 'Activity', id?: number | null, title?: string | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', type?: ExamQuestionType | null } | null> | null } | null> | null, sentirActivities?: Array<{ __typename?: 'Activity', id?: number | null, title?: string | null, bookCount?: number | null, isBncc?: boolean | null, moduleId?: number | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', type?: ExamQuestionType | null } | null> | null, authorInfo?: { __typename?: 'ActivityAuthorInfo', name?: string | null, school?: string | null } | null, books?: Array<{ __typename?: 'Book', author?: string | null, name?: string | null, imageUrlThumb?: string | null } | null> | null } | null> | null, englishLevels?: Array<{ __typename?: 'EnglishLevel', type?: EnglishLevelType | null, levels?: Array<string | null> | null } | null> | null } | null };

export type BookRecommendedContentQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BookRecommendedContentQuery = { __typename?: 'RootQueryType', bookDetails?: { __typename?: 'Book', slug?: string | null, recommendedContentShelves?: Array<{ __typename?: 'ContentShelf', identifier: ContentShelfIdentifier, title: string, contentShelf: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null> } | null> | null } | null };

export type ArticleRecommendedContentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ArticleRecommendedContentQuery = { __typename?: 'RootQueryType', articleDetails?: { __typename?: 'Article', id: number, recommendedContentShelves?: Array<{ __typename?: 'ContentShelf', identifier: ContentShelfIdentifier, title: string, shelfItems: Array<{ __typename: 'Article', id: number, title?: string | null, author?: string | null, image?: string | null, subtitle?: string | null, publishDate?: string | null, degree?: string | null, categories: Array<{ __typename?: 'Category', name: string, slug: string, iconIdentifier: string } | null> } | { __typename?: 'Book' } | null> } | null> | null } | null };

export type GetActivityQueryVariables = Exact<{
  activityId: Scalars['Int']['input'];
}>;


export type GetActivityQuery = { __typename?: 'RootQueryType', getActivity?: { __typename?: 'Activity', moduleId?: number | null, description?: string | null, id?: number | null, isReady?: boolean | null, submittedToPublic: boolean, title?: string | null, authorInfo?: { __typename?: 'ActivityAuthorInfo', facebookPhoto?: string | null, name?: string | null, school?: string | null } | null, books?: Array<{ __typename?: 'Book', slug?: string | null } | null> | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', id?: number | null } | null> | null, publicDataActivity?: { __typename?: 'PublicDataActivity', id?: number | null } | null } | null };

export type ArticleShelvesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ArticleShelvesQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, articleShelves?: Array<{ __typename?: 'ArticleShelf', id?: number | null, description?: string | null, name?: string | null, articles?: Array<{ __typename?: 'Article', id: number, author?: string | null, degree?: string | null, description?: string | null, subtitle?: string | null, image?: string | null, title?: string | null, publishDate?: string | null, categories: Array<{ __typename?: 'Category', name: string, slug: string, iconIdentifier: string } | null> } | null> | null } | null> | null } | null } | null };

export type ListArticlesQueryVariables = Exact<{
  input: ListArticlesInput;
}>;


export type ListArticlesQuery = { __typename?: 'RootQueryType', listArticles?: { __typename?: 'ListArticlesOutput', totalEntries?: number | null, articles?: Array<{ __typename?: 'Article', id: number, author?: string | null, description?: string | null, image?: string | null, title?: string | null, subtitle?: string | null, publishDate?: string | null, publisher?: string | null, degree?: string | null } | null> | null } | null };

export type ArticleDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ArticleDetailsQuery = { __typename?: 'RootQueryType', articleDetails?: { __typename?: 'Article', author?: string | null, imageAuthor?: string | null, consumptionStatus?: ContentConsumptionStatus | null, coverSubtitle?: string | null, coverTitle?: string | null, degree?: string | null, description?: string | null, htmlContent?: string | null, htmlRaw?: string | null, id: number, image?: string | null, title?: string | null, subtitle?: string | null, publishDate?: string | null, publisher?: string | null, activities?: Array<{ __typename?: 'Activity', id?: number | null, title?: string | null, isBncc?: boolean | null, moduleId?: number | null, examQuestions?: Array<{ __typename?: 'ExamQuestion', type?: ExamQuestionType | null } | null> | null } | null> | null, schoolSegment?: { __typename?: 'SchoolSegment', label: string, abbreviation: string, value: SchoolSegmentValue, recommendedDegrees?: Array<string | null> | null } | null } | null };

export type MagazinesShelfQueryVariables = Exact<{ [key: string]: never; }>;


export type MagazinesShelfQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, magazinesShelf?: Array<{ __typename?: 'NewsstandArticles', date?: string | null, name?: string | null, image?: string | null, url?: string | null, cid?: string | null } | null> | null } | null } | null };

export type NewspaperShelfQueryVariables = Exact<{ [key: string]: never; }>;


export type NewspaperShelfQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, newspaperShelf?: Array<{ __typename?: 'NewsstandArticles', date?: string | null, name?: string | null, image?: string | null, url?: string | null, cid?: string | null } | null> | null } | null } | null };

export type BookRemovalDatesQueryVariables = Exact<{
  slugs: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type BookRemovalDatesQuery = { __typename?: 'RootQueryType', bookRemovalDates?: Array<{ __typename?: 'BookRemovalDate', deactivationDate?: string | null, slug?: string | null } | null> | null };

export type SearchArticlesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  onlyPublished: Scalars['Boolean']['input'];
}>;


export type SearchArticlesQuery = { __typename?: 'RootQueryType', searchArticles?: Array<{ __typename?: 'SearchArticlesPayload', id?: number | null, title?: string | null, image?: string | null, author?: string | null, degree?: string | null, subtitle?: string | null, publishDate?: string | null } | null> | null };

export type SearchBookV3QueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage: Scalars['Int']['input'];
  opts?: InputMaybe<Scalars['String']['input']>;
  hasStoryTree?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchBookV3Query = { __typename?: 'RootQueryType', searchBookV3?: { __typename?: 'SearchResult', searchFilters?: any | null, books?: Array<{ __typename?: 'Book', name?: string | null, slug?: string | null, author?: string | null, degree?: string | null, hasAudioBook?: boolean | null, hasEbook?: boolean | null, isReadingTrail?: boolean | null, language?: string | null, imageUrlThumb?: string | null, imageUrlThumbLow?: string | null, lexileLevel?: number | null, publisher?: { __typename?: 'Publisher', id?: number | null, name?: string | null } | null } | null> | null } | null };

export type ShowBookShelfQueryVariables = Exact<{
  bookShelfId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ShowBookShelfQuery = { __typename?: 'RootQueryType', showBookShelf?: { __typename?: 'BookShelf', name?: string | null, subtitle?: string | null, degreeRange?: string | null, contentFilter?: string | null, isHighlight?: boolean | null, acervoType?: string | null, id?: number | null, type?: string | null, description?: string | null, image?: string | null, bgColor?: string | null, bookShelfItemsCount?: number | null, bookShelfItems?: Array<{ __typename?: 'BookShelfItem', bookShelfId?: number | null, id?: number | null, mascot?: string | null, book?: { __typename?: 'Book', slug?: string | null, name?: string | null, imageUrlThumb?: string | null, author?: string | null, hasAudioBook?: boolean | null, degree?: string | null, premiumLock?: boolean | null } | null } | null> | null } | null };

export type SearchIndependentActivitiesQueryVariables = Exact<{
  input: SearchIndependentActivitiesInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchIndependentActivitiesQuery = { __typename?: 'RootQueryType', searchIndependentActivities?: { __typename?: 'SearchIndependentActivitiesPayload', totalEntries?: number | null, independentActivities?: Array<{ __typename?: 'IndependentActivity', title?: string | null, subtitle?: string | null, readerId?: number | null, entity?: string | null, reader?: string | null, appliedActivityId?: number | null, status?: string | null, grade?: string | null, moduleId?: number | null, articles?: Array<{ __typename?: 'Article', image?: string | null, title?: string | null } | null> | null, books?: Array<{ __typename?: 'Book', imageUrlThumb?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export type ContentIndicationsToMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentIndicationsToMeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', indicationsToMe?: Array<{ __typename?: 'ContentIndication', id?: number | null, dueDate?: any | null, indicatedAt?: any | null, sourceUser?: { __typename?: 'IndicationSourceUser', name?: string | null, isTeacher?: boolean | null, isFamily?: boolean | null } | null, content?: { __typename?: 'Content', identifier?: string | null, type?: string | null, contentDetails?: { __typename?: 'Article', id: number, title?: string | null, image?: string | null, author?: string | null } | { __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, imageUrlThumb?: string | null } | null } | null } | null> | null } | null };

export type ContentIndicationsByMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentIndicationsByMeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', indicationsMadeByMe?: Array<{ __typename?: 'ContentIndication', id?: number | null, dueDate?: any | null, indicatedAt?: any | null, target?: { __typename?: 'IndicationTarget', targetDetails?: { __typename?: 'Entity', name?: string | null } | { __typename?: 'Reader', user?: { __typename?: 'User', name?: string | null } | null } | null } | null, content?: { __typename?: 'Content', identifier?: string | null, type?: string | null, contentDetails?: { __typename?: 'Article', id: number, title?: string | null, image?: string | null, author?: string | null } | { __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, imageUrlThumb?: string | null } | null } | null } | null> | null } | null };

export type SearchAvailableReadersToIndicateQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type SearchAvailableReadersToIndicateQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', entitiesSubtreeFlat?: any | null, searchAvailableReadersToIndicate?: any | null } | null } | null };

export type SearchBookForAutoCompleteQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type SearchBookForAutoCompleteQuery = { __typename?: 'RootQueryType', searchBook?: Array<{ __typename?: 'Book', name?: string | null, slug?: string | null } | null> | null };

export type ListReadersSameDegreeQueryVariables = Exact<{
  term: Scalars['String']['input'];
}>;


export type ListReadersSameDegreeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, listReadersSameDegree?: any | null } | null } | null };

export type ExistsAtLeastOnePlantedTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type ExistsAtLeastOnePlantedTreeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, existsAtLeastOnePlantedTree?: boolean | null } | null } | null };

export type SentirHomeContentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  pillar: Scalars['String']['input'];
}>;


export type SentirHomeContentsQuery = { __typename?: 'RootQueryType', sentirHomeContents?: { __typename?: 'SentirHomeContentsOutput', pillars?: Array<{ __typename?: 'Pillar', name?: string | null, iconUrl?: string | null } | null> | null, courseBooks?: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, language?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null> | null, bookShelves?: Array<{ __typename?: 'SentirBookShelf', id?: number | null, name?: string | null, subtitle?: string | null, active?: boolean | null, description?: string | null, bookShelfItems?: Array<{ __typename?: 'BookShelfItem', id?: number | null, bookShelfId?: number | null, book?: { __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, language?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null } | null> | null } | null> | null, secondaryEmotions?: { __typename?: 'SecondaryEmotions', happy?: Array<{ __typename?: 'SecondaryEmotion', name?: string | null, slug?: string | null } | null> | null, neutral?: Array<{ __typename?: 'SecondaryEmotion', name?: string | null, slug?: string | null } | null> | null, sad?: Array<{ __typename?: 'SecondaryEmotion', name?: string | null, slug?: string | null } | null> | null } | null } | null };

export type SentirHomeContentsOnboardingQueryVariables = Exact<{
  degree?: InputMaybe<Scalars['String']['input']>;
  pillar: Scalars['String']['input'];
}>;


export type SentirHomeContentsOnboardingQuery = { __typename?: 'RootQueryType', sentirHomeContents?: { __typename?: 'SentirHomeContentsOutput', pillars?: Array<{ __typename?: 'Pillar', name?: string | null, iconUrl?: string | null } | null> | null } | null };

export type RecommendedBooksQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendedBooksQuery = { __typename?: 'RootQueryType', recommendedBooks?: Array<{ __typename?: 'Book', slug?: string | null, imageUrlThumbLow?: string | null, imageUrlThumb?: string | null } | null> | null };

export type DataHomeForestQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DataHomeForestQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, coins?: any | null, treeListings?: Array<{ __typename?: 'TreeListing', id?: number | null, image?: string | null } | null> | null, waterDropDetails?: { __typename?: 'WaterDropDetails', currentDrops?: any | null, maxDrops?: number | null } | null } | null } | null } | null };

export type GetUserCoinsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCoinsQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null, coins?: any | null } | null } | null } | null };

export type GetRecommendedBookShelfQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecommendedBookShelfQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, bookSuggestions?: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, language?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null> | null } | null } | null };

export type RunningRecordsBookshelvesQueryQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunningRecordsBookshelvesQueryQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, runningRecordsAssessmentBooksSuggested?: Array<{ __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null, degree?: string | null, imageUrlThumb?: string | null, language?: string | null, premiumLock?: boolean | null, hasAudioBook?: boolean | null } | null> | null } | null } | null };

export type EmotionJournalEntriesByMonthQueryVariables = Exact<{
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  readerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EmotionJournalEntriesByMonthQuery = { __typename?: 'RootQueryType', emotionJournalEntriesByMonth?: Array<{ __typename?: 'JournalEntriesByMonthPayload', date?: string | null, entries?: Array<{ __typename?: 'EmotionJournalEntry', id?: number | null, primaryEmotion?: string | null, note?: string | null, blockNote?: boolean | null, insertedAt?: string | null, emotionColor?: string | null, secondaryEmotions?: Array<{ __typename?: 'SecondaryEmotion', slug?: string | null } | null> | null } | null> | null } | null> | null };

export type SentirSubpagesQueryQueryVariables = Exact<{
  pillar: Scalars['String']['input'];
}>;


export type SentirSubpagesQueryQuery = { __typename?: 'RootQueryType', sentirHomeContents?: { __typename?: 'SentirHomeContentsOutput', subpages?: Array<SentirSubpage | null> | null } | null };

export type TeacherClassesQueryVariables = Exact<{
  degree: Scalars['String']['input'];
}>;


export type TeacherClassesQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, teacherClasses?: Array<{ __typename?: 'Entity', id?: number | null, name?: string | null, degree?: string | null } | null> | null } | null } | null };

export type ClassLastJournalEntriesQueryVariables = Exact<{
  class_id: Scalars['Int']['input'];
}>;


export type ClassLastJournalEntriesQuery = { __typename?: 'RootQueryType', classLastJournalEntries?: Array<{ __typename?: 'ClassLastJournalEntriesPayload', reader?: { __typename?: 'SentirReader', id?: number | null, name?: string | null, lastEntries?: Array<string | null> | null, showAlert?: boolean | null } | null } | null> | null };

export type ConsumedContentContentReportQueryVariables = Exact<{
  contentType: ContentType;
  entityId: Scalars['Int']['input'];
}>;


export type ConsumedContentContentReportQuery = { __typename?: 'RootQueryType', consumedContentsContentReport?: Array<{ __typename?: 'ConsumedContentContentReport', openedCount?: number | null, fullyConsumedCount?: number | null, content?: { __typename?: 'Content', identifier?: string | null, type?: string | null, contentDetails?: { __typename?: 'Article', id: number, title?: string | null, author?: string | null } | { __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null } | null } | null } | null> | null };

export type MostReadContentByTypeQueryVariables = Exact<{
  contentType: ContentType;
}>;


export type MostReadContentByTypeQuery = { __typename?: 'RootQueryType', mostReadContentByType?: Array<{ __typename?: 'ConsumedContentContentReport', fullyConsumedCount?: number | null, content?: { __typename?: 'Content', contentDetails?: { __typename?: 'Article', id: number, author?: string | null, degree?: string | null, description?: string | null, subtitle?: string | null, image?: string | null, title?: string | null, publishDate?: string | null, categories: Array<{ __typename?: 'Category', name: string, slug: string, iconIdentifier: string } | null> } | { __typename?: 'Book', name?: string | null, author?: string | null, slug?: string | null } | null } | null } | null> | null };

export type ContentConsumptionDetailsByEntityAndContentReportQueryVariables = Exact<{
  entityId: Scalars['Int']['input'];
  contentIdentifier: Scalars['String']['input'];
  contentType: ContentType;
}>;


export type ContentConsumptionDetailsByEntityAndContentReportQuery = { __typename?: 'RootQueryType', consumedContentsByEntityAndContentReport?: Array<{ __typename?: 'ConsumedContent', id?: number | null, status?: ContentConsumptionStatus | null, firstConsumedAt?: any | null, user?: { __typename?: 'User', id?: string | null, name?: string | null } | null, content?: { __typename?: 'Content', contentDetails?: { __typename?: 'Article', id: number, title?: string | null, author?: string | null } | { __typename?: 'Book' } | null } | null } | null> | null };

export type ContentConsumptionByUserReportQueryVariables = Exact<{
  readerId: Scalars['Int']['input'];
}>;


export type ContentConsumptionByUserReportQuery = { __typename?: 'RootQueryType', consumedContentsByUserReport?: Array<{ __typename?: 'ConsumedContent', status?: ContentConsumptionStatus | null, firstConsumedAt?: any | null, content?: { __typename?: 'Content', identifier?: string | null, type?: string | null, contentDetails?: { __typename?: 'Article', title?: string | null, author?: string | null } | { __typename?: 'Book', name?: string | null, author?: string | null } | null } | null, user?: { __typename?: 'User', name?: string | null } | null } | null> | null };

export type ArticleSchoolSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ArticleSchoolSegmentsQuery = { __typename?: 'RootQueryType', articleSchoolSegments?: Array<{ __typename?: 'SchoolSegment', value: SchoolSegmentValue, label: string, abbreviation: string, recommendedDegrees?: Array<string | null> | null } | null> | null };

export type ContentCategoryShelvesQueryVariables = Exact<{
  type: ContentType;
}>;


export type ContentCategoryShelvesQuery = { __typename?: 'RootQueryType', contentCategoryShelves: Array<{ __typename?: 'ContentCategoryShelf', iconIdentifier: string, name: string, slug: string, contents: Array<{ __typename?: 'Content', identifier?: string | null, type?: string | null, contentDetails?: { __typename?: 'Article', id: number, title?: string | null, image?: string | null, description?: string | null, subtitle?: string | null, degree?: string | null, publishDate?: string | null, categories: Array<{ __typename?: 'Category', name: string, slug: string, iconIdentifier: string } | null> } | { __typename?: 'Book' } | null } | null> } | null> };

export type ShouldShowCsatFormQueryVariables = Exact<{ [key: string]: never; }>;


export type ShouldShowCsatFormQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, showCsatForm?: boolean | null } | null } | null };

export type ListLevelingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLevelingsQuery = { __typename?: 'RootQueryType', listLevelings?: Array<{ __typename?: 'PartnerLeveling', id?: number | null, name?: string | null } | null> | null };

export type ListBenchmarksQueryVariables = Exact<{
  partnerLevelingId: Scalars['Int']['input'];
}>;


export type ListBenchmarksQuery = { __typename?: 'RootQueryType', listBenchmarks?: Array<{ __typename?: 'BenchmarkItem', id?: number | null, filePath?: string | null, wordCount?: number | null, book?: { __typename?: 'Book', name?: string | null, description?: string | null, slug?: string | null, downloadUrl?: string | null, author?: string | null } | null } | null> | null };

export type GetTeacherClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeacherClassesQuery = { __typename?: 'RootQueryType', getTeacherClasses?: Array<{ __typename?: 'Entity', id?: number | null, name?: string | null, degree?: string | null } | null> | null };

export type GetBlockedBooksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlockedBooksQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, blockedBooks?: Array<string | null> | null } | null } | null };

export type GetAvailableBooksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  readerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAvailableBooksQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, teacher?: { __typename?: 'Teacher', id?: number | null, availableBooks?: Array<{ __typename?: 'Book', name?: string | null, slug?: string | null, author?: string | null, imageUrlThumb?: string | null, degree?: string | null, manualInfoChecked?: boolean | null } | null> | null } | null } | null };

export type GetUserTeacherEntitiesQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserTeacherEntitiesQuery = { __typename?: 'RootQueryType', getUserTeacherEntities?: Array<{ __typename?: 'TeacherEntity', id?: number | null, teacherId?: number | null, entityId?: number | null, entity?: { __typename?: 'EntitySummary', id?: string | null, name?: string | null } | null } | null> | null };

export type FeaturesListFragmentFragment = { __typename?: 'FeatureToggles', sentirEmotionJournalNotes?: boolean | null, sentirEmotionJournalSecondaryEmotions?: boolean | null, layoutThema?: boolean | null, entityUsersOnlineStatus?: boolean | null, paranaNotice?: boolean | null, reportsV2?: boolean | null, enableReadingFluencyReapplication?: boolean | null, reportReadingGoalsEnabled?: boolean | null, usageTime?: boolean | null, intermediaryPageRecommendations?: boolean | null, useImportationAiBased?: boolean | null, comprehensionQuestions?: boolean | null, useNewImportationProcess?: boolean | null, hideNews?: boolean | null, pagarmeV5Enabled?: boolean | null, showPressreaderIconOnHeader?: boolean | null, newPermissionsManagement?: boolean | null, readingFluencySimplifiedResults?: boolean | null, askTheBook?: boolean | null, readingReportV2?: boolean | null, autoCorrectionWithAi?: boolean | null, fluencyEmptyState?: boolean | null, newReadingAssessmentV2?: boolean | null, doActivityV2?: boolean | null, bookReadingRecord?: boolean | null, ottoAiEnabled?: boolean | null, hiddenLeagueName?: boolean | null, suspiciousActivityUsersSeduc?: boolean | null, adminPanelV2Rollout?: boolean | null, sharedReadingEnabled?: boolean | null, storyTree?: boolean | null, maple?: boolean | null, runningRecords?: boolean | null, rewind?: boolean | null, onboardingAlunoV3?: boolean | null, onboardingTeacher?: boolean | null, activitiesV3?: boolean | null, readAloudV2Leveling?: boolean | null, summaryReportV2?: boolean | null };

export type OnboardingV2TutorialFragmentFragment = { __typename?: 'Tutorial', id?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null, userId?: number | null };

export type GamificationOnboardingTutorialFragmentFragment = { __typename?: 'Tutorial', id?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null, userId?: number | null };

export type AdminPanelV2OnboardingTutorialFragmentFragment = { __typename?: 'Tutorial', id?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null, userId?: number | null };

export type UserBasicInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBasicInfosQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, requiresPayment?: boolean | null, hasPendingPaymentTransactions?: boolean | null, email?: string | null, apiToken?: string | null, accessToken?: string | null, firstAccess?: boolean | null, name?: string | null, permissions?: Array<string | null> | null, username?: string | null, products?: Array<string | null> | null, filledOnboardingJobInfo?: boolean | null, isAdmin?: boolean | null, suspicionScore?: number | null, jobPositions?: Array<JobPosition | null> | null, jobAreas?: Array<JobArea | null> | null, teacher?: { __typename?: 'Teacher', id?: number | null, blockedBooks?: Array<string | null> | null, permissions?: string | null, role?: string | null, teacherEntities?: any | null, isFamilyPaying?: boolean | null, showFlag?: boolean | null, updateStatus?: { __typename?: 'TeacherUpdateStatus', skips?: number | null, updated?: boolean | null, emailConfirmed?: boolean | null } | null, root?: { __typename?: 'Entity', id?: number | null, name?: string | null, requirePayment?: boolean | null, segment?: string | null } | null, englishTrial?: { __typename?: 'EnglishTrailDetails', endDate?: string | null, startDate?: string | null, remainingDays?: number | null } | null } | null, reader?: { __typename?: 'Reader', id?: string | null, permissions?: string | null, accessDaysLeft?: number | null, contentFilters?: Array<string | null> | null, canAccessOnboarding?: boolean | null, acervos: Array<string | null>, paymentStatus?: PaymentStatus | null, root?: { __typename?: 'Entity', id?: number | null, name?: string | null, paymentInfo?: any | null, daysLeft?: number | null, paymentPrice?: any | null, requirePayment?: boolean | null, type?: string | null, rootAcervo?: string | null, maxSimultaneousUsers?: number | null, currentSimultaneousUsers?: number | null, nextReaderSpotAvailable?: string | null, segment?: string | null, expirationDate?: string | null } | null, entity?: { __typename?: 'Entity', id?: number | null, ancestry?: string | null, requirePayment?: boolean | null, degree?: string | null, name?: string | null, type?: string | null, expirationDate?: string | null, paymentInfo?: any | null, contractInfo?: { __typename?: 'EntityContractInfo', type?: string | null, usesContractModule?: boolean | null, features?: Array<any | null> | null } | null } | null, testPeriods?: Array<{ __typename?: 'TestPeriod', id?: number | null, createdAt?: string | null, durationInDays?: number | null, readerId?: number | null, type?: TestPeriodType | null } | null> | null } | null, featureToggles?: { __typename?: 'FeatureToggles', sentirEmotionJournalNotes?: boolean | null, sentirEmotionJournalSecondaryEmotions?: boolean | null, layoutThema?: boolean | null, entityUsersOnlineStatus?: boolean | null, paranaNotice?: boolean | null, reportsV2?: boolean | null, enableReadingFluencyReapplication?: boolean | null, reportReadingGoalsEnabled?: boolean | null, usageTime?: boolean | null, intermediaryPageRecommendations?: boolean | null, useImportationAiBased?: boolean | null, comprehensionQuestions?: boolean | null, useNewImportationProcess?: boolean | null, hideNews?: boolean | null, pagarmeV5Enabled?: boolean | null, showPressreaderIconOnHeader?: boolean | null, newPermissionsManagement?: boolean | null, readingFluencySimplifiedResults?: boolean | null, askTheBook?: boolean | null, readingReportV2?: boolean | null, autoCorrectionWithAi?: boolean | null, fluencyEmptyState?: boolean | null, newReadingAssessmentV2?: boolean | null, doActivityV2?: boolean | null, bookReadingRecord?: boolean | null, ottoAiEnabled?: boolean | null, hiddenLeagueName?: boolean | null, suspiciousActivityUsersSeduc?: boolean | null, adminPanelV2Rollout?: boolean | null, sharedReadingEnabled?: boolean | null, storyTree?: boolean | null, maple?: boolean | null, runningRecords?: boolean | null, rewind?: boolean | null, onboardingAlunoV3?: boolean | null, onboardingTeacher?: boolean | null, activitiesV3?: boolean | null, readAloudV2Leveling?: boolean | null, summaryReportV2?: boolean | null } | null, onboardingV2Tutorial?: { __typename?: 'Tutorial', id?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null, userId?: number | null } | null, gamificationOnboardingTutorial?: { __typename?: 'Tutorial', id?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null, userId?: number | null } | null, adminPanelV2OnboardingTutorial?: { __typename?: 'Tutorial', id?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null, userId?: number | null } | null } | null };

export type GetChangedPasswordStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChangedPasswordStatusQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, changedPassword?: boolean | null } | null };

export type GamificationOnboardingTutorialQueryVariables = Exact<{ [key: string]: never; }>;


export type GamificationOnboardingTutorialQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, gamificationOnboardingTutorial?: { __typename?: 'Tutorial', id?: number | null, interactions?: number | null, name?: string | null, state?: string | null, updatedAt?: string | null, userId?: number | null } | null } | null };

export type NotificationsPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsPreferencesQuery = { __typename?: 'RootQueryType', notificationsPreferences?: { __typename?: 'NotificationPreferencesPayload', weeklyReadingReport?: boolean | null } | null };

export type GetUserFeatureTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFeatureTogglesQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, featureToggles?: { __typename?: 'FeatureToggles', sentirEmotionJournalNotes?: boolean | null, sentirEmotionJournalSecondaryEmotions?: boolean | null, layoutThema?: boolean | null, entityUsersOnlineStatus?: boolean | null, paranaNotice?: boolean | null, reportsV2?: boolean | null, enableReadingFluencyReapplication?: boolean | null, reportReadingGoalsEnabled?: boolean | null, usageTime?: boolean | null, intermediaryPageRecommendations?: boolean | null, useImportationAiBased?: boolean | null, comprehensionQuestions?: boolean | null, useNewImportationProcess?: boolean | null, hideNews?: boolean | null, pagarmeV5Enabled?: boolean | null, showPressreaderIconOnHeader?: boolean | null, newPermissionsManagement?: boolean | null, readingFluencySimplifiedResults?: boolean | null, askTheBook?: boolean | null, readingReportV2?: boolean | null, autoCorrectionWithAi?: boolean | null, fluencyEmptyState?: boolean | null, newReadingAssessmentV2?: boolean | null, doActivityV2?: boolean | null, bookReadingRecord?: boolean | null, ottoAiEnabled?: boolean | null, hiddenLeagueName?: boolean | null, suspiciousActivityUsersSeduc?: boolean | null, adminPanelV2Rollout?: boolean | null, sharedReadingEnabled?: boolean | null, storyTree?: boolean | null, maple?: boolean | null, runningRecords?: boolean | null, rewind?: boolean | null, onboardingAlunoV3?: boolean | null, onboardingTeacher?: boolean | null, activitiesV3?: boolean | null, readAloudV2Leveling?: boolean | null, summaryReportV2?: boolean | null } | null } | null };

export type GetReaderReadingGoalStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReaderReadingGoalStatusQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, readingGoalStatus?: { __typename?: 'ReadingGoalStatus', goal: number, readingTime: number } | null } | null } | null };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserQuery = { __typename?: 'RootQueryType', getUser?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, accessToken?: string | null, isAdmin?: boolean | null, reader?: { __typename?: 'Reader', id?: string | null, rootId?: number | null, entity?: { __typename?: 'Entity', id?: number | null, name?: string | null } | null } | null } | null };

export type GetUserJobPositionsAndRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserJobPositionsAndRolesQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, jobPositions?: Array<JobPosition | null> | null, jobAreas?: Array<JobArea | null> | null, roles?: Array<string | null> | null } | null };

export type GetReaderForestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReaderForestQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, reader?: { __typename?: 'Reader', id?: string | null, forest?: { __typename?: 'Forest', id?: number | null } | null } | null } | null };

export type BookCoverThumbQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BookCoverThumbQuery = { __typename?: 'RootQueryType', bookDetails?: { __typename?: 'Book', slug?: string | null, imageUrlThumb?: string | null } | null };

export type VisibilityFavoriteBookFragment = { __typename?: 'BookAsNode', favoritesVisibility: boolean };

export type UpdateTeacherRunningRecordsPreferenceMutationVariables = Exact<{
  entities_ids: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateTeacherRunningRecordsPreferenceMutation = { __typename?: 'RootMutationType', updateTeacherRunningRecordsPreference?: { __typename?: 'TeacherPreferencePayload', teacherId?: number | null, entitiesIdsSelected?: any | null } | null };

export type ListLevelingsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLevelingsQueryQuery = { __typename?: 'RootQueryType', listLevelings?: Array<{ __typename?: 'PartnerLeveling', id?: number | null, name?: string | null } | null> | null };

export type SendRunningRecordsResultMutationVariables = Exact<{
  readerUserId: Scalars['Int']['input'];
  newLevelingId: Scalars['Int']['input'];
}>;


export type SendRunningRecordsResultMutation = { __typename?: 'RootMutationType', sendRunningRecordsResult?: string | null };

export type GetTeacherEntitiesSelectedQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeacherEntitiesSelectedQueryQuery = { __typename?: 'RootQueryType', getTeacherEntitiesSelected?: Array<{ __typename?: 'EntitySelectedItem', id?: number | null, name?: string | null } | null> | null };

export type SetTeacherCommentsAnswerMutationVariables = Exact<{
  appliedActivityId: Scalars['Int']['input'];
  readerId: Scalars['Int']['input'];
  examQuestionId: Scalars['Int']['input'];
  comments: Scalars['String']['input'];
  answerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetTeacherCommentsAnswerMutation = { __typename?: 'RootMutationType', setTeacherCommentsAnswer?: { __typename?: 'AppliedActivityAnswer', id?: number | null, answers?: Array<{ __typename?: 'Answer', id?: number | null, examQuestionId?: number | null, teacherComments?: string | null } | null> | null } | null };

export type SetGradeAnswerMutationVariables = Exact<{
  answerId: Scalars['Int']['input'];
  grade: Scalars['String']['input'];
}>;


export type SetGradeAnswerMutation = { __typename?: 'RootMutationType', setGradeAnswer?: { __typename?: 'AppliedActivityAnswer', id?: number | null, answers?: Array<{ __typename?: 'Answer', id?: number | null, examQuestionId?: number | null, grade?: string | null } | null> | null } | null };

export type ShowBookCollectionQueryQueryVariables = Exact<{
  bookShelfId: Scalars['Int']['input'];
}>;


export type ShowBookCollectionQueryQuery = { __typename?: 'RootQueryType', showBookShelf?: { __typename?: 'BookShelf', id?: number | null, name?: string | null, image?: string | null, bgColor?: string | null, description?: string | null, bookShelfItemsCount?: number | null, books?: Array<{ __typename?: 'Book', author?: string | null, degree?: string | null, description?: string | null, edition?: string | null, imageUrlIntermediaria?: string | null, imageUrlThumb?: string | null, name?: string | null, readingLevel?: number | null, series?: string | null, slug?: string | null, subtitle?: string | null, hasAudioBook?: boolean | null } | null> | null } | null };

export const BookNavigationFieldsFragmentDoc = gql`
    fragment bookNavigationFields on Book {
  name
  author
  freemium
  slug
  language
  layout
  v2ready
  degree
  manualInfoChecked
  description
  imageUrlIntermediaria
  imageUrlThumb
  imageUrlThumbLow
  premium
  freemium
  premiumLock
  rights
  hasAudioBook
}
    `;
export const FeaturesListFragmentFragmentDoc = gql`
    fragment featuresListFragment on FeatureToggles {
  sentirEmotionJournalNotes
  sentirEmotionJournalSecondaryEmotions
  layoutThema
  entityUsersOnlineStatus
  paranaNotice
  reportsV2
  enableReadingFluencyReapplication
  reportReadingGoalsEnabled
  usageTime
  intermediaryPageRecommendations
  useImportationAiBased
  comprehensionQuestions
  useNewImportationProcess
  hideNews
  pagarmeV5Enabled
  showPressreaderIconOnHeader
  newPermissionsManagement
  readingFluencySimplifiedResults
  askTheBook
  readingReportV2
  autoCorrectionWithAi
  fluencyEmptyState
  newReadingAssessmentV2
  doActivityV2
  bookReadingRecord
  ottoAiEnabled
  hiddenLeagueName
  suspiciousActivityUsersSeduc
  adminPanelV2Rollout
  sharedReadingEnabled
  storyTree
  maple
  runningRecords
  rewind
  onboardingAlunoV3
  onboardingTeacher
  activitiesV3
  readAloudV2Leveling
  summaryReportV2
}
    `;
export const OnboardingV2TutorialFragmentFragmentDoc = gql`
    fragment onboardingV2TutorialFragment on Tutorial {
  id
  interactions
  name
  state
  updatedAt
  userId
}
    `;
export const GamificationOnboardingTutorialFragmentFragmentDoc = gql`
    fragment gamificationOnboardingTutorialFragment on Tutorial {
  id
  interactions
  name
  state
  updatedAt
  userId
}
    `;
export const AdminPanelV2OnboardingTutorialFragmentFragmentDoc = gql`
    fragment adminPanelV2OnboardingTutorialFragment on Tutorial {
  id
  interactions
  name
  state
  updatedAt
  userId
}
    `;
export const VisibilityFavoriteBookFragmentDoc = gql`
    fragment VisibilityFavoriteBook on BookAsNode {
  favoritesVisibility @client
}
    `;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(email: $email)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ValidatePasswordResetDocument = gql`
    mutation ValidatePasswordReset($email: String!, $token: String!) {
  validatePasswordReset(email: $email, token: $token) {
    id
    name
    email
  }
}
    `;
export type ValidatePasswordResetMutationFn = Apollo.MutationFunction<ValidatePasswordResetMutation, ValidatePasswordResetMutationVariables>;

/**
 * __useValidatePasswordResetMutation__
 *
 * To run a mutation, you first call `useValidatePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePasswordResetMutation, { data, loading, error }] = useValidatePasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidatePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePasswordResetMutation, ValidatePasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePasswordResetMutation, ValidatePasswordResetMutationVariables>(ValidatePasswordResetDocument, options);
      }
export type ValidatePasswordResetMutationHookResult = ReturnType<typeof useValidatePasswordResetMutation>;
export type ValidatePasswordResetMutationResult = Apollo.MutationResult<ValidatePasswordResetMutation>;
export type ValidatePasswordResetMutationOptions = Apollo.BaseMutationOptions<ValidatePasswordResetMutation, ValidatePasswordResetMutationVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($email: String!, $token: String!, $newPassword: String!) {
  passwordReset(email: $email, token: $token, newPassword: $newPassword)
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const FinalGradeAppliedActivityAnswerDocument = gql`
    mutation FinalGradeAppliedActivityAnswer($finalGrade: String!, $appliedActivityId: Int!, $readerId: Int!) {
  setFinalGradeAppliedActivityAnswer(
    finalGrade: $finalGrade
    appliedActivityId: $appliedActivityId
    readerId: $readerId
  ) {
    id
  }
}
    `;
export type FinalGradeAppliedActivityAnswerMutationFn = Apollo.MutationFunction<FinalGradeAppliedActivityAnswerMutation, FinalGradeAppliedActivityAnswerMutationVariables>;

/**
 * __useFinalGradeAppliedActivityAnswerMutation__
 *
 * To run a mutation, you first call `useFinalGradeAppliedActivityAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalGradeAppliedActivityAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalGradeAppliedActivityAnswerMutation, { data, loading, error }] = useFinalGradeAppliedActivityAnswerMutation({
 *   variables: {
 *      finalGrade: // value for 'finalGrade'
 *      appliedActivityId: // value for 'appliedActivityId'
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useFinalGradeAppliedActivityAnswerMutation(baseOptions?: Apollo.MutationHookOptions<FinalGradeAppliedActivityAnswerMutation, FinalGradeAppliedActivityAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalGradeAppliedActivityAnswerMutation, FinalGradeAppliedActivityAnswerMutationVariables>(FinalGradeAppliedActivityAnswerDocument, options);
      }
export type FinalGradeAppliedActivityAnswerMutationHookResult = ReturnType<typeof useFinalGradeAppliedActivityAnswerMutation>;
export type FinalGradeAppliedActivityAnswerMutationResult = Apollo.MutationResult<FinalGradeAppliedActivityAnswerMutation>;
export type FinalGradeAppliedActivityAnswerMutationOptions = Apollo.BaseMutationOptions<FinalGradeAppliedActivityAnswerMutation, FinalGradeAppliedActivityAnswerMutationVariables>;
export const SendApplicationToReaderDocument = gql`
    mutation SendApplicationToReader($appliedActivityAnswerId: Int!) {
  sendApplicationToReader(appliedActivityAnswerId: $appliedActivityAnswerId) {
    id
  }
}
    `;
export type SendApplicationToReaderMutationFn = Apollo.MutationFunction<SendApplicationToReaderMutation, SendApplicationToReaderMutationVariables>;

/**
 * __useSendApplicationToReaderMutation__
 *
 * To run a mutation, you first call `useSendApplicationToReaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendApplicationToReaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendApplicationToReaderMutation, { data, loading, error }] = useSendApplicationToReaderMutation({
 *   variables: {
 *      appliedActivityAnswerId: // value for 'appliedActivityAnswerId'
 *   },
 * });
 */
export function useSendApplicationToReaderMutation(baseOptions?: Apollo.MutationHookOptions<SendApplicationToReaderMutation, SendApplicationToReaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendApplicationToReaderMutation, SendApplicationToReaderMutationVariables>(SendApplicationToReaderDocument, options);
      }
export type SendApplicationToReaderMutationHookResult = ReturnType<typeof useSendApplicationToReaderMutation>;
export type SendApplicationToReaderMutationResult = Apollo.MutationResult<SendApplicationToReaderMutation>;
export type SendApplicationToReaderMutationOptions = Apollo.BaseMutationOptions<SendApplicationToReaderMutation, SendApplicationToReaderMutationVariables>;
export const SetDiscursiveAnswerDocument = gql`
    mutation setDiscursiveAnswer($appliedActivityAnswerId: Int!, $examQuestionId: Int!, $discursiveAnswer: String!) {
  setDiscursiveAnswer(
    appliedActivityAnswerId: $appliedActivityAnswerId
    examQuestionId: $examQuestionId
    discursiveAnswer: $discursiveAnswer
  ) {
    id
    answerDiscursive
    examQuestionId
    teacherComments
    grade
    isCorrect
    correctAnswerId
  }
}
    `;
export type SetDiscursiveAnswerMutationFn = Apollo.MutationFunction<SetDiscursiveAnswerMutation, SetDiscursiveAnswerMutationVariables>;

/**
 * __useSetDiscursiveAnswerMutation__
 *
 * To run a mutation, you first call `useSetDiscursiveAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDiscursiveAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDiscursiveAnswerMutation, { data, loading, error }] = useSetDiscursiveAnswerMutation({
 *   variables: {
 *      appliedActivityAnswerId: // value for 'appliedActivityAnswerId'
 *      examQuestionId: // value for 'examQuestionId'
 *      discursiveAnswer: // value for 'discursiveAnswer'
 *   },
 * });
 */
export function useSetDiscursiveAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetDiscursiveAnswerMutation, SetDiscursiveAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDiscursiveAnswerMutation, SetDiscursiveAnswerMutationVariables>(SetDiscursiveAnswerDocument, options);
      }
export type SetDiscursiveAnswerMutationHookResult = ReturnType<typeof useSetDiscursiveAnswerMutation>;
export type SetDiscursiveAnswerMutationResult = Apollo.MutationResult<SetDiscursiveAnswerMutation>;
export type SetDiscursiveAnswerMutationOptions = Apollo.BaseMutationOptions<SetDiscursiveAnswerMutation, SetDiscursiveAnswerMutationVariables>;
export const SendActivityForCorrectionDocument = gql`
    mutation sendActivityForCorrection($appliedActivityAnswerId: Int!, $readerId: Int!) {
  sendActivityForCorrection(
    appliedActivityAnswerId: $appliedActivityAnswerId
    readerId: $readerId
  ) {
    id
  }
}
    `;
export type SendActivityForCorrectionMutationFn = Apollo.MutationFunction<SendActivityForCorrectionMutation, SendActivityForCorrectionMutationVariables>;

/**
 * __useSendActivityForCorrectionMutation__
 *
 * To run a mutation, you first call `useSendActivityForCorrectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendActivityForCorrectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendActivityForCorrectionMutation, { data, loading, error }] = useSendActivityForCorrectionMutation({
 *   variables: {
 *      appliedActivityAnswerId: // value for 'appliedActivityAnswerId'
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useSendActivityForCorrectionMutation(baseOptions?: Apollo.MutationHookOptions<SendActivityForCorrectionMutation, SendActivityForCorrectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendActivityForCorrectionMutation, SendActivityForCorrectionMutationVariables>(SendActivityForCorrectionDocument, options);
      }
export type SendActivityForCorrectionMutationHookResult = ReturnType<typeof useSendActivityForCorrectionMutation>;
export type SendActivityForCorrectionMutationResult = Apollo.MutationResult<SendActivityForCorrectionMutation>;
export type SendActivityForCorrectionMutationOptions = Apollo.BaseMutationOptions<SendActivityForCorrectionMutation, SendActivityForCorrectionMutationVariables>;
export const BootstrapActivityForReaderDocument = gql`
    mutation BootstrapActivityForReader($id: Int!, $type: BootstrapActivityForReaderTypes!) {
  bootstrapActivityForReader(id: $id, type: $type) {
    appliedActivityId
  }
}
    `;
export type BootstrapActivityForReaderMutationFn = Apollo.MutationFunction<BootstrapActivityForReaderMutation, BootstrapActivityForReaderMutationVariables>;

/**
 * __useBootstrapActivityForReaderMutation__
 *
 * To run a mutation, you first call `useBootstrapActivityForReaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBootstrapActivityForReaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bootstrapActivityForReaderMutation, { data, loading, error }] = useBootstrapActivityForReaderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBootstrapActivityForReaderMutation(baseOptions?: Apollo.MutationHookOptions<BootstrapActivityForReaderMutation, BootstrapActivityForReaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BootstrapActivityForReaderMutation, BootstrapActivityForReaderMutationVariables>(BootstrapActivityForReaderDocument, options);
      }
export type BootstrapActivityForReaderMutationHookResult = ReturnType<typeof useBootstrapActivityForReaderMutation>;
export type BootstrapActivityForReaderMutationResult = Apollo.MutationResult<BootstrapActivityForReaderMutation>;
export type BootstrapActivityForReaderMutationOptions = Apollo.BaseMutationOptions<BootstrapActivityForReaderMutation, BootstrapActivityForReaderMutationVariables>;
export const SetChoiceIdAnswerDocument = gql`
    mutation setChoiceIdAnswer($appliedActivityAnswerId: Int!, $examQuestionChoiceId: Int!, $examQuestionId: Int!, $isCorrectionAutomatic: Boolean, $recaptchaToken: String) {
  setChoiceIdAnswer(
    appliedActivityAnswerId: $appliedActivityAnswerId
    examQuestionChoiceId: $examQuestionChoiceId
    examQuestionId: $examQuestionId
    isCorrectionAutomatic: $isCorrectionAutomatic
    recaptchaToken: $recaptchaToken
  ) {
    id
    answerChoiceId
    examQuestionId
    isCorrect
    correctAnswerId
  }
}
    `;
export type SetChoiceIdAnswerMutationFn = Apollo.MutationFunction<SetChoiceIdAnswerMutation, SetChoiceIdAnswerMutationVariables>;

/**
 * __useSetChoiceIdAnswerMutation__
 *
 * To run a mutation, you first call `useSetChoiceIdAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChoiceIdAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChoiceIdAnswerMutation, { data, loading, error }] = useSetChoiceIdAnswerMutation({
 *   variables: {
 *      appliedActivityAnswerId: // value for 'appliedActivityAnswerId'
 *      examQuestionChoiceId: // value for 'examQuestionChoiceId'
 *      examQuestionId: // value for 'examQuestionId'
 *      isCorrectionAutomatic: // value for 'isCorrectionAutomatic'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useSetChoiceIdAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetChoiceIdAnswerMutation, SetChoiceIdAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetChoiceIdAnswerMutation, SetChoiceIdAnswerMutationVariables>(SetChoiceIdAnswerDocument, options);
      }
export type SetChoiceIdAnswerMutationHookResult = ReturnType<typeof useSetChoiceIdAnswerMutation>;
export type SetChoiceIdAnswerMutationResult = Apollo.MutationResult<SetChoiceIdAnswerMutation>;
export type SetChoiceIdAnswerMutationOptions = Apollo.BaseMutationOptions<SetChoiceIdAnswerMutation, SetChoiceIdAnswerMutationVariables>;
export const CreateAppliedActivityAnswerDocument = gql`
    mutation createAppliedActivityAnswer($appliedActivityId: Int!) {
  createAppliedActivityAnswer(appliedActivityId: $appliedActivityId) {
    id
  }
}
    `;
export type CreateAppliedActivityAnswerMutationFn = Apollo.MutationFunction<CreateAppliedActivityAnswerMutation, CreateAppliedActivityAnswerMutationVariables>;

/**
 * __useCreateAppliedActivityAnswerMutation__
 *
 * To run a mutation, you first call `useCreateAppliedActivityAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppliedActivityAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppliedActivityAnswerMutation, { data, loading, error }] = useCreateAppliedActivityAnswerMutation({
 *   variables: {
 *      appliedActivityId: // value for 'appliedActivityId'
 *   },
 * });
 */
export function useCreateAppliedActivityAnswerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppliedActivityAnswerMutation, CreateAppliedActivityAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppliedActivityAnswerMutation, CreateAppliedActivityAnswerMutationVariables>(CreateAppliedActivityAnswerDocument, options);
      }
export type CreateAppliedActivityAnswerMutationHookResult = ReturnType<typeof useCreateAppliedActivityAnswerMutation>;
export type CreateAppliedActivityAnswerMutationResult = Apollo.MutationResult<CreateAppliedActivityAnswerMutation>;
export type CreateAppliedActivityAnswerMutationOptions = Apollo.BaseMutationOptions<CreateAppliedActivityAnswerMutation, CreateAppliedActivityAnswerMutationVariables>;
export const AnswerMatchingPairsV2Document = gql`
    mutation answerMatchingPairsV2($appliedActivityId: Int!, $examQuestionId: Int!, $matchingPairs: [MatchingPairV2Input]!, $isCorrectionAutomatic: Boolean!) {
  answerMatchingPairsV2(
    appliedActivityId: $appliedActivityId
    examQuestionId: $examQuestionId
    matchingPairs: $matchingPairs
    isCorrectionAutomatic: $isCorrectionAutomatic
  ) {
    matchingPairs {
      id
      leftId
      rightId
      isCorrect
    }
  }
}
    `;
export type AnswerMatchingPairsV2MutationFn = Apollo.MutationFunction<AnswerMatchingPairsV2Mutation, AnswerMatchingPairsV2MutationVariables>;

/**
 * __useAnswerMatchingPairsV2Mutation__
 *
 * To run a mutation, you first call `useAnswerMatchingPairsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerMatchingPairsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerMatchingPairsV2Mutation, { data, loading, error }] = useAnswerMatchingPairsV2Mutation({
 *   variables: {
 *      appliedActivityId: // value for 'appliedActivityId'
 *      examQuestionId: // value for 'examQuestionId'
 *      matchingPairs: // value for 'matchingPairs'
 *      isCorrectionAutomatic: // value for 'isCorrectionAutomatic'
 *   },
 * });
 */
export function useAnswerMatchingPairsV2Mutation(baseOptions?: Apollo.MutationHookOptions<AnswerMatchingPairsV2Mutation, AnswerMatchingPairsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerMatchingPairsV2Mutation, AnswerMatchingPairsV2MutationVariables>(AnswerMatchingPairsV2Document, options);
      }
export type AnswerMatchingPairsV2MutationHookResult = ReturnType<typeof useAnswerMatchingPairsV2Mutation>;
export type AnswerMatchingPairsV2MutationResult = Apollo.MutationResult<AnswerMatchingPairsV2Mutation>;
export type AnswerMatchingPairsV2MutationOptions = Apollo.BaseMutationOptions<AnswerMatchingPairsV2Mutation, AnswerMatchingPairsV2MutationVariables>;
export const Teste2Document = gql`
    query Teste2 {
  me {
    id
  }
}
    `;

/**
 * __useTeste2Query__
 *
 * To run a query within a React component, call `useTeste2Query` and pass it any options that fit your needs.
 * When your component renders, `useTeste2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeste2Query({
 *   variables: {
 *   },
 * });
 */
export function useTeste2Query(baseOptions?: Apollo.QueryHookOptions<Teste2Query, Teste2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Teste2Query, Teste2QueryVariables>(Teste2Document, options);
      }
export function useTeste2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Teste2Query, Teste2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Teste2Query, Teste2QueryVariables>(Teste2Document, options);
        }
export function useTeste2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Teste2Query, Teste2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Teste2Query, Teste2QueryVariables>(Teste2Document, options);
        }
export type Teste2QueryHookResult = ReturnType<typeof useTeste2Query>;
export type Teste2LazyQueryHookResult = ReturnType<typeof useTeste2LazyQuery>;
export type Teste2SuspenseQueryHookResult = ReturnType<typeof useTeste2SuspenseQuery>;
export type Teste2QueryResult = Apollo.QueryResult<Teste2Query, Teste2QueryVariables>;
export const Teste3Document = gql`
    query Teste3 {
  me {
    id
  }
}
    `;

/**
 * __useTeste3Query__
 *
 * To run a query within a React component, call `useTeste3Query` and pass it any options that fit your needs.
 * When your component renders, `useTeste3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeste3Query({
 *   variables: {
 *   },
 * });
 */
export function useTeste3Query(baseOptions?: Apollo.QueryHookOptions<Teste3Query, Teste3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Teste3Query, Teste3QueryVariables>(Teste3Document, options);
      }
export function useTeste3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Teste3Query, Teste3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Teste3Query, Teste3QueryVariables>(Teste3Document, options);
        }
export function useTeste3SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Teste3Query, Teste3QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Teste3Query, Teste3QueryVariables>(Teste3Document, options);
        }
export type Teste3QueryHookResult = ReturnType<typeof useTeste3Query>;
export type Teste3LazyQueryHookResult = ReturnType<typeof useTeste3LazyQuery>;
export type Teste3SuspenseQueryHookResult = ReturnType<typeof useTeste3SuspenseQuery>;
export type Teste3QueryResult = Apollo.QueryResult<Teste3Query, Teste3QueryVariables>;
export const CreateArticleDocument = gql`
    mutation createArticle($input: CreateArticleInput!) {
  createArticle(input: $input) {
    id
    title
    subtitle
    imageAuthor
    htmlContent
    degree
    schoolSegment {
      value
      label
      abbreviation
      recommendedDegrees
    }
    coverTitle
    coverSubtitle
    author
  }
}
    `;
export type CreateArticleMutationFn = Apollo.MutationFunction<CreateArticleMutation, CreateArticleMutationVariables>;

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArticleMutation(baseOptions?: Apollo.MutationHookOptions<CreateArticleMutation, CreateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArticleMutation, CreateArticleMutationVariables>(CreateArticleDocument, options);
      }
export type CreateArticleMutationHookResult = ReturnType<typeof useCreateArticleMutation>;
export type CreateArticleMutationResult = Apollo.MutationResult<CreateArticleMutation>;
export type CreateArticleMutationOptions = Apollo.BaseMutationOptions<CreateArticleMutation, CreateArticleMutationVariables>;
export const UpdateArticleDocument = gql`
    mutation updateArticle($input: UpdateArticleInput!) {
  updateArticle(input: $input) {
    id
    title
    subtitle
    imageAuthor
    htmlContent
    degree
    schoolSegment {
      value
      label
      abbreviation
      recommendedDegrees
    }
    coverTitle
    coverSubtitle
    author
  }
}
    `;
export type UpdateArticleMutationFn = Apollo.MutationFunction<UpdateArticleMutation, UpdateArticleMutationVariables>;

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArticleMutation, UpdateArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UpdateArticleDocument, options);
      }
export type UpdateArticleMutationHookResult = ReturnType<typeof useUpdateArticleMutation>;
export type UpdateArticleMutationResult = Apollo.MutationResult<UpdateArticleMutation>;
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<UpdateArticleMutation, UpdateArticleMutationVariables>;
export const QualifyUserJobDescriptionDocument = gql`
    mutation qualifyUserJobDescription($targetUserId: Int!, $jobPositions: [JobPosition]!) {
  qualifyUserJobDescription(
    targetUserId: $targetUserId
    jobPositions: $jobPositions
  ) {
    id
    jobPositions
  }
}
    `;
export type QualifyUserJobDescriptionMutationFn = Apollo.MutationFunction<QualifyUserJobDescriptionMutation, QualifyUserJobDescriptionMutationVariables>;

/**
 * __useQualifyUserJobDescriptionMutation__
 *
 * To run a mutation, you first call `useQualifyUserJobDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQualifyUserJobDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [qualifyUserJobDescriptionMutation, { data, loading, error }] = useQualifyUserJobDescriptionMutation({
 *   variables: {
 *      targetUserId: // value for 'targetUserId'
 *      jobPositions: // value for 'jobPositions'
 *   },
 * });
 */
export function useQualifyUserJobDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<QualifyUserJobDescriptionMutation, QualifyUserJobDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QualifyUserJobDescriptionMutation, QualifyUserJobDescriptionMutationVariables>(QualifyUserJobDescriptionDocument, options);
      }
export type QualifyUserJobDescriptionMutationHookResult = ReturnType<typeof useQualifyUserJobDescriptionMutation>;
export type QualifyUserJobDescriptionMutationResult = Apollo.MutationResult<QualifyUserJobDescriptionMutation>;
export type QualifyUserJobDescriptionMutationOptions = Apollo.BaseMutationOptions<QualifyUserJobDescriptionMutation, QualifyUserJobDescriptionMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation updateUserRole($roleName: String!, $userId: Int!) {
  changeRole(roleName: $roleName, userId: $userId) {
    id
    roles
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      roleName: // value for 'roleName'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const EditManyUsersDocument = gql`
    mutation editManyUsers($file: Upload!, $queryType: String!) {
  editManyUsers(file: $file, queryType: $queryType) {
    name
    email
    accessToken
  }
}
    `;
export type EditManyUsersMutationFn = Apollo.MutationFunction<EditManyUsersMutation, EditManyUsersMutationVariables>;

/**
 * __useEditManyUsersMutation__
 *
 * To run a mutation, you first call `useEditManyUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditManyUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editManyUsersMutation, { data, loading, error }] = useEditManyUsersMutation({
 *   variables: {
 *      file: // value for 'file'
 *      queryType: // value for 'queryType'
 *   },
 * });
 */
export function useEditManyUsersMutation(baseOptions?: Apollo.MutationHookOptions<EditManyUsersMutation, EditManyUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditManyUsersMutation, EditManyUsersMutationVariables>(EditManyUsersDocument, options);
      }
export type EditManyUsersMutationHookResult = ReturnType<typeof useEditManyUsersMutation>;
export type EditManyUsersMutationResult = Apollo.MutationResult<EditManyUsersMutation>;
export type EditManyUsersMutationOptions = Apollo.BaseMutationOptions<EditManyUsersMutation, EditManyUsersMutationVariables>;
export const ListBooksByCsvDocument = gql`
    mutation listBooksByCsv($file: Upload!, $queryType: ListBooksByCsvQueryType!) {
  listBooksByCsv(file: $file, queryType: $queryType) {
    id
    name
    author
    imageUrlThumb
  }
}
    `;
export type ListBooksByCsvMutationFn = Apollo.MutationFunction<ListBooksByCsvMutation, ListBooksByCsvMutationVariables>;

/**
 * __useListBooksByCsvMutation__
 *
 * To run a mutation, you first call `useListBooksByCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListBooksByCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listBooksByCsvMutation, { data, loading, error }] = useListBooksByCsvMutation({
 *   variables: {
 *      file: // value for 'file'
 *      queryType: // value for 'queryType'
 *   },
 * });
 */
export function useListBooksByCsvMutation(baseOptions?: Apollo.MutationHookOptions<ListBooksByCsvMutation, ListBooksByCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListBooksByCsvMutation, ListBooksByCsvMutationVariables>(ListBooksByCsvDocument, options);
      }
export type ListBooksByCsvMutationHookResult = ReturnType<typeof useListBooksByCsvMutation>;
export type ListBooksByCsvMutationResult = Apollo.MutationResult<ListBooksByCsvMutation>;
export type ListBooksByCsvMutationOptions = Apollo.BaseMutationOptions<ListBooksByCsvMutation, ListBooksByCsvMutationVariables>;
export const AddBooksToCollectionDocument = gql`
    mutation addBooksToCollection($collectionId: Int!, $bookIds: [Int!]!) {
  addBooksToCollection(collectionId: $collectionId, bookIds: $bookIds)
}
    `;
export type AddBooksToCollectionMutationFn = Apollo.MutationFunction<AddBooksToCollectionMutation, AddBooksToCollectionMutationVariables>;

/**
 * __useAddBooksToCollectionMutation__
 *
 * To run a mutation, you first call `useAddBooksToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBooksToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBooksToCollectionMutation, { data, loading, error }] = useAddBooksToCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      bookIds: // value for 'bookIds'
 *   },
 * });
 */
export function useAddBooksToCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddBooksToCollectionMutation, AddBooksToCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBooksToCollectionMutation, AddBooksToCollectionMutationVariables>(AddBooksToCollectionDocument, options);
      }
export type AddBooksToCollectionMutationHookResult = ReturnType<typeof useAddBooksToCollectionMutation>;
export type AddBooksToCollectionMutationResult = Apollo.MutationResult<AddBooksToCollectionMutation>;
export type AddBooksToCollectionMutationOptions = Apollo.BaseMutationOptions<AddBooksToCollectionMutation, AddBooksToCollectionMutationVariables>;
export const EditExamQuestionDocument = gql`
    mutation EditExamQuestion($params: [EditExamQuestionPayload]) {
  editExamQuestions(params: $params) {
    examQuestionId
    id
    isCorrect
    statement
  }
}
    `;
export type EditExamQuestionMutationFn = Apollo.MutationFunction<EditExamQuestionMutation, EditExamQuestionMutationVariables>;

/**
 * __useEditExamQuestionMutation__
 *
 * To run a mutation, you first call `useEditExamQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditExamQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editExamQuestionMutation, { data, loading, error }] = useEditExamQuestionMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useEditExamQuestionMutation(baseOptions?: Apollo.MutationHookOptions<EditExamQuestionMutation, EditExamQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditExamQuestionMutation, EditExamQuestionMutationVariables>(EditExamQuestionDocument, options);
      }
export type EditExamQuestionMutationHookResult = ReturnType<typeof useEditExamQuestionMutation>;
export type EditExamQuestionMutationResult = Apollo.MutationResult<EditExamQuestionMutation>;
export type EditExamQuestionMutationOptions = Apollo.BaseMutationOptions<EditExamQuestionMutation, EditExamQuestionMutationVariables>;
export const ProcessOnixFileDocument = gql`
    mutation processOnixFile($isbn: String!) {
  processOnixFile(isbn: $isbn)
}
    `;
export type ProcessOnixFileMutationFn = Apollo.MutationFunction<ProcessOnixFileMutation, ProcessOnixFileMutationVariables>;

/**
 * __useProcessOnixFileMutation__
 *
 * To run a mutation, you first call `useProcessOnixFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessOnixFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processOnixFileMutation, { data, loading, error }] = useProcessOnixFileMutation({
 *   variables: {
 *      isbn: // value for 'isbn'
 *   },
 * });
 */
export function useProcessOnixFileMutation(baseOptions?: Apollo.MutationHookOptions<ProcessOnixFileMutation, ProcessOnixFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessOnixFileMutation, ProcessOnixFileMutationVariables>(ProcessOnixFileDocument, options);
      }
export type ProcessOnixFileMutationHookResult = ReturnType<typeof useProcessOnixFileMutation>;
export type ProcessOnixFileMutationResult = Apollo.MutationResult<ProcessOnixFileMutation>;
export type ProcessOnixFileMutationOptions = Apollo.BaseMutationOptions<ProcessOnixFileMutation, ProcessOnixFileMutationVariables>;
export const ListClientsByCsvDocument = gql`
    mutation listClientsByCsv($file: Upload!) {
  listClientsByCsv(file: $file) {
    id
    name
  }
}
    `;
export type ListClientsByCsvMutationFn = Apollo.MutationFunction<ListClientsByCsvMutation, ListClientsByCsvMutationVariables>;

/**
 * __useListClientsByCsvMutation__
 *
 * To run a mutation, you first call `useListClientsByCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListClientsByCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listClientsByCsvMutation, { data, loading, error }] = useListClientsByCsvMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useListClientsByCsvMutation(baseOptions?: Apollo.MutationHookOptions<ListClientsByCsvMutation, ListClientsByCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListClientsByCsvMutation, ListClientsByCsvMutationVariables>(ListClientsByCsvDocument, options);
      }
export type ListClientsByCsvMutationHookResult = ReturnType<typeof useListClientsByCsvMutation>;
export type ListClientsByCsvMutationResult = Apollo.MutationResult<ListClientsByCsvMutation>;
export type ListClientsByCsvMutationOptions = Apollo.BaseMutationOptions<ListClientsByCsvMutation, ListClientsByCsvMutationVariables>;
export const DeactivateClientsDocument = gql`
    mutation deactivateClients($clientIds: [Int]!) {
  deactivateClients(clientIds: $clientIds) {
    id
    deactivated
    errorMessage
  }
}
    `;
export type DeactivateClientsMutationFn = Apollo.MutationFunction<DeactivateClientsMutation, DeactivateClientsMutationVariables>;

/**
 * __useDeactivateClientsMutation__
 *
 * To run a mutation, you first call `useDeactivateClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateClientsMutation, { data, loading, error }] = useDeactivateClientsMutation({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useDeactivateClientsMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateClientsMutation, DeactivateClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateClientsMutation, DeactivateClientsMutationVariables>(DeactivateClientsDocument, options);
      }
export type DeactivateClientsMutationHookResult = ReturnType<typeof useDeactivateClientsMutation>;
export type DeactivateClientsMutationResult = Apollo.MutationResult<DeactivateClientsMutation>;
export type DeactivateClientsMutationOptions = Apollo.BaseMutationOptions<DeactivateClientsMutation, DeactivateClientsMutationVariables>;
export const CancelApplicationDocument = gql`
    mutation CancelApplication($appliedActivityId: Int!, $readerId: Int!) {
  setAppliedActivityAnswerStatusCancelled(
    appliedActivityId: $appliedActivityId
    readerId: $readerId
  ) {
    id
  }
}
    `;
export type CancelApplicationMutationFn = Apollo.MutationFunction<CancelApplicationMutation, CancelApplicationMutationVariables>;

/**
 * __useCancelApplicationMutation__
 *
 * To run a mutation, you first call `useCancelApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelApplicationMutation, { data, loading, error }] = useCancelApplicationMutation({
 *   variables: {
 *      appliedActivityId: // value for 'appliedActivityId'
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useCancelApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CancelApplicationMutation, CancelApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelApplicationMutation, CancelApplicationMutationVariables>(CancelApplicationDocument, options);
      }
export type CancelApplicationMutationHookResult = ReturnType<typeof useCancelApplicationMutation>;
export type CancelApplicationMutationResult = Apollo.MutationResult<CancelApplicationMutation>;
export type CancelApplicationMutationOptions = Apollo.BaseMutationOptions<CancelApplicationMutation, CancelApplicationMutationVariables>;
export const ApplyAssignmentDocument = gql`
    mutation ApplyAssignment($input: ApplyAssignmentInput!) {
  applyAssignment(input: $input) {
    assignmentId
    status
  }
}
    `;
export type ApplyAssignmentMutationFn = Apollo.MutationFunction<ApplyAssignmentMutation, ApplyAssignmentMutationVariables>;

/**
 * __useApplyAssignmentMutation__
 *
 * To run a mutation, you first call `useApplyAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAssignmentMutation, { data, loading, error }] = useApplyAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<ApplyAssignmentMutation, ApplyAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyAssignmentMutation, ApplyAssignmentMutationVariables>(ApplyAssignmentDocument, options);
      }
export type ApplyAssignmentMutationHookResult = ReturnType<typeof useApplyAssignmentMutation>;
export type ApplyAssignmentMutationResult = Apollo.MutationResult<ApplyAssignmentMutation>;
export type ApplyAssignmentMutationOptions = Apollo.BaseMutationOptions<ApplyAssignmentMutation, ApplyAssignmentMutationVariables>;
export const BoostForestDocument = gql`
    mutation boostForest($coins: Int!, $drops: Int!) {
  boostForest(input: {coins: $coins, drops: $drops}) {
    coins
    waterDropDetails {
      currentDrops
    }
  }
}
    `;
export type BoostForestMutationFn = Apollo.MutationFunction<BoostForestMutation, BoostForestMutationVariables>;

/**
 * __useBoostForestMutation__
 *
 * To run a mutation, you first call `useBoostForestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoostForestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boostForestMutation, { data, loading, error }] = useBoostForestMutation({
 *   variables: {
 *      coins: // value for 'coins'
 *      drops: // value for 'drops'
 *   },
 * });
 */
export function useBoostForestMutation(baseOptions?: Apollo.MutationHookOptions<BoostForestMutation, BoostForestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BoostForestMutation, BoostForestMutationVariables>(BoostForestDocument, options);
      }
export type BoostForestMutationHookResult = ReturnType<typeof useBoostForestMutation>;
export type BoostForestMutationResult = Apollo.MutationResult<BoostForestMutation>;
export type BoostForestMutationOptions = Apollo.BaseMutationOptions<BoostForestMutation, BoostForestMutationVariables>;
export const UpdateContentRecordingEvaluationDocument = gql`
    mutation updateContentRecordingEvaluation($input: UpdateContentRecordingEvaluationInput!) {
  updateContentRecordingEvaluation(input: $input) {
    id
    userId
    contentIdentifier
    contentType
    audioS3Key
    evaluationResponse
    createdAt
    updatedAt
    audioUrl
  }
}
    `;
export type UpdateContentRecordingEvaluationMutationFn = Apollo.MutationFunction<UpdateContentRecordingEvaluationMutation, UpdateContentRecordingEvaluationMutationVariables>;

/**
 * __useUpdateContentRecordingEvaluationMutation__
 *
 * To run a mutation, you first call `useUpdateContentRecordingEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentRecordingEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentRecordingEvaluationMutation, { data, loading, error }] = useUpdateContentRecordingEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentRecordingEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentRecordingEvaluationMutation, UpdateContentRecordingEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentRecordingEvaluationMutation, UpdateContentRecordingEvaluationMutationVariables>(UpdateContentRecordingEvaluationDocument, options);
      }
export type UpdateContentRecordingEvaluationMutationHookResult = ReturnType<typeof useUpdateContentRecordingEvaluationMutation>;
export type UpdateContentRecordingEvaluationMutationResult = Apollo.MutationResult<UpdateContentRecordingEvaluationMutation>;
export type UpdateContentRecordingEvaluationMutationOptions = Apollo.BaseMutationOptions<UpdateContentRecordingEvaluationMutation, UpdateContentRecordingEvaluationMutationVariables>;
export const CreatePaymentTransactionDocument = gql`
    mutation createPaymentTransaction($input: CreatePaymentTransactionInput!) {
  createPaymentTransaction(input: $input) {
    id
    paymentUrl
  }
}
    `;
export type CreatePaymentTransactionMutationFn = Apollo.MutationFunction<CreatePaymentTransactionMutation, CreatePaymentTransactionMutationVariables>;

/**
 * __useCreatePaymentTransactionMutation__
 *
 * To run a mutation, you first call `useCreatePaymentTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentTransactionMutation, { data, loading, error }] = useCreatePaymentTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentTransactionMutation, CreatePaymentTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentTransactionMutation, CreatePaymentTransactionMutationVariables>(CreatePaymentTransactionDocument, options);
      }
export type CreatePaymentTransactionMutationHookResult = ReturnType<typeof useCreatePaymentTransactionMutation>;
export type CreatePaymentTransactionMutationResult = Apollo.MutationResult<CreatePaymentTransactionMutation>;
export type CreatePaymentTransactionMutationOptions = Apollo.BaseMutationOptions<CreatePaymentTransactionMutation, CreatePaymentTransactionMutationVariables>;
export const ActivateLayersUserDocument = gql`
    mutation activateLayersUser($userId: Int!, $entityId: Int!, $degree: String!, $externalTransactionId: String!) {
  activateLayersUser(
    userId: $userId
    entityId: $entityId
    degree: $degree
    externalTransactionId: $externalTransactionId
  ) {
    userId
    entityId
    degree
  }
}
    `;
export type ActivateLayersUserMutationFn = Apollo.MutationFunction<ActivateLayersUserMutation, ActivateLayersUserMutationVariables>;

/**
 * __useActivateLayersUserMutation__
 *
 * To run a mutation, you first call `useActivateLayersUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateLayersUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateLayersUserMutation, { data, loading, error }] = useActivateLayersUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityId: // value for 'entityId'
 *      degree: // value for 'degree'
 *      externalTransactionId: // value for 'externalTransactionId'
 *   },
 * });
 */
export function useActivateLayersUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateLayersUserMutation, ActivateLayersUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateLayersUserMutation, ActivateLayersUserMutationVariables>(ActivateLayersUserDocument, options);
      }
export type ActivateLayersUserMutationHookResult = ReturnType<typeof useActivateLayersUserMutation>;
export type ActivateLayersUserMutationResult = Apollo.MutationResult<ActivateLayersUserMutation>;
export type ActivateLayersUserMutationOptions = Apollo.BaseMutationOptions<ActivateLayersUserMutation, ActivateLayersUserMutationVariables>;
export const JoinGameDocument = gql`
    mutation joinGame {
  joinGame {
    status
  }
}
    `;
export type JoinGameMutationFn = Apollo.MutationFunction<JoinGameMutation, JoinGameMutationVariables>;

/**
 * __useJoinGameMutation__
 *
 * To run a mutation, you first call `useJoinGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinGameMutation, { data, loading, error }] = useJoinGameMutation({
 *   variables: {
 *   },
 * });
 */
export function useJoinGameMutation(baseOptions?: Apollo.MutationHookOptions<JoinGameMutation, JoinGameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinGameMutation, JoinGameMutationVariables>(JoinGameDocument, options);
      }
export type JoinGameMutationHookResult = ReturnType<typeof useJoinGameMutation>;
export type JoinGameMutationResult = Apollo.MutationResult<JoinGameMutation>;
export type JoinGameMutationOptions = Apollo.BaseMutationOptions<JoinGameMutation, JoinGameMutationVariables>;
export const AuthenticateWithProviderDocument = gql`
    mutation AuthenticateWithProvider($deviceId: String!, $deviceType: DeviceType!, $provider: Provider!, $token: String!, $uid: String) {
  authenticateWithProvider(
    deviceId: $deviceId
    deviceType: $deviceType
    provider: $provider
    token: $token
    uid: $uid
  )
}
    `;
export type AuthenticateWithProviderMutationFn = Apollo.MutationFunction<AuthenticateWithProviderMutation, AuthenticateWithProviderMutationVariables>;

/**
 * __useAuthenticateWithProviderMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithProviderMutation, { data, loading, error }] = useAuthenticateWithProviderMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      deviceType: // value for 'deviceType'
 *      provider: // value for 'provider'
 *      token: // value for 'token'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useAuthenticateWithProviderMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithProviderMutation, AuthenticateWithProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithProviderMutation, AuthenticateWithProviderMutationVariables>(AuthenticateWithProviderDocument, options);
      }
export type AuthenticateWithProviderMutationHookResult = ReturnType<typeof useAuthenticateWithProviderMutation>;
export type AuthenticateWithProviderMutationResult = Apollo.MutationResult<AuthenticateWithProviderMutation>;
export type AuthenticateWithProviderMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithProviderMutation, AuthenticateWithProviderMutationVariables>;
export const MoveUserToRootDocument = gql`
    mutation MoveUserToRoot($accessToken: String!) {
  moveUserToRoot(accessToken: $accessToken) {
    id
    name
  }
}
    `;
export type MoveUserToRootMutationFn = Apollo.MutationFunction<MoveUserToRootMutation, MoveUserToRootMutationVariables>;

/**
 * __useMoveUserToRootMutation__
 *
 * To run a mutation, you first call `useMoveUserToRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveUserToRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveUserToRootMutation, { data, loading, error }] = useMoveUserToRootMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useMoveUserToRootMutation(baseOptions?: Apollo.MutationHookOptions<MoveUserToRootMutation, MoveUserToRootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveUserToRootMutation, MoveUserToRootMutationVariables>(MoveUserToRootDocument, options);
      }
export type MoveUserToRootMutationHookResult = ReturnType<typeof useMoveUserToRootMutation>;
export type MoveUserToRootMutationResult = Apollo.MutationResult<MoveUserToRootMutation>;
export type MoveUserToRootMutationOptions = Apollo.BaseMutationOptions<MoveUserToRootMutation, MoveUserToRootMutationVariables>;
export const CreateActivityDocument = gql`
    mutation createActivity($title: String!) {
  createActivity(title: $title) {
    id
    title
    moduleId
  }
}
    `;
export type CreateActivityMutationFn = Apollo.MutationFunction<CreateActivityMutation, CreateActivityMutationVariables>;

/**
 * __useCreateActivityMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityMutation, { data, loading, error }] = useCreateActivityMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateActivityMutation, CreateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActivityMutation, CreateActivityMutationVariables>(CreateActivityDocument, options);
      }
export type CreateActivityMutationHookResult = ReturnType<typeof useCreateActivityMutation>;
export type CreateActivityMutationResult = Apollo.MutationResult<CreateActivityMutation>;
export type CreateActivityMutationOptions = Apollo.BaseMutationOptions<CreateActivityMutation, CreateActivityMutationVariables>;
export const CreateAtualidadesActivityDocument = gql`
    mutation createAtualidadesActivity($title: String!) {
  createAtualidadesActivity(title: $title) {
    id
    title
    moduleId
  }
}
    `;
export type CreateAtualidadesActivityMutationFn = Apollo.MutationFunction<CreateAtualidadesActivityMutation, CreateAtualidadesActivityMutationVariables>;

/**
 * __useCreateAtualidadesActivityMutation__
 *
 * To run a mutation, you first call `useCreateAtualidadesActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAtualidadesActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAtualidadesActivityMutation, { data, loading, error }] = useCreateAtualidadesActivityMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateAtualidadesActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateAtualidadesActivityMutation, CreateAtualidadesActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAtualidadesActivityMutation, CreateAtualidadesActivityMutationVariables>(CreateAtualidadesActivityDocument, options);
      }
export type CreateAtualidadesActivityMutationHookResult = ReturnType<typeof useCreateAtualidadesActivityMutation>;
export type CreateAtualidadesActivityMutationResult = Apollo.MutationResult<CreateAtualidadesActivityMutation>;
export type CreateAtualidadesActivityMutationOptions = Apollo.BaseMutationOptions<CreateAtualidadesActivityMutation, CreateAtualidadesActivityMutationVariables>;
export const AddBookToAtualidadesActivityDocument = gql`
    mutation addBookToAtualidadesActivity($activityId: Int!, $slug: String!) {
  addBookToAtualidadesActivity(activityId: $activityId, slug: $slug) {
    id
    moduleId
    books {
      name
    }
  }
}
    `;
export type AddBookToAtualidadesActivityMutationFn = Apollo.MutationFunction<AddBookToAtualidadesActivityMutation, AddBookToAtualidadesActivityMutationVariables>;

/**
 * __useAddBookToAtualidadesActivityMutation__
 *
 * To run a mutation, you first call `useAddBookToAtualidadesActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBookToAtualidadesActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBookToAtualidadesActivityMutation, { data, loading, error }] = useAddBookToAtualidadesActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAddBookToAtualidadesActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddBookToAtualidadesActivityMutation, AddBookToAtualidadesActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBookToAtualidadesActivityMutation, AddBookToAtualidadesActivityMutationVariables>(AddBookToAtualidadesActivityDocument, options);
      }
export type AddBookToAtualidadesActivityMutationHookResult = ReturnType<typeof useAddBookToAtualidadesActivityMutation>;
export type AddBookToAtualidadesActivityMutationResult = Apollo.MutationResult<AddBookToAtualidadesActivityMutation>;
export type AddBookToAtualidadesActivityMutationOptions = Apollo.BaseMutationOptions<AddBookToAtualidadesActivityMutation, AddBookToAtualidadesActivityMutationVariables>;
export const RemoveBookFromAtualidadesActivityDocument = gql`
    mutation removeBookFromAtualidadesActivity($activityId: Int!, $slug: String!) {
  removeBookFromAtualidadesActivity(activityId: $activityId, slug: $slug) {
    id
    moduleId
    books {
      name
    }
  }
}
    `;
export type RemoveBookFromAtualidadesActivityMutationFn = Apollo.MutationFunction<RemoveBookFromAtualidadesActivityMutation, RemoveBookFromAtualidadesActivityMutationVariables>;

/**
 * __useRemoveBookFromAtualidadesActivityMutation__
 *
 * To run a mutation, you first call `useRemoveBookFromAtualidadesActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookFromAtualidadesActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookFromAtualidadesActivityMutation, { data, loading, error }] = useRemoveBookFromAtualidadesActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRemoveBookFromAtualidadesActivityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBookFromAtualidadesActivityMutation, RemoveBookFromAtualidadesActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBookFromAtualidadesActivityMutation, RemoveBookFromAtualidadesActivityMutationVariables>(RemoveBookFromAtualidadesActivityDocument, options);
      }
export type RemoveBookFromAtualidadesActivityMutationHookResult = ReturnType<typeof useRemoveBookFromAtualidadesActivityMutation>;
export type RemoveBookFromAtualidadesActivityMutationResult = Apollo.MutationResult<RemoveBookFromAtualidadesActivityMutation>;
export type RemoveBookFromAtualidadesActivityMutationOptions = Apollo.BaseMutationOptions<RemoveBookFromAtualidadesActivityMutation, RemoveBookFromAtualidadesActivityMutationVariables>;
export const ApplyIndependentActivityToReaderDocument = gql`
    mutation applyIndependentActivityToReader($activityId: Int!) {
  applyIndependentActivityToReader(activityId: $activityId) {
    activity {
      moduleId
    }
    id
  }
}
    `;
export type ApplyIndependentActivityToReaderMutationFn = Apollo.MutationFunction<ApplyIndependentActivityToReaderMutation, ApplyIndependentActivityToReaderMutationVariables>;

/**
 * __useApplyIndependentActivityToReaderMutation__
 *
 * To run a mutation, you first call `useApplyIndependentActivityToReaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyIndependentActivityToReaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyIndependentActivityToReaderMutation, { data, loading, error }] = useApplyIndependentActivityToReaderMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useApplyIndependentActivityToReaderMutation(baseOptions?: Apollo.MutationHookOptions<ApplyIndependentActivityToReaderMutation, ApplyIndependentActivityToReaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyIndependentActivityToReaderMutation, ApplyIndependentActivityToReaderMutationVariables>(ApplyIndependentActivityToReaderDocument, options);
      }
export type ApplyIndependentActivityToReaderMutationHookResult = ReturnType<typeof useApplyIndependentActivityToReaderMutation>;
export type ApplyIndependentActivityToReaderMutationResult = Apollo.MutationResult<ApplyIndependentActivityToReaderMutation>;
export type ApplyIndependentActivityToReaderMutationOptions = Apollo.BaseMutationOptions<ApplyIndependentActivityToReaderMutation, ApplyIndependentActivityToReaderMutationVariables>;
export const AddArticleToActivityDocument = gql`
    mutation addArticleToActivity($articleId: Int!, $activityId: Int!) {
  addArticleToActivity(articleId: $articleId, activityId: $activityId) {
    article {
      title
    }
    activity {
      title
    }
  }
}
    `;
export type AddArticleToActivityMutationFn = Apollo.MutationFunction<AddArticleToActivityMutation, AddArticleToActivityMutationVariables>;

/**
 * __useAddArticleToActivityMutation__
 *
 * To run a mutation, you first call `useAddArticleToActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArticleToActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArticleToActivityMutation, { data, loading, error }] = useAddArticleToActivityMutation({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useAddArticleToActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddArticleToActivityMutation, AddArticleToActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArticleToActivityMutation, AddArticleToActivityMutationVariables>(AddArticleToActivityDocument, options);
      }
export type AddArticleToActivityMutationHookResult = ReturnType<typeof useAddArticleToActivityMutation>;
export type AddArticleToActivityMutationResult = Apollo.MutationResult<AddArticleToActivityMutation>;
export type AddArticleToActivityMutationOptions = Apollo.BaseMutationOptions<AddArticleToActivityMutation, AddArticleToActivityMutationVariables>;
export const SetActivityDegreeRangeDocument = gql`
    mutation setActivityDegreeRange($activityId: Int!, $degreeRange: [String!]) {
  setActivityDegreeRange(activityId: $activityId, degreeRange: $degreeRange) {
    id
  }
}
    `;
export type SetActivityDegreeRangeMutationFn = Apollo.MutationFunction<SetActivityDegreeRangeMutation, SetActivityDegreeRangeMutationVariables>;

/**
 * __useSetActivityDegreeRangeMutation__
 *
 * To run a mutation, you first call `useSetActivityDegreeRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActivityDegreeRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActivityDegreeRangeMutation, { data, loading, error }] = useSetActivityDegreeRangeMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      degreeRange: // value for 'degreeRange'
 *   },
 * });
 */
export function useSetActivityDegreeRangeMutation(baseOptions?: Apollo.MutationHookOptions<SetActivityDegreeRangeMutation, SetActivityDegreeRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActivityDegreeRangeMutation, SetActivityDegreeRangeMutationVariables>(SetActivityDegreeRangeDocument, options);
      }
export type SetActivityDegreeRangeMutationHookResult = ReturnType<typeof useSetActivityDegreeRangeMutation>;
export type SetActivityDegreeRangeMutationResult = Apollo.MutationResult<SetActivityDegreeRangeMutation>;
export type SetActivityDegreeRangeMutationOptions = Apollo.BaseMutationOptions<SetActivityDegreeRangeMutation, SetActivityDegreeRangeMutationVariables>;
export const CreateExamQuestionDocument = gql`
    mutation createExamQuestion($activityId: Int!, $examQuestionType: ExamQuestionType!, $pageReference: String, $relatedBnccs: [Int]) {
  createExamQuestion(
    activityId: $activityId
    examQuestionType: $examQuestionType
    pageReference: $pageReference
    relatedBnccs: $relatedBnccs
  ) {
    id
  }
}
    `;
export type CreateExamQuestionMutationFn = Apollo.MutationFunction<CreateExamQuestionMutation, CreateExamQuestionMutationVariables>;

/**
 * __useCreateExamQuestionMutation__
 *
 * To run a mutation, you first call `useCreateExamQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExamQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExamQuestionMutation, { data, loading, error }] = useCreateExamQuestionMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      examQuestionType: // value for 'examQuestionType'
 *      pageReference: // value for 'pageReference'
 *      relatedBnccs: // value for 'relatedBnccs'
 *   },
 * });
 */
export function useCreateExamQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateExamQuestionMutation, CreateExamQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExamQuestionMutation, CreateExamQuestionMutationVariables>(CreateExamQuestionDocument, options);
      }
export type CreateExamQuestionMutationHookResult = ReturnType<typeof useCreateExamQuestionMutation>;
export type CreateExamQuestionMutationResult = Apollo.MutationResult<CreateExamQuestionMutation>;
export type CreateExamQuestionMutationOptions = Apollo.BaseMutationOptions<CreateExamQuestionMutation, CreateExamQuestionMutationVariables>;
export const SetExamQuestionStatementDocument = gql`
    mutation setExamQuestionStatement($activityId: Int!, $examQuestionId: Int!, $statement: String!, $expectedAnswer: String) {
  setExamQuestionStatement(
    activityId: $activityId
    examQuestionId: $examQuestionId
    statement: $statement
    expectedAnswer: $expectedAnswer
  ) {
    id
  }
}
    `;
export type SetExamQuestionStatementMutationFn = Apollo.MutationFunction<SetExamQuestionStatementMutation, SetExamQuestionStatementMutationVariables>;

/**
 * __useSetExamQuestionStatementMutation__
 *
 * To run a mutation, you first call `useSetExamQuestionStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExamQuestionStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExamQuestionStatementMutation, { data, loading, error }] = useSetExamQuestionStatementMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      examQuestionId: // value for 'examQuestionId'
 *      statement: // value for 'statement'
 *      expectedAnswer: // value for 'expectedAnswer'
 *   },
 * });
 */
export function useSetExamQuestionStatementMutation(baseOptions?: Apollo.MutationHookOptions<SetExamQuestionStatementMutation, SetExamQuestionStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetExamQuestionStatementMutation, SetExamQuestionStatementMutationVariables>(SetExamQuestionStatementDocument, options);
      }
export type SetExamQuestionStatementMutationHookResult = ReturnType<typeof useSetExamQuestionStatementMutation>;
export type SetExamQuestionStatementMutationResult = Apollo.MutationResult<SetExamQuestionStatementMutation>;
export type SetExamQuestionStatementMutationOptions = Apollo.BaseMutationOptions<SetExamQuestionStatementMutation, SetExamQuestionStatementMutationVariables>;
export const AddChoiceToExamQuestionDocument = gql`
    mutation addChoiceToExamQuestion($examQuestionId: Int!, $isCorrect: Boolean!, $statement: String!) {
  addChoiceToExamQuestion(
    examQuestionId: $examQuestionId
    isCorrect: $isCorrect
    statement: $statement
  ) {
    id
  }
}
    `;
export type AddChoiceToExamQuestionMutationFn = Apollo.MutationFunction<AddChoiceToExamQuestionMutation, AddChoiceToExamQuestionMutationVariables>;

/**
 * __useAddChoiceToExamQuestionMutation__
 *
 * To run a mutation, you first call `useAddChoiceToExamQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChoiceToExamQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChoiceToExamQuestionMutation, { data, loading, error }] = useAddChoiceToExamQuestionMutation({
 *   variables: {
 *      examQuestionId: // value for 'examQuestionId'
 *      isCorrect: // value for 'isCorrect'
 *      statement: // value for 'statement'
 *   },
 * });
 */
export function useAddChoiceToExamQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AddChoiceToExamQuestionMutation, AddChoiceToExamQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChoiceToExamQuestionMutation, AddChoiceToExamQuestionMutationVariables>(AddChoiceToExamQuestionDocument, options);
      }
export type AddChoiceToExamQuestionMutationHookResult = ReturnType<typeof useAddChoiceToExamQuestionMutation>;
export type AddChoiceToExamQuestionMutationResult = Apollo.MutationResult<AddChoiceToExamQuestionMutation>;
export type AddChoiceToExamQuestionMutationOptions = Apollo.BaseMutationOptions<AddChoiceToExamQuestionMutation, AddChoiceToExamQuestionMutationVariables>;
export const SetChoiceStatementDocument = gql`
    mutation setChoiceStatement($activityId: Int!, $examQuestionChoiceId: Int!, $statement: String!) {
  setChoiceStatement(
    activityId: $activityId
    examQuestionChoiceId: $examQuestionChoiceId
    statement: $statement
  ) {
    id
  }
}
    `;
export type SetChoiceStatementMutationFn = Apollo.MutationFunction<SetChoiceStatementMutation, SetChoiceStatementMutationVariables>;

/**
 * __useSetChoiceStatementMutation__
 *
 * To run a mutation, you first call `useSetChoiceStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChoiceStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChoiceStatementMutation, { data, loading, error }] = useSetChoiceStatementMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      examQuestionChoiceId: // value for 'examQuestionChoiceId'
 *      statement: // value for 'statement'
 *   },
 * });
 */
export function useSetChoiceStatementMutation(baseOptions?: Apollo.MutationHookOptions<SetChoiceStatementMutation, SetChoiceStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetChoiceStatementMutation, SetChoiceStatementMutationVariables>(SetChoiceStatementDocument, options);
      }
export type SetChoiceStatementMutationHookResult = ReturnType<typeof useSetChoiceStatementMutation>;
export type SetChoiceStatementMutationResult = Apollo.MutationResult<SetChoiceStatementMutation>;
export type SetChoiceStatementMutationOptions = Apollo.BaseMutationOptions<SetChoiceStatementMutation, SetChoiceStatementMutationVariables>;
export const CreateSentirActivityDocument = gql`
    mutation createSentirActivity($title: String!) {
  createSentirActivity(title: $title) {
    id
    title
    moduleId
  }
}
    `;
export type CreateSentirActivityMutationFn = Apollo.MutationFunction<CreateSentirActivityMutation, CreateSentirActivityMutationVariables>;

/**
 * __useCreateSentirActivityMutation__
 *
 * To run a mutation, you first call `useCreateSentirActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSentirActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSentirActivityMutation, { data, loading, error }] = useCreateSentirActivityMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateSentirActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateSentirActivityMutation, CreateSentirActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSentirActivityMutation, CreateSentirActivityMutationVariables>(CreateSentirActivityDocument, options);
      }
export type CreateSentirActivityMutationHookResult = ReturnType<typeof useCreateSentirActivityMutation>;
export type CreateSentirActivityMutationResult = Apollo.MutationResult<CreateSentirActivityMutation>;
export type CreateSentirActivityMutationOptions = Apollo.BaseMutationOptions<CreateSentirActivityMutation, CreateSentirActivityMutationVariables>;
export const IdentifyMotrixUserDocument = gql`
    mutation identifyMotrixUser($degree: String!, $entityName: String!) {
  identifyMotrixUser(degree: $degree, entityName: $entityName) {
    partnerData
    partnerExternalId
    partnerId
    userId
  }
}
    `;
export type IdentifyMotrixUserMutationFn = Apollo.MutationFunction<IdentifyMotrixUserMutation, IdentifyMotrixUserMutationVariables>;

/**
 * __useIdentifyMotrixUserMutation__
 *
 * To run a mutation, you first call `useIdentifyMotrixUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdentifyMotrixUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [identifyMotrixUserMutation, { data, loading, error }] = useIdentifyMotrixUserMutation({
 *   variables: {
 *      degree: // value for 'degree'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useIdentifyMotrixUserMutation(baseOptions?: Apollo.MutationHookOptions<IdentifyMotrixUserMutation, IdentifyMotrixUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdentifyMotrixUserMutation, IdentifyMotrixUserMutationVariables>(IdentifyMotrixUserDocument, options);
      }
export type IdentifyMotrixUserMutationHookResult = ReturnType<typeof useIdentifyMotrixUserMutation>;
export type IdentifyMotrixUserMutationResult = Apollo.MutationResult<IdentifyMotrixUserMutation>;
export type IdentifyMotrixUserMutationOptions = Apollo.BaseMutationOptions<IdentifyMotrixUserMutation, IdentifyMotrixUserMutationVariables>;
export const CreateNewMotrixRecordingDocument = gql`
    mutation createNewMotrixRecording($partnerExternalId: String!) {
  createNewMotrixRecording(partnerExternalId: $partnerExternalId) {
    recordingId
    imageCategory
    imagePath
    sessionId
  }
}
    `;
export type CreateNewMotrixRecordingMutationFn = Apollo.MutationFunction<CreateNewMotrixRecordingMutation, CreateNewMotrixRecordingMutationVariables>;

/**
 * __useCreateNewMotrixRecordingMutation__
 *
 * To run a mutation, you first call `useCreateNewMotrixRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewMotrixRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewMotrixRecordingMutation, { data, loading, error }] = useCreateNewMotrixRecordingMutation({
 *   variables: {
 *      partnerExternalId: // value for 'partnerExternalId'
 *   },
 * });
 */
export function useCreateNewMotrixRecordingMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewMotrixRecordingMutation, CreateNewMotrixRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewMotrixRecordingMutation, CreateNewMotrixRecordingMutationVariables>(CreateNewMotrixRecordingDocument, options);
      }
export type CreateNewMotrixRecordingMutationHookResult = ReturnType<typeof useCreateNewMotrixRecordingMutation>;
export type CreateNewMotrixRecordingMutationResult = Apollo.MutationResult<CreateNewMotrixRecordingMutation>;
export type CreateNewMotrixRecordingMutationOptions = Apollo.BaseMutationOptions<CreateNewMotrixRecordingMutation, CreateNewMotrixRecordingMutationVariables>;
export const CreateOnboardingReaderThemesDocument = gql`
    mutation createOnboardingReaderThemes($onboardingReaderProfileThemes: [OnboardingReaderProfileThemesInput!]) {
  createOnboardingReaderThemes(
    onboardingReaderProfileThemes: $onboardingReaderProfileThemes
  ) {
    entities {
      onboardingReaderProfileThemeId
    }
  }
}
    `;
export type CreateOnboardingReaderThemesMutationFn = Apollo.MutationFunction<CreateOnboardingReaderThemesMutation, CreateOnboardingReaderThemesMutationVariables>;

/**
 * __useCreateOnboardingReaderThemesMutation__
 *
 * To run a mutation, you first call `useCreateOnboardingReaderThemesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnboardingReaderThemesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnboardingReaderThemesMutation, { data, loading, error }] = useCreateOnboardingReaderThemesMutation({
 *   variables: {
 *      onboardingReaderProfileThemes: // value for 'onboardingReaderProfileThemes'
 *   },
 * });
 */
export function useCreateOnboardingReaderThemesMutation(baseOptions?: Apollo.MutationHookOptions<CreateOnboardingReaderThemesMutation, CreateOnboardingReaderThemesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOnboardingReaderThemesMutation, CreateOnboardingReaderThemesMutationVariables>(CreateOnboardingReaderThemesDocument, options);
      }
export type CreateOnboardingReaderThemesMutationHookResult = ReturnType<typeof useCreateOnboardingReaderThemesMutation>;
export type CreateOnboardingReaderThemesMutationResult = Apollo.MutationResult<CreateOnboardingReaderThemesMutation>;
export type CreateOnboardingReaderThemesMutationOptions = Apollo.BaseMutationOptions<CreateOnboardingReaderThemesMutation, CreateOnboardingReaderThemesMutationVariables>;
export const UpdateOnboardingV2TutorialStateDocument = gql`
    mutation updateOnboardingV2TutorialState($action: TutorialActions!) {
  updateOnboardingV2TutorialState(action: $action) {
    id
    userId
    interactions
    name
    state
  }
}
    `;
export type UpdateOnboardingV2TutorialStateMutationFn = Apollo.MutationFunction<UpdateOnboardingV2TutorialStateMutation, UpdateOnboardingV2TutorialStateMutationVariables>;

/**
 * __useUpdateOnboardingV2TutorialStateMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingV2TutorialStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingV2TutorialStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingV2TutorialStateMutation, { data, loading, error }] = useUpdateOnboardingV2TutorialStateMutation({
 *   variables: {
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateOnboardingV2TutorialStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOnboardingV2TutorialStateMutation, UpdateOnboardingV2TutorialStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOnboardingV2TutorialStateMutation, UpdateOnboardingV2TutorialStateMutationVariables>(UpdateOnboardingV2TutorialStateDocument, options);
      }
export type UpdateOnboardingV2TutorialStateMutationHookResult = ReturnType<typeof useUpdateOnboardingV2TutorialStateMutation>;
export type UpdateOnboardingV2TutorialStateMutationResult = Apollo.MutationResult<UpdateOnboardingV2TutorialStateMutation>;
export type UpdateOnboardingV2TutorialStateMutationOptions = Apollo.BaseMutationOptions<UpdateOnboardingV2TutorialStateMutation, UpdateOnboardingV2TutorialStateMutationVariables>;
export const UpdateGamificationOnboardingTutorialStateDocument = gql`
    mutation updateGamificationOnboardingTutorialState($action: TutorialActions!) {
  updateGamificationOnboardingTutorialState(action: $action) {
    id
    userId
    interactions
    name
    state
    updatedAt
  }
}
    `;
export type UpdateGamificationOnboardingTutorialStateMutationFn = Apollo.MutationFunction<UpdateGamificationOnboardingTutorialStateMutation, UpdateGamificationOnboardingTutorialStateMutationVariables>;

/**
 * __useUpdateGamificationOnboardingTutorialStateMutation__
 *
 * To run a mutation, you first call `useUpdateGamificationOnboardingTutorialStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGamificationOnboardingTutorialStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGamificationOnboardingTutorialStateMutation, { data, loading, error }] = useUpdateGamificationOnboardingTutorialStateMutation({
 *   variables: {
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateGamificationOnboardingTutorialStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGamificationOnboardingTutorialStateMutation, UpdateGamificationOnboardingTutorialStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGamificationOnboardingTutorialStateMutation, UpdateGamificationOnboardingTutorialStateMutationVariables>(UpdateGamificationOnboardingTutorialStateDocument, options);
      }
export type UpdateGamificationOnboardingTutorialStateMutationHookResult = ReturnType<typeof useUpdateGamificationOnboardingTutorialStateMutation>;
export type UpdateGamificationOnboardingTutorialStateMutationResult = Apollo.MutationResult<UpdateGamificationOnboardingTutorialStateMutation>;
export type UpdateGamificationOnboardingTutorialStateMutationOptions = Apollo.BaseMutationOptions<UpdateGamificationOnboardingTutorialStateMutation, UpdateGamificationOnboardingTutorialStateMutationVariables>;
export const UpdateAdminPanelV2OnboardingTutorialStateDocument = gql`
    mutation updateAdminPanelV2OnboardingTutorialState($action: TutorialActions!) {
  updateAdminPanelV2OnboardingTutorialState(action: $action) {
    id
    userId
    interactions
    name
    state
    updatedAt
  }
}
    `;
export type UpdateAdminPanelV2OnboardingTutorialStateMutationFn = Apollo.MutationFunction<UpdateAdminPanelV2OnboardingTutorialStateMutation, UpdateAdminPanelV2OnboardingTutorialStateMutationVariables>;

/**
 * __useUpdateAdminPanelV2OnboardingTutorialStateMutation__
 *
 * To run a mutation, you first call `useUpdateAdminPanelV2OnboardingTutorialStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminPanelV2OnboardingTutorialStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminPanelV2OnboardingTutorialStateMutation, { data, loading, error }] = useUpdateAdminPanelV2OnboardingTutorialStateMutation({
 *   variables: {
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateAdminPanelV2OnboardingTutorialStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminPanelV2OnboardingTutorialStateMutation, UpdateAdminPanelV2OnboardingTutorialStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminPanelV2OnboardingTutorialStateMutation, UpdateAdminPanelV2OnboardingTutorialStateMutationVariables>(UpdateAdminPanelV2OnboardingTutorialStateDocument, options);
      }
export type UpdateAdminPanelV2OnboardingTutorialStateMutationHookResult = ReturnType<typeof useUpdateAdminPanelV2OnboardingTutorialStateMutation>;
export type UpdateAdminPanelV2OnboardingTutorialStateMutationResult = Apollo.MutationResult<UpdateAdminPanelV2OnboardingTutorialStateMutation>;
export type UpdateAdminPanelV2OnboardingTutorialStateMutationOptions = Apollo.BaseMutationOptions<UpdateAdminPanelV2OnboardingTutorialStateMutation, UpdateAdminPanelV2OnboardingTutorialStateMutationVariables>;
export const AssignOnboardingLikedBooksToReaderDocument = gql`
    mutation assignOnboardingLikedBooksToReader($likedBooks: [AssignOnboardingLikedBooksToReaderInput!]) {
  assignOnboardingLikedBooksToReader(likedBooks: $likedBooks) {
    likedBooks {
      slug
      liked
    }
  }
}
    `;
export type AssignOnboardingLikedBooksToReaderMutationFn = Apollo.MutationFunction<AssignOnboardingLikedBooksToReaderMutation, AssignOnboardingLikedBooksToReaderMutationVariables>;

/**
 * __useAssignOnboardingLikedBooksToReaderMutation__
 *
 * To run a mutation, you first call `useAssignOnboardingLikedBooksToReaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignOnboardingLikedBooksToReaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignOnboardingLikedBooksToReaderMutation, { data, loading, error }] = useAssignOnboardingLikedBooksToReaderMutation({
 *   variables: {
 *      likedBooks: // value for 'likedBooks'
 *   },
 * });
 */
export function useAssignOnboardingLikedBooksToReaderMutation(baseOptions?: Apollo.MutationHookOptions<AssignOnboardingLikedBooksToReaderMutation, AssignOnboardingLikedBooksToReaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignOnboardingLikedBooksToReaderMutation, AssignOnboardingLikedBooksToReaderMutationVariables>(AssignOnboardingLikedBooksToReaderDocument, options);
      }
export type AssignOnboardingLikedBooksToReaderMutationHookResult = ReturnType<typeof useAssignOnboardingLikedBooksToReaderMutation>;
export type AssignOnboardingLikedBooksToReaderMutationResult = Apollo.MutationResult<AssignOnboardingLikedBooksToReaderMutation>;
export type AssignOnboardingLikedBooksToReaderMutationOptions = Apollo.BaseMutationOptions<AssignOnboardingLikedBooksToReaderMutation, AssignOnboardingLikedBooksToReaderMutationVariables>;
export const RemoveOnboardingThemesFromReaderDocument = gql`
    mutation removeOnboardingThemesFromReader {
  removeOnboardingThemesFromReader {
    message
    errors
  }
}
    `;
export type RemoveOnboardingThemesFromReaderMutationFn = Apollo.MutationFunction<RemoveOnboardingThemesFromReaderMutation, RemoveOnboardingThemesFromReaderMutationVariables>;

/**
 * __useRemoveOnboardingThemesFromReaderMutation__
 *
 * To run a mutation, you first call `useRemoveOnboardingThemesFromReaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOnboardingThemesFromReaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOnboardingThemesFromReaderMutation, { data, loading, error }] = useRemoveOnboardingThemesFromReaderMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveOnboardingThemesFromReaderMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOnboardingThemesFromReaderMutation, RemoveOnboardingThemesFromReaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOnboardingThemesFromReaderMutation, RemoveOnboardingThemesFromReaderMutationVariables>(RemoveOnboardingThemesFromReaderDocument, options);
      }
export type RemoveOnboardingThemesFromReaderMutationHookResult = ReturnType<typeof useRemoveOnboardingThemesFromReaderMutation>;
export type RemoveOnboardingThemesFromReaderMutationResult = Apollo.MutationResult<RemoveOnboardingThemesFromReaderMutation>;
export type RemoveOnboardingThemesFromReaderMutationOptions = Apollo.BaseMutationOptions<RemoveOnboardingThemesFromReaderMutation, RemoveOnboardingThemesFromReaderMutationVariables>;
export const UnassignOnboardingLikedBooksDocument = gql`
    mutation unassignOnboardingLikedBooks {
  unassignOnboardingLikedBooks {
    message
  }
}
    `;
export type UnassignOnboardingLikedBooksMutationFn = Apollo.MutationFunction<UnassignOnboardingLikedBooksMutation, UnassignOnboardingLikedBooksMutationVariables>;

/**
 * __useUnassignOnboardingLikedBooksMutation__
 *
 * To run a mutation, you first call `useUnassignOnboardingLikedBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignOnboardingLikedBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignOnboardingLikedBooksMutation, { data, loading, error }] = useUnassignOnboardingLikedBooksMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnassignOnboardingLikedBooksMutation(baseOptions?: Apollo.MutationHookOptions<UnassignOnboardingLikedBooksMutation, UnassignOnboardingLikedBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignOnboardingLikedBooksMutation, UnassignOnboardingLikedBooksMutationVariables>(UnassignOnboardingLikedBooksDocument, options);
      }
export type UnassignOnboardingLikedBooksMutationHookResult = ReturnType<typeof useUnassignOnboardingLikedBooksMutation>;
export type UnassignOnboardingLikedBooksMutationResult = Apollo.MutationResult<UnassignOnboardingLikedBooksMutation>;
export type UnassignOnboardingLikedBooksMutationOptions = Apollo.BaseMutationOptions<UnassignOnboardingLikedBooksMutation, UnassignOnboardingLikedBooksMutationVariables>;
export const CreateEmotionJournalEntryDocument = gql`
    mutation createEmotionJournalEntry($primaryEmotion: JournalPrimaryEmotion!, $note: String, $blockNote: Boolean, $secondaryEmotions: [JournalSecondaryEmotion]) {
  createEmotionJournalEntry(
    input: {primaryEmotion: $primaryEmotion, note: $note, blockNote: $blockNote, secondaryEmotions: $secondaryEmotions}
  ) {
    id
    primaryEmotion
    note
    blockNote
    secondaryEmotions {
      slug
    }
    insertedAt
  }
}
    `;
export type CreateEmotionJournalEntryMutationFn = Apollo.MutationFunction<CreateEmotionJournalEntryMutation, CreateEmotionJournalEntryMutationVariables>;

/**
 * __useCreateEmotionJournalEntryMutation__
 *
 * To run a mutation, you first call `useCreateEmotionJournalEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmotionJournalEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmotionJournalEntryMutation, { data, loading, error }] = useCreateEmotionJournalEntryMutation({
 *   variables: {
 *      primaryEmotion: // value for 'primaryEmotion'
 *      note: // value for 'note'
 *      blockNote: // value for 'blockNote'
 *      secondaryEmotions: // value for 'secondaryEmotions'
 *   },
 * });
 */
export function useCreateEmotionJournalEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmotionJournalEntryMutation, CreateEmotionJournalEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmotionJournalEntryMutation, CreateEmotionJournalEntryMutationVariables>(CreateEmotionJournalEntryDocument, options);
      }
export type CreateEmotionJournalEntryMutationHookResult = ReturnType<typeof useCreateEmotionJournalEntryMutation>;
export type CreateEmotionJournalEntryMutationResult = Apollo.MutationResult<CreateEmotionJournalEntryMutation>;
export type CreateEmotionJournalEntryMutationOptions = Apollo.BaseMutationOptions<CreateEmotionJournalEntryMutation, CreateEmotionJournalEntryMutationVariables>;
export const UpdateNotificationPreferencesDocument = gql`
    mutation updateNotificationPreferences($notificationType: NotificationType!) {
  toggleNotificationStatus(input: {notificationType: $notificationType}) {
    weeklyReadingReport
  }
}
    `;
export type UpdateNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;

/**
 * __useUpdateNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferencesMutation, { data, loading, error }] = useUpdateNotificationPreferencesMutation({
 *   variables: {
 *      notificationType: // value for 'notificationType'
 *   },
 * });
 */
export function useUpdateNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>(UpdateNotificationPreferencesDocument, options);
      }
export type UpdateNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;
export const AdminDeleteActivityDocument = gql`
    mutation adminDeleteActivity($activityId: Int!) {
  adminDeleteActivity(activityId: $activityId) {
    id
  }
}
    `;
export type AdminDeleteActivityMutationFn = Apollo.MutationFunction<AdminDeleteActivityMutation, AdminDeleteActivityMutationVariables>;

/**
 * __useAdminDeleteActivityMutation__
 *
 * To run a mutation, you first call `useAdminDeleteActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteActivityMutation, { data, loading, error }] = useAdminDeleteActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useAdminDeleteActivityMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteActivityMutation, AdminDeleteActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteActivityMutation, AdminDeleteActivityMutationVariables>(AdminDeleteActivityDocument, options);
      }
export type AdminDeleteActivityMutationHookResult = ReturnType<typeof useAdminDeleteActivityMutation>;
export type AdminDeleteActivityMutationResult = Apollo.MutationResult<AdminDeleteActivityMutation>;
export type AdminDeleteActivityMutationOptions = Apollo.BaseMutationOptions<AdminDeleteActivityMutation, AdminDeleteActivityMutationVariables>;
export const CreateActivityV2Document = gql`
    mutation createActivityV2($activityQuestions: [CreateExamQuestionInput], $module: ModuleType!, $relatedArticles: [Int], $relatedBooks: [String], $submitPublicApproval: Boolean!, $suggestedDegrees: [ActivityDegree]!, $title: String!) {
  createActivityV2(
    input: {activityQuestions: $activityQuestions, module: $module, relatedArticles: $relatedArticles, relatedBooks: $relatedBooks, submitPublicApproval: $submitPublicApproval, suggestedDegrees: $suggestedDegrees, title: $title}
  ) {
    id
    title
    moduleId
    articles {
      id
    }
    books {
      name
      degree
    }
    examQuestions {
      id
      statement
      type
      examQuestionChoices {
        statement
        isCorrect
      }
    }
  }
}
    `;
export type CreateActivityV2MutationFn = Apollo.MutationFunction<CreateActivityV2Mutation, CreateActivityV2MutationVariables>;

/**
 * __useCreateActivityV2Mutation__
 *
 * To run a mutation, you first call `useCreateActivityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityV2Mutation, { data, loading, error }] = useCreateActivityV2Mutation({
 *   variables: {
 *      activityQuestions: // value for 'activityQuestions'
 *      module: // value for 'module'
 *      relatedArticles: // value for 'relatedArticles'
 *      relatedBooks: // value for 'relatedBooks'
 *      submitPublicApproval: // value for 'submitPublicApproval'
 *      suggestedDegrees: // value for 'suggestedDegrees'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateActivityV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateActivityV2Mutation, CreateActivityV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActivityV2Mutation, CreateActivityV2MutationVariables>(CreateActivityV2Document, options);
      }
export type CreateActivityV2MutationHookResult = ReturnType<typeof useCreateActivityV2Mutation>;
export type CreateActivityV2MutationResult = Apollo.MutationResult<CreateActivityV2Mutation>;
export type CreateActivityV2MutationOptions = Apollo.BaseMutationOptions<CreateActivityV2Mutation, CreateActivityV2MutationVariables>;
export const EditActivityDocument = gql`
    mutation editActivity($activityId: Int!, $activityQuestions: [EditExamQuestionInput], $module: ModuleType!, $relatedArticles: [Int], $relatedBooks: [String], $submitPublicApproval: Boolean!, $suggestedDegrees: [ActivityDegree], $title: String!) {
  editActivity(
    input: {activityId: $activityId, activityQuestions: $activityQuestions, module: $module, relatedArticles: $relatedArticles, relatedBooks: $relatedBooks, submitPublicApproval: $submitPublicApproval, suggestedDegrees: $suggestedDegrees, title: $title}
  ) {
    id
    title
    moduleId
    articles {
      id
    }
    books {
      name
      degree
      slug
    }
    examQuestions {
      id
      statement
      type
      examQuestionChoices {
        statement
        isCorrect
      }
    }
  }
}
    `;
export type EditActivityMutationFn = Apollo.MutationFunction<EditActivityMutation, EditActivityMutationVariables>;

/**
 * __useEditActivityMutation__
 *
 * To run a mutation, you first call `useEditActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editActivityMutation, { data, loading, error }] = useEditActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      activityQuestions: // value for 'activityQuestions'
 *      module: // value for 'module'
 *      relatedArticles: // value for 'relatedArticles'
 *      relatedBooks: // value for 'relatedBooks'
 *      submitPublicApproval: // value for 'submitPublicApproval'
 *      suggestedDegrees: // value for 'suggestedDegrees'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useEditActivityMutation(baseOptions?: Apollo.MutationHookOptions<EditActivityMutation, EditActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditActivityMutation, EditActivityMutationVariables>(EditActivityDocument, options);
      }
export type EditActivityMutationHookResult = ReturnType<typeof useEditActivityMutation>;
export type EditActivityMutationResult = Apollo.MutationResult<EditActivityMutation>;
export type EditActivityMutationOptions = Apollo.BaseMutationOptions<EditActivityMutation, EditActivityMutationVariables>;
export const CreateContentIndicationsDocument = gql`
    mutation CreateContentIndications($input: CreateContentIndicationInput!) {
  createContentIndications(input: $input) {
    sourceUser {
      id
      name
      isTeacher
    }
    target {
      id
      type
    }
    content {
      identifier
      type
    }
    dueDate
    indicatedAt
  }
}
    `;
export type CreateContentIndicationsMutationFn = Apollo.MutationFunction<CreateContentIndicationsMutation, CreateContentIndicationsMutationVariables>;

/**
 * __useCreateContentIndicationsMutation__
 *
 * To run a mutation, you first call `useCreateContentIndicationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentIndicationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentIndicationsMutation, { data, loading, error }] = useCreateContentIndicationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentIndicationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentIndicationsMutation, CreateContentIndicationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentIndicationsMutation, CreateContentIndicationsMutationVariables>(CreateContentIndicationsDocument, options);
      }
export type CreateContentIndicationsMutationHookResult = ReturnType<typeof useCreateContentIndicationsMutation>;
export type CreateContentIndicationsMutationResult = Apollo.MutationResult<CreateContentIndicationsMutation>;
export type CreateContentIndicationsMutationOptions = Apollo.BaseMutationOptions<CreateContentIndicationsMutation, CreateContentIndicationsMutationVariables>;
export const RemoveContentIndicationDocument = gql`
    mutation removeContentIndication($indicationId: Int!) {
  removeContentIndication(contentIndicationId: $indicationId) {
    id
  }
}
    `;
export type RemoveContentIndicationMutationFn = Apollo.MutationFunction<RemoveContentIndicationMutation, RemoveContentIndicationMutationVariables>;

/**
 * __useRemoveContentIndicationMutation__
 *
 * To run a mutation, you first call `useRemoveContentIndicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentIndicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentIndicationMutation, { data, loading, error }] = useRemoveContentIndicationMutation({
 *   variables: {
 *      indicationId: // value for 'indicationId'
 *   },
 * });
 */
export function useRemoveContentIndicationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContentIndicationMutation, RemoveContentIndicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContentIndicationMutation, RemoveContentIndicationMutationVariables>(RemoveContentIndicationDocument, options);
      }
export type RemoveContentIndicationMutationHookResult = ReturnType<typeof useRemoveContentIndicationMutation>;
export type RemoveContentIndicationMutationResult = Apollo.MutationResult<RemoveContentIndicationMutation>;
export type RemoveContentIndicationMutationOptions = Apollo.BaseMutationOptions<RemoveContentIndicationMutation, RemoveContentIndicationMutationVariables>;
export const ConsumeContentDocument = gql`
    mutation ConsumeContent($input: ConsumeContentInput!) {
  consumeContent(input: $input) {
    rewards {
      type
      amount
    }
  }
}
    `;
export type ConsumeContentMutationFn = Apollo.MutationFunction<ConsumeContentMutation, ConsumeContentMutationVariables>;

/**
 * __useConsumeContentMutation__
 *
 * To run a mutation, you first call `useConsumeContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeContentMutation, { data, loading, error }] = useConsumeContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumeContentMutation(baseOptions?: Apollo.MutationHookOptions<ConsumeContentMutation, ConsumeContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumeContentMutation, ConsumeContentMutationVariables>(ConsumeContentDocument, options);
      }
export type ConsumeContentMutationHookResult = ReturnType<typeof useConsumeContentMutation>;
export type ConsumeContentMutationResult = Apollo.MutationResult<ConsumeContentMutation>;
export type ConsumeContentMutationOptions = Apollo.BaseMutationOptions<ConsumeContentMutation, ConsumeContentMutationVariables>;
export const SendFeatureFeedbackDocument = gql`
    mutation sendFeatureFeedback($feedback: String!) {
  sendFeatureFeedback(feedback: $feedback)
}
    `;
export type SendFeatureFeedbackMutationFn = Apollo.MutationFunction<SendFeatureFeedbackMutation, SendFeatureFeedbackMutationVariables>;

/**
 * __useSendFeatureFeedbackMutation__
 *
 * To run a mutation, you first call `useSendFeatureFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeatureFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeatureFeedbackMutation, { data, loading, error }] = useSendFeatureFeedbackMutation({
 *   variables: {
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSendFeatureFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SendFeatureFeedbackMutation, SendFeatureFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFeatureFeedbackMutation, SendFeatureFeedbackMutationVariables>(SendFeatureFeedbackDocument, options);
      }
export type SendFeatureFeedbackMutationHookResult = ReturnType<typeof useSendFeatureFeedbackMutation>;
export type SendFeatureFeedbackMutationResult = Apollo.MutationResult<SendFeatureFeedbackMutation>;
export type SendFeatureFeedbackMutationOptions = Apollo.BaseMutationOptions<SendFeatureFeedbackMutation, SendFeatureFeedbackMutationVariables>;
export const CreateOrUpdateReadingGoalsDocument = gql`
    mutation CreateOrUpdateReadingGoals($goal: Int!, $entityIds: [Int!]!) {
  createOrUpdateReadingGoals(input: {goal: $goal, entityIds: $entityIds}) {
    readingGoals {
      goal
      startDate
      entityId
    }
  }
}
    `;
export type CreateOrUpdateReadingGoalsMutationFn = Apollo.MutationFunction<CreateOrUpdateReadingGoalsMutation, CreateOrUpdateReadingGoalsMutationVariables>;

/**
 * __useCreateOrUpdateReadingGoalsMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateReadingGoalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateReadingGoalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateReadingGoalsMutation, { data, loading, error }] = useCreateOrUpdateReadingGoalsMutation({
 *   variables: {
 *      goal: // value for 'goal'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useCreateOrUpdateReadingGoalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateReadingGoalsMutation, CreateOrUpdateReadingGoalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateReadingGoalsMutation, CreateOrUpdateReadingGoalsMutationVariables>(CreateOrUpdateReadingGoalsDocument, options);
      }
export type CreateOrUpdateReadingGoalsMutationHookResult = ReturnType<typeof useCreateOrUpdateReadingGoalsMutation>;
export type CreateOrUpdateReadingGoalsMutationResult = Apollo.MutationResult<CreateOrUpdateReadingGoalsMutation>;
export type CreateOrUpdateReadingGoalsMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateReadingGoalsMutation, CreateOrUpdateReadingGoalsMutationVariables>;
export const DeactivateReadingGoalDocument = gql`
    mutation DeactivateReadingGoal($entityId: Int!) {
  deactivateReadingGoal(input: {entityId: $entityId}) {
    readingGoals {
      goal
      startDate
      endDate
      entityId
    }
  }
}
    `;
export type DeactivateReadingGoalMutationFn = Apollo.MutationFunction<DeactivateReadingGoalMutation, DeactivateReadingGoalMutationVariables>;

/**
 * __useDeactivateReadingGoalMutation__
 *
 * To run a mutation, you first call `useDeactivateReadingGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateReadingGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateReadingGoalMutation, { data, loading, error }] = useDeactivateReadingGoalMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useDeactivateReadingGoalMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateReadingGoalMutation, DeactivateReadingGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateReadingGoalMutation, DeactivateReadingGoalMutationVariables>(DeactivateReadingGoalDocument, options);
      }
export type DeactivateReadingGoalMutationHookResult = ReturnType<typeof useDeactivateReadingGoalMutation>;
export type DeactivateReadingGoalMutationResult = Apollo.MutationResult<DeactivateReadingGoalMutation>;
export type DeactivateReadingGoalMutationOptions = Apollo.BaseMutationOptions<DeactivateReadingGoalMutation, DeactivateReadingGoalMutationVariables>;
export const GetReadingGoalsByEntitiesDocument = gql`
    query GetReadingGoalsByEntities($entityIds: [Int!]!) {
  readingGoals(entityIds: $entityIds) {
    goal
    startDate
    entityId
  }
}
    `;

/**
 * __useGetReadingGoalsByEntitiesQuery__
 *
 * To run a query within a React component, call `useGetReadingGoalsByEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadingGoalsByEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReadingGoalsByEntitiesQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetReadingGoalsByEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetReadingGoalsByEntitiesQuery, GetReadingGoalsByEntitiesQueryVariables> & ({ variables: GetReadingGoalsByEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReadingGoalsByEntitiesQuery, GetReadingGoalsByEntitiesQueryVariables>(GetReadingGoalsByEntitiesDocument, options);
      }
export function useGetReadingGoalsByEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReadingGoalsByEntitiesQuery, GetReadingGoalsByEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReadingGoalsByEntitiesQuery, GetReadingGoalsByEntitiesQueryVariables>(GetReadingGoalsByEntitiesDocument, options);
        }
export function useGetReadingGoalsByEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReadingGoalsByEntitiesQuery, GetReadingGoalsByEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReadingGoalsByEntitiesQuery, GetReadingGoalsByEntitiesQueryVariables>(GetReadingGoalsByEntitiesDocument, options);
        }
export type GetReadingGoalsByEntitiesQueryHookResult = ReturnType<typeof useGetReadingGoalsByEntitiesQuery>;
export type GetReadingGoalsByEntitiesLazyQueryHookResult = ReturnType<typeof useGetReadingGoalsByEntitiesLazyQuery>;
export type GetReadingGoalsByEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetReadingGoalsByEntitiesSuspenseQuery>;
export type GetReadingGoalsByEntitiesQueryResult = Apollo.QueryResult<GetReadingGoalsByEntitiesQuery, GetReadingGoalsByEntitiesQueryVariables>;
export const GetReadingGoalReportDocument = gql`
    query GetReadingGoalReport($entityId: Int!, $page: Int!, $limit: Int!, $referenceDate: DateTime!) {
  readingGoalsReport(
    entityId: $entityId
    page: $page
    limit: $limit
    referenceDate: $referenceDate
    orderBy: BY_READING_TIME
  ) {
    readingGoal {
      goal
      startDate
    }
    totalCount
    users {
      name
      readingTime
    }
  }
}
    `;

/**
 * __useGetReadingGoalReportQuery__
 *
 * To run a query within a React component, call `useGetReadingGoalReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadingGoalReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReadingGoalReportQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function useGetReadingGoalReportQuery(baseOptions: Apollo.QueryHookOptions<GetReadingGoalReportQuery, GetReadingGoalReportQueryVariables> & ({ variables: GetReadingGoalReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReadingGoalReportQuery, GetReadingGoalReportQueryVariables>(GetReadingGoalReportDocument, options);
      }
export function useGetReadingGoalReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReadingGoalReportQuery, GetReadingGoalReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReadingGoalReportQuery, GetReadingGoalReportQueryVariables>(GetReadingGoalReportDocument, options);
        }
export function useGetReadingGoalReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReadingGoalReportQuery, GetReadingGoalReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReadingGoalReportQuery, GetReadingGoalReportQueryVariables>(GetReadingGoalReportDocument, options);
        }
export type GetReadingGoalReportQueryHookResult = ReturnType<typeof useGetReadingGoalReportQuery>;
export type GetReadingGoalReportLazyQueryHookResult = ReturnType<typeof useGetReadingGoalReportLazyQuery>;
export type GetReadingGoalReportSuspenseQueryHookResult = ReturnType<typeof useGetReadingGoalReportSuspenseQuery>;
export type GetReadingGoalReportQueryResult = Apollo.QueryResult<GetReadingGoalReportQuery, GetReadingGoalReportQueryVariables>;
export const UploadReadingFluencyAudioDocument = gql`
    mutation uploadReadingFluencyAudio($file: Upload!, $userId: Int!) {
  uploadReadingFluencyAudio(input: {file: $file, userId: $userId})
}
    `;
export type UploadReadingFluencyAudioMutationFn = Apollo.MutationFunction<UploadReadingFluencyAudioMutation, UploadReadingFluencyAudioMutationVariables>;

/**
 * __useUploadReadingFluencyAudioMutation__
 *
 * To run a mutation, you first call `useUploadReadingFluencyAudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadReadingFluencyAudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadReadingFluencyAudioMutation, { data, loading, error }] = useUploadReadingFluencyAudioMutation({
 *   variables: {
 *      file: // value for 'file'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUploadReadingFluencyAudioMutation(baseOptions?: Apollo.MutationHookOptions<UploadReadingFluencyAudioMutation, UploadReadingFluencyAudioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadReadingFluencyAudioMutation, UploadReadingFluencyAudioMutationVariables>(UploadReadingFluencyAudioDocument, options);
      }
export type UploadReadingFluencyAudioMutationHookResult = ReturnType<typeof useUploadReadingFluencyAudioMutation>;
export type UploadReadingFluencyAudioMutationResult = Apollo.MutationResult<UploadReadingFluencyAudioMutation>;
export type UploadReadingFluencyAudioMutationOptions = Apollo.BaseMutationOptions<UploadReadingFluencyAudioMutation, UploadReadingFluencyAudioMutationVariables>;
export const RescheduleSubmissionDateForReadingFluencyAssessmentDocument = gql`
    mutation rescheduleSubmissionDateForReadingFluencyAssessment($assessmentId: Int!, $newEndDate: Date!) {
  rescheduleSubmissionDateForReadingFluencyAssessment(
    input: {assessmentId: $assessmentId, newEndDate: $newEndDate}
  )
}
    `;
export type RescheduleSubmissionDateForReadingFluencyAssessmentMutationFn = Apollo.MutationFunction<RescheduleSubmissionDateForReadingFluencyAssessmentMutation, RescheduleSubmissionDateForReadingFluencyAssessmentMutationVariables>;

/**
 * __useRescheduleSubmissionDateForReadingFluencyAssessmentMutation__
 *
 * To run a mutation, you first call `useRescheduleSubmissionDateForReadingFluencyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleSubmissionDateForReadingFluencyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleSubmissionDateForReadingFluencyAssessmentMutation, { data, loading, error }] = useRescheduleSubmissionDateForReadingFluencyAssessmentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      newEndDate: // value for 'newEndDate'
 *   },
 * });
 */
export function useRescheduleSubmissionDateForReadingFluencyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleSubmissionDateForReadingFluencyAssessmentMutation, RescheduleSubmissionDateForReadingFluencyAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleSubmissionDateForReadingFluencyAssessmentMutation, RescheduleSubmissionDateForReadingFluencyAssessmentMutationVariables>(RescheduleSubmissionDateForReadingFluencyAssessmentDocument, options);
      }
export type RescheduleSubmissionDateForReadingFluencyAssessmentMutationHookResult = ReturnType<typeof useRescheduleSubmissionDateForReadingFluencyAssessmentMutation>;
export type RescheduleSubmissionDateForReadingFluencyAssessmentMutationResult = Apollo.MutationResult<RescheduleSubmissionDateForReadingFluencyAssessmentMutation>;
export type RescheduleSubmissionDateForReadingFluencyAssessmentMutationOptions = Apollo.BaseMutationOptions<RescheduleSubmissionDateForReadingFluencyAssessmentMutation, RescheduleSubmissionDateForReadingFluencyAssessmentMutationVariables>;
export const ChooseTeacherClassDocument = gql`
    mutation ChooseTeacherClass($classId: Int!) {
  chooseTeacherClass(classId: $classId)
}
    `;
export type ChooseTeacherClassMutationFn = Apollo.MutationFunction<ChooseTeacherClassMutation, ChooseTeacherClassMutationVariables>;

/**
 * __useChooseTeacherClassMutation__
 *
 * To run a mutation, you first call `useChooseTeacherClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseTeacherClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseTeacherClassMutation, { data, loading, error }] = useChooseTeacherClassMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useChooseTeacherClassMutation(baseOptions?: Apollo.MutationHookOptions<ChooseTeacherClassMutation, ChooseTeacherClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChooseTeacherClassMutation, ChooseTeacherClassMutationVariables>(ChooseTeacherClassDocument, options);
      }
export type ChooseTeacherClassMutationHookResult = ReturnType<typeof useChooseTeacherClassMutation>;
export type ChooseTeacherClassMutationResult = Apollo.MutationResult<ChooseTeacherClassMutation>;
export type ChooseTeacherClassMutationOptions = Apollo.BaseMutationOptions<ChooseTeacherClassMutation, ChooseTeacherClassMutationVariables>;
export const RemoveTeacherClassDocument = gql`
    mutation RemoveTeacherClass($classId: Int!) {
  removeTeacherClass(classId: $classId)
}
    `;
export type RemoveTeacherClassMutationFn = Apollo.MutationFunction<RemoveTeacherClassMutation, RemoveTeacherClassMutationVariables>;

/**
 * __useRemoveTeacherClassMutation__
 *
 * To run a mutation, you first call `useRemoveTeacherClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeacherClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeacherClassMutation, { data, loading, error }] = useRemoveTeacherClassMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useRemoveTeacherClassMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeacherClassMutation, RemoveTeacherClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeacherClassMutation, RemoveTeacherClassMutationVariables>(RemoveTeacherClassDocument, options);
      }
export type RemoveTeacherClassMutationHookResult = ReturnType<typeof useRemoveTeacherClassMutation>;
export type RemoveTeacherClassMutationResult = Apollo.MutationResult<RemoveTeacherClassMutation>;
export type RemoveTeacherClassMutationOptions = Apollo.BaseMutationOptions<RemoveTeacherClassMutation, RemoveTeacherClassMutationVariables>;
export const AddToBlockedBooksDocument = gql`
    mutation addToBlockedBooks($slug: String) {
  addToBlockedBooks: addBookToBlackList(slug: $slug) {
    slug
  }
}
    `;
export type AddToBlockedBooksMutationFn = Apollo.MutationFunction<AddToBlockedBooksMutation, AddToBlockedBooksMutationVariables>;

/**
 * __useAddToBlockedBooksMutation__
 *
 * To run a mutation, you first call `useAddToBlockedBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToBlockedBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToBlockedBooksMutation, { data, loading, error }] = useAddToBlockedBooksMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAddToBlockedBooksMutation(baseOptions?: Apollo.MutationHookOptions<AddToBlockedBooksMutation, AddToBlockedBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToBlockedBooksMutation, AddToBlockedBooksMutationVariables>(AddToBlockedBooksDocument, options);
      }
export type AddToBlockedBooksMutationHookResult = ReturnType<typeof useAddToBlockedBooksMutation>;
export type AddToBlockedBooksMutationResult = Apollo.MutationResult<AddToBlockedBooksMutation>;
export type AddToBlockedBooksMutationOptions = Apollo.BaseMutationOptions<AddToBlockedBooksMutation, AddToBlockedBooksMutationVariables>;
export const RemoveFromBlockedBooksDocument = gql`
    mutation removeFromBlockedBooks($slug: String) {
  removeFromBlockedBooks: removeBookFromBlackList(slug: $slug) {
    slug
  }
}
    `;
export type RemoveFromBlockedBooksMutationFn = Apollo.MutationFunction<RemoveFromBlockedBooksMutation, RemoveFromBlockedBooksMutationVariables>;

/**
 * __useRemoveFromBlockedBooksMutation__
 *
 * To run a mutation, you first call `useRemoveFromBlockedBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromBlockedBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromBlockedBooksMutation, { data, loading, error }] = useRemoveFromBlockedBooksMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRemoveFromBlockedBooksMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromBlockedBooksMutation, RemoveFromBlockedBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromBlockedBooksMutation, RemoveFromBlockedBooksMutationVariables>(RemoveFromBlockedBooksDocument, options);
      }
export type RemoveFromBlockedBooksMutationHookResult = ReturnType<typeof useRemoveFromBlockedBooksMutation>;
export type RemoveFromBlockedBooksMutationResult = Apollo.MutationResult<RemoveFromBlockedBooksMutation>;
export type RemoveFromBlockedBooksMutationOptions = Apollo.BaseMutationOptions<RemoveFromBlockedBooksMutation, RemoveFromBlockedBooksMutationVariables>;
export const ChangeTeacherEntityDocument = gql`
    mutation changeTeacherEntity($entityId: Int!) {
  changeTeacherEntity(entityId: $entityId) {
    id
  }
}
    `;
export type ChangeTeacherEntityMutationFn = Apollo.MutationFunction<ChangeTeacherEntityMutation, ChangeTeacherEntityMutationVariables>;

/**
 * __useChangeTeacherEntityMutation__
 *
 * To run a mutation, you first call `useChangeTeacherEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTeacherEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTeacherEntityMutation, { data, loading, error }] = useChangeTeacherEntityMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useChangeTeacherEntityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTeacherEntityMutation, ChangeTeacherEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTeacherEntityMutation, ChangeTeacherEntityMutationVariables>(ChangeTeacherEntityDocument, options);
      }
export type ChangeTeacherEntityMutationHookResult = ReturnType<typeof useChangeTeacherEntityMutation>;
export type ChangeTeacherEntityMutationResult = Apollo.MutationResult<ChangeTeacherEntityMutation>;
export type ChangeTeacherEntityMutationOptions = Apollo.BaseMutationOptions<ChangeTeacherEntityMutation, ChangeTeacherEntityMutationVariables>;
export const QualifyJobDescriptionDocument = gql`
    mutation qualifyJobDescription($jobPositions: [JobPosition!], $jobAreas: [JobArea!]) {
  qualifyJobDescription(jobPositions: $jobPositions, jobAreas: $jobAreas) {
    id
    jobPositions
    jobAreas
  }
}
    `;
export type QualifyJobDescriptionMutationFn = Apollo.MutationFunction<QualifyJobDescriptionMutation, QualifyJobDescriptionMutationVariables>;

/**
 * __useQualifyJobDescriptionMutation__
 *
 * To run a mutation, you first call `useQualifyJobDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQualifyJobDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [qualifyJobDescriptionMutation, { data, loading, error }] = useQualifyJobDescriptionMutation({
 *   variables: {
 *      jobPositions: // value for 'jobPositions'
 *      jobAreas: // value for 'jobAreas'
 *   },
 * });
 */
export function useQualifyJobDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<QualifyJobDescriptionMutation, QualifyJobDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QualifyJobDescriptionMutation, QualifyJobDescriptionMutationVariables>(QualifyJobDescriptionDocument, options);
      }
export type QualifyJobDescriptionMutationHookResult = ReturnType<typeof useQualifyJobDescriptionMutation>;
export type QualifyJobDescriptionMutationResult = Apollo.MutationResult<QualifyJobDescriptionMutation>;
export type QualifyJobDescriptionMutationOptions = Apollo.BaseMutationOptions<QualifyJobDescriptionMutation, QualifyJobDescriptionMutationVariables>;
export const AddTeacherEntityToUserDocument = gql`
    mutation addTeacherEntityToUser($userId: Int!, $entityIds: [Int!]) {
  addTeacherEntityToUser(userId: $userId, entityIds: $entityIds)
}
    `;
export type AddTeacherEntityToUserMutationFn = Apollo.MutationFunction<AddTeacherEntityToUserMutation, AddTeacherEntityToUserMutationVariables>;

/**
 * __useAddTeacherEntityToUserMutation__
 *
 * To run a mutation, you first call `useAddTeacherEntityToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeacherEntityToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeacherEntityToUserMutation, { data, loading, error }] = useAddTeacherEntityToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useAddTeacherEntityToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddTeacherEntityToUserMutation, AddTeacherEntityToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeacherEntityToUserMutation, AddTeacherEntityToUserMutationVariables>(AddTeacherEntityToUserDocument, options);
      }
export type AddTeacherEntityToUserMutationHookResult = ReturnType<typeof useAddTeacherEntityToUserMutation>;
export type AddTeacherEntityToUserMutationResult = Apollo.MutationResult<AddTeacherEntityToUserMutation>;
export type AddTeacherEntityToUserMutationOptions = Apollo.BaseMutationOptions<AddTeacherEntityToUserMutation, AddTeacherEntityToUserMutationVariables>;
export const SearchParanaPublicActivitiesDocument = gql`
    query SearchParanaPublicActivities($limit: Int, $page: Int, $searchFilters: SearchParanaActivitiesFiltersInput, $searchTerm: String!) {
  searchParanaActivities(
    limit: $limit
    page: $page
    searchFilters: $searchFilters
    searchTerm: $searchTerm
  ) {
    activities {
      books {
        imageUrlThumb
        name
      }
      difficultyLevel
      estimatedCompletionTimeInSeconds
      id
      recommendedDegrees
      tags
      textualGenres
      title
    }
    aggregations {
      name
      values {
        count
        parameterValue
      }
    }
  }
}
    `;

/**
 * __useSearchParanaPublicActivitiesQuery__
 *
 * To run a query within a React component, call `useSearchParanaPublicActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchParanaPublicActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchParanaPublicActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      searchFilters: // value for 'searchFilters'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchParanaPublicActivitiesQuery(baseOptions: Apollo.QueryHookOptions<SearchParanaPublicActivitiesQuery, SearchParanaPublicActivitiesQueryVariables> & ({ variables: SearchParanaPublicActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchParanaPublicActivitiesQuery, SearchParanaPublicActivitiesQueryVariables>(SearchParanaPublicActivitiesDocument, options);
      }
export function useSearchParanaPublicActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchParanaPublicActivitiesQuery, SearchParanaPublicActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchParanaPublicActivitiesQuery, SearchParanaPublicActivitiesQueryVariables>(SearchParanaPublicActivitiesDocument, options);
        }
export function useSearchParanaPublicActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchParanaPublicActivitiesQuery, SearchParanaPublicActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchParanaPublicActivitiesQuery, SearchParanaPublicActivitiesQueryVariables>(SearchParanaPublicActivitiesDocument, options);
        }
export type SearchParanaPublicActivitiesQueryHookResult = ReturnType<typeof useSearchParanaPublicActivitiesQuery>;
export type SearchParanaPublicActivitiesLazyQueryHookResult = ReturnType<typeof useSearchParanaPublicActivitiesLazyQuery>;
export type SearchParanaPublicActivitiesSuspenseQueryHookResult = ReturnType<typeof useSearchParanaPublicActivitiesSuspenseQuery>;
export type SearchParanaPublicActivitiesQueryResult = Apollo.QueryResult<SearchParanaPublicActivitiesQuery, SearchParanaPublicActivitiesQueryVariables>;
export const ListActivityQuestionsV2Document = gql`
    query listActivityQuestionsV2($appliedActivityId: Int!, $readerId: Int!) {
  listActivityQuestionsV2(
    appliedActivityId: $appliedActivityId
    readerId: $readerId
  ) {
    id
    readerId
    appliedActivityAnswers {
      answers {
        answerChoiceId
        answerDiscursive
        examQuestionId
        grade
        id
        teacherComments
        aiGrade
        aiComment
        answerMatchingPairs {
          id
          leftId
          rightId
          isCorrect
        }
      }
      status
      id
      finalGrade
    }
    id
    message
    activity {
      id
      moduleId
      title
      books {
        imageUrlThumb
        slug
        author
        name
      }
      examQuestions {
        statement
        type
        id
        commentedAnswer
        expectedAnswer
        examQuestionMatchingPairs {
          id
          leftId
          leftStatement
          rightId
          rightStatement
        }
        examQuestionChoices {
          id
          statement
          isCorrect
        }
      }
    }
  }
}
    `;

/**
 * __useListActivityQuestionsV2Query__
 *
 * To run a query within a React component, call `useListActivityQuestionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListActivityQuestionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivityQuestionsV2Query({
 *   variables: {
 *      appliedActivityId: // value for 'appliedActivityId'
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useListActivityQuestionsV2Query(baseOptions: Apollo.QueryHookOptions<ListActivityQuestionsV2Query, ListActivityQuestionsV2QueryVariables> & ({ variables: ListActivityQuestionsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActivityQuestionsV2Query, ListActivityQuestionsV2QueryVariables>(ListActivityQuestionsV2Document, options);
      }
export function useListActivityQuestionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActivityQuestionsV2Query, ListActivityQuestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActivityQuestionsV2Query, ListActivityQuestionsV2QueryVariables>(ListActivityQuestionsV2Document, options);
        }
export function useListActivityQuestionsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivityQuestionsV2Query, ListActivityQuestionsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActivityQuestionsV2Query, ListActivityQuestionsV2QueryVariables>(ListActivityQuestionsV2Document, options);
        }
export type ListActivityQuestionsV2QueryHookResult = ReturnType<typeof useListActivityQuestionsV2Query>;
export type ListActivityQuestionsV2LazyQueryHookResult = ReturnType<typeof useListActivityQuestionsV2LazyQuery>;
export type ListActivityQuestionsV2SuspenseQueryHookResult = ReturnType<typeof useListActivityQuestionsV2SuspenseQuery>;
export type ListActivityQuestionsV2QueryResult = Apollo.QueryResult<ListActivityQuestionsV2Query, ListActivityQuestionsV2QueryVariables>;
export const ListBnccAbilitiesDocument = gql`
    query ListBnccAbilities {
  listBnccAbilities {
    code
    degreeRange
    description
    id
  }
}
    `;

/**
 * __useListBnccAbilitiesQuery__
 *
 * To run a query within a React component, call `useListBnccAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBnccAbilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBnccAbilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListBnccAbilitiesQuery(baseOptions?: Apollo.QueryHookOptions<ListBnccAbilitiesQuery, ListBnccAbilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBnccAbilitiesQuery, ListBnccAbilitiesQueryVariables>(ListBnccAbilitiesDocument, options);
      }
export function useListBnccAbilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBnccAbilitiesQuery, ListBnccAbilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBnccAbilitiesQuery, ListBnccAbilitiesQueryVariables>(ListBnccAbilitiesDocument, options);
        }
export function useListBnccAbilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBnccAbilitiesQuery, ListBnccAbilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBnccAbilitiesQuery, ListBnccAbilitiesQueryVariables>(ListBnccAbilitiesDocument, options);
        }
export type ListBnccAbilitiesQueryHookResult = ReturnType<typeof useListBnccAbilitiesQuery>;
export type ListBnccAbilitiesLazyQueryHookResult = ReturnType<typeof useListBnccAbilitiesLazyQuery>;
export type ListBnccAbilitiesSuspenseQueryHookResult = ReturnType<typeof useListBnccAbilitiesSuspenseQuery>;
export type ListBnccAbilitiesQueryResult = Apollo.QueryResult<ListBnccAbilitiesQuery, ListBnccAbilitiesQueryVariables>;
export const SummarizedActivitiesReportDocument = gql`
    query SummarizedActivitiesReport($classId: Int, $holdingId: Int, $networkId: Int, $readerId: Int, $schoolId: Int, $trademarkId: Int, $startDate: IsoDate!, $endDate: IsoDate!) {
  summarizedActivitiesReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    readerId: $readerId
    schoolId: $schoolId
    trademarkId: $trademarkId
    startDate: $startDate
    endDate: $endDate
  ) {
    finalizedActivitiesPercentage
    id
    name
    numberOfAnsweredActivities
    numberOfAppliedActivities
    numberOfCorrectedActivities
    numberOfInProgressActivities
    numberOfNotStartedActivities
  }
}
    `;

/**
 * __useSummarizedActivitiesReportQuery__
 *
 * To run a query within a React component, call `useSummarizedActivitiesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizedActivitiesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizedActivitiesReportQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      readerId: // value for 'readerId'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useSummarizedActivitiesReportQuery(baseOptions: Apollo.QueryHookOptions<SummarizedActivitiesReportQuery, SummarizedActivitiesReportQueryVariables> & ({ variables: SummarizedActivitiesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizedActivitiesReportQuery, SummarizedActivitiesReportQueryVariables>(SummarizedActivitiesReportDocument, options);
      }
export function useSummarizedActivitiesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizedActivitiesReportQuery, SummarizedActivitiesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizedActivitiesReportQuery, SummarizedActivitiesReportQueryVariables>(SummarizedActivitiesReportDocument, options);
        }
export function useSummarizedActivitiesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizedActivitiesReportQuery, SummarizedActivitiesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizedActivitiesReportQuery, SummarizedActivitiesReportQueryVariables>(SummarizedActivitiesReportDocument, options);
        }
export type SummarizedActivitiesReportQueryHookResult = ReturnType<typeof useSummarizedActivitiesReportQuery>;
export type SummarizedActivitiesReportLazyQueryHookResult = ReturnType<typeof useSummarizedActivitiesReportLazyQuery>;
export type SummarizedActivitiesReportSuspenseQueryHookResult = ReturnType<typeof useSummarizedActivitiesReportSuspenseQuery>;
export type SummarizedActivitiesReportQueryResult = Apollo.QueryResult<SummarizedActivitiesReportQuery, SummarizedActivitiesReportQueryVariables>;
export const DetailedActivitiesReportDocument = gql`
    query DetailedActivitiesReport($classId: Int, $endDate: IsoDate!, $holdingId: Int, $networkId: Int, $schoolId: Int, $startDate: IsoDate!, $trademarkId: Int, $teacherUserId: Int) {
  detailedActivitiesReport(
    classId: $classId
    endDate: $endDate
    holdingId: $holdingId
    networkId: $networkId
    schoolId: $schoolId
    startDate: $startDate
    trademarkId: $trademarkId
    teacherUserId: $teacherUserId
  ) {
    activity {
      difficultyLevel
      id
      title
    }
    appliedAt
    appliedBy {
      id
      name
    }
    appliedTo {
      id
      name
    }
    finalizedActivitiesPercentage
  }
}
    `;

/**
 * __useDetailedActivitiesReportQuery__
 *
 * To run a query within a React component, call `useDetailedActivitiesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailedActivitiesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailedActivitiesReportQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      endDate: // value for 'endDate'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      startDate: // value for 'startDate'
 *      trademarkId: // value for 'trademarkId'
 *      teacherUserId: // value for 'teacherUserId'
 *   },
 * });
 */
export function useDetailedActivitiesReportQuery(baseOptions: Apollo.QueryHookOptions<DetailedActivitiesReportQuery, DetailedActivitiesReportQueryVariables> & ({ variables: DetailedActivitiesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetailedActivitiesReportQuery, DetailedActivitiesReportQueryVariables>(DetailedActivitiesReportDocument, options);
      }
export function useDetailedActivitiesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailedActivitiesReportQuery, DetailedActivitiesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetailedActivitiesReportQuery, DetailedActivitiesReportQueryVariables>(DetailedActivitiesReportDocument, options);
        }
export function useDetailedActivitiesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DetailedActivitiesReportQuery, DetailedActivitiesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DetailedActivitiesReportQuery, DetailedActivitiesReportQueryVariables>(DetailedActivitiesReportDocument, options);
        }
export type DetailedActivitiesReportQueryHookResult = ReturnType<typeof useDetailedActivitiesReportQuery>;
export type DetailedActivitiesReportLazyQueryHookResult = ReturnType<typeof useDetailedActivitiesReportLazyQuery>;
export type DetailedActivitiesReportSuspenseQueryHookResult = ReturnType<typeof useDetailedActivitiesReportSuspenseQuery>;
export type DetailedActivitiesReportQueryResult = Apollo.QueryResult<DetailedActivitiesReportQuery, DetailedActivitiesReportQueryVariables>;
export const StudentDetailedActivitiesReportDocument = gql`
    query StudentDetailedActivitiesReport($endDate: IsoDate!, $startDate: IsoDate!, $studentUserId: Int!) {
  studentDetailedActivitiesReport(
    endDate: $endDate
    startDate: $startDate
    studentUserId: $studentUserId
  ) {
    appliedActivityId
    activity {
      difficultyLevel
      id
      title
    }
    appliedAt
    appliedBy {
      id
      name
    }
    finalGrade
    status
  }
}
    `;

/**
 * __useStudentDetailedActivitiesReportQuery__
 *
 * To run a query within a React component, call `useStudentDetailedActivitiesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDetailedActivitiesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDetailedActivitiesReportQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      studentUserId: // value for 'studentUserId'
 *   },
 * });
 */
export function useStudentDetailedActivitiesReportQuery(baseOptions: Apollo.QueryHookOptions<StudentDetailedActivitiesReportQuery, StudentDetailedActivitiesReportQueryVariables> & ({ variables: StudentDetailedActivitiesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentDetailedActivitiesReportQuery, StudentDetailedActivitiesReportQueryVariables>(StudentDetailedActivitiesReportDocument, options);
      }
export function useStudentDetailedActivitiesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDetailedActivitiesReportQuery, StudentDetailedActivitiesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentDetailedActivitiesReportQuery, StudentDetailedActivitiesReportQueryVariables>(StudentDetailedActivitiesReportDocument, options);
        }
export function useStudentDetailedActivitiesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StudentDetailedActivitiesReportQuery, StudentDetailedActivitiesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StudentDetailedActivitiesReportQuery, StudentDetailedActivitiesReportQueryVariables>(StudentDetailedActivitiesReportDocument, options);
        }
export type StudentDetailedActivitiesReportQueryHookResult = ReturnType<typeof useStudentDetailedActivitiesReportQuery>;
export type StudentDetailedActivitiesReportLazyQueryHookResult = ReturnType<typeof useStudentDetailedActivitiesReportLazyQuery>;
export type StudentDetailedActivitiesReportSuspenseQueryHookResult = ReturnType<typeof useStudentDetailedActivitiesReportSuspenseQuery>;
export type StudentDetailedActivitiesReportQueryResult = Apollo.QueryResult<StudentDetailedActivitiesReportQuery, StudentDetailedActivitiesReportQueryVariables>;
export const ActivityDetailsByLineageDocument = gql`
    query ActivityDetailsByLineage($classId: Int!, $activityId: Int!) {
  activityDetailsByLineage(classId: $classId, activityId: $activityId) {
    answers {
      examQuestionId
      isCorrect
      type
      bnccTags
    }
    finalGrade
    grade
    readerId
    status
    userName
    appliedActivityId
    conclusionPercentage
  }
}
    `;

/**
 * __useActivityDetailsByLineageQuery__
 *
 * To run a query within a React component, call `useActivityDetailsByLineageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsByLineageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsByLineageQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityDetailsByLineageQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsByLineageQuery, ActivityDetailsByLineageQueryVariables> & ({ variables: ActivityDetailsByLineageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsByLineageQuery, ActivityDetailsByLineageQueryVariables>(ActivityDetailsByLineageDocument, options);
      }
export function useActivityDetailsByLineageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsByLineageQuery, ActivityDetailsByLineageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsByLineageQuery, ActivityDetailsByLineageQueryVariables>(ActivityDetailsByLineageDocument, options);
        }
export function useActivityDetailsByLineageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityDetailsByLineageQuery, ActivityDetailsByLineageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityDetailsByLineageQuery, ActivityDetailsByLineageQueryVariables>(ActivityDetailsByLineageDocument, options);
        }
export type ActivityDetailsByLineageQueryHookResult = ReturnType<typeof useActivityDetailsByLineageQuery>;
export type ActivityDetailsByLineageLazyQueryHookResult = ReturnType<typeof useActivityDetailsByLineageLazyQuery>;
export type ActivityDetailsByLineageSuspenseQueryHookResult = ReturnType<typeof useActivityDetailsByLineageSuspenseQuery>;
export type ActivityDetailsByLineageQueryResult = Apollo.QueryResult<ActivityDetailsByLineageQuery, ActivityDetailsByLineageQueryVariables>;
export const ActivityReportActivityVisualizationDocument = gql`
    query ActivityReportActivityVisualization($startDate: IsoDate!, $endDate: IsoDate!, $holdingId: Int, $classId: Int, $schoolId: Int, $networkId: Int, $trademarkId: Int) {
  activityReportActivityVisualization(
    startDate: $startDate
    endDate: $endDate
    holdingId: $holdingId
    classId: $classId
    schoolId: $schoolId
    networkId: $networkId
    trademarkId: $trademarkId
  ) {
    activityId
    activityName
    recommendedDegree
    subjectsName
    conclusionPercentage
  }
}
    `;

/**
 * __useActivityReportActivityVisualizationQuery__
 *
 * To run a query within a React component, call `useActivityReportActivityVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityReportActivityVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityReportActivityVisualizationQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      holdingId: // value for 'holdingId'
 *      classId: // value for 'classId'
 *      schoolId: // value for 'schoolId'
 *      networkId: // value for 'networkId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useActivityReportActivityVisualizationQuery(baseOptions: Apollo.QueryHookOptions<ActivityReportActivityVisualizationQuery, ActivityReportActivityVisualizationQueryVariables> & ({ variables: ActivityReportActivityVisualizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityReportActivityVisualizationQuery, ActivityReportActivityVisualizationQueryVariables>(ActivityReportActivityVisualizationDocument, options);
      }
export function useActivityReportActivityVisualizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityReportActivityVisualizationQuery, ActivityReportActivityVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityReportActivityVisualizationQuery, ActivityReportActivityVisualizationQueryVariables>(ActivityReportActivityVisualizationDocument, options);
        }
export function useActivityReportActivityVisualizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityReportActivityVisualizationQuery, ActivityReportActivityVisualizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityReportActivityVisualizationQuery, ActivityReportActivityVisualizationQueryVariables>(ActivityReportActivityVisualizationDocument, options);
        }
export type ActivityReportActivityVisualizationQueryHookResult = ReturnType<typeof useActivityReportActivityVisualizationQuery>;
export type ActivityReportActivityVisualizationLazyQueryHookResult = ReturnType<typeof useActivityReportActivityVisualizationLazyQuery>;
export type ActivityReportActivityVisualizationSuspenseQueryHookResult = ReturnType<typeof useActivityReportActivityVisualizationSuspenseQuery>;
export type ActivityReportActivityVisualizationQueryResult = Apollo.QueryResult<ActivityReportActivityVisualizationQuery, ActivityReportActivityVisualizationQueryVariables>;
export const ActivityReportSubjectVisualizationDocument = gql`
    query ActivityReportSubjectVisualization($startDate: IsoDate!, $endDate: IsoDate!, $holdingId: Int, $classId: Int, $schoolId: Int, $networkId: Int, $trademarkId: Int) {
  activityReportSubjectVisualization(
    startDate: $startDate
    endDate: $endDate
    holdingId: $holdingId
    classId: $classId
    schoolId: $schoolId
    networkId: $networkId
    trademarkId: $trademarkId
  ) {
    subjectId
    subjectName
    totalActivitiesCount
    notStartedActivitiesCount
    inProgressActivitiesCount
    finishedActivitiesCount
    conclusionPercentage
  }
}
    `;

/**
 * __useActivityReportSubjectVisualizationQuery__
 *
 * To run a query within a React component, call `useActivityReportSubjectVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityReportSubjectVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityReportSubjectVisualizationQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      holdingId: // value for 'holdingId'
 *      classId: // value for 'classId'
 *      schoolId: // value for 'schoolId'
 *      networkId: // value for 'networkId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useActivityReportSubjectVisualizationQuery(baseOptions: Apollo.QueryHookOptions<ActivityReportSubjectVisualizationQuery, ActivityReportSubjectVisualizationQueryVariables> & ({ variables: ActivityReportSubjectVisualizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityReportSubjectVisualizationQuery, ActivityReportSubjectVisualizationQueryVariables>(ActivityReportSubjectVisualizationDocument, options);
      }
export function useActivityReportSubjectVisualizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityReportSubjectVisualizationQuery, ActivityReportSubjectVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityReportSubjectVisualizationQuery, ActivityReportSubjectVisualizationQueryVariables>(ActivityReportSubjectVisualizationDocument, options);
        }
export function useActivityReportSubjectVisualizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityReportSubjectVisualizationQuery, ActivityReportSubjectVisualizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityReportSubjectVisualizationQuery, ActivityReportSubjectVisualizationQueryVariables>(ActivityReportSubjectVisualizationDocument, options);
        }
export type ActivityReportSubjectVisualizationQueryHookResult = ReturnType<typeof useActivityReportSubjectVisualizationQuery>;
export type ActivityReportSubjectVisualizationLazyQueryHookResult = ReturnType<typeof useActivityReportSubjectVisualizationLazyQuery>;
export type ActivityReportSubjectVisualizationSuspenseQueryHookResult = ReturnType<typeof useActivityReportSubjectVisualizationSuspenseQuery>;
export type ActivityReportSubjectVisualizationQueryResult = Apollo.QueryResult<ActivityReportSubjectVisualizationQuery, ActivityReportSubjectVisualizationQueryVariables>;
export const ActivityReportReaderVisualizationDocument = gql`
    query ActivityReportReaderVisualization($startDate: IsoDate!, $endDate: IsoDate!, $readerId: Int!) {
  activityReportReaderVisualization(
    startDate: $startDate
    endDate: $endDate
    readerId: $readerId
  ) {
    activityId
    activityName
    recommendedDegree
    grade
    conclusionPercentage
  }
}
    `;

/**
 * __useActivityReportReaderVisualizationQuery__
 *
 * To run a query within a React component, call `useActivityReportReaderVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityReportReaderVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityReportReaderVisualizationQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useActivityReportReaderVisualizationQuery(baseOptions: Apollo.QueryHookOptions<ActivityReportReaderVisualizationQuery, ActivityReportReaderVisualizationQueryVariables> & ({ variables: ActivityReportReaderVisualizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityReportReaderVisualizationQuery, ActivityReportReaderVisualizationQueryVariables>(ActivityReportReaderVisualizationDocument, options);
      }
export function useActivityReportReaderVisualizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityReportReaderVisualizationQuery, ActivityReportReaderVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityReportReaderVisualizationQuery, ActivityReportReaderVisualizationQueryVariables>(ActivityReportReaderVisualizationDocument, options);
        }
export function useActivityReportReaderVisualizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityReportReaderVisualizationQuery, ActivityReportReaderVisualizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityReportReaderVisualizationQuery, ActivityReportReaderVisualizationQueryVariables>(ActivityReportReaderVisualizationDocument, options);
        }
export type ActivityReportReaderVisualizationQueryHookResult = ReturnType<typeof useActivityReportReaderVisualizationQuery>;
export type ActivityReportReaderVisualizationLazyQueryHookResult = ReturnType<typeof useActivityReportReaderVisualizationLazyQuery>;
export type ActivityReportReaderVisualizationSuspenseQueryHookResult = ReturnType<typeof useActivityReportReaderVisualizationSuspenseQuery>;
export type ActivityReportReaderVisualizationQueryResult = Apollo.QueryResult<ActivityReportReaderVisualizationQuery, ActivityReportReaderVisualizationQueryVariables>;
export const FetchActivityForReaderDocument = gql`
    query FetchActivityForReader($appliedActivityId: Int!) {
  fetchActivityForReader(appliedActivityId: $appliedActivityId) {
    id
    title
    status
    isCorrectionAutomatic
    totalCoins
    appliedActivityAnswerId
    questions {
      id
      coins
      title
      isCorrect
      isPartiallyCorrect
      titleImageUrl
      status
      matchingPairs {
        id
        leftId
        leftStatement
        rightId
        rightStatement
      }
      answer {
        id
        answerDiscursive
        answerChoiceId
        examQuestionId
        teacherComments
        grade
        isCorrect
        correctAnswerId
        isPartiallyCorrect
        answerMatchingPairs {
          id
          leftId
          rightId
          isCorrect
        }
      }
      choices {
        id
        title
        choiceImageUrl
        isCorrect
      }
      type
    }
  }
}
    `;

/**
 * __useFetchActivityForReaderQuery__
 *
 * To run a query within a React component, call `useFetchActivityForReaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActivityForReaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActivityForReaderQuery({
 *   variables: {
 *      appliedActivityId: // value for 'appliedActivityId'
 *   },
 * });
 */
export function useFetchActivityForReaderQuery(baseOptions: Apollo.QueryHookOptions<FetchActivityForReaderQuery, FetchActivityForReaderQueryVariables> & ({ variables: FetchActivityForReaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchActivityForReaderQuery, FetchActivityForReaderQueryVariables>(FetchActivityForReaderDocument, options);
      }
export function useFetchActivityForReaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchActivityForReaderQuery, FetchActivityForReaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchActivityForReaderQuery, FetchActivityForReaderQueryVariables>(FetchActivityForReaderDocument, options);
        }
export function useFetchActivityForReaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchActivityForReaderQuery, FetchActivityForReaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchActivityForReaderQuery, FetchActivityForReaderQueryVariables>(FetchActivityForReaderDocument, options);
        }
export type FetchActivityForReaderQueryHookResult = ReturnType<typeof useFetchActivityForReaderQuery>;
export type FetchActivityForReaderLazyQueryHookResult = ReturnType<typeof useFetchActivityForReaderLazyQuery>;
export type FetchActivityForReaderSuspenseQueryHookResult = ReturnType<typeof useFetchActivityForReaderSuspenseQuery>;
export type FetchActivityForReaderQueryResult = Apollo.QueryResult<FetchActivityForReaderQuery, FetchActivityForReaderQueryVariables>;
export const ActivityDetailReportDocument = gql`
    query ActivityDetailReport($entityIds: [Int]!, $activityId: Int!) {
  me {
    id
    serverDateTime
    teacher {
      id
      activityDetailReport(activityId: $activityId, entityIds: $entityIds)
    }
  }
  getActivity(activityId: $activityId) {
    id
    title
  }
}
    `;

/**
 * __useActivityDetailReportQuery__
 *
 * To run a query within a React component, call `useActivityDetailReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailReportQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityDetailReportQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailReportQuery, ActivityDetailReportQueryVariables> & ({ variables: ActivityDetailReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailReportQuery, ActivityDetailReportQueryVariables>(ActivityDetailReportDocument, options);
      }
export function useActivityDetailReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailReportQuery, ActivityDetailReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailReportQuery, ActivityDetailReportQueryVariables>(ActivityDetailReportDocument, options);
        }
export function useActivityDetailReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityDetailReportQuery, ActivityDetailReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityDetailReportQuery, ActivityDetailReportQueryVariables>(ActivityDetailReportDocument, options);
        }
export type ActivityDetailReportQueryHookResult = ReturnType<typeof useActivityDetailReportQuery>;
export type ActivityDetailReportLazyQueryHookResult = ReturnType<typeof useActivityDetailReportLazyQuery>;
export type ActivityDetailReportSuspenseQueryHookResult = ReturnType<typeof useActivityDetailReportSuspenseQuery>;
export type ActivityDetailReportQueryResult = Apollo.QueryResult<ActivityDetailReportQuery, ActivityDetailReportQueryVariables>;
export const AdminSearchAtualidadesActivitiesDocument = gql`
    query adminSearchAtualidadesActivities($page: Int!, $perPage: Int!, $searchTerm: String!) {
  adminSearchAtualidadesActivities(
    searchTerm: $searchTerm
    page: $page
    perPage: $perPage
  ) {
    activities {
      degreeRange
      id
      moduleId
      title
      examQuestions {
        type
      }
      articles {
        id
        image
        title
      }
    }
    totalEntries
  }
}
    `;

/**
 * __useAdminSearchAtualidadesActivitiesQuery__
 *
 * To run a query within a React component, call `useAdminSearchAtualidadesActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchAtualidadesActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchAtualidadesActivitiesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useAdminSearchAtualidadesActivitiesQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchAtualidadesActivitiesQuery, AdminSearchAtualidadesActivitiesQueryVariables> & ({ variables: AdminSearchAtualidadesActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchAtualidadesActivitiesQuery, AdminSearchAtualidadesActivitiesQueryVariables>(AdminSearchAtualidadesActivitiesDocument, options);
      }
export function useAdminSearchAtualidadesActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchAtualidadesActivitiesQuery, AdminSearchAtualidadesActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchAtualidadesActivitiesQuery, AdminSearchAtualidadesActivitiesQueryVariables>(AdminSearchAtualidadesActivitiesDocument, options);
        }
export function useAdminSearchAtualidadesActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminSearchAtualidadesActivitiesQuery, AdminSearchAtualidadesActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchAtualidadesActivitiesQuery, AdminSearchAtualidadesActivitiesQueryVariables>(AdminSearchAtualidadesActivitiesDocument, options);
        }
export type AdminSearchAtualidadesActivitiesQueryHookResult = ReturnType<typeof useAdminSearchAtualidadesActivitiesQuery>;
export type AdminSearchAtualidadesActivitiesLazyQueryHookResult = ReturnType<typeof useAdminSearchAtualidadesActivitiesLazyQuery>;
export type AdminSearchAtualidadesActivitiesSuspenseQueryHookResult = ReturnType<typeof useAdminSearchAtualidadesActivitiesSuspenseQuery>;
export type AdminSearchAtualidadesActivitiesQueryResult = Apollo.QueryResult<AdminSearchAtualidadesActivitiesQuery, AdminSearchAtualidadesActivitiesQueryVariables>;
export const SelectEntityQueryDocument = gql`
    query SelectEntityQuery {
  me {
    id
    teacher {
      id
      permissions
      teacherEntities
      showFlag
    }
  }
}
    `;

/**
 * __useSelectEntityQueryQuery__
 *
 * To run a query within a React component, call `useSelectEntityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectEntityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectEntityQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectEntityQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectEntityQueryQuery, SelectEntityQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectEntityQueryQuery, SelectEntityQueryQueryVariables>(SelectEntityQueryDocument, options);
      }
export function useSelectEntityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectEntityQueryQuery, SelectEntityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectEntityQueryQuery, SelectEntityQueryQueryVariables>(SelectEntityQueryDocument, options);
        }
export function useSelectEntityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectEntityQueryQuery, SelectEntityQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectEntityQueryQuery, SelectEntityQueryQueryVariables>(SelectEntityQueryDocument, options);
        }
export type SelectEntityQueryQueryHookResult = ReturnType<typeof useSelectEntityQueryQuery>;
export type SelectEntityQueryLazyQueryHookResult = ReturnType<typeof useSelectEntityQueryLazyQuery>;
export type SelectEntityQuerySuspenseQueryHookResult = ReturnType<typeof useSelectEntityQuerySuspenseQuery>;
export type SelectEntityQueryQueryResult = Apollo.QueryResult<SelectEntityQueryQuery, SelectEntityQueryQueryVariables>;
export const ListAppliedActivityDetailsDocument = gql`
    query listAppliedActivityDetails($activityId: Int!) {
  me {
    id
    teacher {
      id
      listAppliedActivityDetails(activityId: $activityId) {
        activityTitle
        others {
          status
        }
        entities
      }
    }
  }
}
    `;

/**
 * __useListAppliedActivityDetailsQuery__
 *
 * To run a query within a React component, call `useListAppliedActivityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAppliedActivityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAppliedActivityDetailsQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useListAppliedActivityDetailsQuery(baseOptions: Apollo.QueryHookOptions<ListAppliedActivityDetailsQuery, ListAppliedActivityDetailsQueryVariables> & ({ variables: ListAppliedActivityDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAppliedActivityDetailsQuery, ListAppliedActivityDetailsQueryVariables>(ListAppliedActivityDetailsDocument, options);
      }
export function useListAppliedActivityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAppliedActivityDetailsQuery, ListAppliedActivityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAppliedActivityDetailsQuery, ListAppliedActivityDetailsQueryVariables>(ListAppliedActivityDetailsDocument, options);
        }
export function useListAppliedActivityDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAppliedActivityDetailsQuery, ListAppliedActivityDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAppliedActivityDetailsQuery, ListAppliedActivityDetailsQueryVariables>(ListAppliedActivityDetailsDocument, options);
        }
export type ListAppliedActivityDetailsQueryHookResult = ReturnType<typeof useListAppliedActivityDetailsQuery>;
export type ListAppliedActivityDetailsLazyQueryHookResult = ReturnType<typeof useListAppliedActivityDetailsLazyQuery>;
export type ListAppliedActivityDetailsSuspenseQueryHookResult = ReturnType<typeof useListAppliedActivityDetailsSuspenseQuery>;
export type ListAppliedActivityDetailsQueryResult = Apollo.QueryResult<ListAppliedActivityDetailsQuery, ListAppliedActivityDetailsQueryVariables>;
export const Teste1Document = gql`
    query Teste1 {
  me {
    id
  }
}
    `;

/**
 * __useTeste1Query__
 *
 * To run a query within a React component, call `useTeste1Query` and pass it any options that fit your needs.
 * When your component renders, `useTeste1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeste1Query({
 *   variables: {
 *   },
 * });
 */
export function useTeste1Query(baseOptions?: Apollo.QueryHookOptions<Teste1Query, Teste1QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Teste1Query, Teste1QueryVariables>(Teste1Document, options);
      }
export function useTeste1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Teste1Query, Teste1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Teste1Query, Teste1QueryVariables>(Teste1Document, options);
        }
export function useTeste1SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Teste1Query, Teste1QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Teste1Query, Teste1QueryVariables>(Teste1Document, options);
        }
export type Teste1QueryHookResult = ReturnType<typeof useTeste1Query>;
export type Teste1LazyQueryHookResult = ReturnType<typeof useTeste1LazyQuery>;
export type Teste1SuspenseQueryHookResult = ReturnType<typeof useTeste1SuspenseQuery>;
export type Teste1QueryResult = Apollo.QueryResult<Teste1Query, Teste1QueryVariables>;
export const ReaderYearlyIndicatorsDocument = gql`
    query readerYearlyIndicators($classId: Int, $holdingId: Int, $networkId: Int, $readerId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  readerSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    readerId: $readerId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    yearlyIndicators {
      monthlyCompletedActivitiesCount {
        completedActivitiesCount
        referenceMonth
      }
      monthlyReadingsCount {
        readingsCount
        referenceMonth
      }
    }
  }
}
    `;

/**
 * __useReaderYearlyIndicatorsQuery__
 *
 * To run a query within a React component, call `useReaderYearlyIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReaderYearlyIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReaderYearlyIndicatorsQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      readerId: // value for 'readerId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useReaderYearlyIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<ReaderYearlyIndicatorsQuery, ReaderYearlyIndicatorsQueryVariables> & ({ variables: ReaderYearlyIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReaderYearlyIndicatorsQuery, ReaderYearlyIndicatorsQueryVariables>(ReaderYearlyIndicatorsDocument, options);
      }
export function useReaderYearlyIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReaderYearlyIndicatorsQuery, ReaderYearlyIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReaderYearlyIndicatorsQuery, ReaderYearlyIndicatorsQueryVariables>(ReaderYearlyIndicatorsDocument, options);
        }
export function useReaderYearlyIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReaderYearlyIndicatorsQuery, ReaderYearlyIndicatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReaderYearlyIndicatorsQuery, ReaderYearlyIndicatorsQueryVariables>(ReaderYearlyIndicatorsDocument, options);
        }
export type ReaderYearlyIndicatorsQueryHookResult = ReturnType<typeof useReaderYearlyIndicatorsQuery>;
export type ReaderYearlyIndicatorsLazyQueryHookResult = ReturnType<typeof useReaderYearlyIndicatorsLazyQuery>;
export type ReaderYearlyIndicatorsSuspenseQueryHookResult = ReturnType<typeof useReaderYearlyIndicatorsSuspenseQuery>;
export type ReaderYearlyIndicatorsQueryResult = Apollo.QueryResult<ReaderYearlyIndicatorsQuery, ReaderYearlyIndicatorsQueryVariables>;
export const TeacherYearlyIndicatorsDocument = gql`
    query teacherYearlyIndicators($classId: Int, $holdingId: Int, $networkId: Int, $teacherId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  teacherSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    teacherId: $teacherId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    yearlyIndicators {
      monthlyReviewedActivitiesCount {
        referenceMonth
        reviewedActivitiesCount
      }
      monthlyIndicationsCount {
        indicationsCount
        referenceMonth
      }
    }
  }
}
    `;

/**
 * __useTeacherYearlyIndicatorsQuery__
 *
 * To run a query within a React component, call `useTeacherYearlyIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherYearlyIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherYearlyIndicatorsQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      teacherId: // value for 'teacherId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useTeacherYearlyIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<TeacherYearlyIndicatorsQuery, TeacherYearlyIndicatorsQueryVariables> & ({ variables: TeacherYearlyIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherYearlyIndicatorsQuery, TeacherYearlyIndicatorsQueryVariables>(TeacherYearlyIndicatorsDocument, options);
      }
export function useTeacherYearlyIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherYearlyIndicatorsQuery, TeacherYearlyIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherYearlyIndicatorsQuery, TeacherYearlyIndicatorsQueryVariables>(TeacherYearlyIndicatorsDocument, options);
        }
export function useTeacherYearlyIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherYearlyIndicatorsQuery, TeacherYearlyIndicatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherYearlyIndicatorsQuery, TeacherYearlyIndicatorsQueryVariables>(TeacherYearlyIndicatorsDocument, options);
        }
export type TeacherYearlyIndicatorsQueryHookResult = ReturnType<typeof useTeacherYearlyIndicatorsQuery>;
export type TeacherYearlyIndicatorsLazyQueryHookResult = ReturnType<typeof useTeacherYearlyIndicatorsLazyQuery>;
export type TeacherYearlyIndicatorsSuspenseQueryHookResult = ReturnType<typeof useTeacherYearlyIndicatorsSuspenseQuery>;
export type TeacherYearlyIndicatorsQueryResult = Apollo.QueryResult<TeacherYearlyIndicatorsQuery, TeacherYearlyIndicatorsQueryVariables>;
export const ReaderProgressBnccAbilitiesDocument = gql`
    query readerProgressBnccAbilities($classId: Int, $holdingId: Int, $networkId: Int, $readerId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  readerSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    readerId: $readerId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    performanceIndicators {
      progressBnccAbilities {
        ability
        abilityDescription
        totalCorrectObjectiveQuestionsCount
        totalObjectiveQuestionsCount
      }
    }
  }
}
    `;

/**
 * __useReaderProgressBnccAbilitiesQuery__
 *
 * To run a query within a React component, call `useReaderProgressBnccAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReaderProgressBnccAbilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReaderProgressBnccAbilitiesQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      readerId: // value for 'readerId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useReaderProgressBnccAbilitiesQuery(baseOptions: Apollo.QueryHookOptions<ReaderProgressBnccAbilitiesQuery, ReaderProgressBnccAbilitiesQueryVariables> & ({ variables: ReaderProgressBnccAbilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReaderProgressBnccAbilitiesQuery, ReaderProgressBnccAbilitiesQueryVariables>(ReaderProgressBnccAbilitiesDocument, options);
      }
export function useReaderProgressBnccAbilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReaderProgressBnccAbilitiesQuery, ReaderProgressBnccAbilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReaderProgressBnccAbilitiesQuery, ReaderProgressBnccAbilitiesQueryVariables>(ReaderProgressBnccAbilitiesDocument, options);
        }
export function useReaderProgressBnccAbilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReaderProgressBnccAbilitiesQuery, ReaderProgressBnccAbilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReaderProgressBnccAbilitiesQuery, ReaderProgressBnccAbilitiesQueryVariables>(ReaderProgressBnccAbilitiesDocument, options);
        }
export type ReaderProgressBnccAbilitiesQueryHookResult = ReturnType<typeof useReaderProgressBnccAbilitiesQuery>;
export type ReaderProgressBnccAbilitiesLazyQueryHookResult = ReturnType<typeof useReaderProgressBnccAbilitiesLazyQuery>;
export type ReaderProgressBnccAbilitiesSuspenseQueryHookResult = ReturnType<typeof useReaderProgressBnccAbilitiesSuspenseQuery>;
export type ReaderProgressBnccAbilitiesQueryResult = Apollo.QueryResult<ReaderProgressBnccAbilitiesQuery, ReaderProgressBnccAbilitiesQueryVariables>;
export const ReaderMostReadContentsDocument = gql`
    query readerMostReadContents($classId: Int, $holdingId: Int, $networkId: Int, $readerId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  readerSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    readerId: $readerId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    performanceIndicators {
      mostReadContents {
        author
        contentId
        contentType
        thumbUrl
        title
      }
    }
  }
}
    `;

/**
 * __useReaderMostReadContentsQuery__
 *
 * To run a query within a React component, call `useReaderMostReadContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReaderMostReadContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReaderMostReadContentsQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      readerId: // value for 'readerId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useReaderMostReadContentsQuery(baseOptions: Apollo.QueryHookOptions<ReaderMostReadContentsQuery, ReaderMostReadContentsQueryVariables> & ({ variables: ReaderMostReadContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReaderMostReadContentsQuery, ReaderMostReadContentsQueryVariables>(ReaderMostReadContentsDocument, options);
      }
export function useReaderMostReadContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReaderMostReadContentsQuery, ReaderMostReadContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReaderMostReadContentsQuery, ReaderMostReadContentsQueryVariables>(ReaderMostReadContentsDocument, options);
        }
export function useReaderMostReadContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReaderMostReadContentsQuery, ReaderMostReadContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReaderMostReadContentsQuery, ReaderMostReadContentsQueryVariables>(ReaderMostReadContentsDocument, options);
        }
export type ReaderMostReadContentsQueryHookResult = ReturnType<typeof useReaderMostReadContentsQuery>;
export type ReaderMostReadContentsLazyQueryHookResult = ReturnType<typeof useReaderMostReadContentsLazyQuery>;
export type ReaderMostReadContentsSuspenseQueryHookResult = ReturnType<typeof useReaderMostReadContentsSuspenseQuery>;
export type ReaderMostReadContentsQueryResult = Apollo.QueryResult<ReaderMostReadContentsQuery, ReaderMostReadContentsQueryVariables>;
export const ActivitiesReaderQueryDocument = gql`
    query activitiesReaderQuery($classId: Int, $holdingId: Int, $networkId: Int, $readerId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  readerSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    readerId: $readerId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    performanceIndicators {
      completedActivitiesCountToDate
      startedActivitiesCountToDate
      hitsPerQuestionToDate
    }
  }
}
    `;

/**
 * __useActivitiesReaderQueryQuery__
 *
 * To run a query within a React component, call `useActivitiesReaderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesReaderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesReaderQueryQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      readerId: // value for 'readerId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useActivitiesReaderQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesReaderQueryQuery, ActivitiesReaderQueryQueryVariables> & ({ variables: ActivitiesReaderQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesReaderQueryQuery, ActivitiesReaderQueryQueryVariables>(ActivitiesReaderQueryDocument, options);
      }
export function useActivitiesReaderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesReaderQueryQuery, ActivitiesReaderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesReaderQueryQuery, ActivitiesReaderQueryQueryVariables>(ActivitiesReaderQueryDocument, options);
        }
export function useActivitiesReaderQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesReaderQueryQuery, ActivitiesReaderQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitiesReaderQueryQuery, ActivitiesReaderQueryQueryVariables>(ActivitiesReaderQueryDocument, options);
        }
export type ActivitiesReaderQueryQueryHookResult = ReturnType<typeof useActivitiesReaderQueryQuery>;
export type ActivitiesReaderQueryLazyQueryHookResult = ReturnType<typeof useActivitiesReaderQueryLazyQuery>;
export type ActivitiesReaderQuerySuspenseQueryHookResult = ReturnType<typeof useActivitiesReaderQuerySuspenseQuery>;
export type ActivitiesReaderQueryQueryResult = Apollo.QueryResult<ActivitiesReaderQueryQuery, ActivitiesReaderQueryQueryVariables>;
export const ActivitiesTeacherQueryDocument = gql`
    query activitiesTeacherQuery($classId: Int, $holdingId: Int, $networkId: Int, $teacherId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  teacherSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    teacherId: $teacherId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    performanceIndicators {
      assignedActivitiesCountByDifficulty {
        count
        difficultyLevel
      }
      mostAssignedBnccCompetencies {
        competency
        count
      }
      assignedQuestionsCountByKind {
        count
        kind
      }
      assignedActivitiesCount
      startedActivitiesCount
      pendingReviewActivitiesCount
      reviewedActivitiesCount
    }
  }
}
    `;

/**
 * __useActivitiesTeacherQueryQuery__
 *
 * To run a query within a React component, call `useActivitiesTeacherQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesTeacherQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesTeacherQueryQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      teacherId: // value for 'teacherId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useActivitiesTeacherQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesTeacherQueryQuery, ActivitiesTeacherQueryQueryVariables> & ({ variables: ActivitiesTeacherQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesTeacherQueryQuery, ActivitiesTeacherQueryQueryVariables>(ActivitiesTeacherQueryDocument, options);
      }
export function useActivitiesTeacherQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesTeacherQueryQuery, ActivitiesTeacherQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesTeacherQueryQuery, ActivitiesTeacherQueryQueryVariables>(ActivitiesTeacherQueryDocument, options);
        }
export function useActivitiesTeacherQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesTeacherQueryQuery, ActivitiesTeacherQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitiesTeacherQueryQuery, ActivitiesTeacherQueryQueryVariables>(ActivitiesTeacherQueryDocument, options);
        }
export type ActivitiesTeacherQueryQueryHookResult = ReturnType<typeof useActivitiesTeacherQueryQuery>;
export type ActivitiesTeacherQueryLazyQueryHookResult = ReturnType<typeof useActivitiesTeacherQueryLazyQuery>;
export type ActivitiesTeacherQuerySuspenseQueryHookResult = ReturnType<typeof useActivitiesTeacherQuerySuspenseQuery>;
export type ActivitiesTeacherQueryQueryResult = Apollo.QueryResult<ActivitiesTeacherQueryQuery, ActivitiesTeacherQueryQueryVariables>;
export const ReaderAccessCountDocument = gql`
    query readerAccessCount($classId: Int, $holdingId: Int, $networkId: Int, $readerId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  readerSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    readerId: $readerId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    usageTimeIndicators {
      learningTimeInMinutes
    }
  }
}
    `;

/**
 * __useReaderAccessCountQuery__
 *
 * To run a query within a React component, call `useReaderAccessCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReaderAccessCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReaderAccessCountQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      readerId: // value for 'readerId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useReaderAccessCountQuery(baseOptions: Apollo.QueryHookOptions<ReaderAccessCountQuery, ReaderAccessCountQueryVariables> & ({ variables: ReaderAccessCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReaderAccessCountQuery, ReaderAccessCountQueryVariables>(ReaderAccessCountDocument, options);
      }
export function useReaderAccessCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReaderAccessCountQuery, ReaderAccessCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReaderAccessCountQuery, ReaderAccessCountQueryVariables>(ReaderAccessCountDocument, options);
        }
export function useReaderAccessCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReaderAccessCountQuery, ReaderAccessCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReaderAccessCountQuery, ReaderAccessCountQueryVariables>(ReaderAccessCountDocument, options);
        }
export type ReaderAccessCountQueryHookResult = ReturnType<typeof useReaderAccessCountQuery>;
export type ReaderAccessCountLazyQueryHookResult = ReturnType<typeof useReaderAccessCountLazyQuery>;
export type ReaderAccessCountSuspenseQueryHookResult = ReturnType<typeof useReaderAccessCountSuspenseQuery>;
export type ReaderAccessCountQueryResult = Apollo.QueryResult<ReaderAccessCountQuery, ReaderAccessCountQueryVariables>;
export const TeacherAccessCountDocument = gql`
    query teacherAccessCount($classId: Int, $holdingId: Int, $networkId: Int, $teacherId: Int!, $referenceDate: IsoDate!, $schoolId: Int, $trademarkId: Int) {
  teacherSummaryReport(
    classId: $classId
    holdingId: $holdingId
    networkId: $networkId
    teacherId: $teacherId
    referenceDate: $referenceDate
    schoolId: $schoolId
    trademarkId: $trademarkId
  ) {
    usageTimeIndicators {
      platformUsageTimeInMinutes
    }
  }
}
    `;

/**
 * __useTeacherAccessCountQuery__
 *
 * To run a query within a React component, call `useTeacherAccessCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherAccessCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherAccessCountQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      holdingId: // value for 'holdingId'
 *      networkId: // value for 'networkId'
 *      teacherId: // value for 'teacherId'
 *      referenceDate: // value for 'referenceDate'
 *      schoolId: // value for 'schoolId'
 *      trademarkId: // value for 'trademarkId'
 *   },
 * });
 */
export function useTeacherAccessCountQuery(baseOptions: Apollo.QueryHookOptions<TeacherAccessCountQuery, TeacherAccessCountQueryVariables> & ({ variables: TeacherAccessCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherAccessCountQuery, TeacherAccessCountQueryVariables>(TeacherAccessCountDocument, options);
      }
export function useTeacherAccessCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherAccessCountQuery, TeacherAccessCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherAccessCountQuery, TeacherAccessCountQueryVariables>(TeacherAccessCountDocument, options);
        }
export function useTeacherAccessCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherAccessCountQuery, TeacherAccessCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherAccessCountQuery, TeacherAccessCountQueryVariables>(TeacherAccessCountDocument, options);
        }
export type TeacherAccessCountQueryHookResult = ReturnType<typeof useTeacherAccessCountQuery>;
export type TeacherAccessCountLazyQueryHookResult = ReturnType<typeof useTeacherAccessCountLazyQuery>;
export type TeacherAccessCountSuspenseQueryHookResult = ReturnType<typeof useTeacherAccessCountSuspenseQuery>;
export type TeacherAccessCountQueryResult = Apollo.QueryResult<TeacherAccessCountQuery, TeacherAccessCountQueryVariables>;
export const ListCollectionsDocument = gql`
    query listCollections {
  listCollections {
    id
    name
  }
}
    `;

/**
 * __useListCollectionsQuery__
 *
 * To run a query within a React component, call `useListCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, options);
      }
export function useListCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, options);
        }
export function useListCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCollectionsQuery, ListCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, options);
        }
export type ListCollectionsQueryHookResult = ReturnType<typeof useListCollectionsQuery>;
export type ListCollectionsLazyQueryHookResult = ReturnType<typeof useListCollectionsLazyQuery>;
export type ListCollectionsSuspenseQueryHookResult = ReturnType<typeof useListCollectionsSuspenseQuery>;
export type ListCollectionsQueryResult = Apollo.QueryResult<ListCollectionsQuery, ListCollectionsQueryVariables>;
export const FetchBooksByCollectionAndBookCollectionDocument = gql`
    query fetchBooksByCollectionAndBookCollection($collectionId: Int, $bookCollectionId: Int) {
  fetchBooksByCollectionAndBookCollection(
    collectionId: $collectionId
    bookCollectionId: $bookCollectionId
  ) {
    id
    name
    author
    slug
    publicationYear
    isbn
    publisher {
      name
    }
  }
}
    `;

/**
 * __useFetchBooksByCollectionAndBookCollectionQuery__
 *
 * To run a query within a React component, call `useFetchBooksByCollectionAndBookCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBooksByCollectionAndBookCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBooksByCollectionAndBookCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      bookCollectionId: // value for 'bookCollectionId'
 *   },
 * });
 */
export function useFetchBooksByCollectionAndBookCollectionQuery(baseOptions?: Apollo.QueryHookOptions<FetchBooksByCollectionAndBookCollectionQuery, FetchBooksByCollectionAndBookCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBooksByCollectionAndBookCollectionQuery, FetchBooksByCollectionAndBookCollectionQueryVariables>(FetchBooksByCollectionAndBookCollectionDocument, options);
      }
export function useFetchBooksByCollectionAndBookCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBooksByCollectionAndBookCollectionQuery, FetchBooksByCollectionAndBookCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBooksByCollectionAndBookCollectionQuery, FetchBooksByCollectionAndBookCollectionQueryVariables>(FetchBooksByCollectionAndBookCollectionDocument, options);
        }
export function useFetchBooksByCollectionAndBookCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchBooksByCollectionAndBookCollectionQuery, FetchBooksByCollectionAndBookCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBooksByCollectionAndBookCollectionQuery, FetchBooksByCollectionAndBookCollectionQueryVariables>(FetchBooksByCollectionAndBookCollectionDocument, options);
        }
export type FetchBooksByCollectionAndBookCollectionQueryHookResult = ReturnType<typeof useFetchBooksByCollectionAndBookCollectionQuery>;
export type FetchBooksByCollectionAndBookCollectionLazyQueryHookResult = ReturnType<typeof useFetchBooksByCollectionAndBookCollectionLazyQuery>;
export type FetchBooksByCollectionAndBookCollectionSuspenseQueryHookResult = ReturnType<typeof useFetchBooksByCollectionAndBookCollectionSuspenseQuery>;
export type FetchBooksByCollectionAndBookCollectionQueryResult = Apollo.QueryResult<FetchBooksByCollectionAndBookCollectionQuery, FetchBooksByCollectionAndBookCollectionQueryVariables>;
export const AdminListBookActivitiesDocument = gql`
    query adminListBookActivities($bookSlug: String!) {
  adminListBookActivities(bookSlug: $bookSlug) {
    hasActivitiesToShow
    id
    title
    status
    questions {
      id
      type
      title
      isCorrect
      pageReference
      matchingPairs {
        id
        statement
        leftId
        leftStatement
        rightId
        rightStatement
        __typename
      }
      answer {
        id
        answerDiscursive
        answerChoiceId
        examQuestionId
        teacherComments
        grade
        isCorrect
        correctAnswerId
        __typename
      }
      choices {
        id
        title
        isCorrect
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useAdminListBookActivitiesQuery__
 *
 * To run a query within a React component, call `useAdminListBookActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListBookActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListBookActivitiesQuery({
 *   variables: {
 *      bookSlug: // value for 'bookSlug'
 *   },
 * });
 */
export function useAdminListBookActivitiesQuery(baseOptions: Apollo.QueryHookOptions<AdminListBookActivitiesQuery, AdminListBookActivitiesQueryVariables> & ({ variables: AdminListBookActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListBookActivitiesQuery, AdminListBookActivitiesQueryVariables>(AdminListBookActivitiesDocument, options);
      }
export function useAdminListBookActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListBookActivitiesQuery, AdminListBookActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListBookActivitiesQuery, AdminListBookActivitiesQueryVariables>(AdminListBookActivitiesDocument, options);
        }
export function useAdminListBookActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListBookActivitiesQuery, AdminListBookActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListBookActivitiesQuery, AdminListBookActivitiesQueryVariables>(AdminListBookActivitiesDocument, options);
        }
export type AdminListBookActivitiesQueryHookResult = ReturnType<typeof useAdminListBookActivitiesQuery>;
export type AdminListBookActivitiesLazyQueryHookResult = ReturnType<typeof useAdminListBookActivitiesLazyQuery>;
export type AdminListBookActivitiesSuspenseQueryHookResult = ReturnType<typeof useAdminListBookActivitiesSuspenseQuery>;
export type AdminListBookActivitiesQueryResult = Apollo.QueryResult<AdminListBookActivitiesQuery, AdminListBookActivitiesQueryVariables>;
export const GetAccessReportDocument = gql`
    query getAccessReport($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $endDate: IsoDate!, $startDate: IsoDate!, $userProfile: UserProfileType) {
  getAccessReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    endDate: $endDate
    startDate: $startDate
    userProfile: $userProfile
  ) {
    numberOfAccesses
    studentName
    readerId
    entityId
    entityName
    readingTime
    platformTime
    averageTimeByAccess
    teacherName
  }
}
    `;

/**
 * __useGetAccessReportQuery__
 *
 * To run a query within a React component, call `useGetAccessReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessReportQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      userProfile: // value for 'userProfile'
 *   },
 * });
 */
export function useGetAccessReportQuery(baseOptions: Apollo.QueryHookOptions<GetAccessReportQuery, GetAccessReportQueryVariables> & ({ variables: GetAccessReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessReportQuery, GetAccessReportQueryVariables>(GetAccessReportDocument, options);
      }
export function useGetAccessReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessReportQuery, GetAccessReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessReportQuery, GetAccessReportQueryVariables>(GetAccessReportDocument, options);
        }
export function useGetAccessReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccessReportQuery, GetAccessReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccessReportQuery, GetAccessReportQueryVariables>(GetAccessReportDocument, options);
        }
export type GetAccessReportQueryHookResult = ReturnType<typeof useGetAccessReportQuery>;
export type GetAccessReportLazyQueryHookResult = ReturnType<typeof useGetAccessReportLazyQuery>;
export type GetAccessReportSuspenseQueryHookResult = ReturnType<typeof useGetAccessReportSuspenseQuery>;
export type GetAccessReportQueryResult = Apollo.QueryResult<GetAccessReportQuery, GetAccessReportQueryVariables>;
export const GetReaderActivityStatusByEntityDocument = gql`
    query getReaderActivityStatusByEntity($appliedActivityId: Int!, $entityId: Int!) {
  getReaderActivityStatusByEntity(
    appliedActivityId: $appliedActivityId
    entityId: $entityId
  ) {
    activityDetails {
      userName
      readerId
      status
      finalGrade
      answers {
        examQuestionId
        type
        isCorrect
      }
    }
    bnccTags
  }
}
    `;

/**
 * __useGetReaderActivityStatusByEntityQuery__
 *
 * To run a query within a React component, call `useGetReaderActivityStatusByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReaderActivityStatusByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReaderActivityStatusByEntityQuery({
 *   variables: {
 *      appliedActivityId: // value for 'appliedActivityId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetReaderActivityStatusByEntityQuery(baseOptions: Apollo.QueryHookOptions<GetReaderActivityStatusByEntityQuery, GetReaderActivityStatusByEntityQueryVariables> & ({ variables: GetReaderActivityStatusByEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReaderActivityStatusByEntityQuery, GetReaderActivityStatusByEntityQueryVariables>(GetReaderActivityStatusByEntityDocument, options);
      }
export function useGetReaderActivityStatusByEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReaderActivityStatusByEntityQuery, GetReaderActivityStatusByEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReaderActivityStatusByEntityQuery, GetReaderActivityStatusByEntityQueryVariables>(GetReaderActivityStatusByEntityDocument, options);
        }
export function useGetReaderActivityStatusByEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReaderActivityStatusByEntityQuery, GetReaderActivityStatusByEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReaderActivityStatusByEntityQuery, GetReaderActivityStatusByEntityQueryVariables>(GetReaderActivityStatusByEntityDocument, options);
        }
export type GetReaderActivityStatusByEntityQueryHookResult = ReturnType<typeof useGetReaderActivityStatusByEntityQuery>;
export type GetReaderActivityStatusByEntityLazyQueryHookResult = ReturnType<typeof useGetReaderActivityStatusByEntityLazyQuery>;
export type GetReaderActivityStatusByEntitySuspenseQueryHookResult = ReturnType<typeof useGetReaderActivityStatusByEntitySuspenseQuery>;
export type GetReaderActivityStatusByEntityQueryResult = Apollo.QueryResult<GetReaderActivityStatusByEntityQuery, GetReaderActivityStatusByEntityQueryVariables>;
export const GetUsageTimeIndicatorsDocument = gql`
    query GetUsageTimeIndicators($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    usageTimeIndicators {
      learningTimeInMinutes
    }
  }
}
    `;

/**
 * __useGetUsageTimeIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetUsageTimeIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsageTimeIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsageTimeIndicatorsQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function useGetUsageTimeIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetUsageTimeIndicatorsQuery, GetUsageTimeIndicatorsQueryVariables> & ({ variables: GetUsageTimeIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsageTimeIndicatorsQuery, GetUsageTimeIndicatorsQueryVariables>(GetUsageTimeIndicatorsDocument, options);
      }
export function useGetUsageTimeIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsageTimeIndicatorsQuery, GetUsageTimeIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsageTimeIndicatorsQuery, GetUsageTimeIndicatorsQueryVariables>(GetUsageTimeIndicatorsDocument, options);
        }
export function useGetUsageTimeIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsageTimeIndicatorsQuery, GetUsageTimeIndicatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsageTimeIndicatorsQuery, GetUsageTimeIndicatorsQueryVariables>(GetUsageTimeIndicatorsDocument, options);
        }
export type GetUsageTimeIndicatorsQueryHookResult = ReturnType<typeof useGetUsageTimeIndicatorsQuery>;
export type GetUsageTimeIndicatorsLazyQueryHookResult = ReturnType<typeof useGetUsageTimeIndicatorsLazyQuery>;
export type GetUsageTimeIndicatorsSuspenseQueryHookResult = ReturnType<typeof useGetUsageTimeIndicatorsSuspenseQuery>;
export type GetUsageTimeIndicatorsQueryResult = Apollo.QueryResult<GetUsageTimeIndicatorsQuery, GetUsageTimeIndicatorsQueryVariables>;
export const GetManagementIndicatorsDocument = gql`
    query GetManagementIndicators($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    managementIndicators {
      classesCount
      networksCount
      schoolsCount
      studentsCount
      trademarksCount
    }
  }
}
    `;

/**
 * __useGetManagementIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetManagementIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementIndicatorsQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function useGetManagementIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetManagementIndicatorsQuery, GetManagementIndicatorsQueryVariables> & ({ variables: GetManagementIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagementIndicatorsQuery, GetManagementIndicatorsQueryVariables>(GetManagementIndicatorsDocument, options);
      }
export function useGetManagementIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagementIndicatorsQuery, GetManagementIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagementIndicatorsQuery, GetManagementIndicatorsQueryVariables>(GetManagementIndicatorsDocument, options);
        }
export function useGetManagementIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetManagementIndicatorsQuery, GetManagementIndicatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManagementIndicatorsQuery, GetManagementIndicatorsQueryVariables>(GetManagementIndicatorsDocument, options);
        }
export type GetManagementIndicatorsQueryHookResult = ReturnType<typeof useGetManagementIndicatorsQuery>;
export type GetManagementIndicatorsLazyQueryHookResult = ReturnType<typeof useGetManagementIndicatorsLazyQuery>;
export type GetManagementIndicatorsSuspenseQueryHookResult = ReturnType<typeof useGetManagementIndicatorsSuspenseQuery>;
export type GetManagementIndicatorsQueryResult = Apollo.QueryResult<GetManagementIndicatorsQuery, GetManagementIndicatorsQueryVariables>;
export const ListUsersByFullAncestryDocument = gql`
    query ListUsersByFullAncestry($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!, $userProfile: UserProfileType) {
  listUsersByFullAncestry(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
    userProfile: $userProfile
  ) {
    className
    profile
    readerId
    schoolName
    userId
    userName
  }
}
    `;

/**
 * __useListUsersByFullAncestryQuery__
 *
 * To run a query within a React component, call `useListUsersByFullAncestryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersByFullAncestryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersByFullAncestryQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *      userProfile: // value for 'userProfile'
 *   },
 * });
 */
export function useListUsersByFullAncestryQuery(baseOptions: Apollo.QueryHookOptions<ListUsersByFullAncestryQuery, ListUsersByFullAncestryQueryVariables> & ({ variables: ListUsersByFullAncestryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersByFullAncestryQuery, ListUsersByFullAncestryQueryVariables>(ListUsersByFullAncestryDocument, options);
      }
export function useListUsersByFullAncestryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersByFullAncestryQuery, ListUsersByFullAncestryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersByFullAncestryQuery, ListUsersByFullAncestryQueryVariables>(ListUsersByFullAncestryDocument, options);
        }
export function useListUsersByFullAncestrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersByFullAncestryQuery, ListUsersByFullAncestryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersByFullAncestryQuery, ListUsersByFullAncestryQueryVariables>(ListUsersByFullAncestryDocument, options);
        }
export type ListUsersByFullAncestryQueryHookResult = ReturnType<typeof useListUsersByFullAncestryQuery>;
export type ListUsersByFullAncestryLazyQueryHookResult = ReturnType<typeof useListUsersByFullAncestryLazyQuery>;
export type ListUsersByFullAncestrySuspenseQueryHookResult = ReturnType<typeof useListUsersByFullAncestrySuspenseQuery>;
export type ListUsersByFullAncestryQueryResult = Apollo.QueryResult<ListUsersByFullAncestryQuery, ListUsersByFullAncestryQueryVariables>;
export const MostReadContentsAdminAdminSummaryDocument = gql`
    query MostReadContentsAdminAdminSummary($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    performanceIndicators {
      mostReadContents {
        author
        contentId
        contentType
        thumbUrl
        title
      }
      readingsCountByFormat {
        format
        readingsCount
      }
    }
  }
}
    `;

/**
 * __useMostReadContentsAdminAdminSummaryQuery__
 *
 * To run a query within a React component, call `useMostReadContentsAdminAdminSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostReadContentsAdminAdminSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostReadContentsAdminAdminSummaryQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function useMostReadContentsAdminAdminSummaryQuery(baseOptions: Apollo.QueryHookOptions<MostReadContentsAdminAdminSummaryQuery, MostReadContentsAdminAdminSummaryQueryVariables> & ({ variables: MostReadContentsAdminAdminSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MostReadContentsAdminAdminSummaryQuery, MostReadContentsAdminAdminSummaryQueryVariables>(MostReadContentsAdminAdminSummaryDocument, options);
      }
export function useMostReadContentsAdminAdminSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MostReadContentsAdminAdminSummaryQuery, MostReadContentsAdminAdminSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MostReadContentsAdminAdminSummaryQuery, MostReadContentsAdminAdminSummaryQueryVariables>(MostReadContentsAdminAdminSummaryDocument, options);
        }
export function useMostReadContentsAdminAdminSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MostReadContentsAdminAdminSummaryQuery, MostReadContentsAdminAdminSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MostReadContentsAdminAdminSummaryQuery, MostReadContentsAdminAdminSummaryQueryVariables>(MostReadContentsAdminAdminSummaryDocument, options);
        }
export type MostReadContentsAdminAdminSummaryQueryHookResult = ReturnType<typeof useMostReadContentsAdminAdminSummaryQuery>;
export type MostReadContentsAdminAdminSummaryLazyQueryHookResult = ReturnType<typeof useMostReadContentsAdminAdminSummaryLazyQuery>;
export type MostReadContentsAdminAdminSummarySuspenseQueryHookResult = ReturnType<typeof useMostReadContentsAdminAdminSummarySuspenseQuery>;
export type MostReadContentsAdminAdminSummaryQueryResult = Apollo.QueryResult<MostReadContentsAdminAdminSummaryQuery, MostReadContentsAdminAdminSummaryQueryVariables>;
export const RecommendationsAdminSummaryDocument = gql`
    query RecommendationsAdminSummary($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    performanceIndicators {
      mostIndicatedContents {
        author
        contentId
        contentType
        thumbUrl
        title
      }
    }
  }
}
    `;

/**
 * __useRecommendationsAdminSummaryQuery__
 *
 * To run a query within a React component, call `useRecommendationsAdminSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendationsAdminSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendationsAdminSummaryQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function useRecommendationsAdminSummaryQuery(baseOptions: Apollo.QueryHookOptions<RecommendationsAdminSummaryQuery, RecommendationsAdminSummaryQueryVariables> & ({ variables: RecommendationsAdminSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendationsAdminSummaryQuery, RecommendationsAdminSummaryQueryVariables>(RecommendationsAdminSummaryDocument, options);
      }
export function useRecommendationsAdminSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendationsAdminSummaryQuery, RecommendationsAdminSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendationsAdminSummaryQuery, RecommendationsAdminSummaryQueryVariables>(RecommendationsAdminSummaryDocument, options);
        }
export function useRecommendationsAdminSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendationsAdminSummaryQuery, RecommendationsAdminSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendationsAdminSummaryQuery, RecommendationsAdminSummaryQueryVariables>(RecommendationsAdminSummaryDocument, options);
        }
export type RecommendationsAdminSummaryQueryHookResult = ReturnType<typeof useRecommendationsAdminSummaryQuery>;
export type RecommendationsAdminSummaryLazyQueryHookResult = ReturnType<typeof useRecommendationsAdminSummaryLazyQuery>;
export type RecommendationsAdminSummarySuspenseQueryHookResult = ReturnType<typeof useRecommendationsAdminSummarySuspenseQuery>;
export type RecommendationsAdminSummaryQueryResult = Apollo.QueryResult<RecommendationsAdminSummaryQuery, RecommendationsAdminSummaryQueryVariables>;
export const ActivitiesAdminSummaryDocument = gql`
    query ActivitiesAdminSummary($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    performanceIndicators {
      reviewedActivitiesCount
      startedActivitiesCount
      pendingReviewActivitiesCount
      assignedActivitiesCount
      bestBnccAbilitiesByObjectiveQuestions {
        ability
        abilityDescription
        count
      }
      worstBnccAbilitiesByObjectiveQuestions {
        ability
        abilityDescription
        count
      }
    }
  }
}
    `;

/**
 * __useActivitiesAdminSummaryQuery__
 *
 * To run a query within a React component, call `useActivitiesAdminSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesAdminSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesAdminSummaryQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function useActivitiesAdminSummaryQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesAdminSummaryQuery, ActivitiesAdminSummaryQueryVariables> & ({ variables: ActivitiesAdminSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesAdminSummaryQuery, ActivitiesAdminSummaryQueryVariables>(ActivitiesAdminSummaryDocument, options);
      }
export function useActivitiesAdminSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesAdminSummaryQuery, ActivitiesAdminSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesAdminSummaryQuery, ActivitiesAdminSummaryQueryVariables>(ActivitiesAdminSummaryDocument, options);
        }
export function useActivitiesAdminSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesAdminSummaryQuery, ActivitiesAdminSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitiesAdminSummaryQuery, ActivitiesAdminSummaryQueryVariables>(ActivitiesAdminSummaryDocument, options);
        }
export type ActivitiesAdminSummaryQueryHookResult = ReturnType<typeof useActivitiesAdminSummaryQuery>;
export type ActivitiesAdminSummaryLazyQueryHookResult = ReturnType<typeof useActivitiesAdminSummaryLazyQuery>;
export type ActivitiesAdminSummarySuspenseQueryHookResult = ReturnType<typeof useActivitiesAdminSummarySuspenseQuery>;
export type ActivitiesAdminSummaryQueryResult = Apollo.QueryResult<ActivitiesAdminSummaryQuery, ActivitiesAdminSummaryQueryVariables>;
export const PerformanceSummaryActivitiesDocument = gql`
    query PerformanceSummaryActivities($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    performanceIndicators {
      completedActivitiesCountToDate
      completedActivitiesTrendForCurrentWeek
    }
  }
}
    `;

/**
 * __usePerformanceSummaryActivitiesQuery__
 *
 * To run a query within a React component, call `usePerformanceSummaryActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceSummaryActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceSummaryActivitiesQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function usePerformanceSummaryActivitiesQuery(baseOptions: Apollo.QueryHookOptions<PerformanceSummaryActivitiesQuery, PerformanceSummaryActivitiesQueryVariables> & ({ variables: PerformanceSummaryActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceSummaryActivitiesQuery, PerformanceSummaryActivitiesQueryVariables>(PerformanceSummaryActivitiesDocument, options);
      }
export function usePerformanceSummaryActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceSummaryActivitiesQuery, PerformanceSummaryActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceSummaryActivitiesQuery, PerformanceSummaryActivitiesQueryVariables>(PerformanceSummaryActivitiesDocument, options);
        }
export function usePerformanceSummaryActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceSummaryActivitiesQuery, PerformanceSummaryActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceSummaryActivitiesQuery, PerformanceSummaryActivitiesQueryVariables>(PerformanceSummaryActivitiesDocument, options);
        }
export type PerformanceSummaryActivitiesQueryHookResult = ReturnType<typeof usePerformanceSummaryActivitiesQuery>;
export type PerformanceSummaryActivitiesLazyQueryHookResult = ReturnType<typeof usePerformanceSummaryActivitiesLazyQuery>;
export type PerformanceSummaryActivitiesSuspenseQueryHookResult = ReturnType<typeof usePerformanceSummaryActivitiesSuspenseQuery>;
export type PerformanceSummaryActivitiesQueryResult = Apollo.QueryResult<PerformanceSummaryActivitiesQuery, PerformanceSummaryActivitiesQueryVariables>;
export const PerformanceSummaryReadingsDocument = gql`
    query PerformanceSummaryReadings($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    performanceIndicators {
      readingsCountToDate
      readingsTrendForCurrentWeek
    }
  }
}
    `;

/**
 * __usePerformanceSummaryReadingsQuery__
 *
 * To run a query within a React component, call `usePerformanceSummaryReadingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceSummaryReadingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceSummaryReadingsQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function usePerformanceSummaryReadingsQuery(baseOptions: Apollo.QueryHookOptions<PerformanceSummaryReadingsQuery, PerformanceSummaryReadingsQueryVariables> & ({ variables: PerformanceSummaryReadingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceSummaryReadingsQuery, PerformanceSummaryReadingsQueryVariables>(PerformanceSummaryReadingsDocument, options);
      }
export function usePerformanceSummaryReadingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceSummaryReadingsQuery, PerformanceSummaryReadingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceSummaryReadingsQuery, PerformanceSummaryReadingsQueryVariables>(PerformanceSummaryReadingsDocument, options);
        }
export function usePerformanceSummaryReadingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceSummaryReadingsQuery, PerformanceSummaryReadingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceSummaryReadingsQuery, PerformanceSummaryReadingsQueryVariables>(PerformanceSummaryReadingsDocument, options);
        }
export type PerformanceSummaryReadingsQueryHookResult = ReturnType<typeof usePerformanceSummaryReadingsQuery>;
export type PerformanceSummaryReadingsLazyQueryHookResult = ReturnType<typeof usePerformanceSummaryReadingsLazyQuery>;
export type PerformanceSummaryReadingsSuspenseQueryHookResult = ReturnType<typeof usePerformanceSummaryReadingsSuspenseQuery>;
export type PerformanceSummaryReadingsQueryResult = Apollo.QueryResult<PerformanceSummaryReadingsQuery, PerformanceSummaryReadingsQueryVariables>;
export const PerformanceSummaryIndicationsDocument = gql`
    query PerformanceSummaryIndications($holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int, $referenceDate: IsoDate!) {
  generalSummaryReport(
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
    referenceDate: $referenceDate
  ) {
    performanceIndicators {
      indicationsCountToDate
      indicationsTrendForCurrentWeek
    }
  }
}
    `;

/**
 * __usePerformanceSummaryIndicationsQuery__
 *
 * To run a query within a React component, call `usePerformanceSummaryIndicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceSummaryIndicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceSummaryIndicationsQuery({
 *   variables: {
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      referenceDate: // value for 'referenceDate'
 *   },
 * });
 */
export function usePerformanceSummaryIndicationsQuery(baseOptions: Apollo.QueryHookOptions<PerformanceSummaryIndicationsQuery, PerformanceSummaryIndicationsQueryVariables> & ({ variables: PerformanceSummaryIndicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceSummaryIndicationsQuery, PerformanceSummaryIndicationsQueryVariables>(PerformanceSummaryIndicationsDocument, options);
      }
export function usePerformanceSummaryIndicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceSummaryIndicationsQuery, PerformanceSummaryIndicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceSummaryIndicationsQuery, PerformanceSummaryIndicationsQueryVariables>(PerformanceSummaryIndicationsDocument, options);
        }
export function usePerformanceSummaryIndicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerformanceSummaryIndicationsQuery, PerformanceSummaryIndicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerformanceSummaryIndicationsQuery, PerformanceSummaryIndicationsQueryVariables>(PerformanceSummaryIndicationsDocument, options);
        }
export type PerformanceSummaryIndicationsQueryHookResult = ReturnType<typeof usePerformanceSummaryIndicationsQuery>;
export type PerformanceSummaryIndicationsLazyQueryHookResult = ReturnType<typeof usePerformanceSummaryIndicationsLazyQuery>;
export type PerformanceSummaryIndicationsSuspenseQueryHookResult = ReturnType<typeof usePerformanceSummaryIndicationsSuspenseQuery>;
export type PerformanceSummaryIndicationsQueryResult = Apollo.QueryResult<PerformanceSummaryIndicationsQuery, PerformanceSummaryIndicationsQueryVariables>;
export const UsersWithRolesDocument = gql`
    query usersWithRoles($page: Int!, $perPage: Int!, $searchTerm: String, $role: Role) {
  fetchUsersWithRoles(
    page: $page
    perPage: $perPage
    searchTerm: $searchTerm
    role: $role
  ) {
    totalCount
    users {
      id
      name
      jobPositions
      roles
      teacherId
    }
  }
}
    `;

/**
 * __useUsersWithRolesQuery__
 *
 * To run a query within a React component, call `useUsersWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersWithRolesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      searchTerm: // value for 'searchTerm'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUsersWithRolesQuery(baseOptions: Apollo.QueryHookOptions<UsersWithRolesQuery, UsersWithRolesQueryVariables> & ({ variables: UsersWithRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersWithRolesQuery, UsersWithRolesQueryVariables>(UsersWithRolesDocument, options);
      }
export function useUsersWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersWithRolesQuery, UsersWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersWithRolesQuery, UsersWithRolesQueryVariables>(UsersWithRolesDocument, options);
        }
export function useUsersWithRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersWithRolesQuery, UsersWithRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersWithRolesQuery, UsersWithRolesQueryVariables>(UsersWithRolesDocument, options);
        }
export type UsersWithRolesQueryHookResult = ReturnType<typeof useUsersWithRolesQuery>;
export type UsersWithRolesLazyQueryHookResult = ReturnType<typeof useUsersWithRolesLazyQuery>;
export type UsersWithRolesSuspenseQueryHookResult = ReturnType<typeof useUsersWithRolesSuspenseQuery>;
export type UsersWithRolesQueryResult = Apollo.QueryResult<UsersWithRolesQuery, UsersWithRolesQueryVariables>;
export const ReadingReportDocument = gql`
    query readingReport($schoolId: Int!, $classId: Int!, $trademarkId: Int!, $networkId: Int!, $startDate: IsoDate!, $endDate: IsoDate!) {
  readingReport(
    schoolId: $schoolId
    classId: $classId
    trademarkId: $trademarkId
    networkId: $networkId
    startDate: $startDate
    endDate: $endDate
  ) {
    users {
      name
      timeSpent
      validTimeSpent
      finalGrade
      readerId
    }
    aggregate {
      totalReadingTime
      totalValidReadingTime
      totalCorrectQuestions
      totalUsers
    }
  }
}
    `;

/**
 * __useReadingReportQuery__
 *
 * To run a query within a React component, call `useReadingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadingReportQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useReadingReportQuery(baseOptions: Apollo.QueryHookOptions<ReadingReportQuery, ReadingReportQueryVariables> & ({ variables: ReadingReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadingReportQuery, ReadingReportQueryVariables>(ReadingReportDocument, options);
      }
export function useReadingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadingReportQuery, ReadingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadingReportQuery, ReadingReportQueryVariables>(ReadingReportDocument, options);
        }
export function useReadingReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadingReportQuery, ReadingReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadingReportQuery, ReadingReportQueryVariables>(ReadingReportDocument, options);
        }
export type ReadingReportQueryHookResult = ReturnType<typeof useReadingReportQuery>;
export type ReadingReportLazyQueryHookResult = ReturnType<typeof useReadingReportLazyQuery>;
export type ReadingReportSuspenseQueryHookResult = ReturnType<typeof useReadingReportSuspenseQuery>;
export type ReadingReportQueryResult = Apollo.QueryResult<ReadingReportQuery, ReadingReportQueryVariables>;
export const ReadingReportByReaderIdDocument = gql`
    query readingReportByReaderId($readerId: Int!, $startDate: IsoDate!, $endDate: IsoDate!) {
  readingReportByReaderId(
    readerId: $readerId
    startDate: $startDate
    endDate: $endDate
  ) {
    userName
    readingData {
      name
      thumbnailUrl
      slug
      timeSpent
      validTimeSpent
      finalGrade
    }
  }
}
    `;

/**
 * __useReadingReportByReaderIdQuery__
 *
 * To run a query within a React component, call `useReadingReportByReaderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadingReportByReaderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadingReportByReaderIdQuery({
 *   variables: {
 *      readerId: // value for 'readerId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useReadingReportByReaderIdQuery(baseOptions: Apollo.QueryHookOptions<ReadingReportByReaderIdQuery, ReadingReportByReaderIdQueryVariables> & ({ variables: ReadingReportByReaderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadingReportByReaderIdQuery, ReadingReportByReaderIdQueryVariables>(ReadingReportByReaderIdDocument, options);
      }
export function useReadingReportByReaderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadingReportByReaderIdQuery, ReadingReportByReaderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadingReportByReaderIdQuery, ReadingReportByReaderIdQueryVariables>(ReadingReportByReaderIdDocument, options);
        }
export function useReadingReportByReaderIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadingReportByReaderIdQuery, ReadingReportByReaderIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadingReportByReaderIdQuery, ReadingReportByReaderIdQueryVariables>(ReadingReportByReaderIdDocument, options);
        }
export type ReadingReportByReaderIdQueryHookResult = ReturnType<typeof useReadingReportByReaderIdQuery>;
export type ReadingReportByReaderIdLazyQueryHookResult = ReturnType<typeof useReadingReportByReaderIdLazyQuery>;
export type ReadingReportByReaderIdSuspenseQueryHookResult = ReturnType<typeof useReadingReportByReaderIdSuspenseQuery>;
export type ReadingReportByReaderIdQueryResult = Apollo.QueryResult<ReadingReportByReaderIdQuery, ReadingReportByReaderIdQueryVariables>;
export const GeneralVisionReportDocument = gql`
    query generalVisionReport($startDate: IsoDate!, $endDate: IsoDate!, $trademarkId: Int, $networkId: Int, $schoolId: Int, $page: Int, $perPage: Int) {
  generalVision(
    startDate: $startDate
    endDate: $endDate
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    page: $page
    perPage: $perPage
  ) {
    currentEntity {
      entityId
      entityName
    }
    summaryData {
      activeUsers
      totalUsers
      activeUsersPercentage
      averageReadingTimeByUser
      averageCorrectAnswersByUser
      totalBooksRead
      totalArticlesRead
    }
    data {
      id
      entityName
      activeUsersPercentage
      totalUsers
      activeUsers
      averageReadingTime
      correctAnswersPercentage
      totalAnswers
      correctAnswers
      averageCorrectAnswersByUser
      totalBooksRead
      totalArticlesRead
    }
    totalCount
  }
}
    `;

/**
 * __useGeneralVisionReportQuery__
 *
 * To run a query within a React component, call `useGeneralVisionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralVisionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralVisionReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGeneralVisionReportQuery(baseOptions: Apollo.QueryHookOptions<GeneralVisionReportQuery, GeneralVisionReportQueryVariables> & ({ variables: GeneralVisionReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralVisionReportQuery, GeneralVisionReportQueryVariables>(GeneralVisionReportDocument, options);
      }
export function useGeneralVisionReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralVisionReportQuery, GeneralVisionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralVisionReportQuery, GeneralVisionReportQueryVariables>(GeneralVisionReportDocument, options);
        }
export function useGeneralVisionReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralVisionReportQuery, GeneralVisionReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralVisionReportQuery, GeneralVisionReportQueryVariables>(GeneralVisionReportDocument, options);
        }
export type GeneralVisionReportQueryHookResult = ReturnType<typeof useGeneralVisionReportQuery>;
export type GeneralVisionReportLazyQueryHookResult = ReturnType<typeof useGeneralVisionReportLazyQuery>;
export type GeneralVisionReportSuspenseQueryHookResult = ReturnType<typeof useGeneralVisionReportSuspenseQuery>;
export type GeneralVisionReportQueryResult = Apollo.QueryResult<GeneralVisionReportQuery, GeneralVisionReportQueryVariables>;
export const GeneralVisionClassReportDocument = gql`
    query generalVisionClassReport($startDate: IsoDate!, $endDate: IsoDate!, $classId: Int!) {
  generalVisionClassReport(
    startDate: $startDate
    endDate: $endDate
    classId: $classId
  ) {
    currentEntity {
      entityId
      entityName
    }
    summaryData {
      activeUsers
      totalUsers
      activeUsersPercentage
      averageReadingTimeByUser
      averageCorrectAnswersByUser
      totalBooksRead
      totalArticlesRead
    }
    data {
      id
      studentName
      lastAccessDate
      readingTime
      correctAnswersPercentage
      averageCorrectAnswersByActivity
      booksRead
      articlesRead
    }
  }
}
    `;

/**
 * __useGeneralVisionClassReportQuery__
 *
 * To run a query within a React component, call `useGeneralVisionClassReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralVisionClassReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralVisionClassReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useGeneralVisionClassReportQuery(baseOptions: Apollo.QueryHookOptions<GeneralVisionClassReportQuery, GeneralVisionClassReportQueryVariables> & ({ variables: GeneralVisionClassReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralVisionClassReportQuery, GeneralVisionClassReportQueryVariables>(GeneralVisionClassReportDocument, options);
      }
export function useGeneralVisionClassReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralVisionClassReportQuery, GeneralVisionClassReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralVisionClassReportQuery, GeneralVisionClassReportQueryVariables>(GeneralVisionClassReportDocument, options);
        }
export function useGeneralVisionClassReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralVisionClassReportQuery, GeneralVisionClassReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralVisionClassReportQuery, GeneralVisionClassReportQueryVariables>(GeneralVisionClassReportDocument, options);
        }
export type GeneralVisionClassReportQueryHookResult = ReturnType<typeof useGeneralVisionClassReportQuery>;
export type GeneralVisionClassReportLazyQueryHookResult = ReturnType<typeof useGeneralVisionClassReportLazyQuery>;
export type GeneralVisionClassReportSuspenseQueryHookResult = ReturnType<typeof useGeneralVisionClassReportSuspenseQuery>;
export type GeneralVisionClassReportQueryResult = Apollo.QueryResult<GeneralVisionClassReportQuery, GeneralVisionClassReportQueryVariables>;
export const GeneralVisionUserReportDocument = gql`
    query generalVisionUserReport($startDate: IsoDate!, $endDate: IsoDate!, $userId: Int!) {
  generalVisionUserReport(
    startDate: $startDate
    endDate: $endDate
    userId: $userId
  ) {
    summaryData {
      readingTime
      correctAnswersPercentage
      averageCorrectAnswersByActivity
      totalBooksRead
    }
    data {
      id
      title
      author
      readingTime
      correctAnswersPercentage
      correctAnswers
      totalAnswers
      coverUrl
      effectiveReadingPercentage
      isSharedReading
      isDefaultReading
    }
  }
}
    `;

/**
 * __useGeneralVisionUserReportQuery__
 *
 * To run a query within a React component, call `useGeneralVisionUserReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralVisionUserReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralVisionUserReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGeneralVisionUserReportQuery(baseOptions: Apollo.QueryHookOptions<GeneralVisionUserReportQuery, GeneralVisionUserReportQueryVariables> & ({ variables: GeneralVisionUserReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralVisionUserReportQuery, GeneralVisionUserReportQueryVariables>(GeneralVisionUserReportDocument, options);
      }
export function useGeneralVisionUserReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralVisionUserReportQuery, GeneralVisionUserReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralVisionUserReportQuery, GeneralVisionUserReportQueryVariables>(GeneralVisionUserReportDocument, options);
        }
export function useGeneralVisionUserReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralVisionUserReportQuery, GeneralVisionUserReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralVisionUserReportQuery, GeneralVisionUserReportQueryVariables>(GeneralVisionUserReportDocument, options);
        }
export type GeneralVisionUserReportQueryHookResult = ReturnType<typeof useGeneralVisionUserReportQuery>;
export type GeneralVisionUserReportLazyQueryHookResult = ReturnType<typeof useGeneralVisionUserReportLazyQuery>;
export type GeneralVisionUserReportSuspenseQueryHookResult = ReturnType<typeof useGeneralVisionUserReportSuspenseQuery>;
export type GeneralVisionUserReportQueryResult = Apollo.QueryResult<GeneralVisionUserReportQuery, GeneralVisionUserReportQueryVariables>;
export const BooksReportDocument = gql`
    query booksReport($startDate: IsoDate!, $endDate: IsoDate!, $holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int) {
  booksReport(
    startDate: $startDate
    endDate: $endDate
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
  ) {
    currentEntity {
      entityId
      entityName
    }
    summaryData {
      totalBooksRead
      totalArticlesRead
      totalEffectiveReadingTime
      averageReadingTimeByUser
    }
    data {
      id
      title
      author
      totalUsersRead
      totalEffectiveReadingTime
      averageReadingTimeByUser
      coverUrl
      slug
    }
  }
}
    `;

/**
 * __useBooksReportQuery__
 *
 * To run a query within a React component, call `useBooksReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBooksReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBooksReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useBooksReportQuery(baseOptions: Apollo.QueryHookOptions<BooksReportQuery, BooksReportQueryVariables> & ({ variables: BooksReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BooksReportQuery, BooksReportQueryVariables>(BooksReportDocument, options);
      }
export function useBooksReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BooksReportQuery, BooksReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BooksReportQuery, BooksReportQueryVariables>(BooksReportDocument, options);
        }
export function useBooksReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BooksReportQuery, BooksReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BooksReportQuery, BooksReportQueryVariables>(BooksReportDocument, options);
        }
export type BooksReportQueryHookResult = ReturnType<typeof useBooksReportQuery>;
export type BooksReportLazyQueryHookResult = ReturnType<typeof useBooksReportLazyQuery>;
export type BooksReportSuspenseQueryHookResult = ReturnType<typeof useBooksReportSuspenseQuery>;
export type BooksReportQueryResult = Apollo.QueryResult<BooksReportQuery, BooksReportQueryVariables>;
export const BooksUserReportDocument = gql`
    query booksUserReport($startDate: IsoDate!, $endDate: IsoDate!, $userId: Int!) {
  booksUserReport(startDate: $startDate, endDate: $endDate, userId: $userId) {
    summaryData {
      totalBooksRead
      totalArticlesRead
      averageReadingByDay
      totalEffectiveReadingTime
    }
    data {
      id
      title
      author
      slug
      coverUrl
      lastReadingDate
      totalReadingTime
      totalEffectiveReadingTime
      effectiveReadingPercentage
      hasAudioRecording
      isSharedReading
      isDefaultReading
    }
  }
}
    `;

/**
 * __useBooksUserReportQuery__
 *
 * To run a query within a React component, call `useBooksUserReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBooksUserReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBooksUserReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBooksUserReportQuery(baseOptions: Apollo.QueryHookOptions<BooksUserReportQuery, BooksUserReportQueryVariables> & ({ variables: BooksUserReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BooksUserReportQuery, BooksUserReportQueryVariables>(BooksUserReportDocument, options);
      }
export function useBooksUserReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BooksUserReportQuery, BooksUserReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BooksUserReportQuery, BooksUserReportQueryVariables>(BooksUserReportDocument, options);
        }
export function useBooksUserReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BooksUserReportQuery, BooksUserReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BooksUserReportQuery, BooksUserReportQueryVariables>(BooksUserReportDocument, options);
        }
export type BooksUserReportQueryHookResult = ReturnType<typeof useBooksUserReportQuery>;
export type BooksUserReportLazyQueryHookResult = ReturnType<typeof useBooksUserReportLazyQuery>;
export type BooksUserReportSuspenseQueryHookResult = ReturnType<typeof useBooksUserReportSuspenseQuery>;
export type BooksUserReportQueryResult = Apollo.QueryResult<BooksUserReportQuery, BooksUserReportQueryVariables>;
export const BookDetailReportDocument = gql`
    query bookDetailReport($startDate: IsoDate!, $endDate: IsoDate!, $classId: Int!, $bookId: Int!) {
  bookDetailReport(
    startDate: $startDate
    endDate: $endDate
    classId: $classId
    bookId: $bookId
  ) {
    data {
      id
      name
      lastReadDate
      readingTime
      effectiveReadingTime
      effectiveReadingPercentage
      hasAudioRecording
    }
  }
}
    `;

/**
 * __useBookDetailReportQuery__
 *
 * To run a query within a React component, call `useBookDetailReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookDetailReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookDetailReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      classId: // value for 'classId'
 *      bookId: // value for 'bookId'
 *   },
 * });
 */
export function useBookDetailReportQuery(baseOptions: Apollo.QueryHookOptions<BookDetailReportQuery, BookDetailReportQueryVariables> & ({ variables: BookDetailReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookDetailReportQuery, BookDetailReportQueryVariables>(BookDetailReportDocument, options);
      }
export function useBookDetailReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookDetailReportQuery, BookDetailReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookDetailReportQuery, BookDetailReportQueryVariables>(BookDetailReportDocument, options);
        }
export function useBookDetailReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookDetailReportQuery, BookDetailReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookDetailReportQuery, BookDetailReportQueryVariables>(BookDetailReportDocument, options);
        }
export type BookDetailReportQueryHookResult = ReturnType<typeof useBookDetailReportQuery>;
export type BookDetailReportLazyQueryHookResult = ReturnType<typeof useBookDetailReportLazyQuery>;
export type BookDetailReportSuspenseQueryHookResult = ReturnType<typeof useBookDetailReportSuspenseQuery>;
export type BookDetailReportQueryResult = Apollo.QueryResult<BookDetailReportQuery, BookDetailReportQueryVariables>;
export const ActivitiesReportDocument = gql`
    query activitiesReport($startDate: IsoDate!, $endDate: IsoDate!, $holdingId: Int, $trademarkId: Int, $networkId: Int, $schoolId: Int, $classId: Int) {
  activitiesReport(
    startDate: $startDate
    endDate: $endDate
    holdingId: $holdingId
    trademarkId: $trademarkId
    networkId: $networkId
    schoolId: $schoolId
    classId: $classId
  ) {
    currentEntity {
      entityId
      entityName
    }
    summaryData {
      totalCorrectAnswers
      totalAnswers
      averageCorrectAnswersByUser
    }
    data {
      id
      title
      totalQuestions
      usersAnswered
      averageCorrectAnswersByUser
    }
  }
}
    `;

/**
 * __useActivitiesReportQuery__
 *
 * To run a query within a React component, call `useActivitiesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      holdingId: // value for 'holdingId'
 *      trademarkId: // value for 'trademarkId'
 *      networkId: // value for 'networkId'
 *      schoolId: // value for 'schoolId'
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useActivitiesReportQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesReportQuery, ActivitiesReportQueryVariables> & ({ variables: ActivitiesReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesReportQuery, ActivitiesReportQueryVariables>(ActivitiesReportDocument, options);
      }
export function useActivitiesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesReportQuery, ActivitiesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesReportQuery, ActivitiesReportQueryVariables>(ActivitiesReportDocument, options);
        }
export function useActivitiesReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesReportQuery, ActivitiesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitiesReportQuery, ActivitiesReportQueryVariables>(ActivitiesReportDocument, options);
        }
export type ActivitiesReportQueryHookResult = ReturnType<typeof useActivitiesReportQuery>;
export type ActivitiesReportLazyQueryHookResult = ReturnType<typeof useActivitiesReportLazyQuery>;
export type ActivitiesReportSuspenseQueryHookResult = ReturnType<typeof useActivitiesReportSuspenseQuery>;
export type ActivitiesReportQueryResult = Apollo.QueryResult<ActivitiesReportQuery, ActivitiesReportQueryVariables>;
export const ActivitiesUserReportDocument = gql`
    query activitiesUserReport($startDate: IsoDate!, $endDate: IsoDate!, $userId: Int!) {
  activitiesUserReport(startDate: $startDate, endDate: $endDate, userId: $userId) {
    summaryData {
      totalActivities
      totalCorrectAnswersPercentage
      totalAnswers
      totalCorrectAnswers
      averageCorrectAnswerByActivity
    }
    data {
      id
      title
      totalQuestions
      status
      percentageCorrectAnswer
      correctAnswers
      totalAnswers
    }
  }
}
    `;

/**
 * __useActivitiesUserReportQuery__
 *
 * To run a query within a React component, call `useActivitiesUserReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesUserReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesUserReportQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useActivitiesUserReportQuery(baseOptions: Apollo.QueryHookOptions<ActivitiesUserReportQuery, ActivitiesUserReportQueryVariables> & ({ variables: ActivitiesUserReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesUserReportQuery, ActivitiesUserReportQueryVariables>(ActivitiesUserReportDocument, options);
      }
export function useActivitiesUserReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesUserReportQuery, ActivitiesUserReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesUserReportQuery, ActivitiesUserReportQueryVariables>(ActivitiesUserReportDocument, options);
        }
export function useActivitiesUserReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivitiesUserReportQuery, ActivitiesUserReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivitiesUserReportQuery, ActivitiesUserReportQueryVariables>(ActivitiesUserReportDocument, options);
        }
export type ActivitiesUserReportQueryHookResult = ReturnType<typeof useActivitiesUserReportQuery>;
export type ActivitiesUserReportLazyQueryHookResult = ReturnType<typeof useActivitiesUserReportLazyQuery>;
export type ActivitiesUserReportSuspenseQueryHookResult = ReturnType<typeof useActivitiesUserReportSuspenseQuery>;
export type ActivitiesUserReportQueryResult = Apollo.QueryResult<ActivitiesUserReportQuery, ActivitiesUserReportQueryVariables>;
export const ActivityDetailReportV2Document = gql`
    query activityDetailReportV2($classId: Int!, $activityId: Int!) {
  activityDetailReport(classId: $classId, activityId: $activityId) {
    id
    name
    status
    correctAnswers
    totalAnswers
    answeredQuestions
    answersIsCorrect
    readerId
    appliedActivityId
  }
}
    `;

/**
 * __useActivityDetailReportV2Query__
 *
 * To run a query within a React component, call `useActivityDetailReportV2Query` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailReportV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailReportV2Query({
 *   variables: {
 *      classId: // value for 'classId'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityDetailReportV2Query(baseOptions: Apollo.QueryHookOptions<ActivityDetailReportV2Query, ActivityDetailReportV2QueryVariables> & ({ variables: ActivityDetailReportV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailReportV2Query, ActivityDetailReportV2QueryVariables>(ActivityDetailReportV2Document, options);
      }
export function useActivityDetailReportV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailReportV2Query, ActivityDetailReportV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailReportV2Query, ActivityDetailReportV2QueryVariables>(ActivityDetailReportV2Document, options);
        }
export function useActivityDetailReportV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityDetailReportV2Query, ActivityDetailReportV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityDetailReportV2Query, ActivityDetailReportV2QueryVariables>(ActivityDetailReportV2Document, options);
        }
export type ActivityDetailReportV2QueryHookResult = ReturnType<typeof useActivityDetailReportV2Query>;
export type ActivityDetailReportV2LazyQueryHookResult = ReturnType<typeof useActivityDetailReportV2LazyQuery>;
export type ActivityDetailReportV2SuspenseQueryHookResult = ReturnType<typeof useActivityDetailReportV2SuspenseQuery>;
export type ActivityDetailReportV2QueryResult = Apollo.QueryResult<ActivityDetailReportV2Query, ActivityDetailReportV2QueryVariables>;
export const GetUserContentRecordingsDocument = gql`
    query getUserContentRecordings($userId: Int!, $contentIdentifier: String!, $contentType: String!) {
  getUserContentRecordings(
    userId: $userId
    contentIdentifier: $contentIdentifier
    contentType: $contentType
  ) {
    id
    userId
    contentIdentifier
    contentType
    audioS3Key
    evaluationResponse
    createdAt
    updatedAt
    audioUrl
  }
}
    `;

/**
 * __useGetUserContentRecordingsQuery__
 *
 * To run a query within a React component, call `useGetUserContentRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContentRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContentRecordingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      contentIdentifier: // value for 'contentIdentifier'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useGetUserContentRecordingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserContentRecordingsQuery, GetUserContentRecordingsQueryVariables> & ({ variables: GetUserContentRecordingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserContentRecordingsQuery, GetUserContentRecordingsQueryVariables>(GetUserContentRecordingsDocument, options);
      }
export function useGetUserContentRecordingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserContentRecordingsQuery, GetUserContentRecordingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserContentRecordingsQuery, GetUserContentRecordingsQueryVariables>(GetUserContentRecordingsDocument, options);
        }
export function useGetUserContentRecordingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserContentRecordingsQuery, GetUserContentRecordingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserContentRecordingsQuery, GetUserContentRecordingsQueryVariables>(GetUserContentRecordingsDocument, options);
        }
export type GetUserContentRecordingsQueryHookResult = ReturnType<typeof useGetUserContentRecordingsQuery>;
export type GetUserContentRecordingsLazyQueryHookResult = ReturnType<typeof useGetUserContentRecordingsLazyQuery>;
export type GetUserContentRecordingsSuspenseQueryHookResult = ReturnType<typeof useGetUserContentRecordingsSuspenseQuery>;
export type GetUserContentRecordingsQueryResult = Apollo.QueryResult<GetUserContentRecordingsQuery, GetUserContentRecordingsQueryVariables>;
export const GetRecordingUrlDocument = gql`
    query getRecordingUrl($recordingId: Int!) {
  getRecordingUrl(recordingId: $recordingId)
}
    `;

/**
 * __useGetRecordingUrlQuery__
 *
 * To run a query within a React component, call `useGetRecordingUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingUrlQuery({
 *   variables: {
 *      recordingId: // value for 'recordingId'
 *   },
 * });
 */
export function useGetRecordingUrlQuery(baseOptions: Apollo.QueryHookOptions<GetRecordingUrlQuery, GetRecordingUrlQueryVariables> & ({ variables: GetRecordingUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordingUrlQuery, GetRecordingUrlQueryVariables>(GetRecordingUrlDocument, options);
      }
export function useGetRecordingUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordingUrlQuery, GetRecordingUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordingUrlQuery, GetRecordingUrlQueryVariables>(GetRecordingUrlDocument, options);
        }
export function useGetRecordingUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecordingUrlQuery, GetRecordingUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecordingUrlQuery, GetRecordingUrlQueryVariables>(GetRecordingUrlDocument, options);
        }
export type GetRecordingUrlQueryHookResult = ReturnType<typeof useGetRecordingUrlQuery>;
export type GetRecordingUrlLazyQueryHookResult = ReturnType<typeof useGetRecordingUrlLazyQuery>;
export type GetRecordingUrlSuspenseQueryHookResult = ReturnType<typeof useGetRecordingUrlSuspenseQuery>;
export type GetRecordingUrlQueryResult = Apollo.QueryResult<GetRecordingUrlQuery, GetRecordingUrlQueryVariables>;
export const GetEntityDocument = gql`
    query GetEntity($id: Int!, $page: Int, $perPage: Int) {
  getEntity(id: $id) {
    id
    childrenCount
    name
    ancestry
    ancestryDetails {
      id
      name
    }
    type
    userCount
    children(page: $page, perPage: $perPage) {
      childrenCount
      id
      name
      ancestry
      userCount
      degree
    }
  }
}
    `;

/**
 * __useGetEntityQuery__
 *
 * To run a query within a React component, call `useGetEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetEntityQuery(baseOptions: Apollo.QueryHookOptions<GetEntityQuery, GetEntityQueryVariables> & ({ variables: GetEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityQuery, GetEntityQueryVariables>(GetEntityDocument, options);
      }
export function useGetEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityQuery, GetEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityQuery, GetEntityQueryVariables>(GetEntityDocument, options);
        }
export function useGetEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntityQuery, GetEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityQuery, GetEntityQueryVariables>(GetEntityDocument, options);
        }
export type GetEntityQueryHookResult = ReturnType<typeof useGetEntityQuery>;
export type GetEntityLazyQueryHookResult = ReturnType<typeof useGetEntityLazyQuery>;
export type GetEntitySuspenseQueryHookResult = ReturnType<typeof useGetEntitySuspenseQuery>;
export type GetEntityQueryResult = Apollo.QueryResult<GetEntityQuery, GetEntityQueryVariables>;
export const GetEntityReadersPaginatedDocument = gql`
    query GetEntityReadersPaginated($id: Int!, $page: Int, $perPage: Int) {
  getEntity(id: $id) {
    id
    readersPerPage(page: $page, perPage: $perPage) {
      accessExpireDate
      accessToken
      email
      id
      name
      permissions
      teacherId
      teacherPermissions
      userId
    }
  }
}
    `;

/**
 * __useGetEntityReadersPaginatedQuery__
 *
 * To run a query within a React component, call `useGetEntityReadersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityReadersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityReadersPaginatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetEntityReadersPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetEntityReadersPaginatedQuery, GetEntityReadersPaginatedQueryVariables> & ({ variables: GetEntityReadersPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityReadersPaginatedQuery, GetEntityReadersPaginatedQueryVariables>(GetEntityReadersPaginatedDocument, options);
      }
export function useGetEntityReadersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityReadersPaginatedQuery, GetEntityReadersPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityReadersPaginatedQuery, GetEntityReadersPaginatedQueryVariables>(GetEntityReadersPaginatedDocument, options);
        }
export function useGetEntityReadersPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntityReadersPaginatedQuery, GetEntityReadersPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityReadersPaginatedQuery, GetEntityReadersPaginatedQueryVariables>(GetEntityReadersPaginatedDocument, options);
        }
export type GetEntityReadersPaginatedQueryHookResult = ReturnType<typeof useGetEntityReadersPaginatedQuery>;
export type GetEntityReadersPaginatedLazyQueryHookResult = ReturnType<typeof useGetEntityReadersPaginatedLazyQuery>;
export type GetEntityReadersPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetEntityReadersPaginatedSuspenseQuery>;
export type GetEntityReadersPaginatedQueryResult = Apollo.QueryResult<GetEntityReadersPaginatedQuery, GetEntityReadersPaginatedQueryVariables>;
export const GetEntityBasicInfoDocument = gql`
    query GetEntityBasicInfo($id: Int!) {
  getEntity(id: $id) {
    id
    name
    ancestry
    ancestryDetails {
      id
      name
    }
    type
  }
}
    `;

/**
 * __useGetEntityBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetEntityBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEntityBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<GetEntityBasicInfoQuery, GetEntityBasicInfoQueryVariables> & ({ variables: GetEntityBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityBasicInfoQuery, GetEntityBasicInfoQueryVariables>(GetEntityBasicInfoDocument, options);
      }
export function useGetEntityBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityBasicInfoQuery, GetEntityBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityBasicInfoQuery, GetEntityBasicInfoQueryVariables>(GetEntityBasicInfoDocument, options);
        }
export function useGetEntityBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntityBasicInfoQuery, GetEntityBasicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityBasicInfoQuery, GetEntityBasicInfoQueryVariables>(GetEntityBasicInfoDocument, options);
        }
export type GetEntityBasicInfoQueryHookResult = ReturnType<typeof useGetEntityBasicInfoQuery>;
export type GetEntityBasicInfoLazyQueryHookResult = ReturnType<typeof useGetEntityBasicInfoLazyQuery>;
export type GetEntityBasicInfoSuspenseQueryHookResult = ReturnType<typeof useGetEntityBasicInfoSuspenseQuery>;
export type GetEntityBasicInfoQueryResult = Apollo.QueryResult<GetEntityBasicInfoQuery, GetEntityBasicInfoQueryVariables>;
export const GetReadersLastPresenceEventDocument = gql`
    query GetReadersLastPresenceEvent($id: Int!, $page: Int, $perPage: Int) {
  getEntity(id: $id) {
    id
    readersPerPage(page: $page, perPage: $perPage) {
      id
      name
      lastPresenceEvent {
        createdAt
        name
      }
    }
  }
}
    `;

/**
 * __useGetReadersLastPresenceEventQuery__
 *
 * To run a query within a React component, call `useGetReadersLastPresenceEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadersLastPresenceEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReadersLastPresenceEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetReadersLastPresenceEventQuery(baseOptions: Apollo.QueryHookOptions<GetReadersLastPresenceEventQuery, GetReadersLastPresenceEventQueryVariables> & ({ variables: GetReadersLastPresenceEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReadersLastPresenceEventQuery, GetReadersLastPresenceEventQueryVariables>(GetReadersLastPresenceEventDocument, options);
      }
export function useGetReadersLastPresenceEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReadersLastPresenceEventQuery, GetReadersLastPresenceEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReadersLastPresenceEventQuery, GetReadersLastPresenceEventQueryVariables>(GetReadersLastPresenceEventDocument, options);
        }
export function useGetReadersLastPresenceEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReadersLastPresenceEventQuery, GetReadersLastPresenceEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReadersLastPresenceEventQuery, GetReadersLastPresenceEventQueryVariables>(GetReadersLastPresenceEventDocument, options);
        }
export type GetReadersLastPresenceEventQueryHookResult = ReturnType<typeof useGetReadersLastPresenceEventQuery>;
export type GetReadersLastPresenceEventLazyQueryHookResult = ReturnType<typeof useGetReadersLastPresenceEventLazyQuery>;
export type GetReadersLastPresenceEventSuspenseQueryHookResult = ReturnType<typeof useGetReadersLastPresenceEventSuspenseQuery>;
export type GetReadersLastPresenceEventQueryResult = Apollo.QueryResult<GetReadersLastPresenceEventQuery, GetReadersLastPresenceEventQueryVariables>;
export const GetEntityReadersWithLastRunningRecordsDocument = gql`
    query GetEntityReadersWithLastRunningRecords($id: Int!, $perPage: Int, $page: Int) {
  getEntity(id: $id) {
    id
    userCount
    readersPerPage(perPage: $perPage, page: $page) {
      id
      name
      userId
      lastRunningRecordsResult {
        lastAssessmentDate
        currentLeveling
      }
    }
  }
}
    `;

/**
 * __useGetEntityReadersWithLastRunningRecordsQuery__
 *
 * To run a query within a React component, call `useGetEntityReadersWithLastRunningRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityReadersWithLastRunningRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityReadersWithLastRunningRecordsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetEntityReadersWithLastRunningRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetEntityReadersWithLastRunningRecordsQuery, GetEntityReadersWithLastRunningRecordsQueryVariables> & ({ variables: GetEntityReadersWithLastRunningRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityReadersWithLastRunningRecordsQuery, GetEntityReadersWithLastRunningRecordsQueryVariables>(GetEntityReadersWithLastRunningRecordsDocument, options);
      }
export function useGetEntityReadersWithLastRunningRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityReadersWithLastRunningRecordsQuery, GetEntityReadersWithLastRunningRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityReadersWithLastRunningRecordsQuery, GetEntityReadersWithLastRunningRecordsQueryVariables>(GetEntityReadersWithLastRunningRecordsDocument, options);
        }
export function useGetEntityReadersWithLastRunningRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntityReadersWithLastRunningRecordsQuery, GetEntityReadersWithLastRunningRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityReadersWithLastRunningRecordsQuery, GetEntityReadersWithLastRunningRecordsQueryVariables>(GetEntityReadersWithLastRunningRecordsDocument, options);
        }
export type GetEntityReadersWithLastRunningRecordsQueryHookResult = ReturnType<typeof useGetEntityReadersWithLastRunningRecordsQuery>;
export type GetEntityReadersWithLastRunningRecordsLazyQueryHookResult = ReturnType<typeof useGetEntityReadersWithLastRunningRecordsLazyQuery>;
export type GetEntityReadersWithLastRunningRecordsSuspenseQueryHookResult = ReturnType<typeof useGetEntityReadersWithLastRunningRecordsSuspenseQuery>;
export type GetEntityReadersWithLastRunningRecordsQueryResult = Apollo.QueryResult<GetEntityReadersWithLastRunningRecordsQuery, GetEntityReadersWithLastRunningRecordsQueryVariables>;
export const GetEntityChildrenWithBasicInfoPaginatedDocument = gql`
    query GetEntityChildrenWithBasicInfoPaginated($id: Int!, $perPage: Int!, $page: Int!) {
  getEntity(id: $id) {
    id
    degree
    children(perPage: $perPage, page: $page) {
      id
      name
      degree
      type
    }
  }
}
    `;

/**
 * __useGetEntityChildrenWithBasicInfoPaginatedQuery__
 *
 * To run a query within a React component, call `useGetEntityChildrenWithBasicInfoPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityChildrenWithBasicInfoPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityChildrenWithBasicInfoPaginatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetEntityChildrenWithBasicInfoPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetEntityChildrenWithBasicInfoPaginatedQuery, GetEntityChildrenWithBasicInfoPaginatedQueryVariables> & ({ variables: GetEntityChildrenWithBasicInfoPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityChildrenWithBasicInfoPaginatedQuery, GetEntityChildrenWithBasicInfoPaginatedQueryVariables>(GetEntityChildrenWithBasicInfoPaginatedDocument, options);
      }
export function useGetEntityChildrenWithBasicInfoPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityChildrenWithBasicInfoPaginatedQuery, GetEntityChildrenWithBasicInfoPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityChildrenWithBasicInfoPaginatedQuery, GetEntityChildrenWithBasicInfoPaginatedQueryVariables>(GetEntityChildrenWithBasicInfoPaginatedDocument, options);
        }
export function useGetEntityChildrenWithBasicInfoPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntityChildrenWithBasicInfoPaginatedQuery, GetEntityChildrenWithBasicInfoPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityChildrenWithBasicInfoPaginatedQuery, GetEntityChildrenWithBasicInfoPaginatedQueryVariables>(GetEntityChildrenWithBasicInfoPaginatedDocument, options);
        }
export type GetEntityChildrenWithBasicInfoPaginatedQueryHookResult = ReturnType<typeof useGetEntityChildrenWithBasicInfoPaginatedQuery>;
export type GetEntityChildrenWithBasicInfoPaginatedLazyQueryHookResult = ReturnType<typeof useGetEntityChildrenWithBasicInfoPaginatedLazyQuery>;
export type GetEntityChildrenWithBasicInfoPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetEntityChildrenWithBasicInfoPaginatedSuspenseQuery>;
export type GetEntityChildrenWithBasicInfoPaginatedQueryResult = Apollo.QueryResult<GetEntityChildrenWithBasicInfoPaginatedQuery, GetEntityChildrenWithBasicInfoPaginatedQueryVariables>;
export const GetEntitiesByAncestryDocument = gql`
    query GetEntitiesByAncestry($rootId: String!) {
  getEntitiesByAncestry(rootId: $rootId) {
    id
    name
    ancestry
  }
}
    `;

/**
 * __useGetEntitiesByAncestryQuery__
 *
 * To run a query within a React component, call `useGetEntitiesByAncestryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitiesByAncestryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitiesByAncestryQuery({
 *   variables: {
 *      rootId: // value for 'rootId'
 *   },
 * });
 */
export function useGetEntitiesByAncestryQuery(baseOptions: Apollo.QueryHookOptions<GetEntitiesByAncestryQuery, GetEntitiesByAncestryQueryVariables> & ({ variables: GetEntitiesByAncestryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntitiesByAncestryQuery, GetEntitiesByAncestryQueryVariables>(GetEntitiesByAncestryDocument, options);
      }
export function useGetEntitiesByAncestryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntitiesByAncestryQuery, GetEntitiesByAncestryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntitiesByAncestryQuery, GetEntitiesByAncestryQueryVariables>(GetEntitiesByAncestryDocument, options);
        }
export function useGetEntitiesByAncestrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntitiesByAncestryQuery, GetEntitiesByAncestryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntitiesByAncestryQuery, GetEntitiesByAncestryQueryVariables>(GetEntitiesByAncestryDocument, options);
        }
export type GetEntitiesByAncestryQueryHookResult = ReturnType<typeof useGetEntitiesByAncestryQuery>;
export type GetEntitiesByAncestryLazyQueryHookResult = ReturnType<typeof useGetEntitiesByAncestryLazyQuery>;
export type GetEntitiesByAncestrySuspenseQueryHookResult = ReturnType<typeof useGetEntitiesByAncestrySuspenseQuery>;
export type GetEntitiesByAncestryQueryResult = Apollo.QueryResult<GetEntitiesByAncestryQuery, GetEntitiesByAncestryQueryVariables>;
export const GetBookSnippetSelectedDocument = gql`
    query getBookSnippetSelected {
  getBookSnippetSelected {
    textInHtml
    rawText
    wordCount
    book {
      name
      author
    }
  }
}
    `;

/**
 * __useGetBookSnippetSelectedQuery__
 *
 * To run a query within a React component, call `useGetBookSnippetSelectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookSnippetSelectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookSnippetSelectedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookSnippetSelectedQuery(baseOptions?: Apollo.QueryHookOptions<GetBookSnippetSelectedQuery, GetBookSnippetSelectedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookSnippetSelectedQuery, GetBookSnippetSelectedQueryVariables>(GetBookSnippetSelectedDocument, options);
      }
export function useGetBookSnippetSelectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookSnippetSelectedQuery, GetBookSnippetSelectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookSnippetSelectedQuery, GetBookSnippetSelectedQueryVariables>(GetBookSnippetSelectedDocument, options);
        }
export function useGetBookSnippetSelectedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookSnippetSelectedQuery, GetBookSnippetSelectedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookSnippetSelectedQuery, GetBookSnippetSelectedQueryVariables>(GetBookSnippetSelectedDocument, options);
        }
export type GetBookSnippetSelectedQueryHookResult = ReturnType<typeof useGetBookSnippetSelectedQuery>;
export type GetBookSnippetSelectedLazyQueryHookResult = ReturnType<typeof useGetBookSnippetSelectedLazyQuery>;
export type GetBookSnippetSelectedSuspenseQueryHookResult = ReturnType<typeof useGetBookSnippetSelectedSuspenseQuery>;
export type GetBookSnippetSelectedQueryResult = Apollo.QueryResult<GetBookSnippetSelectedQuery, GetBookSnippetSelectedQueryVariables>;
export const ReadingFluencyAssessmentAvailableDocument = gql`
    query readingFluencyAssessmentAvailable {
  me {
    id
    reader {
      id
      readingFluencyAssessmentAvailable
    }
  }
}
    `;

/**
 * __useReadingFluencyAssessmentAvailableQuery__
 *
 * To run a query within a React component, call `useReadingFluencyAssessmentAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadingFluencyAssessmentAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadingFluencyAssessmentAvailableQuery({
 *   variables: {
 *   },
 * });
 */
export function useReadingFluencyAssessmentAvailableQuery(baseOptions?: Apollo.QueryHookOptions<ReadingFluencyAssessmentAvailableQuery, ReadingFluencyAssessmentAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadingFluencyAssessmentAvailableQuery, ReadingFluencyAssessmentAvailableQueryVariables>(ReadingFluencyAssessmentAvailableDocument, options);
      }
export function useReadingFluencyAssessmentAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadingFluencyAssessmentAvailableQuery, ReadingFluencyAssessmentAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadingFluencyAssessmentAvailableQuery, ReadingFluencyAssessmentAvailableQueryVariables>(ReadingFluencyAssessmentAvailableDocument, options);
        }
export function useReadingFluencyAssessmentAvailableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadingFluencyAssessmentAvailableQuery, ReadingFluencyAssessmentAvailableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadingFluencyAssessmentAvailableQuery, ReadingFluencyAssessmentAvailableQueryVariables>(ReadingFluencyAssessmentAvailableDocument, options);
        }
export type ReadingFluencyAssessmentAvailableQueryHookResult = ReturnType<typeof useReadingFluencyAssessmentAvailableQuery>;
export type ReadingFluencyAssessmentAvailableLazyQueryHookResult = ReturnType<typeof useReadingFluencyAssessmentAvailableLazyQuery>;
export type ReadingFluencyAssessmentAvailableSuspenseQueryHookResult = ReturnType<typeof useReadingFluencyAssessmentAvailableSuspenseQuery>;
export type ReadingFluencyAssessmentAvailableQueryResult = Apollo.QueryResult<ReadingFluencyAssessmentAvailableQuery, ReadingFluencyAssessmentAvailableQueryVariables>;
export const GetClassesWithReadingFluencyAssessmentDocument = gql`
    query getClassesWithReadingFluencyAssessment {
  getClassesWithReadingFluencyAssessment {
    id
    name
  }
}
    `;

/**
 * __useGetClassesWithReadingFluencyAssessmentQuery__
 *
 * To run a query within a React component, call `useGetClassesWithReadingFluencyAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassesWithReadingFluencyAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassesWithReadingFluencyAssessmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClassesWithReadingFluencyAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<GetClassesWithReadingFluencyAssessmentQuery, GetClassesWithReadingFluencyAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassesWithReadingFluencyAssessmentQuery, GetClassesWithReadingFluencyAssessmentQueryVariables>(GetClassesWithReadingFluencyAssessmentDocument, options);
      }
export function useGetClassesWithReadingFluencyAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassesWithReadingFluencyAssessmentQuery, GetClassesWithReadingFluencyAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassesWithReadingFluencyAssessmentQuery, GetClassesWithReadingFluencyAssessmentQueryVariables>(GetClassesWithReadingFluencyAssessmentDocument, options);
        }
export function useGetClassesWithReadingFluencyAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassesWithReadingFluencyAssessmentQuery, GetClassesWithReadingFluencyAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassesWithReadingFluencyAssessmentQuery, GetClassesWithReadingFluencyAssessmentQueryVariables>(GetClassesWithReadingFluencyAssessmentDocument, options);
        }
export type GetClassesWithReadingFluencyAssessmentQueryHookResult = ReturnType<typeof useGetClassesWithReadingFluencyAssessmentQuery>;
export type GetClassesWithReadingFluencyAssessmentLazyQueryHookResult = ReturnType<typeof useGetClassesWithReadingFluencyAssessmentLazyQuery>;
export type GetClassesWithReadingFluencyAssessmentSuspenseQueryHookResult = ReturnType<typeof useGetClassesWithReadingFluencyAssessmentSuspenseQuery>;
export type GetClassesWithReadingFluencyAssessmentQueryResult = Apollo.QueryResult<GetClassesWithReadingFluencyAssessmentQuery, GetClassesWithReadingFluencyAssessmentQueryVariables>;
export const GetClassesAvailableToReadingFluencyAssessmentDocument = gql`
    query GetClassesAvailableToReadingFluencyAssessment {
  getClassesAvailableToReadingFluencyAssessment {
    id
    name
  }
}
    `;

/**
 * __useGetClassesAvailableToReadingFluencyAssessmentQuery__
 *
 * To run a query within a React component, call `useGetClassesAvailableToReadingFluencyAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassesAvailableToReadingFluencyAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassesAvailableToReadingFluencyAssessmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClassesAvailableToReadingFluencyAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<GetClassesAvailableToReadingFluencyAssessmentQuery, GetClassesAvailableToReadingFluencyAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassesAvailableToReadingFluencyAssessmentQuery, GetClassesAvailableToReadingFluencyAssessmentQueryVariables>(GetClassesAvailableToReadingFluencyAssessmentDocument, options);
      }
export function useGetClassesAvailableToReadingFluencyAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassesAvailableToReadingFluencyAssessmentQuery, GetClassesAvailableToReadingFluencyAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassesAvailableToReadingFluencyAssessmentQuery, GetClassesAvailableToReadingFluencyAssessmentQueryVariables>(GetClassesAvailableToReadingFluencyAssessmentDocument, options);
        }
export function useGetClassesAvailableToReadingFluencyAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClassesAvailableToReadingFluencyAssessmentQuery, GetClassesAvailableToReadingFluencyAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClassesAvailableToReadingFluencyAssessmentQuery, GetClassesAvailableToReadingFluencyAssessmentQueryVariables>(GetClassesAvailableToReadingFluencyAssessmentDocument, options);
        }
export type GetClassesAvailableToReadingFluencyAssessmentQueryHookResult = ReturnType<typeof useGetClassesAvailableToReadingFluencyAssessmentQuery>;
export type GetClassesAvailableToReadingFluencyAssessmentLazyQueryHookResult = ReturnType<typeof useGetClassesAvailableToReadingFluencyAssessmentLazyQuery>;
export type GetClassesAvailableToReadingFluencyAssessmentSuspenseQueryHookResult = ReturnType<typeof useGetClassesAvailableToReadingFluencyAssessmentSuspenseQuery>;
export type GetClassesAvailableToReadingFluencyAssessmentQueryResult = Apollo.QueryResult<GetClassesAvailableToReadingFluencyAssessmentQuery, GetClassesAvailableToReadingFluencyAssessmentQueryVariables>;
export const GetBookSnippetsByDegreeDocument = gql`
    query GetBookSnippetsByDegree($degree: String!) {
  getBookSnippetsByDegree(degree: $degree) {
    id
    rawText
    textInHtml
    wordCount
    degree
    book {
      name
      description
      slug
      author
      imageUrlThumb
    }
  }
}
    `;

/**
 * __useGetBookSnippetsByDegreeQuery__
 *
 * To run a query within a React component, call `useGetBookSnippetsByDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookSnippetsByDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookSnippetsByDegreeQuery({
 *   variables: {
 *      degree: // value for 'degree'
 *   },
 * });
 */
export function useGetBookSnippetsByDegreeQuery(baseOptions: Apollo.QueryHookOptions<GetBookSnippetsByDegreeQuery, GetBookSnippetsByDegreeQueryVariables> & ({ variables: GetBookSnippetsByDegreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookSnippetsByDegreeQuery, GetBookSnippetsByDegreeQueryVariables>(GetBookSnippetsByDegreeDocument, options);
      }
export function useGetBookSnippetsByDegreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookSnippetsByDegreeQuery, GetBookSnippetsByDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookSnippetsByDegreeQuery, GetBookSnippetsByDegreeQueryVariables>(GetBookSnippetsByDegreeDocument, options);
        }
export function useGetBookSnippetsByDegreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBookSnippetsByDegreeQuery, GetBookSnippetsByDegreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookSnippetsByDegreeQuery, GetBookSnippetsByDegreeQueryVariables>(GetBookSnippetsByDegreeDocument, options);
        }
export type GetBookSnippetsByDegreeQueryHookResult = ReturnType<typeof useGetBookSnippetsByDegreeQuery>;
export type GetBookSnippetsByDegreeLazyQueryHookResult = ReturnType<typeof useGetBookSnippetsByDegreeLazyQuery>;
export type GetBookSnippetsByDegreeSuspenseQueryHookResult = ReturnType<typeof useGetBookSnippetsByDegreeSuspenseQuery>;
export type GetBookSnippetsByDegreeQueryResult = Apollo.QueryResult<GetBookSnippetsByDegreeQuery, GetBookSnippetsByDegreeQueryVariables>;
export const StartReadingFluencyAssessmentDocument = gql`
    mutation StartReadingFluencyAssessment($name: String!, $start_date: DateTime!, $end_date: DateTime!, $entities_ids: [Int]!, $snippet_id: Int!) {
  startReadingFluencyAssessment(
    input: {name: $name, startDate: $start_date, endDate: $end_date, entitiesIds: $entities_ids, snippetId: $snippet_id}
  )
}
    `;
export type StartReadingFluencyAssessmentMutationFn = Apollo.MutationFunction<StartReadingFluencyAssessmentMutation, StartReadingFluencyAssessmentMutationVariables>;

/**
 * __useStartReadingFluencyAssessmentMutation__
 *
 * To run a mutation, you first call `useStartReadingFluencyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartReadingFluencyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startReadingFluencyAssessmentMutation, { data, loading, error }] = useStartReadingFluencyAssessmentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      entities_ids: // value for 'entities_ids'
 *      snippet_id: // value for 'snippet_id'
 *   },
 * });
 */
export function useStartReadingFluencyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<StartReadingFluencyAssessmentMutation, StartReadingFluencyAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartReadingFluencyAssessmentMutation, StartReadingFluencyAssessmentMutationVariables>(StartReadingFluencyAssessmentDocument, options);
      }
export type StartReadingFluencyAssessmentMutationHookResult = ReturnType<typeof useStartReadingFluencyAssessmentMutation>;
export type StartReadingFluencyAssessmentMutationResult = Apollo.MutationResult<StartReadingFluencyAssessmentMutation>;
export type StartReadingFluencyAssessmentMutationOptions = Apollo.BaseMutationOptions<StartReadingFluencyAssessmentMutation, StartReadingFluencyAssessmentMutationVariables>;
export const ReadingFluencyResultDocument = gql`
    query readingFluencyResult($id: Int!, $perPage: Int, $page: Int, $orderBy: String, $orderDirection: String) {
  getEntity(id: $id) {
    id
    userCount
    readingFluencyResultsForCurrentYear {
      totalUsers
      assessmentInfo {
        id
        appliedBy
        name
        startDate
        endDate
        bookSnippetName
        bookSnippetThumb
      }
      levelingResults {
        count
        percentage
        leveling
      }
      userResults {
        userId
        name
        degree
        readingFluencyResult
        correctWordsPerMinute
        assessmentDate
        canceledAt
        comprehensionLevel
      }
    }
    lastReadingFluencyResult {
      totalUsers
      levelingResults {
        count
        percentage
        leveling
      }
      assessmentInfo {
        appliedBy
        id
        name
        startDate
        endDate
        bookSnippetName
        bookSnippetThumb
      }
    }
    readersByReadingFluency(
      perPage: $perPage
      page: $page
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      name
      userId
      degree
      readingFluencyResult {
        correctWordsPerMinute
        assessmentDate
        leveling
        assessmentStatus
        comprehensionLevel
      }
    }
  }
}
    `;

/**
 * __useReadingFluencyResultQuery__
 *
 * To run a query within a React component, call `useReadingFluencyResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadingFluencyResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadingFluencyResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useReadingFluencyResultQuery(baseOptions: Apollo.QueryHookOptions<ReadingFluencyResultQuery, ReadingFluencyResultQueryVariables> & ({ variables: ReadingFluencyResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadingFluencyResultQuery, ReadingFluencyResultQueryVariables>(ReadingFluencyResultDocument, options);
      }
export function useReadingFluencyResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadingFluencyResultQuery, ReadingFluencyResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadingFluencyResultQuery, ReadingFluencyResultQueryVariables>(ReadingFluencyResultDocument, options);
        }
export function useReadingFluencyResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadingFluencyResultQuery, ReadingFluencyResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadingFluencyResultQuery, ReadingFluencyResultQueryVariables>(ReadingFluencyResultDocument, options);
        }
export type ReadingFluencyResultQueryHookResult = ReturnType<typeof useReadingFluencyResultQuery>;
export type ReadingFluencyResultLazyQueryHookResult = ReturnType<typeof useReadingFluencyResultLazyQuery>;
export type ReadingFluencyResultSuspenseQueryHookResult = ReturnType<typeof useReadingFluencyResultSuspenseQuery>;
export type ReadingFluencyResultQueryResult = Apollo.QueryResult<ReadingFluencyResultQuery, ReadingFluencyResultQueryVariables>;
export const GetUserReadingFluencyResultDocument = gql`
    query GetUserReadingFluencyResult($userId: Int!, $assessmentId: Int) {
  getUserReadingFluencyResult(userId: $userId, assessmentId: $assessmentId) {
    correctWordsPerMinute
    leveling
    assessmentDate
    successRate
    assessmentEndDate
    assessmentReapplicationLimitReached
    userName
    assessmentName
    studentDegree
    audioUrl
    audioDurationInSeconds
    textReadInHtml
    errorsByType {
      quantity
      type
    }
    snippetBook {
      name
    }
  }
  me {
    id
    serverDateTime
  }
}
    `;

/**
 * __useGetUserReadingFluencyResultQuery__
 *
 * To run a query within a React component, call `useGetUserReadingFluencyResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserReadingFluencyResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserReadingFluencyResultQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetUserReadingFluencyResultQuery(baseOptions: Apollo.QueryHookOptions<GetUserReadingFluencyResultQuery, GetUserReadingFluencyResultQueryVariables> & ({ variables: GetUserReadingFluencyResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserReadingFluencyResultQuery, GetUserReadingFluencyResultQueryVariables>(GetUserReadingFluencyResultDocument, options);
      }
export function useGetUserReadingFluencyResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserReadingFluencyResultQuery, GetUserReadingFluencyResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserReadingFluencyResultQuery, GetUserReadingFluencyResultQueryVariables>(GetUserReadingFluencyResultDocument, options);
        }
export function useGetUserReadingFluencyResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserReadingFluencyResultQuery, GetUserReadingFluencyResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserReadingFluencyResultQuery, GetUserReadingFluencyResultQueryVariables>(GetUserReadingFluencyResultDocument, options);
        }
export type GetUserReadingFluencyResultQueryHookResult = ReturnType<typeof useGetUserReadingFluencyResultQuery>;
export type GetUserReadingFluencyResultLazyQueryHookResult = ReturnType<typeof useGetUserReadingFluencyResultLazyQuery>;
export type GetUserReadingFluencyResultSuspenseQueryHookResult = ReturnType<typeof useGetUserReadingFluencyResultSuspenseQuery>;
export type GetUserReadingFluencyResultQueryResult = Apollo.QueryResult<GetUserReadingFluencyResultQuery, GetUserReadingFluencyResultQueryVariables>;
export const GetAssessmentHistoryDocument = gql`
    query GetAssessmentHistory($userId: Int!, $year: Int!) {
  getAssessmentHistory(userId: $userId, year: $year) {
    id
    assessmentName
    assessmentDate
    leveling
    correctWordsPerMinute
  }
}
    `;

/**
 * __useGetAssessmentHistoryQuery__
 *
 * To run a query within a React component, call `useGetAssessmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetAssessmentHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentHistoryQuery, GetAssessmentHistoryQueryVariables> & ({ variables: GetAssessmentHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentHistoryQuery, GetAssessmentHistoryQueryVariables>(GetAssessmentHistoryDocument, options);
      }
export function useGetAssessmentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentHistoryQuery, GetAssessmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentHistoryQuery, GetAssessmentHistoryQueryVariables>(GetAssessmentHistoryDocument, options);
        }
export function useGetAssessmentHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentHistoryQuery, GetAssessmentHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentHistoryQuery, GetAssessmentHistoryQueryVariables>(GetAssessmentHistoryDocument, options);
        }
export type GetAssessmentHistoryQueryHookResult = ReturnType<typeof useGetAssessmentHistoryQuery>;
export type GetAssessmentHistoryLazyQueryHookResult = ReturnType<typeof useGetAssessmentHistoryLazyQuery>;
export type GetAssessmentHistorySuspenseQueryHookResult = ReturnType<typeof useGetAssessmentHistorySuspenseQuery>;
export type GetAssessmentHistoryQueryResult = Apollo.QueryResult<GetAssessmentHistoryQuery, GetAssessmentHistoryQueryVariables>;
export const CancelLastReadingFluencyAssessmentResultDocument = gql`
    mutation CancelLastReadingFluencyAssessmentResult($input: CancelLastReadingFluencyAssessmentInput!) {
  cancelLastReadingFluencyAssessmentResult(input: $input)
}
    `;
export type CancelLastReadingFluencyAssessmentResultMutationFn = Apollo.MutationFunction<CancelLastReadingFluencyAssessmentResultMutation, CancelLastReadingFluencyAssessmentResultMutationVariables>;

/**
 * __useCancelLastReadingFluencyAssessmentResultMutation__
 *
 * To run a mutation, you first call `useCancelLastReadingFluencyAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLastReadingFluencyAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLastReadingFluencyAssessmentResultMutation, { data, loading, error }] = useCancelLastReadingFluencyAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelLastReadingFluencyAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<CancelLastReadingFluencyAssessmentResultMutation, CancelLastReadingFluencyAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLastReadingFluencyAssessmentResultMutation, CancelLastReadingFluencyAssessmentResultMutationVariables>(CancelLastReadingFluencyAssessmentResultDocument, options);
      }
export type CancelLastReadingFluencyAssessmentResultMutationHookResult = ReturnType<typeof useCancelLastReadingFluencyAssessmentResultMutation>;
export type CancelLastReadingFluencyAssessmentResultMutationResult = Apollo.MutationResult<CancelLastReadingFluencyAssessmentResultMutation>;
export type CancelLastReadingFluencyAssessmentResultMutationOptions = Apollo.BaseMutationOptions<CancelLastReadingFluencyAssessmentResultMutation, CancelLastReadingFluencyAssessmentResultMutationVariables>;
export const GetWaterDropDetailsDocument = gql`
    query GetWaterDropDetails {
  me {
    id
    reader {
      id
      forest {
        id
        coins
        waterDropDetails {
          currentDrops
          dropsPerLevel
          maxDrops
          minimumLevel
          image
          percentage
          statusText
          description
        }
      }
    }
  }
}
    `;

/**
 * __useGetWaterDropDetailsQuery__
 *
 * To run a query within a React component, call `useGetWaterDropDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaterDropDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaterDropDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWaterDropDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetWaterDropDetailsQuery, GetWaterDropDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWaterDropDetailsQuery, GetWaterDropDetailsQueryVariables>(GetWaterDropDetailsDocument, options);
      }
export function useGetWaterDropDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWaterDropDetailsQuery, GetWaterDropDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWaterDropDetailsQuery, GetWaterDropDetailsQueryVariables>(GetWaterDropDetailsDocument, options);
        }
export function useGetWaterDropDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWaterDropDetailsQuery, GetWaterDropDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWaterDropDetailsQuery, GetWaterDropDetailsQueryVariables>(GetWaterDropDetailsDocument, options);
        }
export type GetWaterDropDetailsQueryHookResult = ReturnType<typeof useGetWaterDropDetailsQuery>;
export type GetWaterDropDetailsLazyQueryHookResult = ReturnType<typeof useGetWaterDropDetailsLazyQuery>;
export type GetWaterDropDetailsSuspenseQueryHookResult = ReturnType<typeof useGetWaterDropDetailsSuspenseQuery>;
export type GetWaterDropDetailsQueryResult = Apollo.QueryResult<GetWaterDropDetailsQuery, GetWaterDropDetailsQueryVariables>;
export const HasForestDocument = gql`
    query HasForest {
  me {
    id
    reader {
      id
      forest {
        id
        treeListings(count: 1) {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useHasForestQuery__
 *
 * To run a query within a React component, call `useHasForestQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasForestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasForestQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasForestQuery(baseOptions?: Apollo.QueryHookOptions<HasForestQuery, HasForestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasForestQuery, HasForestQueryVariables>(HasForestDocument, options);
      }
export function useHasForestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasForestQuery, HasForestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasForestQuery, HasForestQueryVariables>(HasForestDocument, options);
        }
export function useHasForestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasForestQuery, HasForestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasForestQuery, HasForestQueryVariables>(HasForestDocument, options);
        }
export type HasForestQueryHookResult = ReturnType<typeof useHasForestQuery>;
export type HasForestLazyQueryHookResult = ReturnType<typeof useHasForestLazyQuery>;
export type HasForestSuspenseQueryHookResult = ReturnType<typeof useHasForestSuspenseQuery>;
export type HasForestQueryResult = Apollo.QueryResult<HasForestQuery, HasForestQueryVariables>;
export const LeagueReportDocument = gql`
    query LeagueReport {
  me {
    id
    teacher {
      id
      root {
        id
        rankingRootWithTier
      }
    }
  }
}
    `;

/**
 * __useLeagueReportQuery__
 *
 * To run a query within a React component, call `useLeagueReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeagueReportQuery(baseOptions?: Apollo.QueryHookOptions<LeagueReportQuery, LeagueReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueReportQuery, LeagueReportQueryVariables>(LeagueReportDocument, options);
      }
export function useLeagueReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueReportQuery, LeagueReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueReportQuery, LeagueReportQueryVariables>(LeagueReportDocument, options);
        }
export function useLeagueReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeagueReportQuery, LeagueReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeagueReportQuery, LeagueReportQueryVariables>(LeagueReportDocument, options);
        }
export type LeagueReportQueryHookResult = ReturnType<typeof useLeagueReportQuery>;
export type LeagueReportLazyQueryHookResult = ReturnType<typeof useLeagueReportLazyQuery>;
export type LeagueReportSuspenseQueryHookResult = ReturnType<typeof useLeagueReportSuspenseQuery>;
export type LeagueReportQueryResult = Apollo.QueryResult<LeagueReportQuery, LeagueReportQueryVariables>;
export const LeagueBoardsDocument = gql`
    query LeagueBoards {
  me {
    id
    reader {
      id
      getCurrentPoints
      overallRanking(neighbors: 2) {
        points
        tier
        percentage
        rankingUsers {
          entityId
          profileId
          rankPosition
          rootName
          totalTimeSpent
          points
          userName
        }
      }
      overallRankingHistory {
        points
        month
        rankPosition
        tier
        status
      }
      entity {
        id
        degree
        ancestry
        rankingEntity {
          profileId
          rankPosition
          rootName
          tier
          totalTimeSpent
          points
          userName
        }
        rankingSchool {
          profileId
          rankPosition
          rootName
          tier
          totalTimeSpent
          points
          userName
        }
        rankingRoot {
          profileId
          rankPosition
          rootName
          tier
          totalTimeSpent
          points
          userName
        }
      }
    }
  }
}
    `;

/**
 * __useLeagueBoardsQuery__
 *
 * To run a query within a React component, call `useLeagueBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeagueBoardsQuery(baseOptions?: Apollo.QueryHookOptions<LeagueBoardsQuery, LeagueBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueBoardsQuery, LeagueBoardsQueryVariables>(LeagueBoardsDocument, options);
      }
export function useLeagueBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueBoardsQuery, LeagueBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueBoardsQuery, LeagueBoardsQueryVariables>(LeagueBoardsDocument, options);
        }
export function useLeagueBoardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeagueBoardsQuery, LeagueBoardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeagueBoardsQuery, LeagueBoardsQueryVariables>(LeagueBoardsDocument, options);
        }
export type LeagueBoardsQueryHookResult = ReturnType<typeof useLeagueBoardsQuery>;
export type LeagueBoardsLazyQueryHookResult = ReturnType<typeof useLeagueBoardsLazyQuery>;
export type LeagueBoardsSuspenseQueryHookResult = ReturnType<typeof useLeagueBoardsSuspenseQuery>;
export type LeagueBoardsQueryResult = Apollo.QueryResult<LeagueBoardsQuery, LeagueBoardsQueryVariables>;
export const LeaguePointsDocument = gql`
    query LeaguePoints {
  me {
    id
    reader {
      id
      getCurrentPoints
      overallRanking {
        points
        tier
        percentage
      }
    }
  }
}
    `;

/**
 * __useLeaguePointsQuery__
 *
 * To run a query within a React component, call `useLeaguePointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaguePointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaguePointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeaguePointsQuery(baseOptions?: Apollo.QueryHookOptions<LeaguePointsQuery, LeaguePointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaguePointsQuery, LeaguePointsQueryVariables>(LeaguePointsDocument, options);
      }
export function useLeaguePointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaguePointsQuery, LeaguePointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaguePointsQuery, LeaguePointsQueryVariables>(LeaguePointsDocument, options);
        }
export function useLeaguePointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LeaguePointsQuery, LeaguePointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LeaguePointsQuery, LeaguePointsQueryVariables>(LeaguePointsDocument, options);
        }
export type LeaguePointsQueryHookResult = ReturnType<typeof useLeaguePointsQuery>;
export type LeaguePointsLazyQueryHookResult = ReturnType<typeof useLeaguePointsLazyQuery>;
export type LeaguePointsSuspenseQueryHookResult = ReturnType<typeof useLeaguePointsSuspenseQuery>;
export type LeaguePointsQueryResult = Apollo.QueryResult<LeaguePointsQuery, LeaguePointsQueryVariables>;
export const ListLevelingsBooksDocument = gql`
    query listLevelingsBooks($page: Int, $per_page: Int) {
  me {
    id
    reader {
      id
      motrixAssessmentBooksSuggested(input: {page: $page, perPage: $per_page}) {
        name
        author
        slug
        degree
        imageUrlThumb
        language
        premiumLock
        hasAudioBook
      }
    }
  }
}
    `;

/**
 * __useListLevelingsBooksQuery__
 *
 * To run a query within a React component, call `useListLevelingsBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLevelingsBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLevelingsBooksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useListLevelingsBooksQuery(baseOptions?: Apollo.QueryHookOptions<ListLevelingsBooksQuery, ListLevelingsBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLevelingsBooksQuery, ListLevelingsBooksQueryVariables>(ListLevelingsBooksDocument, options);
      }
export function useListLevelingsBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLevelingsBooksQuery, ListLevelingsBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLevelingsBooksQuery, ListLevelingsBooksQueryVariables>(ListLevelingsBooksDocument, options);
        }
export function useListLevelingsBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLevelingsBooksQuery, ListLevelingsBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLevelingsBooksQuery, ListLevelingsBooksQueryVariables>(ListLevelingsBooksDocument, options);
        }
export type ListLevelingsBooksQueryHookResult = ReturnType<typeof useListLevelingsBooksQuery>;
export type ListLevelingsBooksLazyQueryHookResult = ReturnType<typeof useListLevelingsBooksLazyQuery>;
export type ListLevelingsBooksSuspenseQueryHookResult = ReturnType<typeof useListLevelingsBooksSuspenseQuery>;
export type ListLevelingsBooksQueryResult = Apollo.QueryResult<ListLevelingsBooksQuery, ListLevelingsBooksQueryVariables>;
export const MotrixAssessmentBooksSuggestedDocument = gql`
    query motrixAssessmentBooksSuggested {
  me {
    id
    reader {
      id
      motrixAssessmentAvailable
    }
  }
}
    `;

/**
 * __useMotrixAssessmentBooksSuggestedQuery__
 *
 * To run a query within a React component, call `useMotrixAssessmentBooksSuggestedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMotrixAssessmentBooksSuggestedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMotrixAssessmentBooksSuggestedQuery({
 *   variables: {
 *   },
 * });
 */
export function useMotrixAssessmentBooksSuggestedQuery(baseOptions?: Apollo.QueryHookOptions<MotrixAssessmentBooksSuggestedQuery, MotrixAssessmentBooksSuggestedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MotrixAssessmentBooksSuggestedQuery, MotrixAssessmentBooksSuggestedQueryVariables>(MotrixAssessmentBooksSuggestedDocument, options);
      }
export function useMotrixAssessmentBooksSuggestedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MotrixAssessmentBooksSuggestedQuery, MotrixAssessmentBooksSuggestedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MotrixAssessmentBooksSuggestedQuery, MotrixAssessmentBooksSuggestedQueryVariables>(MotrixAssessmentBooksSuggestedDocument, options);
        }
export function useMotrixAssessmentBooksSuggestedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MotrixAssessmentBooksSuggestedQuery, MotrixAssessmentBooksSuggestedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MotrixAssessmentBooksSuggestedQuery, MotrixAssessmentBooksSuggestedQueryVariables>(MotrixAssessmentBooksSuggestedDocument, options);
        }
export type MotrixAssessmentBooksSuggestedQueryHookResult = ReturnType<typeof useMotrixAssessmentBooksSuggestedQuery>;
export type MotrixAssessmentBooksSuggestedLazyQueryHookResult = ReturnType<typeof useMotrixAssessmentBooksSuggestedLazyQuery>;
export type MotrixAssessmentBooksSuggestedSuspenseQueryHookResult = ReturnType<typeof useMotrixAssessmentBooksSuggestedSuspenseQuery>;
export type MotrixAssessmentBooksSuggestedQueryResult = Apollo.QueryResult<MotrixAssessmentBooksSuggestedQuery, MotrixAssessmentBooksSuggestedQueryVariables>;
export const GetTeacherInfoDocument = gql`
    query GetTeacherInfo {
  me {
    id
    secondEmail
    phone
    teacher {
      id
      disciplines {
        title
      }
      roles {
        title
      }
      yearsResponsibleFor
    }
  }
}
    `;

/**
 * __useGetTeacherInfoQuery__
 *
 * To run a query within a React component, call `useGetTeacherInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeacherInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
      }
export function useGetTeacherInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
        }
export function useGetTeacherInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
        }
export type GetTeacherInfoQueryHookResult = ReturnType<typeof useGetTeacherInfoQuery>;
export type GetTeacherInfoLazyQueryHookResult = ReturnType<typeof useGetTeacherInfoLazyQuery>;
export type GetTeacherInfoSuspenseQueryHookResult = ReturnType<typeof useGetTeacherInfoSuspenseQuery>;
export type GetTeacherInfoQueryResult = Apollo.QueryResult<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>;
export const FavoriteBooksQueryDocument = gql`
    query FavoriteBooksQuery {
  me {
    id
    reader {
      id
      favoriteBooks {
        ...bookNavigationFields
      }
    }
  }
}
    ${BookNavigationFieldsFragmentDoc}`;

/**
 * __useFavoriteBooksQueryQuery__
 *
 * To run a query within a React component, call `useFavoriteBooksQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteBooksQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteBooksQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoriteBooksQueryQuery(baseOptions?: Apollo.QueryHookOptions<FavoriteBooksQueryQuery, FavoriteBooksQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteBooksQueryQuery, FavoriteBooksQueryQueryVariables>(FavoriteBooksQueryDocument, options);
      }
export function useFavoriteBooksQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteBooksQueryQuery, FavoriteBooksQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteBooksQueryQuery, FavoriteBooksQueryQueryVariables>(FavoriteBooksQueryDocument, options);
        }
export function useFavoriteBooksQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoriteBooksQueryQuery, FavoriteBooksQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoriteBooksQueryQuery, FavoriteBooksQueryQueryVariables>(FavoriteBooksQueryDocument, options);
        }
export type FavoriteBooksQueryQueryHookResult = ReturnType<typeof useFavoriteBooksQueryQuery>;
export type FavoriteBooksQueryLazyQueryHookResult = ReturnType<typeof useFavoriteBooksQueryLazyQuery>;
export type FavoriteBooksQuerySuspenseQueryHookResult = ReturnType<typeof useFavoriteBooksQuerySuspenseQuery>;
export type FavoriteBooksQueryQueryResult = Apollo.QueryResult<FavoriteBooksQueryQuery, FavoriteBooksQueryQueryVariables>;
export const OldListReadersSameDegreeDocument = gql`
    query OldListReadersSameDegree($term: String!) {
  me {
    id
    reader {
      id
      listReadersSameDegree(term: $term)
    }
  }
}
    `;

/**
 * __useOldListReadersSameDegreeQuery__
 *
 * To run a query within a React component, call `useOldListReadersSameDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldListReadersSameDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldListReadersSameDegreeQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useOldListReadersSameDegreeQuery(baseOptions: Apollo.QueryHookOptions<OldListReadersSameDegreeQuery, OldListReadersSameDegreeQueryVariables> & ({ variables: OldListReadersSameDegreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldListReadersSameDegreeQuery, OldListReadersSameDegreeQueryVariables>(OldListReadersSameDegreeDocument, options);
      }
export function useOldListReadersSameDegreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldListReadersSameDegreeQuery, OldListReadersSameDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldListReadersSameDegreeQuery, OldListReadersSameDegreeQueryVariables>(OldListReadersSameDegreeDocument, options);
        }
export function useOldListReadersSameDegreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldListReadersSameDegreeQuery, OldListReadersSameDegreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldListReadersSameDegreeQuery, OldListReadersSameDegreeQueryVariables>(OldListReadersSameDegreeDocument, options);
        }
export type OldListReadersSameDegreeQueryHookResult = ReturnType<typeof useOldListReadersSameDegreeQuery>;
export type OldListReadersSameDegreeLazyQueryHookResult = ReturnType<typeof useOldListReadersSameDegreeLazyQuery>;
export type OldListReadersSameDegreeSuspenseQueryHookResult = ReturnType<typeof useOldListReadersSameDegreeSuspenseQuery>;
export type OldListReadersSameDegreeQueryResult = Apollo.QueryResult<OldListReadersSameDegreeQuery, OldListReadersSameDegreeQueryVariables>;
export const EntitiesSubtreeFlatQueryDocument = gql`
    query EntitiesSubtreeFlatQuery {
  me {
    id
    teacher {
      id
      entitiesSubtreeFlat
    }
  }
}
    `;

/**
 * __useEntitiesSubtreeFlatQueryQuery__
 *
 * To run a query within a React component, call `useEntitiesSubtreeFlatQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesSubtreeFlatQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesSubtreeFlatQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitiesSubtreeFlatQueryQuery(baseOptions?: Apollo.QueryHookOptions<EntitiesSubtreeFlatQueryQuery, EntitiesSubtreeFlatQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesSubtreeFlatQueryQuery, EntitiesSubtreeFlatQueryQueryVariables>(EntitiesSubtreeFlatQueryDocument, options);
      }
export function useEntitiesSubtreeFlatQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesSubtreeFlatQueryQuery, EntitiesSubtreeFlatQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesSubtreeFlatQueryQuery, EntitiesSubtreeFlatQueryQueryVariables>(EntitiesSubtreeFlatQueryDocument, options);
        }
export function useEntitiesSubtreeFlatQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesSubtreeFlatQueryQuery, EntitiesSubtreeFlatQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesSubtreeFlatQueryQuery, EntitiesSubtreeFlatQueryQueryVariables>(EntitiesSubtreeFlatQueryDocument, options);
        }
export type EntitiesSubtreeFlatQueryQueryHookResult = ReturnType<typeof useEntitiesSubtreeFlatQueryQuery>;
export type EntitiesSubtreeFlatQueryLazyQueryHookResult = ReturnType<typeof useEntitiesSubtreeFlatQueryLazyQuery>;
export type EntitiesSubtreeFlatQuerySuspenseQueryHookResult = ReturnType<typeof useEntitiesSubtreeFlatQuerySuspenseQuery>;
export type EntitiesSubtreeFlatQueryQueryResult = Apollo.QueryResult<EntitiesSubtreeFlatQueryQuery, EntitiesSubtreeFlatQueryQueryVariables>;
export const OldSearchAvailableReadersToIndicateDocument = gql`
    query OldSearchAvailableReadersToIndicate($term: String!) {
  me {
    id
    teacher {
      id
      searchAvailableReadersToIndicate(term: $term)
    }
  }
}
    `;

/**
 * __useOldSearchAvailableReadersToIndicateQuery__
 *
 * To run a query within a React component, call `useOldSearchAvailableReadersToIndicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldSearchAvailableReadersToIndicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldSearchAvailableReadersToIndicateQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useOldSearchAvailableReadersToIndicateQuery(baseOptions: Apollo.QueryHookOptions<OldSearchAvailableReadersToIndicateQuery, OldSearchAvailableReadersToIndicateQueryVariables> & ({ variables: OldSearchAvailableReadersToIndicateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldSearchAvailableReadersToIndicateQuery, OldSearchAvailableReadersToIndicateQueryVariables>(OldSearchAvailableReadersToIndicateDocument, options);
      }
export function useOldSearchAvailableReadersToIndicateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldSearchAvailableReadersToIndicateQuery, OldSearchAvailableReadersToIndicateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldSearchAvailableReadersToIndicateQuery, OldSearchAvailableReadersToIndicateQueryVariables>(OldSearchAvailableReadersToIndicateDocument, options);
        }
export function useOldSearchAvailableReadersToIndicateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldSearchAvailableReadersToIndicateQuery, OldSearchAvailableReadersToIndicateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldSearchAvailableReadersToIndicateQuery, OldSearchAvailableReadersToIndicateQueryVariables>(OldSearchAvailableReadersToIndicateDocument, options);
        }
export type OldSearchAvailableReadersToIndicateQueryHookResult = ReturnType<typeof useOldSearchAvailableReadersToIndicateQuery>;
export type OldSearchAvailableReadersToIndicateLazyQueryHookResult = ReturnType<typeof useOldSearchAvailableReadersToIndicateLazyQuery>;
export type OldSearchAvailableReadersToIndicateSuspenseQueryHookResult = ReturnType<typeof useOldSearchAvailableReadersToIndicateSuspenseQuery>;
export type OldSearchAvailableReadersToIndicateQueryResult = Apollo.QueryResult<OldSearchAvailableReadersToIndicateQuery, OldSearchAvailableReadersToIndicateQueryVariables>;
export const BookBasicInfoDocument = gql`
    query BookBasicInfo($slug: String!) {
  bookDetails(slug: $slug) {
    ...bookNavigationFields
  }
}
    ${BookNavigationFieldsFragmentDoc}`;

/**
 * __useBookBasicInfoQuery__
 *
 * To run a query within a React component, call `useBookBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookBasicInfoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBookBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<BookBasicInfoQuery, BookBasicInfoQueryVariables> & ({ variables: BookBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookBasicInfoQuery, BookBasicInfoQueryVariables>(BookBasicInfoDocument, options);
      }
export function useBookBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookBasicInfoQuery, BookBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookBasicInfoQuery, BookBasicInfoQueryVariables>(BookBasicInfoDocument, options);
        }
export function useBookBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookBasicInfoQuery, BookBasicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookBasicInfoQuery, BookBasicInfoQueryVariables>(BookBasicInfoDocument, options);
        }
export type BookBasicInfoQueryHookResult = ReturnType<typeof useBookBasicInfoQuery>;
export type BookBasicInfoLazyQueryHookResult = ReturnType<typeof useBookBasicInfoLazyQuery>;
export type BookBasicInfoSuspenseQueryHookResult = ReturnType<typeof useBookBasicInfoSuspenseQuery>;
export type BookBasicInfoQueryResult = Apollo.QueryResult<BookBasicInfoQuery, BookBasicInfoQueryVariables>;
export const CollectionDocument = gql`
    query collection($collectionId: Int!) {
  me {
    id
    reader {
      id
      collection(id: $collectionId) {
        id
        name
        image
        bgColor
        description
        books {
          author
          degree
          description
          edition
          imageUrlIntermediaria
          imageUrlThumb
          name
          readingLevel
          series
          slug
          subtitle
          hasAudioBook
        }
      }
    }
  }
}
    `;

/**
 * __useCollectionQuery__
 *
 * To run a query within a React component, call `useCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useCollectionQuery(baseOptions: Apollo.QueryHookOptions<CollectionQuery, CollectionQueryVariables> & ({ variables: CollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
      }
export function useCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
        }
export function useCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
        }
export type CollectionQueryHookResult = ReturnType<typeof useCollectionQuery>;
export type CollectionLazyQueryHookResult = ReturnType<typeof useCollectionLazyQuery>;
export type CollectionSuspenseQueryHookResult = ReturnType<typeof useCollectionSuspenseQuery>;
export type CollectionQueryResult = Apollo.QueryResult<CollectionQuery, CollectionQueryVariables>;
export const SearchAllAvailableBooksDocument = gql`
    query SearchAllAvailableBooks($searchTerm: String!, $page: Int) {
  searchAllAvailableBooks(searchTerm: $searchTerm, page: $page) {
    ...bookNavigationFields
  }
}
    ${BookNavigationFieldsFragmentDoc}`;

/**
 * __useSearchAllAvailableBooksQuery__
 *
 * To run a query within a React component, call `useSearchAllAvailableBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAllAvailableBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAllAvailableBooksQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchAllAvailableBooksQuery(baseOptions: Apollo.QueryHookOptions<SearchAllAvailableBooksQuery, SearchAllAvailableBooksQueryVariables> & ({ variables: SearchAllAvailableBooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAllAvailableBooksQuery, SearchAllAvailableBooksQueryVariables>(SearchAllAvailableBooksDocument, options);
      }
export function useSearchAllAvailableBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAllAvailableBooksQuery, SearchAllAvailableBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAllAvailableBooksQuery, SearchAllAvailableBooksQueryVariables>(SearchAllAvailableBooksDocument, options);
        }
export function useSearchAllAvailableBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAllAvailableBooksQuery, SearchAllAvailableBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAllAvailableBooksQuery, SearchAllAvailableBooksQueryVariables>(SearchAllAvailableBooksDocument, options);
        }
export type SearchAllAvailableBooksQueryHookResult = ReturnType<typeof useSearchAllAvailableBooksQuery>;
export type SearchAllAvailableBooksLazyQueryHookResult = ReturnType<typeof useSearchAllAvailableBooksLazyQuery>;
export type SearchAllAvailableBooksSuspenseQueryHookResult = ReturnType<typeof useSearchAllAvailableBooksSuspenseQuery>;
export type SearchAllAvailableBooksQueryResult = Apollo.QueryResult<SearchAllAvailableBooksQuery, SearchAllAvailableBooksQueryVariables>;
export const OldSearchBookForAutoCompleteDocument = gql`
    query OldSearchBookForAutoComplete($searchTerm: String!) {
  searchBook(searchTerm: $searchTerm) {
    name
    slug
  }
}
    `;

/**
 * __useOldSearchBookForAutoCompleteQuery__
 *
 * To run a query within a React component, call `useOldSearchBookForAutoCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldSearchBookForAutoCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldSearchBookForAutoCompleteQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useOldSearchBookForAutoCompleteQuery(baseOptions: Apollo.QueryHookOptions<OldSearchBookForAutoCompleteQuery, OldSearchBookForAutoCompleteQueryVariables> & ({ variables: OldSearchBookForAutoCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldSearchBookForAutoCompleteQuery, OldSearchBookForAutoCompleteQueryVariables>(OldSearchBookForAutoCompleteDocument, options);
      }
export function useOldSearchBookForAutoCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldSearchBookForAutoCompleteQuery, OldSearchBookForAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldSearchBookForAutoCompleteQuery, OldSearchBookForAutoCompleteQueryVariables>(OldSearchBookForAutoCompleteDocument, options);
        }
export function useOldSearchBookForAutoCompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldSearchBookForAutoCompleteQuery, OldSearchBookForAutoCompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldSearchBookForAutoCompleteQuery, OldSearchBookForAutoCompleteQueryVariables>(OldSearchBookForAutoCompleteDocument, options);
        }
export type OldSearchBookForAutoCompleteQueryHookResult = ReturnType<typeof useOldSearchBookForAutoCompleteQuery>;
export type OldSearchBookForAutoCompleteLazyQueryHookResult = ReturnType<typeof useOldSearchBookForAutoCompleteLazyQuery>;
export type OldSearchBookForAutoCompleteSuspenseQueryHookResult = ReturnType<typeof useOldSearchBookForAutoCompleteSuspenseQuery>;
export type OldSearchBookForAutoCompleteQueryResult = Apollo.QueryResult<OldSearchBookForAutoCompleteQuery, OldSearchBookForAutoCompleteQueryVariables>;
export const OldSearchBookForAutoCompleteActivityDocument = gql`
    query OldSearchBookForAutoCompleteActivity($searchTerm: String!) {
  searchBook(searchTerm: $searchTerm) {
    name
    slug
  }
}
    `;

/**
 * __useOldSearchBookForAutoCompleteActivityQuery__
 *
 * To run a query within a React component, call `useOldSearchBookForAutoCompleteActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldSearchBookForAutoCompleteActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldSearchBookForAutoCompleteActivityQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useOldSearchBookForAutoCompleteActivityQuery(baseOptions: Apollo.QueryHookOptions<OldSearchBookForAutoCompleteActivityQuery, OldSearchBookForAutoCompleteActivityQueryVariables> & ({ variables: OldSearchBookForAutoCompleteActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldSearchBookForAutoCompleteActivityQuery, OldSearchBookForAutoCompleteActivityQueryVariables>(OldSearchBookForAutoCompleteActivityDocument, options);
      }
export function useOldSearchBookForAutoCompleteActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldSearchBookForAutoCompleteActivityQuery, OldSearchBookForAutoCompleteActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldSearchBookForAutoCompleteActivityQuery, OldSearchBookForAutoCompleteActivityQueryVariables>(OldSearchBookForAutoCompleteActivityDocument, options);
        }
export function useOldSearchBookForAutoCompleteActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldSearchBookForAutoCompleteActivityQuery, OldSearchBookForAutoCompleteActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldSearchBookForAutoCompleteActivityQuery, OldSearchBookForAutoCompleteActivityQueryVariables>(OldSearchBookForAutoCompleteActivityDocument, options);
        }
export type OldSearchBookForAutoCompleteActivityQueryHookResult = ReturnType<typeof useOldSearchBookForAutoCompleteActivityQuery>;
export type OldSearchBookForAutoCompleteActivityLazyQueryHookResult = ReturnType<typeof useOldSearchBookForAutoCompleteActivityLazyQuery>;
export type OldSearchBookForAutoCompleteActivitySuspenseQueryHookResult = ReturnType<typeof useOldSearchBookForAutoCompleteActivitySuspenseQuery>;
export type OldSearchBookForAutoCompleteActivityQueryResult = Apollo.QueryResult<OldSearchBookForAutoCompleteActivityQuery, OldSearchBookForAutoCompleteActivityQueryVariables>;
export const ListMascotsDocument = gql`
    query listMascots {
  listMascots
}
    `;

/**
 * __useListMascotsQuery__
 *
 * To run a query within a React component, call `useListMascotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMascotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMascotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMascotsQuery(baseOptions?: Apollo.QueryHookOptions<ListMascotsQuery, ListMascotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMascotsQuery, ListMascotsQueryVariables>(ListMascotsDocument, options);
      }
export function useListMascotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMascotsQuery, ListMascotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMascotsQuery, ListMascotsQueryVariables>(ListMascotsDocument, options);
        }
export function useListMascotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMascotsQuery, ListMascotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMascotsQuery, ListMascotsQueryVariables>(ListMascotsDocument, options);
        }
export type ListMascotsQueryHookResult = ReturnType<typeof useListMascotsQuery>;
export type ListMascotsLazyQueryHookResult = ReturnType<typeof useListMascotsLazyQuery>;
export type ListMascotsSuspenseQueryHookResult = ReturnType<typeof useListMascotsSuspenseQuery>;
export type ListMascotsQueryResult = Apollo.QueryResult<ListMascotsQuery, ListMascotsQueryVariables>;
export const SearchBnccAbilityForAutoCompleteDocument = gql`
    query SearchBnccAbilityForAutoComplete($term: String!) {
  searchBnccAbility(term: $term) {
    code
    description
  }
}
    `;

/**
 * __useSearchBnccAbilityForAutoCompleteQuery__
 *
 * To run a query within a React component, call `useSearchBnccAbilityForAutoCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBnccAbilityForAutoCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBnccAbilityForAutoCompleteQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchBnccAbilityForAutoCompleteQuery(baseOptions: Apollo.QueryHookOptions<SearchBnccAbilityForAutoCompleteQuery, SearchBnccAbilityForAutoCompleteQueryVariables> & ({ variables: SearchBnccAbilityForAutoCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBnccAbilityForAutoCompleteQuery, SearchBnccAbilityForAutoCompleteQueryVariables>(SearchBnccAbilityForAutoCompleteDocument, options);
      }
export function useSearchBnccAbilityForAutoCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBnccAbilityForAutoCompleteQuery, SearchBnccAbilityForAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBnccAbilityForAutoCompleteQuery, SearchBnccAbilityForAutoCompleteQueryVariables>(SearchBnccAbilityForAutoCompleteDocument, options);
        }
export function useSearchBnccAbilityForAutoCompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBnccAbilityForAutoCompleteQuery, SearchBnccAbilityForAutoCompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBnccAbilityForAutoCompleteQuery, SearchBnccAbilityForAutoCompleteQueryVariables>(SearchBnccAbilityForAutoCompleteDocument, options);
        }
export type SearchBnccAbilityForAutoCompleteQueryHookResult = ReturnType<typeof useSearchBnccAbilityForAutoCompleteQuery>;
export type SearchBnccAbilityForAutoCompleteLazyQueryHookResult = ReturnType<typeof useSearchBnccAbilityForAutoCompleteLazyQuery>;
export type SearchBnccAbilityForAutoCompleteSuspenseQueryHookResult = ReturnType<typeof useSearchBnccAbilityForAutoCompleteSuspenseQuery>;
export type SearchBnccAbilityForAutoCompleteQueryResult = Apollo.QueryResult<SearchBnccAbilityForAutoCompleteQuery, SearchBnccAbilityForAutoCompleteQueryVariables>;
export const SearchBnccTagsForAutoCompleteDocument = gql`
    query SearchBnccTagsForAutoComplete($term: String!) {
  searchBnccTags(term: $term) {
    name
  }
}
    `;

/**
 * __useSearchBnccTagsForAutoCompleteQuery__
 *
 * To run a query within a React component, call `useSearchBnccTagsForAutoCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBnccTagsForAutoCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBnccTagsForAutoCompleteQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchBnccTagsForAutoCompleteQuery(baseOptions: Apollo.QueryHookOptions<SearchBnccTagsForAutoCompleteQuery, SearchBnccTagsForAutoCompleteQueryVariables> & ({ variables: SearchBnccTagsForAutoCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBnccTagsForAutoCompleteQuery, SearchBnccTagsForAutoCompleteQueryVariables>(SearchBnccTagsForAutoCompleteDocument, options);
      }
export function useSearchBnccTagsForAutoCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBnccTagsForAutoCompleteQuery, SearchBnccTagsForAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBnccTagsForAutoCompleteQuery, SearchBnccTagsForAutoCompleteQueryVariables>(SearchBnccTagsForAutoCompleteDocument, options);
        }
export function useSearchBnccTagsForAutoCompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBnccTagsForAutoCompleteQuery, SearchBnccTagsForAutoCompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBnccTagsForAutoCompleteQuery, SearchBnccTagsForAutoCompleteQueryVariables>(SearchBnccTagsForAutoCompleteDocument, options);
        }
export type SearchBnccTagsForAutoCompleteQueryHookResult = ReturnType<typeof useSearchBnccTagsForAutoCompleteQuery>;
export type SearchBnccTagsForAutoCompleteLazyQueryHookResult = ReturnType<typeof useSearchBnccTagsForAutoCompleteLazyQuery>;
export type SearchBnccTagsForAutoCompleteSuspenseQueryHookResult = ReturnType<typeof useSearchBnccTagsForAutoCompleteSuspenseQuery>;
export type SearchBnccTagsForAutoCompleteQueryResult = Apollo.QueryResult<SearchBnccTagsForAutoCompleteQuery, SearchBnccTagsForAutoCompleteQueryVariables>;
export const SearchTextualGenresForAutoCompleteDocument = gql`
    query SearchTextualGenresForAutoComplete($term: String!) {
  searchTextualGenre(term: $term) {
    name
  }
}
    `;

/**
 * __useSearchTextualGenresForAutoCompleteQuery__
 *
 * To run a query within a React component, call `useSearchTextualGenresForAutoCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTextualGenresForAutoCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTextualGenresForAutoCompleteQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchTextualGenresForAutoCompleteQuery(baseOptions: Apollo.QueryHookOptions<SearchTextualGenresForAutoCompleteQuery, SearchTextualGenresForAutoCompleteQueryVariables> & ({ variables: SearchTextualGenresForAutoCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTextualGenresForAutoCompleteQuery, SearchTextualGenresForAutoCompleteQueryVariables>(SearchTextualGenresForAutoCompleteDocument, options);
      }
export function useSearchTextualGenresForAutoCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTextualGenresForAutoCompleteQuery, SearchTextualGenresForAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTextualGenresForAutoCompleteQuery, SearchTextualGenresForAutoCompleteQueryVariables>(SearchTextualGenresForAutoCompleteDocument, options);
        }
export function useSearchTextualGenresForAutoCompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTextualGenresForAutoCompleteQuery, SearchTextualGenresForAutoCompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTextualGenresForAutoCompleteQuery, SearchTextualGenresForAutoCompleteQueryVariables>(SearchTextualGenresForAutoCompleteDocument, options);
        }
export type SearchTextualGenresForAutoCompleteQueryHookResult = ReturnType<typeof useSearchTextualGenresForAutoCompleteQuery>;
export type SearchTextualGenresForAutoCompleteLazyQueryHookResult = ReturnType<typeof useSearchTextualGenresForAutoCompleteLazyQuery>;
export type SearchTextualGenresForAutoCompleteSuspenseQueryHookResult = ReturnType<typeof useSearchTextualGenresForAutoCompleteSuspenseQuery>;
export type SearchTextualGenresForAutoCompleteQueryResult = Apollo.QueryResult<SearchTextualGenresForAutoCompleteQuery, SearchTextualGenresForAutoCompleteQueryVariables>;
export const BooksInCategoryWithFiltersDocument = gql`
    query BooksInCategoryWithFilters($searchTerm: String!, $page: Int, $opts: String) {
  searchCategoryV2: searchCategoryV2(
    searchTerm: $searchTerm
    page: $page
    opts: $opts
  ) {
    searchFilters
    books {
      ...bookNavigationFields
    }
  }
}
    ${BookNavigationFieldsFragmentDoc}`;

/**
 * __useBooksInCategoryWithFiltersQuery__
 *
 * To run a query within a React component, call `useBooksInCategoryWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBooksInCategoryWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBooksInCategoryWithFiltersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *      opts: // value for 'opts'
 *   },
 * });
 */
export function useBooksInCategoryWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<BooksInCategoryWithFiltersQuery, BooksInCategoryWithFiltersQueryVariables> & ({ variables: BooksInCategoryWithFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BooksInCategoryWithFiltersQuery, BooksInCategoryWithFiltersQueryVariables>(BooksInCategoryWithFiltersDocument, options);
      }
export function useBooksInCategoryWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BooksInCategoryWithFiltersQuery, BooksInCategoryWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BooksInCategoryWithFiltersQuery, BooksInCategoryWithFiltersQueryVariables>(BooksInCategoryWithFiltersDocument, options);
        }
export function useBooksInCategoryWithFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BooksInCategoryWithFiltersQuery, BooksInCategoryWithFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BooksInCategoryWithFiltersQuery, BooksInCategoryWithFiltersQueryVariables>(BooksInCategoryWithFiltersDocument, options);
        }
export type BooksInCategoryWithFiltersQueryHookResult = ReturnType<typeof useBooksInCategoryWithFiltersQuery>;
export type BooksInCategoryWithFiltersLazyQueryHookResult = ReturnType<typeof useBooksInCategoryWithFiltersLazyQuery>;
export type BooksInCategoryWithFiltersSuspenseQueryHookResult = ReturnType<typeof useBooksInCategoryWithFiltersSuspenseQuery>;
export type BooksInCategoryWithFiltersQueryResult = Apollo.QueryResult<BooksInCategoryWithFiltersQuery, BooksInCategoryWithFiltersQueryVariables>;
export const AdminHomeInfosDocument = gql`
    query adminHomeInfos {
  me {
    id
    firstAccess
    teacher {
      id
      countReaders
      totalTimeSpent
      entityContentConsumptionSummary {
        openedContentCount
        fullyConsumedContentCount
      }
      indicatedBooks
      preferredBooks
      mostReaders
      mostReadersByEntity
      root {
        id
        segment
      }
    }
  }
}
    `;

/**
 * __useAdminHomeInfosQuery__
 *
 * To run a query within a React component, call `useAdminHomeInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminHomeInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminHomeInfosQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminHomeInfosQuery(baseOptions?: Apollo.QueryHookOptions<AdminHomeInfosQuery, AdminHomeInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminHomeInfosQuery, AdminHomeInfosQueryVariables>(AdminHomeInfosDocument, options);
      }
export function useAdminHomeInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminHomeInfosQuery, AdminHomeInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminHomeInfosQuery, AdminHomeInfosQueryVariables>(AdminHomeInfosDocument, options);
        }
export function useAdminHomeInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminHomeInfosQuery, AdminHomeInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminHomeInfosQuery, AdminHomeInfosQueryVariables>(AdminHomeInfosDocument, options);
        }
export type AdminHomeInfosQueryHookResult = ReturnType<typeof useAdminHomeInfosQuery>;
export type AdminHomeInfosLazyQueryHookResult = ReturnType<typeof useAdminHomeInfosLazyQuery>;
export type AdminHomeInfosSuspenseQueryHookResult = ReturnType<typeof useAdminHomeInfosSuspenseQuery>;
export type AdminHomeInfosQueryResult = Apollo.QueryResult<AdminHomeInfosQuery, AdminHomeInfosQueryVariables>;
export const PreferredBooksDocument = gql`
    query preferredBooks {
  me {
    id
    teacher {
      id
      preferredBooks
    }
  }
}
    `;

/**
 * __usePreferredBooksQuery__
 *
 * To run a query within a React component, call `usePreferredBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreferredBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreferredBooksQuery({
 *   variables: {
 *   },
 * });
 */
export function usePreferredBooksQuery(baseOptions?: Apollo.QueryHookOptions<PreferredBooksQuery, PreferredBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreferredBooksQuery, PreferredBooksQueryVariables>(PreferredBooksDocument, options);
      }
export function usePreferredBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreferredBooksQuery, PreferredBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreferredBooksQuery, PreferredBooksQueryVariables>(PreferredBooksDocument, options);
        }
export function usePreferredBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreferredBooksQuery, PreferredBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreferredBooksQuery, PreferredBooksQueryVariables>(PreferredBooksDocument, options);
        }
export type PreferredBooksQueryHookResult = ReturnType<typeof usePreferredBooksQuery>;
export type PreferredBooksLazyQueryHookResult = ReturnType<typeof usePreferredBooksLazyQuery>;
export type PreferredBooksSuspenseQueryHookResult = ReturnType<typeof usePreferredBooksSuspenseQuery>;
export type PreferredBooksQueryResult = Apollo.QueryResult<PreferredBooksQuery, PreferredBooksQueryVariables>;
export const GetInitialDataForSharedBooksPageQueryDocument = gql`
    query getInitialDataForSharedBooksPageQuery($page: Int!, $perPage: Int!) {
  me {
    id
    reader {
      id
      topGeneralSharedReadingsWeekly {
        book {
          name
          imageUrlThumb
          slug
          hasAudioBook
        }
        likedByMe
        likes
        lastUserShare
        sharedByMe
      }
      sharedReadingsBySchool: sharedReadings(
        page: $page
        perPage: $perPage
        sharedByMeOnly: false
      ) {
        book {
          name
          imageUrlThumb
          slug
          hasAudioBook
        }
        likedByMe
        likes
        lastUserShare
        shares
        sharedByMe
      }
    }
  }
}
    `;

/**
 * __useGetInitialDataForSharedBooksPageQueryQuery__
 *
 * To run a query within a React component, call `useGetInitialDataForSharedBooksPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataForSharedBooksPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataForSharedBooksPageQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetInitialDataForSharedBooksPageQueryQuery(baseOptions: Apollo.QueryHookOptions<GetInitialDataForSharedBooksPageQueryQuery, GetInitialDataForSharedBooksPageQueryQueryVariables> & ({ variables: GetInitialDataForSharedBooksPageQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataForSharedBooksPageQueryQuery, GetInitialDataForSharedBooksPageQueryQueryVariables>(GetInitialDataForSharedBooksPageQueryDocument, options);
      }
export function useGetInitialDataForSharedBooksPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataForSharedBooksPageQueryQuery, GetInitialDataForSharedBooksPageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataForSharedBooksPageQueryQuery, GetInitialDataForSharedBooksPageQueryQueryVariables>(GetInitialDataForSharedBooksPageQueryDocument, options);
        }
export function useGetInitialDataForSharedBooksPageQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInitialDataForSharedBooksPageQueryQuery, GetInitialDataForSharedBooksPageQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInitialDataForSharedBooksPageQueryQuery, GetInitialDataForSharedBooksPageQueryQueryVariables>(GetInitialDataForSharedBooksPageQueryDocument, options);
        }
export type GetInitialDataForSharedBooksPageQueryQueryHookResult = ReturnType<typeof useGetInitialDataForSharedBooksPageQueryQuery>;
export type GetInitialDataForSharedBooksPageQueryLazyQueryHookResult = ReturnType<typeof useGetInitialDataForSharedBooksPageQueryLazyQuery>;
export type GetInitialDataForSharedBooksPageQuerySuspenseQueryHookResult = ReturnType<typeof useGetInitialDataForSharedBooksPageQuerySuspenseQuery>;
export type GetInitialDataForSharedBooksPageQueryQueryResult = Apollo.QueryResult<GetInitialDataForSharedBooksPageQueryQuery, GetInitialDataForSharedBooksPageQueryQueryVariables>;
export const GetMoreSharedBooksQueryDocument = gql`
    query getMoreSharedBooksQuery($page: Int!, $perPage: Int!, $sharedByMeOnly: Boolean!) {
  me {
    id
    reader {
      id
      sharedReadings(page: $page, perPage: $perPage, sharedByMeOnly: $sharedByMeOnly) {
        book {
          name
          imageUrlThumb
          slug
          hasAudioBook
        }
        likedByMe
        likes
        lastUserShare
        shares
        sharedByMe
      }
    }
  }
}
    `;

/**
 * __useGetMoreSharedBooksQueryQuery__
 *
 * To run a query within a React component, call `useGetMoreSharedBooksQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoreSharedBooksQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoreSharedBooksQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sharedByMeOnly: // value for 'sharedByMeOnly'
 *   },
 * });
 */
export function useGetMoreSharedBooksQueryQuery(baseOptions: Apollo.QueryHookOptions<GetMoreSharedBooksQueryQuery, GetMoreSharedBooksQueryQueryVariables> & ({ variables: GetMoreSharedBooksQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoreSharedBooksQueryQuery, GetMoreSharedBooksQueryQueryVariables>(GetMoreSharedBooksQueryDocument, options);
      }
export function useGetMoreSharedBooksQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoreSharedBooksQueryQuery, GetMoreSharedBooksQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoreSharedBooksQueryQuery, GetMoreSharedBooksQueryQueryVariables>(GetMoreSharedBooksQueryDocument, options);
        }
export function useGetMoreSharedBooksQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoreSharedBooksQueryQuery, GetMoreSharedBooksQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoreSharedBooksQueryQuery, GetMoreSharedBooksQueryQueryVariables>(GetMoreSharedBooksQueryDocument, options);
        }
export type GetMoreSharedBooksQueryQueryHookResult = ReturnType<typeof useGetMoreSharedBooksQueryQuery>;
export type GetMoreSharedBooksQueryLazyQueryHookResult = ReturnType<typeof useGetMoreSharedBooksQueryLazyQuery>;
export type GetMoreSharedBooksQuerySuspenseQueryHookResult = ReturnType<typeof useGetMoreSharedBooksQuerySuspenseQuery>;
export type GetMoreSharedBooksQueryQueryResult = Apollo.QueryResult<GetMoreSharedBooksQueryQuery, GetMoreSharedBooksQueryQueryVariables>;
export const AllUserActivitiesDocument = gql`
    query allUserActivities {
  me {
    id
    serverDateTime
    reader {
      id
      listAppliedActivities
    }
  }
}
    `;

/**
 * __useAllUserActivitiesQuery__
 *
 * To run a query within a React component, call `useAllUserActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<AllUserActivitiesQuery, AllUserActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserActivitiesQuery, AllUserActivitiesQueryVariables>(AllUserActivitiesDocument, options);
      }
export function useAllUserActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserActivitiesQuery, AllUserActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserActivitiesQuery, AllUserActivitiesQueryVariables>(AllUserActivitiesDocument, options);
        }
export function useAllUserActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserActivitiesQuery, AllUserActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUserActivitiesQuery, AllUserActivitiesQueryVariables>(AllUserActivitiesDocument, options);
        }
export type AllUserActivitiesQueryHookResult = ReturnType<typeof useAllUserActivitiesQuery>;
export type AllUserActivitiesLazyQueryHookResult = ReturnType<typeof useAllUserActivitiesLazyQuery>;
export type AllUserActivitiesSuspenseQueryHookResult = ReturnType<typeof useAllUserActivitiesSuspenseQuery>;
export type AllUserActivitiesQueryResult = Apollo.QueryResult<AllUserActivitiesQuery, AllUserActivitiesQueryVariables>;
export const OldAllUserActivitiesDocument = gql`
    query oldAllUserActivities {
  me {
    id
    reader {
      id
      surveys
    }
  }
}
    `;

/**
 * __useOldAllUserActivitiesQuery__
 *
 * To run a query within a React component, call `useOldAllUserActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldAllUserActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldAllUserActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOldAllUserActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<OldAllUserActivitiesQuery, OldAllUserActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldAllUserActivitiesQuery, OldAllUserActivitiesQueryVariables>(OldAllUserActivitiesDocument, options);
      }
export function useOldAllUserActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldAllUserActivitiesQuery, OldAllUserActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldAllUserActivitiesQuery, OldAllUserActivitiesQueryVariables>(OldAllUserActivitiesDocument, options);
        }
export function useOldAllUserActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldAllUserActivitiesQuery, OldAllUserActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldAllUserActivitiesQuery, OldAllUserActivitiesQueryVariables>(OldAllUserActivitiesDocument, options);
        }
export type OldAllUserActivitiesQueryHookResult = ReturnType<typeof useOldAllUserActivitiesQuery>;
export type OldAllUserActivitiesLazyQueryHookResult = ReturnType<typeof useOldAllUserActivitiesLazyQuery>;
export type OldAllUserActivitiesSuspenseQueryHookResult = ReturnType<typeof useOldAllUserActivitiesSuspenseQuery>;
export type OldAllUserActivitiesQueryResult = Apollo.QueryResult<OldAllUserActivitiesQuery, OldAllUserActivitiesQueryVariables>;
export const SurveysOfMySchoolQueryDocument = gql`
    query surveysOfMySchoolQuery {
  me {
    id
    teacher {
      id
      surveysOfMySchool
    }
  }
}
    `;

/**
 * __useSurveysOfMySchoolQueryQuery__
 *
 * To run a query within a React component, call `useSurveysOfMySchoolQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveysOfMySchoolQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveysOfMySchoolQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSurveysOfMySchoolQueryQuery(baseOptions?: Apollo.QueryHookOptions<SurveysOfMySchoolQueryQuery, SurveysOfMySchoolQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveysOfMySchoolQueryQuery, SurveysOfMySchoolQueryQueryVariables>(SurveysOfMySchoolQueryDocument, options);
      }
export function useSurveysOfMySchoolQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveysOfMySchoolQueryQuery, SurveysOfMySchoolQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveysOfMySchoolQueryQuery, SurveysOfMySchoolQueryQueryVariables>(SurveysOfMySchoolQueryDocument, options);
        }
export function useSurveysOfMySchoolQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveysOfMySchoolQueryQuery, SurveysOfMySchoolQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveysOfMySchoolQueryQuery, SurveysOfMySchoolQueryQueryVariables>(SurveysOfMySchoolQueryDocument, options);
        }
export type SurveysOfMySchoolQueryQueryHookResult = ReturnType<typeof useSurveysOfMySchoolQueryQuery>;
export type SurveysOfMySchoolQueryLazyQueryHookResult = ReturnType<typeof useSurveysOfMySchoolQueryLazyQuery>;
export type SurveysOfMySchoolQuerySuspenseQueryHookResult = ReturnType<typeof useSurveysOfMySchoolQuerySuspenseQuery>;
export type SurveysOfMySchoolQueryQueryResult = Apollo.QueryResult<SurveysOfMySchoolQueryQuery, SurveysOfMySchoolQueryQueryVariables>;
export const AllBookshelvesDocument = gql`
    query AllBookshelves($isHighlight: Boolean!, $acervoType: String, $degreeRange: String, $contentFilter: String, $type: String, $page: Int, $perPage: Int, $active: Boolean) {
  listExistingBookshelf(
    degreeRange: $degreeRange
    isHighlight: $isHighlight
    acervoType: $acervoType
    contentFilter: $contentFilter
    type: $type
    page: $page
    perPage: $perPage
    active: $active
  ) {
    name
    active
    degreeRange
    id
    isHighlight
    type
    image
    bgColor
    description
    bookShelfItems {
      book {
        slug
        name
        imageUrlThumb
        author
        hasAudioBook
        degree
      }
      bookShelfId
      id
      mascot
    }
    bookShelfItemsCount
  }
}
    `;

/**
 * __useAllBookshelvesQuery__
 *
 * To run a query within a React component, call `useAllBookshelvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBookshelvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBookshelvesQuery({
 *   variables: {
 *      isHighlight: // value for 'isHighlight'
 *      acervoType: // value for 'acervoType'
 *      degreeRange: // value for 'degreeRange'
 *      contentFilter: // value for 'contentFilter'
 *      type: // value for 'type'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useAllBookshelvesQuery(baseOptions: Apollo.QueryHookOptions<AllBookshelvesQuery, AllBookshelvesQueryVariables> & ({ variables: AllBookshelvesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllBookshelvesQuery, AllBookshelvesQueryVariables>(AllBookshelvesDocument, options);
      }
export function useAllBookshelvesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllBookshelvesQuery, AllBookshelvesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllBookshelvesQuery, AllBookshelvesQueryVariables>(AllBookshelvesDocument, options);
        }
export function useAllBookshelvesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllBookshelvesQuery, AllBookshelvesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllBookshelvesQuery, AllBookshelvesQueryVariables>(AllBookshelvesDocument, options);
        }
export type AllBookshelvesQueryHookResult = ReturnType<typeof useAllBookshelvesQuery>;
export type AllBookshelvesLazyQueryHookResult = ReturnType<typeof useAllBookshelvesLazyQuery>;
export type AllBookshelvesSuspenseQueryHookResult = ReturnType<typeof useAllBookshelvesSuspenseQuery>;
export type AllBookshelvesQueryResult = Apollo.QueryResult<AllBookshelvesQuery, AllBookshelvesQueryVariables>;
export const ShowBookShelfOldDocument = gql`
    query showBookShelfOld($bookShelfId: Int!, $limit: Int!) {
  showBookShelf(bookShelfId: $bookShelfId) {
    name
    subtitle
    degreeRange
    contentFilter
    isHighlight
    acervoType
    id
    type
    description
    image
    bgColor
    bookShelfItems(limit: $limit) {
      book {
        slug
        name
        imageUrlThumb
        author
        hasAudioBook
        degree
        premiumLock
      }
      bookShelfId
      id
      mascot
    }
    bookShelfItemsCount
  }
}
    `;

/**
 * __useShowBookShelfOldQuery__
 *
 * To run a query within a React component, call `useShowBookShelfOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowBookShelfOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowBookShelfOldQuery({
 *   variables: {
 *      bookShelfId: // value for 'bookShelfId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useShowBookShelfOldQuery(baseOptions: Apollo.QueryHookOptions<ShowBookShelfOldQuery, ShowBookShelfOldQueryVariables> & ({ variables: ShowBookShelfOldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowBookShelfOldQuery, ShowBookShelfOldQueryVariables>(ShowBookShelfOldDocument, options);
      }
export function useShowBookShelfOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowBookShelfOldQuery, ShowBookShelfOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowBookShelfOldQuery, ShowBookShelfOldQueryVariables>(ShowBookShelfOldDocument, options);
        }
export function useShowBookShelfOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowBookShelfOldQuery, ShowBookShelfOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowBookShelfOldQuery, ShowBookShelfOldQueryVariables>(ShowBookShelfOldDocument, options);
        }
export type ShowBookShelfOldQueryHookResult = ReturnType<typeof useShowBookShelfOldQuery>;
export type ShowBookShelfOldLazyQueryHookResult = ReturnType<typeof useShowBookShelfOldLazyQuery>;
export type ShowBookShelfOldSuspenseQueryHookResult = ReturnType<typeof useShowBookShelfOldSuspenseQuery>;
export type ShowBookShelfOldQueryResult = Apollo.QueryResult<ShowBookShelfOldQuery, ShowBookShelfOldQueryVariables>;
export const GetAcervoTypesQueryDocument = gql`
    query getAcervoTypesQuery {
  getAcervoTypes
}
    `;

/**
 * __useGetAcervoTypesQueryQuery__
 *
 * To run a query within a React component, call `useGetAcervoTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcervoTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcervoTypesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAcervoTypesQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetAcervoTypesQueryQuery, GetAcervoTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcervoTypesQueryQuery, GetAcervoTypesQueryQueryVariables>(GetAcervoTypesQueryDocument, options);
      }
export function useGetAcervoTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcervoTypesQueryQuery, GetAcervoTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcervoTypesQueryQuery, GetAcervoTypesQueryQueryVariables>(GetAcervoTypesQueryDocument, options);
        }
export function useGetAcervoTypesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAcervoTypesQueryQuery, GetAcervoTypesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAcervoTypesQueryQuery, GetAcervoTypesQueryQueryVariables>(GetAcervoTypesQueryDocument, options);
        }
export type GetAcervoTypesQueryQueryHookResult = ReturnType<typeof useGetAcervoTypesQueryQuery>;
export type GetAcervoTypesQueryLazyQueryHookResult = ReturnType<typeof useGetAcervoTypesQueryLazyQuery>;
export type GetAcervoTypesQuerySuspenseQueryHookResult = ReturnType<typeof useGetAcervoTypesQuerySuspenseQuery>;
export type GetAcervoTypesQueryQueryResult = Apollo.QueryResult<GetAcervoTypesQueryQuery, GetAcervoTypesQueryQueryVariables>;
export const ListDidacticSequencesQueryDocument = gql`
    query listDidacticSequencesQuery {
  listDidacticSequences {
    id
    title
    isReady
    arvoreId
  }
}
    `;

/**
 * __useListDidacticSequencesQueryQuery__
 *
 * To run a query within a React component, call `useListDidacticSequencesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDidacticSequencesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDidacticSequencesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDidacticSequencesQueryQuery(baseOptions?: Apollo.QueryHookOptions<ListDidacticSequencesQueryQuery, ListDidacticSequencesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDidacticSequencesQueryQuery, ListDidacticSequencesQueryQueryVariables>(ListDidacticSequencesQueryDocument, options);
      }
export function useListDidacticSequencesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDidacticSequencesQueryQuery, ListDidacticSequencesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDidacticSequencesQueryQuery, ListDidacticSequencesQueryQueryVariables>(ListDidacticSequencesQueryDocument, options);
        }
export function useListDidacticSequencesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDidacticSequencesQueryQuery, ListDidacticSequencesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDidacticSequencesQueryQuery, ListDidacticSequencesQueryQueryVariables>(ListDidacticSequencesQueryDocument, options);
        }
export type ListDidacticSequencesQueryQueryHookResult = ReturnType<typeof useListDidacticSequencesQueryQuery>;
export type ListDidacticSequencesQueryLazyQueryHookResult = ReturnType<typeof useListDidacticSequencesQueryLazyQuery>;
export type ListDidacticSequencesQuerySuspenseQueryHookResult = ReturnType<typeof useListDidacticSequencesQuerySuspenseQuery>;
export type ListDidacticSequencesQueryQueryResult = Apollo.QueryResult<ListDidacticSequencesQueryQuery, ListDidacticSequencesQueryQueryVariables>;
export const ListSpecificSkillsDocument = gql`
    query ListSpecificSkills($knowledgeAreaId: Int!) {
  listSpecificSkills(knowledgeAreaId: $knowledgeAreaId) {
    description
    id
  }
}
    `;

/**
 * __useListSpecificSkillsQuery__
 *
 * To run a query within a React component, call `useListSpecificSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSpecificSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSpecificSkillsQuery({
 *   variables: {
 *      knowledgeAreaId: // value for 'knowledgeAreaId'
 *   },
 * });
 */
export function useListSpecificSkillsQuery(baseOptions: Apollo.QueryHookOptions<ListSpecificSkillsQuery, ListSpecificSkillsQueryVariables> & ({ variables: ListSpecificSkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSpecificSkillsQuery, ListSpecificSkillsQueryVariables>(ListSpecificSkillsDocument, options);
      }
export function useListSpecificSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSpecificSkillsQuery, ListSpecificSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSpecificSkillsQuery, ListSpecificSkillsQueryVariables>(ListSpecificSkillsDocument, options);
        }
export function useListSpecificSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSpecificSkillsQuery, ListSpecificSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSpecificSkillsQuery, ListSpecificSkillsQueryVariables>(ListSpecificSkillsDocument, options);
        }
export type ListSpecificSkillsQueryHookResult = ReturnType<typeof useListSpecificSkillsQuery>;
export type ListSpecificSkillsLazyQueryHookResult = ReturnType<typeof useListSpecificSkillsLazyQuery>;
export type ListSpecificSkillsSuspenseQueryHookResult = ReturnType<typeof useListSpecificSkillsSuspenseQuery>;
export type ListSpecificSkillsQueryResult = Apollo.QueryResult<ListSpecificSkillsQuery, ListSpecificSkillsQueryVariables>;
export const ListGeneralSkillsDocument = gql`
    query ListGeneralSkills {
  listGeneralSkills {
    id
    description
  }
}
    `;

/**
 * __useListGeneralSkillsQuery__
 *
 * To run a query within a React component, call `useListGeneralSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGeneralSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGeneralSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListGeneralSkillsQuery(baseOptions?: Apollo.QueryHookOptions<ListGeneralSkillsQuery, ListGeneralSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGeneralSkillsQuery, ListGeneralSkillsQueryVariables>(ListGeneralSkillsDocument, options);
      }
export function useListGeneralSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGeneralSkillsQuery, ListGeneralSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGeneralSkillsQuery, ListGeneralSkillsQueryVariables>(ListGeneralSkillsDocument, options);
        }
export function useListGeneralSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGeneralSkillsQuery, ListGeneralSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGeneralSkillsQuery, ListGeneralSkillsQueryVariables>(ListGeneralSkillsDocument, options);
        }
export type ListGeneralSkillsQueryHookResult = ReturnType<typeof useListGeneralSkillsQuery>;
export type ListGeneralSkillsLazyQueryHookResult = ReturnType<typeof useListGeneralSkillsLazyQuery>;
export type ListGeneralSkillsSuspenseQueryHookResult = ReturnType<typeof useListGeneralSkillsSuspenseQuery>;
export type ListGeneralSkillsQueryResult = Apollo.QueryResult<ListGeneralSkillsQuery, ListGeneralSkillsQueryVariables>;
export const GetDidacticSequenceDocument = gql`
    query GetDidacticSequence($didacticSequenceId: Int!) {
  getDidacticSequence(didacticSequenceId: $didacticSequenceId) {
    isFavorite
    arvoreId
    author
    contents
    evaluation
    id
    isReady
    purposes
    summary
    title
    tags {
      id
      name
    }
    activity {
      id
      description
      didacticSequenceId
      examQuestions {
        id
        baseText {
          id
          statement
        }
        bnccAbility {
          bnccAbility {
            id
            code
            description
          }
        }
        books {
          name
          slug
          imageUrlThumb
          author
        }
        commentedAnswer
        examQuestionChoices {
          examQuestionId
          id
          isCorrect
          statement
          tempImage
        }
        statement
        type
      }
      isBncc
      title
    }
    bnccAbilities {
      id
      code
      degreeRange
      description
      practiceObjectId
      practiceObject {
        name
        fieldPractice {
          name
        }
      }
    }
    bnccDegrees {
      degree
      id
    }
    books {
      name
      slug
      author
      imageUrlThumb
    }
    lessons {
      text
      id
    }
    specificSkills {
      description
      id
      knowledgeAreaId
    }
    tags {
      name
      id
    }
    textualGenres {
      name
      id
    }
  }
}
    `;

/**
 * __useGetDidacticSequenceQuery__
 *
 * To run a query within a React component, call `useGetDidacticSequenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDidacticSequenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDidacticSequenceQuery({
 *   variables: {
 *      didacticSequenceId: // value for 'didacticSequenceId'
 *   },
 * });
 */
export function useGetDidacticSequenceQuery(baseOptions: Apollo.QueryHookOptions<GetDidacticSequenceQuery, GetDidacticSequenceQueryVariables> & ({ variables: GetDidacticSequenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDidacticSequenceQuery, GetDidacticSequenceQueryVariables>(GetDidacticSequenceDocument, options);
      }
export function useGetDidacticSequenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDidacticSequenceQuery, GetDidacticSequenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDidacticSequenceQuery, GetDidacticSequenceQueryVariables>(GetDidacticSequenceDocument, options);
        }
export function useGetDidacticSequenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDidacticSequenceQuery, GetDidacticSequenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDidacticSequenceQuery, GetDidacticSequenceQueryVariables>(GetDidacticSequenceDocument, options);
        }
export type GetDidacticSequenceQueryHookResult = ReturnType<typeof useGetDidacticSequenceQuery>;
export type GetDidacticSequenceLazyQueryHookResult = ReturnType<typeof useGetDidacticSequenceLazyQuery>;
export type GetDidacticSequenceSuspenseQueryHookResult = ReturnType<typeof useGetDidacticSequenceSuspenseQuery>;
export type GetDidacticSequenceQueryResult = Apollo.QueryResult<GetDidacticSequenceQuery, GetDidacticSequenceQueryVariables>;
export const SearchDidacticSequenceDocument = gql`
    query SearchDidacticSequence($searchTerm: String!, $opts: String, $page: Int) {
  searchDidacticSequence(searchTerm: $searchTerm, opts: $opts, page: $page) {
    searchFilters
    didacticSequences {
      title
      id
      actionFields {
        id
        name
      }
      lessons {
        text
      }
      textualGenres {
        name
      }
      degrees {
        degree
      }
    }
  }
}
    `;

/**
 * __useSearchDidacticSequenceQuery__
 *
 * To run a query within a React component, call `useSearchDidacticSequenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDidacticSequenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDidacticSequenceQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      opts: // value for 'opts'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchDidacticSequenceQuery(baseOptions: Apollo.QueryHookOptions<SearchDidacticSequenceQuery, SearchDidacticSequenceQueryVariables> & ({ variables: SearchDidacticSequenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDidacticSequenceQuery, SearchDidacticSequenceQueryVariables>(SearchDidacticSequenceDocument, options);
      }
export function useSearchDidacticSequenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDidacticSequenceQuery, SearchDidacticSequenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDidacticSequenceQuery, SearchDidacticSequenceQueryVariables>(SearchDidacticSequenceDocument, options);
        }
export function useSearchDidacticSequenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDidacticSequenceQuery, SearchDidacticSequenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDidacticSequenceQuery, SearchDidacticSequenceQueryVariables>(SearchDidacticSequenceDocument, options);
        }
export type SearchDidacticSequenceQueryHookResult = ReturnType<typeof useSearchDidacticSequenceQuery>;
export type SearchDidacticSequenceLazyQueryHookResult = ReturnType<typeof useSearchDidacticSequenceLazyQuery>;
export type SearchDidacticSequenceSuspenseQueryHookResult = ReturnType<typeof useSearchDidacticSequenceSuspenseQuery>;
export type SearchDidacticSequenceQueryResult = Apollo.QueryResult<SearchDidacticSequenceQuery, SearchDidacticSequenceQueryVariables>;
export const ListDidacticSequencesDocument = gql`
    query ListDidacticSequences($favorite: Boolean, $isReady: Boolean = true) {
  listDidacticSequences(favorite: $favorite, isReady: $isReady) {
    title
    id
    bnccAbilities {
      code
      practiceObject {
        id
        name
        fieldPractice {
          id
          name
          actionField {
            id
            name
          }
        }
      }
    }
    lessons {
      text
    }
    textualGenres {
      name
    }
    bnccDegrees {
      degree
    }
  }
}
    `;

/**
 * __useListDidacticSequencesQuery__
 *
 * To run a query within a React component, call `useListDidacticSequencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDidacticSequencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDidacticSequencesQuery({
 *   variables: {
 *      favorite: // value for 'favorite'
 *      isReady: // value for 'isReady'
 *   },
 * });
 */
export function useListDidacticSequencesQuery(baseOptions?: Apollo.QueryHookOptions<ListDidacticSequencesQuery, ListDidacticSequencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDidacticSequencesQuery, ListDidacticSequencesQueryVariables>(ListDidacticSequencesDocument, options);
      }
export function useListDidacticSequencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDidacticSequencesQuery, ListDidacticSequencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDidacticSequencesQuery, ListDidacticSequencesQueryVariables>(ListDidacticSequencesDocument, options);
        }
export function useListDidacticSequencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDidacticSequencesQuery, ListDidacticSequencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDidacticSequencesQuery, ListDidacticSequencesQueryVariables>(ListDidacticSequencesDocument, options);
        }
export type ListDidacticSequencesQueryHookResult = ReturnType<typeof useListDidacticSequencesQuery>;
export type ListDidacticSequencesLazyQueryHookResult = ReturnType<typeof useListDidacticSequencesLazyQuery>;
export type ListDidacticSequencesSuspenseQueryHookResult = ReturnType<typeof useListDidacticSequencesSuspenseQuery>;
export type ListDidacticSequencesQueryResult = Apollo.QueryResult<ListDidacticSequencesQuery, ListDidacticSequencesQueryVariables>;
export const ListBnccAbilitiesForFilterDocument = gql`
    query ListBnccAbilitiesForFilter {
  listBnccAbilitiesForFilter {
    id
    code
    description
  }
}
    `;

/**
 * __useListBnccAbilitiesForFilterQuery__
 *
 * To run a query within a React component, call `useListBnccAbilitiesForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBnccAbilitiesForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBnccAbilitiesForFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useListBnccAbilitiesForFilterQuery(baseOptions?: Apollo.QueryHookOptions<ListBnccAbilitiesForFilterQuery, ListBnccAbilitiesForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBnccAbilitiesForFilterQuery, ListBnccAbilitiesForFilterQueryVariables>(ListBnccAbilitiesForFilterDocument, options);
      }
export function useListBnccAbilitiesForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBnccAbilitiesForFilterQuery, ListBnccAbilitiesForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBnccAbilitiesForFilterQuery, ListBnccAbilitiesForFilterQueryVariables>(ListBnccAbilitiesForFilterDocument, options);
        }
export function useListBnccAbilitiesForFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBnccAbilitiesForFilterQuery, ListBnccAbilitiesForFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBnccAbilitiesForFilterQuery, ListBnccAbilitiesForFilterQueryVariables>(ListBnccAbilitiesForFilterDocument, options);
        }
export type ListBnccAbilitiesForFilterQueryHookResult = ReturnType<typeof useListBnccAbilitiesForFilterQuery>;
export type ListBnccAbilitiesForFilterLazyQueryHookResult = ReturnType<typeof useListBnccAbilitiesForFilterLazyQuery>;
export type ListBnccAbilitiesForFilterSuspenseQueryHookResult = ReturnType<typeof useListBnccAbilitiesForFilterSuspenseQuery>;
export type ListBnccAbilitiesForFilterQueryResult = Apollo.QueryResult<ListBnccAbilitiesForFilterQuery, ListBnccAbilitiesForFilterQueryVariables>;
export const OldGetActivityDocument = gql`
    query OldGetActivity($activityId: Int!) {
  getActivity(activityId: $activityId) {
    id
    title
    moduleId
    description
    submittedToPublic
    isReady
    degreeRange
    authorInfo {
      facebookPhoto
      name
      school
    }
    books {
      slug
      author
      name
      imageUrlThumb
      publisher {
        id
        name
      }
    }
    articles {
      id
      image
      title
      author
      degree
      publishDate
      subtitle
    }
    publicDataActivity {
      generalSkills {
        id
        description
      }
      degreeRange
      email
      id
      objective
      publicActivityId
      school
      sourceActivityId
      tags {
        name
      }
      textualGenres {
        id
        name
      }
    }
    examQuestions {
      statement
      type
      id
      tempImage
      examQuestionMatchingPairs {
        id
        leftId
        leftStatement
        rightId
        rightStatement
      }
      examQuestionChoices {
        id
        statement
        isCorrect
        tempImage
      }
    }
  }
}
    `;

/**
 * __useOldGetActivityQuery__
 *
 * To run a query within a React component, call `useOldGetActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldGetActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldGetActivityQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useOldGetActivityQuery(baseOptions: Apollo.QueryHookOptions<OldGetActivityQuery, OldGetActivityQueryVariables> & ({ variables: OldGetActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldGetActivityQuery, OldGetActivityQueryVariables>(OldGetActivityDocument, options);
      }
export function useOldGetActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OldGetActivityQuery, OldGetActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldGetActivityQuery, OldGetActivityQueryVariables>(OldGetActivityDocument, options);
        }
export function useOldGetActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldGetActivityQuery, OldGetActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldGetActivityQuery, OldGetActivityQueryVariables>(OldGetActivityDocument, options);
        }
export type OldGetActivityQueryHookResult = ReturnType<typeof useOldGetActivityQuery>;
export type OldGetActivityLazyQueryHookResult = ReturnType<typeof useOldGetActivityLazyQuery>;
export type OldGetActivitySuspenseQueryHookResult = ReturnType<typeof useOldGetActivitySuspenseQuery>;
export type OldGetActivityQueryResult = Apollo.QueryResult<OldGetActivityQuery, OldGetActivityQueryVariables>;
export const GetPublicActivityDocument = gql`
    query GetPublicActivity($activityId: Int!) {
  getPublicActivity(activityId: $activityId) {
    id
    title
    description
    submittedToPublic
    isReady
    difficultyLevel
    estimatedCompletionTimeInSeconds
    authorInfo {
      facebookPhoto
      name
      school
    }
    books {
      slug
      author
      name
      imageUrlThumb
    }
    publicDataActivity {
      generalSkills {
        id
        description
      }
      degreeRange
      email
      id
      objective
      publicActivityId
      school
      sourceActivityId
      tags {
        name
      }
      textualGenres {
        id
        name
      }
    }
    examQuestions {
      statement
      type
      id
      examQuestionChoices {
        id
        statement
        isCorrect
        tempImage
      }
      bnccAbilities {
        id
        code
        description
        practiceObject {
          id
          name
          fieldPractice {
            id
            name
            actionField {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPublicActivityQuery__
 *
 * To run a query within a React component, call `useGetPublicActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicActivityQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useGetPublicActivityQuery(baseOptions: Apollo.QueryHookOptions<GetPublicActivityQuery, GetPublicActivityQueryVariables> & ({ variables: GetPublicActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicActivityQuery, GetPublicActivityQueryVariables>(GetPublicActivityDocument, options);
      }
export function useGetPublicActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicActivityQuery, GetPublicActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicActivityQuery, GetPublicActivityQueryVariables>(GetPublicActivityDocument, options);
        }
export function useGetPublicActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicActivityQuery, GetPublicActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicActivityQuery, GetPublicActivityQueryVariables>(GetPublicActivityDocument, options);
        }
export type GetPublicActivityQueryHookResult = ReturnType<typeof useGetPublicActivityQuery>;
export type GetPublicActivityLazyQueryHookResult = ReturnType<typeof useGetPublicActivityLazyQuery>;
export type GetPublicActivitySuspenseQueryHookResult = ReturnType<typeof useGetPublicActivitySuspenseQuery>;
export type GetPublicActivityQueryResult = Apollo.QueryResult<GetPublicActivityQuery, GetPublicActivityQueryVariables>;
export const CurationGetActivityDocument = gql`
    query CurationGetActivity($activityId: Int!) {
  me {
    id
    teacher {
      id
      curationGetActivity(activityId: $activityId) {
        id
        title
        description
        submittedToPublic
        isReady
        authorInfo {
          facebookPhoto
          name
          school
        }
        books {
          slug
          author
          name
          imageUrlThumb
          publisher {
            id
            name
          }
        }
        publicDataActivity {
          generalSkills {
            id
            description
          }
          degreeRange
          email
          id
          objective
          publicActivityId
          school
          sourceActivityId
          tags {
            id
            name
          }
          textualGenres {
            id
            name
          }
        }
        examQuestions {
          statement
          type
          id
          examQuestionChoices {
            id
            statement
            isCorrect
            tempImage
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCurationGetActivityQuery__
 *
 * To run a query within a React component, call `useCurationGetActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurationGetActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurationGetActivityQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useCurationGetActivityQuery(baseOptions: Apollo.QueryHookOptions<CurationGetActivityQuery, CurationGetActivityQueryVariables> & ({ variables: CurationGetActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurationGetActivityQuery, CurationGetActivityQueryVariables>(CurationGetActivityDocument, options);
      }
export function useCurationGetActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurationGetActivityQuery, CurationGetActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurationGetActivityQuery, CurationGetActivityQueryVariables>(CurationGetActivityDocument, options);
        }
export function useCurationGetActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurationGetActivityQuery, CurationGetActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurationGetActivityQuery, CurationGetActivityQueryVariables>(CurationGetActivityDocument, options);
        }
export type CurationGetActivityQueryHookResult = ReturnType<typeof useCurationGetActivityQuery>;
export type CurationGetActivityLazyQueryHookResult = ReturnType<typeof useCurationGetActivityLazyQuery>;
export type CurationGetActivitySuspenseQueryHookResult = ReturnType<typeof useCurationGetActivitySuspenseQuery>;
export type CurationGetActivityQueryResult = Apollo.QueryResult<CurationGetActivityQuery, CurationGetActivityQueryVariables>;
export const ListMyActivitiesQueryDocument = gql`
    query listMyActivitiesQuery {
  me {
    id
    teacher {
      id
      listMyActivities {
        id
        title
        books {
          slug
          author
          name
          imageUrlThumb
          publisher {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListMyActivitiesQueryQuery__
 *
 * To run a query within a React component, call `useListMyActivitiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyActivitiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyActivitiesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMyActivitiesQueryQuery(baseOptions?: Apollo.QueryHookOptions<ListMyActivitiesQueryQuery, ListMyActivitiesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMyActivitiesQueryQuery, ListMyActivitiesQueryQueryVariables>(ListMyActivitiesQueryDocument, options);
      }
export function useListMyActivitiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMyActivitiesQueryQuery, ListMyActivitiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMyActivitiesQueryQuery, ListMyActivitiesQueryQueryVariables>(ListMyActivitiesQueryDocument, options);
        }
export function useListMyActivitiesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMyActivitiesQueryQuery, ListMyActivitiesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMyActivitiesQueryQuery, ListMyActivitiesQueryQueryVariables>(ListMyActivitiesQueryDocument, options);
        }
export type ListMyActivitiesQueryQueryHookResult = ReturnType<typeof useListMyActivitiesQueryQuery>;
export type ListMyActivitiesQueryLazyQueryHookResult = ReturnType<typeof useListMyActivitiesQueryLazyQuery>;
export type ListMyActivitiesQuerySuspenseQueryHookResult = ReturnType<typeof useListMyActivitiesQuerySuspenseQuery>;
export type ListMyActivitiesQueryQueryResult = Apollo.QueryResult<ListMyActivitiesQueryQuery, ListMyActivitiesQueryQueryVariables>;
export const ListApplicationsForActivityQueryDocument = gql`
    query listApplicationsForActivityQuery($activityId: Int!) {
  me {
    id
    teacher {
      id
      listApplicationsForActivity(activityId: $activityId) {
        startDate
        endDate
        readerId
        entityId
        id
        createdAt
        title
      }
    }
  }
}
    `;

/**
 * __useListApplicationsForActivityQueryQuery__
 *
 * To run a query within a React component, call `useListApplicationsForActivityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationsForActivityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationsForActivityQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useListApplicationsForActivityQueryQuery(baseOptions: Apollo.QueryHookOptions<ListApplicationsForActivityQueryQuery, ListApplicationsForActivityQueryQueryVariables> & ({ variables: ListApplicationsForActivityQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListApplicationsForActivityQueryQuery, ListApplicationsForActivityQueryQueryVariables>(ListApplicationsForActivityQueryDocument, options);
      }
export function useListApplicationsForActivityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationsForActivityQueryQuery, ListApplicationsForActivityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListApplicationsForActivityQueryQuery, ListApplicationsForActivityQueryQueryVariables>(ListApplicationsForActivityQueryDocument, options);
        }
export function useListApplicationsForActivityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListApplicationsForActivityQueryQuery, ListApplicationsForActivityQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListApplicationsForActivityQueryQuery, ListApplicationsForActivityQueryQueryVariables>(ListApplicationsForActivityQueryDocument, options);
        }
export type ListApplicationsForActivityQueryQueryHookResult = ReturnType<typeof useListApplicationsForActivityQueryQuery>;
export type ListApplicationsForActivityQueryLazyQueryHookResult = ReturnType<typeof useListApplicationsForActivityQueryLazyQuery>;
export type ListApplicationsForActivityQuerySuspenseQueryHookResult = ReturnType<typeof useListApplicationsForActivityQuerySuspenseQuery>;
export type ListApplicationsForActivityQueryQueryResult = Apollo.QueryResult<ListApplicationsForActivityQueryQuery, ListApplicationsForActivityQueryQueryVariables>;
export const SearchReadersDocument = gql`
    query SearchReaders($searchTerm: String!) {
  me {
    id
    teacher {
      id
      searchReaders(searchTerm: $searchTerm)
    }
  }
}
    `;

/**
 * __useSearchReadersQuery__
 *
 * To run a query within a React component, call `useSearchReadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchReadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchReadersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchReadersQuery(baseOptions: Apollo.QueryHookOptions<SearchReadersQuery, SearchReadersQueryVariables> & ({ variables: SearchReadersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchReadersQuery, SearchReadersQueryVariables>(SearchReadersDocument, options);
      }
export function useSearchReadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchReadersQuery, SearchReadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchReadersQuery, SearchReadersQueryVariables>(SearchReadersDocument, options);
        }
export function useSearchReadersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchReadersQuery, SearchReadersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchReadersQuery, SearchReadersQueryVariables>(SearchReadersDocument, options);
        }
export type SearchReadersQueryHookResult = ReturnType<typeof useSearchReadersQuery>;
export type SearchReadersLazyQueryHookResult = ReturnType<typeof useSearchReadersLazyQuery>;
export type SearchReadersSuspenseQueryHookResult = ReturnType<typeof useSearchReadersSuspenseQuery>;
export type SearchReadersQueryResult = Apollo.QueryResult<SearchReadersQuery, SearchReadersQueryVariables>;
export const CategoriesPageDocument = gql`
    query CategoriesPage {
  me {
    id
    reader {
      id
      entity {
        id
        customCategories {
          name
          iconPath
        }
      }
    }
  }
}
    `;

/**
 * __useCategoriesPageQuery__
 *
 * To run a query within a React component, call `useCategoriesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriesPageQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesPageQuery, CategoriesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesPageQuery, CategoriesPageQueryVariables>(CategoriesPageDocument, options);
      }
export function useCategoriesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesPageQuery, CategoriesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesPageQuery, CategoriesPageQueryVariables>(CategoriesPageDocument, options);
        }
export function useCategoriesPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoriesPageQuery, CategoriesPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoriesPageQuery, CategoriesPageQueryVariables>(CategoriesPageDocument, options);
        }
export type CategoriesPageQueryHookResult = ReturnType<typeof useCategoriesPageQuery>;
export type CategoriesPageLazyQueryHookResult = ReturnType<typeof useCategoriesPageLazyQuery>;
export type CategoriesPageSuspenseQueryHookResult = ReturnType<typeof useCategoriesPageSuspenseQuery>;
export type CategoriesPageQueryResult = Apollo.QueryResult<CategoriesPageQuery, CategoriesPageQueryVariables>;
export const GetTemporarilyBooksQueryDocument = gql`
    query getTemporarilyBooksQuery {
  me {
    id
    reader {
      id
      entity {
        id
        temporarilyBooks
      }
    }
  }
}
    `;

/**
 * __useGetTemporarilyBooksQueryQuery__
 *
 * To run a query within a React component, call `useGetTemporarilyBooksQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemporarilyBooksQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemporarilyBooksQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemporarilyBooksQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetTemporarilyBooksQueryQuery, GetTemporarilyBooksQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemporarilyBooksQueryQuery, GetTemporarilyBooksQueryQueryVariables>(GetTemporarilyBooksQueryDocument, options);
      }
export function useGetTemporarilyBooksQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemporarilyBooksQueryQuery, GetTemporarilyBooksQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemporarilyBooksQueryQuery, GetTemporarilyBooksQueryQueryVariables>(GetTemporarilyBooksQueryDocument, options);
        }
export function useGetTemporarilyBooksQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemporarilyBooksQueryQuery, GetTemporarilyBooksQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemporarilyBooksQueryQuery, GetTemporarilyBooksQueryQueryVariables>(GetTemporarilyBooksQueryDocument, options);
        }
export type GetTemporarilyBooksQueryQueryHookResult = ReturnType<typeof useGetTemporarilyBooksQueryQuery>;
export type GetTemporarilyBooksQueryLazyQueryHookResult = ReturnType<typeof useGetTemporarilyBooksQueryLazyQuery>;
export type GetTemporarilyBooksQuerySuspenseQueryHookResult = ReturnType<typeof useGetTemporarilyBooksQuerySuspenseQuery>;
export type GetTemporarilyBooksQueryQueryResult = Apollo.QueryResult<GetTemporarilyBooksQueryQuery, GetTemporarilyBooksQueryQueryVariables>;
export const GetNpsScoreDocument = gql`
    query getNpsScore {
  me {
    id
    npsScore {
      score
      source
      createdAt
    }
  }
}
    `;

/**
 * __useGetNpsScoreQuery__
 *
 * To run a query within a React component, call `useGetNpsScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNpsScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNpsScoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNpsScoreQuery(baseOptions?: Apollo.QueryHookOptions<GetNpsScoreQuery, GetNpsScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNpsScoreQuery, GetNpsScoreQueryVariables>(GetNpsScoreDocument, options);
      }
export function useGetNpsScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNpsScoreQuery, GetNpsScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNpsScoreQuery, GetNpsScoreQueryVariables>(GetNpsScoreDocument, options);
        }
export function useGetNpsScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNpsScoreQuery, GetNpsScoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNpsScoreQuery, GetNpsScoreQueryVariables>(GetNpsScoreDocument, options);
        }
export type GetNpsScoreQueryHookResult = ReturnType<typeof useGetNpsScoreQuery>;
export type GetNpsScoreLazyQueryHookResult = ReturnType<typeof useGetNpsScoreLazyQuery>;
export type GetNpsScoreSuspenseQueryHookResult = ReturnType<typeof useGetNpsScoreSuspenseQuery>;
export type GetNpsScoreQueryResult = Apollo.QueryResult<GetNpsScoreQuery, GetNpsScoreQueryVariables>;
export const TrialFirstAccessQueryDocument = gql`
    query trialFirstAccessQuery {
  me {
    id
    teacher {
      id
    }
  }
}
    `;

/**
 * __useTrialFirstAccessQueryQuery__
 *
 * To run a query within a React component, call `useTrialFirstAccessQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialFirstAccessQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialFirstAccessQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrialFirstAccessQueryQuery(baseOptions?: Apollo.QueryHookOptions<TrialFirstAccessQueryQuery, TrialFirstAccessQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrialFirstAccessQueryQuery, TrialFirstAccessQueryQueryVariables>(TrialFirstAccessQueryDocument, options);
      }
export function useTrialFirstAccessQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrialFirstAccessQueryQuery, TrialFirstAccessQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrialFirstAccessQueryQuery, TrialFirstAccessQueryQueryVariables>(TrialFirstAccessQueryDocument, options);
        }
export function useTrialFirstAccessQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialFirstAccessQueryQuery, TrialFirstAccessQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrialFirstAccessQueryQuery, TrialFirstAccessQueryQueryVariables>(TrialFirstAccessQueryDocument, options);
        }
export type TrialFirstAccessQueryQueryHookResult = ReturnType<typeof useTrialFirstAccessQueryQuery>;
export type TrialFirstAccessQueryLazyQueryHookResult = ReturnType<typeof useTrialFirstAccessQueryLazyQuery>;
export type TrialFirstAccessQuerySuspenseQueryHookResult = ReturnType<typeof useTrialFirstAccessQuerySuspenseQuery>;
export type TrialFirstAccessQueryQueryResult = Apollo.QueryResult<TrialFirstAccessQueryQuery, TrialFirstAccessQueryQueryVariables>;
export const DataHomeForestOldDocument = gql`
    query DataHomeForestOld($count: Int) {
  me {
    id
    reader {
      id
      forest {
        id
        coins
        treeListings(count: $count) {
          id
          image
        }
      }
    }
  }
}
    `;

/**
 * __useDataHomeForestOldQuery__
 *
 * To run a query within a React component, call `useDataHomeForestOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataHomeForestOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataHomeForestOldQuery({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function useDataHomeForestOldQuery(baseOptions?: Apollo.QueryHookOptions<DataHomeForestOldQuery, DataHomeForestOldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataHomeForestOldQuery, DataHomeForestOldQueryVariables>(DataHomeForestOldDocument, options);
      }
export function useDataHomeForestOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataHomeForestOldQuery, DataHomeForestOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataHomeForestOldQuery, DataHomeForestOldQueryVariables>(DataHomeForestOldDocument, options);
        }
export function useDataHomeForestOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataHomeForestOldQuery, DataHomeForestOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataHomeForestOldQuery, DataHomeForestOldQueryVariables>(DataHomeForestOldDocument, options);
        }
export type DataHomeForestOldQueryHookResult = ReturnType<typeof useDataHomeForestOldQuery>;
export type DataHomeForestOldLazyQueryHookResult = ReturnType<typeof useDataHomeForestOldLazyQuery>;
export type DataHomeForestOldSuspenseQueryHookResult = ReturnType<typeof useDataHomeForestOldSuspenseQuery>;
export type DataHomeForestOldQueryResult = Apollo.QueryResult<DataHomeForestOldQuery, DataHomeForestOldQueryVariables>;
export const GetDataMainForestScreenDocument = gql`
    query GetDataMainForestScreen {
  me {
    id
    reader {
      id
      forest {
        id
        coins
        trees {
          id
          specialItemUsed
          stage
          agePercentage
          description
          growthTime
          image
          name
          position
          scientificName
          species
          ageStatusText
        }
        seeds {
          id
          image
          name
          description
          locked
          lockedText
          scientificName
          species
          growthTime
          price
        }
        specialItems {
          id
          name
          description
          price
          action
          image
          type
        }
        waterDropDetails {
          raining
        }
      }
    }
  }
}
    `;

/**
 * __useGetDataMainForestScreenQuery__
 *
 * To run a query within a React component, call `useGetDataMainForestScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataMainForestScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataMainForestScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataMainForestScreenQuery(baseOptions?: Apollo.QueryHookOptions<GetDataMainForestScreenQuery, GetDataMainForestScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataMainForestScreenQuery, GetDataMainForestScreenQueryVariables>(GetDataMainForestScreenDocument, options);
      }
export function useGetDataMainForestScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataMainForestScreenQuery, GetDataMainForestScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataMainForestScreenQuery, GetDataMainForestScreenQueryVariables>(GetDataMainForestScreenDocument, options);
        }
export function useGetDataMainForestScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataMainForestScreenQuery, GetDataMainForestScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataMainForestScreenQuery, GetDataMainForestScreenQueryVariables>(GetDataMainForestScreenDocument, options);
        }
export type GetDataMainForestScreenQueryHookResult = ReturnType<typeof useGetDataMainForestScreenQuery>;
export type GetDataMainForestScreenLazyQueryHookResult = ReturnType<typeof useGetDataMainForestScreenLazyQuery>;
export type GetDataMainForestScreenSuspenseQueryHookResult = ReturnType<typeof useGetDataMainForestScreenSuspenseQuery>;
export type GetDataMainForestScreenQueryResult = Apollo.QueryResult<GetDataMainForestScreenQuery, GetDataMainForestScreenQueryVariables>;
export const FriendTreeListingsDocument = gql`
    query friendTreeListings($friendReaderId: Int!) {
  me {
    id
    reader {
      id
      forest {
        id
        friendTreeListings(friendReaderId: $friendReaderId) {
          id
          image
          position
        }
      }
    }
  }
}
    `;

/**
 * __useFriendTreeListingsQuery__
 *
 * To run a query within a React component, call `useFriendTreeListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendTreeListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendTreeListingsQuery({
 *   variables: {
 *      friendReaderId: // value for 'friendReaderId'
 *   },
 * });
 */
export function useFriendTreeListingsQuery(baseOptions: Apollo.QueryHookOptions<FriendTreeListingsQuery, FriendTreeListingsQueryVariables> & ({ variables: FriendTreeListingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendTreeListingsQuery, FriendTreeListingsQueryVariables>(FriendTreeListingsDocument, options);
      }
export function useFriendTreeListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendTreeListingsQuery, FriendTreeListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendTreeListingsQuery, FriendTreeListingsQueryVariables>(FriendTreeListingsDocument, options);
        }
export function useFriendTreeListingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendTreeListingsQuery, FriendTreeListingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendTreeListingsQuery, FriendTreeListingsQueryVariables>(FriendTreeListingsDocument, options);
        }
export type FriendTreeListingsQueryHookResult = ReturnType<typeof useFriendTreeListingsQuery>;
export type FriendTreeListingsLazyQueryHookResult = ReturnType<typeof useFriendTreeListingsLazyQuery>;
export type FriendTreeListingsSuspenseQueryHookResult = ReturnType<typeof useFriendTreeListingsSuspenseQuery>;
export type FriendTreeListingsQueryResult = Apollo.QueryResult<FriendTreeListingsQuery, FriendTreeListingsQueryVariables>;
export const FriendsDocument = gql`
    query friends($page: Int!, $count: Int!) {
  me {
    id
    reader {
      id
      forest {
        id
        friends(page: $page, count: $count) {
          name
          readerId
        }
      }
    }
  }
}
    `;

/**
 * __useFriendsQuery__
 *
 * To run a query within a React component, call `useFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useFriendsQuery(baseOptions: Apollo.QueryHookOptions<FriendsQuery, FriendsQueryVariables> & ({ variables: FriendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendsQuery, FriendsQueryVariables>(FriendsDocument, options);
      }
export function useFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendsQuery, FriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendsQuery, FriendsQueryVariables>(FriendsDocument, options);
        }
export function useFriendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendsQuery, FriendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendsQuery, FriendsQueryVariables>(FriendsDocument, options);
        }
export type FriendsQueryHookResult = ReturnType<typeof useFriendsQuery>;
export type FriendsLazyQueryHookResult = ReturnType<typeof useFriendsLazyQuery>;
export type FriendsSuspenseQueryHookResult = ReturnType<typeof useFriendsSuspenseQuery>;
export type FriendsQueryResult = Apollo.QueryResult<FriendsQuery, FriendsQueryVariables>;
export const FriendsForAdminDocument = gql`
    query friendsForAdmin($entityId: Int!, $page: Int!, $count: Int!) {
  me {
    id
    reader {
      id
      forest {
        id
        friendsForAdmin(entityId: $entityId, page: $page, count: $count) {
          id
          name
          type
        }
      }
    }
  }
}
    `;

/**
 * __useFriendsForAdminQuery__
 *
 * To run a query within a React component, call `useFriendsForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendsForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendsForAdminQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useFriendsForAdminQuery(baseOptions: Apollo.QueryHookOptions<FriendsForAdminQuery, FriendsForAdminQueryVariables> & ({ variables: FriendsForAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FriendsForAdminQuery, FriendsForAdminQueryVariables>(FriendsForAdminDocument, options);
      }
export function useFriendsForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FriendsForAdminQuery, FriendsForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FriendsForAdminQuery, FriendsForAdminQueryVariables>(FriendsForAdminDocument, options);
        }
export function useFriendsForAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FriendsForAdminQuery, FriendsForAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FriendsForAdminQuery, FriendsForAdminQueryVariables>(FriendsForAdminDocument, options);
        }
export type FriendsForAdminQueryHookResult = ReturnType<typeof useFriendsForAdminQuery>;
export type FriendsForAdminLazyQueryHookResult = ReturnType<typeof useFriendsForAdminLazyQuery>;
export type FriendsForAdminSuspenseQueryHookResult = ReturnType<typeof useFriendsForAdminSuspenseQuery>;
export type FriendsForAdminQueryResult = Apollo.QueryResult<FriendsForAdminQuery, FriendsForAdminQueryVariables>;
export const GetMyForestAndSeedsDataDocument = gql`
    query GetMyForestAndSeedsData {
  me {
    id
    reader {
      id
      forest {
        id
        coins
        trees(count: 20) {
          id
          specialItemUsed
          stage
          agePercentage
          description
          growthTime
          image
          name
          position
          scientificName
          species
          ageStatusText
        }
        seeds {
          id
          image
          name
          description
          locked
          lockedText
          scientificName
          species
          growthTime
          price
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyForestAndSeedsDataQuery__
 *
 * To run a query within a React component, call `useGetMyForestAndSeedsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyForestAndSeedsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyForestAndSeedsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyForestAndSeedsDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMyForestAndSeedsDataQuery, GetMyForestAndSeedsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyForestAndSeedsDataQuery, GetMyForestAndSeedsDataQueryVariables>(GetMyForestAndSeedsDataDocument, options);
      }
export function useGetMyForestAndSeedsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyForestAndSeedsDataQuery, GetMyForestAndSeedsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyForestAndSeedsDataQuery, GetMyForestAndSeedsDataQueryVariables>(GetMyForestAndSeedsDataDocument, options);
        }
export function useGetMyForestAndSeedsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyForestAndSeedsDataQuery, GetMyForestAndSeedsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyForestAndSeedsDataQuery, GetMyForestAndSeedsDataQueryVariables>(GetMyForestAndSeedsDataDocument, options);
        }
export type GetMyForestAndSeedsDataQueryHookResult = ReturnType<typeof useGetMyForestAndSeedsDataQuery>;
export type GetMyForestAndSeedsDataLazyQueryHookResult = ReturnType<typeof useGetMyForestAndSeedsDataLazyQuery>;
export type GetMyForestAndSeedsDataSuspenseQueryHookResult = ReturnType<typeof useGetMyForestAndSeedsDataSuspenseQuery>;
export type GetMyForestAndSeedsDataQueryResult = Apollo.QueryResult<GetMyForestAndSeedsDataQuery, GetMyForestAndSeedsDataQueryVariables>;
export const GetStoreDataDocument = gql`
    query GetStoreData {
  me {
    id
    reader {
      id
      forest {
        id
        coins
        seeds {
          id
          image
          name
          description
          locked
          lockedText
          scientificName
          species
          growthTime
          price
        }
        waterDropDetails {
          raining
        }
      }
    }
  }
}
    `;

/**
 * __useGetStoreDataQuery__
 *
 * To run a query within a React component, call `useGetStoreDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStoreDataQuery(baseOptions?: Apollo.QueryHookOptions<GetStoreDataQuery, GetStoreDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreDataQuery, GetStoreDataQueryVariables>(GetStoreDataDocument, options);
      }
export function useGetStoreDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreDataQuery, GetStoreDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreDataQuery, GetStoreDataQueryVariables>(GetStoreDataDocument, options);
        }
export function useGetStoreDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoreDataQuery, GetStoreDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoreDataQuery, GetStoreDataQueryVariables>(GetStoreDataDocument, options);
        }
export type GetStoreDataQueryHookResult = ReturnType<typeof useGetStoreDataQuery>;
export type GetStoreDataLazyQueryHookResult = ReturnType<typeof useGetStoreDataLazyQuery>;
export type GetStoreDataSuspenseQueryHookResult = ReturnType<typeof useGetStoreDataSuspenseQuery>;
export type GetStoreDataQueryResult = Apollo.QueryResult<GetStoreDataQuery, GetStoreDataQueryVariables>;
export const GetClientListingDocument = gql`
    query GetClientListing($filters: ClientListingFilters) {
  getClientListing(filters: $filters) {
    id
    name
    deactivated
  }
}
    `;

/**
 * __useGetClientListingQuery__
 *
 * To run a query within a React component, call `useGetClientListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientListingQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClientListingQuery(baseOptions?: Apollo.QueryHookOptions<GetClientListingQuery, GetClientListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientListingQuery, GetClientListingQueryVariables>(GetClientListingDocument, options);
      }
export function useGetClientListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientListingQuery, GetClientListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientListingQuery, GetClientListingQueryVariables>(GetClientListingDocument, options);
        }
export function useGetClientListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientListingQuery, GetClientListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientListingQuery, GetClientListingQueryVariables>(GetClientListingDocument, options);
        }
export type GetClientListingQueryHookResult = ReturnType<typeof useGetClientListingQuery>;
export type GetClientListingLazyQueryHookResult = ReturnType<typeof useGetClientListingLazyQuery>;
export type GetClientListingSuspenseQueryHookResult = ReturnType<typeof useGetClientListingSuspenseQuery>;
export type GetClientListingQueryResult = Apollo.QueryResult<GetClientListingQuery, GetClientListingQueryVariables>;
export const SearchLoginTypeDocument = gql`
    query SearchLoginType($prefixOrSufix: LoginTypePrefixOrSufix!, $profileType: ProfileType!, $term: String!) {
  searchLoginType(
    prefixOrSufix: $prefixOrSufix
    profileType: $profileType
    term: $term
  ) {
    id
  }
}
    `;

/**
 * __useSearchLoginTypeQuery__
 *
 * To run a query within a React component, call `useSearchLoginTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLoginTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLoginTypeQuery({
 *   variables: {
 *      prefixOrSufix: // value for 'prefixOrSufix'
 *      profileType: // value for 'profileType'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchLoginTypeQuery(baseOptions: Apollo.QueryHookOptions<SearchLoginTypeQuery, SearchLoginTypeQueryVariables> & ({ variables: SearchLoginTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLoginTypeQuery, SearchLoginTypeQueryVariables>(SearchLoginTypeDocument, options);
      }
export function useSearchLoginTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLoginTypeQuery, SearchLoginTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLoginTypeQuery, SearchLoginTypeQueryVariables>(SearchLoginTypeDocument, options);
        }
export function useSearchLoginTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLoginTypeQuery, SearchLoginTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLoginTypeQuery, SearchLoginTypeQueryVariables>(SearchLoginTypeDocument, options);
        }
export type SearchLoginTypeQueryHookResult = ReturnType<typeof useSearchLoginTypeQuery>;
export type SearchLoginTypeLazyQueryHookResult = ReturnType<typeof useSearchLoginTypeLazyQuery>;
export type SearchLoginTypeSuspenseQueryHookResult = ReturnType<typeof useSearchLoginTypeSuspenseQuery>;
export type SearchLoginTypeQueryResult = Apollo.QueryResult<SearchLoginTypeQuery, SearchLoginTypeQueryVariables>;
export const GetClientDocument = gql`
    query GetClient($clientId: Int!) {
  me {
    id
  }
  getClient(clientId: $clientId) {
    id
    name
    accessCode
    isTrial
    whoPays
    loginType
    payingClient
    responsibleName
    responsibleEmail
    schoolStructure
    segment
    internalContacts
    usesContractModuleSystem
    entityType
    blockAccessTokens
    deactivated
    maxSimultaneousUsers
    clientContracts {
      id
      type
      contractModules {
        id
        contractId
        info {
          ... on CnpjPayingModuleInfoPayload {
            minUsers
            freeUsers
            pricePerUnit
            bookCollection
          }
          ... on FamilyPayingModuleInfoPayload {
            minUsers
            pricePerUnit
            discount
            discountExpirationDate
            bookCollection
          }
          ... on PublicModuleInfoPayload {
            numberOfReaders
            bookCollection
          }
          ... on ProjectModuleInfoPayload {
            maxTeachers
            maxReaders
            bookCollection
          }
          ... on TrialModuleInfoPayload {
            maxTeachers
            maxReaders
            bookCollection
          }
        }
        module {
          name
        }
      }
    }
    contractModules {
      id
      contractId
      module {
        name
      }
    }
  }
  getContractListing(clientId: $clientId) {
    active
    clientId
    clientName
    contractType
    contractId
    contractModules {
      id
      contractId
      module {
        name
      }
    }
    active
  }
  getSubtreeFromEntityListing(entityId: $clientId) {
    child
    parentId
    parentName
    accessCode
    degree
    entityId
    entityName
    entityAncestry
    entityType
    contractModules {
      id
      contractId
      module {
        name
      }
    }
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables> & ({ variables: GetClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetContractListingQueryDocument = gql`
    query GetContractListingQuery {
  getContractListing {
    active
    clientId
    clientName
    contractType
    contractId
    contractModules {
      id
      contractId
      module {
        name
      }
    }
    active
  }
}
    `;

/**
 * __useGetContractListingQueryQuery__
 *
 * To run a query within a React component, call `useGetContractListingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractListingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractListingQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractListingQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetContractListingQueryQuery, GetContractListingQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractListingQueryQuery, GetContractListingQueryQueryVariables>(GetContractListingQueryDocument, options);
      }
export function useGetContractListingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractListingQueryQuery, GetContractListingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractListingQueryQuery, GetContractListingQueryQueryVariables>(GetContractListingQueryDocument, options);
        }
export function useGetContractListingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractListingQueryQuery, GetContractListingQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractListingQueryQuery, GetContractListingQueryQueryVariables>(GetContractListingQueryDocument, options);
        }
export type GetContractListingQueryQueryHookResult = ReturnType<typeof useGetContractListingQueryQuery>;
export type GetContractListingQueryLazyQueryHookResult = ReturnType<typeof useGetContractListingQueryLazyQuery>;
export type GetContractListingQuerySuspenseQueryHookResult = ReturnType<typeof useGetContractListingQuerySuspenseQuery>;
export type GetContractListingQueryQueryResult = Apollo.QueryResult<GetContractListingQueryQuery, GetContractListingQueryQueryVariables>;
export const GetSubtreeFromEntityListingQueryDocument = gql`
    query GetSubtreeFromEntityListingQuery($entityId: Int!) {
  getSubtreeFromEntityListing(entityId: $entityId) {
    degree
    child
    parentId
    parentName
    entityId
    entityName
    entityAncestry
    entityType
    contractModules {
      contractId
      module {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSubtreeFromEntityListingQueryQuery__
 *
 * To run a query within a React component, call `useGetSubtreeFromEntityListingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubtreeFromEntityListingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubtreeFromEntityListingQueryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetSubtreeFromEntityListingQueryQuery(baseOptions: Apollo.QueryHookOptions<GetSubtreeFromEntityListingQueryQuery, GetSubtreeFromEntityListingQueryQueryVariables> & ({ variables: GetSubtreeFromEntityListingQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubtreeFromEntityListingQueryQuery, GetSubtreeFromEntityListingQueryQueryVariables>(GetSubtreeFromEntityListingQueryDocument, options);
      }
export function useGetSubtreeFromEntityListingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubtreeFromEntityListingQueryQuery, GetSubtreeFromEntityListingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubtreeFromEntityListingQueryQuery, GetSubtreeFromEntityListingQueryQueryVariables>(GetSubtreeFromEntityListingQueryDocument, options);
        }
export function useGetSubtreeFromEntityListingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubtreeFromEntityListingQueryQuery, GetSubtreeFromEntityListingQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubtreeFromEntityListingQueryQuery, GetSubtreeFromEntityListingQueryQueryVariables>(GetSubtreeFromEntityListingQueryDocument, options);
        }
export type GetSubtreeFromEntityListingQueryQueryHookResult = ReturnType<typeof useGetSubtreeFromEntityListingQueryQuery>;
export type GetSubtreeFromEntityListingQueryLazyQueryHookResult = ReturnType<typeof useGetSubtreeFromEntityListingQueryLazyQuery>;
export type GetSubtreeFromEntityListingQuerySuspenseQueryHookResult = ReturnType<typeof useGetSubtreeFromEntityListingQuerySuspenseQuery>;
export type GetSubtreeFromEntityListingQueryQueryResult = Apollo.QueryResult<GetSubtreeFromEntityListingQueryQuery, GetSubtreeFromEntityListingQueryQueryVariables>;
export const GetReadersAccessInfoQueryDocument = gql`
    query GetReadersAccessInfoQuery($entityId: Int!, $source: ReadersInfoSourceType!, $profileType: ProfileType!) {
  readersAccessInfo(
    entityId: $entityId
    source: $source
    profileType: $profileType
  ) {
    ... on ReadersAccessInfoPayload {
      entityName
      accessCode
      readerName
      accessToken
      url
    }
    ... on Card {
      id
      name
      entityName
      accessToken
    }
  }
}
    `;

/**
 * __useGetReadersAccessInfoQueryQuery__
 *
 * To run a query within a React component, call `useGetReadersAccessInfoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadersAccessInfoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReadersAccessInfoQueryQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      source: // value for 'source'
 *      profileType: // value for 'profileType'
 *   },
 * });
 */
export function useGetReadersAccessInfoQueryQuery(baseOptions: Apollo.QueryHookOptions<GetReadersAccessInfoQueryQuery, GetReadersAccessInfoQueryQueryVariables> & ({ variables: GetReadersAccessInfoQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReadersAccessInfoQueryQuery, GetReadersAccessInfoQueryQueryVariables>(GetReadersAccessInfoQueryDocument, options);
      }
export function useGetReadersAccessInfoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReadersAccessInfoQueryQuery, GetReadersAccessInfoQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReadersAccessInfoQueryQuery, GetReadersAccessInfoQueryQueryVariables>(GetReadersAccessInfoQueryDocument, options);
        }
export function useGetReadersAccessInfoQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReadersAccessInfoQueryQuery, GetReadersAccessInfoQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReadersAccessInfoQueryQuery, GetReadersAccessInfoQueryQueryVariables>(GetReadersAccessInfoQueryDocument, options);
        }
export type GetReadersAccessInfoQueryQueryHookResult = ReturnType<typeof useGetReadersAccessInfoQueryQuery>;
export type GetReadersAccessInfoQueryLazyQueryHookResult = ReturnType<typeof useGetReadersAccessInfoQueryLazyQuery>;
export type GetReadersAccessInfoQuerySuspenseQueryHookResult = ReturnType<typeof useGetReadersAccessInfoQuerySuspenseQuery>;
export type GetReadersAccessInfoQueryQueryResult = Apollo.QueryResult<GetReadersAccessInfoQueryQuery, GetReadersAccessInfoQueryQueryVariables>;
export const GetContractDataQueryDocument = gql`
    query GetContractDataQuery($contractId: Int!) {
  getAcervoTypes
  listCollections {
    id
    name
  }
  listBookCollections {
    id
    name
  }
  getContract(contractId: $contractId) {
    active
    cnpj
    clientId
    clientName
    companyName
    contractModules {
      collections {
        id
        name
      }
      bookCollections {
        id
        name
      }
      extraInformation {
        ... on CnpjPayingExtraInformation {
          activeUsers
          chargedUsers
          totalAmount
        }
        ... on FamilyPayingExtraInformation {
          activeUsers
          paidUsers
        }
        ... on PublicExtraInformation {
          activeUsers
          numberOfReaders
        }
        ... on ProjectExtraInformation {
          maxReaders
          maxTeachers
        }
        ... on TrialExtraInformation {
          maxReaders
          maxTeachers
        }
      }
      info {
        ... on CnpjPayingModuleInfoPayload {
          minUsers
          freeUsers
          pricePerUnit
          bookCollection
        }
        ... on FamilyPayingModuleInfoPayload {
          minUsers
          pricePerUnit
          discount
          discountExpirationDate
          bookCollection
        }
        ... on PublicModuleInfoPayload {
          numberOfReaders
          bookCollection
        }
        ... on ProjectModuleInfoPayload {
          maxTeachers
          maxReaders
          bookCollection
        }
        ... on TrialModuleInfoPayload {
          maxTeachers
          maxReaders
          bookCollection
        }
      }
      module {
        name
      }
    }
    billingAddress {
      address
      city
      complement
      country
      neighborhood
      number
      state
      zipcode
    }
    contractId
    contractType
    disableContractAfterExpiration
    endDate
    entityName
    expirationWarningDays
    financeContactEmail
    financeContactName
    financeContactPhone
    observation
    paymentInfo
    signatureDate
    startDate
    stateRegistration
    municipalRegistration
    market
    tradingName
    firstChargeDate
  }
}
    `;

/**
 * __useGetContractDataQueryQuery__
 *
 * To run a query within a React component, call `useGetContractDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractDataQueryQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetContractDataQueryQuery(baseOptions: Apollo.QueryHookOptions<GetContractDataQueryQuery, GetContractDataQueryQueryVariables> & ({ variables: GetContractDataQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractDataQueryQuery, GetContractDataQueryQueryVariables>(GetContractDataQueryDocument, options);
      }
export function useGetContractDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractDataQueryQuery, GetContractDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractDataQueryQuery, GetContractDataQueryQueryVariables>(GetContractDataQueryDocument, options);
        }
export function useGetContractDataQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContractDataQueryQuery, GetContractDataQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContractDataQueryQuery, GetContractDataQueryQueryVariables>(GetContractDataQueryDocument, options);
        }
export type GetContractDataQueryQueryHookResult = ReturnType<typeof useGetContractDataQueryQuery>;
export type GetContractDataQueryLazyQueryHookResult = ReturnType<typeof useGetContractDataQueryLazyQuery>;
export type GetContractDataQuerySuspenseQueryHookResult = ReturnType<typeof useGetContractDataQuerySuspenseQuery>;
export type GetContractDataQueryQueryResult = Apollo.QueryResult<GetContractDataQueryQuery, GetContractDataQueryQueryVariables>;
export const GetImportationListingQueryDocument = gql`
    query GetImportationListingQuery($userId: Int!, $clientId: Int) {
  importationListing(userId: $userId, clientId: $clientId) {
    clientName
    id
    processType
    progress
    status
    userName
  }
}
    `;

/**
 * __useGetImportationListingQueryQuery__
 *
 * To run a query within a React component, call `useGetImportationListingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportationListingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportationListingQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetImportationListingQueryQuery(baseOptions: Apollo.QueryHookOptions<GetImportationListingQueryQuery, GetImportationListingQueryQueryVariables> & ({ variables: GetImportationListingQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportationListingQueryQuery, GetImportationListingQueryQueryVariables>(GetImportationListingQueryDocument, options);
      }
export function useGetImportationListingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportationListingQueryQuery, GetImportationListingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportationListingQueryQuery, GetImportationListingQueryQueryVariables>(GetImportationListingQueryDocument, options);
        }
export function useGetImportationListingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImportationListingQueryQuery, GetImportationListingQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImportationListingQueryQuery, GetImportationListingQueryQueryVariables>(GetImportationListingQueryDocument, options);
        }
export type GetImportationListingQueryQueryHookResult = ReturnType<typeof useGetImportationListingQueryQuery>;
export type GetImportationListingQueryLazyQueryHookResult = ReturnType<typeof useGetImportationListingQueryLazyQuery>;
export type GetImportationListingQuerySuspenseQueryHookResult = ReturnType<typeof useGetImportationListingQuerySuspenseQuery>;
export type GetImportationListingQueryQueryResult = Apollo.QueryResult<GetImportationListingQueryQuery, GetImportationListingQueryQueryVariables>;
export const ImportationReviewDocument = gql`
    query ImportationReview($id: Int!) {
  importReview(id: $id)
}
    `;

/**
 * __useImportationReviewQuery__
 *
 * To run a query within a React component, call `useImportationReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportationReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportationReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportationReviewQuery(baseOptions: Apollo.QueryHookOptions<ImportationReviewQuery, ImportationReviewQueryVariables> & ({ variables: ImportationReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportationReviewQuery, ImportationReviewQueryVariables>(ImportationReviewDocument, options);
      }
export function useImportationReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportationReviewQuery, ImportationReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportationReviewQuery, ImportationReviewQueryVariables>(ImportationReviewDocument, options);
        }
export function useImportationReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportationReviewQuery, ImportationReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportationReviewQuery, ImportationReviewQueryVariables>(ImportationReviewDocument, options);
        }
export type ImportationReviewQueryHookResult = ReturnType<typeof useImportationReviewQuery>;
export type ImportationReviewLazyQueryHookResult = ReturnType<typeof useImportationReviewLazyQuery>;
export type ImportationReviewSuspenseQueryHookResult = ReturnType<typeof useImportationReviewSuspenseQuery>;
export type ImportationReviewQueryResult = Apollo.QueryResult<ImportationReviewQuery, ImportationReviewQueryVariables>;
export const ImportationDocument = gql`
    query Importation($id: Int!) {
  getImportation(id: $id) {
    id
    clientName
    clientId
    userName
    status
  }
}
    `;

/**
 * __useImportationQuery__
 *
 * To run a query within a React component, call `useImportationQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportationQuery(baseOptions: Apollo.QueryHookOptions<ImportationQuery, ImportationQueryVariables> & ({ variables: ImportationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportationQuery, ImportationQueryVariables>(ImportationDocument, options);
      }
export function useImportationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportationQuery, ImportationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportationQuery, ImportationQueryVariables>(ImportationDocument, options);
        }
export function useImportationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportationQuery, ImportationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportationQuery, ImportationQueryVariables>(ImportationDocument, options);
        }
export type ImportationQueryHookResult = ReturnType<typeof useImportationQuery>;
export type ImportationLazyQueryHookResult = ReturnType<typeof useImportationLazyQuery>;
export type ImportationSuspenseQueryHookResult = ReturnType<typeof useImportationSuspenseQuery>;
export type ImportationQueryResult = Apollo.QueryResult<ImportationQuery, ImportationQueryVariables>;
export const EntityPublicInfoDocument = gql`
    query entityPublicInfo($code: String!) {
  entityPublicInfo(code: $code) {
    rootName
    degree
  }
}
    `;

/**
 * __useEntityPublicInfoQuery__
 *
 * To run a query within a React component, call `useEntityPublicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPublicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPublicInfoQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEntityPublicInfoQuery(baseOptions: Apollo.QueryHookOptions<EntityPublicInfoQuery, EntityPublicInfoQueryVariables> & ({ variables: EntityPublicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPublicInfoQuery, EntityPublicInfoQueryVariables>(EntityPublicInfoDocument, options);
      }
export function useEntityPublicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPublicInfoQuery, EntityPublicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPublicInfoQuery, EntityPublicInfoQueryVariables>(EntityPublicInfoDocument, options);
        }
export function useEntityPublicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityPublicInfoQuery, EntityPublicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityPublicInfoQuery, EntityPublicInfoQueryVariables>(EntityPublicInfoDocument, options);
        }
export type EntityPublicInfoQueryHookResult = ReturnType<typeof useEntityPublicInfoQuery>;
export type EntityPublicInfoLazyQueryHookResult = ReturnType<typeof useEntityPublicInfoLazyQuery>;
export type EntityPublicInfoSuspenseQueryHookResult = ReturnType<typeof useEntityPublicInfoSuspenseQuery>;
export type EntityPublicInfoQueryResult = Apollo.QueryResult<EntityPublicInfoQuery, EntityPublicInfoQueryVariables>;
export const GetBooksDeactivationDatesDocument = gql`
    query getBooksDeactivationDates($slugs: [String]!) {
  bookRemovalDates(slugs: $slugs) {
    slug
    deactivationDate
  }
}
    `;

/**
 * __useGetBooksDeactivationDatesQuery__
 *
 * To run a query within a React component, call `useGetBooksDeactivationDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBooksDeactivationDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBooksDeactivationDatesQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useGetBooksDeactivationDatesQuery(baseOptions: Apollo.QueryHookOptions<GetBooksDeactivationDatesQuery, GetBooksDeactivationDatesQueryVariables> & ({ variables: GetBooksDeactivationDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBooksDeactivationDatesQuery, GetBooksDeactivationDatesQueryVariables>(GetBooksDeactivationDatesDocument, options);
      }
export function useGetBooksDeactivationDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBooksDeactivationDatesQuery, GetBooksDeactivationDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBooksDeactivationDatesQuery, GetBooksDeactivationDatesQueryVariables>(GetBooksDeactivationDatesDocument, options);
        }
export function useGetBooksDeactivationDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBooksDeactivationDatesQuery, GetBooksDeactivationDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBooksDeactivationDatesQuery, GetBooksDeactivationDatesQueryVariables>(GetBooksDeactivationDatesDocument, options);
        }
export type GetBooksDeactivationDatesQueryHookResult = ReturnType<typeof useGetBooksDeactivationDatesQuery>;
export type GetBooksDeactivationDatesLazyQueryHookResult = ReturnType<typeof useGetBooksDeactivationDatesLazyQuery>;
export type GetBooksDeactivationDatesSuspenseQueryHookResult = ReturnType<typeof useGetBooksDeactivationDatesSuspenseQuery>;
export type GetBooksDeactivationDatesQueryResult = Apollo.QueryResult<GetBooksDeactivationDatesQuery, GetBooksDeactivationDatesQueryVariables>;
export const GetRootPublicInfoDocument = gql`
    query getRootPublicInfo($code: String!) {
  rootPublicInfo(code: $code) {
    id
    name
  }
}
    `;

/**
 * __useGetRootPublicInfoQuery__
 *
 * To run a query within a React component, call `useGetRootPublicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootPublicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootPublicInfoQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetRootPublicInfoQuery(baseOptions: Apollo.QueryHookOptions<GetRootPublicInfoQuery, GetRootPublicInfoQueryVariables> & ({ variables: GetRootPublicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRootPublicInfoQuery, GetRootPublicInfoQueryVariables>(GetRootPublicInfoDocument, options);
      }
export function useGetRootPublicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRootPublicInfoQuery, GetRootPublicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRootPublicInfoQuery, GetRootPublicInfoQueryVariables>(GetRootPublicInfoDocument, options);
        }
export function useGetRootPublicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRootPublicInfoQuery, GetRootPublicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRootPublicInfoQuery, GetRootPublicInfoQueryVariables>(GetRootPublicInfoDocument, options);
        }
export type GetRootPublicInfoQueryHookResult = ReturnType<typeof useGetRootPublicInfoQuery>;
export type GetRootPublicInfoLazyQueryHookResult = ReturnType<typeof useGetRootPublicInfoLazyQuery>;
export type GetRootPublicInfoSuspenseQueryHookResult = ReturnType<typeof useGetRootPublicInfoSuspenseQuery>;
export type GetRootPublicInfoQueryResult = Apollo.QueryResult<GetRootPublicInfoQuery, GetRootPublicInfoQueryVariables>;
export const LayersPaymentEntityInfoDocument = gql`
    query LayersPaymentEntityInfo($externalTransactionId: String!) {
  layersPaymentEntityInfo(externalTransactionId: $externalTransactionId) {
    arvoreEntityId
    entityName
  }
}
    `;

/**
 * __useLayersPaymentEntityInfoQuery__
 *
 * To run a query within a React component, call `useLayersPaymentEntityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayersPaymentEntityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayersPaymentEntityInfoQuery({
 *   variables: {
 *      externalTransactionId: // value for 'externalTransactionId'
 *   },
 * });
 */
export function useLayersPaymentEntityInfoQuery(baseOptions: Apollo.QueryHookOptions<LayersPaymentEntityInfoQuery, LayersPaymentEntityInfoQueryVariables> & ({ variables: LayersPaymentEntityInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayersPaymentEntityInfoQuery, LayersPaymentEntityInfoQueryVariables>(LayersPaymentEntityInfoDocument, options);
      }
export function useLayersPaymentEntityInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayersPaymentEntityInfoQuery, LayersPaymentEntityInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayersPaymentEntityInfoQuery, LayersPaymentEntityInfoQueryVariables>(LayersPaymentEntityInfoDocument, options);
        }
export function useLayersPaymentEntityInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayersPaymentEntityInfoQuery, LayersPaymentEntityInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayersPaymentEntityInfoQuery, LayersPaymentEntityInfoQueryVariables>(LayersPaymentEntityInfoDocument, options);
        }
export type LayersPaymentEntityInfoQueryHookResult = ReturnType<typeof useLayersPaymentEntityInfoQuery>;
export type LayersPaymentEntityInfoLazyQueryHookResult = ReturnType<typeof useLayersPaymentEntityInfoLazyQuery>;
export type LayersPaymentEntityInfoSuspenseQueryHookResult = ReturnType<typeof useLayersPaymentEntityInfoSuspenseQuery>;
export type LayersPaymentEntityInfoQueryResult = Apollo.QueryResult<LayersPaymentEntityInfoQuery, LayersPaymentEntityInfoQueryVariables>;
export const GetUserPublicInfoDocument = gql`
    query getUserPublicInfo($input: UserPublicInfoInput!) {
  userPublicInfo(input: $input) {
    id
    name
    paid
  }
}
    `;

/**
 * __useGetUserPublicInfoQuery__
 *
 * To run a query within a React component, call `useGetUserPublicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPublicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPublicInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserPublicInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUserPublicInfoQuery, GetUserPublicInfoQueryVariables> & ({ variables: GetUserPublicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPublicInfoQuery, GetUserPublicInfoQueryVariables>(GetUserPublicInfoDocument, options);
      }
export function useGetUserPublicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPublicInfoQuery, GetUserPublicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPublicInfoQuery, GetUserPublicInfoQueryVariables>(GetUserPublicInfoDocument, options);
        }
export function useGetUserPublicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPublicInfoQuery, GetUserPublicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPublicInfoQuery, GetUserPublicInfoQueryVariables>(GetUserPublicInfoDocument, options);
        }
export type GetUserPublicInfoQueryHookResult = ReturnType<typeof useGetUserPublicInfoQuery>;
export type GetUserPublicInfoLazyQueryHookResult = ReturnType<typeof useGetUserPublicInfoLazyQuery>;
export type GetUserPublicInfoSuspenseQueryHookResult = ReturnType<typeof useGetUserPublicInfoSuspenseQuery>;
export type GetUserPublicInfoQueryResult = Apollo.QueryResult<GetUserPublicInfoQuery, GetUserPublicInfoQueryVariables>;
export const GetMaximumHierarchyTypeDocument = gql`
    query GetMaximumHierarchyType($rootId: Int!) {
  maximumHierarchyType(rootId: $rootId) {
    hierarchyType
  }
}
    `;

/**
 * __useGetMaximumHierarchyTypeQuery__
 *
 * To run a query within a React component, call `useGetMaximumHierarchyTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaximumHierarchyTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaximumHierarchyTypeQuery({
 *   variables: {
 *      rootId: // value for 'rootId'
 *   },
 * });
 */
export function useGetMaximumHierarchyTypeQuery(baseOptions: Apollo.QueryHookOptions<GetMaximumHierarchyTypeQuery, GetMaximumHierarchyTypeQueryVariables> & ({ variables: GetMaximumHierarchyTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaximumHierarchyTypeQuery, GetMaximumHierarchyTypeQueryVariables>(GetMaximumHierarchyTypeDocument, options);
      }
export function useGetMaximumHierarchyTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaximumHierarchyTypeQuery, GetMaximumHierarchyTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaximumHierarchyTypeQuery, GetMaximumHierarchyTypeQueryVariables>(GetMaximumHierarchyTypeDocument, options);
        }
export function useGetMaximumHierarchyTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaximumHierarchyTypeQuery, GetMaximumHierarchyTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaximumHierarchyTypeQuery, GetMaximumHierarchyTypeQueryVariables>(GetMaximumHierarchyTypeDocument, options);
        }
export type GetMaximumHierarchyTypeQueryHookResult = ReturnType<typeof useGetMaximumHierarchyTypeQuery>;
export type GetMaximumHierarchyTypeLazyQueryHookResult = ReturnType<typeof useGetMaximumHierarchyTypeLazyQuery>;
export type GetMaximumHierarchyTypeSuspenseQueryHookResult = ReturnType<typeof useGetMaximumHierarchyTypeSuspenseQuery>;
export type GetMaximumHierarchyTypeQueryResult = Apollo.QueryResult<GetMaximumHierarchyTypeQuery, GetMaximumHierarchyTypeQueryVariables>;
export const GetSchoolsByRootDocument = gql`
    query GetSchoolsByRoot($rootId: Int!, $type: String!) {
  schoolsByRoot(rootId: $rootId, type: $type) {
    id
    name
  }
}
    `;

/**
 * __useGetSchoolsByRootQuery__
 *
 * To run a query within a React component, call `useGetSchoolsByRootQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolsByRootQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolsByRootQuery({
 *   variables: {
 *      rootId: // value for 'rootId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSchoolsByRootQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolsByRootQuery, GetSchoolsByRootQueryVariables> & ({ variables: GetSchoolsByRootQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolsByRootQuery, GetSchoolsByRootQueryVariables>(GetSchoolsByRootDocument, options);
      }
export function useGetSchoolsByRootLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolsByRootQuery, GetSchoolsByRootQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolsByRootQuery, GetSchoolsByRootQueryVariables>(GetSchoolsByRootDocument, options);
        }
export function useGetSchoolsByRootSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchoolsByRootQuery, GetSchoolsByRootQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchoolsByRootQuery, GetSchoolsByRootQueryVariables>(GetSchoolsByRootDocument, options);
        }
export type GetSchoolsByRootQueryHookResult = ReturnType<typeof useGetSchoolsByRootQuery>;
export type GetSchoolsByRootLazyQueryHookResult = ReturnType<typeof useGetSchoolsByRootLazyQuery>;
export type GetSchoolsByRootSuspenseQueryHookResult = ReturnType<typeof useGetSchoolsByRootSuspenseQuery>;
export type GetSchoolsByRootQueryResult = Apollo.QueryResult<GetSchoolsByRootQuery, GetSchoolsByRootQueryVariables>;
export const FindReadersDocument = gql`
    query FindReaders($entityId: Int!, $term: String!) {
  findReaders(entityId: $entityId, term: $term) {
    id
    name
  }
}
    `;

/**
 * __useFindReadersQuery__
 *
 * To run a query within a React component, call `useFindReadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindReadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindReadersQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useFindReadersQuery(baseOptions: Apollo.QueryHookOptions<FindReadersQuery, FindReadersQueryVariables> & ({ variables: FindReadersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindReadersQuery, FindReadersQueryVariables>(FindReadersDocument, options);
      }
export function useFindReadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindReadersQuery, FindReadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindReadersQuery, FindReadersQueryVariables>(FindReadersDocument, options);
        }
export function useFindReadersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindReadersQuery, FindReadersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindReadersQuery, FindReadersQueryVariables>(FindReadersDocument, options);
        }
export type FindReadersQueryHookResult = ReturnType<typeof useFindReadersQuery>;
export type FindReadersLazyQueryHookResult = ReturnType<typeof useFindReadersLazyQuery>;
export type FindReadersSuspenseQueryHookResult = ReturnType<typeof useFindReadersSuspenseQuery>;
export type FindReadersQueryResult = Apollo.QueryResult<FindReadersQuery, FindReadersQueryVariables>;
export const AcquisitionPlansOldDocument = gql`
    query acquisitionPlansOld {
  acquisitionPlans {
    iconUri
    id
    name
    price
    productSum
    products {
      id
      name
      price
    }
    type
  }
}
    `;

/**
 * __useAcquisitionPlansOldQuery__
 *
 * To run a query within a React component, call `useAcquisitionPlansOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcquisitionPlansOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcquisitionPlansOldQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcquisitionPlansOldQuery(baseOptions?: Apollo.QueryHookOptions<AcquisitionPlansOldQuery, AcquisitionPlansOldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcquisitionPlansOldQuery, AcquisitionPlansOldQueryVariables>(AcquisitionPlansOldDocument, options);
      }
export function useAcquisitionPlansOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcquisitionPlansOldQuery, AcquisitionPlansOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcquisitionPlansOldQuery, AcquisitionPlansOldQueryVariables>(AcquisitionPlansOldDocument, options);
        }
export function useAcquisitionPlansOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AcquisitionPlansOldQuery, AcquisitionPlansOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AcquisitionPlansOldQuery, AcquisitionPlansOldQueryVariables>(AcquisitionPlansOldDocument, options);
        }
export type AcquisitionPlansOldQueryHookResult = ReturnType<typeof useAcquisitionPlansOldQuery>;
export type AcquisitionPlansOldLazyQueryHookResult = ReturnType<typeof useAcquisitionPlansOldLazyQuery>;
export type AcquisitionPlansOldSuspenseQueryHookResult = ReturnType<typeof useAcquisitionPlansOldSuspenseQuery>;
export type AcquisitionPlansOldQueryResult = Apollo.QueryResult<AcquisitionPlansOldQuery, AcquisitionPlansOldQueryVariables>;
export const GetForestDropsDataDocument = gql`
    query getForestDropsData {
  me {
    id
    reader {
      id
      forest {
        id
        waterDropDetails {
          currentDrops
          dropsPerLevel
          maxDrops
          minimumLevel
          raining
        }
      }
    }
  }
}
    `;

/**
 * __useGetForestDropsDataQuery__
 *
 * To run a query within a React component, call `useGetForestDropsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForestDropsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForestDropsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetForestDropsDataQuery(baseOptions?: Apollo.QueryHookOptions<GetForestDropsDataQuery, GetForestDropsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForestDropsDataQuery, GetForestDropsDataQueryVariables>(GetForestDropsDataDocument, options);
      }
export function useGetForestDropsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForestDropsDataQuery, GetForestDropsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForestDropsDataQuery, GetForestDropsDataQueryVariables>(GetForestDropsDataDocument, options);
        }
export function useGetForestDropsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetForestDropsDataQuery, GetForestDropsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetForestDropsDataQuery, GetForestDropsDataQueryVariables>(GetForestDropsDataDocument, options);
        }
export type GetForestDropsDataQueryHookResult = ReturnType<typeof useGetForestDropsDataQuery>;
export type GetForestDropsDataLazyQueryHookResult = ReturnType<typeof useGetForestDropsDataLazyQuery>;
export type GetForestDropsDataSuspenseQueryHookResult = ReturnType<typeof useGetForestDropsDataSuspenseQuery>;
export type GetForestDropsDataQueryResult = Apollo.QueryResult<GetForestDropsDataQuery, GetForestDropsDataQueryVariables>;
export const GetUsersListingDocument = gql`
    query GetUsersListing($page: Int, $perPage: Int, $search: String) {
  getUsersListing(page: $page, perPage: $perPage, search: $search) {
    id
    name
    email
    entity {
      id
      name
    }
    root {
      id
      name
    }
  }
  totalUsers
}
    `;

/**
 * __useGetUsersListingQuery__
 *
 * To run a query within a React component, call `useGetUsersListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersListingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetUsersListingQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersListingQuery, GetUsersListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersListingQuery, GetUsersListingQueryVariables>(GetUsersListingDocument, options);
      }
export function useGetUsersListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersListingQuery, GetUsersListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersListingQuery, GetUsersListingQueryVariables>(GetUsersListingDocument, options);
        }
export function useGetUsersListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersListingQuery, GetUsersListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersListingQuery, GetUsersListingQueryVariables>(GetUsersListingDocument, options);
        }
export type GetUsersListingQueryHookResult = ReturnType<typeof useGetUsersListingQuery>;
export type GetUsersListingLazyQueryHookResult = ReturnType<typeof useGetUsersListingLazyQuery>;
export type GetUsersListingSuspenseQueryHookResult = ReturnType<typeof useGetUsersListingSuspenseQuery>;
export type GetUsersListingQueryResult = Apollo.QueryResult<GetUsersListingQuery, GetUsersListingQueryVariables>;
export const GetPublicFeatureTogglesDocument = gql`
    query getPublicFeatureToggles {
  publicFeatureToggles {
    comboRedirects
  }
}
    `;

/**
 * __useGetPublicFeatureTogglesQuery__
 *
 * To run a query within a React component, call `useGetPublicFeatureTogglesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicFeatureTogglesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicFeatureTogglesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicFeatureTogglesQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicFeatureTogglesQuery, GetPublicFeatureTogglesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicFeatureTogglesQuery, GetPublicFeatureTogglesQueryVariables>(GetPublicFeatureTogglesDocument, options);
      }
export function useGetPublicFeatureTogglesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicFeatureTogglesQuery, GetPublicFeatureTogglesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicFeatureTogglesQuery, GetPublicFeatureTogglesQueryVariables>(GetPublicFeatureTogglesDocument, options);
        }
export function useGetPublicFeatureTogglesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicFeatureTogglesQuery, GetPublicFeatureTogglesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicFeatureTogglesQuery, GetPublicFeatureTogglesQueryVariables>(GetPublicFeatureTogglesDocument, options);
        }
export type GetPublicFeatureTogglesQueryHookResult = ReturnType<typeof useGetPublicFeatureTogglesQuery>;
export type GetPublicFeatureTogglesLazyQueryHookResult = ReturnType<typeof useGetPublicFeatureTogglesLazyQuery>;
export type GetPublicFeatureTogglesSuspenseQueryHookResult = ReturnType<typeof useGetPublicFeatureTogglesSuspenseQuery>;
export type GetPublicFeatureTogglesQueryResult = Apollo.QueryResult<GetPublicFeatureTogglesQuery, GetPublicFeatureTogglesQueryVariables>;
export const GetReaderDocument = gql`
    query GetReader($id: Int!) {
  getReader(id: $id) {
    id
    userId
    name
    email
    accessToken
    permissions
    accessExpireDate
    teacherId
    teacherPermissions
  }
}
    `;

/**
 * __useGetReaderQuery__
 *
 * To run a query within a React component, call `useGetReaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReaderQuery(baseOptions: Apollo.QueryHookOptions<GetReaderQuery, GetReaderQueryVariables> & ({ variables: GetReaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReaderQuery, GetReaderQueryVariables>(GetReaderDocument, options);
      }
export function useGetReaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReaderQuery, GetReaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReaderQuery, GetReaderQueryVariables>(GetReaderDocument, options);
        }
export function useGetReaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReaderQuery, GetReaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReaderQuery, GetReaderQueryVariables>(GetReaderDocument, options);
        }
export type GetReaderQueryHookResult = ReturnType<typeof useGetReaderQuery>;
export type GetReaderLazyQueryHookResult = ReturnType<typeof useGetReaderLazyQuery>;
export type GetReaderSuspenseQueryHookResult = ReturnType<typeof useGetReaderSuspenseQuery>;
export type GetReaderQueryResult = Apollo.QueryResult<GetReaderQuery, GetReaderQueryVariables>;
export const IsFavoriteBookDocument = gql`
    query IsFavoriteBook($slug: String) {
  me {
    id
    reader {
      id
      isFavoriteBook(slug: $slug)
    }
  }
}
    `;

/**
 * __useIsFavoriteBookQuery__
 *
 * To run a query within a React component, call `useIsFavoriteBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFavoriteBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFavoriteBookQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useIsFavoriteBookQuery(baseOptions?: Apollo.QueryHookOptions<IsFavoriteBookQuery, IsFavoriteBookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsFavoriteBookQuery, IsFavoriteBookQueryVariables>(IsFavoriteBookDocument, options);
      }
export function useIsFavoriteBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsFavoriteBookQuery, IsFavoriteBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsFavoriteBookQuery, IsFavoriteBookQueryVariables>(IsFavoriteBookDocument, options);
        }
export function useIsFavoriteBookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsFavoriteBookQuery, IsFavoriteBookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsFavoriteBookQuery, IsFavoriteBookQueryVariables>(IsFavoriteBookDocument, options);
        }
export type IsFavoriteBookQueryHookResult = ReturnType<typeof useIsFavoriteBookQuery>;
export type IsFavoriteBookLazyQueryHookResult = ReturnType<typeof useIsFavoriteBookLazyQuery>;
export type IsFavoriteBookSuspenseQueryHookResult = ReturnType<typeof useIsFavoriteBookSuspenseQuery>;
export type IsFavoriteBookQueryResult = Apollo.QueryResult<IsFavoriteBookQuery, IsFavoriteBookQueryVariables>;
export const ListOnboardingThemesDocument = gql`
    query listOnboardingThemes {
  listOnboardingThemes {
    id
    name
    iconName: icon
  }
}
    `;

/**
 * __useListOnboardingThemesQuery__
 *
 * To run a query within a React component, call `useListOnboardingThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOnboardingThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOnboardingThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOnboardingThemesQuery(baseOptions?: Apollo.QueryHookOptions<ListOnboardingThemesQuery, ListOnboardingThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOnboardingThemesQuery, ListOnboardingThemesQueryVariables>(ListOnboardingThemesDocument, options);
      }
export function useListOnboardingThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOnboardingThemesQuery, ListOnboardingThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOnboardingThemesQuery, ListOnboardingThemesQueryVariables>(ListOnboardingThemesDocument, options);
        }
export function useListOnboardingThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOnboardingThemesQuery, ListOnboardingThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOnboardingThemesQuery, ListOnboardingThemesQueryVariables>(ListOnboardingThemesDocument, options);
        }
export type ListOnboardingThemesQueryHookResult = ReturnType<typeof useListOnboardingThemesQuery>;
export type ListOnboardingThemesLazyQueryHookResult = ReturnType<typeof useListOnboardingThemesLazyQuery>;
export type ListOnboardingThemesSuspenseQueryHookResult = ReturnType<typeof useListOnboardingThemesSuspenseQuery>;
export type ListOnboardingThemesQueryResult = Apollo.QueryResult<ListOnboardingThemesQuery, ListOnboardingThemesQueryVariables>;
export const CollectionsDocument = gql`
    query Collections($contentFilter: String) {
  me {
    id
    reader {
      id
      collections(contentFilter: $contentFilter) {
        id
        name
        image
      }
    }
  }
}
    `;

/**
 * __useCollectionsQuery__
 *
 * To run a query within a React component, call `useCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsQuery({
 *   variables: {
 *      contentFilter: // value for 'contentFilter'
 *   },
 * });
 */
export function useCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
      }
export function useCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
        }
export function useCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
        }
export type CollectionsQueryHookResult = ReturnType<typeof useCollectionsQuery>;
export type CollectionsLazyQueryHookResult = ReturnType<typeof useCollectionsLazyQuery>;
export type CollectionsSuspenseQueryHookResult = ReturnType<typeof useCollectionsSuspenseQuery>;
export type CollectionsQueryResult = Apollo.QueryResult<CollectionsQuery, CollectionsQueryVariables>;
export const HighlightsBooksDocument = gql`
    query highlightsBooks($contentFilter: String) {
  me {
    id
    reader {
      id
      highlightsv2(contentFilter: $contentFilter) {
        id
        bookShelfItems {
          book {
            name
            author
            slug
            degree
            imageUrlThumb
            language
            premiumLock
            hasAudioBook
          }
          mascot
        }
        isHighlight
        name
      }
    }
  }
}
    `;

/**
 * __useHighlightsBooksQuery__
 *
 * To run a query within a React component, call `useHighlightsBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightsBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightsBooksQuery({
 *   variables: {
 *      contentFilter: // value for 'contentFilter'
 *   },
 * });
 */
export function useHighlightsBooksQuery(baseOptions?: Apollo.QueryHookOptions<HighlightsBooksQuery, HighlightsBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightsBooksQuery, HighlightsBooksQueryVariables>(HighlightsBooksDocument, options);
      }
export function useHighlightsBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightsBooksQuery, HighlightsBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightsBooksQuery, HighlightsBooksQueryVariables>(HighlightsBooksDocument, options);
        }
export function useHighlightsBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightsBooksQuery, HighlightsBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightsBooksQuery, HighlightsBooksQueryVariables>(HighlightsBooksDocument, options);
        }
export type HighlightsBooksQueryHookResult = ReturnType<typeof useHighlightsBooksQuery>;
export type HighlightsBooksLazyQueryHookResult = ReturnType<typeof useHighlightsBooksLazyQuery>;
export type HighlightsBooksSuspenseQueryHookResult = ReturnType<typeof useHighlightsBooksSuspenseQuery>;
export type HighlightsBooksQueryResult = Apollo.QueryResult<HighlightsBooksQuery, HighlightsBooksQueryVariables>;
export const RelayPaginatedFavoritesDocument = gql`
    query relayPaginatedFavorites($after: String, $before: String, $first: Int, $last: Int, $order: String, $hasStoryTree: Boolean = false) {
  me {
    id
    reader {
      id
      relayPaginatedFavorites(
        after: $after
        before: $before
        first: $first
        last: $last
        order: $order
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            hasEbook
            hasAudioBook
            author
            slug
            degree
            imageUrlThumb
            imageUrlThumbLow
            premiumLock
            lexileLevel @include(if: $hasStoryTree)
            language
            favoritesVisibility @client
            publisher {
              id
            }
            activities {
              moduleId
            }
            qualeActivities {
              moduleId
            }
            sentirActivities {
              moduleId
            }
          }
          cursor
        }
      }
    }
  }
}
    `;

/**
 * __useRelayPaginatedFavoritesQuery__
 *
 * To run a query within a React component, call `useRelayPaginatedFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelayPaginatedFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelayPaginatedFavoritesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      order: // value for 'order'
 *      hasStoryTree: // value for 'hasStoryTree'
 *   },
 * });
 */
export function useRelayPaginatedFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<RelayPaginatedFavoritesQuery, RelayPaginatedFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelayPaginatedFavoritesQuery, RelayPaginatedFavoritesQueryVariables>(RelayPaginatedFavoritesDocument, options);
      }
export function useRelayPaginatedFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelayPaginatedFavoritesQuery, RelayPaginatedFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelayPaginatedFavoritesQuery, RelayPaginatedFavoritesQueryVariables>(RelayPaginatedFavoritesDocument, options);
        }
export function useRelayPaginatedFavoritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelayPaginatedFavoritesQuery, RelayPaginatedFavoritesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelayPaginatedFavoritesQuery, RelayPaginatedFavoritesQueryVariables>(RelayPaginatedFavoritesDocument, options);
        }
export type RelayPaginatedFavoritesQueryHookResult = ReturnType<typeof useRelayPaginatedFavoritesQuery>;
export type RelayPaginatedFavoritesLazyQueryHookResult = ReturnType<typeof useRelayPaginatedFavoritesLazyQuery>;
export type RelayPaginatedFavoritesSuspenseQueryHookResult = ReturnType<typeof useRelayPaginatedFavoritesSuspenseQuery>;
export type RelayPaginatedFavoritesQueryResult = Apollo.QueryResult<RelayPaginatedFavoritesQuery, RelayPaginatedFavoritesQueryVariables>;
export const RelayPaginatedViewedBooksDocument = gql`
    query relayPaginatedViewedBooks($after: String, $before: String, $contentFilter: String, $first: Int, $isReading: Boolean, $order: String, $hasStoryTree: Boolean = false) {
  me {
    id
    reader {
      id
      relayPaginatedViewedBooks(
        after: $after
        before: $before
        contentFilter: $contentFilter
        first: $first
        isReading: $isReading
        order: $order
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            book {
              name
              author
              slug
              degree
              imageUrlThumb
              imageUrlThumbLow
              premiumLock
              hasAudioBook
              hasEbook
              language
              lexileLevel @include(if: $hasStoryTree)
            }
          }
          cursor
        }
      }
    }
  }
}
    `;

/**
 * __useRelayPaginatedViewedBooksQuery__
 *
 * To run a query within a React component, call `useRelayPaginatedViewedBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelayPaginatedViewedBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelayPaginatedViewedBooksQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      contentFilter: // value for 'contentFilter'
 *      first: // value for 'first'
 *      isReading: // value for 'isReading'
 *      order: // value for 'order'
 *      hasStoryTree: // value for 'hasStoryTree'
 *   },
 * });
 */
export function useRelayPaginatedViewedBooksQuery(baseOptions?: Apollo.QueryHookOptions<RelayPaginatedViewedBooksQuery, RelayPaginatedViewedBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelayPaginatedViewedBooksQuery, RelayPaginatedViewedBooksQueryVariables>(RelayPaginatedViewedBooksDocument, options);
      }
export function useRelayPaginatedViewedBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelayPaginatedViewedBooksQuery, RelayPaginatedViewedBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelayPaginatedViewedBooksQuery, RelayPaginatedViewedBooksQueryVariables>(RelayPaginatedViewedBooksDocument, options);
        }
export function useRelayPaginatedViewedBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelayPaginatedViewedBooksQuery, RelayPaginatedViewedBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelayPaginatedViewedBooksQuery, RelayPaginatedViewedBooksQueryVariables>(RelayPaginatedViewedBooksDocument, options);
        }
export type RelayPaginatedViewedBooksQueryHookResult = ReturnType<typeof useRelayPaginatedViewedBooksQuery>;
export type RelayPaginatedViewedBooksLazyQueryHookResult = ReturnType<typeof useRelayPaginatedViewedBooksLazyQuery>;
export type RelayPaginatedViewedBooksSuspenseQueryHookResult = ReturnType<typeof useRelayPaginatedViewedBooksSuspenseQuery>;
export type RelayPaginatedViewedBooksQueryResult = Apollo.QueryResult<RelayPaginatedViewedBooksQuery, RelayPaginatedViewedBooksQueryVariables>;
export const BookLastInteractionDocument = gql`
    query BookLastInteraction($slug: String!) {
  bookDetails(slug: $slug) {
    slug
    lastInteraction
  }
}
    `;

/**
 * __useBookLastInteractionQuery__
 *
 * To run a query within a React component, call `useBookLastInteractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookLastInteractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookLastInteractionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBookLastInteractionQuery(baseOptions: Apollo.QueryHookOptions<BookLastInteractionQuery, BookLastInteractionQueryVariables> & ({ variables: BookLastInteractionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookLastInteractionQuery, BookLastInteractionQueryVariables>(BookLastInteractionDocument, options);
      }
export function useBookLastInteractionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookLastInteractionQuery, BookLastInteractionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookLastInteractionQuery, BookLastInteractionQueryVariables>(BookLastInteractionDocument, options);
        }
export function useBookLastInteractionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookLastInteractionQuery, BookLastInteractionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookLastInteractionQuery, BookLastInteractionQueryVariables>(BookLastInteractionDocument, options);
        }
export type BookLastInteractionQueryHookResult = ReturnType<typeof useBookLastInteractionQuery>;
export type BookLastInteractionLazyQueryHookResult = ReturnType<typeof useBookLastInteractionLazyQuery>;
export type BookLastInteractionSuspenseQueryHookResult = ReturnType<typeof useBookLastInteractionSuspenseQuery>;
export type BookLastInteractionQueryResult = Apollo.QueryResult<BookLastInteractionQuery, BookLastInteractionQueryVariables>;
export const MainScreenSuggestionsv3Document = gql`
    query MainScreenSuggestionsv3($page: Int, $perPage: Int, $contentFilter: String!, $degree: String, $limit: Int) {
  me {
    id
    reader {
      id
      mainScreenSuggestionsv3(
        page: $page
        perPage: $perPage
        contentFilter: $contentFilter
      ) {
        id
        name
        subtitle
        isHighlight
        bookShelfItems(limit: $limit, degree: $degree) {
          id
          book {
            name
            author
            language
            slug
            degree
            imageUrlThumb
            premiumLock
            hasAudioBook
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMainScreenSuggestionsv3Query__
 *
 * To run a query within a React component, call `useMainScreenSuggestionsv3Query` and pass it any options that fit your needs.
 * When your component renders, `useMainScreenSuggestionsv3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainScreenSuggestionsv3Query({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      contentFilter: // value for 'contentFilter'
 *      degree: // value for 'degree'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMainScreenSuggestionsv3Query(baseOptions: Apollo.QueryHookOptions<MainScreenSuggestionsv3Query, MainScreenSuggestionsv3QueryVariables> & ({ variables: MainScreenSuggestionsv3QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainScreenSuggestionsv3Query, MainScreenSuggestionsv3QueryVariables>(MainScreenSuggestionsv3Document, options);
      }
export function useMainScreenSuggestionsv3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainScreenSuggestionsv3Query, MainScreenSuggestionsv3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainScreenSuggestionsv3Query, MainScreenSuggestionsv3QueryVariables>(MainScreenSuggestionsv3Document, options);
        }
export function useMainScreenSuggestionsv3SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MainScreenSuggestionsv3Query, MainScreenSuggestionsv3QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainScreenSuggestionsv3Query, MainScreenSuggestionsv3QueryVariables>(MainScreenSuggestionsv3Document, options);
        }
export type MainScreenSuggestionsv3QueryHookResult = ReturnType<typeof useMainScreenSuggestionsv3Query>;
export type MainScreenSuggestionsv3LazyQueryHookResult = ReturnType<typeof useMainScreenSuggestionsv3LazyQuery>;
export type MainScreenSuggestionsv3SuspenseQueryHookResult = ReturnType<typeof useMainScreenSuggestionsv3SuspenseQuery>;
export type MainScreenSuggestionsv3QueryResult = Apollo.QueryResult<MainScreenSuggestionsv3Query, MainScreenSuggestionsv3QueryVariables>;
export const GetReaderEnglishLevelsDocument = gql`
    query getReaderEnglishLevels {
  me {
    id
    reader {
      listEnglishLevels {
        type
        levels
      }
    }
  }
}
    `;

/**
 * __useGetReaderEnglishLevelsQuery__
 *
 * To run a query within a React component, call `useGetReaderEnglishLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReaderEnglishLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReaderEnglishLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReaderEnglishLevelsQuery(baseOptions?: Apollo.QueryHookOptions<GetReaderEnglishLevelsQuery, GetReaderEnglishLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReaderEnglishLevelsQuery, GetReaderEnglishLevelsQueryVariables>(GetReaderEnglishLevelsDocument, options);
      }
export function useGetReaderEnglishLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReaderEnglishLevelsQuery, GetReaderEnglishLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReaderEnglishLevelsQuery, GetReaderEnglishLevelsQueryVariables>(GetReaderEnglishLevelsDocument, options);
        }
export function useGetReaderEnglishLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReaderEnglishLevelsQuery, GetReaderEnglishLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReaderEnglishLevelsQuery, GetReaderEnglishLevelsQueryVariables>(GetReaderEnglishLevelsDocument, options);
        }
export type GetReaderEnglishLevelsQueryHookResult = ReturnType<typeof useGetReaderEnglishLevelsQuery>;
export type GetReaderEnglishLevelsLazyQueryHookResult = ReturnType<typeof useGetReaderEnglishLevelsLazyQuery>;
export type GetReaderEnglishLevelsSuspenseQueryHookResult = ReturnType<typeof useGetReaderEnglishLevelsSuspenseQuery>;
export type GetReaderEnglishLevelsQueryResult = Apollo.QueryResult<GetReaderEnglishLevelsQuery, GetReaderEnglishLevelsQueryVariables>;
export const BookDocument = gql`
    query Book($slug: String!) {
  me {
    id
    reader {
      id
      isFavoriteBook(slug: $slug)
      viewedBookPosition: getViewedBookPosition(slug: $slug)
    }
  }
  bookDetails(slug: $slug) {
    id
    authors
    downloadUrl
    ...bookNavigationFields
    relatedContents {
      source
      url
    }
    bookCharacteristic {
      characteristic {
        name
      }
    }
    bookTheme {
      theme {
        name
      }
    }
    bookThema {
      thema {
        id
        name
        code
        uiName
      }
    }
    bookCategory {
      category {
        name
      }
    }
    customCategories {
      name
    }
    bookDegree {
      degree
    }
    language
    publisher {
      id
      name
    }
    activities {
      id
      title
      bookCount
      isBncc
      estimatedCompletionTimeInSeconds
      authorInfo {
        name
        school
      }
      examQuestions {
        id
        type
        bnccAbilityExamQuestion {
          id
          bnccAbility {
            id
            code
          }
        }
      }
      publicDataActivity {
        id
        objective
        degreeRange
        tags {
          name
        }
        textualGenres {
          name
        }
        generalSkills {
          description
        }
      }
      books {
        author
        name
        imageUrlThumb
      }
    }
    pendingActivities {
      id
      title
      bookCount
      isBncc
      estimatedCompletionTimeInSeconds
      authorInfo {
        name
        school
      }
      examQuestions {
        id
        type
        bnccAbilityExamQuestion {
          id
          bnccAbility {
            id
            code
          }
        }
      }
      publicDataActivity {
        id
        objective
        degreeRange
        tags {
          name
        }
        textualGenres {
          name
        }
        generalSkills {
          description
        }
      }
      books {
        author
        name
        imageUrlThumb
      }
    }
    qualeActivities {
      id
      title
      examQuestions {
        type
      }
    }
    sentirActivities {
      id
      title
      bookCount
      isBncc
      moduleId
      examQuestions {
        type
      }
      authorInfo {
        name
        school
      }
      books {
        author
        name
        imageUrlThumb
      }
    }
    imprint
    readingLevel
    englishLevels {
      type
      levels
    }
    series
    subtitle
    edition
    publicationYear
    note
    hasEbook
    disabled
  }
}
    ${BookNavigationFieldsFragmentDoc}`;

/**
 * __useBookQuery__
 *
 * To run a query within a React component, call `useBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBookQuery(baseOptions: Apollo.QueryHookOptions<BookQuery, BookQueryVariables> & ({ variables: BookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookQuery, BookQueryVariables>(BookDocument, options);
      }
export function useBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookQuery, BookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookQuery, BookQueryVariables>(BookDocument, options);
        }
export function useBookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookQuery, BookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookQuery, BookQueryVariables>(BookDocument, options);
        }
export type BookQueryHookResult = ReturnType<typeof useBookQuery>;
export type BookLazyQueryHookResult = ReturnType<typeof useBookLazyQuery>;
export type BookSuspenseQueryHookResult = ReturnType<typeof useBookSuspenseQuery>;
export type BookQueryResult = Apollo.QueryResult<BookQuery, BookQueryVariables>;
export const BookRecommendedContentDocument = gql`
    query BookRecommendedContent($slug: String!) {
  bookDetails(slug: $slug) {
    slug
    recommendedContentShelves {
      identifier
      title
      contentShelf {
        name
        author
        slug
        imageUrlThumb
        imageUrlThumbLow
        premiumLock
        hasAudioBook
      }
    }
  }
}
    `;

/**
 * __useBookRecommendedContentQuery__
 *
 * To run a query within a React component, call `useBookRecommendedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookRecommendedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookRecommendedContentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBookRecommendedContentQuery(baseOptions: Apollo.QueryHookOptions<BookRecommendedContentQuery, BookRecommendedContentQueryVariables> & ({ variables: BookRecommendedContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookRecommendedContentQuery, BookRecommendedContentQueryVariables>(BookRecommendedContentDocument, options);
      }
export function useBookRecommendedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookRecommendedContentQuery, BookRecommendedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookRecommendedContentQuery, BookRecommendedContentQueryVariables>(BookRecommendedContentDocument, options);
        }
export function useBookRecommendedContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookRecommendedContentQuery, BookRecommendedContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookRecommendedContentQuery, BookRecommendedContentQueryVariables>(BookRecommendedContentDocument, options);
        }
export type BookRecommendedContentQueryHookResult = ReturnType<typeof useBookRecommendedContentQuery>;
export type BookRecommendedContentLazyQueryHookResult = ReturnType<typeof useBookRecommendedContentLazyQuery>;
export type BookRecommendedContentSuspenseQueryHookResult = ReturnType<typeof useBookRecommendedContentSuspenseQuery>;
export type BookRecommendedContentQueryResult = Apollo.QueryResult<BookRecommendedContentQuery, BookRecommendedContentQueryVariables>;
export const ArticleRecommendedContentDocument = gql`
    query ArticleRecommendedContent($id: Int!) {
  articleDetails(id: $id) {
    id
    recommendedContentShelves {
      identifier
      title
      shelfItems {
        ... on Article {
          __typename
          id
          title
          author
          image
          subtitle
          publishDate
          degree
          categories {
            name
            slug
            iconIdentifier
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArticleRecommendedContentQuery__
 *
 * To run a query within a React component, call `useArticleRecommendedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleRecommendedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleRecommendedContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleRecommendedContentQuery(baseOptions: Apollo.QueryHookOptions<ArticleRecommendedContentQuery, ArticleRecommendedContentQueryVariables> & ({ variables: ArticleRecommendedContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleRecommendedContentQuery, ArticleRecommendedContentQueryVariables>(ArticleRecommendedContentDocument, options);
      }
export function useArticleRecommendedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleRecommendedContentQuery, ArticleRecommendedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleRecommendedContentQuery, ArticleRecommendedContentQueryVariables>(ArticleRecommendedContentDocument, options);
        }
export function useArticleRecommendedContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleRecommendedContentQuery, ArticleRecommendedContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleRecommendedContentQuery, ArticleRecommendedContentQueryVariables>(ArticleRecommendedContentDocument, options);
        }
export type ArticleRecommendedContentQueryHookResult = ReturnType<typeof useArticleRecommendedContentQuery>;
export type ArticleRecommendedContentLazyQueryHookResult = ReturnType<typeof useArticleRecommendedContentLazyQuery>;
export type ArticleRecommendedContentSuspenseQueryHookResult = ReturnType<typeof useArticleRecommendedContentSuspenseQuery>;
export type ArticleRecommendedContentQueryResult = Apollo.QueryResult<ArticleRecommendedContentQuery, ArticleRecommendedContentQueryVariables>;
export const GetActivityDocument = gql`
    query getActivity($activityId: Int!) {
  getActivity(activityId: $activityId) {
    authorInfo {
      facebookPhoto
      name
      school
    }
    moduleId
    books {
      slug
    }
    description
    examQuestions {
      id
    }
    id
    isReady
    publicDataActivity {
      id
    }
    submittedToPublic
    title
  }
}
    `;

/**
 * __useGetActivityQuery__
 *
 * To run a query within a React component, call `useGetActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useGetActivityQuery(baseOptions: Apollo.QueryHookOptions<GetActivityQuery, GetActivityQueryVariables> & ({ variables: GetActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
      }
export function useGetActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityQuery, GetActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
        }
export function useGetActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityQuery, GetActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, options);
        }
export type GetActivityQueryHookResult = ReturnType<typeof useGetActivityQuery>;
export type GetActivityLazyQueryHookResult = ReturnType<typeof useGetActivityLazyQuery>;
export type GetActivitySuspenseQueryHookResult = ReturnType<typeof useGetActivitySuspenseQuery>;
export type GetActivityQueryResult = Apollo.QueryResult<GetActivityQuery, GetActivityQueryVariables>;
export const ArticleShelvesDocument = gql`
    query articleShelves($page: Int!, $perPage: Int!) {
  me {
    id
    reader {
      id
      articleShelves {
        id
        description
        name
        articles(page: $page, perPage: $perPage) {
          id
          author
          degree
          description
          subtitle
          image
          title
          publishDate
          categories {
            name
            slug
            iconIdentifier
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArticleShelvesQuery__
 *
 * To run a query within a React component, call `useArticleShelvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleShelvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleShelvesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useArticleShelvesQuery(baseOptions: Apollo.QueryHookOptions<ArticleShelvesQuery, ArticleShelvesQueryVariables> & ({ variables: ArticleShelvesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleShelvesQuery, ArticleShelvesQueryVariables>(ArticleShelvesDocument, options);
      }
export function useArticleShelvesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleShelvesQuery, ArticleShelvesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleShelvesQuery, ArticleShelvesQueryVariables>(ArticleShelvesDocument, options);
        }
export function useArticleShelvesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleShelvesQuery, ArticleShelvesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleShelvesQuery, ArticleShelvesQueryVariables>(ArticleShelvesDocument, options);
        }
export type ArticleShelvesQueryHookResult = ReturnType<typeof useArticleShelvesQuery>;
export type ArticleShelvesLazyQueryHookResult = ReturnType<typeof useArticleShelvesLazyQuery>;
export type ArticleShelvesSuspenseQueryHookResult = ReturnType<typeof useArticleShelvesSuspenseQuery>;
export type ArticleShelvesQueryResult = Apollo.QueryResult<ArticleShelvesQuery, ArticleShelvesQueryVariables>;
export const ListArticlesDocument = gql`
    query listArticles($input: ListArticlesInput!) {
  listArticles(input: $input) {
    articles {
      id
      author
      description
      image
      title
      subtitle
      publishDate
      publisher
      degree
    }
    totalEntries
  }
}
    `;

/**
 * __useListArticlesQuery__
 *
 * To run a query within a React component, call `useListArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListArticlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListArticlesQuery(baseOptions: Apollo.QueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables> & ({ variables: ListArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListArticlesQuery, ListArticlesQueryVariables>(ListArticlesDocument, options);
      }
export function useListArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListArticlesQuery, ListArticlesQueryVariables>(ListArticlesDocument, options);
        }
export function useListArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListArticlesQuery, ListArticlesQueryVariables>(ListArticlesDocument, options);
        }
export type ListArticlesQueryHookResult = ReturnType<typeof useListArticlesQuery>;
export type ListArticlesLazyQueryHookResult = ReturnType<typeof useListArticlesLazyQuery>;
export type ListArticlesSuspenseQueryHookResult = ReturnType<typeof useListArticlesSuspenseQuery>;
export type ListArticlesQueryResult = Apollo.QueryResult<ListArticlesQuery, ListArticlesQueryVariables>;
export const ArticleDetailsDocument = gql`
    query articleDetails($id: Int!) {
  articleDetails(id: $id) {
    activities {
      id
      title
      isBncc
      moduleId
      examQuestions {
        type
      }
    }
    author
    imageAuthor
    consumptionStatus
    coverSubtitle
    coverTitle
    degree
    description
    htmlContent
    htmlRaw
    id
    image
    title
    subtitle
    publishDate
    publisher
    schoolSegment {
      label
      abbreviation
      value
      recommendedDegrees
    }
  }
}
    `;

/**
 * __useArticleDetailsQuery__
 *
 * To run a query within a React component, call `useArticleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleDetailsQuery(baseOptions: Apollo.QueryHookOptions<ArticleDetailsQuery, ArticleDetailsQueryVariables> & ({ variables: ArticleDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleDetailsQuery, ArticleDetailsQueryVariables>(ArticleDetailsDocument, options);
      }
export function useArticleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleDetailsQuery, ArticleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleDetailsQuery, ArticleDetailsQueryVariables>(ArticleDetailsDocument, options);
        }
export function useArticleDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleDetailsQuery, ArticleDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleDetailsQuery, ArticleDetailsQueryVariables>(ArticleDetailsDocument, options);
        }
export type ArticleDetailsQueryHookResult = ReturnType<typeof useArticleDetailsQuery>;
export type ArticleDetailsLazyQueryHookResult = ReturnType<typeof useArticleDetailsLazyQuery>;
export type ArticleDetailsSuspenseQueryHookResult = ReturnType<typeof useArticleDetailsSuspenseQuery>;
export type ArticleDetailsQueryResult = Apollo.QueryResult<ArticleDetailsQuery, ArticleDetailsQueryVariables>;
export const MagazinesShelfDocument = gql`
    query magazinesShelf {
  me {
    id
    reader {
      id
      magazinesShelf {
        date
        name
        image
        url
        cid
      }
    }
  }
}
    `;

/**
 * __useMagazinesShelfQuery__
 *
 * To run a query within a React component, call `useMagazinesShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagazinesShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagazinesShelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useMagazinesShelfQuery(baseOptions?: Apollo.QueryHookOptions<MagazinesShelfQuery, MagazinesShelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagazinesShelfQuery, MagazinesShelfQueryVariables>(MagazinesShelfDocument, options);
      }
export function useMagazinesShelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagazinesShelfQuery, MagazinesShelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagazinesShelfQuery, MagazinesShelfQueryVariables>(MagazinesShelfDocument, options);
        }
export function useMagazinesShelfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MagazinesShelfQuery, MagazinesShelfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MagazinesShelfQuery, MagazinesShelfQueryVariables>(MagazinesShelfDocument, options);
        }
export type MagazinesShelfQueryHookResult = ReturnType<typeof useMagazinesShelfQuery>;
export type MagazinesShelfLazyQueryHookResult = ReturnType<typeof useMagazinesShelfLazyQuery>;
export type MagazinesShelfSuspenseQueryHookResult = ReturnType<typeof useMagazinesShelfSuspenseQuery>;
export type MagazinesShelfQueryResult = Apollo.QueryResult<MagazinesShelfQuery, MagazinesShelfQueryVariables>;
export const NewspaperShelfDocument = gql`
    query newspaperShelf {
  me {
    id
    reader {
      id
      newspaperShelf {
        date
        name
        image
        url
        cid
      }
    }
  }
}
    `;

/**
 * __useNewspaperShelfQuery__
 *
 * To run a query within a React component, call `useNewspaperShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewspaperShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewspaperShelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewspaperShelfQuery(baseOptions?: Apollo.QueryHookOptions<NewspaperShelfQuery, NewspaperShelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewspaperShelfQuery, NewspaperShelfQueryVariables>(NewspaperShelfDocument, options);
      }
export function useNewspaperShelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewspaperShelfQuery, NewspaperShelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewspaperShelfQuery, NewspaperShelfQueryVariables>(NewspaperShelfDocument, options);
        }
export function useNewspaperShelfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewspaperShelfQuery, NewspaperShelfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewspaperShelfQuery, NewspaperShelfQueryVariables>(NewspaperShelfDocument, options);
        }
export type NewspaperShelfQueryHookResult = ReturnType<typeof useNewspaperShelfQuery>;
export type NewspaperShelfLazyQueryHookResult = ReturnType<typeof useNewspaperShelfLazyQuery>;
export type NewspaperShelfSuspenseQueryHookResult = ReturnType<typeof useNewspaperShelfSuspenseQuery>;
export type NewspaperShelfQueryResult = Apollo.QueryResult<NewspaperShelfQuery, NewspaperShelfQueryVariables>;
export const BookRemovalDatesDocument = gql`
    query bookRemovalDates($slugs: [String]!) {
  bookRemovalDates(slugs: $slugs) {
    deactivationDate
    slug
  }
}
    `;

/**
 * __useBookRemovalDatesQuery__
 *
 * To run a query within a React component, call `useBookRemovalDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookRemovalDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookRemovalDatesQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useBookRemovalDatesQuery(baseOptions: Apollo.QueryHookOptions<BookRemovalDatesQuery, BookRemovalDatesQueryVariables> & ({ variables: BookRemovalDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookRemovalDatesQuery, BookRemovalDatesQueryVariables>(BookRemovalDatesDocument, options);
      }
export function useBookRemovalDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookRemovalDatesQuery, BookRemovalDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookRemovalDatesQuery, BookRemovalDatesQueryVariables>(BookRemovalDatesDocument, options);
        }
export function useBookRemovalDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookRemovalDatesQuery, BookRemovalDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookRemovalDatesQuery, BookRemovalDatesQueryVariables>(BookRemovalDatesDocument, options);
        }
export type BookRemovalDatesQueryHookResult = ReturnType<typeof useBookRemovalDatesQuery>;
export type BookRemovalDatesLazyQueryHookResult = ReturnType<typeof useBookRemovalDatesLazyQuery>;
export type BookRemovalDatesSuspenseQueryHookResult = ReturnType<typeof useBookRemovalDatesSuspenseQuery>;
export type BookRemovalDatesQueryResult = Apollo.QueryResult<BookRemovalDatesQuery, BookRemovalDatesQueryVariables>;
export const SearchArticlesDocument = gql`
    query searchArticles($page: Int!, $perPage: Int!, $term: String, $onlyPublished: Boolean!) {
  searchArticles(
    input: {page: $page, perPage: $perPage, term: $term, onlyPublished: $onlyPublished}
  ) {
    id
    title
    image
    author
    degree
    subtitle
    publishDate
  }
}
    `;

/**
 * __useSearchArticlesQuery__
 *
 * To run a query within a React component, call `useSearchArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticlesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      term: // value for 'term'
 *      onlyPublished: // value for 'onlyPublished'
 *   },
 * });
 */
export function useSearchArticlesQuery(baseOptions: Apollo.QueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables> & ({ variables: SearchArticlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
      }
export function useSearchArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export function useSearchArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export type SearchArticlesQueryHookResult = ReturnType<typeof useSearchArticlesQuery>;
export type SearchArticlesLazyQueryHookResult = ReturnType<typeof useSearchArticlesLazyQuery>;
export type SearchArticlesSuspenseQueryHookResult = ReturnType<typeof useSearchArticlesSuspenseQuery>;
export type SearchArticlesQueryResult = Apollo.QueryResult<SearchArticlesQuery, SearchArticlesQueryVariables>;
export const SearchBookV3Document = gql`
    query searchBookV3($searchTerm: String, $page: Int, $perPage: Int!, $opts: String, $hasStoryTree: Boolean = false) {
  searchBookV3(
    searchTerm: $searchTerm
    page: $page
    perPage: $perPage
    opts: $opts
  ) {
    searchFilters
    books {
      name
      slug
      author
      degree
      hasAudioBook
      hasEbook
      isReadingTrail
      language
      imageUrlThumb
      imageUrlThumbLow
      lexileLevel @include(if: $hasStoryTree)
      publisher {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchBookV3Query__
 *
 * To run a query within a React component, call `useSearchBookV3Query` and pass it any options that fit your needs.
 * When your component renders, `useSearchBookV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBookV3Query({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      opts: // value for 'opts'
 *      hasStoryTree: // value for 'hasStoryTree'
 *   },
 * });
 */
export function useSearchBookV3Query(baseOptions: Apollo.QueryHookOptions<SearchBookV3Query, SearchBookV3QueryVariables> & ({ variables: SearchBookV3QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBookV3Query, SearchBookV3QueryVariables>(SearchBookV3Document, options);
      }
export function useSearchBookV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBookV3Query, SearchBookV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBookV3Query, SearchBookV3QueryVariables>(SearchBookV3Document, options);
        }
export function useSearchBookV3SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBookV3Query, SearchBookV3QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBookV3Query, SearchBookV3QueryVariables>(SearchBookV3Document, options);
        }
export type SearchBookV3QueryHookResult = ReturnType<typeof useSearchBookV3Query>;
export type SearchBookV3LazyQueryHookResult = ReturnType<typeof useSearchBookV3LazyQuery>;
export type SearchBookV3SuspenseQueryHookResult = ReturnType<typeof useSearchBookV3SuspenseQuery>;
export type SearchBookV3QueryResult = Apollo.QueryResult<SearchBookV3Query, SearchBookV3QueryVariables>;
export const ShowBookShelfDocument = gql`
    query showBookShelf($bookShelfId: Int!, $limit: Int, $page: Int) {
  showBookShelf(bookShelfId: $bookShelfId) {
    name
    subtitle
    degreeRange
    contentFilter
    isHighlight
    acervoType
    id
    type
    description
    image
    bgColor
    bookShelfItems(limit: $limit, page: $page) {
      book {
        slug
        name
        imageUrlThumb
        author
        hasAudioBook
        degree
        premiumLock
      }
      bookShelfId
      id
      mascot
    }
    bookShelfItemsCount
  }
}
    `;

/**
 * __useShowBookShelfQuery__
 *
 * To run a query within a React component, call `useShowBookShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowBookShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowBookShelfQuery({
 *   variables: {
 *      bookShelfId: // value for 'bookShelfId'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useShowBookShelfQuery(baseOptions: Apollo.QueryHookOptions<ShowBookShelfQuery, ShowBookShelfQueryVariables> & ({ variables: ShowBookShelfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowBookShelfQuery, ShowBookShelfQueryVariables>(ShowBookShelfDocument, options);
      }
export function useShowBookShelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowBookShelfQuery, ShowBookShelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowBookShelfQuery, ShowBookShelfQueryVariables>(ShowBookShelfDocument, options);
        }
export function useShowBookShelfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowBookShelfQuery, ShowBookShelfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowBookShelfQuery, ShowBookShelfQueryVariables>(ShowBookShelfDocument, options);
        }
export type ShowBookShelfQueryHookResult = ReturnType<typeof useShowBookShelfQuery>;
export type ShowBookShelfLazyQueryHookResult = ReturnType<typeof useShowBookShelfLazyQuery>;
export type ShowBookShelfSuspenseQueryHookResult = ReturnType<typeof useShowBookShelfSuspenseQuery>;
export type ShowBookShelfQueryResult = Apollo.QueryResult<ShowBookShelfQuery, ShowBookShelfQueryVariables>;
export const SearchIndependentActivitiesDocument = gql`
    query searchIndependentActivities($input: SearchIndependentActivitiesInput!, $searchTerm: String) {
  searchIndependentActivities(input: $input) {
    independentActivities {
      title
      subtitle
      readerId
      entity
      reader
      appliedActivityId
      status
      grade
      moduleId
      articles {
        image
        title
      }
      books {
        imageUrlThumb
        name
      }
    }
    totalEntries(searchTerm: $searchTerm)
  }
}
    `;

/**
 * __useSearchIndependentActivitiesQuery__
 *
 * To run a query within a React component, call `useSearchIndependentActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIndependentActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIndependentActivitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchIndependentActivitiesQuery(baseOptions: Apollo.QueryHookOptions<SearchIndependentActivitiesQuery, SearchIndependentActivitiesQueryVariables> & ({ variables: SearchIndependentActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchIndependentActivitiesQuery, SearchIndependentActivitiesQueryVariables>(SearchIndependentActivitiesDocument, options);
      }
export function useSearchIndependentActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchIndependentActivitiesQuery, SearchIndependentActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchIndependentActivitiesQuery, SearchIndependentActivitiesQueryVariables>(SearchIndependentActivitiesDocument, options);
        }
export function useSearchIndependentActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchIndependentActivitiesQuery, SearchIndependentActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchIndependentActivitiesQuery, SearchIndependentActivitiesQueryVariables>(SearchIndependentActivitiesDocument, options);
        }
export type SearchIndependentActivitiesQueryHookResult = ReturnType<typeof useSearchIndependentActivitiesQuery>;
export type SearchIndependentActivitiesLazyQueryHookResult = ReturnType<typeof useSearchIndependentActivitiesLazyQuery>;
export type SearchIndependentActivitiesSuspenseQueryHookResult = ReturnType<typeof useSearchIndependentActivitiesSuspenseQuery>;
export type SearchIndependentActivitiesQueryResult = Apollo.QueryResult<SearchIndependentActivitiesQuery, SearchIndependentActivitiesQueryVariables>;
export const ContentIndicationsToMeDocument = gql`
    query contentIndicationsToMe {
  me {
    indicationsToMe {
      id
      dueDate
      indicatedAt
      sourceUser {
        name
        isTeacher
        isFamily
      }
      content {
        identifier
        type
        contentDetails {
          ... on Book {
            name
            author
            slug
            imageUrlThumb
          }
          ... on Article {
            id
            title
            image
            author
          }
        }
      }
    }
  }
}
    `;

/**
 * __useContentIndicationsToMeQuery__
 *
 * To run a query within a React component, call `useContentIndicationsToMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentIndicationsToMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentIndicationsToMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentIndicationsToMeQuery(baseOptions?: Apollo.QueryHookOptions<ContentIndicationsToMeQuery, ContentIndicationsToMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentIndicationsToMeQuery, ContentIndicationsToMeQueryVariables>(ContentIndicationsToMeDocument, options);
      }
export function useContentIndicationsToMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentIndicationsToMeQuery, ContentIndicationsToMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentIndicationsToMeQuery, ContentIndicationsToMeQueryVariables>(ContentIndicationsToMeDocument, options);
        }
export function useContentIndicationsToMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentIndicationsToMeQuery, ContentIndicationsToMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentIndicationsToMeQuery, ContentIndicationsToMeQueryVariables>(ContentIndicationsToMeDocument, options);
        }
export type ContentIndicationsToMeQueryHookResult = ReturnType<typeof useContentIndicationsToMeQuery>;
export type ContentIndicationsToMeLazyQueryHookResult = ReturnType<typeof useContentIndicationsToMeLazyQuery>;
export type ContentIndicationsToMeSuspenseQueryHookResult = ReturnType<typeof useContentIndicationsToMeSuspenseQuery>;
export type ContentIndicationsToMeQueryResult = Apollo.QueryResult<ContentIndicationsToMeQuery, ContentIndicationsToMeQueryVariables>;
export const ContentIndicationsByMeDocument = gql`
    query contentIndicationsByMe {
  me {
    indicationsMadeByMe {
      id
      dueDate
      indicatedAt
      target {
        targetDetails {
          ... on Reader {
            user {
              name
            }
          }
          ... on Entity {
            name
          }
        }
      }
      content {
        identifier
        type
        contentDetails {
          ... on Book {
            name
            author
            slug
            imageUrlThumb
          }
          ... on Article {
            id
            title
            image
            author
          }
        }
      }
    }
  }
}
    `;

/**
 * __useContentIndicationsByMeQuery__
 *
 * To run a query within a React component, call `useContentIndicationsByMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentIndicationsByMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentIndicationsByMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentIndicationsByMeQuery(baseOptions?: Apollo.QueryHookOptions<ContentIndicationsByMeQuery, ContentIndicationsByMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentIndicationsByMeQuery, ContentIndicationsByMeQueryVariables>(ContentIndicationsByMeDocument, options);
      }
export function useContentIndicationsByMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentIndicationsByMeQuery, ContentIndicationsByMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentIndicationsByMeQuery, ContentIndicationsByMeQueryVariables>(ContentIndicationsByMeDocument, options);
        }
export function useContentIndicationsByMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentIndicationsByMeQuery, ContentIndicationsByMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentIndicationsByMeQuery, ContentIndicationsByMeQueryVariables>(ContentIndicationsByMeDocument, options);
        }
export type ContentIndicationsByMeQueryHookResult = ReturnType<typeof useContentIndicationsByMeQuery>;
export type ContentIndicationsByMeLazyQueryHookResult = ReturnType<typeof useContentIndicationsByMeLazyQuery>;
export type ContentIndicationsByMeSuspenseQueryHookResult = ReturnType<typeof useContentIndicationsByMeSuspenseQuery>;
export type ContentIndicationsByMeQueryResult = Apollo.QueryResult<ContentIndicationsByMeQuery, ContentIndicationsByMeQueryVariables>;
export const SearchAvailableReadersToIndicateDocument = gql`
    query searchAvailableReadersToIndicate($term: String!) {
  me {
    id
    teacher {
      entitiesSubtreeFlat
      searchAvailableReadersToIndicate(term: $term)
    }
  }
}
    `;

/**
 * __useSearchAvailableReadersToIndicateQuery__
 *
 * To run a query within a React component, call `useSearchAvailableReadersToIndicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAvailableReadersToIndicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAvailableReadersToIndicateQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchAvailableReadersToIndicateQuery(baseOptions: Apollo.QueryHookOptions<SearchAvailableReadersToIndicateQuery, SearchAvailableReadersToIndicateQueryVariables> & ({ variables: SearchAvailableReadersToIndicateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAvailableReadersToIndicateQuery, SearchAvailableReadersToIndicateQueryVariables>(SearchAvailableReadersToIndicateDocument, options);
      }
export function useSearchAvailableReadersToIndicateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAvailableReadersToIndicateQuery, SearchAvailableReadersToIndicateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAvailableReadersToIndicateQuery, SearchAvailableReadersToIndicateQueryVariables>(SearchAvailableReadersToIndicateDocument, options);
        }
export function useSearchAvailableReadersToIndicateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAvailableReadersToIndicateQuery, SearchAvailableReadersToIndicateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAvailableReadersToIndicateQuery, SearchAvailableReadersToIndicateQueryVariables>(SearchAvailableReadersToIndicateDocument, options);
        }
export type SearchAvailableReadersToIndicateQueryHookResult = ReturnType<typeof useSearchAvailableReadersToIndicateQuery>;
export type SearchAvailableReadersToIndicateLazyQueryHookResult = ReturnType<typeof useSearchAvailableReadersToIndicateLazyQuery>;
export type SearchAvailableReadersToIndicateSuspenseQueryHookResult = ReturnType<typeof useSearchAvailableReadersToIndicateSuspenseQuery>;
export type SearchAvailableReadersToIndicateQueryResult = Apollo.QueryResult<SearchAvailableReadersToIndicateQuery, SearchAvailableReadersToIndicateQueryVariables>;
export const SearchBookForAutoCompleteDocument = gql`
    query searchBookForAutoComplete($searchTerm: String!) {
  searchBook(searchTerm: $searchTerm) {
    name
    slug
  }
}
    `;

/**
 * __useSearchBookForAutoCompleteQuery__
 *
 * To run a query within a React component, call `useSearchBookForAutoCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBookForAutoCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBookForAutoCompleteQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchBookForAutoCompleteQuery(baseOptions: Apollo.QueryHookOptions<SearchBookForAutoCompleteQuery, SearchBookForAutoCompleteQueryVariables> & ({ variables: SearchBookForAutoCompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBookForAutoCompleteQuery, SearchBookForAutoCompleteQueryVariables>(SearchBookForAutoCompleteDocument, options);
      }
export function useSearchBookForAutoCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBookForAutoCompleteQuery, SearchBookForAutoCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBookForAutoCompleteQuery, SearchBookForAutoCompleteQueryVariables>(SearchBookForAutoCompleteDocument, options);
        }
export function useSearchBookForAutoCompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBookForAutoCompleteQuery, SearchBookForAutoCompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBookForAutoCompleteQuery, SearchBookForAutoCompleteQueryVariables>(SearchBookForAutoCompleteDocument, options);
        }
export type SearchBookForAutoCompleteQueryHookResult = ReturnType<typeof useSearchBookForAutoCompleteQuery>;
export type SearchBookForAutoCompleteLazyQueryHookResult = ReturnType<typeof useSearchBookForAutoCompleteLazyQuery>;
export type SearchBookForAutoCompleteSuspenseQueryHookResult = ReturnType<typeof useSearchBookForAutoCompleteSuspenseQuery>;
export type SearchBookForAutoCompleteQueryResult = Apollo.QueryResult<SearchBookForAutoCompleteQuery, SearchBookForAutoCompleteQueryVariables>;
export const ListReadersSameDegreeDocument = gql`
    query listReadersSameDegree($term: String!) {
  me {
    id
    reader {
      id
      listReadersSameDegree(term: $term)
    }
  }
}
    `;

/**
 * __useListReadersSameDegreeQuery__
 *
 * To run a query within a React component, call `useListReadersSameDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReadersSameDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReadersSameDegreeQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useListReadersSameDegreeQuery(baseOptions: Apollo.QueryHookOptions<ListReadersSameDegreeQuery, ListReadersSameDegreeQueryVariables> & ({ variables: ListReadersSameDegreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReadersSameDegreeQuery, ListReadersSameDegreeQueryVariables>(ListReadersSameDegreeDocument, options);
      }
export function useListReadersSameDegreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReadersSameDegreeQuery, ListReadersSameDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReadersSameDegreeQuery, ListReadersSameDegreeQueryVariables>(ListReadersSameDegreeDocument, options);
        }
export function useListReadersSameDegreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReadersSameDegreeQuery, ListReadersSameDegreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReadersSameDegreeQuery, ListReadersSameDegreeQueryVariables>(ListReadersSameDegreeDocument, options);
        }
export type ListReadersSameDegreeQueryHookResult = ReturnType<typeof useListReadersSameDegreeQuery>;
export type ListReadersSameDegreeLazyQueryHookResult = ReturnType<typeof useListReadersSameDegreeLazyQuery>;
export type ListReadersSameDegreeSuspenseQueryHookResult = ReturnType<typeof useListReadersSameDegreeSuspenseQuery>;
export type ListReadersSameDegreeQueryResult = Apollo.QueryResult<ListReadersSameDegreeQuery, ListReadersSameDegreeQueryVariables>;
export const ExistsAtLeastOnePlantedTreeDocument = gql`
    query existsAtLeastOnePlantedTree {
  me {
    id
    reader {
      id
      existsAtLeastOnePlantedTree
    }
  }
}
    `;

/**
 * __useExistsAtLeastOnePlantedTreeQuery__
 *
 * To run a query within a React component, call `useExistsAtLeastOnePlantedTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistsAtLeastOnePlantedTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistsAtLeastOnePlantedTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useExistsAtLeastOnePlantedTreeQuery(baseOptions?: Apollo.QueryHookOptions<ExistsAtLeastOnePlantedTreeQuery, ExistsAtLeastOnePlantedTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExistsAtLeastOnePlantedTreeQuery, ExistsAtLeastOnePlantedTreeQueryVariables>(ExistsAtLeastOnePlantedTreeDocument, options);
      }
export function useExistsAtLeastOnePlantedTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistsAtLeastOnePlantedTreeQuery, ExistsAtLeastOnePlantedTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExistsAtLeastOnePlantedTreeQuery, ExistsAtLeastOnePlantedTreeQueryVariables>(ExistsAtLeastOnePlantedTreeDocument, options);
        }
export function useExistsAtLeastOnePlantedTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExistsAtLeastOnePlantedTreeQuery, ExistsAtLeastOnePlantedTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExistsAtLeastOnePlantedTreeQuery, ExistsAtLeastOnePlantedTreeQueryVariables>(ExistsAtLeastOnePlantedTreeDocument, options);
        }
export type ExistsAtLeastOnePlantedTreeQueryHookResult = ReturnType<typeof useExistsAtLeastOnePlantedTreeQuery>;
export type ExistsAtLeastOnePlantedTreeLazyQueryHookResult = ReturnType<typeof useExistsAtLeastOnePlantedTreeLazyQuery>;
export type ExistsAtLeastOnePlantedTreeSuspenseQueryHookResult = ReturnType<typeof useExistsAtLeastOnePlantedTreeSuspenseQuery>;
export type ExistsAtLeastOnePlantedTreeQueryResult = Apollo.QueryResult<ExistsAtLeastOnePlantedTreeQuery, ExistsAtLeastOnePlantedTreeQueryVariables>;
export const SentirHomeContentsDocument = gql`
    query sentirHomeContents($limit: Int, $page: Int, $degree: String, $pillar: String!) {
  sentirHomeContents(degree: $degree, pillar: $pillar) {
    pillars {
      name
      iconUrl
    }
    courseBooks {
      name
      author
      slug
      degree
      imageUrlThumb
      language
      premiumLock
      hasAudioBook
    }
    bookShelves {
      id
      name
      subtitle
      active
      description
      bookShelfItems(limit: $limit, page: $page) {
        id
        bookShelfId
        book {
          name
          author
          slug
          degree
          imageUrlThumb
          language
          premiumLock
          hasAudioBook
        }
      }
    }
    secondaryEmotions {
      happy {
        name
        slug
      }
      neutral {
        name
        slug
      }
      sad {
        name
        slug
      }
    }
  }
}
    `;

/**
 * __useSentirHomeContentsQuery__
 *
 * To run a query within a React component, call `useSentirHomeContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentirHomeContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentirHomeContentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      degree: // value for 'degree'
 *      pillar: // value for 'pillar'
 *   },
 * });
 */
export function useSentirHomeContentsQuery(baseOptions: Apollo.QueryHookOptions<SentirHomeContentsQuery, SentirHomeContentsQueryVariables> & ({ variables: SentirHomeContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentirHomeContentsQuery, SentirHomeContentsQueryVariables>(SentirHomeContentsDocument, options);
      }
export function useSentirHomeContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentirHomeContentsQuery, SentirHomeContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentirHomeContentsQuery, SentirHomeContentsQueryVariables>(SentirHomeContentsDocument, options);
        }
export function useSentirHomeContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentirHomeContentsQuery, SentirHomeContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentirHomeContentsQuery, SentirHomeContentsQueryVariables>(SentirHomeContentsDocument, options);
        }
export type SentirHomeContentsQueryHookResult = ReturnType<typeof useSentirHomeContentsQuery>;
export type SentirHomeContentsLazyQueryHookResult = ReturnType<typeof useSentirHomeContentsLazyQuery>;
export type SentirHomeContentsSuspenseQueryHookResult = ReturnType<typeof useSentirHomeContentsSuspenseQuery>;
export type SentirHomeContentsQueryResult = Apollo.QueryResult<SentirHomeContentsQuery, SentirHomeContentsQueryVariables>;
export const SentirHomeContentsOnboardingDocument = gql`
    query sentirHomeContentsOnboarding($degree: String, $pillar: String!) {
  sentirHomeContents(degree: $degree, pillar: $pillar) {
    pillars {
      name
      iconUrl
    }
  }
}
    `;

/**
 * __useSentirHomeContentsOnboardingQuery__
 *
 * To run a query within a React component, call `useSentirHomeContentsOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentirHomeContentsOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentirHomeContentsOnboardingQuery({
 *   variables: {
 *      degree: // value for 'degree'
 *      pillar: // value for 'pillar'
 *   },
 * });
 */
export function useSentirHomeContentsOnboardingQuery(baseOptions: Apollo.QueryHookOptions<SentirHomeContentsOnboardingQuery, SentirHomeContentsOnboardingQueryVariables> & ({ variables: SentirHomeContentsOnboardingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentirHomeContentsOnboardingQuery, SentirHomeContentsOnboardingQueryVariables>(SentirHomeContentsOnboardingDocument, options);
      }
export function useSentirHomeContentsOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentirHomeContentsOnboardingQuery, SentirHomeContentsOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentirHomeContentsOnboardingQuery, SentirHomeContentsOnboardingQueryVariables>(SentirHomeContentsOnboardingDocument, options);
        }
export function useSentirHomeContentsOnboardingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentirHomeContentsOnboardingQuery, SentirHomeContentsOnboardingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentirHomeContentsOnboardingQuery, SentirHomeContentsOnboardingQueryVariables>(SentirHomeContentsOnboardingDocument, options);
        }
export type SentirHomeContentsOnboardingQueryHookResult = ReturnType<typeof useSentirHomeContentsOnboardingQuery>;
export type SentirHomeContentsOnboardingLazyQueryHookResult = ReturnType<typeof useSentirHomeContentsOnboardingLazyQuery>;
export type SentirHomeContentsOnboardingSuspenseQueryHookResult = ReturnType<typeof useSentirHomeContentsOnboardingSuspenseQuery>;
export type SentirHomeContentsOnboardingQueryResult = Apollo.QueryResult<SentirHomeContentsOnboardingQuery, SentirHomeContentsOnboardingQueryVariables>;
export const RecommendedBooksDocument = gql`
    query recommendedBooks {
  recommendedBooks {
    slug
    imageUrlThumbLow
    imageUrlThumb
  }
}
    `;

/**
 * __useRecommendedBooksQuery__
 *
 * To run a query within a React component, call `useRecommendedBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedBooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedBooksQuery(baseOptions?: Apollo.QueryHookOptions<RecommendedBooksQuery, RecommendedBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedBooksQuery, RecommendedBooksQueryVariables>(RecommendedBooksDocument, options);
      }
export function useRecommendedBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedBooksQuery, RecommendedBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedBooksQuery, RecommendedBooksQueryVariables>(RecommendedBooksDocument, options);
        }
export function useRecommendedBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedBooksQuery, RecommendedBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedBooksQuery, RecommendedBooksQueryVariables>(RecommendedBooksDocument, options);
        }
export type RecommendedBooksQueryHookResult = ReturnType<typeof useRecommendedBooksQuery>;
export type RecommendedBooksLazyQueryHookResult = ReturnType<typeof useRecommendedBooksLazyQuery>;
export type RecommendedBooksSuspenseQueryHookResult = ReturnType<typeof useRecommendedBooksSuspenseQuery>;
export type RecommendedBooksQueryResult = Apollo.QueryResult<RecommendedBooksQuery, RecommendedBooksQueryVariables>;
export const DataHomeForestDocument = gql`
    query DataHomeForest($count: Int) {
  me {
    id
    reader {
      id
      forest {
        id
        coins
        treeListings(count: $count) {
          id
          image
        }
        waterDropDetails {
          currentDrops
          maxDrops
        }
      }
    }
  }
}
    `;

/**
 * __useDataHomeForestQuery__
 *
 * To run a query within a React component, call `useDataHomeForestQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataHomeForestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataHomeForestQuery({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function useDataHomeForestQuery(baseOptions?: Apollo.QueryHookOptions<DataHomeForestQuery, DataHomeForestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataHomeForestQuery, DataHomeForestQueryVariables>(DataHomeForestDocument, options);
      }
export function useDataHomeForestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataHomeForestQuery, DataHomeForestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataHomeForestQuery, DataHomeForestQueryVariables>(DataHomeForestDocument, options);
        }
export function useDataHomeForestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataHomeForestQuery, DataHomeForestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataHomeForestQuery, DataHomeForestQueryVariables>(DataHomeForestDocument, options);
        }
export type DataHomeForestQueryHookResult = ReturnType<typeof useDataHomeForestQuery>;
export type DataHomeForestLazyQueryHookResult = ReturnType<typeof useDataHomeForestLazyQuery>;
export type DataHomeForestSuspenseQueryHookResult = ReturnType<typeof useDataHomeForestSuspenseQuery>;
export type DataHomeForestQueryResult = Apollo.QueryResult<DataHomeForestQuery, DataHomeForestQueryVariables>;
export const GetUserCoinsDocument = gql`
    query getUserCoins {
  me {
    id
    reader {
      id
      forest {
        id
        coins
      }
    }
  }
}
    `;

/**
 * __useGetUserCoinsQuery__
 *
 * To run a query within a React component, call `useGetUserCoinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCoinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCoinsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCoinsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCoinsQuery, GetUserCoinsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCoinsQuery, GetUserCoinsQueryVariables>(GetUserCoinsDocument, options);
      }
export function useGetUserCoinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCoinsQuery, GetUserCoinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCoinsQuery, GetUserCoinsQueryVariables>(GetUserCoinsDocument, options);
        }
export function useGetUserCoinsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCoinsQuery, GetUserCoinsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCoinsQuery, GetUserCoinsQueryVariables>(GetUserCoinsDocument, options);
        }
export type GetUserCoinsQueryHookResult = ReturnType<typeof useGetUserCoinsQuery>;
export type GetUserCoinsLazyQueryHookResult = ReturnType<typeof useGetUserCoinsLazyQuery>;
export type GetUserCoinsSuspenseQueryHookResult = ReturnType<typeof useGetUserCoinsSuspenseQuery>;
export type GetUserCoinsQueryResult = Apollo.QueryResult<GetUserCoinsQuery, GetUserCoinsQueryVariables>;
export const GetRecommendedBookShelfDocument = gql`
    query getRecommendedBookShelf {
  me {
    id
    reader {
      id
      bookSuggestions {
        name
        author
        slug
        degree
        imageUrlThumb
        language
        premiumLock
        hasAudioBook
      }
    }
  }
}
    `;

/**
 * __useGetRecommendedBookShelfQuery__
 *
 * To run a query within a React component, call `useGetRecommendedBookShelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedBookShelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedBookShelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecommendedBookShelfQuery(baseOptions?: Apollo.QueryHookOptions<GetRecommendedBookShelfQuery, GetRecommendedBookShelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedBookShelfQuery, GetRecommendedBookShelfQueryVariables>(GetRecommendedBookShelfDocument, options);
      }
export function useGetRecommendedBookShelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedBookShelfQuery, GetRecommendedBookShelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedBookShelfQuery, GetRecommendedBookShelfQueryVariables>(GetRecommendedBookShelfDocument, options);
        }
export function useGetRecommendedBookShelfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendedBookShelfQuery, GetRecommendedBookShelfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendedBookShelfQuery, GetRecommendedBookShelfQueryVariables>(GetRecommendedBookShelfDocument, options);
        }
export type GetRecommendedBookShelfQueryHookResult = ReturnType<typeof useGetRecommendedBookShelfQuery>;
export type GetRecommendedBookShelfLazyQueryHookResult = ReturnType<typeof useGetRecommendedBookShelfLazyQuery>;
export type GetRecommendedBookShelfSuspenseQueryHookResult = ReturnType<typeof useGetRecommendedBookShelfSuspenseQuery>;
export type GetRecommendedBookShelfQueryResult = Apollo.QueryResult<GetRecommendedBookShelfQuery, GetRecommendedBookShelfQueryVariables>;
export const RunningRecordsBookshelvesQueryDocument = gql`
    query runningRecordsBookshelvesQuery($page: Int, $per_page: Int) {
  me {
    id
    reader {
      id
      runningRecordsAssessmentBooksSuggested(input: {page: $page, perPage: $per_page}) {
        name
        author
        slug
        degree
        imageUrlThumb
        language
        premiumLock
        hasAudioBook
      }
    }
  }
}
    `;

/**
 * __useRunningRecordsBookshelvesQueryQuery__
 *
 * To run a query within a React component, call `useRunningRecordsBookshelvesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunningRecordsBookshelvesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunningRecordsBookshelvesQueryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      per_page: // value for 'per_page'
 *   },
 * });
 */
export function useRunningRecordsBookshelvesQueryQuery(baseOptions?: Apollo.QueryHookOptions<RunningRecordsBookshelvesQueryQuery, RunningRecordsBookshelvesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RunningRecordsBookshelvesQueryQuery, RunningRecordsBookshelvesQueryQueryVariables>(RunningRecordsBookshelvesQueryDocument, options);
      }
export function useRunningRecordsBookshelvesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RunningRecordsBookshelvesQueryQuery, RunningRecordsBookshelvesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RunningRecordsBookshelvesQueryQuery, RunningRecordsBookshelvesQueryQueryVariables>(RunningRecordsBookshelvesQueryDocument, options);
        }
export function useRunningRecordsBookshelvesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RunningRecordsBookshelvesQueryQuery, RunningRecordsBookshelvesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RunningRecordsBookshelvesQueryQuery, RunningRecordsBookshelvesQueryQueryVariables>(RunningRecordsBookshelvesQueryDocument, options);
        }
export type RunningRecordsBookshelvesQueryQueryHookResult = ReturnType<typeof useRunningRecordsBookshelvesQueryQuery>;
export type RunningRecordsBookshelvesQueryLazyQueryHookResult = ReturnType<typeof useRunningRecordsBookshelvesQueryLazyQuery>;
export type RunningRecordsBookshelvesQuerySuspenseQueryHookResult = ReturnType<typeof useRunningRecordsBookshelvesQuerySuspenseQuery>;
export type RunningRecordsBookshelvesQueryQueryResult = Apollo.QueryResult<RunningRecordsBookshelvesQueryQuery, RunningRecordsBookshelvesQueryQueryVariables>;
export const EmotionJournalEntriesByMonthDocument = gql`
    query emotionJournalEntriesByMonth($month: Int!, $year: Int!, $readerId: Int) {
  emotionJournalEntriesByMonth(month: $month, year: $year, readerId: $readerId) {
    date
    entries {
      id
      primaryEmotion
      secondaryEmotions {
        slug
      }
      note
      blockNote
      insertedAt
      emotionColor
    }
  }
}
    `;

/**
 * __useEmotionJournalEntriesByMonthQuery__
 *
 * To run a query within a React component, call `useEmotionJournalEntriesByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmotionJournalEntriesByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmotionJournalEntriesByMonthQuery({
 *   variables: {
 *      month: // value for 'month'
 *      year: // value for 'year'
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useEmotionJournalEntriesByMonthQuery(baseOptions: Apollo.QueryHookOptions<EmotionJournalEntriesByMonthQuery, EmotionJournalEntriesByMonthQueryVariables> & ({ variables: EmotionJournalEntriesByMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmotionJournalEntriesByMonthQuery, EmotionJournalEntriesByMonthQueryVariables>(EmotionJournalEntriesByMonthDocument, options);
      }
export function useEmotionJournalEntriesByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmotionJournalEntriesByMonthQuery, EmotionJournalEntriesByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmotionJournalEntriesByMonthQuery, EmotionJournalEntriesByMonthQueryVariables>(EmotionJournalEntriesByMonthDocument, options);
        }
export function useEmotionJournalEntriesByMonthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmotionJournalEntriesByMonthQuery, EmotionJournalEntriesByMonthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmotionJournalEntriesByMonthQuery, EmotionJournalEntriesByMonthQueryVariables>(EmotionJournalEntriesByMonthDocument, options);
        }
export type EmotionJournalEntriesByMonthQueryHookResult = ReturnType<typeof useEmotionJournalEntriesByMonthQuery>;
export type EmotionJournalEntriesByMonthLazyQueryHookResult = ReturnType<typeof useEmotionJournalEntriesByMonthLazyQuery>;
export type EmotionJournalEntriesByMonthSuspenseQueryHookResult = ReturnType<typeof useEmotionJournalEntriesByMonthSuspenseQuery>;
export type EmotionJournalEntriesByMonthQueryResult = Apollo.QueryResult<EmotionJournalEntriesByMonthQuery, EmotionJournalEntriesByMonthQueryVariables>;
export const SentirSubpagesQueryDocument = gql`
    query SentirSubpagesQuery($pillar: String!) {
  sentirHomeContents(pillar: $pillar) {
    subpages
  }
}
    `;

/**
 * __useSentirSubpagesQueryQuery__
 *
 * To run a query within a React component, call `useSentirSubpagesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentirSubpagesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentirSubpagesQueryQuery({
 *   variables: {
 *      pillar: // value for 'pillar'
 *   },
 * });
 */
export function useSentirSubpagesQueryQuery(baseOptions: Apollo.QueryHookOptions<SentirSubpagesQueryQuery, SentirSubpagesQueryQueryVariables> & ({ variables: SentirSubpagesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentirSubpagesQueryQuery, SentirSubpagesQueryQueryVariables>(SentirSubpagesQueryDocument, options);
      }
export function useSentirSubpagesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentirSubpagesQueryQuery, SentirSubpagesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentirSubpagesQueryQuery, SentirSubpagesQueryQueryVariables>(SentirSubpagesQueryDocument, options);
        }
export function useSentirSubpagesQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentirSubpagesQueryQuery, SentirSubpagesQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentirSubpagesQueryQuery, SentirSubpagesQueryQueryVariables>(SentirSubpagesQueryDocument, options);
        }
export type SentirSubpagesQueryQueryHookResult = ReturnType<typeof useSentirSubpagesQueryQuery>;
export type SentirSubpagesQueryLazyQueryHookResult = ReturnType<typeof useSentirSubpagesQueryLazyQuery>;
export type SentirSubpagesQuerySuspenseQueryHookResult = ReturnType<typeof useSentirSubpagesQuerySuspenseQuery>;
export type SentirSubpagesQueryQueryResult = Apollo.QueryResult<SentirSubpagesQueryQuery, SentirSubpagesQueryQueryVariables>;
export const TeacherClassesDocument = gql`
    query teacherClasses($degree: String!) {
  me {
    id
    teacher {
      id
      teacherClasses(degree: $degree) {
        id
        name
        degree
      }
    }
  }
}
    `;

/**
 * __useTeacherClassesQuery__
 *
 * To run a query within a React component, call `useTeacherClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherClassesQuery({
 *   variables: {
 *      degree: // value for 'degree'
 *   },
 * });
 */
export function useTeacherClassesQuery(baseOptions: Apollo.QueryHookOptions<TeacherClassesQuery, TeacherClassesQueryVariables> & ({ variables: TeacherClassesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherClassesQuery, TeacherClassesQueryVariables>(TeacherClassesDocument, options);
      }
export function useTeacherClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherClassesQuery, TeacherClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherClassesQuery, TeacherClassesQueryVariables>(TeacherClassesDocument, options);
        }
export function useTeacherClassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherClassesQuery, TeacherClassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherClassesQuery, TeacherClassesQueryVariables>(TeacherClassesDocument, options);
        }
export type TeacherClassesQueryHookResult = ReturnType<typeof useTeacherClassesQuery>;
export type TeacherClassesLazyQueryHookResult = ReturnType<typeof useTeacherClassesLazyQuery>;
export type TeacherClassesSuspenseQueryHookResult = ReturnType<typeof useTeacherClassesSuspenseQuery>;
export type TeacherClassesQueryResult = Apollo.QueryResult<TeacherClassesQuery, TeacherClassesQueryVariables>;
export const ClassLastJournalEntriesDocument = gql`
    query classLastJournalEntries($class_id: Int!) {
  classLastJournalEntries(classId: $class_id) {
    reader {
      id
      name
      lastEntries
      showAlert
    }
  }
}
    `;

/**
 * __useClassLastJournalEntriesQuery__
 *
 * To run a query within a React component, call `useClassLastJournalEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassLastJournalEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassLastJournalEntriesQuery({
 *   variables: {
 *      class_id: // value for 'class_id'
 *   },
 * });
 */
export function useClassLastJournalEntriesQuery(baseOptions: Apollo.QueryHookOptions<ClassLastJournalEntriesQuery, ClassLastJournalEntriesQueryVariables> & ({ variables: ClassLastJournalEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassLastJournalEntriesQuery, ClassLastJournalEntriesQueryVariables>(ClassLastJournalEntriesDocument, options);
      }
export function useClassLastJournalEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassLastJournalEntriesQuery, ClassLastJournalEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassLastJournalEntriesQuery, ClassLastJournalEntriesQueryVariables>(ClassLastJournalEntriesDocument, options);
        }
export function useClassLastJournalEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassLastJournalEntriesQuery, ClassLastJournalEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassLastJournalEntriesQuery, ClassLastJournalEntriesQueryVariables>(ClassLastJournalEntriesDocument, options);
        }
export type ClassLastJournalEntriesQueryHookResult = ReturnType<typeof useClassLastJournalEntriesQuery>;
export type ClassLastJournalEntriesLazyQueryHookResult = ReturnType<typeof useClassLastJournalEntriesLazyQuery>;
export type ClassLastJournalEntriesSuspenseQueryHookResult = ReturnType<typeof useClassLastJournalEntriesSuspenseQuery>;
export type ClassLastJournalEntriesQueryResult = Apollo.QueryResult<ClassLastJournalEntriesQuery, ClassLastJournalEntriesQueryVariables>;
export const ConsumedContentContentReportDocument = gql`
    query ConsumedContentContentReport($contentType: ContentType!, $entityId: Int!) {
  consumedContentsContentReport(contentType: $contentType, entityId: $entityId) {
    content {
      identifier
      type
      contentDetails {
        ... on Book {
          name
          author
          slug
        }
        ... on Article {
          id
          title
          author
        }
      }
    }
    openedCount
    fullyConsumedCount
  }
}
    `;

/**
 * __useConsumedContentContentReportQuery__
 *
 * To run a query within a React component, call `useConsumedContentContentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumedContentContentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumedContentContentReportQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useConsumedContentContentReportQuery(baseOptions: Apollo.QueryHookOptions<ConsumedContentContentReportQuery, ConsumedContentContentReportQueryVariables> & ({ variables: ConsumedContentContentReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumedContentContentReportQuery, ConsumedContentContentReportQueryVariables>(ConsumedContentContentReportDocument, options);
      }
export function useConsumedContentContentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumedContentContentReportQuery, ConsumedContentContentReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumedContentContentReportQuery, ConsumedContentContentReportQueryVariables>(ConsumedContentContentReportDocument, options);
        }
export function useConsumedContentContentReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsumedContentContentReportQuery, ConsumedContentContentReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsumedContentContentReportQuery, ConsumedContentContentReportQueryVariables>(ConsumedContentContentReportDocument, options);
        }
export type ConsumedContentContentReportQueryHookResult = ReturnType<typeof useConsumedContentContentReportQuery>;
export type ConsumedContentContentReportLazyQueryHookResult = ReturnType<typeof useConsumedContentContentReportLazyQuery>;
export type ConsumedContentContentReportSuspenseQueryHookResult = ReturnType<typeof useConsumedContentContentReportSuspenseQuery>;
export type ConsumedContentContentReportQueryResult = Apollo.QueryResult<ConsumedContentContentReportQuery, ConsumedContentContentReportQueryVariables>;
export const MostReadContentByTypeDocument = gql`
    query mostReadContentByType($contentType: ContentType!) {
  mostReadContentByType(contentType: $contentType) {
    content {
      contentDetails {
        ... on Book {
          name
          author
          slug
        }
        ... on Article {
          id
          author
          degree
          description
          subtitle
          image
          title
          publishDate
          categories {
            name
            slug
            iconIdentifier
          }
        }
      }
    }
    fullyConsumedCount
  }
}
    `;

/**
 * __useMostReadContentByTypeQuery__
 *
 * To run a query within a React component, call `useMostReadContentByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostReadContentByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostReadContentByTypeQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useMostReadContentByTypeQuery(baseOptions: Apollo.QueryHookOptions<MostReadContentByTypeQuery, MostReadContentByTypeQueryVariables> & ({ variables: MostReadContentByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MostReadContentByTypeQuery, MostReadContentByTypeQueryVariables>(MostReadContentByTypeDocument, options);
      }
export function useMostReadContentByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MostReadContentByTypeQuery, MostReadContentByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MostReadContentByTypeQuery, MostReadContentByTypeQueryVariables>(MostReadContentByTypeDocument, options);
        }
export function useMostReadContentByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MostReadContentByTypeQuery, MostReadContentByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MostReadContentByTypeQuery, MostReadContentByTypeQueryVariables>(MostReadContentByTypeDocument, options);
        }
export type MostReadContentByTypeQueryHookResult = ReturnType<typeof useMostReadContentByTypeQuery>;
export type MostReadContentByTypeLazyQueryHookResult = ReturnType<typeof useMostReadContentByTypeLazyQuery>;
export type MostReadContentByTypeSuspenseQueryHookResult = ReturnType<typeof useMostReadContentByTypeSuspenseQuery>;
export type MostReadContentByTypeQueryResult = Apollo.QueryResult<MostReadContentByTypeQuery, MostReadContentByTypeQueryVariables>;
export const ContentConsumptionDetailsByEntityAndContentReportDocument = gql`
    query contentConsumptionDetailsByEntityAndContentReport($entityId: Int!, $contentIdentifier: String!, $contentType: ContentType!) {
  consumedContentsByEntityAndContentReport(
    input: {entityId: $entityId, contentIdentifier: $contentIdentifier, contentType: $contentType}
  ) {
    id
    user {
      id
      name
    }
    content {
      contentDetails {
        ... on Article {
          id
          title
          author
        }
      }
    }
    status
    firstConsumedAt
  }
}
    `;

/**
 * __useContentConsumptionDetailsByEntityAndContentReportQuery__
 *
 * To run a query within a React component, call `useContentConsumptionDetailsByEntityAndContentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentConsumptionDetailsByEntityAndContentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentConsumptionDetailsByEntityAndContentReportQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      contentIdentifier: // value for 'contentIdentifier'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useContentConsumptionDetailsByEntityAndContentReportQuery(baseOptions: Apollo.QueryHookOptions<ContentConsumptionDetailsByEntityAndContentReportQuery, ContentConsumptionDetailsByEntityAndContentReportQueryVariables> & ({ variables: ContentConsumptionDetailsByEntityAndContentReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentConsumptionDetailsByEntityAndContentReportQuery, ContentConsumptionDetailsByEntityAndContentReportQueryVariables>(ContentConsumptionDetailsByEntityAndContentReportDocument, options);
      }
export function useContentConsumptionDetailsByEntityAndContentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentConsumptionDetailsByEntityAndContentReportQuery, ContentConsumptionDetailsByEntityAndContentReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentConsumptionDetailsByEntityAndContentReportQuery, ContentConsumptionDetailsByEntityAndContentReportQueryVariables>(ContentConsumptionDetailsByEntityAndContentReportDocument, options);
        }
export function useContentConsumptionDetailsByEntityAndContentReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentConsumptionDetailsByEntityAndContentReportQuery, ContentConsumptionDetailsByEntityAndContentReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentConsumptionDetailsByEntityAndContentReportQuery, ContentConsumptionDetailsByEntityAndContentReportQueryVariables>(ContentConsumptionDetailsByEntityAndContentReportDocument, options);
        }
export type ContentConsumptionDetailsByEntityAndContentReportQueryHookResult = ReturnType<typeof useContentConsumptionDetailsByEntityAndContentReportQuery>;
export type ContentConsumptionDetailsByEntityAndContentReportLazyQueryHookResult = ReturnType<typeof useContentConsumptionDetailsByEntityAndContentReportLazyQuery>;
export type ContentConsumptionDetailsByEntityAndContentReportSuspenseQueryHookResult = ReturnType<typeof useContentConsumptionDetailsByEntityAndContentReportSuspenseQuery>;
export type ContentConsumptionDetailsByEntityAndContentReportQueryResult = Apollo.QueryResult<ContentConsumptionDetailsByEntityAndContentReportQuery, ContentConsumptionDetailsByEntityAndContentReportQueryVariables>;
export const ContentConsumptionByUserReportDocument = gql`
    query contentConsumptionByUserReport($readerId: Int!) {
  consumedContentsByUserReport(readerId: $readerId) {
    status
    firstConsumedAt
    content {
      identifier
      type
      contentDetails {
        ... on Article {
          title
          author
        }
        ... on Book {
          name
          author
        }
      }
    }
    user {
      name
    }
  }
}
    `;

/**
 * __useContentConsumptionByUserReportQuery__
 *
 * To run a query within a React component, call `useContentConsumptionByUserReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentConsumptionByUserReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentConsumptionByUserReportQuery({
 *   variables: {
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useContentConsumptionByUserReportQuery(baseOptions: Apollo.QueryHookOptions<ContentConsumptionByUserReportQuery, ContentConsumptionByUserReportQueryVariables> & ({ variables: ContentConsumptionByUserReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentConsumptionByUserReportQuery, ContentConsumptionByUserReportQueryVariables>(ContentConsumptionByUserReportDocument, options);
      }
export function useContentConsumptionByUserReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentConsumptionByUserReportQuery, ContentConsumptionByUserReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentConsumptionByUserReportQuery, ContentConsumptionByUserReportQueryVariables>(ContentConsumptionByUserReportDocument, options);
        }
export function useContentConsumptionByUserReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentConsumptionByUserReportQuery, ContentConsumptionByUserReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentConsumptionByUserReportQuery, ContentConsumptionByUserReportQueryVariables>(ContentConsumptionByUserReportDocument, options);
        }
export type ContentConsumptionByUserReportQueryHookResult = ReturnType<typeof useContentConsumptionByUserReportQuery>;
export type ContentConsumptionByUserReportLazyQueryHookResult = ReturnType<typeof useContentConsumptionByUserReportLazyQuery>;
export type ContentConsumptionByUserReportSuspenseQueryHookResult = ReturnType<typeof useContentConsumptionByUserReportSuspenseQuery>;
export type ContentConsumptionByUserReportQueryResult = Apollo.QueryResult<ContentConsumptionByUserReportQuery, ContentConsumptionByUserReportQueryVariables>;
export const ArticleSchoolSegmentsDocument = gql`
    query articleSchoolSegments {
  articleSchoolSegments {
    value
    label
    abbreviation
    recommendedDegrees
  }
}
    `;

/**
 * __useArticleSchoolSegmentsQuery__
 *
 * To run a query within a React component, call `useArticleSchoolSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleSchoolSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleSchoolSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useArticleSchoolSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<ArticleSchoolSegmentsQuery, ArticleSchoolSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleSchoolSegmentsQuery, ArticleSchoolSegmentsQueryVariables>(ArticleSchoolSegmentsDocument, options);
      }
export function useArticleSchoolSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleSchoolSegmentsQuery, ArticleSchoolSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleSchoolSegmentsQuery, ArticleSchoolSegmentsQueryVariables>(ArticleSchoolSegmentsDocument, options);
        }
export function useArticleSchoolSegmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleSchoolSegmentsQuery, ArticleSchoolSegmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleSchoolSegmentsQuery, ArticleSchoolSegmentsQueryVariables>(ArticleSchoolSegmentsDocument, options);
        }
export type ArticleSchoolSegmentsQueryHookResult = ReturnType<typeof useArticleSchoolSegmentsQuery>;
export type ArticleSchoolSegmentsLazyQueryHookResult = ReturnType<typeof useArticleSchoolSegmentsLazyQuery>;
export type ArticleSchoolSegmentsSuspenseQueryHookResult = ReturnType<typeof useArticleSchoolSegmentsSuspenseQuery>;
export type ArticleSchoolSegmentsQueryResult = Apollo.QueryResult<ArticleSchoolSegmentsQuery, ArticleSchoolSegmentsQueryVariables>;
export const ContentCategoryShelvesDocument = gql`
    query contentCategoryShelves($type: ContentType!) {
  contentCategoryShelves(type: $type) {
    contents {
      contentDetails {
        ... on Article {
          id
          title
          image
          description
          subtitle
          degree
          publishDate
          categories {
            name
            slug
            iconIdentifier
          }
        }
      }
      identifier
      type
    }
    iconIdentifier
    name
    slug
  }
}
    `;

/**
 * __useContentCategoryShelvesQuery__
 *
 * To run a query within a React component, call `useContentCategoryShelvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentCategoryShelvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentCategoryShelvesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useContentCategoryShelvesQuery(baseOptions: Apollo.QueryHookOptions<ContentCategoryShelvesQuery, ContentCategoryShelvesQueryVariables> & ({ variables: ContentCategoryShelvesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentCategoryShelvesQuery, ContentCategoryShelvesQueryVariables>(ContentCategoryShelvesDocument, options);
      }
export function useContentCategoryShelvesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentCategoryShelvesQuery, ContentCategoryShelvesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentCategoryShelvesQuery, ContentCategoryShelvesQueryVariables>(ContentCategoryShelvesDocument, options);
        }
export function useContentCategoryShelvesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentCategoryShelvesQuery, ContentCategoryShelvesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentCategoryShelvesQuery, ContentCategoryShelvesQueryVariables>(ContentCategoryShelvesDocument, options);
        }
export type ContentCategoryShelvesQueryHookResult = ReturnType<typeof useContentCategoryShelvesQuery>;
export type ContentCategoryShelvesLazyQueryHookResult = ReturnType<typeof useContentCategoryShelvesLazyQuery>;
export type ContentCategoryShelvesSuspenseQueryHookResult = ReturnType<typeof useContentCategoryShelvesSuspenseQuery>;
export type ContentCategoryShelvesQueryResult = Apollo.QueryResult<ContentCategoryShelvesQuery, ContentCategoryShelvesQueryVariables>;
export const ShouldShowCsatFormDocument = gql`
    query shouldShowCsatForm {
  me {
    id
    reader {
      id
      showCsatForm(context: GAMING)
    }
  }
}
    `;

/**
 * __useShouldShowCsatFormQuery__
 *
 * To run a query within a React component, call `useShouldShowCsatFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useShouldShowCsatFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShouldShowCsatFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useShouldShowCsatFormQuery(baseOptions?: Apollo.QueryHookOptions<ShouldShowCsatFormQuery, ShouldShowCsatFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShouldShowCsatFormQuery, ShouldShowCsatFormQueryVariables>(ShouldShowCsatFormDocument, options);
      }
export function useShouldShowCsatFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShouldShowCsatFormQuery, ShouldShowCsatFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShouldShowCsatFormQuery, ShouldShowCsatFormQueryVariables>(ShouldShowCsatFormDocument, options);
        }
export function useShouldShowCsatFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShouldShowCsatFormQuery, ShouldShowCsatFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShouldShowCsatFormQuery, ShouldShowCsatFormQueryVariables>(ShouldShowCsatFormDocument, options);
        }
export type ShouldShowCsatFormQueryHookResult = ReturnType<typeof useShouldShowCsatFormQuery>;
export type ShouldShowCsatFormLazyQueryHookResult = ReturnType<typeof useShouldShowCsatFormLazyQuery>;
export type ShouldShowCsatFormSuspenseQueryHookResult = ReturnType<typeof useShouldShowCsatFormSuspenseQuery>;
export type ShouldShowCsatFormQueryResult = Apollo.QueryResult<ShouldShowCsatFormQuery, ShouldShowCsatFormQueryVariables>;
export const ListLevelingsDocument = gql`
    query ListLevelings {
  listLevelings {
    id
    name
  }
}
    `;

/**
 * __useListLevelingsQuery__
 *
 * To run a query within a React component, call `useListLevelingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLevelingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLevelingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListLevelingsQuery(baseOptions?: Apollo.QueryHookOptions<ListLevelingsQuery, ListLevelingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLevelingsQuery, ListLevelingsQueryVariables>(ListLevelingsDocument, options);
      }
export function useListLevelingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLevelingsQuery, ListLevelingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLevelingsQuery, ListLevelingsQueryVariables>(ListLevelingsDocument, options);
        }
export function useListLevelingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLevelingsQuery, ListLevelingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLevelingsQuery, ListLevelingsQueryVariables>(ListLevelingsDocument, options);
        }
export type ListLevelingsQueryHookResult = ReturnType<typeof useListLevelingsQuery>;
export type ListLevelingsLazyQueryHookResult = ReturnType<typeof useListLevelingsLazyQuery>;
export type ListLevelingsSuspenseQueryHookResult = ReturnType<typeof useListLevelingsSuspenseQuery>;
export type ListLevelingsQueryResult = Apollo.QueryResult<ListLevelingsQuery, ListLevelingsQueryVariables>;
export const ListBenchmarksDocument = gql`
    query listBenchmarks($partnerLevelingId: Int!) {
  listBenchmarks(input: {partnerLevelingId: $partnerLevelingId}) {
    id
    filePath
    wordCount
    book {
      name
      description
      slug
      downloadUrl
      author
    }
  }
}
    `;

/**
 * __useListBenchmarksQuery__
 *
 * To run a query within a React component, call `useListBenchmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBenchmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBenchmarksQuery({
 *   variables: {
 *      partnerLevelingId: // value for 'partnerLevelingId'
 *   },
 * });
 */
export function useListBenchmarksQuery(baseOptions: Apollo.QueryHookOptions<ListBenchmarksQuery, ListBenchmarksQueryVariables> & ({ variables: ListBenchmarksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBenchmarksQuery, ListBenchmarksQueryVariables>(ListBenchmarksDocument, options);
      }
export function useListBenchmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBenchmarksQuery, ListBenchmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBenchmarksQuery, ListBenchmarksQueryVariables>(ListBenchmarksDocument, options);
        }
export function useListBenchmarksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBenchmarksQuery, ListBenchmarksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBenchmarksQuery, ListBenchmarksQueryVariables>(ListBenchmarksDocument, options);
        }
export type ListBenchmarksQueryHookResult = ReturnType<typeof useListBenchmarksQuery>;
export type ListBenchmarksLazyQueryHookResult = ReturnType<typeof useListBenchmarksLazyQuery>;
export type ListBenchmarksSuspenseQueryHookResult = ReturnType<typeof useListBenchmarksSuspenseQuery>;
export type ListBenchmarksQueryResult = Apollo.QueryResult<ListBenchmarksQuery, ListBenchmarksQueryVariables>;
export const GetTeacherClassesDocument = gql`
    query GetTeacherClasses {
  getTeacherClasses {
    id
    name
    degree
  }
}
    `;

/**
 * __useGetTeacherClassesQuery__
 *
 * To run a query within a React component, call `useGetTeacherClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeacherClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetTeacherClassesQuery, GetTeacherClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherClassesQuery, GetTeacherClassesQueryVariables>(GetTeacherClassesDocument, options);
      }
export function useGetTeacherClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherClassesQuery, GetTeacherClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherClassesQuery, GetTeacherClassesQueryVariables>(GetTeacherClassesDocument, options);
        }
export function useGetTeacherClassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeacherClassesQuery, GetTeacherClassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeacherClassesQuery, GetTeacherClassesQueryVariables>(GetTeacherClassesDocument, options);
        }
export type GetTeacherClassesQueryHookResult = ReturnType<typeof useGetTeacherClassesQuery>;
export type GetTeacherClassesLazyQueryHookResult = ReturnType<typeof useGetTeacherClassesLazyQuery>;
export type GetTeacherClassesSuspenseQueryHookResult = ReturnType<typeof useGetTeacherClassesSuspenseQuery>;
export type GetTeacherClassesQueryResult = Apollo.QueryResult<GetTeacherClassesQuery, GetTeacherClassesQueryVariables>;
export const GetBlockedBooksDocument = gql`
    query GetBlockedBooks {
  me {
    id
    teacher {
      id
      blockedBooks
    }
  }
}
    `;

/**
 * __useGetBlockedBooksQuery__
 *
 * To run a query within a React component, call `useGetBlockedBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedBooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlockedBooksQuery(baseOptions?: Apollo.QueryHookOptions<GetBlockedBooksQuery, GetBlockedBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlockedBooksQuery, GetBlockedBooksQueryVariables>(GetBlockedBooksDocument, options);
      }
export function useGetBlockedBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlockedBooksQuery, GetBlockedBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlockedBooksQuery, GetBlockedBooksQueryVariables>(GetBlockedBooksDocument, options);
        }
export function useGetBlockedBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlockedBooksQuery, GetBlockedBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlockedBooksQuery, GetBlockedBooksQueryVariables>(GetBlockedBooksDocument, options);
        }
export type GetBlockedBooksQueryHookResult = ReturnType<typeof useGetBlockedBooksQuery>;
export type GetBlockedBooksLazyQueryHookResult = ReturnType<typeof useGetBlockedBooksLazyQuery>;
export type GetBlockedBooksSuspenseQueryHookResult = ReturnType<typeof useGetBlockedBooksSuspenseQuery>;
export type GetBlockedBooksQueryResult = Apollo.QueryResult<GetBlockedBooksQuery, GetBlockedBooksQueryVariables>;
export const GetAvailableBooksDocument = gql`
    query GetAvailableBooks($page: Int, $perPage: Int, $readerId: Int) {
  me {
    id
    teacher {
      id
      availableBooks(page: $page, perPage: $perPage, readerId: $readerId) {
        name
        slug
        author
        imageUrlThumb
        degree
        manualInfoChecked
      }
    }
  }
}
    `;

/**
 * __useGetAvailableBooksQuery__
 *
 * To run a query within a React component, call `useGetAvailableBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableBooksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      readerId: // value for 'readerId'
 *   },
 * });
 */
export function useGetAvailableBooksQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableBooksQuery, GetAvailableBooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableBooksQuery, GetAvailableBooksQueryVariables>(GetAvailableBooksDocument, options);
      }
export function useGetAvailableBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableBooksQuery, GetAvailableBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableBooksQuery, GetAvailableBooksQueryVariables>(GetAvailableBooksDocument, options);
        }
export function useGetAvailableBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableBooksQuery, GetAvailableBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableBooksQuery, GetAvailableBooksQueryVariables>(GetAvailableBooksDocument, options);
        }
export type GetAvailableBooksQueryHookResult = ReturnType<typeof useGetAvailableBooksQuery>;
export type GetAvailableBooksLazyQueryHookResult = ReturnType<typeof useGetAvailableBooksLazyQuery>;
export type GetAvailableBooksSuspenseQueryHookResult = ReturnType<typeof useGetAvailableBooksSuspenseQuery>;
export type GetAvailableBooksQueryResult = Apollo.QueryResult<GetAvailableBooksQuery, GetAvailableBooksQueryVariables>;
export const GetUserTeacherEntitiesDocument = gql`
    query getUserTeacherEntities($userId: Int!) {
  getUserTeacherEntities(userId: $userId) {
    id
    teacherId
    entityId
    entity {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserTeacherEntitiesQuery__
 *
 * To run a query within a React component, call `useGetUserTeacherEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTeacherEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTeacherEntitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserTeacherEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetUserTeacherEntitiesQuery, GetUserTeacherEntitiesQueryVariables> & ({ variables: GetUserTeacherEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTeacherEntitiesQuery, GetUserTeacherEntitiesQueryVariables>(GetUserTeacherEntitiesDocument, options);
      }
export function useGetUserTeacherEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTeacherEntitiesQuery, GetUserTeacherEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTeacherEntitiesQuery, GetUserTeacherEntitiesQueryVariables>(GetUserTeacherEntitiesDocument, options);
        }
export function useGetUserTeacherEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTeacherEntitiesQuery, GetUserTeacherEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTeacherEntitiesQuery, GetUserTeacherEntitiesQueryVariables>(GetUserTeacherEntitiesDocument, options);
        }
export type GetUserTeacherEntitiesQueryHookResult = ReturnType<typeof useGetUserTeacherEntitiesQuery>;
export type GetUserTeacherEntitiesLazyQueryHookResult = ReturnType<typeof useGetUserTeacherEntitiesLazyQuery>;
export type GetUserTeacherEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetUserTeacherEntitiesSuspenseQuery>;
export type GetUserTeacherEntitiesQueryResult = Apollo.QueryResult<GetUserTeacherEntitiesQuery, GetUserTeacherEntitiesQueryVariables>;
export const UserBasicInfosDocument = gql`
    query UserBasicInfos {
  me {
    id
    requiresPayment
    hasPendingPaymentTransactions
    email
    apiToken
    accessToken
    firstAccess
    name
    permissions
    username
    products
    filledOnboardingJobInfo
    isAdmin
    suspicionScore
    teacher {
      id
      blockedBooks
      permissions
      role
      teacherEntities
      isFamilyPaying
      showFlag
      updateStatus {
        skips
        updated
        emailConfirmed
      }
      root {
        id
        name
        requirePayment
        segment
      }
      englishTrial {
        endDate
        startDate
        remainingDays
      }
    }
    reader {
      id
      permissions
      accessDaysLeft
      contentFilters
      canAccessOnboarding
      acervos
      paymentStatus
      root {
        id
        name
        paymentInfo
        daysLeft
        paymentPrice
        requirePayment
        type
        rootAcervo
        maxSimultaneousUsers
        currentSimultaneousUsers
        nextReaderSpotAvailable
        segment
        expirationDate
      }
      entity {
        id
        ancestry
        requirePayment
        degree
        name
        type
        expirationDate
        paymentInfo
        contractInfo {
          type
          usesContractModule
          features
        }
      }
      testPeriods {
        id
        createdAt
        durationInDays
        readerId
        type
      }
    }
    featureToggles {
      ...featuresListFragment
    }
    onboardingV2Tutorial {
      ...onboardingV2TutorialFragment
    }
    gamificationOnboardingTutorial {
      ...gamificationOnboardingTutorialFragment
    }
    adminPanelV2OnboardingTutorial {
      ...adminPanelV2OnboardingTutorialFragment
    }
    jobPositions
    jobAreas
  }
}
    ${FeaturesListFragmentFragmentDoc}
${OnboardingV2TutorialFragmentFragmentDoc}
${GamificationOnboardingTutorialFragmentFragmentDoc}
${AdminPanelV2OnboardingTutorialFragmentFragmentDoc}`;

/**
 * __useUserBasicInfosQuery__
 *
 * To run a query within a React component, call `useUserBasicInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBasicInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBasicInfosQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserBasicInfosQuery(baseOptions?: Apollo.QueryHookOptions<UserBasicInfosQuery, UserBasicInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBasicInfosQuery, UserBasicInfosQueryVariables>(UserBasicInfosDocument, options);
      }
export function useUserBasicInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBasicInfosQuery, UserBasicInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBasicInfosQuery, UserBasicInfosQueryVariables>(UserBasicInfosDocument, options);
        }
export function useUserBasicInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserBasicInfosQuery, UserBasicInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserBasicInfosQuery, UserBasicInfosQueryVariables>(UserBasicInfosDocument, options);
        }
export type UserBasicInfosQueryHookResult = ReturnType<typeof useUserBasicInfosQuery>;
export type UserBasicInfosLazyQueryHookResult = ReturnType<typeof useUserBasicInfosLazyQuery>;
export type UserBasicInfosSuspenseQueryHookResult = ReturnType<typeof useUserBasicInfosSuspenseQuery>;
export type UserBasicInfosQueryResult = Apollo.QueryResult<UserBasicInfosQuery, UserBasicInfosQueryVariables>;
export const GetChangedPasswordStatusDocument = gql`
    query GetChangedPasswordStatus {
  me {
    id
    changedPassword
  }
}
    `;

/**
 * __useGetChangedPasswordStatusQuery__
 *
 * To run a query within a React component, call `useGetChangedPasswordStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangedPasswordStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangedPasswordStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChangedPasswordStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetChangedPasswordStatusQuery, GetChangedPasswordStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChangedPasswordStatusQuery, GetChangedPasswordStatusQueryVariables>(GetChangedPasswordStatusDocument, options);
      }
export function useGetChangedPasswordStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChangedPasswordStatusQuery, GetChangedPasswordStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChangedPasswordStatusQuery, GetChangedPasswordStatusQueryVariables>(GetChangedPasswordStatusDocument, options);
        }
export function useGetChangedPasswordStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChangedPasswordStatusQuery, GetChangedPasswordStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChangedPasswordStatusQuery, GetChangedPasswordStatusQueryVariables>(GetChangedPasswordStatusDocument, options);
        }
export type GetChangedPasswordStatusQueryHookResult = ReturnType<typeof useGetChangedPasswordStatusQuery>;
export type GetChangedPasswordStatusLazyQueryHookResult = ReturnType<typeof useGetChangedPasswordStatusLazyQuery>;
export type GetChangedPasswordStatusSuspenseQueryHookResult = ReturnType<typeof useGetChangedPasswordStatusSuspenseQuery>;
export type GetChangedPasswordStatusQueryResult = Apollo.QueryResult<GetChangedPasswordStatusQuery, GetChangedPasswordStatusQueryVariables>;
export const GamificationOnboardingTutorialDocument = gql`
    query GamificationOnboardingTutorial {
  me {
    id
    gamificationOnboardingTutorial {
      ...gamificationOnboardingTutorialFragment
    }
  }
}
    ${GamificationOnboardingTutorialFragmentFragmentDoc}`;

/**
 * __useGamificationOnboardingTutorialQuery__
 *
 * To run a query within a React component, call `useGamificationOnboardingTutorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGamificationOnboardingTutorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGamificationOnboardingTutorialQuery({
 *   variables: {
 *   },
 * });
 */
export function useGamificationOnboardingTutorialQuery(baseOptions?: Apollo.QueryHookOptions<GamificationOnboardingTutorialQuery, GamificationOnboardingTutorialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GamificationOnboardingTutorialQuery, GamificationOnboardingTutorialQueryVariables>(GamificationOnboardingTutorialDocument, options);
      }
export function useGamificationOnboardingTutorialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GamificationOnboardingTutorialQuery, GamificationOnboardingTutorialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GamificationOnboardingTutorialQuery, GamificationOnboardingTutorialQueryVariables>(GamificationOnboardingTutorialDocument, options);
        }
export function useGamificationOnboardingTutorialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GamificationOnboardingTutorialQuery, GamificationOnboardingTutorialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GamificationOnboardingTutorialQuery, GamificationOnboardingTutorialQueryVariables>(GamificationOnboardingTutorialDocument, options);
        }
export type GamificationOnboardingTutorialQueryHookResult = ReturnType<typeof useGamificationOnboardingTutorialQuery>;
export type GamificationOnboardingTutorialLazyQueryHookResult = ReturnType<typeof useGamificationOnboardingTutorialLazyQuery>;
export type GamificationOnboardingTutorialSuspenseQueryHookResult = ReturnType<typeof useGamificationOnboardingTutorialSuspenseQuery>;
export type GamificationOnboardingTutorialQueryResult = Apollo.QueryResult<GamificationOnboardingTutorialQuery, GamificationOnboardingTutorialQueryVariables>;
export const NotificationsPreferencesDocument = gql`
    query NotificationsPreferences {
  notificationsPreferences {
    weeklyReadingReport
  }
}
    `;

/**
 * __useNotificationsPreferencesQuery__
 *
 * To run a query within a React component, call `useNotificationsPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsPreferencesQuery, NotificationsPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsPreferencesQuery, NotificationsPreferencesQueryVariables>(NotificationsPreferencesDocument, options);
      }
export function useNotificationsPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsPreferencesQuery, NotificationsPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsPreferencesQuery, NotificationsPreferencesQueryVariables>(NotificationsPreferencesDocument, options);
        }
export function useNotificationsPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsPreferencesQuery, NotificationsPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsPreferencesQuery, NotificationsPreferencesQueryVariables>(NotificationsPreferencesDocument, options);
        }
export type NotificationsPreferencesQueryHookResult = ReturnType<typeof useNotificationsPreferencesQuery>;
export type NotificationsPreferencesLazyQueryHookResult = ReturnType<typeof useNotificationsPreferencesLazyQuery>;
export type NotificationsPreferencesSuspenseQueryHookResult = ReturnType<typeof useNotificationsPreferencesSuspenseQuery>;
export type NotificationsPreferencesQueryResult = Apollo.QueryResult<NotificationsPreferencesQuery, NotificationsPreferencesQueryVariables>;
export const GetUserFeatureTogglesDocument = gql`
    query getUserFeatureToggles {
  me {
    id
    featureToggles {
      ...featuresListFragment
    }
  }
}
    ${FeaturesListFragmentFragmentDoc}`;

/**
 * __useGetUserFeatureTogglesQuery__
 *
 * To run a query within a React component, call `useGetUserFeatureTogglesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFeatureTogglesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFeatureTogglesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFeatureTogglesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFeatureTogglesQuery, GetUserFeatureTogglesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFeatureTogglesQuery, GetUserFeatureTogglesQueryVariables>(GetUserFeatureTogglesDocument, options);
      }
export function useGetUserFeatureTogglesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFeatureTogglesQuery, GetUserFeatureTogglesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFeatureTogglesQuery, GetUserFeatureTogglesQueryVariables>(GetUserFeatureTogglesDocument, options);
        }
export function useGetUserFeatureTogglesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFeatureTogglesQuery, GetUserFeatureTogglesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFeatureTogglesQuery, GetUserFeatureTogglesQueryVariables>(GetUserFeatureTogglesDocument, options);
        }
export type GetUserFeatureTogglesQueryHookResult = ReturnType<typeof useGetUserFeatureTogglesQuery>;
export type GetUserFeatureTogglesLazyQueryHookResult = ReturnType<typeof useGetUserFeatureTogglesLazyQuery>;
export type GetUserFeatureTogglesSuspenseQueryHookResult = ReturnType<typeof useGetUserFeatureTogglesSuspenseQuery>;
export type GetUserFeatureTogglesQueryResult = Apollo.QueryResult<GetUserFeatureTogglesQuery, GetUserFeatureTogglesQueryVariables>;
export const GetReaderReadingGoalStatusDocument = gql`
    query GetReaderReadingGoalStatus {
  me {
    id
    reader {
      id
      readingGoalStatus {
        goal
        readingTime
      }
    }
  }
}
    `;

/**
 * __useGetReaderReadingGoalStatusQuery__
 *
 * To run a query within a React component, call `useGetReaderReadingGoalStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReaderReadingGoalStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReaderReadingGoalStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReaderReadingGoalStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetReaderReadingGoalStatusQuery, GetReaderReadingGoalStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReaderReadingGoalStatusQuery, GetReaderReadingGoalStatusQueryVariables>(GetReaderReadingGoalStatusDocument, options);
      }
export function useGetReaderReadingGoalStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReaderReadingGoalStatusQuery, GetReaderReadingGoalStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReaderReadingGoalStatusQuery, GetReaderReadingGoalStatusQueryVariables>(GetReaderReadingGoalStatusDocument, options);
        }
export function useGetReaderReadingGoalStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReaderReadingGoalStatusQuery, GetReaderReadingGoalStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReaderReadingGoalStatusQuery, GetReaderReadingGoalStatusQueryVariables>(GetReaderReadingGoalStatusDocument, options);
        }
export type GetReaderReadingGoalStatusQueryHookResult = ReturnType<typeof useGetReaderReadingGoalStatusQuery>;
export type GetReaderReadingGoalStatusLazyQueryHookResult = ReturnType<typeof useGetReaderReadingGoalStatusLazyQuery>;
export type GetReaderReadingGoalStatusSuspenseQueryHookResult = ReturnType<typeof useGetReaderReadingGoalStatusSuspenseQuery>;
export type GetReaderReadingGoalStatusQueryResult = Apollo.QueryResult<GetReaderReadingGoalStatusQuery, GetReaderReadingGoalStatusQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($userId: Int!) {
  getUser(userId: $userId) {
    id
    name
    email
    accessToken
    reader {
      id
      rootId
      entity {
        id
        name
      }
    }
    isAdmin
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserJobPositionsAndRolesDocument = gql`
    query GetUserJobPositionsAndRoles {
  me {
    id
    jobPositions
    jobAreas
    roles
  }
}
    `;

/**
 * __useGetUserJobPositionsAndRolesQuery__
 *
 * To run a query within a React component, call `useGetUserJobPositionsAndRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserJobPositionsAndRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserJobPositionsAndRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserJobPositionsAndRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserJobPositionsAndRolesQuery, GetUserJobPositionsAndRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserJobPositionsAndRolesQuery, GetUserJobPositionsAndRolesQueryVariables>(GetUserJobPositionsAndRolesDocument, options);
      }
export function useGetUserJobPositionsAndRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserJobPositionsAndRolesQuery, GetUserJobPositionsAndRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserJobPositionsAndRolesQuery, GetUserJobPositionsAndRolesQueryVariables>(GetUserJobPositionsAndRolesDocument, options);
        }
export function useGetUserJobPositionsAndRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserJobPositionsAndRolesQuery, GetUserJobPositionsAndRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserJobPositionsAndRolesQuery, GetUserJobPositionsAndRolesQueryVariables>(GetUserJobPositionsAndRolesDocument, options);
        }
export type GetUserJobPositionsAndRolesQueryHookResult = ReturnType<typeof useGetUserJobPositionsAndRolesQuery>;
export type GetUserJobPositionsAndRolesLazyQueryHookResult = ReturnType<typeof useGetUserJobPositionsAndRolesLazyQuery>;
export type GetUserJobPositionsAndRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserJobPositionsAndRolesSuspenseQuery>;
export type GetUserJobPositionsAndRolesQueryResult = Apollo.QueryResult<GetUserJobPositionsAndRolesQuery, GetUserJobPositionsAndRolesQueryVariables>;
export const GetReaderForestDocument = gql`
    query GetReaderForest {
  me {
    id
    reader {
      id
      forest {
        id
      }
    }
  }
}
    `;

/**
 * __useGetReaderForestQuery__
 *
 * To run a query within a React component, call `useGetReaderForestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReaderForestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReaderForestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReaderForestQuery(baseOptions?: Apollo.QueryHookOptions<GetReaderForestQuery, GetReaderForestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReaderForestQuery, GetReaderForestQueryVariables>(GetReaderForestDocument, options);
      }
export function useGetReaderForestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReaderForestQuery, GetReaderForestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReaderForestQuery, GetReaderForestQueryVariables>(GetReaderForestDocument, options);
        }
export function useGetReaderForestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReaderForestQuery, GetReaderForestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReaderForestQuery, GetReaderForestQueryVariables>(GetReaderForestDocument, options);
        }
export type GetReaderForestQueryHookResult = ReturnType<typeof useGetReaderForestQuery>;
export type GetReaderForestLazyQueryHookResult = ReturnType<typeof useGetReaderForestLazyQuery>;
export type GetReaderForestSuspenseQueryHookResult = ReturnType<typeof useGetReaderForestSuspenseQuery>;
export type GetReaderForestQueryResult = Apollo.QueryResult<GetReaderForestQuery, GetReaderForestQueryVariables>;
export const BookCoverThumbDocument = gql`
    query BookCoverThumb($slug: String!) {
  bookDetails(slug: $slug) {
    slug
    imageUrlThumb
  }
}
    `;

/**
 * __useBookCoverThumbQuery__
 *
 * To run a query within a React component, call `useBookCoverThumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookCoverThumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookCoverThumbQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBookCoverThumbQuery(baseOptions: Apollo.QueryHookOptions<BookCoverThumbQuery, BookCoverThumbQueryVariables> & ({ variables: BookCoverThumbQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookCoverThumbQuery, BookCoverThumbQueryVariables>(BookCoverThumbDocument, options);
      }
export function useBookCoverThumbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookCoverThumbQuery, BookCoverThumbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookCoverThumbQuery, BookCoverThumbQueryVariables>(BookCoverThumbDocument, options);
        }
export function useBookCoverThumbSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookCoverThumbQuery, BookCoverThumbQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookCoverThumbQuery, BookCoverThumbQueryVariables>(BookCoverThumbDocument, options);
        }
export type BookCoverThumbQueryHookResult = ReturnType<typeof useBookCoverThumbQuery>;
export type BookCoverThumbLazyQueryHookResult = ReturnType<typeof useBookCoverThumbLazyQuery>;
export type BookCoverThumbSuspenseQueryHookResult = ReturnType<typeof useBookCoverThumbSuspenseQuery>;
export type BookCoverThumbQueryResult = Apollo.QueryResult<BookCoverThumbQuery, BookCoverThumbQueryVariables>;
export const UpdateTeacherRunningRecordsPreferenceDocument = gql`
    mutation UpdateTeacherRunningRecordsPreference($entities_ids: [Int]!) {
  updateTeacherRunningRecordsPreference(input: {entitiesIds: $entities_ids}) {
    teacherId
    entitiesIdsSelected
  }
}
    `;
export type UpdateTeacherRunningRecordsPreferenceMutationFn = Apollo.MutationFunction<UpdateTeacherRunningRecordsPreferenceMutation, UpdateTeacherRunningRecordsPreferenceMutationVariables>;

/**
 * __useUpdateTeacherRunningRecordsPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherRunningRecordsPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherRunningRecordsPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherRunningRecordsPreferenceMutation, { data, loading, error }] = useUpdateTeacherRunningRecordsPreferenceMutation({
 *   variables: {
 *      entities_ids: // value for 'entities_ids'
 *   },
 * });
 */
export function useUpdateTeacherRunningRecordsPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeacherRunningRecordsPreferenceMutation, UpdateTeacherRunningRecordsPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeacherRunningRecordsPreferenceMutation, UpdateTeacherRunningRecordsPreferenceMutationVariables>(UpdateTeacherRunningRecordsPreferenceDocument, options);
      }
export type UpdateTeacherRunningRecordsPreferenceMutationHookResult = ReturnType<typeof useUpdateTeacherRunningRecordsPreferenceMutation>;
export type UpdateTeacherRunningRecordsPreferenceMutationResult = Apollo.MutationResult<UpdateTeacherRunningRecordsPreferenceMutation>;
export type UpdateTeacherRunningRecordsPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateTeacherRunningRecordsPreferenceMutation, UpdateTeacherRunningRecordsPreferenceMutationVariables>;
export const ListLevelingsQueryDocument = gql`
    query ListLevelingsQuery {
  listLevelings {
    id
    name
  }
}
    `;

/**
 * __useListLevelingsQueryQuery__
 *
 * To run a query within a React component, call `useListLevelingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLevelingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLevelingsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useListLevelingsQueryQuery(baseOptions?: Apollo.QueryHookOptions<ListLevelingsQueryQuery, ListLevelingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLevelingsQueryQuery, ListLevelingsQueryQueryVariables>(ListLevelingsQueryDocument, options);
      }
export function useListLevelingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLevelingsQueryQuery, ListLevelingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLevelingsQueryQuery, ListLevelingsQueryQueryVariables>(ListLevelingsQueryDocument, options);
        }
export function useListLevelingsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLevelingsQueryQuery, ListLevelingsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLevelingsQueryQuery, ListLevelingsQueryQueryVariables>(ListLevelingsQueryDocument, options);
        }
export type ListLevelingsQueryQueryHookResult = ReturnType<typeof useListLevelingsQueryQuery>;
export type ListLevelingsQueryLazyQueryHookResult = ReturnType<typeof useListLevelingsQueryLazyQuery>;
export type ListLevelingsQuerySuspenseQueryHookResult = ReturnType<typeof useListLevelingsQuerySuspenseQuery>;
export type ListLevelingsQueryQueryResult = Apollo.QueryResult<ListLevelingsQueryQuery, ListLevelingsQueryQueryVariables>;
export const SendRunningRecordsResultDocument = gql`
    mutation SendRunningRecordsResult($readerUserId: Int!, $newLevelingId: Int!) {
  sendRunningRecordsResult(
    input: {readerUserId: $readerUserId, newLevelingId: $newLevelingId}
  )
}
    `;
export type SendRunningRecordsResultMutationFn = Apollo.MutationFunction<SendRunningRecordsResultMutation, SendRunningRecordsResultMutationVariables>;

/**
 * __useSendRunningRecordsResultMutation__
 *
 * To run a mutation, you first call `useSendRunningRecordsResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRunningRecordsResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRunningRecordsResultMutation, { data, loading, error }] = useSendRunningRecordsResultMutation({
 *   variables: {
 *      readerUserId: // value for 'readerUserId'
 *      newLevelingId: // value for 'newLevelingId'
 *   },
 * });
 */
export function useSendRunningRecordsResultMutation(baseOptions?: Apollo.MutationHookOptions<SendRunningRecordsResultMutation, SendRunningRecordsResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRunningRecordsResultMutation, SendRunningRecordsResultMutationVariables>(SendRunningRecordsResultDocument, options);
      }
export type SendRunningRecordsResultMutationHookResult = ReturnType<typeof useSendRunningRecordsResultMutation>;
export type SendRunningRecordsResultMutationResult = Apollo.MutationResult<SendRunningRecordsResultMutation>;
export type SendRunningRecordsResultMutationOptions = Apollo.BaseMutationOptions<SendRunningRecordsResultMutation, SendRunningRecordsResultMutationVariables>;
export const GetTeacherEntitiesSelectedQueryDocument = gql`
    query GetTeacherEntitiesSelectedQuery {
  getTeacherEntitiesSelected {
    id
    name
  }
}
    `;

/**
 * __useGetTeacherEntitiesSelectedQueryQuery__
 *
 * To run a query within a React component, call `useGetTeacherEntitiesSelectedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherEntitiesSelectedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherEntitiesSelectedQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeacherEntitiesSelectedQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetTeacherEntitiesSelectedQueryQuery, GetTeacherEntitiesSelectedQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherEntitiesSelectedQueryQuery, GetTeacherEntitiesSelectedQueryQueryVariables>(GetTeacherEntitiesSelectedQueryDocument, options);
      }
export function useGetTeacherEntitiesSelectedQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherEntitiesSelectedQueryQuery, GetTeacherEntitiesSelectedQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherEntitiesSelectedQueryQuery, GetTeacherEntitiesSelectedQueryQueryVariables>(GetTeacherEntitiesSelectedQueryDocument, options);
        }
export function useGetTeacherEntitiesSelectedQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeacherEntitiesSelectedQueryQuery, GetTeacherEntitiesSelectedQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeacherEntitiesSelectedQueryQuery, GetTeacherEntitiesSelectedQueryQueryVariables>(GetTeacherEntitiesSelectedQueryDocument, options);
        }
export type GetTeacherEntitiesSelectedQueryQueryHookResult = ReturnType<typeof useGetTeacherEntitiesSelectedQueryQuery>;
export type GetTeacherEntitiesSelectedQueryLazyQueryHookResult = ReturnType<typeof useGetTeacherEntitiesSelectedQueryLazyQuery>;
export type GetTeacherEntitiesSelectedQuerySuspenseQueryHookResult = ReturnType<typeof useGetTeacherEntitiesSelectedQuerySuspenseQuery>;
export type GetTeacherEntitiesSelectedQueryQueryResult = Apollo.QueryResult<GetTeacherEntitiesSelectedQueryQuery, GetTeacherEntitiesSelectedQueryQueryVariables>;
export const SetTeacherCommentsAnswerDocument = gql`
    mutation SetTeacherCommentsAnswer($appliedActivityId: Int!, $readerId: Int!, $examQuestionId: Int!, $comments: String!, $answerId: Int) {
  setTeacherCommentsAnswer(
    appliedActivityId: $appliedActivityId
    readerId: $readerId
    examQuestionId: $examQuestionId
    comments: $comments
    answerId: $answerId
  ) {
    id
    answers {
      id
      examQuestionId
      teacherComments
    }
  }
}
    `;
export type SetTeacherCommentsAnswerMutationFn = Apollo.MutationFunction<SetTeacherCommentsAnswerMutation, SetTeacherCommentsAnswerMutationVariables>;

/**
 * __useSetTeacherCommentsAnswerMutation__
 *
 * To run a mutation, you first call `useSetTeacherCommentsAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeacherCommentsAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeacherCommentsAnswerMutation, { data, loading, error }] = useSetTeacherCommentsAnswerMutation({
 *   variables: {
 *      appliedActivityId: // value for 'appliedActivityId'
 *      readerId: // value for 'readerId'
 *      examQuestionId: // value for 'examQuestionId'
 *      comments: // value for 'comments'
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useSetTeacherCommentsAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetTeacherCommentsAnswerMutation, SetTeacherCommentsAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeacherCommentsAnswerMutation, SetTeacherCommentsAnswerMutationVariables>(SetTeacherCommentsAnswerDocument, options);
      }
export type SetTeacherCommentsAnswerMutationHookResult = ReturnType<typeof useSetTeacherCommentsAnswerMutation>;
export type SetTeacherCommentsAnswerMutationResult = Apollo.MutationResult<SetTeacherCommentsAnswerMutation>;
export type SetTeacherCommentsAnswerMutationOptions = Apollo.BaseMutationOptions<SetTeacherCommentsAnswerMutation, SetTeacherCommentsAnswerMutationVariables>;
export const SetGradeAnswerDocument = gql`
    mutation SetGradeAnswer($answerId: Int!, $grade: String!) {
  setGradeAnswer(answerId: $answerId, grade: $grade) {
    id
    answers {
      id
      examQuestionId
      grade
    }
  }
}
    `;
export type SetGradeAnswerMutationFn = Apollo.MutationFunction<SetGradeAnswerMutation, SetGradeAnswerMutationVariables>;

/**
 * __useSetGradeAnswerMutation__
 *
 * To run a mutation, you first call `useSetGradeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGradeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGradeAnswerMutation, { data, loading, error }] = useSetGradeAnswerMutation({
 *   variables: {
 *      answerId: // value for 'answerId'
 *      grade: // value for 'grade'
 *   },
 * });
 */
export function useSetGradeAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SetGradeAnswerMutation, SetGradeAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGradeAnswerMutation, SetGradeAnswerMutationVariables>(SetGradeAnswerDocument, options);
      }
export type SetGradeAnswerMutationHookResult = ReturnType<typeof useSetGradeAnswerMutation>;
export type SetGradeAnswerMutationResult = Apollo.MutationResult<SetGradeAnswerMutation>;
export type SetGradeAnswerMutationOptions = Apollo.BaseMutationOptions<SetGradeAnswerMutation, SetGradeAnswerMutationVariables>;
export const ShowBookCollectionQueryDocument = gql`
    query showBookCollectionQuery($bookShelfId: Int!) {
  showBookShelf(bookShelfId: $bookShelfId) {
    id
    name
    image
    bgColor
    description
    books {
      author
      degree
      description
      edition
      imageUrlIntermediaria
      imageUrlThumb
      name
      readingLevel
      series
      slug
      subtitle
      hasAudioBook
    }
    bookShelfItemsCount
  }
}
    `;

/**
 * __useShowBookCollectionQueryQuery__
 *
 * To run a query within a React component, call `useShowBookCollectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowBookCollectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowBookCollectionQueryQuery({
 *   variables: {
 *      bookShelfId: // value for 'bookShelfId'
 *   },
 * });
 */
export function useShowBookCollectionQueryQuery(baseOptions: Apollo.QueryHookOptions<ShowBookCollectionQueryQuery, ShowBookCollectionQueryQueryVariables> & ({ variables: ShowBookCollectionQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowBookCollectionQueryQuery, ShowBookCollectionQueryQueryVariables>(ShowBookCollectionQueryDocument, options);
      }
export function useShowBookCollectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowBookCollectionQueryQuery, ShowBookCollectionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowBookCollectionQueryQuery, ShowBookCollectionQueryQueryVariables>(ShowBookCollectionQueryDocument, options);
        }
export function useShowBookCollectionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowBookCollectionQueryQuery, ShowBookCollectionQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowBookCollectionQueryQuery, ShowBookCollectionQueryQueryVariables>(ShowBookCollectionQueryDocument, options);
        }
export type ShowBookCollectionQueryQueryHookResult = ReturnType<typeof useShowBookCollectionQueryQuery>;
export type ShowBookCollectionQueryLazyQueryHookResult = ReturnType<typeof useShowBookCollectionQueryLazyQuery>;
export type ShowBookCollectionQuerySuspenseQueryHookResult = ReturnType<typeof useShowBookCollectionQuerySuspenseQuery>;
export type ShowBookCollectionQueryQueryResult = Apollo.QueryResult<ShowBookCollectionQueryQuery, ShowBookCollectionQueryQueryVariables>;